(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.pricingPausing', [])
    .controller('PricingPausingController', PricingPausingController);

  /* @ngInject */
  function PricingPausingController($scope, $mdDialog, $mdEditDialog, toastr, lodash, UrlsService,
    NotificationService, PUB_URL_STATE, TYPE_STATE, ROLE,$timeout) {
    var vm = this;
    //Accesible variables
    vm.pricingPausing = [];
    vm.totalItemsCount = 0;
    vm.blank_auto_search_available = true;

    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '',
      page: 1,
      limit: 20
    };
    vm.changeIcon = changeIcon;
    vm.isSubmitted = isSubmitted;
    vm.submitUrl = submitUrl;
    vm.canSubmit = canSubmit;
    vm.showSearchIcon = showSearchIcon;
    vm.removeFilter = removeFilter;
    vm.showInfo = showInfo;
    vm.getRowClass = getRowClass;
    vm.getPriceText = getPriceText;
    vm.getEditPriceTooltipText = getEditPriceTooltipText;
    vm.toggleOrderPaused = toggleOrderPaused;
    vm.formatApprovedDate = formatApprovedDate;
    vm.getActiveURLs = getActiveURLs
    vm.searchBox = searchBox;

    initialize();

    function initialize() {
      getActiveURLs();
    }

    function getActiveURLs() {
      NotificationService.deleteNotification(TYPE_STATE.PRICING_AND_PAUSING, ROLE.PUB);
      UrlsService.indexOnlyUrls([PUB_URL_STATE.ACTIVE, PUB_URL_STATE.PAUSED, PUB_URL_STATE.PENDING, PUB_URL_STATE.REJECTED, PUB_URL_STATE.UNDER_REVIEW], vm.query, function (response) {
        vm.totalItemsCount = response.data.total_count;
        vm.pricingPausing = response.data.urls;
        lodash.map(vm.pricingPausing, function (item) {
          item.submitted = lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.REJECTED], item.state);
          item.oldPrice = item.price;
          item.paused = item.state === PUB_URL_STATE.PAUSED ? true : false;
          item.oldPaused = item.paused;
        });
        vm.filtered = vm.pricingPausing;
      }, function (response) {
        toastr.error("Couldn't retrieve URLs. Try again please.");
      });
    }

    function changeIcon(ad) {
      return ad.submitted ? 'hourglass_empty' : 'check_circle';
    }

    $scope.editPrice = function (event, url) {
      event.stopPropagation(); // in case autoselect is enabled
      if ((!url.submitted || isRejected(url)) && url.state !== PUB_URL_STATE.UNDER_REVIEW) {
        var editDialog = {
          modelValue: url.price,
          placeholder: 'Payout',
          save: function (input) {
            url.price = input.$modelValue;
            if (priceChanged(url)) {
              vm.submitUrl(url);
            }
          },
          targetEvent: event,
          title: 'Change Your Price',
          type: 'number',
          validators: {
            'step': .01
          }
        };
        var promise = $mdEditDialog.large(editDialog);
      }
    };
    $scope.editPriceBlur = function (event, url) {
      event.stopPropagation(); // in case autoselect is enabled
      if (!url.submitted || isRejected(url)) {
        url.price = event.target.value;
        if (priceChanged(url)) {
          vm.submitUrl(url);
        }
      }
    };

    function priceChanged(url) {
      return url.price != url.oldPrice;
    }

    function pausedChanged(url) {
      return url.paused != url.oldPaused;
    }

    function isSubmitted(url) {
      return url.state === PUB_URL_STATE.PENDING && url.submitted;
    }

    function submitUrl(url) {
      if (canSubmit(url) && (!url.submitted || isRejected(url))) {
        $mdDialog.show({
          controller: 'PauseController',
          controllerAs: 'pauseCtrl',
          templateUrl: 'app/pages/reports/pub/pricingAndPausing/partials/pause.html',
          hasBackdrop: true,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
          locals: {
            url: url
          }
        }).then(function () {
          initialize();
        }).catch(function () {
          if (pausedChanged(url)) {
            url.paused = !url.paused;
          }

          if (priceChanged(url)) {
            url.price = url.oldPrice;
          }
        });
      } else {
        url.price = url.oldPrice;
        toastr.error("No changes were made. Note that paused URLs don't qualify for price changes.");
      }
    }

    function canSubmit(url) {
      return (!url.paused && priceChanged(url)) || pausedChanged(url);
    }

    function removeFilter() {
      vm.search = false;
      vm.query.filter = '';
      vm.query.page = 1;
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    $scope.$watch('ppCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = null;
      if (!oldValue) {
        bookmark = vm.query.page;
      } else if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      } else if (newValue === '') {
        vm.query.page = 1;
      }

      if(vm.query.page === null) {
        vm.query.page = 1;
      }
    });

    function showInfo() {
      return $mdDialog.show(
        $mdDialog.alert()
        .title('Pricing & Pausing')
        .htmlContent('Here is where you change your price and remove your site ' +
          'temporarily from receiving new orders.<br> You can change these things at any time.')
        .escapeToClose(false)
        .ok('Ok')
      );
    }

    function getRowClass(url) {
      switch (url.state) {
        case PUB_URL_STATE.PENDING:
          return 'submitted-url';
        case PUB_URL_STATE.REJECTED:
          return 'rejected-url'
      }
    }

    function getPriceText(url) {
      if(url.state === PUB_URL_STATE.UNDER_REVIEW) {
        return '$' + url.price + ' -> $' + url.requested_price;
      }
      else {
        return '$' + url.price
      }
    }

    function getEditPriceTooltipText(url) {
      // return 'poot';
      if (isRejected(url)) {
        return 'Price change needed for approval (see notes in email). Click here to edit.';
      }
      else if(url.state === PUB_URL_STATE.UNDER_REVIEW) {
        return 'Price change currently under review for approval.';
      }
      else {
        return 'Click Here to Edit Price';
      }
    }

    function isRejected(url) {
      return url.submitted && url.state === PUB_URL_STATE.REJECTED;
    }

    function toggleOrderPaused(order) {
      order.paused = !order.paused;
    }

    function formatApprovedDate(url) {
      if (url.approved_date == null) {
        if (url.state === PUB_URL_STATE.ACTIVE || url.state === PUB_URL_STATE.PAUSED) return 'Unknown'
        else return 'Pending'
      } else {
        return url.approved_date
      }
    }
    
    function makeBlankAutoSearchAvailable (){
      vm.blank_auto_search_available = true;
    }
  
    function searchBox(event) {
        if (vm.query.filter.length == 0 && vm.blank_auto_search_available) {
          searchActiveURLs();
          vm.blank_auto_search_available = false;
          $timeout(makeBlankAutoSearchAvailable, 5000);
        } else if (event.keyCode === 13) searchActiveURLs(); 
    }
  
    function searchActiveURLs() {
        if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
          toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
        } else {
          getActiveURLs();
        }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.pricingPausing')
    .controller('PauseController', PauseController);

  /* @ngInject */
  function PauseController($scope, $mdDialog, lodash, toastr, UrlsService, url) {
    var vm = this;

    //Accesible variables
    vm.url = {};
    vm.noteReason;

    //Accesible functions
    vm.ok = ok;
    vm.cancel = cancel;
    vm.priceChanged = priceChanged;
    vm.pausedChanged = pausedChanged;
    vm.isPausing = isPausing;
    vm.isUnpausing = isUnpausing;

    initialize();

    function initialize() {
      vm.url = url;
    }

    function priceChanged() {
      return vm.url.price != vm.url.oldPrice;
    }

    function pausedChanged() {
      return vm.url.oldPaused != vm.url.paused;
    }

    function isPausing() {
      return pausedChanged() && vm.url.paused;
    }

    function isUnpausing() {
      return pausedChanged() && !vm.url.paused;
    }

    function ok() {
      if (priceChanged() && !pausedChanged()) {
        UrlsService.requestPrice(vm.url, function() {
          toastr.success('URL was updated!');
          $mdDialog.hide();
        }, function() {
          toastr.error("Couldn't update URL. Try again please.");
        });
      }
      else {
        UrlsService.pauseUrl(vm.url, vm.noteReason, function() {
          toastr.success('URL was updated!');
          $mdDialog.hide();
        }, function() {
          toastr.error("Couldn't update URL. Try again please.");
        });
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ngMaterial',
      'ngFileUpload',
      'toastr',
      'linktubConfig',
      'ngLodash',
      'dibari.angular-ellipsis',
      'textAngular',
      'angularUtils.directives.dirPagination',
      'linktub.pages',
      'md.data.table',
      'rzModule',
      'ui.mask',
      'LocalStorageModule',
      'material.components.expansionPanels',
      'ui.utils.masks',
      'ngImgCrop',
      'ngFileSaver',
      'betsol.intlTelInput'
    ])
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('ReportNotesController', ReportNotesController);

  /* @ngInject */
  function ReportNotesController($scope, $mdDialog, lodash, ad) {
    var vm = this;

    //Accesible variables
    vm.notes = [];
    vm.ad = {};

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.ad = ad;
      vm.notes = ad.notes;
    }

    function ok() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.newOrders', [])
    .controller('NewOrdersController', NewOrdersController);

  /* @ngInject */
  function NewOrdersController($scope, $window, $mdDialog, toastr, BlogPostsService,
    NotificationService, PUB_URL_STATE, ROLE, TYPE_STATE) {
    var vm = this;

    //Accesible variables
    vm.newOrders = [];
    vm.filtered = [];
    vm.orderExpired = false;
    vm.query = {
      filter: '',
      order: '-requested_date',
      limit: 20,
      page: 1
    };

    //Accesible functions
    vm.approve = approve;
    vm.decline = decline;
    vm.downloadContent = downloadContent;
    vm.isRejected = isRejected;

    initialize();

    function initialize() {
      NotificationService.deleteNotification(TYPE_STATE.NEW_ORDERS, ROLE.PUB);
      BlogPostsService.indexPublisherBlogPosts(PUB_URL_STATE.PENDING, function (response) {
        vm.newOrders = response.data.ads || [];
      }, function (error) {
        toastr.error('Couldn\'t retrieve orders. Try again please.');
      });
    }

    function approve(ad) {
      if (!isRejected(ad)) {
        var confirm = $mdDialog.confirm()
          .title('Are you sure?')
          .textContent('')
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function (result) {
          BlogPostsService.approveAd(ad.id, function (response) {
            refreshOrRedirect();
          }, function (error) {
            toastr.error('Couldn\'t approve order. Try again please.');
          });
        });
      }
    }

    function decline(ad) {
      if (!isRejected(ad)) {

        var confirm = $mdDialog.confirm()
          .title('Are you sure?')
          .htmlContent('<p>Declining an ad is permanent.</p>')
          .ok('Yes - Decline')
          .cancel('No');

        $mdDialog.show(confirm).then(function (result) {
          var reject_details = {
            rejected_reason: 'rejected by publisher',
            notes: '',
            editable: false
          };
          BlogPostsService.rejectAd(ad.id, reject_details, function (response) {
            refreshOrRedirect();
          }, function (error) {
            toastr.error('Couldn\'t decline order. Try again please.');
          });
        }, function () {});
      }
    }

    function refreshOrRedirect() {
      if (vm.newOrders.length > 1) {
        initialize();
      } else {
        $window.location.href = '/#/pub/dashboard';
      }
    }

    $scope.$watch('newOrdersCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      } else if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      } else if (newValue === '') {
        vm.query.page = 1;
      }
    });

    function downloadContent(ev, ad) {
      if (ad.blog_post_body) {
        blogPostEditDialog(ev, ad, true);
      } else if (ad.word) {
        return ad.word.url;
      }
    }

    function blogPostEditDialog(ev, ad, download) {
      $mdDialog.show({
        controller: 'BlogPostEditController',
        controllerAs: 'blgEditCtrl',
        templateUrl: 'app/pages/reports/adv/rejected/blogPostsEdit/blogPostsEdit.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad,
          download: download
        }
      });
    }

    function isRejected(ad) {
      return ad.state === PUB_URL_STATE.REJECTED;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.newOrders')
    .controller('RejectOrderController', RejectOrderController);

  /* @ngInject */
  function RejectOrderController($scope, $mdDialog, lodash, RejectedReasonsService) {
    var vm = this;

    //Accesible variables
    vm.rejectReasons = [];
    vm.notes = '';
    vm.allowAgency;
    vm.selected = [];

    //Accesible functions
    vm.submit = submit;
    vm.cancel = cancel;

    initialize();

    function initialize() {
      vm.allowAgency = false;
      vm.rejectedReasons = RejectedReasonsService.getRejectedReasons();
    }

    function submit() {
      var response = {
        rejected_reason: vm.selected,
        notes: vm.notes,
        editable: vm.allowAgency
      };

      $mdDialog.hide(response);
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.rejected', [])
    .controller('ReportRejectedController', ReportRejectedController);

  /* @ngInject */
  function ReportRejectedController($log, $mdDialog, $mdMedia, lodash, TYPE_STATE, ROLE, RoutesService,
    BlogPostsService, NotificationService) {
    var vm = this;

    //Accesible variables
    vm.rejectedAds = [];
    vm.perPage = 10;
    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '-requested_date',
      limit: 20,
      page: 1
    };

    //Accessible functions
    vm.deleteUrl = deleteUrl;
    vm.downloadContent = downloadContent;
    vm.showInstructions = showInstructions;
    vm.blogPostEditDialog = blogPostEditDialog;
    vm.showMoreNotes = showMoreNotes;
    vm.cancel = cancel;
    vm.canEdit = canEdit;
    vm.canDelete = canDelete;
    vm.$mdMedia = $mdMedia;
    vm.showNotesIcon = showNotesIcon;
    vm.showSearchIcon = showSearchIcon;
    vm.removeFilter = removeFilter;
    vm.getTooltipText = getTooltipText;
    vm.notesSeen = notesSeen;

    function getTooltipText(input, ad) {
      switch (input) {
      case 'notes':
        if (!ad.downloaded) {
          return 'Please download content first';
        } else {
          return 'Read notes';
        }
      case 'delete':
        if (ad.editable && !ad.downloaded) {
          return 'Please download content first';
        } else {
          return 'Delete';
        }
      case 'edit':
        if (ad.editable && !ad.downloaded) {
          return 'Please download content first';
        } else if (!ad.sawNote && ad.downloaded && ad.editable) {
          return 'Read notes first please';
        } else {
          return 'Edit';
        }
      }
    }

    initialize();

    function initialize() {
      NotificationService.deleteNotification(TYPE_STATE.REJECTED_CONTENT, ROLE.ADV);
      BlogPostsService.indexBlogPosts({ state: TYPE_STATE.REJECTED_OR_CANCELLED_CONTENT }, function (response) {
        var aux = lodash.map(response.data.ads, function (ad) {
          ad.sawNote = false;
          ad.downloaded = false;
          return ad;
        });
        vm.rejectedAds = aux;
        vm.filtered = vm.rejectedAds;
      }, function () {
        $log.error('Error retrieving blog posts');
      });
    }

    function deleteUrl(id) {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete this content?')
        .textContent('This content will be removed permanently.')
        .ariaLabel('Removing content')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        BlogPostsService.deleteBlogPost(id, function () {
          lodash.remove(vm.rejectedAds, function (item) {
            return item.id == id;
          });
        }, function () {
          $log.error('Error deleting blog posts');
        });
      });
    }

    function showInstructions() {
      $mdDialog.show({
        controller: 'ReportRejectedController',
        controllerAs: 'repRejCtrl',
        templateUrl: 'app/pages/reports/adv/rejected/instructions.html',
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true
      });
    }

    function showMoreNotes(ad) {
      ad.sawNote = true;
      $mdDialog.show({
        templateUrl: 'app/pages/reports/adv/rejected/pubNotes/pubNotes.html',
        controller: 'PubNotesController',
        controllerAs: 'pubNotesCtrl',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          order: ad
        }
      });
    }

    function downloadContent(ev, ad) {
      ad.downloaded = true;
      if (ad.blog_post_body) {
        blogPostEditDialog(ev, ad, true);
      } else if (ad.word) {
        return ad.word.url;
      }
    }

    function blogPostEditDialog(ev, ad, download) {
      $mdDialog.show({
        controller: 'BlogPostEditController',
        controllerAs: 'blgEditCtrl',
        templateUrl: 'app/pages/reports/adv/rejected/blogPostsEdit/blogPostsEdit.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad,
          download: download
        }
      }).then(function (id) {
        lodash.remove(vm.rejectedAds, function (item) {
          return item.id == id;
        });

        if (vm.rejectedAds.length == 0) {
          return RoutesService.dashboard();
        }
      }, function () {
        $log.log('Dialog was canceled');
      });
    }

    function removeFilter() {
      vm.search = false;
      vm.query.filter = '';
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    function cancel() {
      $mdDialog.hide();
    }

    function canEdit(ad) {
      return (ad.editable && ad.downloaded && ad.sawNote);
    }

    function canDelete(ad) {
      return (ad.downloaded);
    }

    function showNotesIcon() {
      return 'assets/images/note.svg';
    }

    function notesSeen(ad) {
      ad.sawNote = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.rejected')
    .controller('PubNotesController', PubNotesController);

  /* @ngInject */
  function PubNotesController($scope, $mdDialog, lodash, order) {
    var vm = this;

    //Accesible variables
    vm.rejectedReason = '';
    vm.note = '';
    vm.allowAgency;

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.allowAgency = true;
      vm.rejectedReason = order.rejected_reason;
      vm.note = angular.isDefined(order.notes[0]) ? order.notes[0] : '';
    }

    function ok() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.resubmitted', [])
    .controller('ResubmittedController', ResubmittedController);

  /* @ngInject */
  function ResubmittedController($scope, $mdDialog, toastr, BlogPostsService,
    NotificationService, PUB_URL_STATE, TYPE_STATE, ROLE) {
    var vm = this;

    //Accesible variables
    vm.resubmitted = [];
    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '-url.profile_name',
      limit: 20,
      page: 1
    };

    //Accesible functions
    vm.showNotesIcon = showNotesIcon;
    vm.approve = approve;
    vm.decline = decline;
    vm.showNotes = showNotes;

    initialize();

    function initialize() {
      NotificationService.deleteNotification(TYPE_STATE.RESUBMITTED_CONTENT, ROLE.PUB);
      BlogPostsService.indexPublisherBlogPosts(PUB_URL_STATE.RESUBMITTED, function (response) {
        vm.resubmitted = response.data.ads || [];
        vm.filtered = vm.resubmitted;
      }, function (error) {
        toastr.error('Couldn\'t retrieve ads. Try again please.');
      });
    }

    function showNotesIcon() {
      return 'assets/images/note.svg';
    }

    function showNotes(ev, ad) {
      $mdDialog.show({
        controller: 'ReportNotesController',
        controllerAs: 'noteCtrl',
        templateUrl: 'app/pages/reports/pub/resubmittedContent/partials/notes.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad
        }
      });
    }

    function downloadContent(ev, ad) {
      if (ad.blog_post_body) {
        blogPostEditDialog(ev, ad, true);
      } else if (ad.word) {
        return ad.word.url;
      }
    }

    function blogPostEditDialog(ev, ad, download) {
      $mdDialog.show({
        controller: 'BlogPostEditController',
        controllerAs: 'blgEditCtrl',
        templateUrl: 'app/pages/reports/adv/rejected/blogPostsEdit/blogPostsEdit.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad,
          download: download
        }
      });
    }

    function approve(ad) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent('')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function (result) {
        BlogPostsService.approveAd(ad.id, function (response) {
          initialize();
        }, function (error) {
          toastr.error('Couldn\'t approve order. Try again please.');
        });
      });
    }

    function decline(ad) {
      if (ad.rejected_counter >= 1) {
        // Reject the ad again will cancel the ad for ever
        var confirm = $mdDialog.confirm()
          .title('Are You Sure?')
          .textContent('If you reject this piece a 2nd time, you will be permanently cancelling this order.')
          .ok('I Understand')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
          BlogPostsService.rejectAd(ad.id, ad, function (response) {
            initialize();
          }, function (error) {
            toastr.error('Couldn\'t decline order. Try again please.');
          });
        });
      } else {
        $mdDialog.show({
          templateUrl: 'app/pages/reports/pub/newOrders/partials/rejectOrder.html',
          controller: 'RejectOrderController',
          controllerAs: 'rejCtrl',
          preserveScope: true,
          clickOutsideToClose: false,
          fullscreen: true
        }).then(function (ads) {
          BlogPostsService.rejectAd(ad.id, ad, function (response) {
            initialize();
          }, function (error) {
            toastr.error('Couldn\'t decline order. Try again please.');
          });
        });
      }
    }

    $scope.$watch('resCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      } else if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      } else if (newValue === '') {
        vm.query.page = 1;
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.resubmitted')
    .controller('NotesControllerActiveContent', NotesControllerActiveContent);

  /* @ngInject */
  function NotesControllerActiveContent($scope, $mdDialog, lodash, ad) {
    var vm = this;

    //Accesible variables
    vm.notes = [];
    vm.ad = {};
    vm.pubNote;
    vm.pubUrl = '';

    //Accesible functions
    vm.ok = ok;
    vm.cancel = cancel;

    initialize();

    function initialize() {
      vm.ad = ad;
      vm.notes = ad.notes;
    }

    function ok() {
      vm.ad.full_pub_url = vm.pubUrl;
      var response = {
        ad: vm.ad,
        note: vm.pubNote
      };
      $mdDialog.hide(response);
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('BlogPostEditController', BlogPostEditController);

  /** @ngInject */
  function BlogPostEditController($log, $mdDialog, toastr, lodash, CampaignsService, BlogPostsService, ad, download) {
    var vm = this;

    // Accessible variables
    vm.blogPost = {};
    vm.infographic = 'no';
    vm.campaigns = [];
    vm.download = download;
    vm.word = {};

    // Accessible functions
    vm.save = save;
    vm.closeDialog = closeDialog;
    vm.setTitle = setTitle;
    vm.isDocRequired = isDocRequired;
    vm.noUrl = noUrl;
    vm.hasContent = hasContent;

    initialize();

    // Functions
    function initialize() {
      CampaignsService.indexCampaigns(function (response) {
        vm.campaigns = response.data.campaigns;
        if (ad) {
          vm.campaign = ad.campaign;
          setupForm(ad);
        } else {
          vm.blogPost = {}
        }
      }, function () {
        $log.error('There was an error retrieving campaigns.');
        toastr.error('Error retrieving campaigns.');
      });
    }

    function setupForm(ad) {
      var campaign = lodash.find(vm.campaigns, function (campaign) {
        return campaign.id == ad.campaign.id;
      });
      var link = lodash.find(campaign.links, function (link) {
        return link.id == ad.link.id;
      });

      vm.newURL = ad.link.href;
      vm.blogPost.campaign = campaign;
      vm.infographic = ad.blog_post_body ? 'yes' : 'no';
      vm.blogPost.blog_post_body = ad.blog_post_body || null;
      vm.word = ad.word || null;
      vm.blogPost.word = vm.word;
      vm.blogPost.id = ad.id;
      vm.blogPost.url = ad.url;
      vm.blogPost.link = link;
      vm.blogPost.blog_post_title = ad.blog_post_title;
      vm.blogPost.link_text = ad.link_text;
      vm.blogPost.editable = ad.editable;
    }

    function save() {
      if (isValidURL(vm.newURL)) {
        vm.blogPost.link = vm.newURL;
        vm.blogPost.campaign.url = vm.newURL;
        CampaignsService.updateCampaign(vm.blogPost.campaign.id, vm.blogPost.campaign,
          function (response) {
            var addedLink = response.data.link;
            createBlogPost(addedLink);
          },
          function (response) {
            var message = response.data.errors['links.href'][0];
            $log.error('Error submiting new site.');
            toastr.error('The site ' + message + '. Please retry.');
          });
      }
    }

    function createBlogPost(link) {
      if (angular.isDefined(link)) {
        vm.blogPost.link = link;
      }

      if (!vm.blogPost.blog_post_body || vm.blogPost.blog_post_body === 'null') {
        vm.blogPost.blog_post_body = null;
      }

      BlogPostsService.updateBlogPost(vm.blogPost.id, vm.blogPost, function () {
        $mdDialog.hide(vm.blogPost.id);
        toastr.success('Updated blog post.');
      }, function () {
        $log.error('There was an error submiting blog post.');
        toastr.error('Error submiting blog post.');
      });
    }

    function closeDialog() {
      $mdDialog.cancel();
    }

    function setTitle() {
      return vm.blogPost.editable ? 'Edit Blog Post' : 'Download infographic';
    }

    function isDocRequired() {
      if (vm.word) {
        return vm.word && !vm.blogPost.word;
      }

      return false;
    }

    function noUrl() {
      return !isValidURL(vm.blogPost.link) && !isValidURL(vm.newURL);
    }

    function hasContent() {
      return vm.blogPost.word || vm.blogPost.blog_post_body;
    }

    function isValidURL(url) {
      return angular.isDefined(url) && url !== null && url !== '';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('ConfirmationController', ConfirmationController);

  /* @ngInject */
  function ConfirmationController($mdDialog, user) {
    var vm = this;

    //Accesible functions
    vm.save = save;
    vm.closeDialog = closeDialog;

    // Functions
    function save() {
      user.current_password = vm.current_password;
      $mdDialog.hide(user)
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.activeAdsContent', [])
    .controller('ActiveAdsContentController', ActiveAdsContentController);

  /* @ngInject */
  function ActiveAdsContentController($scope, $mdEditDialog, $mdDialog, toastr, lodash, BlogPostsService,
    OrdersService, PUB_URL_STATE, ROLE, TYPE_STATE, NotificationService, $window, $location, $anchorScroll, $timeout) {
    var vm = this;

    //Accesible variables
    vm.adsNotSubmitted = [];
    vm.filteredNotSubmitted = [];
    vm.result = 0;
    vm.activeAdsResult = 0;
    vm.notSubmittedTotal = 0;
    vm.queryNotSubmitted = {
      filter: '',
      order: '',
      limit: 20,
      page: 1
    };

    vm.search = false;
    vm.activeAds = [];
    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '',
      limit: 20,
      page: 1
    };
    vm.blank_auto_search_available = true;
    vm.searchFilter = false;

    //Accessible functions
    vm.searchUnsubmitted = searchUnsubmitted;
    vm.removeFilter = removeFilter;
    vm.removeFilterAds = removeFilterAds;
    vm.noAds = noAds;
    vm.activeSearch =  activeSearch;
    vm.noUnsubmittedAds = noUnsubmittedAds;
    vm.noSubmittedAds = noSubmittedAds;
    vm.showSearchIcon = showSearchIcon;
    vm.submitUrl = submitUrl;
    vm.changeIcon = changeIcon;
    vm.isSubmitted = isSubmitted;
    vm.getIconTooltip = getIconTooltip;
    vm.adRejected = adRejected;
    vm.submitOrNotes = submitOrNotes;
    vm.searchOn = searchOn;
    vm.topPaginated = topPaginated;
    vm.orderPayout = orderPayout;
    vm.orderPayoutDate = orderPayoutDate;
    vm.loadActiveAds = loadActiveAds;
    vm.searchBoxKeyUp = searchBoxKeyUp;
    vm.downloadWordDoc = downloadWordDoc;

    initialize();

    function initialize() {
      loadUnsubmitted();
      loadActiveAds();
    }

    function loadUnsubmitted() {
      NotificationService.deleteNotification(TYPE_STATE.ACTIVE_ADS, ROLE.PUB);
      searchUnsubmitted();
    }

    function searchUnsubmitted() {
      BlogPostsService.indexPublisherBlogPostsWithPagination(PUB_URL_STATE.APPROVE_PUB, vm.queryNotSubmitted, function (response) {
        vm.notSubmittedTotal = response.data.results;
        var total_ads = response.data.ads;
        lodash.map(total_ads, function (item) {
          item.submitted = item.full_pub_url;
        });
        vm.adsNotSubmitted = total_ads;
        vm.filterNotSubmitted = vm.adsNotSubmitted;
      }, function (error) {
        toastr.error('Error');
      });
    }

    function loadActiveAds() {
      OrdersService.indexCompletedOrders(vm.query, function (response) {
        vm.activeAds = response.data.orders;
        vm.filtered = vm.activeAds;
        vm.activeAdsResult = response.data.total_count;
        vm.searchFilter = response.data.searched;
      }, function (error) {
        toastr.error('Error');
      });
    }

    function activeSearch() {
      BlogPostsService.indexPublisherBlogPostsWithPagination(PUB_URL_STATE.APPROVE_PUB, vm.queryNotSubmitted, function (response) {
        vm.result = response.data.results;
        var total_ads = response.data.ads;
        vm.adsNotSubmitted = total_ads;
        vm.filterNotSubmitted = vm.adsNotSubmitted;
      });
    }

    $scope.$watch('actAdsCtrl.query.filterNotSubmitted', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      } else if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      } else if (newValue === '') {
        vm.query.page = 1;
      }
    });

    function removeFilter() {
      vm.search = false;
      vm.queryNotSubmitted.filter = '';
    }

    function removeFilterAds() {
      vm.search = false;
      vm.query.filter = '';
      loadActiveAds();
    }

    $scope.editComment = function (event, ad) {
      event.stopPropagation(); // in case autoselect is enabled
      if (!ad.submitted && (!adRejected(ad))) {
        var editDialog = {
          modelValue: ad.full_pub_url,
          placeholder: 'http://MySite.com/new-post',
          save: function (input) {
            ad.full_pub_url = input.$modelValue;
          },
          targetEvent: event,
          title: 'Live Post URL'
        };
        var promise;
        promise = $mdEditDialog.large(editDialog).then(function (response) {
          ad.submitted = false;
        });
      }
    };
    $scope.editCommentBlur = function (event, ad) {
      event.stopPropagation(); // in case autoselect is enabled
      if (!ad.submitted && (!adRejected(ad))) {
        ad.full_pub_url = event.target.value;
        ad.submitted = false;
      }
    };

    function noAds() {
      return noUnsubmittedAds() && noSubmittedAds();
    }

    function noUnsubmittedAds() {
      return vm.adsNotSubmitted.length === 0;
    }

    function noSubmittedAds() {
      return vm.activeAds.length === 0;
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    function submitUrl(ad) {
      if (ad.full_pub_url && !isSubmitted(ad)) {
        BlogPostsService.updateLiveUrl(ad.id, ad.full_pub_url, null, function (response) {
          ad.submitted = true;
          toastr.success('Submitted Ad!');
        }, function (response) {
          toastr.error('Couldn\'t submit live url. Try again please.');
        });
      } else if (!ad.full_pub_url && !isSubmitted(ad)) {
        toastr.error('You must provide the Live Post URL');
      }
    }

    function changeIcon(ad) {
      if (ad.full_pub_url && ad.submitted) {
        return 'hourglass_empty';
      } else if (ad.state === PUB_URL_STATE.REJECTED_ADMIN) {
        return 'assets/images/alert.svg';
      } else {
        return 'check_circle';
      }
      return ad.submitted ? 'hourglass_empty' : 'check_circle';
    }

    function isSubmitted(ad) {
      return ad.state === PUB_URL_STATE.APPROVE_PUB && ad.full_pub_url && ad.submitted;
    }

    function getIconTooltip(ad) {
      if (ad.full_pub_url && ad.submitted && !adRejected(ad)) {
        return 'Waiting on admin approval';
      } else if (adRejected(ad)) {
        return 'Click here to resubmit';
      } else {
        return 'Ready to submit';
      }
    }

    function adRejected(ad) {
      return ad.state === PUB_URL_STATE.REJECTED_ADMIN;
    }

    function showNotes(ad) {
      $mdDialog.show({
        controller: 'NotesControllerActiveContent',
        controllerAs: 'noteCtrl',
        templateUrl: 'app/pages/reports/pub/activeAds/partials/notes.html',
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad
        }
      }).then(function (response) {
        if (response.ad.full_pub_url) {
          BlogPostsService.updateLiveUrl(response.ad.id, response.ad.full_pub_url, response.note, function (response) {
            loadUnsubmitted();
            toastr.success('Submitted Ad!');
          }, function (response) {
            toastr.error('Couldn\'t submit live url. Try again please.');
          });
        }
      });
    }

    function submitOrNotes(ad) {
      switch (ad.state) {
      case PUB_URL_STATE.REJECTED_ADMIN:
        showNotes(ad);
        break;
      case PUB_URL_STATE.APPROVE_PUB:
        submitUrl(ad);
        break;
      case PUB_URL_STATE.APPROVE:
        submitUrl(ad);
        break;
      case PUB_URL_STATE.PAID:
        submitUrl(ad);
        break;
      }
    }

    function searchOn() {
      vm.search = true;
    }

    function topPaginated() {
      $anchorScroll.yOffset = $window.innerHeight - 75;
      $location.hash('topPaginate');
      $anchorScroll();
    }

    function orderPayout(order) {
      if (order.payout) {
        return order.payout.amount;
      } else if(order.ad && order.ad.payout_amount) {
        return order.ad.payout_amount;
      } else {
        return order.url.price;
      }
    }

    function orderPayoutDate(order) {
      if (order.payout != null && order.payout.created_at != null && order.payout.status == 'success') {
        return moment(order.payout.created_at).format('MM-DD-YYYY');
      } else return "Not paid yet";
    }

    function makeBlankAutoSearchAvailable() {
      vm.blank_auto_search_available = true;
    }

    function searchBoxKeyUp(event) {
      // if search box is now empty then re-query data if blank auto search is available
      if (vm.query.filter.length == 0 && vm.blank_auto_search_available) {
        searchQuery();
        // make blank auto search unavailable for 5 seconds to avoid rapid pointless api requests
        vm.blank_auto_search_available = false;
        $timeout(makeBlankAutoSearchAvailable, 5000);
      } else if (event.keyCode === 13) searchQuery(); // if enter key then search without constraint
    }

    function searchQuery() {
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        loadActiveAds();
      }
    }

    function downloadWordDoc(order) {
      $window.open(order.word.url, '_blank');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.awaitingContent', [])
    .controller('ReportAwaitingContentController', ReportAwaitingContentController);

  /* @ngInject */
  function ReportAwaitingContentController($log, $mdDialog, $anchorScroll, $state, $scope, toastr, lodash,
    TYPE_STATE, ROLE, BlogPostsService, NotificationService) {
    var vm = this;

    //Accesible variables
    vm.awaitingAds = [];
    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '-requested_date',
      limit: 20,
      page: 1
    };

    //Accesible functions
    vm.downloadContent = downloadContent;
    vm.cancel = cancel;

    initialize();

    function initialize() {
      NotificationService.deleteNotification(TYPE_STATE.AWAITING_PUBLICATION, ROLE.ADV);
      BlogPostsService.indexBlogPosts({ state: TYPE_STATE.AWAITING_PUBLICATION }, function (response) {
        vm.awaitingAds = response.data.ads;
        vm.filtered = vm.activeAds;
      }, function () {
        $log.error('Error retrieving blog posts');
      });
    }

    $scope.$watch('repAwaitingCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      }

      if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      }

      if (newValue == '') {
        vm.query.page = 1;
      }
    });

    function downloadContent(ev, ad) {
      if (ad.blog_post_body) {
        blogPostEditDialog(ev, ad, true);
      } else if (ad.word) {
        return ad.word.url;
      }
    }

    function blogPostEditDialog(ev, ad, download) {
      $mdDialog.show({
        controller: 'BlogPostEditController',
        controllerAs: 'blgEditCtrl',
        templateUrl: 'app/pages/reports/adv/rejected/blogPostsEdit/blogPostsEdit.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          ad: ad,
          download: download
        }
      });
    }

    function cancel() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports.activeContent', [])
    .controller('ReportActiveContentController', ReportActiveContentController);

  /* @ngInject */
  function ReportActiveContentController($log, $mdDialog, $anchorScroll, $state, $scope, toastr, lodash,
    TYPE_STATE, ROLE, BLOG_POST_STATES, BlogPostsService, NotificationService, INIT_DATE, FileSaver, Blob) {
    var vm = this;

    //Accesible variables
    vm.activeAds = [];
    vm.active_csv_url = '';
    vm.searchReportActiveContents = {
      filter: '',
      order: '-requested_date',
      limit: 20,
      page: 1
    };

    // Accesible functions
    vm.setChangesToDates = setChangesToDates;
    vm.cancelledBlogPost = cancelledBlogPost;
    vm.requireHttp = requireHttp;
    vm.showInfo = showInfo;
    vm.filterAds = filterAds;
    vm.downloadReport = downloadReport;
    vm.liveLinkText = liveLinkText;
    vm.liveLinkStatus = liveLinkStatus;
    vm.getPaginatedBlogPosts = getPaginatedBlogPosts;
    vm.searchReportActivecontent = searchReportActivecontent;

    initialize();

    function initialize() {
      initDates();
      NotificationService.deleteNotification(TYPE_STATE.ACTIVE_CONTENT, ROLE.ADV);
      getBlogPosts(vm.date_from, vm.date_to);
    }

    $scope.$watch('repActCntCtrl.searchReportActiveContents.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.searchReportActiveContents.page;
      }

      if (newValue !== oldValue) {
        vm.searchReportActiveContents.page = 1;
      }

      if (!newValue) {
        vm.searchReportActiveContents.page = bookmark;
      }

      if (newValue == '') {
        vm.searchReportActiveContents.page = 1;
      }
    });

    function setChangesToDates() {
      var totalDays = calculateDifference();
      if (totalDays < 0) {
        toastr.error('Please make sure the selected "to date" is not earlier than the selected "from date"');
        return false;
      }
      // don't think the min/max reflecting any change after init
      // no matter, we are using above diff check instead
      vm.maxDateFrom = vm.date_to;
      vm.minDateTo = vm.date_from;
      vm.totalDays = calculateDifference();
      vm.cannotSearch = false;
      getBlogPosts(vm.date_from, vm.date_to);
    }

    function initDates() {
      vm.myDate = moment().format('MM/DD/YYYY');
      vm.date_to = moment().format('MM/DD/YYYY');
      vm.minDateFrom = moment(INIT_DATE).format('MM/DD/YYYY');
      vm.date_from = moment().subtract(30, 'days').format('MM/DD/YYYY');

      vm.maxDateFrom = vm.date_to;
      vm.minDateTo = vm.minDateFrom
      vm.maxDateTo = vm.date_to;
      vm.totalDays = calculateDifference();
    }

    function calculateDifference() {
      var date_from = moment(vm.date_from, 'MM/DD/YYYY');
      var date_to = moment(vm.date_to, 'MM/DD/YYYY');
      return date_to.diff(date_from, 'days');
    }

    function getBlogPosts(date_from, date_to) {
      vm.searchReportActiveContents.date_from_obj = moment(date_from, 'MM/DD/YYYY').toDate();
      vm.searchReportActiveContents.date_to_obj = moment(date_to, 'MM/DD/YYYY').toDate();
      vm.searchReportActiveContents.state = TYPE_STATE.ACTIVE_CONTENT;
      BlogPostsService.indexActiveContent(vm.searchReportActiveContents, function (response) {
        vm.activeAds = response.data.ads;
        vm.active_csv_url = response.data.spreadsheet_file;
        vm.results = response.data.results;
      }, function () {
        $log.error('Error retrieving blog posts');
      });
    }

    function searchReportActivecontent() {
      if (vm.searchReportActiveContents.filter.length > 0 && vm.searchReportActiveContents.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        getBlogPosts(vm.date_from, vm.date_to);
      }
    }

    function getPaginatedBlogPosts() {
      getBlogPosts(vm.date_from, vm.date_to);
    }

    function cancelledBlogPost(ad) {
      return ad.state === BLOG_POST_STATES.CANCELLED;
    }

    function requireHttp(url) {
      return url.startsWith('http') ? url : 'http://' + url;
    }

    function showInfo() {
      return $mdDialog.show(
        $mdDialog.alert()
        .title('Active Content')
        .htmlContent('These are orders approved by our team for the dates selected. ' +
                     'You can further constrain by searching for Campaign or URL to find a group(s) of orders in your history. ' +
                     'You can also download a full report for your records. ')
        .escapeToClose(false)
        .ok('Ok')
      );
    }

    function filterAds(item) {
      var searchByCampaign = item.campaign.name.toString().toLowerCase().indexOf(vm.searchReportActiveContents.filter) > -1;
      var searchByDestinationUrl = (item.link && item.link.href) ? item.link.href.toString().toLowerCase().indexOf(vm.searchReportActiveContents.filter) > -1 : false;
      var searchByPublisher = item.url.href.toString().toLowerCase().indexOf(vm.searchReportActiveContents.filter) > -1;
      var searchByAnchorText = (item.link_text) ? item.link_text.toString().toLowerCase().indexOf(vm.searchReportActiveContents.filter) > -1 : false;
      return searchByCampaign || searchByDestinationUrl || searchByPublisher || searchByAnchorText;
    }

    function downloadReport(date_from, date_to) {
      var date_from_obj = moment(date_from, 'MM/DD/YYYY').toDate();
      var date_to_obj = moment(date_to, 'MM/DD/YYYY').toDate();
      var filename = 'active_content_' + moment(date_from, 'MM/DD/YYYY').format('MM-DD-YYYY') + '_to_' + moment(date_to, 'MM/DD/YYYY').format('MM-DD-YYYY') + '.csv';

      BlogPostsService.indexBlogPosts({
        state: TYPE_STATE.ACTIVE_CONTENT,
        date_from: date_from_obj,
        date_to: date_to_obj
      }, function (response) {
        var data = response.data;
        var ads = [];
        for (var i = 0; i < data.ads.length; i++) {
          if (filterAds(data.ads[i])) ads.push(data.ads[i]);
        }
        if (ads.length == 0) {
          toastr.error('Sorry, no ads found for this date range.');
          return false;
        }
        var file_data = 'Date Purchased,Campaign,Publisher,DA,Cost,Destination URL,Anchor Text,Live Link';
        for (var i = 0; i < ads.length; i++) {
          var ad = ads[i];
          file_data += "\r\n" + moment(ad.ordered_date).format('MM-DD-YYYY') + ',' + ad.campaign.name.replace(',','-') + ',' + ad.url.href + ',';
          file_data += ad.url.domain_authority + ',' + ad.url_price + ',';
          if (ad.link !== null) {
            file_data += ad.link.href;
          }
          file_data += ',' + ad.link_text + ',';
          if (ad.full_pub_url && (ad.state == 'approved' || ad.state == 'paid' || cancelledBlogPost(ad))) {
            file_data += ad.full_pub_url;
          } else {
            file_data += 'Not Live';
          }
        }
        var blob_data = new Blob([file_data], { type: 'text/plain;charset=utf-8 '});
        FileSaver.saveAs(blob_data, filename);
      }, function () {
        $log.error('Error retrieving ads');
      });
    }

    function liveLinkText(ad) {
      // only want to show live link if live (approved/paid) or cancelled and therefore swapped with notes
      if (ad.full_pub_url && (ad.state == 'approved' || ad.state == 'paid' || cancelledBlogPost(ad))) {
        return ad.full_pub_url;
      } else {
        return 'Not Live'
      }
    }

    function liveLinkStatus(ad) {
      if (ad.full_pub_url && (ad.state == 'approved' || ad.state == 'paid')) {
        return 'link';
      } else {
        return 'text';
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('TwitterHandleController', TwitterHandleController);

  /* @ngInject */
  function TwitterHandleController($scope, $mdDialog) {
    var vm = this;

    //Accesible variables
    vm.twitterHandle = '';

    //Accesible functions
    vm.ok = ok;

    function ok() {
      var response = {
        handle: vm.twitterHandle
      };
      $mdDialog.hide(response);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('SocialHandleController', SocialHandleController);

  /* @ngInject */
  function SocialHandleController($scope, $mdDialog, accounts) {
    var vm = this;

    //Accesible variables
    vm.socialHandle = '';

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.accounts = accounts;
    }

    function ok() {
      var index = _.findIndex(vm.accounts, function(account) { return account.name === vm.socialHandle; });
      var account = vm.accounts[index];
      var response = {
        name: account.name,
        username: account.username,
        fan_count: account.fan_count,
        id: account.id
      };

      $mdDialog.hide(JSON.stringify(response));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('MonthlyVisitorsController', MonthlyVisitorsController);

  /* @ngInject */
  function MonthlyVisitorsController($scope, $mdDialog) {
    var vm = this;

    //Accesible variables
    vm.visitorsPerMonth = '';

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      // nothing
    }

    function ok() {
      $mdDialog.hide(vm.visitorsPerMonth);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('TwitterHandleController', TwitterHandleController);

  /* @ngInject */
  function TwitterHandleController($scope, $mdDialog) {
    var vm = this;

    //Accesible variables
    vm.twitterHandle = '';

    //Accesible functions
    vm.ok = ok;

    function ok() {
      var response = {
        handle: vm.twitterHandle
      };
      $mdDialog.hide(response);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('SocialHandleController', SocialHandleController);

  /* @ngInject */
  function SocialHandleController($scope, $mdDialog, accounts) {
    var vm = this;

    //Accesible variables
    vm.socialHandle = '';

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.accounts = accounts;
    }

    function ok() {
      var index = _.findIndex(vm.accounts, function(account) { return account.name === vm.socialHandle; });
      var account = vm.accounts[index];
      var response = {
        name: account.name,
        username: account.username,
        fan_count: account.fan_count,
        id: account.id
      };

      $mdDialog.hide(JSON.stringify(response));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('MonthlyVisitorsController', MonthlyVisitorsController);

  /* @ngInject */
  function MonthlyVisitorsController($scope, $mdDialog) {
    var vm = this;

    //Accesible variables
    vm.visitorsPerMonth = '';

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      // nothing
    }

    function ok() {
      $mdDialog.hide(vm.visitorsPerMonth);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.editV1', [])
    .controller('EditProfileV1Controller', EditProfileV1Controller);

  /** @ngInject */
  function EditProfileV1Controller($state, $stateParams, $rootElement, $scope, $rootScope, $log, $location, $window, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, ProfilesService, RoutesService, PricingService, SocialHandlesService, UrlsService, PROFILE_TYPE,
                                 SOCIAL, PAGINATION_SIZE, PUB_URL_STATE, MIN_VALUES, HTTP_STATUS, ERRORS_RESPONSES, PricesService, GoogleService, FacebookService, EnvironmentConfig,
                                 NEW_PROFILE, SOCIAL_PRICES, WEB_CONTENT_PRICES
  ) {
    var vm = this;

    var params = $location.search();
    $location.search({});

    var twitterFollowersCount = params.twitter_followers_count;
    var twitterNickname = params.twitter_nickname;
    var igAuthCode = params.ig_auth_code;
    var igUserId = params.ig_user_id;

    // Accessible attributes
    vm.showCategories = false;
    vm.url = {};
    vm.disableMetaButton = false;
    vm.profile = {};
    vm.webContentHandle = {
      web_content_prices: WEB_CONTENT_PRICES.FIELDS
    };
    vm.socialHandles = {
      facebook_handle: {
        name: SOCIAL_PRICES.FACEBOOK.NAME,
        social_prices: SOCIAL_PRICES.FACEBOOK.FIELDS
      },
      twitter_handle: {
        name: SOCIAL_PRICES.TWITTER.NAME,
        social_prices: SOCIAL_PRICES.TWITTER.FIELDS
      },
      instagram_handle: {
        name: SOCIAL_PRICES.INSTAGRAM.NAME,
        social_prices: SOCIAL_PRICES.INSTAGRAM.FIELDS
      },
      youtube_handle: {
        name: SOCIAL_PRICES.YOUTUBE.NAME,
        social_prices: SOCIAL_PRICES.YOUTUBE.FIELDS
      }
    };
    vm.categories = [];
    vm.copyProfile = {};
    vm.profileNames = [];
    vm.followers = [];
    vm.query = {
      filter: '',
      order: 'state',
      limit: 20,
      page: 1
    };
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;
    vm.urls = [];
    vm.csv;
    vm.search = false;
    vm.filtered = [];
    vm.filteredPausedStatus = [];
    vm.suggestedPrice = '';
    vm.pricePlaceholder = 'Payout';
    $rootScope.sampleDownloaded = false;
    vm.web_content = {};
    vm.analytics = [];
    vm.initialAnalytics = {};
    vm.selectedAnalytics = {};
    vm.analyticsAuthorized = false;
    vm.gaSaved = false;
    vm.showProgressCircular = false;
    vm.state = "";
    vm.ethnicitiesList = NEW_PROFILE.ETNIC_GROUPS;
    vm.audienceGenderList = NEW_PROFILE.GENDER_LIST;
    vm.audienceEstimatedIncomes = NEW_PROFILE.AUDIENCE_ESTIMATED_INCOMES;
    vm.languagesList = NEW_PROFILE.LANGUAGES_LIST;
    vm.ageGroupList = NEW_PROFILE.AGE_GROUPS;
    vm.petsList = NEW_PROFILE.PETS_LIST;
    vm.hasChangedCategories = false;
    vm.hasChangedLanguages = false;
    vm.hasChangedPets = false;
    vm.hasChangedAudienceEthnicities = false;
    vm.hasChangedAudienceAge = false;
    vm.hideCategories = true;
    vm.hideAudienceDemographics = true;
    vm.hideWebContent = true;
    vm.hideDomainInfo = true;
    vm.hideFacebook = true;
    vm.hideInstagram = true;
    vm.hideYoutube = true;
    vm.hideTwitter = true;

    // SEO price grid
    $scope.da;
    $scope.tf;
    $scope.close = function () {
      $mdDialog.cancel();
    }

    // Accessible functions
    vm.submit = submit;
    vm.avatarUploaded = avatarUploaded;
    vm.showPriceGa = showPriceGa;
    vm.canSubmit = canSubmit;
    vm.showPriceSEO = showPriceSEO;
    vm.isInfluencer = isInfluencer;
    vm.isBroker = isBroker;
    vm.isBlogger = isBlogger;
    vm.isContributor = isContributor;
    vm.cantSubmit = cantSubmit;
    vm.showInfo = showInfo;
    vm.editDomain = editDomain;
    vm.setFollowValue = setFollowValue;
    vm.clearCsv = clearCsv;
    vm.showCsvDialog = showCsvDialog;
    vm.removeFilter = removeFilter;
    vm.setPausedValue = setPausedValue;
    vm.pausedStateChanged = pausedStateChanged;
    vm.nonPausableUrl = nonPausableUrl;
    vm.checkSocialMinValues = checkSocialMinValues;
    vm.getPricingLabel = getPricingLabel;
    vm.canEditDomainInfo = canEditDomainInfo;
    vm.canEditSponsoredWeb = canEditSponsoredWeb;
    vm.canEditSocialHandle = canEditSocialHandle;
    vm.canEditSocialPrice = canEditSocialPrice;
    vm.displayPendingStateText = displayPendingStateText;
    vm.showUploadedFileDialog = showUploadedFileDialog;
    vm.sendFileToAdmin = sendFileToAdmin;
    vm.checkURL = checkURL;
    vm.getPencilTooltip = getPencilTooltip;
    vm.categoriesChanged = categoriesChanged;
    vm.audienceAgeChanged = audienceAgeChanged;
    vm.ethnicitiesChanged = ethnicitiesChanged;
    vm.languagesChanged = languagesChanged;
    vm.petsChanged = petsChanged;
    vm.showXlsIcon = showXlsIcon;
    vm.showSearchIcon = showSearchIcon;
    vm.saveHeaderChanges = saveHeaderChanges;
    vm.saveChanges = saveChanges;
    vm.saveWebContent = saveWebContent;
    vm.saveSocialContent = saveSocialContent;
    vm.saveSearchContent = saveSearchContent;
    vm.checkGAMinValues = checkGAMinValues;
    vm.getPropertyLabelGA = getPropertyLabelGA;
    vm.getPricingLabelGA = getPricingLabelGA;
    vm.showWarningPopup = showWarningPopup;
    vm.changeIcon = changeIcon;
    vm.getIconTooltip = getIconTooltip;
    vm.showRejectionReasons = showRejectionReasons;
    vm.isRejected = isRejected;
    vm.getPausedStatus = getPausedStatus;
    vm.handleFacebookAuthentication = handleFacebookAuthentication;
    vm.disconnectSocial = disconnectSocial;
    vm.loadSocialHandle = loadSocialHandle;
    vm.authorize = authorize;
    vm.getYouTubeFollowers = getYouTubeFollowers;
    vm.queryAccounts = queryAccounts;
    vm.authenticateTwitter = authenticateTwitter;
    vm.analyticSelected = analyticSelected;
    vm.handleAccounts = handleAccounts;
    vm.handleProperties = handleProperties;
    vm.handleProfiles = handleProfiles;
    vm.handleReports = handleReports;
    vm.disconnectGA = disconnectGA;
    vm.updateDomain = updateDomain;
    vm.toggleEditProfileBlock = toggleEditProfileBlock;
    vm.handleFacebookConnection = handleFacebookConnection;
    vm.handleInstagramConnection = handleInstagramConnection;
    vm.handleYoutubeConnection = handleYoutubeConnection;
    vm.handleTwitterConnection = handleTwitterConnection;
    vm.showConfirmDisconnectSocialModal = showConfirmDisconnectSocialModal;
    vm.setSubtype = setSubtype;
    vm.showEditSocialPriceInfo = showEditSocialPriceInfo;
    vm.getEditSocialPriceInfo = getEditSocialPriceInfo;
    vm.getPriceClass = getPriceClass;

    init();

    function init() {
      if (angular.isDefined($stateParams.profileId)) {
        ProfilesService.showProfile($stateParams.profileId, function (response) {
            vm.profile = response.data;
            setSocialHandles();
            setcategories();
            setInitialWebContent();

            if (twitterParamsReceived()) vm.hideTwitter = false;

            ProfilesService.getProfileSocialUrls(function (response) {
              vm.profileSocialUrls = response.data.profile_social_urls;
              if (igAuthCode && igUserId) {
                ProfilesService.verifyInstagramAccount(igAuthCode, igUserId, function (response) {
                  $location.search({});
                  vm.hideInstagram = false;
                  var username = response.data.username;
                  if (checkExistedSocialAccount('instagram', username)) {
                    showUseAnotherAccountModal(vm.profile.instagram_handle, 'instagram')
                  } else {
                    getInstagramFollowers(username);
                  }

                }, function (error) {
                  $location.search({});
                  console.log(error);
                });
              }
            });

            if (twitterFollowersCount && twitterNickname) {
              loadSocialHandle(vm.profile.twitter_handle, 'twitter', twitterNickname, twitterFollowersCount)
            }

            vm.urls = vm.profile.urls;
            vm.url = vm.urls[0];
            if (vm.url) {
              vm.url.canEdit = !isRejected(vm.url.state);
              checkURL();
            }

            vm.filtered = vm.profile.urls;
            vm.filteredPausedStatus = vm.filtered.map(function(url) {
              return setPausedValue(url);
            });

            angular.copy(vm.profile, vm.copyProfile);
            ProfilesService.getProfileNames(function (response) {
              vm.profileNames = response.data.profile_names;
              lodash.remove(vm.profileNames, function (name) {
                return vm.profile.name == name;
              });
            });
          },
          function () {
            $log.log('Error retrieving the profile.');
            toastr.error('There was an error retrieving the profile.');
          });
      }
      $scope.$mdMedia = $mdMedia;
    }

    function twitterParamsReceived() {
      if (angular.isDefined($stateParams.profileId) &&
          angular.isDefined(params.twitter_followers_count) &&
          angular.isDefined(params.twitter_nickname))
      {
        return true;
      } else {
        return false;
      }
    }

    function categoriesChanged() {}
    function audienceAgeChanged() {}
    function ethnicitiesChanged() {}
    function languagesChanged() {}
    function petsChanged() {}

    function getInstagramFollowers(username) {
      ProfilesService.getInstagramData(username, function (response) {
        var followersCount = response.data.qty_followers;
        if (followersCount == null) {
          // followersCount = MIN_VALUES.SOCIAL;
          return $mdDialog.show($mdDialog.alert()
            .title('')
            .textContent('Hey ' + username + ',  seems like Instagram is taking longer than normal. Nothing to worry about. Should only be a moment longer.  Remember, after we get the data, click the orange ? icon to see what our suggested pricing is.')
            .escapeToClose(false)
            .ok('Ok')
          )
          .then(function(result) {
            getInstagramFollowers(username);
          });
        }
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, followersCount);
      }, function (error) {
        console.log(error);
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, MIN_VALUES.SOCIAL);
      });
    }

    function setcategories() {
      vm.categories = vm.profile.categories;
      vm.categories.forEach(function(category) {
        category.displayName = category.name;
      });
    }

    function setInitialWebContent() {
      if (!vm.profile.web_content) {
        vm.profile.web_content = {};
        vm.initialAnalytics.selected = "none";
        vm.web_content.muv = '';
        vm.selectedAnalytics = vm.initialAnalytics;
        vm.analytics = [];
        vm.analyticsAuthorized = false;
      } else if(vm.profile.web_content.href) {
        vm.hidden = true;
        vm.gaSaved = true;
        vm.initialAnalytics.selected = vm.profile.web_content.website_url;
        vm.selectedAnalytics = vm.initialAnalytics;
        vm.analyticsAuthorized = true;
      }
      setWebContentPrices()
    }

    function setWebContentPrices() {
      var merged = _.merge(
        _.keyBy(vm.profile.web_content.web_content_prices, 'price_type'),
        _.keyBy(vm.webContentHandle.web_content_prices, 'price_type')
      );
      vm.profile.web_content.web_content_prices = _.values(merged);
    }

    function toggleEditProfileBlock(block, hasChanged, hideBlock) {
      if( hasChanged && !hideBlock) {
        showConfirmToggleModal(block)
      }

      switch (block) {
        case 'categories':
          vm.hideCategories = !vm.hideCategories;
          break;
        case 'audienceDemographics':
          vm.hideAudienceDemographics = !vm.hideAudienceDemographics;
          break;
        case 'webContent':
          vm.hideWebContent = !vm.hideWebContent;
          break;
        case 'domainInformation':
          vm.hideDomainInfo = !vm.hideDomainInfo;
          break;
        case 'facebook':
          vm.hideFacebook = !vm.hideFacebook;
          break;
        case 'instagram':
          vm.hideInstagram = !vm.hideInstagram;
          break;
        case 'youtube':
          vm.hideYoutube = !vm.hideYoutube;
          break;
        case 'twitter':
          vm.hideTwitter = !vm.hideTwitter;
      }
    }

    function getEditSocialPriceInfo(state) {
      switch (state) {
        case PUB_URL_STATE.ACTIVE:
          return 'Price approved';
        case PUB_URL_STATE.PENDING:
          return 'Pending review';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'Pending review';
        case PUB_URL_STATE.REJECTED:
          return 'Price declined';
        case PUB_URL_STATE.CANCELLED:
          return 'Price rejected'
      }
    }

    function getPriceClass(price) {
      if (price.changed) return '';
      switch (price.state) {
        case PUB_URL_STATE.ACTIVE:
          return 'active-social';
        case PUB_URL_STATE.PENDING:
          return 'submitted-social';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'submitted-social';
        case PUB_URL_STATE.REJECTED:
          return 'rejected-social';
        case PUB_URL_STATE.CANCELLED:
          return 'rejected-social'
      }
    }

    function showConfirmToggleModal(block) {
      var confirm = $mdDialog.confirm()
        .textContent('Do you want to save changes?')
        .cancel('No')
        .ok('Yes');

      $mdDialog.show(confirm).then(function (result) {
        switch (block) {
          case 'categories':
            saveChanges('categories');
            break;
          case 'audienceDemographics':
            saveChanges('audienceDemographics');
            break;
          case 'domainInformation':
            saveSearchContent(vm.domainInformationForm);
            break;
          case 'webContent':
            saveWebContent(vm.webContentForm);
            break;
          case 'facebook':
            saveSocialContent(vm.facebookForm, 'facebook');
            break;
          case 'instagram':
            saveSocialContent(vm.instagramForm, 'instagram');
            break;
          case 'youtube':
            saveSocialContent(vm.youtubeForm, 'youtube');
            break;
          case 'twitter':
            saveSocialContent(vm.twitterForm, 'twitter');
            break;
          default:
            console.log('default');
            break;
        }

      }, function () {
      });
    }

    function getPencilTooltip(state) {
      switch (state) {
      case PUB_URL_STATE.REJECTED:
        return 'Make some changes and we\'ll approve this domain';
      case PUB_URL_STATE.CANCELLED:
        return 'We have rejected this domain. Sorry!';
      case PUB_URL_STATE.ACTIVE:
        return 'Url is live. Click here to edit.';
      case PUB_URL_STATE.PAUSED:
        return 'This URL is paused from search. Click here to change.';
      case PUB_URL_STATE.RESUBMITTED:
        return 'URL is Pending Approval by Admin';
      default:
        return 'URL is Pending Approval by Admin';
      }
    }

    function changeIcon(state) {
      switch (state) {
      case PUB_URL_STATE.PENDING:
        return 'hourglass_empty';
      case PUB_URL_STATE.RESUBMITTED:
        return 'hourglass_empty';
      case PUB_URL_STATE.REJECTED:
        return 'warning';
      case PUB_URL_STATE.ACTIVE:
        return 'check_circle';
      default:
        return 'help'
      }
    }

    function getIconTooltip(state) {
      switch (state) {
      case PUB_URL_STATE.PENDING:
        return 'Waiting on admin approval.';
      case PUB_URL_STATE.RESUBMITTED:
        return 'Waiting on admin approval.';
      case PUB_URL_STATE.ACTIVE:
        return 'Active product.';
      case PUB_URL_STATE.REJECTED:
        return 'Rejected product. Click to see why.';
      case PUB_URL_STATE.UNDER_REVIEW:
        return 'Waiting for admin approval.';
      default:
        return 'No tooltip found for this state.';
      }
    }

    function isRejected(state) {
      return state === PUB_URL_STATE.REJECTED;
    }

    function showRejectionReasons(product) {
      if (isRejected(product.state)) {
        $mdDialog.show({
          controller: 'NotesController',
          controllerAs: 'noteCtrl',
          templateUrl: 'app/pages/profiles/editProfile/notes/notes.html',
          clickOutsideToClose: false,
          escapeToClose: true,
          focusOnOpen: true,
          locals: {
            product: product
          }
        }).then(function (response) {
          product.canEdit = response.canEdit;
        });
      }
    }

    function setSocialHandles() {
      lodash.map(vm.socialHandles, function (handle) {
        var handleKey = getHandleKey(handle.name);
        var merged = _.merge(
          _.keyBy(vm.profile[handleKey].social_prices, 'price_type'),
          _.keyBy(vm.socialHandles[handleKey].social_prices, 'price_type')
        );
        vm.profile[handleKey].social_prices = _.values(merged);
      });
    }

    function getPropertyLabelGA() {
      return vm.web_content.muv ? 'Website (' + vm.web_content.muv + ' visits)' : 'Website';
    }

    function getPricingLabelGA(network) {
      return vm.web_content.muv && vm.web_content.muv >= MIN_VALUES.GA ? 'Suggested price: ' + PricingService.getPrice(vm.web_content.muv, network) : 'Your price per post (USD):';
    }

    function checkGAMinValues(display) {
      if (vm.profile.web_content.muv && vm.profile.web_content.muv >= MIN_VALUES.GA) {
        $scope.followers = vm.profile.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          'Should be placed on front page for best performance. ';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'You Have ' + vm.profile.web_content.muv + ' Monthly Visitors';
        if (display) {
          displayRowGridPrice();
        }
      } else {
        showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. You currently do not meet ' +
          'that criteria. When you do reach that traffic, you can come back to ' +
          'this profile and submit it then.', 'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
        });
      }
      // need to avoid the below code for now
      if (false && vm.profile.web_content.href) {
        // This just calls a random number generator. Wahoo. Replaced with front end
        // GA reporting service, but that only works within the initial authorize session
        // ProfilesService.getAnalyticsMUV(vm.profile.web_content.href, function (response) {
        //   vm.web_content.muv = response.data.visitors;
        GoogleService.queryCoreReportingApi(vm.profile.web_content.ga_profile_id, function (response) {
          vm.web_content.muv = Math.round(parseInt(response.result.totalsForAllResults['ga:users']) / 3);
          if (angular.isDefined(EnvironmentConfig.TEST_GA_VISITORS)) vm.web_content.muv = EnvironmentConfig.TEST_GA_VISITORS;
          if (vm.web_content.muv < MIN_VALUES.GA) {
            showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
              'per month to participate in this product. You currently do not meet ' +
              'that criteria. When you do reach that traffic, you can come back to ' +
              'this profile and submit it then.', 'Ok I understand').then(function (result) {
              vm.profile.web_content.href = '';
              vm.profile.web_content.price = '';
            });
          } else {
            $scope.followers = vm.web_content.muv;
            $scope.network = 'GA';
            $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
            $scope.content = 'Content will be disclosed and will have no-follow links. ' +
              'Should be placed on front page for best performance. ';
            $scope.contentLineTwo = 'Content must be up 6 months or longer.';
            $scope.header = 'Monthly Visitors';
            if (display) {
              displayRowGridPrice();
            }
          }
        }, function (response)  {
          toastr.error(response.error);
        });
      } else if (false) {
        console.log('check min values setting muv to nothing');
        vm.web_content.muv = '';
        getPricingLabelGA('GA');
      }
    }

    function checkGAUncompleted() {
      var bothSet = ((angular.isDefined(vm.profile.web_content.href) && vm.profile.web_content.href != '') &&
        vm.profile.web_content.price > 0);
      var noneSet = !(vm.profile.web_content.href || vm.profile.web_content.price);
      return bothSet || noneSet;
    }

    function checkSocialMinValues(type, socialMedia, display) {
      if (!socialMedia.url) {
        socialMedia.followers = '';
        getPricingLabel(socialMedia, type);
      } else {
        var handles = [];
        var socialMediaFlag = false;
        switch (type) {
        case SOCIAL.Facebook:
          socialMediaFlag = true;
          handles = vm.profile.facebook_handle;
          break;
        case SOCIAL.Twitter:
          socialMediaFlag = true;
          handles = vm.profile.twitter_handle;
          break;
        case SOCIAL.Youtube:
          handles = vm.profile.youtube_handle;
          break;
        case SOCIAL.Instagram:
          handles = vm.profile.instagram_handle;
          break;
        }
        var pos = lodash.findIndex(handles, ['$$hashKey', socialMedia.$$hashKey]);

        // Adding this code due to the additional check thru backend below not working
        if (socialMedia.followers < MIN_VALUES.SOCIAL) {
          showAlert('Minimum followers', 'We apologize but we need a minimum of 1000 followers for ' +
            'EACH social handle for you to participate in this product. You ' +
            'currently do not meet that criteria for this handle. When you do ' +
            'reach that engagement, you can come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
            handles[pos].url = '';
            handles[pos].price = '';
          });
        } else {
          var price = PricingService.getPrice(socialMedia.followers, type);
          var videoPrice = PricingService.getVideoPrice(socialMedia.followers, type);
          if (type === 'facebook') {
            var sharingPrice =  PricingService.getSharingPrice(socialMedia.followers, type);
          }
          socialMedia.suggested_post_price = price;
          socialMedia.suggested_video_price = videoPrice;
          socialMedia.suggested_sharing_price = sharingPrice;

          $scope.followers = socialMedia.followers;
          $scope.network = type;
          $scope.rowHeader = socialMediaFlag ? 'Suggested Pricing for Facebook, Twitter & Pinterest' : 'Suggested Pricing for Instagram & YouTube';
          $scope.content = 'According to (Social Media channel), you have (' + socialMedia.followers + ') followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.';
          $scope.contentLineTwo = 'For your protection, this content will be disclosed per FTC guidelines.';
          $scope.header = 'You have ' + socialMedia.followers + ' Followers';
          if (display) {
            displayRowGridPrice();
          }
        }

        // Below code will NOT work as that API endpoint returns random numbers!
        // ProfilesService.getSocialHandleFollowers(socialMedia.url, type, function (response) {
        //   socialMedia.followers = response.data.followers;
        //   if (socialMedia.followers < MIN_VALUES.SOCIAL) {
        //     showAlert('Minimum followers', 'We apologize but we need a minimum of 1000 followers for ' +
        //       'EACH social handle for you to participate in this product. You ' +
        //       'currently do not meet that criteria for this handle. When you do ' +
        //       'reach that engagement, you can come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
        //       handles[pos].url = '';
        //       handles[pos].price = '';
        //     });
        //   } else {
        //     $scope.followers = socialMedia.followers
        //     $scope.network = type;
        //     $scope.rowHeader = socialMediaFlag ? 'Suggested Pricing for Facebook, Twitter & Pinterest' : 'Suggested Pricing for Instagram & YouTube';
        //     $scope.content = 'For your protection, this content will be disclosed per FTC guidelines.';
        //     $scope.contentLineTwo = '';
        //     $scope.header = 'Followers';
        //     if (display) {
        //       displayRowGridPrice();
        //     }
        //   }
        // },
        // function (response) {
        //   toastr.error(response.error);
        // });
      }
    }

    function canSubmit() {
      return !checkGAUncompleted();
    }

    function saveHeaderChanges(form) {
      ProfilesService.updateProfile(vm.profile.id, {
        image: vm.profile.image,
        name: vm.profile.name
      }, function () {
        form.$setPristine();
        toastr.success('Profile\'s name/image successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this profile, please retry.');
      });
    }

    function saveChanges(type) {
      prepareNewProfile(type);
      if (vm.igAuthCode) vm.auth_key = vm.igAuthCode;
      ProfilesService.updateProfile(vm.profile.id, vm.newProfile, function () {
        updateProfileState(type);
        toastr.success( capitalizeFirstLetter(type.replace(/([a-z0-9])([A-Z])/g, '$1 $2')) + ' successfully updated.')
      }, function () {
        toastr.error('There was an error updating ' + type.split('_').join(' ') + ', please retry.');
      });
    }

    function prepareNewProfile(type) {
      switch (type) {
        case 'categories':
          vm.newProfile = {
            categories_ids: lodash.map(vm.categories, 'id')
          };
          break;
        case 'audienceDemographics':
          vm.newProfile = {
            audience_age_groups: vm.profile.audience_age_groups,
            audience_ethnicities: vm.profile.audience_ethnicities,
            pets: vm.profile.pets,
            languages: vm.profile.languages,
            audience_gender: vm.profile.audience_gender,
            audience_estimated_income: vm.profile.audience_estimated_income
          };
          break;
      }
    }

    function updateProfileState(type) {
      switch (type) {
        case 'categories':
          vm.hasChangedCategories = false;
          vm.hideCategories = true;
          break;
        case 'audience_demographics':
          vm.hasChangedAudienceAge = false;
          vm.hasChangedAudienceEthnicities = false;
          vm.hasChangedPets = false;
          vm.hasChangedLanguages = false;
          vm.hasChangedAudienceIncome = false;
          vm.hasChangedAudienceGender = false;
          break
      }
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function updateProfile(form) {
      // Submit search content product
      ProfilesService.updateProfile(vm.profile.id, {
        urls: [{
          id: vm.url.id,
          href: vm.url.href,
          price: vm.url.price,
          description: vm.url.description
        }]
      }, function () {
        form.$setPristine();
        vm.hideDomainInfo = true;
        ProfilesService.showProfile(vm.profile.id, function (response) {
          var data = response.data;
          vm.url = data.urls[0];
          if (url) {
            vm.url.canEdit = !isRejected(vm.url.state);
          }
          vm.urls = data.urls;
        }, function () {
          toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
        });
        toastr.success('Profile\'s web content successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this profile\'s web content, please retry.');
      });
    }

    function saveSearchContent(form) {
      if (form.$error.pattern || form.$error.required) return;

      // Check if url is duplicated or rejected
      if (form.url.$dirty) {
        ProfilesService.checkUrl(vm.url.href, function (response) {
          var state = response.data.state;
          switch (state) {
            case "suspended":
              vm.state = "suspended";
              form.url.$setValidity('active', false);
              break;
            case "paused":
              vm.state = "paused";
              form.url.$setValidity('active', false);
              break;
            case "rejected":
              vm.state = "rejected";
              form.url.$setValidity('active', false);
              break;
            case "duplicated":
              form.url.$setValidity('unmatched', false);
              break;
            case "valid":
              updateProfile(form);
              updateDomain(form);
              vm.hideDomainInfo = true;
              break;
          }
        }, function (response) {
          toastr.error(response.data.error || 'Error checking domain url.');
        });
      } else {
        updateProfile(form);
        updateDomain(form);
      }
    }

    function saveWebContent(form) {
      ProfilesService.updateProfile(vm.profile.id, {
        web_content: {
          id: vm.profile.web_content.id,
          web_content_prices: vm.profile.web_content.web_content_prices,
          href: vm.profile.web_content.href,
          ga_account_id: vm.profile.web_content.ga_account_id,
          ga_profile_id: vm.profile.web_content.ga_profile_id,
          website_url: vm.profile.web_content.website_url,
          muv: vm.profile.web_content.muv,
        }
      }, function () {
        form.$setPristine();
        vm.hideWebContent = true;
        ProfilesService.showProfile(vm.profile.id, function (response) {
          var data = response.data;
          vm.profile.web_content = data.web_content;
          setWebContentPrices();
        }, function () {
          toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
        });
        toastr.success('Profile\'s web content successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this profile\'s web content, please retry.');
      });
    }

    function saveSocialContent(form, socialNetwork) {
      var profile = vm.profile;
      var updateData;
      switch (socialNetwork) {
        case 'facebook':
          updateData =  {
            facebook_handle: profile.facebook_handle
          };
          break;
        case 'instagram':
          updateData =  {
            instagram_handle: profile.instagram_handle
          };
          break;
        case 'youtube':
          updateData =  {
            youtube_handle: profile.youtube_handle
          };
          break;
        case 'twitter':
          updateData =  {
            twitter_handle: profile.twitter_handle
          };
      }

      ProfilesService.updateProfile(profile.id, updateData, function () {
        ProfilesService.showProfile(profile.id, function (response) {
          vm.profile = response.data;
          setSocialHandles();
        }, function () {
          toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
        });
        form.$setPristine();
        toastr.success('Profile\'s social content successfuly updated.');
      }, function (response) {
        if (response.data.errors) {
          var errors = lodash.map(Object.keys(response.data.errors), function (err) {
            return response.data.errors[err]
          });
          lodash.each(errors, function (error) {
            toastr.error(error[0]);
          })
        }
      });
    }

    function submit() {
      vm.noCategories = false;
      if (!vm.categories.length) {
        vm.noCategories = true;
      } else {
        vm.profile.categories_ids = lodash.map(vm.categories, 'id');
        if (vm.profile.urls.length == 1) {
          vm.profile.urls = [];
          vm.profile.urls.push(vm.url);
        }
        if (isBlogger()) {
          ProfilesService.getDomainInformation(vm.url.href, function (response) {
            vm.domInfo = response.data;
            if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
              vm.domInfo.domain_authority < MIN_VALUES.DA) {
              showSEODialog();
            } else {
              if (vm.profile.web_content.id && vm.profile.web_content.href == '' &&
                vm.profile.web_content.price == '') {
                vm.profile.web_content._destroy = 1;
              }
              continueSubmit();
            }
          });
        } else {
          continueSubmit();
        }
      }
    }

    function continueSubmit() {
      if (vm.csv) {
        vm.profile.csv = vm.csv;
      }
      ProfilesService.updateProfile($stateParams.profileId, vm.profile, function (response) {
        toastr.success('Successfully updated the profile!');
        if (socialHandlesChange()) {
          showAlert('New social handle', 'Thanks for submitting new handles! ' +
            'We will need to vet these submission before accepting. Please respond to our email! Thank you!.', 'Got it').then(function (result) {
            RoutesService.dashboard();
          });
        } else {
          RoutesService.dashboard();
        }
      }, function (response) {
        handleErrors(response.data.errors);
      });
    }

    function handleErrors(errors) {
      lodash.forEach(errors, function (error) {
        toastr.error(error[0]);
      });
    }

    function showSEODialog() {
      showAlert('Minimum Values', 'We apologize but we need a minimum MOZ Domain Authority ' +
        'score of 15. And a minimum of of Majestic Trust Flow score of 5 for ' +
        'you to participate in this product. You currently do not meet one, ' +
        'or both, of these criteria. When you do reach these targets, you can ' +
        'come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
        return false;
      });
    }

    function avatarUploaded() {
      return angular.isDefined(vm.profile.image) && vm.profile.image != null;
    }

    function showPriceGa(network, socialHandle, display) {
      if (network === 'GA') {
        if (angular.isDefined(vm.web_content.muv)) {
          $scope.followers = 0;
        }
        checkGAMinValues(display);
      } else {
        if (angular.isUndefined(socialHandle.followers)) {
          $scope.followers = 0;
          $scope.network = '';
        }
        checkSocialMinValues(network, socialHandle, display);
      }
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/partials/rowDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'EditProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function cantSubmit() {
      if (!vm.profile.name) {
        return true;
      } else {
        if (isBlogger()) {
          return !(oneProductIsSet() && (vm.url.description && vm.url.href));
        } else if (isBroker() || isContributor()) {
          return !(vm.url.description && vm.url.price);
        } else if (isInfluencer()) {
          return !(vm.url.description && socialMediaProduct());
        }
      }
    }

    function setSubtype(socialHandle, subtype) {
      socialHandle.subtype = subtype;
    }

    function handleFacebookConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        handleFacebookAuthentication(socialHandle, socialNetwork);
      }
    }

    function handleInstagramConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        switch (socialHandle.subtype) {
          case 'simple':
            getAuthURL();
            break;
          case 'verified':
            handleFacebookAuthentication(socialHandle, socialNetwork);
            break;
        }
      }
    }

    function getAuthURL() {
      ProfilesService.getInstagramAuthUrl('edit', vm.profile.id, function (response) {
        if (response.data.auth_url) {
          $window.location.href = response.data.auth_url;
        }
      }, function (error) {
        console.log(error)
      });
    }

    function handleYoutubeConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        authorize(ev, true, socialHandle)
      }
    }

    function handleTwitterConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        authenticateTwitter(ev, socialHandle)
      }
    }

    function oneProductIsSet() {
      var webProduct = vm.profile.web_content.href && vm.profile.web_content.price;
      var socialProduct = socialMediaProduct();
      var seoProduct = vm.url.price;

      return webProduct || socialProduct || seoProduct;
    }

    function socialMediaProduct() {
      var socialMediaProduct = [true, true, true, true, true];

      updateSocialmedia(socialMediaProduct, vm.profile.facebook_handle, 0);
      updateSocialmedia(socialMediaProduct, vm.profile.twitter_handle, 1);
      updateSocialmedia(socialMediaProduct, vm.profile.youtube_handle, 2);
      updateSocialmedia(socialMediaProduct, vm.profile.instagram_handle, 3);

      return lodash.some(socialMediaProduct);
    }

    function socialHandlesRepeated() {
      return SocialHandlesService.anyRepeated(vm.profile);
    }

    function socialHandlesChange() {
      return SocialHandlesService.anyChange(vm.profile, vm.copyProfile);
    }

    function updateSocialmedia(socialMediaProduct, social_handle, index) {
      var count = 0;
      lodash.map(social_handle, function (s) {
        s._destroy = (s.url && s.price) ? 0 : 1;
        if (!s.url || !s.price) {
          count++;
        }
      });
      if (count == social_handle.length) {
        socialMediaProduct[index] = false;
      }
    }

    function isInfluencer() {
      return vm.profile.profile_type == PROFILE_TYPE.INFLUENCER;
    }

    function isBlogger() {
      return vm.profile.profile_type == PROFILE_TYPE.BLOGGER;
    }

    function isBroker() {
      return vm.profile.profile_type == PROFILE_TYPE.BROKER;
    }

    function isContributor() {
      return vm.profile.profile_type == PROFILE_TYPE.CONTRIBUTOR;
    }

    function showPriceSEO() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/partials/gridDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'EditProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function sendFileToAdmin() {
      ProfilesService.updateSpreadsheetProfile(vm.profile.id, vm.profile.profile_type, vm.csv, function (response) {
        refreshUrls();
        if (response.data && response.data.errors[0] == ERRORS_RESPONSES.ALREADY_TAKEN) {
          showSomeUrlsDuplicatedDialog();
        } else if (response.data && response.data.errors[0] == ERRORS_RESPONSES.INVALID) {
          showBadUrlDialog();
        } else {
          showUploadedFileDialog();
        }
        clearCsv();
      }, function (response) {
        if (response.status == HTTP_STATUS.BAD_REQUEST) {
          if (response.data.error == ERRORS_RESPONSES.ALREADY_TAKEN) {
            showDuplicateDialog();
          } else if (response.data.error == ERRORS_RESPONSES.INVALID) {
            showBadUrlDialog();
          } else {
            toastr.error(response.data.error);
          }
          clearCsv();
        }
      });
    }

    function showSomeUrlsDuplicatedDialog() {
      showAlertHTML('Some Duplicated Urls', 'Some Urls are already in out DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showUploadedFileDialog() {
      return showAlertHTML('Spreadsheet uploaded', 'Thank you for uploading these domains. ' +
        'Our admin department will review them one at a time and you will receive notifications ' +
        'when they are either approved or rejected.', 'Got it!').then(function (result) {
        return false;
      });
    }

    function showDuplicateDialog() {
      return showAlertHTML('Duplicate Url', 'This URL is already in our DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showBadUrlDialog() {
      return showAlertHTML('Bad Url format', 'Please take a look at your file, some urls are not correct.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showInfo(step) {
      switch (step) {
      case 2:
        return showAlertHTML('Search Content (SEO)', "This product is for SEO firms. " +
          "You are accepting content that is 'natural and organic'. It is NOT a sales pitch. " +
          "Content will NOT be disclosed as paid. YOU ARE NOT recommending a product or service " +
          "to purchase per FTC guidelines. And links will be do-follow to help clients out with ranking higher.", 'Ok').then(function (result) {
          return false;
        });
      case 3:
        return showAlertHTML('Sponsored Web Content', 'Sponsored Web Content will read more like featured content. ' +
          'You will need to disclose compensation for the content per FTC regulations. ' +
          'Links inside the content will be NO-FOLLOW. You will have editorial control as well.' +
          '<br>' + '<br>' + 'By authorizing your Google Analytics account below, Scalefluence can see how ' +
          'many people engaged with each blog post. We will not be retrieving any ' +
          'private data from your Analytics account. Only the number of monthly ' +
          'unique visitors coming to your blog and previous content placements done through Scalefluence.', 'Ok').then(function (result) {
          return false;
        });
        case 31: // Case 3.1
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos & \'story messaging\' ' +
            'points if you accept this assignment. Choose which ones you like and seamlessly include them in a new blog post going over ' +
            'the product or service, you will then submit a draft for review and ' +
            'publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 32: // Case 3.2
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. Many low traffic bloggers ' +
            '(less than 2000 visits per month) will put $0 because products are usually around $50 to $150 retail. ' +
            'Marketers want photos of you reviewing the product / service. You will submit a draft for r' +
            'eview and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 33: // Case 3.3
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'This assignment is an unboxing video of you using the product with video + blog content. ' +
            'Please give an appropriate discount for the free product. We understand video is more impactful, ' +
            'takes longer and is more expensive, but again, please give a discount for free product ' +
            'being shipped to you. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
      case 4:
        return showAlertHTML('Sponsored Social Content', 'Sponsored Social Content is featured content on your social handle. ' +
          'You will need to disclose compensation for the content per FTC regulations ' +
          'by using #Ad or #Sponsored hashtags. Content will also come with a Tiny URL ' +
          'to track clicks and engagement of your Social Post. ' +
          '<br>' + '<br>' + 'By supplying your Social handles below, our technology can see how many ' +
          'people engaged with the social post. We will not be retrieving any private ' +
          'data of your account. Only the number of followers and previous content ' +
          'placements done through Scalefluence.', 'Ok').then(function (result) {
          return false;
        });
      case 411: // Case 4.1.1
        return showAlertHTML('Sponsored Social Content',  'You will be given a few branded assets / photos / hashtags &' +
          ' \'story messaging\' points if you accept this assignment. ' +
          'Choose which ones you like and seamlessly include them in a new FB post for review and publication.', 'Ok').then(function (result) {
          return false;
        });
      case 412: // Case 4.1.2
        return showAlertHTML('Sponsored Social Content',  'Product will be shipped to you if you accept this assignment. ' +
          'Please give an appropriate discount for the free product. ' +
          'Many micro-influencers put $0 because the products are usually around $50 to $150 retail.' +
          ' Marketers want photos of you using the product.', 'Ok').then(function (result) {
          return false;
        });
      case 413: // Case 4.1.3
        return showAlertHTML('Sponsored Social Content',  'Product will be shipped to you if you accept this assignment. ' +
          'Please give an appropriate discount for the free product. ' +
          'Marketers understand videos are more extensive and more impactful, ' +
          'but please still give a discount compensating for the $50 to $150 retail price of most products. ' +
          'Marketers want video of you using the product.', 'Ok').then(function (result) {
          return false;
        });
      case 414: // Case 4.1.4
        return showAlertHTML('Sponsored Social Content',  'You will be given an existing influencer story about the brand, ' +
          'or maybe a blog post / press / news story about the brand if you accept this assignment. ' +
          'You will share this and link to it when possible. ' +
          'You will write your own positive thoughts on the subject and submit for review and publication. ', 'Ok').then(function (result) {
          return false;
        });
      case 421: // Case 4.2.1
        return showAlertHTML('Sponsored Social Content',  "You will be given a few branded assets / photos / hashtags & 'story messaging' " +
          "points if you accept this assignment. Choose which ones you like and seamlessly include them in a new IG" +
          " post for review and publication.", 'Ok').then(function (result) {
          return false;
        });

      case 422: // Case 4.2.2
        return showAlertHTML('Sponsored Social Content',  "Product will be shipped to you if you accept this assignment. " +
          "Please give an appropriate discount for the free product. Many micro-influencers put $0 because the products" +
          " are usually around $50 to $150 retail. Marketers want photos of you using the product.", 'Ok').then(function (result) {
          return false;
        });
      case 423: // Case 4.2.3
        return showAlertHTML('Sponsored Social Content',  "This is the same as a single post. " +
          "But a brand may feel that  they are 'in tune' with your audience that they will want to schedule" +
          " out 3 posts with you over several months. Please a give a 10 to 20% discount for this to entice" +
          " marketers to work with you 3 times over.", 'Ok').then(function (result) {
          return false;
        });
      case 424: // Case 4.2.4
        return showAlertHTML('Sponsored Social Content',  "This is the same as a single post. " +
          "But a brand may feel that they are 'in tune' with your audience that they will want to schedule out" +
          " 5 posts with you over several months. Please a give a 20 to 30% discount to entice marketers" +
          " to work with 5 times over.", 'Ok').then(function (result) {
          return false;
        });
      case 425: // Case 4.2.5
        return showAlertHTML('Sponsored Social Content',  "", 'Ok').then(function (result) {
          return false;
        });
      case 431: // Case 4.3.1
        return showAlertHTML('Sponsored Social Content',  "You will be given a few branded " +
          "assets / photos / hashtags & 'story messaging' points if you accept this assignment. " +
          "Choose which ones you like and seamlessly include them in a new video for review and publication. " +
          "This type of promotion is also called a 'pre-roll ad' or 'mid-roll ad' ." +
          " Such as:  \"This video is brought to you by our partners.\"", 'Ok').then(function (result) {
          return false;
        });
      case 432: // Case 4.3.2
        return showAlertHTML('Sponsored Social Content',  "Product will be shipped to you if you " +
          "accept this assignment (or software keys for download). Please give an appropriate discount for " +
          "the free product. Many micro-influencers put $0 because the products are usually " +
          "around $50 to $150 retail. Marketers want photos of you using the product. " +
          "This video content will be a 'featured' piece for the client.", 'Ok').then(function (result) {
          return false;
        });
      case 433: // Case 4.3.3
        return showAlertHTML('Sponsored Social Content',  "This is the same as a single post. " +
          "But a brand may feel that they are 'in tune' with your audience and will want to schedule " +
          "out 3 videos with you over several months. Please a give a 10 to 20% discount " +
          "for this product to entice marketers to work with you 3 times over. " +
          "This selection is ONLY for pre-roll & midroll ads. ", 'Ok').then(function (result) {
          return false;
        });
      case 434: // Case 4.3.4
        return showAlertHTML('Sponsored Social Content',  "This is the same as a single post. " +
          "But a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
          "videos with you over several months. Please a give a 20 to 30% discount for this product " +
          "to entice marketers to work with you 5 times over. " +
          "This selection is ONLY for pre-roll & midroll ads. ", 'Ok').then(function (result) {
          return false;
        });
      case 441: // Case 4.4.1
        return showAlertHTML('Sponsored Social Content',  "You will be given a few branded assets" +
          " / photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones you " +
          "like and seamlessly include them in a new video for review and publication", 'Ok').then(function (result) {
          return false;
        });
      case 442: // Case 4.4.2
        return showAlertHTML('Sponsored Social Content',  "Product will be shipped to you if you accept " +
          "this assignment. Please give an appropriate discount for the free product. " +
          "Many micro-influencers put $0 because the products are usually around $50 to $150 retail. " +
          "Marketers want photos of you using the product. ", 'Ok').then(function (result) {
          return false;
        });
      case 443: // Case 4.4.3
        return showAlertHTML('Sponsored Social Content',  '<div class="modal-text">' + "Product will be shipped to you if you accept " +
        "this assignment. This assignment is a video of you using the product. We know video takes more time and is more expensive, " +
        "but please give an appropriate discount for the free product. products are usually around $50 to $150 retail. " +
        '</div>', 'Ok').then(function (result) {
          return false;
        });
      }

      $mdDialog.show(confirm).then(function (result) {
        return false;
      });
    }

    function showEditSocialPriceInfo(socialHandle) {
      if (socialHandle.url && socialHandle.state !== 'active') {
        showAlert('Pending approval', 'This MEDIA is pending approval by our Admin team. ' +
          'You cannot edit it until we approve it.', 'Got it');
      }
    }

    function editDomain(ev, url) {
      var copiedUrl = {};
      var canEdit = true;
      if (url) {
        angular.copy(url, copiedUrl);

        if (url.state == PUB_URL_STATE.PENDING) {
          canEdit = false;
          showAlert('Pending approval', 'This URL is pending approval by our Admin team. ' +
            'You cannot edit it until we approve it.', 'Got it');
        } else if (url.state == PUB_URL_STATE.REJECTED) {
          canEdit = false;
          showAlertHTML('Rejected URL', 'Here are the changes we need to accept this ' +
            'domain into our marketplace. ' +
            '<br><br> <span class="bold-uppercase">' + url.rejected_reason + '</span>', 'Ok, Go to edit').then(function () {
            showEditInfoDialog(copiedUrl, url);
          });
        } else if (url.state == PUB_URL_STATE.CANCELLED) {
          canEdit = false;
          showAlert('Cancelled URL', 'After going through our Quality Assessment tests; ' +
            'this domain has been permanently rejected. We apologize for the inconvenience.', 'Got it');
        } else if (url.state == PUB_URL_STATE.UNDER_REVIEW) {
          canEdit = false;
          showAlert('Pending approval', 'This URL is pending price approval by our Admin team. ' +
            'You cannot edit it until we re approve it.', 'Got it');
        }
      }
      if (canEdit) {
        showEditInfoDialog(copiedUrl, url, null);
      }
    }

    function showEditInfoDialog(copiedUrl, url) {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfileV1/editModalInfo/editInfoDialog.html',
        controller: 'EditInfoV1DialogController',
        controllerAs: 'editInfoCtrl',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          url: copiedUrl,
          isContributor: isContributor()
        }
      }).then(function (response) {
        if (url) {
          ProfilesService.updateUrl(vm.profile.id, {
            id: response.id,
            href: response.href,
            follow_link: response.follow_link,
            price: response.price,
            description: response.description,
            pause: response.state
          }, function () {
            refreshUrls();
          }, function () {
            $log.error('error');
          })
        } else {
          ProfilesService.updateProfile(vm.profile.id, {
            urls: [{
              href: response.href,
              follow_link: response.follow_link,
              allow_blog_post: response.allow_blog_post,
              allow_home_page: response.allow_home_page,
              required_length: response.required_length,
              price: response.price,
              description: response.description
            }]
          }, function () {
            refreshUrls();
          }, function () {
            $log.error('error');
          })
        }
      });
    }

    function refreshUrls() {
      ProfilesService.indexUrls(vm.profile.id, function (response) {
        vm.urls = response.data.urls;
      }, function () {
        $log.error('error');
      });
    }

    function setDataToUrl(urlX, newUrl) {
      urlX.follow_link = newUrl.follow_link;
      urlX.href = newUrl.href;
      urlX.description = newUrl.description;
      urlX.state = newUrl.state;
      urlX.price = newUrl.price;
    }

    function setFollowValue(url) {
      return url.follow_link ? 'Do-Follow Link' : 'No-Follow Link';
    }

    function setPausedValue(url) {
      return { id: url.id, paused: url.state === PUB_URL_STATE.PAUSED };
    }

    function pausedStateChanged(url, pos) {
      url.paused = updatePausedStatus(url);

      UrlsService.updateUrl(url, function(response) {
        var message = url.paused ? 'paused' : 'unpaused';
        toastr.success('Your URL was ' + message)
      }, function(error) {
        updatePausedStatus(url);
        toastr.error(response.error);
      });
    }

    function getPausedStatus(url) {
      var filteredObj = lodash.find(vm.filteredPausedStatus, function(filteredObj) {
        return filteredObj.id === url.id;
      });

      return filteredObj ? filteredObj.paused : false;
    }

    function updatePausedStatus(url) {
      var filteredObj = lodash.find(vm.filteredPausedStatus, function(filteredObj) {
        return filteredObj.id === url.id;
      });

      if(filteredObj) {
        filteredObj.paused = !filteredObj.paused;
      }

      return filteredObj ? filteredObj.paused : false;
    }

    function nonPausableUrl(url) {
      return url.state !== PUB_URL_STATE.ACTIVE && url.state !== PUB_URL_STATE.PAUSED;
    }

    function clearCsv() {
      vm.csv = null;
    }

    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Your price per post (USD):';
    }

    function checkURL() {
      ProfilesService.getDomainInformation(vm.url.href, function (response) {
        vm.domInfo = response.data;
        if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
          vm.domInfo.domain_authority < MIN_VALUES.DA) {
          vm.showMinValues = true;
          vm.suggestedPrice = '';
          vm.pricePlaceholder = 'Payout';
        } else {
          vm.showMinValues = false;
          vm.da = vm.domInfo.domain_authority;
          vm.tf = vm.domInfo.trust_flow;
          $scope.da = vm.da;
          $scope.tf = vm.tf;

          // Use suggested_price from the same response instead of firing a
          // second call to /urls/suggested_price (which burns more API credits
          // on cache misses).
          vm.pricePlaceholder = vm.domInfo.suggested_price
            ? 'Suggested Price: ' + vm.domInfo.suggested_price
            : 'Suggested Price: ';
        }
      });
    }

    function showCsvDialog() {
      $mdDialog.show({
        controller: 'CsvModalController',
        controllerAs: 'csvModalCtrl',
        templateUrl: 'app/pages/profiles/editProfile/csvModal/csvModal.html',
        clickOutsideToClose: true,
        locals: {
          isContributor: isContributor()
        }
      }).then(function (uploadedFile) {
        vm.csv = uploadedFile;
      });
    }

    function removeFilter() {
      vm.search = false;
      vm.query.filter = '';
    }

    $scope.$watch('editProfCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      }

      if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      }

      if (newValue == '') {
        vm.query.page = 1;
      }
    });

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .textContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function canEditDomainInfo() {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED, PUB_URL_STATE.PAUSED], vm.url.state) && vm.url.canEdit;
    }

    function canEditSponsoredWeb() {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED], vm.profile.web_content) && vm.profile.web_content.canEdit;
    }

    function canEditSocialHandle(sh) {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED], sh.state) && sh.canEdit;
    }

    function canEditSocialPrice(priceItem) {
      return (!lodash.includes(
        [
          PUB_URL_STATE.PENDING,
          PUB_URL_STATE.RESUBMITTED,
          PUB_URL_STATE.UNDER_REVIEW,
          PUB_URL_STATE.CANCELLED
        ], priceItem.state)
        && priceItem.state) || !priceItem.state;
    }

    function displayPendingStateText() {
      switch (vm.url.state) {
        case PUB_URL_STATE.PAUSED:
          return 'You must unpause this URL first, before changing anything.'
        default:
          return 'Admin must approve your submission before you can edit';
      }
    }

    function showXlsIcon() {
      return 'assets/images/xlsUpload.svg';
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    function showWarningPopup() {
      showAlert('Suggested Pricing', 'In order to be able to display the suggested price you must sign in to the social network.', 'Got it!');
    }

    function handleFacebookAuthentication(socialHandle, socialNetwork) {
      FacebookService.authenticate(socialNetwork, function (userId) {
        switch (socialNetwork) {
          case 'facebook':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var username = account.username || account.id;
                if (checkExistedSocialAccount(socialNetwork, username)) {
                  showUseAnotherAccountModal(socialHandle, socialNetwork)
                } else {
                  FacebookService.revokePermissions();
                  loadSocialHandle(socialHandle, socialNetwork, username, account.fan_count);
                }
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
          case 'instagram':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var fanPageId = account.id;
                FacebookService.checkForInstagramBusinessAccount(fanPageId, function (response) {
                  if (checkExistedSocialAccount(socialNetwork, response.username)) {
                    showUseAnotherAccountModal(socialHandle, socialNetwork)
                  } else {
                    FacebookService.revokePermissions();
                    loadSocialHandle(socialHandle, socialNetwork, response.username, response.followers_count);
                  }
                }, function (error) {
                  toastr.error(error);
                });
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
        }
      }, function (error) {
        toastr.error(error);
      });
    }

    function showUseAnotherAccountModal(socialHandle, socialNetwork) {
      var confirm = $mdDialog.confirm()
        .title('Account is already linked')
        .htmlContent('<p>You have already connected this handle in another profile.</p>' +
          'Please email ' + '<strong>admin@scalefluence.com</strong>' + ' for help.</p>')
        .ok('Connect other')
        .cancel('Ok got it');
      $mdDialog.show(confirm).then(function () {
        socialHandle.url = null;
        switch (socialNetwork) {
          case 'facebook':
            handleFacebookConnection(socialHandle, socialNetwork, true);
            break;
          case 'instagram':
            handleInstagramConnection(socialHandle, socialNetwork, true)
        }
      }, function () {
        disconnectSocial(socialHandle, socialNetwork)
      });
    }

    function showChooseAccountModal(accounts, successCallback, errorCallback) {
      $mdDialog.show({
        controller: 'SocialHandleController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfileV1/partials/socialHandleDialog.html',
        clickOutsideToClose: false,
        locals: {
          accounts: accounts,
        }
      }).then(function (response) {
          successCallback(response)
        },
        errorCallback);
    }

    function checkExistedSocialAccount(socialNetwork, username) {
      var url = 'https://www.' + socialNetwork + '.com/' + username;
      if (_.includes(vm.profileSocialUrls, url)) {
        return true
      }
    }

    function showConfirmDisconnectSocialModal(socialNetwork, socialHandle) {
      var confirmText = 'Are you sure?  Disconnecting ' + capitalizeFirstLetter(socialNetwork) + ' will remove you from getting any assignments. ' +
        'You will not be able monetize this channel.';
      var confirm = $mdDialog.confirm()
        .title('DISCONNECT WARNING')
        .textContent(confirmText)
        .cancel('Cancel')
        .ok('Disconnect');

      $mdDialog.show(confirm).then(function (result) {
        disconnectSocial(socialHandle, socialNetwork);
      }, function () {
      });
    }

    function disconnectSocial(socialHandle, socialNetwork) {
      var profile = vm.profile;
      var updateData = false;
      var handleKey = getHandleKey(socialNetwork);

      if (profile[handleKey].id) {
        updateData = {};
        updateData[handleKey] =  {
          id: profile[handleKey].id,
          _destroy: 1
        }
      }
      if (updateData === false) {
        clearSocial(socialHandle, socialNetwork);
      } else {
        ProfilesService.updateProfile(profile.id, updateData, function (response) {
          vm.profile = response.data;
          setSocialHandles();
          toastr.success('Disconnected from social network successfuly.');
        }, function (response) {
          if (response.data.errors) {
            var errors = lodash.map(Object.keys(response.data.errors), function (err) {
              return response.data.errors[err]
            });
            lodash.each(errors, function (error) {
              toastr.error(error[0]);
            })
          }
        });
      }
    }

    function getHandleKey(network) {
      return network.toLowerCase() + '_handle';
    }

    function clearSocial(handle, type) {
      lodash.forEach(Object.keys(handle), function (key) {
        if (key !== 'social_prices') delete handle[key];
        lodash.forEach(handle.social_prices, function (item) {
          delete item.price
        });
      });
    }

    function clearWebContent() {
      clearWebContentPrices();
      vm.profile.web_content = null;
      setInitialWebContent();
    }

    function clearWebContentPrices() {
      lodash.forEach(vm.profile.web_content.social_prices, function (item) {
        delete item.price
      });
    }

    function loadSocialHandle(socialHandle, socialNetwork, username, count) {
      socialHandle.url = 'https://www.' + socialNetwork + '.com/' + username;
      socialHandle.followers = count;
      socialHandle.name = socialNetwork;
      checkSocialMinValues(socialNetwork, socialHandle);
    }

    function authorize(event, isYoutube, socialHandle) {
      if (!isYoutube) vm.showProgressCircular = true;
      GoogleService.authorize(event, function (response) {
        if (response.error) {
          vm.hidden = false;
        } else {
          vm.hidden = true;
          if (isYoutube) {
            getYouTubeFollowers(socialHandle);
          } else {
            queryAccounts();
          }
        }
      });
    }

    function getYouTubeFollowers(socialHandle) {
      GoogleService.queryYouTubeStatistics(function (response) {
        if (response.result.items.length) {
          socialHandle.url = 'www.youtube.com/channel/' + response.result.items[0].id;
          socialHandle.followers = response.result.items[0].statistics.subscriberCount;
          if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
          checkSocialMinValues('youtube', socialHandle);
        } else {
          toastr.error('', 'No channel associated to your account.');
        }
      });
    }

    function queryAccounts() {
      vm.analytics = [];
      GoogleService.queryAccounts(handleAccounts, function (error) {
        toastr.error('No Google Analytics account found');
        vm.showProgressCircular = false;
      });
    }

    function authenticateTwitter() {
      $window.location.href = EnvironmentConfig.API_END_POINT.replace('/api/v1','/auth/twitter?action=edit&profile_id=' + vm.profile.id);
    }

    function analyticSelected() {
      vm.showProgressCircular = true;
      var domain = vm.url.href.replace(/(^\w+:|^)\/\//, '');
      if (!vm.selectedAnalytics.websiteUrl.includes(domain)) {
        toastr.error('The selected analytics property does not match the website you are attempting to validate.');
        vm.showProgressCircular = false;
        return false;
      }
      GoogleService.queryProfiles(vm.selectedAnalytics, handleProfiles, function (err) {
        $log.error(err);
      });
    }

    function handleAccounts(response) {
      var accounts = response.result.items;
      if (accounts && accounts.length) {
        vm.analyticsAuthorized = true;
        lodash.map(accounts, function (account) {
          GoogleService.queryProperties(account, handleProperties, function (err) {
            $log.error(err);
          });
        })
      } else {
        $log.log('There are no accounts to show');
      }
    }

    function handleProperties(response) {
      vm.showProgressCircular = false;
      var properties = response.result.items;
      if (properties && properties.length) {
        lodash.map(properties, function (property) {
          vm.analytics.push(property);
        })
      } else {
        $log.log('There are no properties to show');
      }
    }

    function handleProfiles(response) {
      var profiles = response.result.items;
      if (profiles && profiles.length) {
        var firstProfileId = profiles[0].id;
        vm.profile.web_content.ga_profile_id = firstProfileId;
        GoogleService.queryCoreReportingApi(firstProfileId, handleReports, function (err) {
          vm.showProgressCircular = false;
          $log.error(err);
          toastr.error(err.result.error.message);
          disconnectGA(false)
        });
      } else {
        $log.log('There are no profiles to show');
      }
    }

    function handleReports(response) {
      vm.web_content.muv = parseInt(response.result.totalsForAllResults['ga:users']);
      vm.profile.web_content.muv = vm.web_content.muv;
      vm.profile.web_content.ga_account_id = vm.selectedAnalytics.accountId;
      vm.profile.web_content.ga_profile_id = vm.selectedAnalytics.id;
      vm.profile.web_content.website_url = vm.selectedAnalytics.websiteUrl;
      vm.profile.web_content.href = vm.selectedAnalytics.selfLink;

      if (vm.web_content.muv < MIN_VALUES.GA) {
        showAlert('Minimum monthly unique visitors',
          'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. Google Analytics reported ' + vm.web_content.muv +
          '. Please use a higher performing website or try again once you reach an average of ' +
          'at least ' + MIN_VALUES.GA + ' visitors a month for 3 subsequent months.',
          'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
          vm.showProgressCircular = false;
        });
        // vm.hidden = false;
      } else {

        $scope.followers = vm.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'According to Google, your site had (' + vm.web_content.muv + ') visits last month. Below is our suggested payout for a blog post. You can put any price you want. This is only a suggestion based on your traffic.';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'Monthly Visitors';

        vm.showProgressCircular = false;
      }
    }

    function disconnectGA(showMsg) {
      var profile = vm.profile;
      var updateData = false;

      if (profile.web_content.id) {
        updateData = {
          web_content: {
            id: vm.profile.web_content.id,
            _destroy: true,
            href: vm.profile.web_content.href
          }
        }
      }

      if (updateData === false) {
        clearWebContent();
      } else {
        ProfilesService.updateProfile(vm.profile.id, updateData , function () {
          clearWebContent();
          if (showMsg !== false) toastr.success('Analytics account disconnected.');
        }, function () {
          toastr.error('There was an error disconnecting your Analytics account.');
        })
      }
    }

    function updateDomain(form) {
      form.url.$setValidity('active', true);
      form.url.$setValidity('unmatched', true);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.editV1')
    .controller('NotesController', NotesController);

  /* @ngInject */
  function NotesController($scope, $mdDialog, lodash, product) {
    var vm = this;

    //Accesible variables
    vm.note = '';
    vm.product = {};

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.product = product;
      vm.note = product.rejected_reason;
    }

    function ok() {
      $mdDialog.hide({
        canEdit: true
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.editV1')
    .controller('EditInfoV1DialogController', EditInfoV1DialogController);

  /** @ngInject */
  function EditInfoV1DialogController($mdDialog, $rootScope, ProfilesService, MIN_VALUES,
    PUB_URL_STATE, PricesService, url, isContributor, toastr) {

    var vm = this;
    vm.url = {};
    vm.showMinValues = false;
    vm.showUrlDisabled = false;
    vm.urlStatsRequestFailed = false;
    vm.title = '';
    vm.showPause = true;
    vm.pausedValue = false;
    vm.isContributor = false;
    vm.suggestedPrice = '';
    vm.pricePlaceholder = 'Payout';
    vm.showRejectedReasons = false;
    vm.disable = false;
    vm.domInfo;
    vm.maxDomPrice = 999999999;

    //functions
    vm.checkURL = checkURL;
    vm.submit = submit;
    vm.cancel = cancel;
    vm.getDescriptionTitle = getDescriptionTitle;
    vm.rejectedReasons = rejectedReasons;
    vm.followLinkOptionIsSet = followLinkOptionIsSet;
    vm.setUrlRequiredLength = setUrlRequiredLength;
    vm.setUrlAllowHomepage = setUrlAllowHomepage;
    vm.setUrlFollowLink = setUrlFollowLink;
    vm.setUrlAllowBlogPost = setUrlAllowBlogPost;
    vm.isNewDomain = isNewDomain;
    vm.getMaxDomPrice = getMaxDomPrice;
    vm.getUrlDisabledError = getUrlDisabledError;
    vm.getMetaDescription = getMetaDescription;

    init();

    function init() {
      vm.isContributor = isContributor;
      if (url.href) {
        vm.isNew = false;
        vm.url = url;
        vm.pausedValue = PUB_URL_STATE.PAUSED == vm.url.state;
        vm.title = PUB_URL_STATE.ACTIVE == vm.url.state ? 'Edit Information' : 'Re-Submit Edited URL Back to Us';
        vm.showRejectedReasons = PUB_URL_STATE.REJECTED == vm.url.state;
        vm.disable = PUB_URL_STATE.PAUSED == vm.url.state;
        vm.showPause = PUB_URL_STATE.REJECTED != vm.url.state;
      } else {
        vm.isNew = true;
        vm.url.follow_link = true;
        vm.title = 'Add New Domain';
        vm.showPause = false;
      }
    }

    function isNewDomain() {
      return vm.isNew;
    }

    function submit() {
      url.state = vm.pausedValue;
      $mdDialog.hide(vm.url);
    }

    function checkURL(form) {
      vm.showUrlDisabled = false;
      vm.showMinValues = false;
      vm.urlStatsRequestFailed = false;
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      form.domainUrl.$setValidity('url', true);
      if (regex.test(vm.url.href)) {
        ProfilesService.getDomainInformation(vm.url.href, function (response) {
          form.domainUrl.$setValidity('unmatched', true);
          form.urlPrice.$setValidity('unmatched', true);
          form.domainUrl.$setValidity('duplicate', true);
          form.domainUrl.$setValidity('you-own', true);
          vm.domInfo = response.data;
          if(vm.domInfo.already_publisher_url) {
            form.domainUrl.$setValidity('you-own', false);
            return;
          }
          if (vm.domInfo.is_active) {
            vm.maxDomPrice = vm.domInfo.price_to_beat;
          }
          if (vm.domInfo.href_exists && !vm.domInfo.is_active) {
            form.domainUrl.$setValidity('duplicate', false);
          } else if (vm.domInfo.href_exists && vm.domInfo.is_active && vm.url.price && vm.url.price >= vm.domInfo.price_to_beat) {
            form.domainUrl.$setValidity('unmatched', false);
            form.urlPrice.$setValidity('unmatched', false);
          } else if (vm.domInfo.domain_authority === null) {
            vm.urlStatsRequestFailed = true;
          } else if (vm.domInfo.domain_authority < MIN_VALUES.DA) {
            vm.showUrlDisabled = false;
            vm.showMinValues = true;
            vm.suggestedPrice = '';
            vm.pricePlaceholder = 'Payout';
          } else {
            vm.showUrlDisabled = false
            vm.showMinValues = false;
            vm.da = vm.domInfo.domain_authority;
            vm.tf = vm.domInfo.trust_flow;

            // suggested_price is included in the domain_information response;
            // skip the redundant /urls/suggested_price round trip.
            vm.pricePlaceholder = vm.domInfo.suggested_price
              ? 'Suggested Price: ' + vm.domInfo.suggested_price
              : 'Suggested Price: ';
          }
        });
      } else {
        form.domainUrl.$setValidity('url', false);
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function getDescriptionTitle(tooltip) {
      if (vm.url.description && !tooltip) {
        return 'Description';
      } else if (isContributor()) {
        return 'Description: Please tell us what you love to write about.' +
          ' This will enable us to pinpoint the most relevant opportunities for you. ' +
          'Also please indicate if you do Product Roundups, CEO quotes, and if you ' +
          'can link to the home page with a branded link.'
      }
    }

    function rejectedReasons() {
      return vm.url.rejected_reason;
    }

    function followLinkOptionIsSet(url) {
      return (url.follow_link === "true" || url.follow_link === "false")
    }

    function setUrlRequiredLength(requiredLength) {
      switch(requiredLength) {
        case '1500-+':
        case '1250-1500':
        case '1000-1250':
          vm.url.required_length = requiredLength;
          break;

        default:
          vm.url.required_length = '750-1000'
      }
    }

    function setUrlAllowHomepage(allow) {
      vm.url.allow_home_page = allow ? 'true' : 'false';
      if(allow) vm.url.allow_blog_post = 'false';
      else vm.url.allow_blog_post = 'true';
    }

    function setUrlFollowLink(isDoFollow) {
      vm.url.follow_link = isDoFollow ? 'true' : 'false';
    }

    function setUrlAllowBlogPost(allow) {
      vm.url.allow_blog_post = allow ? 'true' : 'false';
    }

    function getMaxDomPrice() {
      return vm.maxDomPrice - 1;
    }

    function getUrlDisabledError() {
      if (vm.domInfo.is_active && vm.url.price && vm.url.price >= vm.domInfo.price_to_beat) {
        return 'This URL is already in Scalefluence and can only be added at a price lower than $' + vm.domInfo.price_to_beat;
      }
      return 'Sorry, this URL is already in Scalefluence and cannot be re-added';
    }

    function getMetaDescription() {
      ProfilesService.getMetaDescription(vm.url.href, function (response) {
        vm.url.description = response.data.description;
      }, function (response) {
        toastr.error(response.data.error);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.editV1')
    .controller('CsvModalController', CsvModalController);

  /** @ngInject */
  function CsvModalController($state, $log, $mdDialog, $rootScope, Assets, isContributor) {
    var vm = this;
    vm.isContributor = isContributor;

    //Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.download = download;
    vm.getPrice = getPrice;
    vm.getFileRoute = getFileRoute;

    function submit() {
      $mdDialog.hide(vm.csv);
    }

    function clearCsv() {
      vm.csv = null;
    }

    function download() {
      $rootScope.sampleDownloaded = true;
    }

    function getPrice() {
      return vm.isContributor ? '200' : '130';
    }

    function getFileRoute() {
      return  vm.isContributor ? Assets + 'contributor_example.xlsx' : Assets + 'broker_example.xlsx';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit', [])
    .controller('EditProfileController', EditProfileController);

  /** @ngInject */
  function EditProfileController($state, $stateParams, $rootElement, $anchorScroll, $scope, $rootScope, $log, $location, $window, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, ProfilesService, RoutesService, PROFILE_TYPE,
                                 PAGINATION_SIZE, HTTP_STATUS, ERRORS_RESPONSES, Upload,
                                 SOCIAL_PRICES, WEB_CONTENT_PRICES, EnvironmentConfig, UserTourService, $timeout
  ) {
    var vm = this;

    var params = $location.search();

    // Accessible attributes
    vm.url = {};
    vm.disableMetaButton = false;
    vm.profile = {};
    vm.webContentHandle = {
      web_content_prices: WEB_CONTENT_PRICES.FIELDS
    };

    vm.categories = [];
    vm.copyProfile = {};
    vm.query = {
      filter: '',
      order: 'state',
      limit: 20,
      page: 1
    };
    vm.showUrlPriceIcon = false;
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;
    vm.urls = [];
    vm.csv;
    vm.search = false;
    vm.filtered = [];
    vm.filteredPausedStatus = [];
    vm.suggestedPrice = '';
    vm.pricePlaceholder = 'Payout';
    $rootScope.sampleDownloaded = false;
    vm.web_content = {};
    vm.analytics = [];
    vm.initialAnalytics = {};
    vm.selectedAnalytics = {};
    vm.analyticsAuthorized = false;
    vm.gaSaved = false;
    vm.showProgressCircular = false;
    vm.showRepeatedNameError = false;
    vm.isAudienceCompleted = false;

    // SEO price grid
    $scope.da;
    $scope.tf;
    $scope.close = function () {
      $mdDialog.cancel();
    }

    // Accessible functions
    vm.editProfileNameAndPhoto = editProfileNameAndPhoto;
    vm.isInfluencer = isInfluencer;
    vm.isBlogger = isBlogger;
    vm.isContributor = isContributor;
    vm.clearCsv = clearCsv;
    vm.showCsvDialog = showCsvDialog;
    vm.removeFilter = removeFilter;
    vm.showUploadedFileDialog = showUploadedFileDialog;
    vm.sendFileToAdmin = sendFileToAdmin;
    vm.showXlsIcon = showXlsIcon;
    vm.showSearchIcon = showSearchIcon;
    vm.showWarningPopup = showWarningPopup;
    vm.goToDashboard = goToDashboard;
    vm.goEditProfileSection = goEditProfileSection;
    vm.isProfilePartCompleted = isProfilePartCompleted;
    vm.saveProfileMainData = saveProfileMainData;
    vm.checkNewProfileName = checkNewProfileName;
    vm.cancel = cancel;

    init();

    function init() {
      if (angular.isDefined($stateParams.profile) || angular.isDefined($stateParams.profileId)) {
        if ($stateParams.profile) {
          vm.profile = $stateParams.profile;
          setProfileData()
          handlePubTour();
        } else {
          if ($stateParams.profileId) {
            ProfilesService.showProfile($stateParams.profileId, function (response) {
              vm.profile = response.data;
              setProfileData()
              handlePubTour();
            }, function () {
              $log.log('Error retrieving the profile.');
              toastr.error('There was an error retrieving the profile.');
            });
          } else {
            goToDashboard()
          }

        }
      }

      $scope.$mdMedia = $mdMedia;
    }

    function handlePubTour() {
      if (UserTourService.currentName() == 'pub_welcome_phase_4' || UserTourService.currentName() == 'pub_welcome_phase_5') {
        $timeout(function() { UserTourService.startPubWelcomeTourPhase5(); }, 1000);
      }
    }

    function twitterValidationRedirect() {
      var pDate = Date.parse(vm.profile.pub_created_at);
      var v2Date = Date.parse(EnvironmentConfig.V2_PROFILE_SWITCH_DATE);
      if (pDate < v2Date) {
        var loc = '/#/profiles/edit-v1/' + $stateParams.profileId + '?twitter_followers_count=' + params.twitter_followers_count + '&twitter_nickname=' + params.twitter_nickname;
        $window.location.href = loc;
      } else {
        var loc = '/#/profiles/edit/' + $stateParams.profileId + '/twitter?twitter_followers_count=' + params.twitter_followers_count + '&twitter_nickname=' + params.twitter_nickname;
        $window.location.href = loc;
      }
    }

    function checkForTwitterRedirect() {
      if (angular.isDefined($stateParams.profileId) &&
          angular.isDefined(params.twitter_followers_count) &&
          angular.isDefined(params.twitter_nickname))
      {
        twitterValidationRedirect();
      }
    }

    function setProfileData() {
      checkForTwitterRedirect();

      setCategories();
      setSocialHandles();
      setInitialWebContent();

      vm.url = vm.profile.url;
      vm.urls = vm.profile.urls;

      ProfilesService.getProfileNames(function (response) {
        vm.profileNames = response.data.profile_names;
      });
      angular.copy(vm.profile, vm.copyProfile);
    }

    function setCategories() {
      vm.categories = vm.profile.categories;
      vm.categories.forEach(function (category) {
        category.displayName = category.name;
      });
    }

    function setInitialWebContent() {
      if (!vm.profile.web_content) {
        vm.profile.web_content = {
          muv: ''
        };
        vm.initialAnalytics.selected = "none";
        vm.selectedAnalytics = vm.initialAnalytics;
        vm.analytics = [];
        vm.analyticsAuthorized = false;
      } else if (vm.profile.web_content.href) {
        vm.hidden = true;
        vm.gaSaved = true;
        vm.initialAnalytics.selected = vm.profile.web_content.website_url;
        vm.selectedAnalytics = vm.initialAnalytics;
        vm.analyticsAuthorized = true;
      }
      setWebContentPrices()
    }

    function setWebContentPrices() {
      var merged = _.merge(
        _.keyBy(vm.profile.web_content.web_content_prices, 'price_type'),
        _.keyBy(vm.webContentHandle.web_content_prices, 'price_type')
      );
      vm.profile.web_content.web_content_prices = _.values(merged);
    }

    function setSocialHandles() {
      lodash.map(vm.socialHandles, function (handle) {
        var handleKey = getHandleKey(handle.name);
        var merged = _.merge(
          _.keyBy(vm.profile[handleKey].social_prices, 'price_type'),
          _.keyBy(vm.socialHandles[handleKey].social_prices, 'price_type')
        );
        vm.profile[handleKey].social_prices = _.values(merged);
      });
    }

    function checkNewProfileName() {
      var res =  lodash.findIndex(vm.profileNames, function (name) {
        return name === vm.profile.newName;
      }) ;

      vm.showRepeatedNameError = res !== -1
    }

    function editProfileNameAndPhoto() {
      $mdDialog.show({
        controller: 'EditProfileController',
        controllerAs: 'editProfCtrl',
        templateUrl: 'app/pages/profiles/editProfile/editProfileDialog.html',
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: true,
      }).then(function (res) {
        vm.profile.name = res.name;
        vm.profile.image = res.image
      })
    }

    function saveProfileMainData() {
      vm.newProfileData = {
        name: vm.profile.newName,
        image: vm.profile.image
      };
      ProfilesService.updateProfile(vm.profile.id, vm.newProfileData, function (response) {
        toastr.success('Profile data successfully updated.');
        $mdDialog.hide({name: response.data.name, image: response.data.image});
      }, function () {
        toastr.error('There was an error updating data, please retry.');
      });
    }

    function getHandleKey(network) {
      return network.toLowerCase() + '_handle';
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function goEditProfileSection(editSection, forceAdd) {
      if (editSection === 'edit-profile-audience' && UserTourService.currentName() == 'pub_welcome_phase_5') {
        UserTourService.stopTour();
      }
      if (!isProfilePartCompleted('audience') && editSection !== 'edit-profile-audience') {
        toastr.error('Please complete audience first.');
      } else {
        RoutesService.editProfileSection(editSection, vm.profile.id, vm.profile, forceAdd);
      }
    }

    function isInfluencer() {
      return vm.profile.profile_type === PROFILE_TYPE.INFLUENCER;
    }

    function isBlogger() {
      return vm.profile.profile_type === PROFILE_TYPE.BLOGGER;
    }

    function isContributor() {
      return vm.profile.profile_type === PROFILE_TYPE.CONTRIBUTOR;
    }

    function sendFileToAdmin() {
      ProfilesService.updateSpreadsheetProfile(vm.profile.id, vm.profile.profile_type, vm.csv, function (response) {
        refreshUrls();
        if (response.data && response.data.errors[0] == ERRORS_RESPONSES.ALREADY_TAKEN) {
          showSomeUrlsDuplicatedDialog();
        } else if (response.data && response.data.errors[0] == ERRORS_RESPONSES.INVALID) {
          showBadUrlDialog();
        } else {
          showUploadedFileDialog();
        }
        clearCsv();
      }, function (response) {
        if (response.status == HTTP_STATUS.BAD_REQUEST) {
          if (response.data.error == ERRORS_RESPONSES.ALREADY_TAKEN) {
            showDuplicateDialog();
          } else if (response.data.error == ERRORS_RESPONSES.INVALID) {
            showBadUrlDialog();
          } else {
            toastr.error(response.data.error);
          }
          clearCsv();
        }
      });
    }

    function refreshUrls() {
      ProfilesService.indexUrls(vm.profile.id, function (response) {
        vm.urls = response.data.urls;
      }, function () {
        $log.error('error');
      });
    }

    function showSomeUrlsDuplicatedDialog() {
      showAlertHTML('Some Duplicated Urls', 'Some Urls are already in out DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showUploadedFileDialog() {
      return showAlertHTML('Spreadsheet uploaded', 'Thank you for uploading these domains. ' +
        'Our admin department will review them one at a time and you will receive notifications ' +
        'when they are either approved or rejected.', 'Got it!').then(function (result) {
        return false;
      });
    }

    function showDuplicateDialog() {
      return showAlertHTML('Duplicate Url', 'This URL is already in our DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showBadUrlDialog() {
      return showAlertHTML('Bad Url format', 'Please take a look at your file, some urls are not correct.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function clearCsv() {
      vm.csv = null;
    }

    function showCsvDialog() {
      $mdDialog.show({
        controller: 'CsvModalController',
        controllerAs: 'csvModalCtrl',
        templateUrl: 'app/pages/profiles/editProfile/csvModal/csvModal.html',
        clickOutsideToClose: true,
        locals: {
          isContributor: isContributor()
        }
      }).then(function (uploadedFile) {
        vm.csv = uploadedFile;
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function removeFilter() {
      vm.search = false;
      vm.query.filter = '';
    }

    $scope.$watch('editProfCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      }

      if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      }

      if (newValue == '') {
        vm.query.page = 1;
      }
    });

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showXlsIcon() {
      return 'assets/images/xlsUpload.svg';
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    function showWarningPopup() {
      showAlert('Suggested Pricing', 'In order to be able to display the suggested price you must sign in to the social network.', 'Got it!');
    }

    function isAudienceInfoCompletedPartially() {
      if (vm.profile != undefined && !!vm.profile.categories
          && angular.isArray(vm.profile.categories) && vm.profile.categories.length > 0) {
        return true;
      } else {
        return false
      }
    }

    function isAnalyticsCompleted() {
      if (!!vm.profile.web_content) {
        return lodash.findIndex(vm.profile.web_content.web_content_prices, function (content_price) {
          if (vm.profile.web_content.href && content_price.price) {
            return true;
          }
        }) !== -1;
      } else {
        return false
      }
    }

    function isSocialCompleted(network) {
      switch (network) {
        case 'facebook':
          return !!vm.profile.facebook_handle ? checkConnection(vm.profile.facebook_handle) : false;
        case 'instagram':
          return !!vm.profile.instagram_handle ? checkConnection(vm.profile.instagram_handle) : false;
        case 'twitter':
          return !!vm.profile.twitter_handle ? checkConnection(vm.profile.twitter_handle) : false;
        case 'youtube':
          return !!vm.profile.youtube_handle ? checkConnection(vm.profile.youtube_handle) : false;
      }
    }

    function checkConnection(socialHandle) {
      if (socialHandle.url && lodash.findIndex(socialHandle.social_prices, function (item) {
        if (item.price) return true
      }) >= 0) {
        return true;
      }
    }

    function isProfilePartCompleted(type) {
      switch (type) {
        case 'audience':
          return isAudienceInfoCompletedPartially();
        case 'blog':
          return isAnalyticsCompleted();
        case 'guest-post':
          return vm.url && vm.url.id && vm.url.href && vm.url.price;
        default:
          return isSocialCompleted(type);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit')
    .controller('NotesController', NotesController);

  /* @ngInject */
  function NotesController($scope, $mdDialog, lodash, product) {
    var vm = this;

    //Accesible variables
    vm.note = '';
    vm.product = {};

    //Accesible functions
    vm.ok = ok;

    initialize();

    function initialize() {
      vm.product = product;
      vm.note = product.rejected_reason;
    }

    function ok() {
      $mdDialog.hide({
        canEdit: true
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit.web_content', [])
    .controller('EditWebContentController', EditWebContentController);

  /** @ngInject */
  function EditWebContentController($state, $stateParams, $anchorScroll, $rootElement, $scope, $location, $window, $log, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, WEB_CONTENT_PRICES, ProfilesService, RoutesService, FacebookService,
                                    PricingService, GoogleService, PROFILE_TYPE, MIN_VALUES, EnvironmentConfig, PUB_URL_STATE
  ) {
    var vm = this;


    // Accessible attributes
    vm.profile = {};
    vm.webContentHandle = {
      web_content_prices: WEB_CONTENT_PRICES.FIELDS
    };
    vm.web_content = {};
    vm.dropDownWebContentConnection = ["UA", "GA4"];
    vm.analytics = [];
    vm.initialAnalytics = {};
    vm.selectedAnalytics = {};
    vm.analyticsAuthorized = false;
    vm.gaSaved = false;
    vm.showProgressCircular = false;
    vm.connectWithGa4 = false;
    vm.allProfiles = [];
    vm.selectedProfile = {};
    vm.goToDashboard = goToDashboard;
    vm.goEditProfileSection = goEditProfileSection;
    vm.goEditProfile = goEditProfile;
    vm.saveWebContent = saveWebContent;
    vm.checkGAMinValues = checkGAMinValues;
    vm.getPropertyLabelGA = getPropertyLabelGA;
    vm.getPricingLabelGA = getPricingLabelGA;
    vm.analyticSelected = analyticSelected;
    vm.analyticSelectedGa4 = analyticSelectedGa4;
    vm.handleWebContentConnection = handleWebContentConnection;
    vm.handleWebContentConnectionGa4 = handleWebContentConnectionGa4;
    vm.authorize = authorize;
    vm.canEditSponsoredWeb = canEditSponsoredWeb;
    vm.getPriceClass = getPriceClass;
    vm.showInfo = showInfo;
    vm.showPriceGa = showPriceGa;
    vm.getEditSocialPriceInfo = getEditSocialPriceInfo;
    vm.showGaDetails = showGaDetails;
    vm.canEditSocialPrice = canEditSocialPrice;
    vm.triggerChange = triggerChange;
    vm.profileSelected = profileSelected;
    vm.profileSelectedGa4 = profileSelectedGa4;
    vm.contributorOnlyPopup = contributorOnlyPopup;
    vm.analyticstAccountTypeDisplay = analyticstAccountTypeDisplay;

    init();

    function init() {
      if (angular.isDefined($stateParams.profile) || angular.isDefined($stateParams.profileId)) {
        if ($stateParams.profile) {
          vm.profile = $stateParams.profile;
          setInitialWebContent();
        } else {
          if ($stateParams.profileId) {
            ProfilesService.showProfile($stateParams.profileId, function (response) {
              vm.profile = response.data;
              vm.google_analytic_version  = response.data.web_content.google_analytic_version;
              if(vm.profile.web_content) {
                if(!vm.profile.web_content.completed) {
                  vm.google_analytic_version === "GA4"
                  ? (vm.connectWithGa4 = true, vm.selectedOption = "GA4",
                    handlePropertiesGa4(vm.profile.web_content.id, vm.profile.id))
                  : (vm.selectedOption = "UA", handleProperties(vm.profile.web_content.id, vm.profile.id));  
                }
              }
              setInitialWebContent();
            }, function () {
              $log.log('Error retrieving the profile.');
              toastr.error('There was an error retrieving the profile.');
            });
          } else {
            goToDashboard()
          }
        }
      }

      $scope.$mdMedia = $mdMedia;
    }

    function getEditSocialPriceInfo(state) {
      switch (state) {
        case PUB_URL_STATE.ACTIVE:
          return 'Price approved';
        case PUB_URL_STATE.PENDING:
          return 'Pending review';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'Pending review';
        case PUB_URL_STATE.REJECTED:
          return 'Price declined';
        case PUB_URL_STATE.CANCELLED:
          return 'Price rejected'
      }
    }

    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Your price per post (USD):';
    }

    function checkSocialMinValues(type, socialMedia, display) {
      if (!socialMedia.url) {
        socialMedia.followers = '';
        getPricingLabel(socialMedia, type);
      } else {
        var socialMediaFlag = type === SOCIAL.Facebook || type === SOCIAL.Twitter;
        // Adding this code due to the additional check thru backend below not working
        if (socialMedia.followers < 0) {
          showAlert('Minimum followers', 'We apologize but we need a minimum of 1000 followers for ' +
            'EACH social handle for you to participate in this product. You ' +
            'currently do not meet that criteria for this handle. When you do ' +
            'reach that engagement, you can come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
            socialMedia.url = '';
            socialMedia.price = '';
          });
        } else {
          var price = PricingService.getPrice(socialMedia.followers, type);
          var videoPrice = PricingService.getVideoPrice(socialMedia.followers, type);
          if (type === 'facebook') {
            var sharingPrice = PricingService.getSharingPrice(socialMedia.followers, type);
          }
          socialMedia.suggested_post_price = price;
          socialMedia.suggested_video_price = videoPrice;
          socialMedia.suggested_sharing_price = sharingPrice;

          $scope.followers = socialMedia.followers;
          $scope.network = type;
          $scope.rowHeader = socialMediaFlag ? 'Suggested Pricing for Facebook, Twitter & Pinterest' : 'Suggested Pricing for Instagram & YouTube';
          $scope.content = 'According to (Social Media channel), you have (' + socialMedia.followers + ') followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.';
          $scope.contentLineTwo = 'For your protection, this content will be disclosed per FTC guidelines.';
          $scope.header = 'You have ' + socialMedia.followers + ' Followers';
          if (display) {
            displayRowGridPrice();
          }
        }
      }
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/partials/rowDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'EditProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function authorize() {
      ProfilesService.getRedirectUrl(vm.profile.id, 2, vm.ga_version,  function (res) {
          vm.authURL = res.data.authorization_uri;
          if(vm.authURL) {
            $window.location.href = vm.authURL;
          }
        }, function (error) {
        });
    }

    function analyticSelected() {
      vm.showProgressCircular = true;
      var selectedobj = {
        'selectedAnalytic': vm.selectedAnalytics,
        'profileId': vm.profile.id,
        'webContentId': vm.profile.web_content.id
      }
      ProfilesService.getWebProfiles(selectedobj, handleProfiles, function (err) {
        $log.error(err);
      });
    }

    function analyticSelectedGa4() {
      vm.allProfiles = vm.selectedAnalytics.propertySummaries;
    }

    function handleAccounts(response) {
      var accounts = response.result.items;
      if (accounts && accounts.length) {
        vm.analyticsAuthorized = true;
        lodash.map(accounts, function (account) {
          GoogleService.queryProperties(account, handleProperties, function (err) {
            $log.error(err);
          });
        })
      } else {
        $log.log('There are no accounts to show');
      }
    }

    function handleProperties(webContentId, profileId) {
      vm.showProgressCircular = true;
      ProfilesService.getWebProperties(webContentId, profileId,function (response) {
        var properties = response.data;
        if (properties && properties.length) {
          lodash.map(properties, function (property) {
            lodash.map(property.items, function (items) {
              vm.analytics.push(items);
            })
          })
          vm.analyticsAuthorized = true;
          vm.showProgressCircular = false;
          setWebContentPrices();
        } else {
          $log.log('There are no properties to show');
        }
      }, function () {
        $log.error('error');
      });
      // var properties = response.result.items;
      // if (properties && properties.length) {
      //   lodash.map(properties, function (property) {
      //     vm.analytics.push(property);
      //   })
      // } else {
      //   $log.log('There are no properties to show');
      // }
    }

    function handlePropertiesGa4(webContentId, profileId) {
      vm.showProgressCircular = false;
      ProfilesService.getWebPropertiesGa4(webContentId, profileId,function (response) {
        var properties = response.data.accountSummaries;
        if (properties && properties.length) {
          lodash.map(properties, function (property) {
              vm.analytics.push(property);
          })
          vm.analyticsAuthorized = true;
          setWebContentPrices();
        } else {
          $log.log('There are no properties to show');
        }
      }, function () {
        $log.error('error');
      });
    }

    function handleProfiles(response) {
      var profiles = response.data.items;
      vm.showProgressCircular = false;
      if (profiles && profiles.length >= 1) {
        vm.allProfiles = profiles;
        // temp patch for delightful mom food blog
        for (var i = 0; i < profiles.length; i++) {
          if (profiles[i].id === '106668701') {
            vm.profile.web_content.ga_profile_id = profiles[i].id;
            break;
          }
        }
      } else {
        $log.log('There are no profiles to show');
      }
    }

    function profileSelected() {
      if (vm.selectedProfile === null) return;
      vm.showProgressCircular = true;
      vm.profile.web_content.ga_profile_id = vm.selectedProfile.id;
      var selectedProfileObj = {
        'webContentId': vm.profile.web_content.id,
        'profileId': vm.profile.id,
        'selectedProfileId': vm.selectedProfile.id,
      }
      ProfilesService.getWebGaData(selectedProfileObj,function (response) {
        handleReports(response);
      }, function () {
        $log.error('error');
         vm.showProgressCircular = false;
          $log.error(err);
          toastr.error(err.result.error.message);
          disconnectGA(false)
      });
    }

    function profileSelectedGa4() {
      if (!vm.selectedProfile) return;
      vm.showProgressCircular = true;
      var selectedProfileId = vm.selectedProfile.property.split('/')
      var selectedProfileObj = {
        'webContentId': vm.profile.web_content.id,
        'profileId': vm.profile.id,
        'selectedProfileId': selectedProfileId[1],
      }
      ProfilesService.getWebGa4Data(selectedProfileObj, function (response) {
        handleReportsGa4(response);
      }, function () {
        $log.error('error');
         vm.showProgressCircular = false;
          $log.error(err);
          toastr.error(err.result.error.message);
          disconnectGA(false)
      });
    }

    function handleReports(response) {
      vm.profile.web_content.muv = parseInt(response.data.totalsForAllResults['ga:users']);
      if (vm.profile.web_content.muv < MIN_VALUES.GA) {
        showAlert('Minimum monthly unique visitors',
          'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. Google Analytics reported ' + vm.profile.web_content.muv +
          '. Please use a higher performing website or try again once you reach an average of ' +
          'at least ' + MIN_VALUES.GA + ' visitors a month for 3 subsequent months.',
          'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
          vm.showProgressCircular = false;
        });
        // vm.hidden = false;
      } else {
        vm.showProgressCircular = false;
        vm.profile.web_content.ga_account_id = vm.selectedAnalytics.account;
        vm.profile.web_content.ga_profile_id = vm.selectedAnalytics.propertySummaries;
        vm.profile.web_content.web_property_id = vm.selectedAnalytics.id;
        vm.profile.web_content.website_url = vm.selectedAnalytics.website_url;
        vm.profile.web_content.href = vm.selectedAnalytics.self_link;
        vm.profile.web_content.followers = vm.profile.web_content.muv;
        vm.profile.web_content.network = 'GA';
        vm.profile.web_content.completed = true;
      }
    }

    function handleReportsGa4(response) {
      vm.profile.web_content.muv = response.data.rows[1].metricValues[0].value; 
      if (vm.profile.web_content.muv < MIN_VALUES.GA) {
        showAlert('Minimum monthly unique visitors',
          'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. Google Analytics reported ' + vm.profile.web_content.muv +
          '. Please use a higher performing website or try again once you reach an average of ' +
          'at least ' + MIN_VALUES.GA + ' visitors a month for 3 subsequent months.',
          'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
          vm.showProgressCircular = false;
        });
        // vm.hidden = false;
      } else {
        vm.showProgressCircular = false;
        var selectedAccountId = vm.selectedAnalytics.account.split('/')
        vm.profile.web_content.ga_account_id = Number(selectedAccountId);
        vm.profile.web_content.ga_profile_id = vm.profile.id;
        var selectedProfileId = vm.selectedProfile.property.split('/')
        vm.profile.web_content.web_property_id = Number(selectedProfileId);
        vm.profile.web_content.website_url = response.data.rows[1].dimensionValues[1].value;
        vm.profile.web_content.href = 'https://www.scalefluence.com/analytics/account/'+ selectedAccountId[1] + '/property/' + selectedProfileId[1];
        vm.profile.web_content.followers = vm.profile.web_content.muv;
        vm.profile.web_content.network = 'GA';
        vm.profile.web_content.completed = true;
      }
    }

    function showGaDetails() {
      showAlert('PRICING FOR SPONSORED BLOG CONTENT', 'According to Google, your site had (' + vm.profile.web_content.muv + ') visits last month. ' +
        'Below is our suggested payout for a blog post. You can put any price you want. This is only a suggestion based on your traffic.' +
        'Content must be up 6 months or longer.',
        'Ok I understand'
      )
    }


    function handleWebContentConnection(selectedOption) {
      vm.showProgressCircular = true;
      if(vm.selectedOption === "GA4"){
        handleWebContentConnectionGa4()
      } else {
      vm.ga_version = "UA";
      checkProfileWebContent();
      }
    }

    function handleWebContentConnectionGa4() {
      vm.showProgressCircular = true;
      vm.ga_version = "GA4";
      checkProfileWebContent();
    }

    function checkProfileWebContent(){
      if (vm.profile.web_content.href) {
        disconnectGA()
      } else {
        authorize();
      }
    }

    function disconnectGA(showMsg) {
      var profile = vm.profile;
      var updateData = false;

      if (profile.web_content.id) {
        updateData = {
          web_content: {
            id: vm.profile.web_content.id,
            _destroy: true,
            href: vm.profile.web_content.href
          }
        }
      }

      if (updateData === false) {
        clearWebContent();
      } else {
        ProfilesService.updateProfile(vm.profile.id, updateData, function () {
          clearWebContent();
          if (showMsg !== false) toastr.success('Analytics account disconnected.');
        }, function () {
          toastr.error('There was an error disconnecting your Analytics account.');
        })
      }
      vm.showProgressCircular = false;
    }

    function clearWebContent() {
      clearWebContentPrices();
      vm.profile.web_content = null;
      setInitialWebContent();
    }

    function clearWebContentPrices() {
      lodash.forEach(vm.profile.web_content.social_prices, function (item) {
        delete item.price
      });
    }

    function setInitialWebContent() {
      if (!vm.profile.web_content) {
        vm.profile.web_content = {
          muv: ''
        };
        vm.initialAnalytics.selected = "none";
        vm.selectedAnalytics = vm.initialAnalytics;


        vm.analytics = [];
        vm.analyticsAuthorized = false;
      } else if (vm.profile.web_content.href) {
        vm.hidden = true;
        vm.gaSaved = true;
        vm.initialAnalytics.selected = vm.profile.web_content.website_url;
        vm.selectedAnalytics = vm.initialAnalytics;
        vm.analyticsAuthorized = true;
      }
      vm.profile.web_content.hasChanged = false;
      setWebContentPrices()
    }

    function setWebContentPrices() {
      var merged = _.merge(
        _.keyBy(vm.profile.web_content.web_content_prices, 'price_type'),
        _.keyBy(vm.webContentHandle.web_content_prices, 'price_type')
      );
      vm.profile.web_content.web_content_prices = _.values(merged);
    }

    function getPropertyLabelGA() {
      return vm.profile.web_content.muv ? 'Website (' + vm.profile.web_content.muv + ' visits)' : 'Website';
    }

    function getPricingLabelGA(network) {
      return vm.profile.web_content.muv && vm.profile.web_content.muv >= MIN_VALUES.GA ? 'Suggested price: ' + PricingService.getPrice(vm.profile.web_content.muv, network) : 'Your price per post (USD):';
    }

    function queryAccounts() {
      vm.analytics = [];
      GoogleService.queryAccounts(handleAccounts, function (error) {
        toastr.error('No Google Analytics account found');
        vm.showProgressCircular = false;
      });
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function goEditProfileSection(editSection) {
      RoutesService.editProfileSection(editSection, vm.profile.id, vm.profile);
    }

    function goEditProfile() {
      var shouldClear = vm.profile.web_content.hasChanged;
      if (shouldClear) {
        confirmLeavePage();
      } else {
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }
    }

    function confirmLeavePage() {
      var confirmText = 'Are you sure you want to leave this page? All unsaved data will be lost.';
      var confirm = $mdDialog.confirm()
        .title('You are leaving the page.')
        .textContent(confirmText)
        .ok('Yes')
        .cancel('Stay');
      $mdDialog.show(confirm).then(function (result) {
        if (vm.profile.web_content.id) {
          lodash.forEach(vm.profile.web_content.web_content_prices, function (item) {
            if (item.changed) delete item.price
          });
        } else {
          clearWebContent()
        }
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }, function () {
      });
    }

    function canEditSponsoredWeb() {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED], vm.profile.web_content) && vm.profile.web_content.canEdit;
    }

    function getPriceClass(price) {
      if (price.changed) return '';
      switch (price.state) {
        case PUB_URL_STATE.ACTIVE:
          return 'active-social';
        case PUB_URL_STATE.PENDING:
          return 'submitted-social';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'submitted-social';
        case PUB_URL_STATE.REJECTED:
          return 'rejected-social';
        case PUB_URL_STATE.CANCELLED:
          return 'rejected-social'
      }
    }

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function showPriceGa(network, socialHandle, display) {
      if (network === 'GA') {
        if (angular.isDefined(vm.profile.web_content.muv)) {
          $scope.followers = 0;
        }
        checkGAMinValues(display);
      } else {
        if (angular.isUndefined(socialHandle.followers)) {
          $scope.followers = 0;
          $scope.network = '';
        }
        checkSocialMinValues(network, socialHandle, display);
      }
    }

    function saveWebContent(form) {
      if (!sponsoredBlogProduct()) {
        showAlert('Blog Required', 'You need to connect sponsored blog ' +
          'and provide pricing for at least one before completing your profile.', 'Got it')
      } else {
        var updateData = { web_content: vm.profile.web_content };
        ProfilesService.updateProfile(vm.profile.id, updateData, function () {
          ProfilesService.showProfile(vm.profile.id, function (response) {
            var data = response.data;
            vm.profile.web_content = data.web_content;
            setWebContentPrices();
            goEditProfile();
          }, function () {
            toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
          });
          toastr.success('Profile\'s web content successfuly updated.');
        }, function () {
          toastr.error('There was an error updating this profile\'s web content, please retry.');
        });
      }
    }

    function sponsoredBlogProduct() {
      return gaPriceChangeEnabled() && isAnalyticsCompleted()
    }

    function gaPriceChangeEnabled() {
      return vm.profile.web_content.href && vm.profile.web_content.muv >= MIN_VALUES.GA;
    }

    function isAnalyticsCompleted() {
      if (!!vm.profile.web_content) {
        return lodash.findIndex(vm.profile.web_content.web_content_prices, function (content_price) {
          if (vm.profile.web_content.href && content_price.price) {
            return true;
          }
        }) !== -1;
      } else {
        return false
      }
    }

    function checkGAMinValues(display) {
      if (vm.profile.web_content.muv && vm.profile.web_content.muv >= MIN_VALUES.GA) {
        $scope.followers = vm.profile.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          'Should be placed on front page for best performance. ';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'You Have ' + vm.profile.web_content.muv + ' Monthly Visitors';
        if (display) {
          displayRowGridPrice();
        }
      } else {
        showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. You currently do not meet ' +
          'that criteria. When you do reach that traffic, you can come back to ' +
          'this profile and submit it then.', 'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
        });
      }
    }

    function canEditSocialPrice(priceItem) {
      return (!lodash.includes(
        [
          PUB_URL_STATE.PENDING,
          PUB_URL_STATE.RESUBMITTED,
          PUB_URL_STATE.UNDER_REVIEW,
          PUB_URL_STATE.CANCELLED
        ], priceItem.state)
        && priceItem.state) || !priceItem.state;
    }

    function triggerChange(handle) {
      handle.changed = true;
      vm.profile.web_content.hasChanged = true;
    }

    function showInfo(step) {
      switch (step) {
        case 3:
          return showAlertHTML('Sponsored Web Content', 'Sponsored Web Content will read more like featured content. ' +
            'You will need to disclose compensation for the content per FTC regulations. ' +
            'Links inside the content will be NO-FOLLOW. You will have editorial control as well.' +
            '<br>' + '<br>' + 'By authorizing your Google Analytics account below, Scalefluence can see how ' +
            'many people engaged with each blog post. We will not be retrieving any ' +
            'private data from your Analytics account. Only the number of monthly ' +
            'unique visitors coming to your blog and previous content placements done through Scalefluence.', 'Ok').then(function (result) {
            return false;
          });
        case 31: // Case 3.1
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos & \'story messaging\' ' +
            'points if you accept this assignment. Choose which ones you like and seamlessly include them in a new blog post going over ' +
            'the product or service, you will then submit a draft for review and ' +
            'publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 32: // Case 3.2
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. Many low traffic bloggers ' +
            '(less than 2000 visits per month) will put $0 because products are usually around $50 to $150 retail. ' +
            'Marketers want photos of you reviewing the product / service. You will submit a draft for r' +
            'eview and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 33: // Case 3.3
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'This assignment is an unboxing video of you using the product with video + blog content. ' +
            'Please give an appropriate discount for the free product. We understand video is more impactful, ' +
            'takes longer and is more expensive, but again, please give a discount for free product ' +
            'being shipped to you. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
      }

      $mdDialog.show(confirm).then(function (result) {
        return false;
      });
    }

    function contributorOnlyPopup() {
      $mdDialog.show(
        $mdDialog.alert()
          .title('ADDING NEW URL')
          .textContent('To make sure each URL is relevant, simply create a NEW Profile for the next URL. Please click OK to be taken back to the dashboard. Then click "Create New Profile" to get started.')
          .escapeToClose(false)
          .ok("OK, Got it.")
      ).then(function() {
        goToDashboard();
      });
    }

    function analyticstAccountTypeDisplay(option) {
      console.log(option);
      if (option == 'UA') {
        return 'Old Analytics -> UA';
      } else {
        return 'New Analytics -> GA4';
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit.socials', [])
    .controller('EditSocialsController', EditSocialsController);

  /** @ngInject */
  function EditSocialsController($state, $stateParams, $anchorScroll, $window, $rootElement, $scope, $location, $log, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, ProfilesService, RoutesService, FacebookService, PricingService, SocialHandlesService, GoogleService, PROFILE_TYPE, SOCIAL, SOCIAL_PRICES, MIN_VALUES,
                                 EnvironmentConfig, PUB_URL_STATE
  ) {
    var vm = this;
    var params = $location.search();
    $location.search({});

    var twitterFollowersCount = params.twitter_followers_count;
    var twitterNickname = params.twitter_nickname;
    var igAuthCode = params.ig_auth_code;
    var igUserId = params.ig_user_id;
    var subtype = params.subtype;

    // Accessible attributes
    vm.profile = {};
    vm.socialHandles = {
      facebook_handle: {
        name: SOCIAL_PRICES.FACEBOOK.NAME,
        social_prices: SOCIAL_PRICES.FACEBOOK.FIELDS
      },
      twitter_handle: {
        name: SOCIAL_PRICES.TWITTER.NAME,
        social_prices: SOCIAL_PRICES.TWITTER.FIELDS
      },
      instagram_handle: {
        name: SOCIAL_PRICES.INSTAGRAM.NAME,
        social_prices: SOCIAL_PRICES.INSTAGRAM.FIELDS
      },
      youtube_handle: {
        name: SOCIAL_PRICES.YOUTUBE.NAME,
        social_prices: SOCIAL_PRICES.YOUTUBE.FIELDS
      }
    };

    vm.qtyIgFailedScrapes = 0;
    vm.maxIgFailedScrapes = 5;
    vm.socialCount = {};

    vm.goToDashboard = goToDashboard;
    vm.goEditProfileSection = goEditProfileSection;
    vm.goEditProfile = goEditProfile;
    vm.saveSocialContent = saveSocialContent;
    vm.handleFacebookConnection = handleFacebookConnection;
    vm.handleInstagramConnection = handleInstagramConnection;
    vm.handleYoutubeConnection = handleYoutubeConnection;
    vm.handleTwitterConnection = handleTwitterConnection;
    vm.showConfirmDisconnectSocialModal = showConfirmDisconnectSocialModal;
    vm.setSubtype = setSubtype;
    vm.disconnectSocial = disconnectSocial;
    vm.loadSocialHandle = loadSocialHandle;
    vm.authorize = authorize;
    vm.canEditSocialPrice = canEditSocialPrice;
    vm.canEditSocialHandle = canEditSocialHandle;
    vm.getPriceClass = getPriceClass;
    vm.showInfo = showInfo;
    vm.showPriceGa = showPriceGa;
    vm.getEditSocialPriceInfo = getEditSocialPriceInfo;
    vm.triggerChange = triggerChange;
    vm.getSocialFollowers = getSocialFollowers;
    vm.getSocialFollowersCount = getSocialFollowersCount;

    init();

    function init() {
      if (angular.isDefined($stateParams.profile) || angular.isDefined($stateParams.profileId)) {
        if ($stateParams.profile) {
          vm.profile = $stateParams.profile;
          setProfileData()
        } else {
          if ($stateParams.profileId) {
            ProfilesService.showProfile($stateParams.profileId, function (response) {
              vm.profile = response.data;
              setProfileData()
            }, function () {
              $log.log('Error retrieving the profile.');
              toastr.error('There was an error retrieving the profile.');
            });
          } else {
            goToDashboard()
          }
        }
      }

      $scope.$mdMedia = $mdMedia;
    }

    function setProfileData() {
      ProfilesService.getProfileSocialUrls(function (response) {
        vm.profileSocialUrls = response.data.profile_social_urls;
        if (igAuthCode && igUserId && subtype) {
          ProfilesService.verifyInstagramAccount(igAuthCode, igUserId, function (response) {
            vm.profile.instagram_handle.subtype = subtype;
            $location.search({});
            var username = response.data.username;
            if (checkExistedSocialAccount('instagram', username)) {
              showUseAnotherAccountModal(vm.profile.instagram_handle, 'instagram')
            } else {
              getInstagramFollowers(username);
            }

          }, function (error) {
            $location.search({});
            console.log(error);
          });
        }
      });

      setSocialHandles();
      getSocialFollowers();

      if (twitterFollowersCount && twitterNickname) {
        loadSocialHandle(vm.profile.twitter_handle, 'twitter', twitterNickname, twitterFollowersCount)
      }
    }

    function getSocialFollowers() {
      lodash.map(vm.socialHandles, function (handle) {
        var handleKey = getHandleKey(handle.name);
        var socialFollowersCount = vm.profile[handleKey].followers;
        if(socialFollowersCount) {
          vm.socialFollowers = getSocialFollowersCount(handleKey);
          vm.socialCount[vm.socialFollowers] = socialFollowersCount;
        }
      });
    }

    function getSocialFollowersCount(handleKey) {
      switch (handleKey) {
        case 'facebook_handle':
          return "facebookFollowersCount"
        case 'youtube_handle':
          return "youTubeFollowersCount"
        case 'instagram_handle':
          return "instagramFollowersCount"
        case 'twitter_handle':
          return "twitterFollowersCount"
      }
    }

    function triggerChange(handle, network) {
      handle.changed = true;
      var socialHandle = getHandleFromType(network);
      socialHandle.hasChanged = true;
    }

    function getEditSocialPriceInfo(state) {
      switch (state) {
        case PUB_URL_STATE.ACTIVE:
          return 'Price approved';
        case PUB_URL_STATE.PENDING:
          return 'Pending review';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'Pending review';
        case PUB_URL_STATE.REJECTED:
          return 'Price declined';
        case PUB_URL_STATE.CANCELLED:
          return 'Price rejected'
      }
    }

    function saveSocialContent(form, network) {
      var socialHandle = getHandleFromType(network);
      if (!socialMediaProduct(network)) {
        showAlert('Social Handle Required', 'You need to connect social handle ' +
          'and provide pricing for at least one before completing your profile.', 'Got it')
      } else {
        var handleKey = getHandleKey(network);
        var updateData = {};
        updateData[handleKey] = socialHandle;

        ProfilesService.updateProfile(vm.profile.id, updateData, function () {
          ProfilesService.showProfile(vm.profile.id, function (response) {
            vm.profile = response.data;
            setSocialHandles();
            goEditProfile(network)
          }, function () {
            toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
          });
          form.$setPristine();
          toastr.success('Profile\'s social content successfuly updated.');
        }, function (response) {
          if (response.data.error) {
            if (angular.isArray(response.data.error)) {
              lodash.each(response.data.error, function (error) {
                toastr.error(error);
              })
            } else {
              showAlert('NOTE', response.data.error,  'Got it').then(function (result) {
                socialHandle.url = '';
             });
            }
          }
        });
      }
    }


    function getHandleFromType(type) {
      var handle = {};
      switch (type) {
        case SOCIAL.Facebook:
          handle = vm.profile.facebook_handle;
          break;
        case SOCIAL.Twitter:
          handle = vm.profile.twitter_handle;
          break;
        case SOCIAL.Youtube:
          handle = vm.profile.youtube_handle;
          break;
        case SOCIAL.Instagram:
          handle = vm.profile.instagram_handle;
          break;
      }
      return handle;
    }

    function socialMediaProduct(network) {
      var socialHandle = getHandleFromType(network);
      console.log('got handle from type', socialHandle);
      return !!(socialHandle.url && lodash.findIndex(socialHandle.social_prices, function (item) {
        if (item.price) return true
      }) >= 0);
    }

    function checkExistedSocialAccount(socialNetwork, username) {
      var url = 'https://www.' + socialNetwork + '.com/' + username;
      if (_.includes(vm.profileSocialUrls, url)) {
        return true
      }
    }

    function getInstagramFollowers(username) {
      ProfilesService.getInstagramData(username, function (response) {
        var followersCount = response.data.qty_followers;
        var error = response.data.data_error;
        // if error is not null then the only data_error that exists right now is restricted_profile, so we are
        // assuming that's what the error is, but this will need to be updated in the future if more data_errors are added
        if (error !== null) {
          return $mdDialog.show($mdDialog.alert()
            .title('')
            .textContent('We apologize but Instagram views your page as adults only (18+) or otherwise restricted and therefore not eligible for sponsorship collaborations.  We suggest reaching out to IG and explaining your situation. And if resolved, come back and connect at that time.')
            .escapeToClose(false)
            .ok('Ok')
          )
          .then(function(result) {
            // do nothing
          });
        } else {
          if (followersCount == null) {
            // followersCount = MIN_VALUES.SOCIAL;
            vm.qtyIgFailedScrapes++;
            if (vm.qtyIgFailedScrapes <= vm.maxIgFailedScrapes) {
              return $mdDialog.show($mdDialog.alert()
                .title('')
                .textContent('Hey ' + username + ',  seems like Instagram is taking longer than normal. Nothing to worry about. Should only be a moment longer.  Remember, after we get the data, click the orange ? icon to see what our suggested pricing is.')
                .escapeToClose(false)
                .ok('Ok')
              )
              .then(function(result) {
                getInstagramFollowers(username);
              });
            } else {
              return $mdDialog.show($mdDialog.alert()
                .title('')
                .textContent('So sorry! It looks like we are having trouble requesting all your Instagram account information at this time. Please try again later and if the problem persists then contact admin@scalefluence.com to report the issue. Thank you!')
                .escapeToClose(false)
                .ok('Ok')
              )
              .then(function(result) {
                // nothing
              });
            }
          }
        }
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, followersCount);
      }, function (error) {
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, MIN_VALUES.SOCIAL);
      });
    }

    function setSocialHandles() {
      lodash.map(vm.socialHandles, function (handle) {
        var handleKey = getHandleKey(handle.name);
        var merged = _.merge(
          _.keyBy(vm.profile[handleKey].social_prices, 'price_type'),
          _.keyBy(vm.socialHandles[handleKey].social_prices, 'price_type')
        );
        vm.profile[handleKey].hasChanged = false;
        vm.profile[handleKey].social_prices = _.values(merged);
      });
    }

    function getHandleKey(network) {
      return network.toLowerCase() + '_handle';
    }

    function loadSocialHandle(socialHandle, socialNetwork, username, count) {
      console.log('loading social handle', socialNetwork, username);
      socialHandle.url = 'https://www.' + socialNetwork + '.com/' + username;
      socialHandle.followers = count;
      socialHandle.name = socialNetwork;
      checkSocialMinValues(socialNetwork, socialHandle);
    }

    function loadSocialHandleWithShortToken(socialHandle, socialNetwork, username, count, userId, token) {
      socialHandle.url = 'https://www.' + socialNetwork + '.com/' + username;
      socialHandle.followers = count;
      socialHandle.name = socialNetwork;
      socialHandle.fb_user_id = userId;
      socialHandle.auth_key = token;
      checkSocialMinValues(socialNetwork, socialHandle);
    }

    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Your price per post (USD):';
    }

    function checkSocialMinValues(type, socialMedia, display) {
      if (!socialMedia.url) {
        socialMedia.followers = '';
        getPricingLabel(socialMedia, type);
      } else {
        var socialMediaFlag = type === SOCIAL.Facebook || type === SOCIAL.Twitter;
        // Adding this code due to the additional check thru backend below not working
        if (socialMedia.followers < MIN_VALUES.SOCIAL) {
          showAlert('Minimum followers', 'We apologize but we need a minimum of 1000 followers for ' +
            'EACH social handle for you to participate in this product. You ' +
            'currently do not meet that criteria for this handle. When you do ' +
            'reach that engagement, you can come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
            socialMedia.url = '';
            socialMedia.price = '';
          });
        } else {
          var price = PricingService.getPrice(socialMedia.followers, type);
          var videoPrice = PricingService.getVideoPrice(socialMedia.followers, type);
          if (type === 'facebook') {
            var sharingPrice = PricingService.getSharingPrice(socialMedia.followers, type);
          }
          socialMedia.suggested_post_price = price;
          socialMedia.suggested_video_price = videoPrice;
          socialMedia.suggested_sharing_price = sharingPrice;
          $scope.followers = socialMedia.followers;
          $scope.network = type;
          $scope.rowHeader = socialMediaFlag ? 'Suggested Pricing for Facebook, Twitter & Pinterest' : 'Suggested Pricing for Instagram & YouTube';
          $scope.content = 'According to (' + type + '), you have (' + socialMedia.followers + ') followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.';
          $scope.contentLineTwo = 'For your protection, this content will be disclosed per FTC guidelines.';
          $scope.header = 'You have ' + socialMedia.followers + ' Followers';
          changeHandle(type);
          getSocialFollowers();
          if (display) {
            displayRowGridPrice();
          }
        }
      }
      vm.showProgressCircular = false;
    }

    function changeHandle(type) {
      var handle = getHandleFromType(type);
      handle.hasChanged = true
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/partials/rowDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'EditProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function authorize(event, socialHandle) {
      GoogleService.authorize(event, function (response) {
        if (response.error) {
          vm.hidden = false;
        } else {
          vm.hidden = true;
          getYouTubeFollowers(socialHandle);
        }
      });
    }

    function getYouTubeFollowers(socialHandle) {
      GoogleService.queryYouTubeStatistics(function (response) {
        if (response.result.items.length) {
          socialHandle.url = 'www.youtube.com/channel/' + response.result.items[0].id;
          socialHandle.followers = response.result.items[0].statistics.subscriberCount;
          if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
          checkSocialMinValues('youtube', socialHandle);
        } else {
          toastr.error('', 'No channel associated to your account.');
        }
      });
    }

    function clearSocial(handle) {
      handle.hasChanged = false;
      lodash.forEach(Object.keys(handle), function (key) {
        if (key !== 'social_prices') delete handle[key];
        lodash.forEach(handle.social_prices, function (item) {
          delete item.price
        });
      });
    }

    function showChooseAccountModal(accounts, successCallback, errorCallback) {
      $mdDialog.show({
        controller: 'SocialHandleController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfile/partials/socialHandleDialog.html',
        clickOutsideToClose: false,
        locals: {
          accounts: accounts,
        }
      }).then(function (response) {
        successCallback(response)
      },
        errorCallback
      );
    }

    function showUseAnotherAccountModal(socialHandle, socialNetwork) {
      var confirm = $mdDialog.confirm()
        .title('Account is already linked')
        .htmlContent('<p>You have already connected this handle in another profile.</p>' +
          'Please email ' + '<strong>admin@scalefluence.com</strong>' + ' for help.</p>')
        .ok('Connect other')
        .cancel('Ok got it');
      $mdDialog.show(confirm).then(function () {
        socialHandle.url = null;
        switch (socialNetwork) {
          case 'facebook':
            handleFacebookConnection(socialHandle, socialNetwork, true);
            break;
          case 'instagram':
            handleInstagramConnection(socialHandle, socialNetwork, true)
        }
      }, function () {
        disconnectSocial(socialHandle, socialNetwork)
      });
    }

    function setSubtype(socialHandle, subtype) {
      socialHandle.subtype = subtype;
    }

    function disconnectSocial(socialHandle, socialNetwork) {
      var profile = vm.profile;
      var updateData = false;
      var handleKey = getHandleKey(socialNetwork);

      if (profile[handleKey].id) {
        updateData = {};
        updateData[handleKey] = {
          id: profile[handleKey].id,
          _destroy: 1
        }
      }
      if (updateData === false) {
        clearSocial(socialHandle);
      } else {
        ProfilesService.updateProfile(profile.id, updateData, function (response) {
          vm.profile = response.data;
          setSocialHandles();
          setProfileData();
          toastr.success('Disconnected from social network successfuly.');
        }, function (response) {
          if (response.data.errors) {
            var errors = lodash.map(Object.keys(response.data.errors), function (err) {
              return response.data.errors[err]
            });
            lodash.each(errors, function (error) {
              toastr.error(error[0]);
            })
          }
        });
      }
      vm.showProgressCircular = false;
    }


    function goToDashboard() {
      RoutesService.dashboard();
    }

    function goEditProfileSection(editSection) {
      RoutesService.editProfileSection(editSection, vm.profile.id, vm.profile);
    }

    function goEditProfile(type) {
      var handle = getHandleFromType(type);
      var shouldClear = handle.hasChanged;
      if (shouldClear) {
        confirmLeavePage(handle, type);
      } else {
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }
    }

    function confirmLeavePage(handle, type) {
      var confirmText = 'Are you sure you want to leave this page? All unsaved data will be lost.';
      var confirm = $mdDialog.confirm()
        .title('You are leaving the page.')
        .textContent(confirmText)
        .ok('Yes')
        .cancel('Stay');

      $mdDialog.show(confirm).then(function (result) {
        if (handle.id) {
          lodash.forEach(handle.social_prices, function (item) {
            if (item.changed) delete item.price
          });
        } else {
          clearSocial(handle)
        }
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }, function () {
      });
    }

    function canEditSocialHandle(sh) {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED], sh.state) && sh.canEdit;
    }

    function canEditSocialPrice(priceItem) {
      return (!lodash.includes(
        [
          PUB_URL_STATE.PENDING,
          PUB_URL_STATE.RESUBMITTED,
          PUB_URL_STATE.UNDER_REVIEW,
          PUB_URL_STATE.CANCELLED
        ], priceItem.state)
        && priceItem.state) || !priceItem.state;
    }

    function getPriceClass(price) {
      if (price.changed) return '';
      switch (price.state) {
        case PUB_URL_STATE.ACTIVE:
          return 'active-social';
        case PUB_URL_STATE.PENDING:
          return 'submitted-social';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'submitted-social';
        case PUB_URL_STATE.REJECTED:
          return 'rejected-social';
        case PUB_URL_STATE.CANCELLED:
          return 'rejected-social'
      }
    }


    function handleFacebookConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        handleFacebookAuthentication(socialHandle, socialNetwork);
      }
    }

    function handleInstagramConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        switch (socialHandle.subtype) {
          case 'simple':
            getAuthURL();
            break;
          case 'verified':
            handleFacebookAuthentication(socialHandle, socialNetwork);
            break;
        }
      }
    }

    function handleFacebookAuthentication(socialHandle, socialNetwork) {
      vm.showProgressCircular = true;
      FacebookService.authenticateAndGetShortToken(socialNetwork, function (userId, accessToken) {
        switch (socialNetwork) {
          case 'facebook':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var username = account.username || account.id;
                if (checkExistedSocialAccount(socialNetwork, username)) {
                  showUseAnotherAccountModal(socialHandle, socialNetwork)
                } else {
                  loadSocialHandleWithShortToken(socialHandle, socialNetwork, username, account.fan_count, userId, accessToken);
                }
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
          case 'instagram':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var fanPageId = account.id;
                FacebookService.checkForInstagramBusinessAccount(fanPageId, function (response) {
                  if (checkExistedSocialAccount(socialNetwork, response.username)) {
                    showUseAnotherAccountModal(socialHandle, socialNetwork)
                  } else {
                    loadSocialHandle(socialHandle, socialNetwork, response.username, response.followers_count);
                  }
                }, function (error) {
                  toastr.error(error);
                });
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
        }
      }, function (error) {
        vm.showProgressCircular = false;
        toastr.error(error);
      });
    }


    function getAuthURL() {
      ProfilesService.getInstagramAuthUrl('edit', vm.profile.id, function (response) {
        if (response.data.auth_url) {
          $window.location.href = response.data.auth_url;
        }
      }, function (error) {
        console.log(error)
      });
    }

    function handleYoutubeConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        authorize(ev, socialHandle)
      }
    }

    function handleTwitterConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        showConfirmDisconnectSocialModal(socialNetwork, socialHandle)
      } else {
        authenticateTwitter(ev, socialHandle)
      }
    }

    function authenticateTwitter() {
      $window.location.href = EnvironmentConfig.API_END_POINT.replace('/api/v1', '/auth/twitter?action=edit&profile_id=' + vm.profile.id);
    }

    function showConfirmDisconnectSocialModal(socialNetwork, socialHandle) {
      var confirmText = 'Are you sure?  Disconnecting ' + capitalizeFirstLetter(socialNetwork) + ' will remove you from getting any assignments. ' +
        'You will not be able monetize this channel.';
      var confirm = $mdDialog.confirm()
        .title('DISCONNECT WARNING')
        .textContent(confirmText)
        .cancel('Cancel')
        .ok('Disconnect');

      $mdDialog.show(confirm).then(function (result) {
        disconnectSocial(socialHandle, socialNetwork);
      }, function () {
      });
    }

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function showPriceGa(network, socialHandle, display) {
      // not sure if this function is still used... it used to be used
      // by an icon next to the network validation button that would
      // appear after a network had been validated and when clicked it
      // would display a popup with the pricing matrix, but we moved
      // the pricing matrix to be on the same page under the button.
      if (network === 'GA') {
        if (angular.isDefined(vm.profile.web_content.muv)) {
          $scope.followers = 0;
        }
        checkGAMinValues(display);
      } else {
        if (angular.isUndefined(socialHandle.followers)) {
          $scope.followers = 0;
          $scope.network = '';
        }
        checkSocialMinValues(network, socialHandle, display);
      }
    }

    function checkGAMinValues(display) {
      if (vm.profile.web_content.muv && vm.profile.web_content.muv >= MIN_VALUES.GA) {
        $scope.followers = vm.profile.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          'Should be placed on front page for best performance. ';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'You Have ' + vm.profile.web_content.muv + ' Monthly Visitors';
        if (display) {
          displayRowGridPrice();
        }
      } else {
        showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of ' + MIN_VALUES.GA + ' unique visitors ' +
          'per month to participate in this product. You currently do not meet ' +
          'that criteria. When you do reach that traffic, you can come back to ' +
          'this profile and submit it then.', 'Ok I understand').then(function (result) {
          vm.profile.web_content.href = '';
          vm.profile.web_content.price = '';
        });
      }
    }

    function showInfo(step) {
      switch (step) {
        case 4:
          return showAlertHTML('Sponsored Social Content', 'Sponsored Social Content is featured content on your social handle. ' +
            'You will need to disclose compensation for the content per FTC regulations ' +
            'by using #Ad or #Sponsored hashtags. Content will also come with a Tiny URL ' +
            'to track clicks and engagement of your Social Post. ' +
            '<br>' + '<br>' + 'By supplying your Social handles below, our technology can see how many ' +
            'people engaged with the social post. We will not be retrieving any private ' +
            'data of your account. Only the number of followers and previous content ' +
            'placements done through Scalefluence.', 'Ok').then(function (result) {
            return false;
          });
        case 411: // Case 4.1.1
          return showAlertHTML('Sponsored Social Content', 'You will be given a few branded assets / photos / hashtags &' +
            ' \'story messaging\' points if you accept this assignment. ' +
            'Choose which ones you like and seamlessly include them in a new FB post for review and publication.', 'Ok').then(function (result) {
            return false;
          });
        case 412: // Case 4.1.2
          return showAlertHTML('Sponsored Social Content', 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Many micro-influencers put $0 because the products are usually around $50 to $150 retail.' +
            ' Marketers want photos of you using the product.', 'Ok').then(function (result) {
            return false;
          });
        case 413: // Case 4.1.3
          return showAlertHTML('Sponsored Social Content', 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Marketers understand videos are more extensive and more impactful, ' +
            'but please still give a discount compensating for the $50 to $150 retail price of most products. ' +
            'Marketers want video of you using the product.', 'Ok').then(function (result) {
            return false;
          });
        case 414: // Case 4.1.4
          return showAlertHTML('Sponsored Social Content', 'You will be given an existing influencer story about the brand, ' +
            'or maybe a blog post / press / news story about the brand if you accept this assignment. ' +
            'You will share this and link to it when possible. ' +
            'You will write your own positive thoughts on the subject and submit for review and publication. ', 'Ok').then(function (result) {
            return false;
          });
        case 421: // Case 4.2.1
          return showAlertHTML('Sponsored Social Content', "You will be given a few branded assets / photos / hashtags & 'story messaging' " +
            "points if you accept this assignment. Choose which ones you like and seamlessly include them in a new IG" +
            " post for review and publication.", 'Ok').then(function (result) {
            return false;
          });

        case 422: // Case 4.2.2
          return showAlertHTML('Sponsored Social Content', "Product will be shipped to you if you accept this assignment. " +
            "Please give an appropriate discount for the free product. Many micro-influencers put $0 because the products" +
            " are usually around $50 to $150 retail. Marketers want photos of you using the product.", 'Ok').then(function (result) {
            return false;
          });
        case 423: // Case 4.2.3
          return showAlertHTML('Sponsored Social Content', "This is the same as a single post. " +
            "But a brand may feel that  they are 'in tune' with your audience that they will want to schedule" +
            " out 3 posts with you over several months. Please a give a 10 to 20% discount for this to entice" +
            " marketers to work with you 3 times over.", 'Ok').then(function (result) {
            return false;
          });
        case 424: // Case 4.2.4
          return showAlertHTML('Sponsored Social Content', "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience that they will want to schedule out" +
            " 5 posts with you over several months. Please a give a 20 to 30% discount to entice marketers" +
            " to work with 5 times over.", 'Ok').then(function (result) {
            return false;
          });
        case 425: // Case 4.2.5
          return showAlertHTML('Sponsored Social Content', "", 'Ok').then(function (result) {
            return false;
          });
        case 431: // Case 4.3.1
          return showAlertHTML('Sponsored Social Content', "You will be given a few branded " +
            "assets / photos / hashtags & 'story messaging' points if you accept this assignment. " +
            "Choose which ones you like and seamlessly include them in a new video for review and publication. " +
            "This type of promotion is also called a 'pre-roll ad' or 'mid-roll ad' ." +
            " Such as:  \"This video is brought to you by our partners.\"", 'Ok').then(function (result) {
            return false;
          });
        case 432: // Case 4.3.2
          return showAlertHTML('Sponsored Social Content', "Product will be shipped to you if you " +
            "accept this assignment (or software keys for download). Please give an appropriate discount for " +
            "the free product. Many micro-influencers put $0 because the products are usually " +
            "around $50 to $150 retail. Marketers want photos of you using the product. " +
            "This video content will be a 'featured' piece for the client.", 'Ok').then(function (result) {
            return false;
          });
        case 433: // Case 4.3.3
          return showAlertHTML('Sponsored Social Content', "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule " +
            "out 3 videos with you over several months. Please a give a 10 to 20% discount " +
            "for this product to entice marketers to work with you 3 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. ", 'Ok').then(function (result) {
            return false;
          });
        case 434: // Case 4.3.4
          return showAlertHTML('Sponsored Social Content', "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
            "videos with you over several months. Please a give a 20 to 30% discount for this product " +
            "to entice marketers to work with you 5 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. ", 'Ok').then(function (result) {
            return false;
          });
        case 435: // Case 4.3.5
          return showAlertHTML('Sponsored Social Content', "Marketers will either ship free " +
            "product to use in a short, or simply tell you what to mention in the clip.", 'Ok').then(function (result) {
            return false;
          });
        case 441: // Case 4.4.1
          return showAlertHTML('Sponsored Social Content', "You will be given a few branded assets" +
            " / photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones you " +
            "like and seamlessly include them in a new video for review and publication", 'Ok').then(function (result) {
            return false;
          });
        case 442: // Case 4.4.2
          return showAlertHTML('Sponsored Social Content', "Product will be shipped to you if you accept " +
            "this assignment. Please give an appropriate discount for the free product. " +
            "Many micro-influencers put $0 because the products are usually around $50 to $150 retail. " +
            "Marketers want photos of you using the product. ", 'Ok').then(function (result) {
            return false;
          });
        case 443: // Case 4.4.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept " +
            "this assignment. This assignment is a video of you using the product. We know video takes more time and is more expensive, " +
            "but please give an appropriate discount for the free product. products are usually around $50 to $150 retail. " +
            '</div>', 'Ok').then(function (result) {
            return false;
          });
      }

      $mdDialog.show(confirm).then(function (result) {
        return false;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit')
    .controller('EditInfoDialogController', EditInfoDialogController);

  /** @ngInject */
  function EditInfoDialogController($mdDialog, $rootScope, ProfilesService, MIN_VALUES,
    PUB_URL_STATE, PricesService, url, isContributor, EnvironmentConfig, toastr) {

    var vm = this;
    vm.url = {};
    vm.showMinValues = false;
    vm.showUrlDisabled = false;
    vm.title = '';
    vm.showPause = true;
    vm.pausedValue = false;
    vm.isContributor = false;
    vm.suggestedPrice = '';
    vm.pricePlaceholder = 'Payout';
    vm.showRejectedReasons = false;
    vm.disable = false;
    vm.maxDomPrice = 9999999;
    vm.currentPrice = 0;

    //functions
    vm.checkURL = checkURL;
    vm.submit = submit;
    vm.cancel = cancel;
    vm.getDescriptionTitle = getDescriptionTitle;
    vm.rejectedReasons = rejectedReasons;
    vm.followLinkOptionIsSet = followLinkOptionIsSet;
    vm.setUrlRequiredLength = setUrlRequiredLength;
    vm.setUrlAllowHomepage = setUrlAllowHomepage;
    vm.setUrlFollowLink = setUrlFollowLink;
    vm.setUrlAllowBlogPost = setUrlAllowBlogPost;
    vm.isNewDomain = isNewDomain;
    vm.isAllowHomepage = isAllowHomepage;
    vm.isNotAllowHomepage = isNotAllowHomepage;
    vm.isDoFollow = isDoFollow;
    vm.isNotDoFollow = isNotDoFollow;
    vm.isAllowBlogPost = isAllowBlogPost;
    vm.isNotAllowBlogPost = isNotAllowBlogPost;
    vm.getMetaDescription = getMetaDescription;
    vm.urlStatsRequestFailed = false;

    init();

    function init() {
      vm.isContributor = isContributor;
      if (url.href) {
        vm.isNew = false;
        vm.url = url;
        vm.pausedValue = PUB_URL_STATE.PAUSED == vm.url.state;
        vm.title = PUB_URL_STATE.ACTIVE == vm.url.state ? 'Edit Information' : 'Re-Submit Edited URL Back to Us';
        vm.showRejectedReasons = PUB_URL_STATE.REJECTED == vm.url.state;
        vm.disable = PUB_URL_STATE.PAUSED == vm.url.state;
        vm.showPause = PUB_URL_STATE.REJECTED != vm.url.state;
        vm.currentPrice = vm.url.price;
      } else {
        vm.isNew = true;
        vm.title = 'Add New Domain';
        vm.showPause = false;
      }
    }

    function isNewDomain() {
      return vm.isNew;
    }

    function submit() {
      url.state = vm.pausedValue;
      $mdDialog.hide(vm.url);
    }

    // function checkURL(form) {
    //   var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    //   form.domainUrl.$setValidity('url', true);
    //   if (regex.test(vm.url.href)) {
    //     ProfilesService.getDomainInformation(vm.url.href, function (response) {
    //       vm.domInfo = response.data;
    //       if (vm.domInfo.disable_add || vm.domInfo.href_exists) {
    //         vm.showUrlDisabled = true;
    //       } else if (vm.domInfo.domain_authority < MIN_VALUES.DA) {
    //         vm.showUrlDisabled = false;
    //         vm.showMinValues = true;
    //         vm.suggestedPrice = '';
    //         vm.pricePlaceholder = 'Payout';
    //       } else {
    //         vm.showUrlDisabled = false
    //         vm.showMinValues = false;
    //         vm.da = vm.domInfo.domain_authority;
    //         vm.tf = vm.domInfo.trust_flow;

    //         PricesService.getPrice(vm.url.href, function (response) {
    //           vm.pricePlaceholder = 'Suggested Price: ' + response.data.suggested_price;
    //         }, function (error) {
    //           $log.error(error);
    //           vm.pricePlaceholder = 'Suggested Price: ';
    //         });
    //       }
    //     });
    //   } else {
    //     form.domainUrl.$setValidity('url', false);
    //   }
    // }

    function checkURL(form) {
      vm.showUrlDisabled = false;
      vm.showMinValues = false;
      vm.maxDomPrice = 999999999;
      vm.urlStatsRequestFailed = false;
      // form.domainUrl.$setValidity('unmatched', true);
      form.urlPrice.$setValidity('unmatched', true);
      form.domainUrl.$setValidity('duplicate', true);
      form.domainUrl.$setValidity('you-own', true);
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      form.domainUrl.$setValidity('url', true);
      if (regex.test(vm.url.href)) {
        ProfilesService.getDomainInformation(vm.url.href, function (response) {
          vm.domInfo = response.data;
          var getDomainInfoFailed = response.data.domain_authority === null;
          if(!vm.url.id && vm.domInfo.already_publisher_url) {
            form.domainUrl.$setValidity('you-own', false);
            return;
          }
          if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
          if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
          if (vm.domInfo.is_active) {
            vm.maxDomPrice = vm.domInfo.price_to_beat;
          }
          if (isNewDomain() && vm.domInfo.href_exists && !vm.domInfo.is_active) {
            form.domainUrl.$setValidity('duplicate', false);
          } else if (isNewDomain() && vm.domInfo.href_exists && vm.domInfo.is_active && vm.url.price && vm.url.price >= vm.domInfo.price_to_beat) {
            // form.domainUrl.$setValidity('unmatched', false);
            form.urlPrice.$setValidity('unmatched', false);
          } else if (getDomainInfoFailed) {
            vm.urlStatsRequestFailed = true;
          } else if (isNewDomain() && vm.domInfo.trust_flow < MIN_VALUES.TF ||
            vm.domInfo.domain_authority < MIN_VALUES.DA) {
              vm.showMinValues = true;
              vm.suggestedPrice = '';
              vm.pricePlaceholder = 'Payout';
          } else {
            vm.showUrlDisabled = false
            vm.showMinValues = false;
            vm.da = vm.domInfo.domain_authority;
            vm.tf = vm.domInfo.trust_flow;

            // suggested_price is included in the domain_information response;
            // skip the redundant /urls/suggested_price round trip.
            vm.pricePlaceholder = vm.domInfo.suggested_price
              ? 'Suggested Price: ' + vm.domInfo.suggested_price
              : 'Suggested Price: ';
          }
        });
      } else {
        form.domainUrl.$setValidity('url', false);
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function getDescriptionTitle(tooltip) {
      if (vm.url.description && !tooltip) {
        return 'Description';
      } else if (isContributor()) {
        return 'Description: Please tell us what you love to write about.' +
          ' This will enable us to pinpoint the most relevant opportunities for you. ' +
          'Also please indicate if you do Product Roundups, CEO quotes, and if you ' +
          'can link to the home page with a branded link.'
      }
    }

    function rejectedReasons() {
      return vm.url.rejected_reason;
    }

    function followLinkOptionIsSet(url) {
      return (url.follow_link === "true" || url.follow_link === "false" || url.follow_link === true || url.follow_link === false)
    }

    function setUrlRequiredLength(requiredLength) {
      switch(requiredLength) {
        case '1500-+':
        case '1250-1500':
        case '1000-1250':
          vm.url.required_length = requiredLength;
          break;

        default:
          vm.url.required_length = '750-1000'
      }
    }

    function setUrlAllowHomepage(allow) {
      vm.url.allow_home_page = allow ? 'true' : 'false';
      if(allow) vm.url.allow_blog_post = 'false';
      else vm.url.allow_blog_post = 'true';
    }

    function setUrlFollowLink(isDoFollow) {
      vm.url.follow_link = isDoFollow ? 'true' : 'false';
    }

    function setUrlAllowBlogPost(allow) {
      if (!isAllowHomepage()) {
        vm.url.allow_blog_post = allow ? 'true' : 'false';
      }
    }

    function isAllowHomepage() {
      if (vm.url.allow_home_page === true || vm.url.allow_home_page === 'true') return true;
      else return false;
    }
    function isNotAllowHomepage() {
      if (vm.url.allow_home_page === false || vm.url.allow_home_page === 'false') return true;
      else return false;
    }

    function isDoFollow() {
      if (vm.url.follow_link === true || vm.url.follow_link === 'true') return true;
      else return false;
    }
    function isNotDoFollow() {
      if (vm.url.follow_link === false || vm.url.follow_link === 'false') return true;
      else return false;
    }

    function isAllowBlogPost() {
      if (vm.url.allow_blog_post === true || vm.url.allow_blog_post === 'true') return true;
      else return false;
    }
    function isNotAllowBlogPost() {
      if (vm.url.allow_blog_post === false || vm.url.allow_blog_post === 'false') return true;
      else return false;
    }

    function getMetaDescription() {
      ProfilesService.getMetaDescription(vm.url.href, function (response) {
        vm.url.description = response.data.description;
      }, function (response) {
        toastr.error(response.data.error);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit.guest_post', [])
    .controller('EditGuestPostController', EditGuestPostController);

  /** @ngInject */
  function EditGuestPostController($state, $stateParams, $rootElement, $anchorScroll, $scope, $rootScope, $log, $location, $window, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, ProfilesService, RoutesService, PricingService, UrlsService, PROFILE_TYPE,
                                 PUB_URL_STATE, MIN_VALUES, HTTP_STATUS, ERRORS_RESPONSES, PricesService, EnvironmentConfig, UserService
  ) {
    var vm = this;
    vm.disableMetaButton = false;
    vm.profile = {};
    vm.copyProfile = {};
    vm.url = {
      description: '',
      href: '',
      price: '',
      author_page: '',
      addedFromGoogle: false
    };
    vm.showUrlPriceIcon = false;
    vm.urls = [];
    vm.csv;
    vm.search = false;
    vm.filtered = [];
    vm.filteredPausedStatus = [];
    vm.suggestedPrice = '';
    vm.pricePlaceholder = 'Payout';
    $rootScope.sampleDownloaded = false;
    vm.showProgressCircular = false;
    vm.showFormErrors = false;
    vm.state = "";
    vm.forceAdd = false;
    vm.hasChangedCategories = false;
    vm.categories = [];
    vm.hideCategories = true;
    vm.initialized = false;
    vm.maxDomPrice = 999999999;
    vm.priceHigherThanSuggested = false;
    vm.daAvgPrice = 0;
    vm.timesWarnedAboveDaAvg = 0;
    vm.user = {};

    // SEO price grid
    $scope.da;
    $scope.tf;
    $scope.close = function () {
      $mdDialog.cancel();
    };

    // Accessible functions
    vm.showPriceSEO = showPriceSEO;
    vm.isBlogger = isBlogger;
    vm.isContributor = isContributor;
    vm.showDialog = showDialog;
    vm.setUrlRequiredLength = setUrlRequiredLength;
    vm.setUrlAllowHomepage = setUrlAllowHomepage;
    vm.setUrlFollowLink = setUrlFollowLink;
    vm.setUrlAllowBlogPost = setUrlAllowBlogPost;
    vm.checkSEO = checkSEO;
    vm.addUrl = addUrl;
    vm.editDomain = editDomain;
    vm.setFollowValue = setFollowValue;
    vm.setPausedValue = setPausedValue;
    vm.pausedStateChanged = pausedStateChanged;
    vm.nonPausableUrl = nonPausableUrl;
    vm.getPricingLabel = getPricingLabel;
    vm.canEditDomainInfo = canEditDomainInfo;
    vm.displayPendingStateText = displayPendingStateText;
    vm.showUploadedFileDialog = showUploadedFileDialog;
    vm.checkURL = checkURL;
    vm.getPencilTooltip = getPencilTooltip;
    vm.saveHeaderChanges = saveHeaderChanges;
    vm.setContentType = setContentType;
    vm.saveSearchContent = saveSearchContent;
    vm.changeIcon = changeIcon;
    vm.getIconTooltip = getIconTooltip;
    vm.showRejectionReasons = showRejectionReasons;
    vm.isRejected = isRejected;
    vm.getPausedStatus = getPausedStatus;
    vm.isGuestPostCompleted = isGuestPostCompleted;
    vm.doForceAdd = doForceAdd;
    vm.validDomInfo = validDomInfo;
    vm.updateDomain = updateDomain;
    vm.goToDashboard = goToDashboard;
    vm.goToAddUrl = goToAddUrl;
    vm.goEditProfileSection = goEditProfileSection;
    vm.goEditProfile = goEditProfile;
    vm.showInfo = showInfo;
    vm.showCsvDialog = showCsvDialog;
    vm.sendFileToAdmin = sendFileToAdmin;
    vm.clearCsv = clearCsv;
    vm.toggleEditProfileBlock = toggleEditProfileBlock;
    vm.saveChanges = saveChanges;
    vm.isInitialized = isInitialized;
    vm.checkUrlV2 = checkUrlV2;
    vm.unmatchedErrorContent = unmatchedErrorContent;
    vm.getMetaDescription = getMetaDescription;

    init();

    function init() {
      if (angular.isDefined($stateParams.profile) || angular.isDefined($stateParams.profileId)) {
        if ($stateParams.profile) {
          vm.profile = $stateParams.profile;
          setProfileData()
        } else {
          if ($stateParams.profileId) {
            ProfilesService.showProfile($stateParams.profileId, function (response) {
              vm.profile = response.data;
              setProfileData()
            }, function () {
              $log.log('Error retrieving the profile.');
              toastr.error('There was an error retrieving the profile.');
            });
          } else {
            goToDashboard()
          }
        }
      }

      $scope.$mdMedia = $mdMedia;
    }

    function setProfileData() {
      if (!vm.profile.url) {
        if (isBlogger() && vm.profile.web_content && vm.profile.web_content.href) {
          vm.url.href = vm.profile.web_content.website_url;
          vm.url.addedFromGoogle = true
        }
      } else {
        vm.url = vm.profile.url;
        vm.url.addedFromGoogle = false
      }

      if (vm.url.href) {
        vm.url.canEdit = !isRejected(vm.url.state);
        checkURL();
      }

      vm.urls = vm.profile.urls;
      vm.filtered = vm.profile.urls;
      vm.filteredPausedStatus = vm.filtered.map(function (url) {
        return setPausedValue(url);
      });

      setcategories();

      angular.copy(vm.profile, vm.copyProfile);

      if (angular.isDefined($stateParams.forceAdd) && $stateParams.forceAdd) vm.forceAdd = true;

      vm.initialized = true;

      UserService.getUser(function (response) {
        vm.user = response.data.user;
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });

      // initialize to ghosted since we are no longer asking this question in the form
      if (vm.profile.contentType == null) vm.profile.contentType = "ghosted";

    }

    function setContentType(type, form) {
      form.$setDirty();
      vm.profile.contentType = type;
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function goToAddUrl() {
      RoutesService.editProfileSection('edit-profile-guest-post', vm.profile.id, vm.profile, true);
    }

    function goEditProfileSection(editSection) {
      RoutesService.editProfileSection(editSection, vm.profile.id, vm.profile);
    }

    function goEditProfile(shouldClear) {
      if (shouldClear) {
        confirmLeavePage();
      } else {
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }
    }

    function confirmLeavePage() {
      var confirmText = 'Are you sure you want to leave this page? All unsaved data will be lost.';
      var confirm = $mdDialog.confirm()
        .title('You are leaving the page.')
        .textContent(confirmText)
        .ok('Yes')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function (result) {
        vm.profile.contentType = '';
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }, function () {
      });
    }

    function getPencilTooltip(state) {
      switch (state) {
        case PUB_URL_STATE.REJECTED:
          return 'Make some changes and we\'ll approve this domain';
        case PUB_URL_STATE.CANCELLED:
          return 'We have rejected this domain. Sorry!';
        case PUB_URL_STATE.ACTIVE:
          return 'Url is live. Click here to edit.';
        case PUB_URL_STATE.PAUSED:
          return 'This URL is paused from search. Click here to change.';
        case PUB_URL_STATE.RESUBMITTED:
          return 'URL is Pending Approval by Admin';
        default:
          return 'URL is Pending Approval by Admin';
      }
    }

    function changeIcon(state) {
      switch (state) {
        case PUB_URL_STATE.PENDING:
          return 'hourglass_empty';
        case PUB_URL_STATE.RESUBMITTED:
          return 'hourglass_empty';
        case PUB_URL_STATE.REJECTED:
          return 'warning';
        case PUB_URL_STATE.ACTIVE:
          return 'check_circle';
        default:
          return 'help'
      }
    }

    function getIconTooltip(state) {
      switch (state) {
        case PUB_URL_STATE.PENDING:
          return 'Waiting on admin approval.';
        case PUB_URL_STATE.RESUBMITTED:
          return 'Waiting on admin approval.';
        case PUB_URL_STATE.ACTIVE:
          return 'Active product.';
        case PUB_URL_STATE.REJECTED:
          return 'Rejected product. Click to see why.';
        case PUB_URL_STATE.UNDER_REVIEW:
          return 'Waiting for admin approval.';
        default:
          return 'No tooltip found for this state.';
      }
    }

    function isRejected(state) {
      return state === PUB_URL_STATE.REJECTED;
    }

    function showRejectionReasons(product) {
      if (isRejected(product.state)) {
        $mdDialog.show({
          controller: 'NotesController',
          controllerAs: 'noteCtrl',
          templateUrl: 'app/pages/profiles/editProfile/notes/notes.html',
          clickOutsideToClose: false,
          escapeToClose: true,
          focusOnOpen: true,
          locals: {
            product: product
          }
        }).then(function (response) {
          product.canEdit = response.canEdit;
        });
      }
    }

    function saveHeaderChanges(form) {
      ProfilesService.updateProfile(vm.profile.id, {
        image: vm.profile.image,
        name: vm.profile.name
      }, function () {
        form.$setPristine();
        toastr.success('Profile\'s name/image successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this profile, please retry.');
      });
    }

    function updateProfile(form) {
      // Submit search content product
      ProfilesService.updateProfile(vm.profile.id, {
        urls: [{
          href: vm.url.href,
          price: vm.url.price,
          description: vm.url.description,
          follow_link: vm.url.follow_link,
          allow_blog_post: vm.url.allow_blog_post,
          allow_home_page: vm.url.allow_home_page,
          required_length: vm.url.required_length
        }]
      }, function () {
        form.$setPristine();
        ProfilesService.showProfile(vm.profile.id, function (response) {
          var data = response.data;
          vm.url = data.url;
          vm.urls = data.urls;
          vm.profile.url = data.url;
          vm.profile.urls = data.urls;
          if (vm.url) {
            vm.url.canEdit = !isRejected(vm.url.state);
          }
          goEditProfile();
        }, function () {
          toastr.error('There was an error updating this profile\'s social content, try to refresh the page.');
        });
        toastr.success('Profile\'s guest blog post successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this profile\'s content, please retry.');
      });
    }

    function showPriceAboveAvgForDaModal() {
      var avg_price = Intl.NumberFormat('en-US').format(vm.domInfo.avg_price_for_da);
      var percent_higher = Math.round(((vm.url.price / vm.domInfo.avg_price_for_da)) * 100);
      return showAlertHTML('Price Higher Than Average',
        '<div style="color:red;"><p>Hey ' + vm.user.first_name + ', our average price for a website with your authority ' +
        'metrix (what SEO marketers value) is $' + avg_price + '.</p>' +
        '<p>Your price is ' + percent_higher + '% higher than the average which means you are less likely to get any orders</p>' +
        '<p>Please try to match the average price if possible &amp; remember you will not have to email back and forth and ' +
        'negotiate a price on any new orders. The price you submit is what you will be paid for a guest post. ' +
        'We even take care of the PayPal fees for you!</p></div>', 'Ok').then(function (result) {
        return false;
      });
    }

    function saveSearchContent(form) {
      if (form.$error.pattern || form.$error.required) {
        vm.showFormErrors = true;
        return;
      }
      // Check if url is duplicated or rejected
      if (form.url.$dirty) {
        vm.showUrlDisabled = false;
        vm.showMinValues = false;
        vm.maxDomPrice = 999999999;
        form.url.$setValidity('unmatched', true);
        form.searchPrice.$setValidity('unmatched', true);
        form.url.$setValidity('duplicate', true);
        var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        form.url.$setValidity('url', true);
        if (regex.test(vm.url.href)) {
          ProfilesService.getDomainInformation(vm.url.href, function (response) {
            vm.domInfo = response.data;
            if (isBloggerOwner()) {
              // price checks for url submission when url is proven to be owned via
              // analytics validation. if blogger_max_price == 0 then we are assuming
              // no urls exist with a blogger price constraint
              if (vm.domInfo.blogger_max_price > 0 && vm.url.price > vm.domInfo.blogger_max_price) {
                form.url.$setValidity('unmatched', false);
                form.searchPrice.$setValidity('unmatched', false);
              } else {
                if (vm.url.price > vm.domInfo.avg_price_for_da && vm.timesWarnedAboveDaAvg === 0) {
                  vm.daAvgPrice = vm.domInfo.avg_price_for_da;
                  vm.priceHigherThanSuggested = true;
                  vm.timesWarnedAboveDaAvg++;
                  showPriceAboveAvgForDaModal();
                } else {
                  updateProfile(form);
                  updateDomain(form);
                }
              }
            } else {
              if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
              if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
              if (vm.domInfo.is_active) {
                vm.showFormErrors = true;
                vm.maxDomPrice = vm.domInfo.price_to_beat;
              }
              if (vm.domInfo.href_exists && !vm.domInfo.is_active) {
                vm.showFormErrors = true;
                form.url.$setValidity('duplicate', false);
              } else if (vm.domInfo.href_exists && vm.domInfo.is_active && vm.url.price && vm.url.price >= vm.domInfo.price_to_beat) {
                vm.showFormErrors = true;
                form.url.$setValidity('unmatched', false);
                form.searchPrice.$setValidity('unmatched', false);
              } else if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
                vm.domInfo.domain_authority < MIN_VALUES.DA) {
                showSEODialog();
              } else {
                if (vm.domInfo.disable_add) {
                  vm.showFormErrors = true;
                  form.url.$setValidity('url', false);
                } else {
                  updateProfile(form);
                  updateDomain(form);
                }
              }
            }
          });
        } else {
          form.url.$setValidity('url', false);
        }
      } else {
        if (isBloggerOwner()) {
          // price checks for url submission when url is proven to be owned via
          // analytics validation. if price_to_beat == 0 then we are assuming
          // no urls exist with a price to beat
          if (vm.domInfo.blogger_max_price > 0 && vm.url.price > vm.domInfo.blogger_max_price) {
            form.url.$setValidity('unmatched', false);
            form.searchPrice.$setValidity('unmatched', false);
          } else {
            if (vm.url.price > vm.domInfo.avg_price_for_da && vm.timesWarnedAboveDaAvg === 0) {
              vm.daAvgPrice = vm.domInfo.avg_price_for_da;
              vm.priceHigherThanSuggested = true;
              vm.timesWarnedAboveDaAvg++;
              showPriceAboveAvgForDaModal();
            } else {
              updateProfile(form);
              updateDomain(form);
            }
          }
        } else {
          updateProfile(form);
          updateDomain(form);
        }
      }
    }

    function isGuestPostCompleted() {
      return vm.url && vm.url.id && vm.url.href && vm.url.price;
    }

    function doForceAdd() {
      return vm.forceAdd;
    }

    function handleErrors(errors) {
      lodash.forEach(errors, function (error) {
        toastr.error(error[0]);
      });
    }

    function showSEODialog() {
      showAlert('Minimum Values', 'We apologize but we need a minimum MOZ Domain Authority ' +
        'score of 15. And a minimum of of Majestic Trust Flow score of 5 for ' +
        'you to participate in this product. You currently do not meet one, ' +
        'or both, of these criteria. When you do reach these targets, you can ' +
        'come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
        return false;
      });
    }

    function isBlogger() {
      return vm.profile.profile_type === PROFILE_TYPE.BLOGGER;
    }

    function isContributor() {
      return vm.profile.profile_type === PROFILE_TYPE.CONTRIBUTOR;
    }

    function checkUrlValidity(form) {
      form.url.$setValidity('active', true);
      form.url.$setValidity('unmatched', true);
      form.url.$setValidity('url', true);
      ProfilesService.checkUrl(vm.url.href, function (response) {
        var state = response.data.state;
        switch (state) {
          case "suspended":
            vm.state = "suspended";
            vm.showFormErrors = true;
            form.url.$setValidity('active', false);
            break;
          case "paused":
            vm.state = "paused";
            vm.showFormErrors = true;
            form.url.$setValidity('active', false);
            break;
          case "rejected":
            vm.state = "rejected";
            vm.showFormErrors = true;
            form.url.$setValidity('active', false);
            break;
          case "duplicated":
            vm.showFormErrors = true;
            form.url.$setValidity('unmatched', false);
            break;
          case "invalid":
            vm.showFormErrors = true;
            form.url.$setValidity('url', false);
            break;
          case "valid":
            vm.showFormErrors = false;
            getDomainInformation(form);
            break;
        }
      }, function (response) {
        toastr.error(response.data.error || 'Error checking domain url.');
      });
    }

    function checkSEO(form) {
      // Short-circuit if the href hasn't changed since the last successful
      // fetch. The domain field used to fire `checkSEO` on every keystroke
      // via ng-change; even after switching to ng-blur, tab/click cycles can
      // re-trigger this with the same value and would otherwise burn API
      // credits (or at least add cache-hit log rows) for no new info.
      if (vm.url.href && vm.url.href === vm.lastFetchedHref) {
        return;
      }
      var validRegex = testWithRegex(vm.url.href);
      if (validRegex) {
        vm.lastFetchedHref = vm.url.href;
        checkUrlValidity(form)
      } else {
        vm.showFormErrors = true;
        form.url.$setValidity('url', false);
      }
    }

    function checkUrlV2(form) {
      // Skip if blur fires repeatedly with the same href.
      if (vm.url.href && vm.url.href === vm.lastFetchedHref) {
        return;
      }
      vm.showUrlDisabled = false;
      vm.showMinValues = false;
      vm.priceHigherThanSuggested = false;
      vm.maxDomPrice = 999999999;
      form.url.$setValidity('unmatched', true);
      form.searchPrice.$setValidity('unmatched', true);
      form.url.$setValidity('duplicate', true);

      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      form.url.$setValidity('url', true);
      if (regex.test(vm.url.href)) {
        vm.lastFetchedHref = vm.url.href;
        ProfilesService.getDomainInformation(vm.url.href, function (response) {
          vm.domInfo = response.data;
          $scope.da = vm.domInfo.domain_authority;
          $scope.tf = vm.trust_flow;
          if (isBloggerOwner()) {
            // price checks for url submission when url is proven to be owned via
            // analytics validation. if blogger_max_price == 0 then we are assuming
            // no urls exist with a price to beat
            if (vm.domInfo.blogger_max_price > 0 && vm.url.price > vm.domInfo.blogger_max_price) {
              form.url.$setValidity('unmatched', false);
              form.searchPrice.$setValidity('unmatched', false);
            } else if (vm.url.price > vm.domInfo.avg_price_for_da) {
              vm.daAvgPrice = vm.domInfo.avg_price_for_da;
              vm.priceHigherThanSuggested = true;
            }
          } else {
            // standard price checks for url submission that is not proven to be owned via
            // analytics validation
            if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
            if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
            if (vm.domInfo.is_active) {
              vm.showFormErrors = true;
              vm.maxDomPrice = vm.domInfo.price_to_beat;
            }
            if (vm.domInfo.href_exists && !vm.domInfo.is_active) {
              vm.showFormErrors = true;
              form.url.$setValidity('duplicate', false);
            } else if (vm.domInfo.href_exists && vm.domInfo.is_active && vm.url.price && vm.url.price >= vm.domInfo.price_to_beat) {
              vm.showFormErrors = true;
              form.url.$setValidity('unmatched', false);
              form.searchPrice.$setValidity('unmatched', false);
            } else if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
              vm.domInfo.domain_authority < MIN_VALUES.DA) {
              showSEODialog();
            } else {
              if (vm.domInfo.disable_add) {
                vm.showFormErrors = true;
                form.url.$setValidity('url', false);
              } else {
                setPriceLabel();
              }
            }
          }
        });
      } else {
        form.url.$setValidity('url', false);
      }
    }

    function getDomainInformation(form) {
      // saveSearchContent fires this after the URL field passes regex; the
      // guard avoids re-firing when the publisher submits the same form
      // twice without changing the URL.
      if (vm.url.href && vm.url.href === vm.lastFetchedHref && vm.domInfo) {
        return;
      }
      vm.lastFetchedHref = vm.url.href;
      ProfilesService.getDomainInformation(vm.url.href, function (response) {
        vm.domInfo = response.data;
        if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
        if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
        if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
          vm.domInfo.domain_authority < MIN_VALUES.DA) {
          showSEODialog();
        } else {
          if (vm.domInfo.disable_add) {
            vm.showFormErrors = true;
            form.url.$setValidity('url', false);
          } else {
            setPriceLabel();
          }
        }
      });
    }

    function testWithRegex() {
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      return regex.test(vm.url.href);
    }

    function setPriceLabel() {
      if (validDomInfo()) {
        $rootScope.da = vm.domInfo.domain_authority;
        $rootScope.tf = vm.domInfo.trust_flow;
      }
    }

    function validDomInfo() {
      return vm.domInfo && vm.domInfo.trust_flow >= MIN_VALUES.TF && vm.domInfo.domain_authority >= MIN_VALUES.DA
    }

    function setUrlRequiredLength(requiredLength, form) {
      form.$setDirty();
      switch (requiredLength) {
        case '1500-+':
        case '1250-1500':
        case '1000-1250':
          vm.url.required_length = requiredLength;
          break;

        default:
          vm.url.required_length = '750-1000'
      }
    }

    function setUrlAllowHomepage(allow, form) {
      form.$setDirty();
      vm.url.allow_home_page = allow ? 'true' : 'false';
      if (allow) {
        vm.url.allow_blog_post = 'false';
      } else {
        vm.url.allow_blog_post = 'true';
      }
    }

    function setUrlFollowLink(isDoFollow, form) {
      form.$setDirty();
      vm.url.follow_link = isDoFollow ? 'true' : 'false';
    }

    function setUrlAllowBlogPost(allow, form) {
      form.$setDirty();
      vm.url.allow_blog_post = allow ? 'true' : 'false';
    }

    function showPriceSEO() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/partials/gridDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'EditProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function showUploadedFileDialog() {
      return showAlertHTML('Spreadsheet uploaded', 'Thank you for uploading these domains. ' +
        'Our admin department will review them one at a time and you will receive notifications ' +
        'when they are either approved or rejected.', 'Got it!').then(function (result) {
        return false;
      });
    }

    function contributorOnlyPopup() {
      $mdDialog.show(
        $mdDialog.alert()
          .title('ADDING NEW URL')
          .textContent('To make sure each URL is relevant, simply create a NEW Profile for the next URL. Please click OK to be taken back to the dashboard. Then click "Create New Profile" to get started.')
          .escapeToClose(false)
          .ok("OK")
      ).then(function() {
        goToDashboard();
      });
    }

    function addUrl(ev, url) {
      // if (isBlogger()) contributorOnlyPopup();
      // else editDomain(ev, url);
      editDomain(ev, url);
    }

    function editDomain(ev, url) {
      var copiedUrl = {};
      var canEdit = true;
      if (url) {
        angular.copy(url, copiedUrl);

        if (url.state == PUB_URL_STATE.PENDING) {
          canEdit = false;
          showAlert('Pending approval', 'This URL is pending approval by our Admin team. ' +
            'You cannot edit it until we approve it.', 'Got it');
        } else if (url.state == PUB_URL_STATE.REJECTED) {
          canEdit = false;
          showAlertHTML('Rejected URL', 'Here are the changes we need to accept this ' +
            'domain into our marketplace. ' +
            '<br><br> <span class="bold-uppercase">' + url.rejected_reason + '</span>', 'Ok, Go to edit').then(function () {
            showEditInfoDialog(copiedUrl, url);
          });
        } else if (url.state == PUB_URL_STATE.CANCELLED) {
          canEdit = false;
          showAlert('Cancelled URL', 'After going through our Quality Assessment tests; ' +
            'this domain has been permanently rejected. We apologize for the inconvenience.', 'Got it');
        } else if (url.state == PUB_URL_STATE.UNDER_REVIEW) {
          canEdit = false;
          showAlert('Pending approval', 'This URL is pending price approval by our Admin team. ' +
            'You cannot edit it until we re approve it.', 'Got it');
        }
      }
      if (canEdit) {
        showEditInfoDialog(copiedUrl, url, null);
      }
    }

    function showEditInfoDialog(copiedUrl, url) {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/editProfile/editModalInfo/editInfoDialog.html',
        controller: 'EditInfoDialogController',
        controllerAs: 'editInfoCtrl',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          url: copiedUrl,
          isContributor: isContributor()
        }
      }).then(function (response) {
        if (url) {
          ProfilesService.updateUrl(vm.profile.id, {
            id: response.id,
            href: response.href,
            follow_link: response.follow_link,
            price: response.price,
            description: response.description,
            pause: response.state,
            required_length: response.required_length,
            allow_home_page: response.allow_home_page,
            allow_blog_post: response.allow_blog_post
          }, function () {
            refreshUrls();
          }, function () {
            $log.error('error');
          })
        } else {
          ProfilesService.updateProfile(vm.profile.id, {
            urls: [{
              href: response.href,
              follow_link: response.follow_link,
              allow_blog_post: response.allow_blog_post,
              allow_home_page: response.allow_home_page,
              required_length: response.required_length,
              price: response.price,
              description: response.description
            }]
          }, function () {
            refreshUrls();
          }, function () {
            $log.error('error');
          })
        }
      });
    }

    function refreshUrls() {
      ProfilesService.indexUrls(vm.profile.id, function (response) {
        vm.urls = response.data.urls;
      }, function () {
        $log.error('error');
      });
    }

    function setDataToUrl(urlX, newUrl) {
      urlX.follow_link = newUrl.follow_link;
      urlX.href = newUrl.href;
      urlX.description = newUrl.description;
      urlX.state = newUrl.state;
      urlX.price = newUrl.price;
    }

    function setFollowValue(url) {
      return url.follow_link ? 'Do-Follow Link' : 'No-Follow Link';
    }

    function setPausedValue(url) {
      return {id: url.id, paused: url.state === PUB_URL_STATE.PAUSED};
    }

    function pausedStateChanged(url, pos) {
      url.paused = updatePausedStatus(url);

      UrlsService.updateUrl(url, function (response) {
        var message = url.paused ? 'paused' : 'unpaused';
        toastr.success('Your URL was ' + message)
      }, function (error) {
        updatePausedStatus(url);
        toastr.error(response.error);
      });
    }

    function getPausedStatus(url) {
      var filteredObj = lodash.find(vm.filteredPausedStatus, function (filteredObj) {
        return filteredObj.id === url.id;
      });

      return filteredObj ? filteredObj.paused : false;
    }

    function updatePausedStatus(url) {
      var filteredObj = lodash.find(vm.filteredPausedStatus, function (filteredObj) {
        return filteredObj.id === url.id;
      });

      if (filteredObj) {
        filteredObj.paused = !filteredObj.paused;
      }

      return filteredObj ? filteredObj.paused : false;
    }

    function nonPausableUrl(url) {
      return url.state !== PUB_URL_STATE.ACTIVE && url.state !== PUB_URL_STATE.PAUSED;
    }


    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Your price per post (USD):';
    }

    function checkURL() {
      ProfilesService.getDomainInformation(vm.url.href, function (response) {
        vm.domInfo = response.data;
        if (vm.domInfo.trust_flow < MIN_VALUES.TF ||
          vm.domInfo.domain_authority < MIN_VALUES.DA) {
          vm.showMinValues = true;
          vm.suggestedPrice = '';
          vm.pricePlaceholder = 'Payout';
        } else {
          vm.showMinValues = false;
          vm.da = vm.domInfo.domain_authority;
          vm.tf = vm.domInfo.trust_flow;
          $scope.da = vm.da;
          $scope.tf = vm.tf;
          // suggested_price is now part of the domain_information response so
          // we don't have to hit /urls/suggested_price (which routes through
          // SocialsService and burns more API credits on cache misses).
          vm.pricePlaceholder = vm.domInfo.suggested_price
            ? 'Suggested Price: ' + vm.domInfo.suggested_price
            : 'Suggested Price: ';
        }
      });
    }

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function canEditDomainInfo() {
      return !lodash.includes([PUB_URL_STATE.PENDING, PUB_URL_STATE.RESUBMITTED, PUB_URL_STATE.PAUSED], vm.url.state) && vm.url.canEdit;
    }

    function displayPendingStateText() {
      switch (vm.url.state) {
        case PUB_URL_STATE.PAUSED:
          return 'You must unpause this URL first, before changing anything.'
        default:
          return 'Admin must approve your submission before you can edit';
      }
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function updateDomain(form) {
      form.url.$setValidity('active', true);
      form.url.$setValidity('unmatched', true);
    }

    function showInfo() {
      return showAlertHTML('Search Content (SEO)', "This product is for SEO firms. " +
        "You are accepting content that is 'natural and organic'. It is NOT a sales pitch. " +
        "Content will NOT be disclosed as paid. YOU ARE NOT recommending a product or service " +
        "to purchase per FTC guidelines. And links will be do-follow to help clients out with ranking higher.", 'Ok').then(function (result) {
        return false;
      });
    }

    function showCsvDialog() {
      $mdDialog.show({
        controller: 'CsvModalController',
        controllerAs: 'csvModalCtrl',
        templateUrl: 'app/pages/profiles/editProfile/csvModal/csvModal.html',
        clickOutsideToClose: true,
        locals: {
          isContributor: isContributor()
        }
      }).then(function (uploadedFile) {
        vm.csv = uploadedFile;
      });
    }

    function sendFileToAdmin() {
      ProfilesService.updateSpreadsheetProfile(vm.profile.id, vm.profile.profile_type, vm.csv, function (response) {
        refreshUrls();
        if (response.data && response.data.errors[0] == ERRORS_RESPONSES.ALREADY_TAKEN) {
          showSomeUrlsDuplicatedDialog();
        } else if (response.data && response.data.errors[0] == ERRORS_RESPONSES.INVALID) {
          showBadUrlDialog();
        } else {
          showUploadedFileDialog();
        }
        clearCsv();
      }, function (response) {
        if (response.status == HTTP_STATUS.BAD_REQUEST) {
          if (response.data.error == ERRORS_RESPONSES.ALREADY_TAKEN) {
            showDuplicateDialog();
          } else if (response.data.error == ERRORS_RESPONSES.INVALID) {
            showBadUrlDialog();
          } else {
            toastr.error(response.data.error);
          }
          clearCsv();
        }
      });
    }

    function showSomeUrlsDuplicatedDialog() {
      showAlertHTML('Some Duplicated Urls', 'Some Urls are already in out DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showDuplicateDialog() {
      return showAlertHTML('Duplicate Url', 'This URL is already in our DB.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function showBadUrlDialog() {
      return showAlertHTML('Bad Url format', 'Please take a look at your file, some urls are not correct.' +
        " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
        return false;
      });
    }

    function clearCsv() {
      vm.csv = null;
    }

    function toggleEditProfileBlock(block, hasChanged, hideBlock) {
      if( hasChanged && !hideBlock) {
        showConfirmToggleModal(block)
      }

      switch (block) {
        case 'categories':
          vm.hideCategories = !vm.hideCategories;
          break;
        case 'audienceDemographics':
          vm.hideAudienceDemographics = !vm.hideAudienceDemographics;
          break;
        case 'webContent':
          vm.hideWebContent = !vm.hideWebContent;
          break;
        case 'domainInformation':
          vm.hideDomainInfo = !vm.hideDomainInfo;
          break;
        case 'facebook':
          vm.hideFacebook = !vm.hideFacebook;
          break;
        case 'instagram':
          vm.hideInstagram = !vm.hideInstagram;
          break;
        case 'youtube':
          vm.hideYoutube = !vm.hideYoutube;
          break;
        case 'twitter':
          vm.hideTwitter = !vm.hideTwitter;
      }
    }

    function showConfirmToggleModal(block) {
      var confirm = $mdDialog.confirm()
        .textContent('Do you want to save changes?')
        .cancel('No')
        .ok('Yes');

      $mdDialog.show(confirm).then(function (result) {
        switch (block) {
          case 'categories':
            saveChanges('categories');
            break;
          case 'audienceDemographics':
            saveChanges('audienceDemographics');
            break;
          case 'domainInformation':
            saveSearchContent(vm.domainInformationForm);
            break;
          default:
            console.log('default');
            break;
        }

      }, function () {
      });
    }

    function saveChanges(type) {
      ProfilesService.updateProfile(vm.profile.id, {
        categories_ids: lodash.map(vm.categories, 'id')
      }, function () {
        vm.hasChangedCategories = false;
        vm.hideCategories = true;
        toastr.success( capitalizeFirstLetter(type.replace(/([a-z0-9])([A-Z])/g, '$1 $2')) + ' successfully updated.')
      }, function () {
        toastr.error('There was an error updating ' + type.split('_').join(' ') + ', please retry.');
      });
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function setcategories() {
      vm.categories = vm.profile.categories;
      vm.categories.forEach(function(category) {
        category.displayName = category.name;
      });
    }

    function isInitialized() {
      return vm.initialized;
    }

    function unmatchedErrorContent() {
      if (isBloggerOwner()) {
        return "Someone has submitted your site already for a lower price. While we have suspended that account for doing so, we'd like you to email us for current pricing for guest posts. Email admin@scalefluence.com please";
      } else {
        return 'Someone has already submitted this site for significantly less.';
      }
    }

    function isBloggerOwner() {
      return isBlogger() && vm.profile.web_content && vm.profile.web_content.href;
    }

    function getMetaDescription() {
      ProfilesService.getMetaDescription(vm.url.href, function (response) {
        vm.url.description = response.data.description;
      }, function (response) {
        toastr.error(response.data.error);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit.audience', [])
    .controller('EditAudienceController', EditAudienceController);

  /** @ngInject */
  function EditAudienceController($state, $stateParams, $anchorScroll, $scope, $log, $mdDialog, $mdEditDialog,
                                 $mdMedia, toastr, lodash, ProfilesService, RoutesService, PROFILE_TYPE,
                                 NEW_PROFILE, UserTourService, $timeout
  ) {
    var vm = this;

    // Accessible attributes
    vm.showCategories = false;
    vm.profile = {};
    vm.copyProfile = {};
    vm.categories = [];
    vm.ethnicitiesList = NEW_PROFILE.ETNIC_GROUPS;
    vm.audienceGenderList = NEW_PROFILE.GENDER_LIST;
    vm.audienceEstimatedIncomes = NEW_PROFILE.AUDIENCE_ESTIMATED_INCOMES;
    vm.languagesList = NEW_PROFILE.LANGUAGES_LIST;
    vm.ageGroupList = NEW_PROFILE.AGE_GROUPS;
    vm.petsList = NEW_PROFILE.PETS_LIST;

    vm.hasChangedCategories = false;
    vm.hasChangedLanguages = false;
    vm.hasChangedPets = false;
    vm.hasChangedAudienceEthnicities = false;
    vm.hasChangedAudienceAge = false;
    vm.hasChangedAudienceIncome =false;
    vm.hasChangedAudienceGender = false;
    vm.saveWarningShown = false;

    vm.categoriesChanged = categoriesChanged;
    vm.audienceAgeChanged = audienceAgeChanged;
    vm.ethnicitiesChanged = ethnicitiesChanged;
    vm.languagesChanged = languagesChanged;
    vm.petsChanged = petsChanged;
    vm.saveAudienceChanges = saveAudienceChanges;

    vm.goToDashboard = goToDashboard;
    vm.goEditProfileSection = goEditProfileSection;
    vm.goEditProfile = goEditProfile;

    vm.selectedEstimatedIncome = selectedEstimatedIncome;
    vm.selectedAudienceGender = selectedAudienceGender;

    init();

    function init() {
      if (angular.isDefined($stateParams.profile) || angular.isDefined($stateParams.profileId)) {
        if ($stateParams.profile) {
          vm.profile = $stateParams.profile;
          setCategories();
          // handlePubTour();
        } else {
          if ($stateParams.profileId) {
            ProfilesService.showProfile($stateParams.profileId, function (response) {
              vm.profile = response.data;
              setCategories();
              // handlePubTour();
            }, function () {
              $log.log('Error retrieving the profile.');
              toastr.error('There was an error retrieving the profile.');
            });
          } else {
            goToDashboard()
          }
        }
      }
      angular.copy(vm.profile, vm.copyProfile);
      $scope.$mdMedia = $mdMedia;
    }

    function categoriesChanged() {}
    function audienceAgeChanged() {}
    function ethnicitiesChanged() {}
    function languagesChanged() {}
    function petsChanged() {}

    function handlePubTour() {
      if (true || UserTourService.currentName() == 'pub_welcome_phase_5' || UserTourService.currentName() == 'pub_welcome_phase_6') {
        $timeout(function() { UserTourService.startPubWelcomeTourPhase6(); }, 1000);
      }
    }

    function setCategories() {
      vm.categories = vm.profile.categories;
      vm.categories.forEach(function (category) {
        category.displayName = category.name;
      });
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function goEditProfileSection(editSection) {
      RoutesService.editProfileSection(editSection, vm.profile.id, vm.profile);
    }

    function goEditProfile(shouldClear) {
      if (shouldClear && anyAudienceBlockChanged()) {
        confirmLeavePage();
      } else {
        RoutesService.editProfile(vm.profile.id, vm.profile);
      }
    }

    function confirmLeavePage() {
      var confirmText = 'Are you sure you want to leave this page? All unsaved data will be lost.';
      var confirm = $mdDialog.confirm()
        .title('You are leaving the page.')
        .textContent(confirmText)
        .ok('Yes')
        .cancel('Cancel');


      $mdDialog.show(confirm).then(function (result) {
        RoutesService.editProfile(vm.profile.id, vm.copyProfile);
      }, function () {
      });
    }

    function saveAudienceChanges(ev) {
      if (!vm.categories.length) {
        vm.showFormErrors = true;
        toastr.error('Please select at least one category.');
        $anchorScroll('categories-data');
        return
      }
      confirmAudienceSave(ev);
    }

    function confirmAudienceSave(ev) {
      if (isAudienceInfoCompleted()) {
        updateAudienceData()
      } else {
        var confirm;
        if (isAudienceInfoCompletedPartially()) {
          confirm = $mdDialog.confirm()
            .title('IMPORTANT!')
            .textContent("It’s better to give fuller information about your audience in order to get more offers")
            .targetEvent(ev)
            .ok('I understand')
            .cancel('I want to skip this');
        } else {
          confirm = $mdDialog.confirm()
            .title('IMPORTANT!')
            .textContent("It's important to give information about your audience.")
            .targetEvent(ev)
            .ok('I understand')
            .cancel('I want to skip this');
        }
        if (vm.saveWarningShown) {
          updateAudienceData();
        } else {
          $mdDialog.show(confirm).then(function (result) {
            vm.saveWarningShown = true;
            vm.showFormErrors = true;
            goAudienceBlock();
          }, function () {
            updateAudienceData();
          });
        }
      }
    }

    function updateAudienceData() {
      vm.newProfileAudience = {
        categories_ids: lodash.map(vm.categories, 'id'),
        audience_age_groups: vm.profile.audience_age_groups,
        audience_ethnicities: vm.profile.audience_ethnicities,
        pets: vm.profile.pets,
        languages: vm.profile.languages,
        audience_gender: vm.profile.audience_gender,
        audience_estimated_income: vm.profile.audience_estimated_income
      };
      ProfilesService.updateProfile(vm.profile.id, vm.newProfileAudience, function () {
        toastr.success('Audience successfully updated.');
        goEditProfile(false)
      }, function () {
        toastr.error('There was an error updating audience, please retry.');
      });
    }


    function goAudienceBlock() {
      $anchorScroll('audience-data');
    }

    function isAudienceInfoCompleted() {
      if (!!vm.profile.categories) {
        return vm.profile.categories.length && vm.profile.audience_gender && vm.profile.audience_estimated_income &&
          vm.profile.audience_ethnicities.length && vm.profile.audience_age_groups.length &&
          vm.profile.pets.length && vm.profile.languages.length
      } else {
        return false
      }
    }

    function isAudienceInfoCompletedPartially() {
      if (!!vm.profile.categories) {
        return vm.profile.categories.length && (vm.profile.audience_gender || vm.profile.audience_estimated_income ||
          vm.profile.audience_ethnicities.length || vm.profile.audience_age_groups.length ||
          vm.profile.pets.length || vm.profile.languages.length)
      } else {
        return false
      }

    }

    function selectedEstimatedIncome() {
      return vm.profile.audience_estimated_income && vm.profile.audience_estimated_income !== 'null';
    }

    function selectedAudienceGender() {
      return vm.profile.audience_gender && vm.profile.audience_gender !== 'null';
    }

    function anyAudienceBlockChanged() {
      return vm.hasChangedCategories || vm.hasChangedPets || vm.hasChangedAudienceAge ||
      vm.hasChangedAudienceEthnicities || vm.hasChangedLanguages ||
      vm.hasChangedAudienceIncome || vm.hasChangedAudienceGender
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.edit')
    .controller('CsvModalController', CsvModalController);

  /** @ngInject */
  function CsvModalController($state, $log, $mdDialog, $rootScope, Assets, isContributor) {
    var vm = this;
    vm.isContributor = isContributor;

    //Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.download = download;
    vm.getPrice = getPrice;
    vm.getFileRoute = getFileRoute;

    function submit() {
      $mdDialog.hide(vm.csv);
    }

    function clearCsv() {
      vm.csv = null;
    }

    function download() {
      $rootScope.sampleDownloaded = true;
    }

    function getPrice() {
      return vm.isContributor ? '200' : '130';
    }

    function getFileRoute() {
      return  vm.isContributor ? Assets + 'contributor_example.xlsx' : Assets + 'broker_example.xlsx';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.campaign.edit', [])
    .controller('EditCampaignController', EditCampaignController);

  /* @ngInject */
  function EditCampaignController($log, $stateParams, $mdDialog, $scope, $rootScope, $anchorScroll, lodash, toastr,
    RoutesService, CampaignsService, LinksService, PAGINATION_SIZE, REGEX, EnvironmentConfig, AccountService) {
    var vm = this;

    //Accesible Variables
    vm.showCategories = false;
    vm.links = [];
    vm.query = {
      filter: '',
      order: '-href',
      limit: 20,
      page: 1
    };
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;
    vm.csv;
    vm.spreadsheetError = false;
    $rootScope.sampleSpreadsheet = false;
    vm.hasChanged = false;
    vm.categories = [];
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalItems = 0;
    vm.teammates = [];
    vm.managers = [];
    vm.advertiser;

    initialize();

    // Functions
    vm.save = save;
    vm.cancel = cancel;
    vm.destroy = destroy;
    vm.removeFilter = removeFilter;
    vm.addDomain = addDomain;
    vm.showXlsIcon = showXlsIcon;
    vm.showSearchIcon = showSearchIcon;
    vm.clearCsv = clearCsv;
    vm.showCsvDialog = showCsvDialog;
    vm.sendFileToAdmin = sendFileToAdmin;
    vm.saveHeaderChanges = saveHeaderChanges;
    vm.categoriesChanged = categoriesChanged;
    vm.saveCategories = saveCategories;
    vm.categoriesNames = categoriesNames;
    vm.deleteLink = deleteLink;
    vm.canOpenRow = canOpenRow;
    vm.goTop = goTop;
    vm.retrieveMoreLinks = retrieveMoreLinks;
    vm.getLinkUrls = getLinkUrls;
    vm.isReportNull = isReportNull;
    vm.linkNotRefounded = linkNotRefounded;
    vm.addHttpIfMissing = addHttpIfMissing;
    vm.togglePanel = togglePanel;
    vm.showNoReportAlert = showNoReportAlert;
    vm.showLiveLink = showLiveLink;

    function initialize() {
      getCampaignData(vm.currentPage);
      // loadTeammates() is called within getCampaignData success
    }

    // make sure vm.campaign is loaded first so existing manager of
    // campaign can be set
    function loadTeammates() {
      AccountService.getAdvWithTeammates(function(response) {
        vm.advertiser = response.data.advertiser;
        // if is master advertiser (does not have parent advertiser_id)
        // then setup manager info
        if (vm.advertiser.parent_id === null) {
          vm.teammates = [];
          for (var i = 0; i < response.data.advertisers.length; i++) {
            var t = response.data.advertisers[i];
            for (var j = 0; j < t.roles.length; j++) {
              if (t.roles[j].name === 'manage_campaigns') {
                vm.teammates.push(t);
                break;
              }
            }
          }
          setManagerIfExists();
        }
      }, function() {
        console.log('failed to load teammates');
      });
    }

    function setManagerIfExists() {
      vm.managers = [];
      for (var i = 0; i < vm.teammates.length; i++) {
        for (var j = 0; angular.isDefined(vm.teammates[i].roles) && j < vm.teammates[i].roles.length; j++) {
          var role = vm.teammates[i].roles[j]
          if (role.name === 'manager' && role.resource_id === vm.campaign.id && role.resource_type === 'Campaign') {
            vm.managers.push(vm.teammates[i]);
            break;
          }
        }
      }
      
      // If no managers found and user is admin, set default
      // if (vm.managers.length === 0 && vm.advertiser.parent_id === null) {
      //   vm.managers = [{
      //     id: 0,
      //     email: vm.advertiser.email
      //   }];
      // }
    }

    function setTeammateManageCampaign(teammate_id) {
      AccountService.setAdvTeammateManageCampaign(teammate_id, vm.campaign.id, function(response) {
        toastr.success('Manager successfully set.');
      }, function() {
        toastr.error('There was a problem setting the manager. Please retry or contact support.');
      });
    }

    function removeManagersFromCampaign() {
      AccountService.removeAdvTeammatesManageCampaign(vm.campaign.id, function(response) {
        toastr.success('Managers successfully removed.');
      }, function() {
        toastr.error('There was a problem removing the teammate manager. Please retry or contact support.');
      });
    }

    function save() {
      if (vm.csv) {
        vm.spreadsheetError = true;
      } else {
        CampaignsService.updateCampaign(vm.campaign.id, vm.campaign, function () {
            toastr.success('Campaign successfuly updated.');
            RoutesService.dashboard();
          },
          function () {
            toastr.error('Error');
          });
      }
    }

    function cancel() {
      RoutesService.dashboard();
    }

    function destroy() {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete this campaign?')
        .textContent('This campaign will be removed permanently.')
        .ariaLabel('Removing campaign')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        CampaignsService.deleteCampaign(vm.campaign.id, function () {
          toastr.success('Campaign was removed successfuly.');
          RoutesService.dashboard();
        }, function () {
          $log.error('Error deleting campaign.');
          toastr.error('There was an error deleting campaign.');
        });
      });
    }

    function removeFilter() {
      vm.search = false;
      vm.query.filter = '';
    }

    $scope.$watch('editCampCtrl.query.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.query.page;
      }

      if (newValue !== oldValue) {
        vm.query.page = 1;
      }

      if (!newValue) {
        vm.query.page = bookmark;
      }

      if (newValue == '') {
        vm.query.page = 1;
      }
    });

    function addDomain() {
      $mdDialog.show({
        templateUrl: 'app/pages/campaigns/editCampaign/newUrlModal/newUrlModal.html',
        controller: 'NewUrlModalController',
        controllerAs: 'newUrlCtrl',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          url: ''
        }
      }).then(function (url) {
        if (url) {
          CampaignsService.addUrl(vm.campaign.id, url, function () {
            CampaignsService.indexLinks(vm.campaign.id, function (response) {
              vm.links = response.data.links;
              toastr.success('Url was added successfuly.');
            }, function () {
              toastr.error('Cannot retrieve Urls. Please try again.');
            });
          }, function (response) {
            if (response.data.errors.href[0] === 'has already been taken') {
              return showAlertHTML('Duplicate Url', 'This URL is already in our DB.' +
                " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
                return false;
              });
            } else if (response.data.errors.href[0] === 'is an invalid URL') {
              toastr.error('Invalid URL. Cannot add Url. Please try again.');
            } else {
              toastr.error('Cannot add Url. Please try again.');
            }
          });
        }
      });
    }

    function categoriesChanged() {
      //TODO: Trigger when categories are changed to be completed.
    }

    function showXlsIcon() {
      return 'assets/images/xlsUpload.svg';
    }

    function showSearchIcon() {
      return 'assets/images/search_icon.svg';
    }

    function sendFileToAdmin() {
      CampaignsService.updateSpreadsheetCampaign(vm.campaign.id, vm.csv, function (response) {
        CampaignsService.indexLinks(vm.campaign.id, function (response) {
          showUploadedFileDialog();
          clearCsv();
          vm.links = response.data.links;
          toastr.success('Urls were added successfuly.');
        }, function () {
          toastr.error('Cannot retrieve Urls. Please try again.');
        });
      }, function (response) {
        var errors = response.data.errors;
        if (errors.href[0] === 'has already been taken') {
          return showAlertHTML('Duplicate Url', 'There are URL already in our DB.' +
            " Please click 'Contact Us' if you feel this is an error.", 'Got it!').then(function (result) {
            return false;
          });
        } else if (errors.href[0] === 'is an invalid URL') {
          toastr.error('Invalid URL. Cannot upload spreadsheet. Please try again.');
        } else {
          toastr.error('Cannot upload spreadsheet. Please try again.');
        }
      });
    }

    function showUploadedFileDialog() {
      return showAlertHTML('Spreadsheet uploaded', 'Thank you for uploading these domains. ' +
        'Our admin department will review them one at a time and you will receive notifications ' +
        'when they are either approved or rejected.', 'Got it!').then(function (result) {
        return false;
      });
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function showCsvDialog() {
      $mdDialog.show({
        controller: 'UrlUploadController',
        controllerAs: 'urlUploadCtrl',
        templateUrl: 'app/pages/campaigns/editCampaign/urlsUpload/urlUpload.html',
        clickOutsideToClose: true
      }).then(function (uploadedFile) {
        if (angular.isDefined(uploadedFile)) {
          vm.csv = uploadedFile;
          sendFileToAdmin();
        }
      });
    }

    function clearCsv() {
      vm.csv = null;
    }

    function saveHeaderChanges(form) {
      if (vm.managers && vm.managers.length > 0 && !vm.managers.some(function(m) { return m.id === 0; })) {
        var managerIds = vm.managers.map(function(m) { return m.id; });
        AccountService.setAdvTeammatesManagersOfCampaign(managerIds, vm.campaign.id, function(response) {
          toastr.success('Managers successfully set.');
        }, function() {
          toastr.error('There was a problem setting the managers. Please retry or contact support.');
        });
      } else if (vm.advertiser.parent_id === null) {
        // if is admin advertiser only
        removeManagersFromCampaign();
      }
      
      CampaignsService.updateCampaignHeader(vm.campaign.id, {
        image: vm.campaign.image,
        name: vm.campaign.name
      }, function () {
        form.$setPristine();
        toastr.success('Campaign\'s name/image successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this campaign, please retry.');
      });
    }

    function saveCategories() {
      vm.newCampaign = {
        categories_ids: lodash.map(vm.categories, 'id')
      }
      CampaignsService.updateCampaignCategories(vm.campaign.id, vm.newCampaign, function () {
        vm.hasChanged = false;
        toastr.success('Campaign\'s categories successfuly updated.');
      }, function () {
        toastr.error('There was an error updating this campaign\'s categories, please retry.');
      });
    }

    function categoriesNames() {
      return lodash.map(vm.categories, 'name');
    }

    function deleteLink(link) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent("You will delete " + link.href)
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function (result) {
        LinksService.deleteLink(link.id, function () {
            lodash.remove(vm.links, function (campaignLinks) {
              return campaignLinks.id === link.id;
            });
            toastr.success('URL was removed successfuly.');
          },
          function () {
            $log.error('Error deleting url.');
            toastr.error('There was an error deleting URL.');
          });
      });
    }

    function canOpenRow(link) {
      return link.urls.length === 0;
    }

    function goTop() {
      $anchorScroll('top');
    }

    function retrieveMoreLinks(newPage) {
      vm.currentPage = newPage;
      getCampaignData(vm.currentPage);
    }

    function getCampaignData(page) {
      CampaignsService.showCampaignWithActiveAdLinks($stateParams.campaignId, page, function (response) {
          var data = response.data;
          vm.totalPages = data.pages;
          vm.totalItems = data.results;
          vm.campaign = data;
          vm.links = data.links;
          vm.categories = data.categories;
          CampaignsService.getCampaignNames(function (response) {
            vm.campaignNames = data.campaign_names;
            lodash.remove(vm.campaignNames, function (name) {
              return vm.campaign.name === name;
            });
          });
          loadTeammates();
        },
        function (response) {
          if (response.status === 403) {
            toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
            RoutesService.dashboard();
          } else {
            $log.log('Error retrieving the campaign.');
            toastr.error('There was an error retrieving the campaign.');
          }
        });
    }

    function getLinkUrls(mainLink) {
      var indexOfLink = lodash.findIndex(vm.links, function (link) {
        return link.id === mainLink.id;
      });
      var linksOrdered = vm.links[indexOfLink];
      if (angular.isUndefined(linksOrdered.orders_built)) {
        LinksService.getActiveLinks(mainLink.id, function (response) {
          linksOrdered.orders_built = response.data.active_orders_built;
        });
      }
    }

    function isReportNull() {
      return !vm.campaign || !vm.campaign.campaign_report;
    }

    function linkNotRefounded(str) {
      var pattern = new RegExp(REGEX.URL);
      return pattern.test(str);
    }

    function addHttpIfMissing(str) {
      if (str.toLowerCase().startsWith('http')) return str;
      else return 'http://' + str;
    }

    function togglePanel(link) {
      link.isOpen = !link.isOpen;
      if(link.isOpen) getLinkUrls(link);
    }

    function showNoReportAlert() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('No Report')
        .textContent("You have not purchased any content for this campaign. There is no report to generate.")
        .ariaLabel('No Report')
        .ok('Got it!')
      );
    }

    function showLiveLink(link) {
      return link.state !== 'rejected_by_admin'
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.campaign.edit')
    .controller('NewUrlModalController', NewUrlModalController);

  /** @ngInject */
  function NewUrlModalController($mdDialog, $rootScope, CampaignsService, MIN_VALUES,
    PUB_URL_STATE, PricesService, url) {

    var vm = this;
    vm.url = {};

    //functions
    vm.checkURL = checkURL;
    vm.submit = submit;
    vm.cancel = cancel;

    init();

    function init() {
      vm.title = 'Add New Domain';
    }

    function submit() {
      $mdDialog.hide(vm.url);
    }

    function checkURL() {
      //TODO: ask if DA & TF will be necessary to check
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.campaign.edit')
    .controller('UrlUploadController', UrlUploadController);

  /** @ngInject */
  function UrlUploadController($state, $log, $mdDialog, $rootScope, Assets) {
    var vm = this;

    //Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.download = download;
    vm.getFileRoute = getFileRoute;

    function submit() {
      $mdDialog.hide(vm.csv);
    }

    function clearCsv() {
      vm.csv = null;
    }

    function getFileRoute() {
      return Assets + 'example_file.csv';
    }

    function download() {
      $rootScope.sampleSpreadsheet = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.articles.done', [])
    .controller('ArticlesDoneController', ArticlesDoneController);

  /* @ngInject */
  function ArticlesDoneController($scope, $log, $rootScope, $mdEditDialog, $mdDialog,
    lodash, toastr, ArticlesService, OrdersService, ARTICLE_STATES, ARTICLE_REWRITES, REGEX, ORDER_CREATED_ORIGIN, EnvironmentConfig, AccountService, RoutesService, PUBLISHER_NOT_ACTIVE_TOOLTIP) {
    var vm = this;

    //Accesible Variables
    vm.articles = [];
    vm.filteredArticles = [];
    vm.selectedArticles = [];
    vm.loading = true;
    vm.queryArticles = {
      filter: '',
      order: 'state',
      limit: 20,
      page: 1
    };
    vm.search;
    vm.enableStarredFeature = false;
    vm.searchQueryArticles = searchQueryArticles;

    //Accesible functions
    vm.isRejected = isRejected;
    vm.canAddToCart = canAddToCart;
    vm.isApproved = isApproved;
    vm.isCompleted = isCompleted;
    vm.isPending = isPending;
    vm.isAssigned = isAssigned;
    vm.isRewritten = isRewritten;
    vm.isRewrittenAfterAgencyRejected = isRewrittenAfterAgencyRejected;
    vm.isApprovedAfterAgencyRejected = isApprovedAfterAgencyRejected;
    vm.advUploadedDoc = advUploadedDoc;
    vm.toggle = toggle;
    vm.toggleAll = toggleAll;
    vm.allSelected = allSelected;
    vm.toggleStarred = toggleStarred;
    vm.removeFilter = removeFilter;
    vm.updateWord = updateWord;
    vm.showNotes = showNotes;
    vm.checkout = checkout;
    vm.instructions = instructions;
    vm.ok = ok;
    vm.setArticleHoverView = setArticleHoverView;
    vm.setArticleHoverUpload = setArticleHoverUpload;
    vm.setArticleHoverDownload = setArticleHoverDownload;
    vm.setArticleHoverNotes = setArticleHoverNotes;
    vm.setArticleHoverRewrite = setArticleHoverRewrite;
    vm.setArticlePendingHoverView = setArticlePendingHoverView;
    vm.setArticlePendingHoverUpload = setArticlePendingHoverUpload;
    vm.setArticlePendingHoverDownload = setArticlePendingHoverDownload;
    vm.setArticlePendingHoverNotes = setArticlePendingHoverNotes;
    vm.setArticlePendingHoverRewrite = setArticlePendingHoverRewrite;
    vm.starFeatureEnabled = starFeatureEnabled;
    vm.getPaginatedArticles = getPaginatedArticles;
    vm.adminApprovedArticlesCount = 0;
    vm.selectableArticlesTotal = 0;
    vm.publisherNotActiveTooltip = PUBLISHER_NOT_ACTIVE_TOOLTIP;

    vm.selectionHasPublisherNotActive = selectionHasPublisherNotActive;
    vm.isRowLocked = isRowLocked;
    vm.rowCellStyle = rowCellStyle;

    preInitialize();

    function preInitialize() {
      AccountService.getAdvertiser(function (response) {
        var has_permission = false;
        var adv = response.data;
        // check if teammate
        if (adv.parent_id) {
          // hack to allow starred feature for Ben Oren
          if (adv.parent_id === 47458) vm.enableStarredFeature = true;
          for (var i = 0; i < adv.roles.length; i++) {
            if (adv.roles[i].name === 'approve_content') {
              has_permission = true;
              break;
            }
          }
        } else {
          // hack to allow starred feature for Ben Oren
          if (adv.id === 47458) vm.enableStarredFeature = true;
          has_permission = true;
        }
        if (has_permission) {
          initialize();
        } else {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      });
    }

    function initialize() {
      vm.search = false;
      vm.selectedArticles = [];
      vm.selectableArticlesTotal = 0;
      getPaginatedArticles();
    }

    function getPaginatedArticles() {
      vm.loading = true;
      ArticlesService.indexArticles({
        limit: vm.queryArticles.limit,
        page: vm.queryArticles.page,
        q: vm.queryArticles.filter,
      },function (response) {
        vm.articles = lodash.orderBy(response.data.articles, [
          function (a) {
            return a.publisher_not_active ? 0 : 1;
          }
        ], ['asc']);
        vm.results = response.data.results;
        vm.zip = response.data.zip;
        vm.adminApprovedArticlesCount = lodash.filter(vm.articles, isApproved).length;
        lodash.map(vm.articles, function (item) {
          var pos = lodash.findIndex(vm.selectedArticles, ['id', item.id]);
          if (pos < 0) item.checked = false;
          else item.checked = true;
        });
        vm.filteredArticles = vm.articles;
        vm.loading = false;
      }, function (response) {
        vm.loading = false;
        toastr.error('There was an error retrieving articles. Please try again.');
      });
    }

    function canAddToCart(article) {
      return lodash.includes([ARTICLE_STATES.APPROVED], article.state) && !article.publisher_not_active;
    }

    function selectionHasPublisherNotActive() {
      return lodash.some(vm.selectedArticles, 'publisher_not_active');
    }

    function isRowLocked(article) {
      return !!article.publisher_not_active;
    }

    function rowCellStyle(article) {
      return article.publisher_not_active ? { 'background-color': '#ffcdd2' } : null;
    }

    function isApproved(article) {
      return lodash.includes([ARTICLE_STATES.APPROVED], article.state) && article.agency_rejected_counter === 0;
    }

    function isCompleted(article) {
      return article.state == ARTICLE_STATES.COMPLETED;
    }

    function isRejected(article) {
      return lodash.includes([ARTICLE_STATES.AGENCY_REJECTED], article.state);
    }

    function isRewritten(article) {
      return lodash.includes([ARTICLE_STATES.APPROVED], article.state) && ARTICLE_REWRITES.includes(article.rewritten_counter);
    }

    function isRewrittenAfterAgencyRejected(article) {
      return lodash.includes([ARTICLE_STATES.APPROVED], article.state) && ARTICLE_REWRITES.includes(article.rewritten_counter) && article.agency_rejected_counter > 0;
    }

    function isApprovedAfterAgencyRejected(article) {
      return lodash.includes([ARTICLE_STATES.APPROVED], article.state) && article.agency_rejected_counter > 0;
    }

    function isPending(article) {
      return lodash.includes([ARTICLE_STATES.DRAFT, ARTICLE_STATES.ADMIN_REJECTED], article.state);
    }

    function isAssigned(article) {
      return article.state == ARTICLE_STATES.ASSIGNED;
    }

    function advUploadedDoc(article) {
      return article.doc_uploaded_via === 'adv_update';
    }

    $scope.editText = function (event, article, anchor) {
      event.stopPropagation(); // in case autoselect is enabled
      if (isRowLocked(article)) {
        return;
      }
      if (!isRejected(article) && !isPending(article)) {
        var editDialog = {
          modelValue: anchor ? article.anchor : article.title,
          placeholder: anchor ? 'Anchor' : 'Title',
          save: function (input) {
            if (anchor) {
              article.anchor = input.$modelValue;
            } else {
              article.title = input.$modelValue;
            }
            updateField(article);
          },
          targetEvent: event,
          title: anchor ? 'Anchor' : 'Title'
        };
        var promise;
        promise = $mdEditDialog.large(editDialog).then(function (ctrl) {});
      }
    };

    $scope.editURL = function (event, article) {
      event.stopPropagation(); // in case autoselect is enabled
      if (isRowLocked(article)) {
        return;
      }
      if (!isRejected(article) && !isPending(article)) {
        var editDialog = {
          modelValue: article.destination_url,
          placeholder: 'http://destination.com',
          save: function (input) {
            article.destination_url = input.$modelValue.replace(/ /g, '');
            updateField(article);
          },
          targetEvent: event,
          title: 'Destination URL'
        };
        var promise;
        promise = $mdEditDialog.large(editDialog).then(function (ctrl) {
          var input = ctrl.getInput();
          input.$viewChangeListeners.push(function () {
            var expression = REGEX.URL;
            var regex = new RegExp(expression);
            var reg = regex.test(input.$modelValue);
            input.$setValidity('url', reg);
          });
        });
      }
    }

    function toggle(article) {
      if (isRowLocked(article)) {
        return;
      }
      article.checked = !article.checked;
      var pos = lodash.findIndex(vm.selectedArticles, ['id', article.id]);
      (pos < 0) ? vm.selectedArticles.push(article): vm.selectedArticles.splice(pos, 1);
    }

    function allSelected() {
      return vm.selectableArticlesTotal > 0 &&
        vm.selectedArticles.length === vm.selectableArticlesTotal;
    }

    function clearSelection() {
      vm.selectedArticles = [];
      lodash.map(vm.articles, function (item) {
        item.checked = false;
      });
    }

    function toggleAll() {
      if (allSelected()) {
        clearSelection();
      } else {
        deepSelectAll();
      }
    }

    function deepSelectAll() {
      ArticlesService.indexArticlesWithoutLimit({
        q: vm.queryArticles.filter
      }, function (response) {
        vm.selectedArticles = lodash.filter(response.data.articles, canAddToCart);
        vm.selectableArticlesTotal = vm.selectedArticles.length;
        getPaginatedArticles();
      }, function () {
        toastr.error('There was an error retrieving articles. Please try again.');
      });
    }

    function toggleStarred(article) {
      if (isRowLocked(article)) {
        return;
      }
      article.starred = !article.starred;
      ArticlesService.setStarred(article.id, article.starred, function (response) {
        // do nothing, it worked
      }, function (response) {
        toastr.error('There was an error retrieving articles. Please try again.');
      });
    }

    function removeFilter() {
      vm.search = false;
      vm.queryArticles.filter = '';
    }

    // $scope.$watch('aDoneCtrl.queryArticles.filter', function (newValue, oldValue) {
    //   var bookmark = '';

    //   if (!oldValue) {
    //     bookmark = vm.queryArticles.page;
    //   }

    //   if (newValue !== oldValue) {
    //     vm.queryArticles.page = 1;
    //   }

    //   if (!newValue) {
    //     vm.queryArticles.page = bookmark;
    //   }

    //   if (newValue == '') {
    //     vm.queryArticles.page = 1;
    //   }
    // });

    function downloadContent(article) {
      return article.blog_post_doc;
    }

    function updateField(article) {
      ArticlesService.updateArticle(article.id, article, function (response) {
        toastr.success('Article was updated successfully!');
        article.blog_post_doc = response.data.blog_post_doc;
      }, function (response) {
        toastr.error('There was an error updating the article. Please try again.');
      });
    }

    function updateWord(article) {
      if (isRowLocked(article)) {
        return;
      }
      updateField(article);
    }

    function showNotes(article, add) {
      if (isRowLocked(article)) {
        return;
      }
      $mdDialog.show({
        controller: 'NotesArticlesController',
        controllerAs: 'noteCtrl',
        templateUrl: 'app/pages/articles/done/partials/notes.html',
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          article: article,
          addNotes: add
        }
      }).then(function (response) {
        if (response) {
          ArticlesService.createNote(response.article.id, response.note, add, function (successResponse) {
            if ($rootScope.counterApprovedArticles > 0) $rootScope.counterApprovedArticles -= 1;
            toastr.success('Note was saved successfully!');
            initialize();
          }, function (errorResponse) {
            toastr.error('There was an error saving note. Try again.');
          });
        }
      });
    }

    function checkout() {
      if (selectionHasPublisherNotActive()) {
        toastr.error(PUBLISHER_NOT_ACTIVE_TOOLTIP);
        return;
      }
      ArticlesService.createOrders(lodash.map(vm.selectedArticles, 'id'), ORDER_CREATED_ORIGIN.ARTICLE, function () {
        if ($rootScope.counterApprovedArticles > 0) $rootScope.counterApprovedArticles -= vm.selectedArticles.length;
        $rootScope.counterPendingOrders += vm.selectedArticles.length;
        toastr.success('This article has been added to your cart.');
        OrdersService.indexOrders(function (response) {
          $log.log('Successfully added order to cart');
        }, function (error) {
          $log.error('Error adding article to cart counter');
        });
        initialize();
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
        } else {
          toastr.error('There was an error adding these articles to your cart, please retry.');
        }
      });
    }

    function instructions() {
      $mdDialog.show({
        controller: 'ArticlesDoneController',
        controllerAs: 'aDoneCtrl',
        templateUrl: 'app/pages/articles/done/partials/instructions.html',
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    }

    function ok() {
      $mdDialog.hide();
    }

    function setArticleHoverView(article, show) {
      article.hoverView = show;
    }

    function setArticleHoverUpload(article, show) {
      article.hoverUpload = show;
    }

    function setArticleHoverDownload(article, show) {
      article.hoverDownload = show;
    }

    function setArticleHoverNotes(article, show) {
      article.hoverNotes = show;
    }

    function setArticleHoverRewrite(article, show) {
      article.hoverRewrite = show;
    }

    function setArticlePendingHoverView(article, show) {
      article.pendingHoverView = show;
    }

    function setArticlePendingHoverUpload(article, show) {
      article.pendingHoverUpload = show;
    }

    function setArticlePendingHoverDownload(article, show) {
      article.pendingHoverDownload = show;
    }

    function setArticlePendingHoverNotes(article, show) {
      article.pendingHoverNotes = show;
    }

    function setArticlePendingHoverRewrite(article, show) {
      article.pendingHoverRewrite = show;
    }

    function starFeatureEnabled() {
      return vm.enableStarredFeature;
    }

    function searchQueryArticles() {
      if (vm.queryArticles.filter.length > 0 && vm.queryArticles.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        getPaginatedArticles();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.articles.done')
    .controller('NotesArticlesController', NotesArticlesController);

  /* @ngInject */
  function NotesArticlesController($scope, $mdDialog, lodash, article, addNotes) {
    var vm = this;

    //Accesible variables
    vm.notes = [];
    vm.article = {};
    vm.noteAdv;

    //Accesible functions
    vm.ok = ok;
    vm.cancel = cancel;
    vm.title = title;
    vm.buttonText = buttonText;

    initialize();

    function initialize() {
      vm.article = article;
      vm.notes = article.notes;
      vm.addNotes = addNotes;
    }

    function title() {
      return vm.addNotes ? 'Rewrite: Tell Author What Changes are Needed' : 'Notes';
    }

    function buttonText() {
      return vm.addNotes ? 'Cancel' : 'Ok';
    }

    function ok() {
      var response = {
        article: vm.article,
        note: vm.noteAdv
      };
      $mdDialog.hide(response);
    }

    function cancel() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.user.profile', [])
    .config(function (intlTelInputOptions) {
      angular.extend(intlTelInputOptions, {
        nationalMode: false,
        defaultCountry: 'us',
        autoFormat: true,
        separateDialCode: true
      })
    })
    .controller('ProfileController', ProfileController);

  /* @ngInject */
  function ProfileController($log, $rootScope, $scope, $mdDialog, $state, toastr, UserService, SessionService,
    StatesService, RoutesService, AuthenticationService, UserTourService) {
    var vm = this;

    //Accesible variables
    vm.user = {
      password: '',
      password_confirmation: '',
      current_password: '',
      payment_method: ''
    };
    vm.oldEmail = '';
    vm.showEmailChangeNotice = false;
    vm.payment_email = 'paypal_email';
    vm.searchTextCountry = '';

    //Accesible functions
    vm.submit = submit;
    vm.samePassword = samePassword;
    vm.canChangePassword = canChangePassword;
    vm.showOrderHistory = showOrderHistory;
    vm.isAdvertiser = isAdvertiser;
    vm.toggleZipMask = toggleZipMask;
    vm.showInfo = showInfo;
    vm.checkEmail = checkEmail;
    vm.updateAttempt = updateAttempt;
    vm.setPaymentMethod = setPaymentMethod;
    vm.setEmailChangeNotice = setEmailChangeNotice;
    vm.querySearchCountries = querySearchCountries;
    vm.countrySelected = countrySelected;
    vm.getPlaceholder = getPlaceholder;

    initialize();

    // Functions
    function initialize() {
      UserService.getUser(function (response) {
        vm.user = response.data.user;
        vm.oldEmail = vm.user.email;
        vm.payment_email = vm.user.payment_method && (vm.user.payment_method.toLowerCase()+'_email') || 'paypal_email';
        initSelectedCountry();
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });

      vm.states = StatesService.getAllUSStates();
    }

    function initSelectedCountry() {
      if(!vm.user.country) return;
      var countries = countryData();
      for(var i = 0; i < countries.length; i++) {
        if(countries[i].code === vm.user.country) {
          vm.searchTextCountry = countries[i].name;
          return;
        }
      }
    }

    function checkEmail(form) {
      vm.attemptEmail = true;
      if (vm.user.email !== vm.oldEmail) {
        form.email.$setValidity('in-use', true);
        UserService.checkDuplicatedEmail(vm.user.email, function (response) {
          var data = response.data;
          form.email.$setValidity('in-use', !data.email_exists);
        }, function (err) {
          $log.error('Error checking duplicated email');
        });
      }
    }

    function updateAttempt() {
      vm.attemptEmail = false;
    }

    function getPlaceholder() {
      return document.querySelector('#pub-phone-number').getAttribute('placeholder');
    }

    function submit(form) {
      if (typedNewPassword() && samePassword()) {
        updateUserInfo(false);
      } else if (!samePassword()) {
        form.confirmPassword.$setValidity("no-match", false);
      } else {
        if (emailedChanged()) {
          showEmailChangedPopup();
        } else {
          updateUserInfo(false);
        }
      }
    }

    function showChangePassword(ev) {
      $mdDialog.show({
        contentElement: '#password',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    }

    function showEmailChangedPopup() {
      $mdDialog.show({
        controller: 'ConfirmationController',
        controllerAs: 'confirmCtrl',
        templateUrl: 'app/pages/user/profile/confirmation/confirmation.html',
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          user: vm.user
        }
      }).then(function (user) {
        if (angular.isDefined(user)) {
          updateUserInfo(true);
        }
      });
    }

    function updateUserInfo(signOut) {
      // if nothing input for phone then it will be undefined
      // so lets set it to empty string
      if (angular.isUndefined(vm.user.phone)) vm.user.phone = '';
      // we'll override and always set as paypal for now
      vm.user.payment_method = 'paypal';
      UserService.updateUser(vm.user, function () {
        if (typedNewPassword() && samePassword()) {
          vm.user.current_password = '';
          vm.user.password = '';
          vm.user.password_confirmation = '';
        }

        if (emailedChanged() && signOut) {
          emailUpdated();
          AuthenticationService.logout(RoutesService.signIn);
        }

        toastr.success('User updated correctly');
        if (UserTourService.currentName() == 'pub_welcome_phase_2') UserTourService.nextStep();
        else RoutesService.dashboard();
      }, function (response) {
        var error = response.data.error.current_password[0];
        if (error) {
          toastr.error('Cannot update user. Current password ' + error);
        } else {
          toastr.error('Cannot update user.');
        }
      });
    }

    function emailUpdated() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Updating email')
        .htmlContent('Please check new email address. We just sent a confirmation to the address provided. Click the link to confirm that address.')
        .ariaLabel('Notes')
        .ok('Got it!')
      );
    }

    function emailedChanged() {
      return !angular.equals(vm.user.email, vm.oldEmail);
    }

    function samePassword() {
      return angular.equals(vm.user.password, vm.user.password_confirmation);
    }

    function canChangePassword(form) {
      form.confirmPassword.$setValidity("no-match", samePassword());
    }

    function showOrderHistory() {
      $state.go('billing');
    }

    function typedNewPassword() {
      return angular.isDefined(vm.user.password) &&
        angular.isDefined(vm.user.current_password);
    }

    function isAdvertiser() {
      return SessionService.isAdvertiser();
    }

    function toggleZipMask() {
      if (!vm.zipMask) {
        vm.zipMask = '99999';
      } else if (!vm.zipCode) {
        vm.zipMask = '';
      }
    }

    function showInfo(userProp) {
      switch (userProp) {
      case 'email':
        return showAlertHTML('Changing Your Email?', 'Changing your email will require ' +
          're-authorization via the new email address!', 'Ok').then(function (result) {
          return false;
        });
      }
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function setPaymentMethod(paymentMethod, form) {
      form.$setDirty();
      vm.user.payment_method = paymentMethod;
      vm.payment_email = vm.user.payment_method && (vm.user.payment_method+'_email');
    }

    function setEmailChangeNotice(show) {
      vm.showEmailChangeNotice = show;
    }

    function querySearchCountries(theCountry, query) {
      var results = query ? countryData().filter(createFilterForCountry(query)) : theCountry.name;
      return results;
    }
    function createFilterForCountry(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(theCountry) {
        return (theCountry.name.toLowerCase().indexOf(lowercaseQuery) >= 0);
      };
    }
    function countrySelected(theCountry) {
      vm.user.country = theCountry ? theCountry.code : theCountry
    }

    function countryData() {
      return [
        {"code": "AF", "code3": "AFG", "name": "Afghanistan", "number": "004"},
        {"code": "AL", "code3": "ALB", "name": "Albania", "number": "008"},
        {"code": "DZ", "code3": "DZA", "name": "Algeria", "number": "012"},
        {"code": "AS", "code3": "ASM", "name": "American Samoa", "number": "016"},
        {"code": "AD", "code3": "AND", "name": "Andorra", "number": "020"},
        {"code": "AO", "code3": "AGO", "name": "Angola", "number": "024"},
        {"code": "AI", "code3": "AIA", "name": "Anguilla", "number": "660"},
        {"code": "AQ", "code3": "ATA", "name": "Antarctica", "number": "010"},
        {"code": "AG", "code3": "ATG", "name": "Antigua and Barbuda", "number": "028"},
        {"code": "AR", "code3": "ARG", "name": "Argentina", "number": "032"},
        {"code": "AM", "code3": "ARM", "name": "Armenia", "number": "051"},
        {"code": "AW", "code3": "ABW", "name": "Aruba", "number": "533"},
        {"code": "AU", "code3": "AUS", "name": "Australia", "number": "036"},
        {"code": "AT", "code3": "AUT", "name": "Austria", "number": "040"},
        {"code": "AZ", "code3": "AZE", "name": "Azerbaijan", "number": "031"},
        {"code": "BS", "code3": "BHS", "name": "Bahamas (the)", "number": "044"},
        {"code": "BH", "code3": "BHR", "name": "Bahrain", "number": "048"},
        {"code": "BD", "code3": "BGD", "name": "Bangladesh", "number": "050"},
        {"code": "BB", "code3": "BRB", "name": "Barbados", "number": "052"},
        {"code": "BY", "code3": "BLR", "name": "Belarus", "number": "112"},
        {"code": "BE", "code3": "BEL", "name": "Belgium", "number": "056"},
        {"code": "BZ", "code3": "BLZ", "name": "Belize", "number": "084"},
        {"code": "BJ", "code3": "BEN", "name": "Benin", "number": "204"},
        {"code": "BM", "code3": "BMU", "name": "Bermuda", "number": "060"},
        {"code": "BT", "code3": "BTN", "name": "Bhutan", "number": "064"},
        {"code": "BO", "code3": "BOL", "name": "Bolivia (Plurinational State of)", "number": "068"},
        {"code": "BQ", "code3": "BES", "name": "Bonaire, Sint Eustatius and Saba", "number": "535"},
        {"code": "BA", "code3": "BIH", "name": "Bosnia and Herzegovina", "number": "070"},
        {"code": "BW", "code3": "BWA", "name": "Botswana", "number": "072"},
        {"code": "BV", "code3": "BVT", "name": "Bouvet Island", "number": "074"},
        {"code": "BR", "code3": "BRA", "name": "Brazil", "number": "076"},
        {"code": "IO", "code3": "IOT", "name": "British Indian Ocean Territory (the)", "number": "086"},
        {"code": "BN", "code3": "BRN", "name": "Brunei Darussalam", "number": "096"},
        {"code": "BG", "code3": "BGR", "name": "Bulgaria", "number": "100"},
        {"code": "BF", "code3": "BFA", "name": "Burkina Faso", "number": "854"},
        {"code": "BI", "code3": "BDI", "name": "Burundi", "number": "108"},
        {"code": "CV", "code3": "CPV", "name": "Cabo Verde", "number": "132"},
        {"code": "KH", "code3": "KHM", "name": "Cambodia", "number": "116"},
        {"code": "CM", "code3": "CMR", "name": "Cameroon", "number": "120"},
        {"code": "CA", "code3": "CAN", "name": "Canada", "number": "124"},
        {"code": "KY", "code3": "CYM", "name": "Cayman Islands (the)", "number": "136"},
        {"code": "CF", "code3": "CAF", "name": "Central African Republic (the)", "number": "140"},
        {"code": "TD", "code3": "TCD", "name": "Chad", "number": "148"},
        {"code": "CL", "code3": "CHL", "name": "Chile", "number": "152"},
        {"code": "CN", "code3": "CHN", "name": "China", "number": "156"},
        {"code": "CX", "code3": "CXR", "name": "Christmas Island", "number": "162"},
        {"code": "CC", "code3": "CCK", "name": "Cocos (Keeling) Islands (the)", "number": "166"},
        {"code": "CO", "code3": "COL", "name": "Colombia", "number": "170"},
        {"code": "KM", "code3": "COM", "name": "Comoros (the)", "number": "174"},
        {"code": "CD", "code3": "COD", "name": "Congo (the Democratic Republic of the)", "number": "180"},
        {"code": "CG", "code3": "COG", "name": "Congo (the)", "number": "178"},
        {"code": "CK", "code3": "COK", "name": "Cook Islands (the)", "number": "184"},
        {"code": "CR", "code3": "CRI", "name": "Costa Rica", "number": "188"},
        {"code": "HR", "code3": "HRV", "name": "Croatia", "number": "191"},
        {"code": "CU", "code3": "CUB", "name": "Cuba", "number": "192"},
        {"code": "CW", "code3": "CUW", "name": "Curaçao", "number": "531"},
        {"code": "CY", "code3": "CYP", "name": "Cyprus", "number": "196"},
        {"code": "CZ", "code3": "CZE", "name": "Czechia", "number": "203"},
        {"code": "CI", "code3": "CIV", "name": "Côte d'Ivoire", "number": "384"},
        {"code": "DK", "code3": "DNK", "name": "Denmark", "number": "208"},
        {"code": "DJ", "code3": "DJI", "name": "Djibouti", "number": "262"},
        {"code": "DM", "code3": "DMA", "name": "Dominica", "number": "212"},
        {"code": "DO", "code3": "DOM", "name": "Dominican Republic (the)", "number": "214"},
        {"code": "EC", "code3": "ECU", "name": "Ecuador", "number": "218"},
        {"code": "EG", "code3": "EGY", "name": "Egypt", "number": "818"},
        {"code": "SV", "code3": "SLV", "name": "El Salvador", "number": "222"},
        {"code": "GQ", "code3": "GNQ", "name": "Equatorial Guinea", "number": "226"},
        {"code": "ER", "code3": "ERI", "name": "Eritrea", "number": "232"},
        {"code": "EE", "code3": "EST", "name": "Estonia", "number": "233"},
        {"code": "SZ", "code3": "SWZ", "name": "Eswatini", "number": "748"},
        {"code": "ET", "code3": "ETH", "name": "Ethiopia", "number": "231"},
        {"code": "FK", "code3": "FLK", "name": "Falkland Islands (the) [Malvinas]", "number": "238"},
        {"code": "FO", "code3": "FRO", "name": "Faroe Islands (the)", "number": "234"},
        {"code": "FJ", "code3": "FJI", "name": "Fiji", "number": "242"},
        {"code": "FI", "code3": "FIN", "name": "Finland", "number": "246"},
        {"code": "FR", "code3": "FRA", "name": "France", "number": "250"},
        {"code": "GF", "code3": "GUF", "name": "French Guiana", "number": "254"},
        {"code": "PF", "code3": "PYF", "name": "French Polynesia", "number": "258"},
        {"code": "TF", "code3": "ATF", "name": "French Southern Territories (the)", "number": "260"},
        {"code": "GA", "code3": "GAB", "name": "Gabon", "number": "266"},
        {"code": "GM", "code3": "GMB", "name": "Gambia (the)", "number": "270"},
        {"code": "GE", "code3": "GEO", "name": "Georgia", "number": "268"},
        {"code": "DE", "code3": "DEU", "name": "Germany", "number": "276"},
        {"code": "GH", "code3": "GHA", "name": "Ghana", "number": "288"},
        {"code": "GI", "code3": "GIB", "name": "Gibraltar", "number": "292"},
        {"code": "GR", "code3": "GRC", "name": "Greece", "number": "300"},
        {"code": "GL", "code3": "GRL", "name": "Greenland", "number": "304"},
        {"code": "GD", "code3": "GRD", "name": "Grenada", "number": "308"},
        {"code": "GP", "code3": "GLP", "name": "Guadeloupe", "number": "312"},
        {"code": "GU", "code3": "GUM", "name": "Guam", "number": "316"},
        {"code": "GT", "code3": "GTM", "name": "Guatemala", "number": "320"},
        {"code": "GG", "code3": "GGY", "name": "Guernsey", "number": "831"},
        {"code": "GN", "code3": "GIN", "name": "Guinea", "number": "324"},
        {"code": "GW", "code3": "GNB", "name": "Guinea-Bissau", "number": "624"},
        {"code": "GY", "code3": "GUY", "name": "Guyana", "number": "328"},
        {"code": "HT", "code3": "HTI", "name": "Haiti", "number": "332"},
        {"code": "HM", "code3": "HMD", "name": "Heard Island and McDonald Islands", "number": "334"},
        {"code": "VA", "code3": "VAT", "name": "Holy See (the)", "number": "336"},
        {"code": "HN", "code3": "HND", "name": "Honduras", "number": "340"},
        {"code": "HK", "code3": "HKG", "name": "Hong Kong", "number": "344"},
        {"code": "HU", "code3": "HUN", "name": "Hungary", "number": "348"},
        {"code": "IS", "code3": "ISL", "name": "Iceland", "number": "352"},
        {"code": "IN", "code3": "IND", "name": "India", "number": "356"},
        {"code": "ID", "code3": "IDN", "name": "Indonesia", "number": "360"},
        {"code": "IR", "code3": "IRN", "name": "Iran (Islamic Republic of)", "number": "364"},
        {"code": "IQ", "code3": "IRQ", "name": "Iraq", "number": "368"},
        {"code": "IE", "code3": "IRL", "name": "Ireland", "number": "372"},
        {"code": "IM", "code3": "IMN", "name": "Isle of Man", "number": "833"},
        {"code": "IL", "code3": "ISR", "name": "Israel", "number": "376"},
        {"code": "IT", "code3": "ITA", "name": "Italy", "number": "380"},
        {"code": "JM", "code3": "JAM", "name": "Jamaica", "number": "388"},
        {"code": "JP", "code3": "JPN", "name": "Japan", "number": "392"},
        {"code": "JE", "code3": "JEY", "name": "Jersey", "number": "832"},
        {"code": "JO", "code3": "JOR", "name": "Jordan", "number": "400"},
        {"code": "KZ", "code3": "KAZ", "name": "Kazakhstan", "number": "398"},
        {"code": "KE", "code3": "KEN", "name": "Kenya", "number": "404"},
        {"code": "KI", "code3": "KIR", "name": "Kiribati", "number": "296"},
        {"code": "KP", "code3": "PRK", "name": "Korea (the Democratic People's Republic of)", "number": "408"},
        {"code": "KR", "code3": "KOR", "name": "Korea (the Republic of)", "number": "410"},
        {"code": "KW", "code3": "KWT", "name": "Kuwait", "number": "414"},
        {"code": "KG", "code3": "KGZ", "name": "Kyrgyzstan", "number": "417"},
        {"code": "LA", "code3": "LAO", "name": "Lao People's Democratic Republic (the)", "number": "418"},
        {"code": "LV", "code3": "LVA", "name": "Latvia", "number": "428"},
        {"code": "LB", "code3": "LBN", "name": "Lebanon", "number": "422"},
        {"code": "LS", "code3": "LSO", "name": "Lesotho", "number": "426"},
        {"code": "LR", "code3": "LBR", "name": "Liberia", "number": "430"},
        {"code": "LY", "code3": "LBY", "name": "Libya", "number": "434"},
        {"code": "LI", "code3": "LIE", "name": "Liechtenstein", "number": "438"},
        {"code": "LT", "code3": "LTU", "name": "Lithuania", "number": "440"},
        {"code": "LU", "code3": "LUX", "name": "Luxembourg", "number": "442"},
        {"code": "MO", "code3": "MAC", "name": "Macao", "number": "446"},
        {"code": "MG", "code3": "MDG", "name": "Madagascar", "number": "450"},
        {"code": "MW", "code3": "MWI", "name": "Malawi", "number": "454"},
        {"code": "MY", "code3": "MYS", "name": "Malaysia", "number": "458"},
        {"code": "MV", "code3": "MDV", "name": "Maldives", "number": "462"},
        {"code": "ML", "code3": "MLI", "name": "Mali", "number": "466"},
        {"code": "MT", "code3": "MLT", "name": "Malta", "number": "470"},
        {"code": "MH", "code3": "MHL", "name": "Marshall Islands (the)", "number": "584"},
        {"code": "MQ", "code3": "MTQ", "name": "Martinique", "number": "474"},
        {"code": "MR", "code3": "MRT", "name": "Mauritania", "number": "478"},
        {"code": "MU", "code3": "MUS", "name": "Mauritius", "number": "480"},
        {"code": "YT", "code3": "MYT", "name": "Mayotte", "number": "175"},
        {"code": "MX", "code3": "MEX", "name": "Mexico", "number": "484"},
        {"code": "FM", "code3": "FSM", "name": "Micronesia (Federated States of)", "number": "583"},
        {"code": "MD", "code3": "MDA", "name": "Moldova (the Republic of)", "number": "498"},
        {"code": "MC", "code3": "MCO", "name": "Monaco", "number": "492"},
        {"code": "MN", "code3": "MNG", "name": "Mongolia", "number": "496"},
        {"code": "ME", "code3": "MNE", "name": "Montenegro", "number": "499"},
        {"code": "MS", "code3": "MSR", "name": "Montserrat", "number": "500"},
        {"code": "MA", "code3": "MAR", "name": "Morocco", "number": "504"},
        {"code": "MZ", "code3": "MOZ", "name": "Mozambique", "number": "508"},
        {"code": "MM", "code3": "MMR", "name": "Myanmar", "number": "104"},
        {"code": "NA", "code3": "NAM", "name": "Namibia", "number": "516"},
        {"code": "NR", "code3": "NRU", "name": "Nauru", "number": "520"},
        {"code": "NP", "code3": "NPL", "name": "Nepal", "number": "524"},
        {"code": "NL", "code3": "NLD", "name": "Netherlands (the)", "number": "528"},
        {"code": "NC", "code3": "NCL", "name": "New Caledonia", "number": "540"},
        {"code": "NZ", "code3": "NZL", "name": "New Zealand", "number": "554"},
        {"code": "NI", "code3": "NIC", "name": "Nicaragua", "number": "558"},
        {"code": "NE", "code3": "NER", "name": "Niger (the)", "number": "562"},
        {"code": "NG", "code3": "NGA", "name": "Nigeria", "number": "566"},
        {"code": "NU", "code3": "NIU", "name": "Niue", "number": "570"},
        {"code": "NF", "code3": "NFK", "name": "Norfolk Island", "number": "574"},
        {"code": "MP", "code3": "MNP", "name": "Northern Mariana Islands (the)", "number": "580"},
        {"code": "NO", "code3": "NOR", "name": "Norway", "number": "578"},
        {"code": "OM", "code3": "OMN", "name": "Oman", "number": "512"},
        {"code": "PK", "code3": "PAK", "name": "Pakistan", "number": "586"},
        {"code": "PW", "code3": "PLW", "name": "Palau", "number": "585"},
        {"code": "PS", "code3": "PSE", "name": "Palestine, State of", "number": "275"},
        {"code": "PA", "code3": "PAN", "name": "Panama", "number": "591"},
        {"code": "PG", "code3": "PNG", "name": "Papua New Guinea", "number": "598"},
        {"code": "PY", "code3": "PRY", "name": "Paraguay", "number": "600"},
        {"code": "PE", "code3": "PER", "name": "Peru", "number": "604"},
        {"code": "PH", "code3": "PHL", "name": "Philippines (the)", "number": "608"},
        {"code": "PN", "code3": "PCN", "name": "Pitcairn", "number": "612"},
        {"code": "PL", "code3": "POL", "name": "Poland", "number": "616"},
        {"code": "PT", "code3": "PRT", "name": "Portugal", "number": "620"},
        {"code": "PR", "code3": "PRI", "name": "Puerto Rico", "number": "630"},
        {"code": "QA", "code3": "QAT", "name": "Qatar", "number": "634"},
        {"code": "MK", "code3": "MKD", "name": "Republic of North Macedonia", "number": "807"},
        {"code": "RO", "code3": "ROU", "name": "Romania", "number": "642"},
        {"code": "RU", "code3": "RUS", "name": "Russian Federation (the)", "number": "643"},
        {"code": "RW", "code3": "RWA", "name": "Rwanda", "number": "646"},
        {"code": "RE", "code3": "REU", "name": "Réunion", "number": "638"},
        {"code": "BL", "code3": "BLM", "name": "Saint Barthélemy", "number": "652"},
        {"code": "SH", "code3": "SHN", "name": "Saint Helena, Ascension and Tristan da Cunha", "number": "654"},
        {"code": "KN", "code3": "KNA", "name": "Saint Kitts and Nevis", "number": "659"},
        {"code": "LC", "code3": "LCA", "name": "Saint Lucia", "number": "662"},
        {"code": "MF", "code3": "MAF", "name": "Saint Martin (French part)", "number": "663"},
        {"code": "PM", "code3": "SPM", "name": "Saint Pierre and Miquelon", "number": "666"},
        {"code": "VC", "code3": "VCT", "name": "Saint Vincent and the Grenadines", "number": "670"},
        {"code": "WS", "code3": "WSM", "name": "Samoa", "number": "882"},
        {"code": "SM", "code3": "SMR", "name": "San Marino", "number": "674"},
        {"code": "ST", "code3": "STP", "name": "Sao Tome and Principe", "number": "678"},
        {"code": "SA", "code3": "SAU", "name": "Saudi Arabia", "number": "682"},
        {"code": "SN", "code3": "SEN", "name": "Senegal", "number": "686"},
        {"code": "RS", "code3": "SRB", "name": "Serbia", "number": "688"},
        {"code": "SC", "code3": "SYC", "name": "Seychelles", "number": "690"},
        {"code": "SL", "code3": "SLE", "name": "Sierra Leone", "number": "694"},
        {"code": "SG", "code3": "SGP", "name": "Singapore", "number": "702"},
        {"code": "SX", "code3": "SXM", "name": "Sint Maarten (Dutch part)", "number": "534"},
        {"code": "SK", "code3": "SVK", "name": "Slovakia", "number": "703"},
        {"code": "SI", "code3": "SVN", "name": "Slovenia", "number": "705"},
        {"code": "SB", "code3": "SLB", "name": "Solomon Islands", "number": "090"},
        {"code": "SO", "code3": "SOM", "name": "Somalia", "number": "706"},
        {"code": "ZA", "code3": "ZAF", "name": "South Africa", "number": "710"},
        {"code": "GS", "code3": "SGS", "name": "South Georgia and the South Sandwich Islands", "number": "239"},
        {"code": "SS", "code3": "SSD", "name": "South Sudan", "number": "728"},
        {"code": "ES", "code3": "ESP", "name": "Spain", "number": "724"},
        {"code": "LK", "code3": "LKA", "name": "Sri Lanka", "number": "144"},
        {"code": "SD", "code3": "SDN", "name": "Sudan (the)", "number": "729"},
        {"code": "SR", "code3": "SUR", "name": "Suriname", "number": "740"},
        {"code": "SJ", "code3": "SJM", "name": "Svalbard and Jan Mayen", "number": "744"},
        {"code": "SE", "code3": "SWE", "name": "Sweden", "number": "752"},
        {"code": "CH", "code3": "CHE", "name": "Switzerland", "number": "756"},
        {"code": "SY", "code3": "SYR", "name": "Syrian Arab Republic", "number": "760"},
        {"code": "TW", "code3": "TWN", "name": "Taiwan", "number": "158"},
        {"code": "TJ", "code3": "TJK", "name": "Tajikistan", "number": "762"},
        {"code": "TZ", "code3": "TZA", "name": "Tanzania, United Republic of", "number": "834"},
        {"code": "TH", "code3": "THA", "name": "Thailand", "number": "764"},
        {"code": "TL", "code3": "TLS", "name": "Timor-Leste", "number": "626"},
        {"code": "TG", "code3": "TGO", "name": "Togo", "number": "768"},
        {"code": "TK", "code3": "TKL", "name": "Tokelau", "number": "772"},
        {"code": "TO", "code3": "TON", "name": "Tonga", "number": "776"},
        {"code": "TT", "code3": "TTO", "name": "Trinidad and Tobago", "number": "780"},
        {"code": "TN", "code3": "TUN", "name": "Tunisia", "number": "788"},
        {"code": "TR", "code3": "TUR", "name": "Turkey", "number": "792"},
        {"code": "TM", "code3": "TKM", "name": "Turkmenistan", "number": "795"},
        {"code": "TC", "code3": "TCA", "name": "Turks and Caicos Islands (the)", "number": "796"},
        {"code": "TV", "code3": "TUV", "name": "Tuvalu", "number": "798"},
        {"code": "UG", "code3": "UGA", "name": "Uganda", "number": "800"},
        {"code": "UA", "code3": "UKR", "name": "Ukraine", "number": "804"},
        {"code": "AE", "code3": "ARE", "name": "United Arab Emirates (the)", "number": "784"},
        {"code": "GB", "code3": "GBR", "name": "United Kingdom of Great Britain and Northern Ireland (the)", "number": "826"},
        {"code": "UM", "code3": "UMI", "name": "United States Minor Outlying Islands (the)", "number": "581"},
        {"code": "US", "code3": "USA", "name": "United States of America (the)", "number": "840"},
        {"code": "UY", "code3": "URY", "name": "Uruguay", "number": "858"},
        {"code": "UZ", "code3": "UZB", "name": "Uzbekistan", "number": "860"},
        {"code": "VU", "code3": "VUT", "name": "Vanuatu", "number": "548"},
        {"code": "VE", "code3": "VEN", "name": "Venezuela (Bolivarian Republic of)", "number": "862"},
        {"code": "VN", "code3": "VNM", "name": "Viet Nam", "number": "704"},
        {"code": "VG", "code3": "VGB", "name": "Virgin Islands (British)", "number": "092"},
        {"code": "VI", "code3": "VIR", "name": "Virgin Islands (U.S.)", "number": "850"},
        {"code": "WF", "code3": "WLF", "name": "Wallis and Futuna", "number": "876"},
        {"code": "EH", "code3": "ESH", "name": "Western Sahara", "number": "732"},
        {"code": "YE", "code3": "YEM", "name": "Yemen", "number": "887"},
        {"code": "ZM", "code3": "ZMB", "name": "Zambia", "number": "894"},
        {"code": "ZW", "code3": "ZWE", "name": "Zimbabwe", "number": "716"},
        {"code": "AX", "code3": "ALA", "name": "Åland Islands", "number": "248"}
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes.received', [])
    .controller('QuotesReceivedController', QuotesReceivedController);

  /* @ngInject */
  function QuotesReceivedController($state, $log, $rootScope, $mdMedia, toastr, ContentService) {
    var vm = this;

    // Accessible attributes
    vm.activeItem;
    vm.contents = [];
    vm.perPage = 20;
    vm.dirId = 'Rec';
    vm.$mdMedia = $mdMedia;
    vm.initialized = false;
    vm.query = {
      limit: 10,
      page: 1,
      filter: ''
    };
    // Accesible functions
    vm.showQuotesFrom = showQuotesFrom;
    vm.goTop = goTop;
    vm.getDoingContentText = getDoingContentText;
    vm.searchQuotes = searchQuotes;
    vm.allCategories = allCategories;
    vm.concatCategories = concatCategories;
    vm.showCatPopup = showCatPopup;

    initialize();

    // Functions
    function initialize() {
      fetchQuotes();
    }

    function showQuotesFrom(item) {
      vm.activeItem = item;
      $state.go('quotes-for', {
        quoteId: item.id
      })
    }

    function goTop() {
      $anchorScroll('top');
    }

    function getDoingContentText(quote) {
      return quote.agency_content ? 'Agency will do content' : 'Scalefluence will do content';
    }

    function fetchQuotes() {
      ContentService.indexReceivedContents(vm.query, function (response) {
        vm.contents = response.data.contents;
        vm.res = response.data.contents;
        $rootScope.quotesReady = vm.contents.length;
        vm.initialized = true;
      }, function () {
        vm.initialized = true;
        $log.error('Error retrieving received content');
        toastr.error('There was an error retrieving received content. Please try again.')
      })
    }

    function searchQuotes() {
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchQuotes();
      }
    }

    function allCategories(content) {
      var catString = '';
      for (var i = 0; i < content.categories.length; i++) {
        if (i > 0) catString += ', ';
        catString += content.categories[i].name;
      }
      return catString;
    }

    function concatCategories(content) {
      var catString = allCategories(content);
      if (catString.length > 28) return catString.substring(0, 25) + '...';
      return catString;
    }

    function showCatPopup(content) {
      var catString = allCategories(content);
      if (catString.length > 28) return true;
      return false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes.quoteFor', [])
    .controller('QuoteForController', QuoteForController);

  /* @ngInject */
  function QuoteForController($scope, $stateParams, $window, $interpolate, $log, $anchorScroll, $mdMedia, $mdDialog, toastr, lodash, ContentService,
    StorageService, ArticlesService, RoutesService, OrdersService, NotificationService, TYPE_STATE, ROLE, ORDER_CREATED_ORIGIN, PUB_URL_STATE,
    $cookies, CounterService, AccountService, EnvironmentConfig, PUBLISHER_NOT_ACTIVE_TOOLTIP) {
    var vm = this;
    vm.publisherNotActiveTooltip = PUBLISHER_NOT_ACTIVE_TOOLTIP;

    // Accessible variables
    vm.urls = [];
    vm.shownUrls = [];
    vm.quote = {};
    vm.perPage = 10;
    vm.filteredUrls =[];
    vm.searchUrls = {
      filter: '',
      order: 'state',
      limit: 10,
      page: 1
    };
    vm.$mdMedia = $mdMedia;
    vm.buttonText = '';

    // Accessible functions
    vm.toggle = toggle;
    vm.cannotSubmit = cannotSubmit;
    vm.setGreenBackground = setGreenBackground;
    vm.goTop = goTop;
    vm.submit = submit;
    vm.downloadReport = downloadReport;
    vm.upload = upload;
    vm.prepareForSubmit = prepareForSubmit;
    vm.urlNotPaused = urlNotPaused;
    vm.close = close;

    initialize();

    // Functions
    function initialize() {
      if (angular.isDefined($stateParams.quoteId)) {
        ContentService.showContent($stateParams.quoteId, function (response) {
          CounterService.getAdvCardValues();
          vm.quote = response.data;
          vm.shownUrls = vm.quote.urls;
          vm.filteredUrls = vm.quote.urls;
          vm.downloaded = vm.quote.campaign.downloaded;
          vm.buttonText = setTextButton(vm.quote);
          if (vm.quote.urls.length > 0) {
            var aux = lodash.map(vm.quote.urls, function (url) {
              url.showMessage = false;
              url.checked = false;
              url.quote = {
                blog_post_title: '',
                href: '',
                link_text: '',
                notes: ''
              };
              url.campaign = response.data.campaign.id;
              url.url_id = url.id;
              url.content_id = vm.quote.id;

              return url;
            });
            vm.quote.urls = aux;
            blockIfNotPermitted();
          } else {
            RoutesService.mainQuotes();
          }
        }, function () {
          $log.error('Error retrieving the content.');
          toastr.error('There was an error retrieving the content. Please retry.');
        });
      }
    }

    //cart search filter code//
    $scope.$watch('quoteForCtrl.searchUrls.filter', function (newValue, oldValue) {
      var bookmark = '';

      if (!oldValue) {
        bookmark = vm.searchUrls.page;
      }

      if (newValue !== oldValue) {
        vm.searchUrls.page = 1;
      }

      if (!newValue) {
        vm.searchUrls.page = bookmark;
      }

      if (newValue == '') {
        vm.searchUrls.page = 1;
      }
    });

    function blockIfNotPermitted() {
      AccountService.getAdvertiser(function (response) {
        var has_permission = false;
        var adv = response.data;
        // check if teammate
        if (adv.parent_id) {
          for (var i = 0; i < adv.roles.length; i++) {
            var role = adv.roles[i]
            if (role.name === 'manager' && role.resource_id === vm.quote.campaign.id && role.resource_type === 'Campaign') {
              has_permission = true;
              break;
            }
          }
        } else {
          has_permission = true;
        }
        if (has_permission) {
          // do nothing
        } else {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      });
    }

    function toggle(url) {
      url.showMessage = url.checked && !vm.quote.agency_content;
      var pos = lodash.findIndex(vm.urls, ['id', url.id]);
      (pos < 0) ? vm.urls.push(url): vm.urls.splice(pos, 1);
    }

    function cannotSubmit() {
      if (vm.urls.length < 1) {
        return true;
      }
      if (lodash.some(vm.urls, 'publisher_not_active')) {
        return true;
      }
      var pos = lodash.findIndex(vm.urls, function (url) {
        return checkQuoteContent(url);
      });

      return pos != -1;
    }

    function checkQuoteContent(url) {
      if (vm.quote.agency_content) {
        return false;
      } else {
        if (url.quote.href && url.quote.link_text) {
          url.showMessage = false;
          return false;
        }

        if (url.checked) {
          url.showMessage = true;
        }
        return true;
      }
    }

    function setGreenBackground(url) {
      if (url) { 
        return url.checked && !url.showMessage;
      }
    }

    function goTop() {
      $anchorScroll('top');
    }

    function submit() {
      if (vm.quote.agency_content) {
        if (lodash.some(vm.urls, 'publisher_not_active')) {
          toastr.error(PUBLISHER_NOT_ACTIVE_TOOLTIP);
          return;
        }
        var url_ids = lodash.map(vm.urls, function (url)  {
          return url.id
        });
        OrdersService.createOrders(url_ids, vm.quote.id, ORDER_CREATED_ORIGIN.QUOTE, function () {
          toastr.success('Quotes successfully submitted');
          removeNotification();
          initialize();
          vm.urls = [];
        }, function () {
          $log.error('Error adding content to your cart.');
          toastr.error('There was an error adding this content to your cart, please retry.');
        });
      } else {
        ArticlesService.createArticles(vm.urls, function (response) {
          toastr.success('Quotes successfully submitted');
          removeNotification();
          initialize();
          vm.urls = [];
        }, function (response) {
          if (response.data.errors.href) {
            toastr.error('Target URL ' + response.data.errors.href[0]);
          } else {
            toastr.error('There was an error creating the Quotes. Please try again.');
          }
        });
      }
    }

    function setTextButton(quote) {
      return quote.agency_content ? 'Send to cart' : 'Submit to Our authors';
    }

    function removeNotification() {
      NotificationService.deleteNotification(TYPE_STATE.QUOTES, ROLE.ADV);
    }

    function downloadReport() {
      $mdDialog.show({
        templateUrl: 'app/pages/quotes/quoteFor/modals/downloadQuote.html',
        controller: 'QuoteForController',
        controllerAs: 'quoteForCtrl',
        autoWrap: false,
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: true
      }).then(function () {
        toastr.info('Quote downloading. Make sure your browser is not "blocking popups".');
        ContentService.downloadReport(vm.quote.id, function (response) {
          vm.downloaded = true;
          $window.open(response.data.urls_spreadsheet_doc, '_blank');
        }, function (err) {
          $log.error(err);
        });
      });
    }

    function upload(campaignName) {
      var template = $interpolate(
        '<md-dialog class="file-content" aria-label="{{ ariaLabel }}">' +
        '<file-upload-dialog title="{{ title }}" file-ext=".csv"></file-upload-dialog></md-dialog>');
      $mdDialog.show({
        template: template({
          ariaLabel: 'Upload file',
          title: 'Upload Order for ' + campaignName
        }),
        autoWrap: false,
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: true
      }).then(function (file) {
        ContentService.uploadReport(vm.quote.id, file, function (response) {
          var count = response.data.processed_count;
          toastr.success('Successfully uploaded ' + count + ' articles for this order.');
          RoutesService.mainQuotes();
        }, function (err) {
          toastr.error("Sorry, there was an error processing your upload. Please try again or contact us and we'll help sort it out!");
          $log.error(err);
        });
      });
    }

    function prepareForSubmit(url) {
      if (!url.checked) {
        url.checked = true;
        toggle(url);
      }
    }

    function urlNotPaused(url) {
      return url.state !== PUB_URL_STATE.PAUSED;
    }

    function close() {
      $mdDialog.hide();
    }

    $scope.preventPanelClick = function (event) {
      event.stopPropagation();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes.main', [])
    .controller('QuotesMainController', QuotesMainController);

  /* @ngInject */
  function QuotesMainController($rootScope) {
    var vm = this;

    // Accessible attributes
    // 'activeQuotes' or 'pendingQuotes'
    vm.quotesTab = 'activeQuotes';

    // Accessible functions
    vm.setQuotesTab = setQuotesTab;
    vm.activeQuotesOn = activeQuotesOn;

    function setQuotesTab(selTab) {
      vm.quotesTab = selTab === 'activeQuotes' ? 'activeQuotes' : 'pendingQuotes';
    }

    function activeQuotesOn() {
      return vm.quotesTab === 'activeQuotes';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes.pending', [])
    .controller('QuotesPendingController', QuotesPendingController);

  /* @ngInject */
  function QuotesPendingController($log, $rootScope, toastr, ContentService, $mdDialog, lodash) {
    var vm = this;

    // Accessible attributes
    vm.contents = [];
    vm.activeItem;
    vm.perPage = 20;
    vm.dirId = 'Pending';
    vm.initialized = false;

    // Accesible functions
    vm.showQuotesFrom = showQuotesFrom;
    vm.goTop = goTop;
    vm.getDoingContentText = getDoingContentText;
    vm.toggleQuote = toggleQuote;
    vm.hideQuote = hideQuote;
    vm.deleteQuote = deleteQuote;

    initialize();

    // Functions
    function initialize() {
      ContentService.indexPendingContents(function (response) {
        vm.contents = response.data.contents;
        $rootScope.quotesPending = vm.contents.length
        vm.initialized = true;
      }, function () {
        vm.initialized = true;
        $log.error('Error retrieving received content.');
        toastr.error('There was an error retrieving received content. Please try again.')
      });
    }

    function showQuotesFrom(item) {
      vm.activeItem = item;
    }

    function goTop() {
      $anchorScroll('top');
    }

    function getDoingContentText(quote) {
      return quote.agency_content ? 'Agency will do content' : 'Scalefluence will do content';
    }

    function toggleQuote(quote) {
      quote.show = !quote.show;
    }

    function hideQuote(quote) {
      quote.show = false;
    }

    function deleteQuote(quoteId) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure you want to delete?')
        .textContent('This quote will be removed permanently.')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        ContentService.deleteQuote(quoteId, function () {
          lodash.remove(vm.contents, function (quote) {
            return quote.id === quoteId;
          });
          $rootScope.quotesPending = vm.contents.length;
          toastr.success('The quote was removed successfully.');
        }, function () {
          toastr.error('There was an error deleting the quote. Please try again.')
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes.newQuote', [])
    .controller('NewQuoteController', NewQuoteController);

  /* @ngInject */
  function NewQuoteController($state, $log, $mdDialog, toastr, CampaignsService, ContentService, AUTHOR_QUOTE, $location, EnvironmentConfig, RoutesService, AccountService, $rootElement, $scope) {
    var vm = this;

    // Accessible attributes
    vm.categories = [];
    vm.campaigns = [];
    vm.content = {
      campaign: null,
      categories: [],
      minTF: 10,
      maxTF: 100,
      minDA: 10,
      maxDA: 100,
      minDR: 0,
      maxDR: 100,
    };
    vm.da_range = {
      options: {
        floor: 10,
        ceil: 100,
        step: 10,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        showTicksValues: true
      }
    };
    vm.tf_range = {
      options: {
        floor: 10,
        ceil: 100,
        step: 10,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        showTicksValues: true
      }
    };
    vm.dr_range = {
      options: {
        floor: 0,
        ceil: 100,
        step: 10,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        showTicksValues: true
      }
    };
    vm.searchTextCampaign = '';

    // Accessible functions
    vm.submit = submit;
    vm.getCampaign = getCampaign;
    vm.showInfo = showInfo;
    vm.showAuthorErrorMessage = showAuthorErrorMessage;
    vm.showNofollowErrorMessage = showNofollowErrorMessage;
    vm.showAuthorContent = showAuthorContent;
    vm.setAuthorAgency = setAuthorAgency;
    vm.setAuthorScalefluence = setAuthorScalefluence;
    vm.setNoFollow = setNoFollow;
    vm.querySearchCampaign = querySearchCampaign;
    vm.displayRowGridPrice = displayRowGridPrice;

    $scope.close = function () {
      $mdDialog.cancel();
    }

    initialize();

    // Functions
    function initialize() {
      confirmAuthorized();

      vm.showAuthorError = false;
      CampaignsService.indexScopedCampaigns('active', function (response) {
        vm.campaigns = response.data.campaigns;
        if (angular.isDefined($location.search().campaign_id)) {
          for (var i = 0; i < vm.campaigns.length; i++) {
            if (vm.campaigns[i].id == $location.search().campaign_id) {
              vm.content.campaign = vm.campaigns[i];
              break;
            }
          }
        }
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        } else {
          $log.error('Error retrieving the campaigns.');
          toastr.error('There was an error retrieving the campaigns.');
        }
      });
    }

    function confirmAuthorized() {
      AccountService.getAdvertiser(function (response) {
        vm.roles = response.data.roles;
        var adv_can_create_quotes = false;
        if (!response.data.parent_id) {
          adv_can_create_quotes = true;
        } else {
          for (var i = 0; i < vm.roles.length; i++) {
            if (vm.roles[i].name === 'create_quotes') {
              adv_can_create_quotes = true;
              break;
            }
          }
        }
        if (!adv_can_create_quotes) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving user info.')
      });
    }

    function getCampaign() {
      if (vm.content.campaign != null && angular.isDefined(vm.content.campaign.id)) {
        vm.content.categories = vm.content.campaign.categories;
        return vm.content.campaign.name;
      } else {
        return 'Please select a campaign';
      }
    }

    function submit() {
      if (!vm.contentAuthor) {
        vm.showAuthorError = true;
        toastr.error('Select who is doing content please.');
      } else if (angular.isUndefined(vm.includeNoFollow)) {
        vm.showNofollowError = true;
        toastr.error('Please indicate whether or not to include no-follow blogs.');
      } else if (vm.content.minDA === 10 && vm.content.maxDA === 100) {
        toastr.error('Please give a spread of Domain Authority metrics you would like. Trust flow is not required.');
      } else {
          vm.content.agency_content = vm.contentAuthor === AUTHOR_QUOTE.AGENCY ? true : false;
          vm.content.include_no_follow = vm.includeNoFollow;
          ContentService.createContent(vm.content, function () {
            $state.go('quotes-main');
            toastr.success('You content was created succesfuly.');
          }, function () {
            $log.error('Error creating the content request.');
            toastr.error('There was an error creating the content request. Please try again.');
          });
      }
    }

    function showAuthorContent() {
      return showAlertHTML('Who is doing content?', 'If your agency chooses ' +
      'to do the content, we will drop the price of each publisher by ' +
      '$50.', 'Ok').then(function (result) {
        return false;
      });
    }

    function showInfo() {
      return showAlertHTML('Higher Authority = Higher Price', 'Please give us a range to select publishers. ' +
        'Most agencies give a range of 30 to 40 points for both Domain Authority and Trust Flow. ' +
        '<br> <br>' +
        'REMEMBER: The higher the authority, the more expensive the link. ' +
        'Assume DA 40 is around $200. Assume DA 60+ is around $350 or more. ', 'Ok').then(function (result) {
        return false;
      });
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function showAuthorErrorMessage() {
      return vm.contentAuthor ? '' : 'Must select who is doing content!';
    }

    function showNofollowErrorMessage() {
      return angular.isDefined(vm.includeNoFollow) ? '' : 'Must select whether or not to include no-follow blogs!';
    }

    function setAuthorAgency() {
      vm.contentAuthor = AUTHOR_QUOTE.AGENCY;
    }

    function setAuthorScalefluence() {
      vm.contentAuthor = AUTHOR_QUOTE.SF;
    }

    function setNoFollow(doInclude) {
      vm.includeNoFollow = doInclude;
    }

    function querySearchCampaign(query) {
      var results = query ? vm.campaigns.filter(createFilterForCampaigns(query)) : vm.campaigns;
      return results;
    }

    function createFilterForCampaigns(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(campaign) {
        return (campaign.name.toLowerCase().indexOf(lowercaseQuery) >= 0);
      };
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/quotes/newQuote/partials/matrixDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'NewQuoteController',
        preserveScope: true,
        clickOutsideToClose: true,
        fullscreen: true
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.newV1', [])
    .controller('NewProfileV1Controller', NewProfileV1Controller);

  /** @ngInject */
  function NewProfileV1Controller($scope, $log, $mdDialog, $mdMedia, $rootElement, $rootScope,
                                $anchorScroll, $location, toastr, lodash, EnvironmentConfig, RoutesService,
                                ProfilesService, SocialHandlesService, PricesService, PricingService,
                                GoogleService, FacebookService, PROFILE_TYPE, SOCIAL, MIN_VALUES, SCOPE,
                                StorageService, NEW_PROFILE, $window, SOCIAL_PRICES, WEB_CONTENT_PRICES
  ) {
    var vm = this;
    const TABS = 4;

    var params = $location.search();
    $location.search({});

    var igAuthCode = params.ig_auth_code;
    var igUserId = params.ig_user_id;
    var twitterFollowersCount = params.twitter_followers_count;
    var twitterNickname = params.twitter_nickname;

    // Accessible attributes
    $rootScope.da;
    $rootScope.tf;
    $scope.da;
    $scope.tf;
    $scope.close = function () {
      $mdDialog.cancel();
    };

    vm.domInfo;
    vm.selectedIndex = getKey('newProfileSelectedIndex') || 0;
    vm.selectedSocialIndex = getKey('newProfileSelectedSocialIndex') || 0;
    vm.stepsLocker = getKey('newProfileStepsLocker') || [false, false, false, false, false];
    vm.stepNames = NEW_PROFILE.STEP_NAMES;
    vm.influencer = {
      description: ''
    };
    vm.url = {
      description: getKey('newProfileDescription') || '',
      href: getKey('newProfileUrl') || '',
      price: getKey('newProfileUrlPrice') || '',
      author_page: getKey('newProfileUrlAuthorPage') || '',
      required_length: getKey('newProfileUrlRequiredLength'),
      follow_link: getKey('newProfileUrlFollowLink'),
      allow_blog_post: getKey('newProfileUrlFollowLink'),
      allow_home_page: getKey('newProfileUrlAllowHomepage')
    };
    vm.profile = {
      categories_ids: [],
      urls: [],
      pets: getKey('newProfilePets') || [],
      languages: getKey('newProfileLanguages') || [],
      facebook_handle: {
        name: 'FACEBOOK',
        social_prices: SOCIAL_PRICES.FACEBOOK.FIELDS
      },
      twitter_handle: {
        name: 'TWITTER',
        social_prices: SOCIAL_PRICES.TWITTER.FIELDS
      },
      instagram_handle: {
        name: 'INSTAGRAM',
        social_prices: SOCIAL_PRICES.INSTAGRAM.FIELDS
      },
      youtube_handle: {
        name: 'YOUTUBE',
        social_prices: SOCIAL_PRICES.YOUTUBE.FIELDS
      },
      web_content: {
        web_content_prices: WEB_CONTENT_PRICES.FIELDS,
        href: getKey('newProfileWebContentHref') || ''
      },
      audience: {
        audience_gender: getKey('newProfileAudienceGenderGroup') || '',
        estimated_income: getKey('newProfileAudienceEstimatedIncome') || '',
        ethnicities: getKey('newProfileAudienceEthnicities') || [],
        age_groups: getKey('newProfileAudienceAgeGroups') || []
      }
    };

    vm.web_content = {
      muv: getKey('newProfileWebContentMuv') || ''
    };
    vm.gaValidating = false;
    vm.categories = [];
    vm.seoFirstTime = true;
    vm.disableSEO = false;
    vm.profileNames = [];
    vm.canContinue = false;
    vm.analytics = getKey('newProfileGoogleAnalytics') || [];
    vm.selectedAnalytics = {};
    vm.initialAnalytics = {};
    vm.analyticsAuthorized = false;
    vm.showProgressCircular = false;
    vm.showHomePageError = false;
    vm.showFollowLinkError = false;
    vm.showAllowBlogPostError = false;
    vm.priceLabel = '';
    vm.domainUrlValid = false;
    vm.categoriesOn = true;
    vm.ethnicitiesOn = true;
    vm.petsOn = true;
    vm.languagesOn = true;
    vm.ageGroupOn = true;
    vm.showFormErrors = false;
    vm.form = {};
    vm.state = "";
    vm.ethnicitiesList = NEW_PROFILE.ETNIC_GROUPS;
    vm.audienceGenderList = NEW_PROFILE.GENDER_LIST;
    vm.audienceEstimatedIncomes = NEW_PROFILE.AUDIENCE_ESTIMATED_INCOMES;
    vm.languagesList = NEW_PROFILE.LANGUAGES_LIST;
    vm.ageGroupList = NEW_PROFILE.AGE_GROUPS;
    vm.petsList = NEW_PROFILE.PETS_LIST;

    // Accessible functions
    vm.next = next;
    vm.previous = previous;
    vm.nextDisabled = nextDisabled;
    vm.showDialog = showDialog;
    vm.showPriceSEO = showPriceSEO;
    vm.showPriceGa = showPriceGa;
    vm.lastStep = lastStep;
    vm.submit = submit;
    vm.getCurrentStepName = getCurrentStepName;
    vm.checkAvatar = checkAvatar;
    vm.getMetaDescription = getMetaDescription;
    vm.noSocialHandlesSet = noSocialHandlesSet;
    vm.noWebContentSet = noWebContentSet;
    vm.setSocialHandles = setSocialHandles;
    vm.getDescriptionTitle = getDescriptionTitle;
    vm.getTileForInfluencersDescription = getTileForInfluencersDescription;
    vm.checkGAMinValues = checkGAMinValues;
    vm.checkSocialMinValues = checkSocialMinValues;
    vm.cantSubmit = cantSubmit;
    vm.setAsInfluencer = setAsInfluencer;
    vm.setAsBroker = setAsBroker;
    vm.setAsContributor = setAsContributor;
    vm.setAsBlogger = setAsBlogger;
    vm.isInfluencer = isInfluencer;
    vm.isBroker = isBroker;
    vm.isContributor = isContributor;
    vm.isBlogger = isBlogger;
    vm.influencer = influencer;
    vm.blogger = blogger;
    vm.broker = broker;
    vm.contributor = contributor;
    vm.oneProductIsSet = oneProductIsSet;
    vm.getFinishText = getFinishText;
    vm.getNextSocialButtonText = getNextSocialButtonText;
    vm.showInfo = showInfo;
    vm.isInvalidProfileName = isInvalidProfileName;
    vm.checkSEO = checkSEO;
    vm.setPriceLabel = setPriceLabel;
    vm.getPricingLabel = getPricingLabel;
    vm.getPricingLabelGA = getPricingLabelGA;
    vm.showWarningPopup = showWarningPopup;
    vm.authorize = authorize;
    vm.analyticSelected = analyticSelected;
    vm.showHomePageErrorMessage = showHomePageErrorMessage;
    vm.showFollowLinkErrorMessage = showFollowLinkErrorMessage;
    vm.setContentType = setContentType;
    vm.typeSelected = typeSelected;
    vm.authenticateTwitter = authenticateTwitter;
    vm.handleFacebookAuthentication = handleFacebookAuthentication;
    vm.toggleCategories = toggleCategories;
    vm.toggleElements = toggleElements;
    vm.categoriesActionMsg = categoriesActionMsg;
    vm.ethnicitiesActionMsg = elementsActionMsg;
    vm.setUrlRequiredLength = setUrlRequiredLength;
    vm.setUrlAllowHomepage = setUrlAllowHomepage;
    vm.setUrlFollowLink = setUrlFollowLink;
    vm.setUrlAllowBlogPost = setUrlAllowBlogPost;
    vm.disconnectSocial = disconnectSocial;
    vm.disconnectGA = disconnectGA;
    vm.getPropertyLabelGA = getPropertyLabelGA;
    vm.gaPriceChangeEnabled = gaPriceChangeEnabled;
    vm.updateDomain = updateDomain;
    vm.setNewProfileUrl = setNewProfileUrl;
    vm.setNewProfileName = setNewProfileName;
    vm.setNewProfileDescription = setNewProfileDescription;
    vm.setNewProfileUrlPrice = setNewProfileUrlPrice;
    vm.setNewProfileSocialPrice = setNewProfileSocialPrice;
    vm.setNewProfileAuthorPage = setNewProfileAuthorPage;
    vm.setNewProfileWebContentPrice = setNewProfileWebContentPrice;
    vm.setAudienceGenderGroup = setAudienceGenderGroup;
    vm.setAudienceEstimatedIncome = setAudienceEstimatedIncome;
    vm.getAuthURL = getAuthURL;
    vm.setSocialTab = setSocialTab;
    vm.setSubtype = setSubtype;
    vm.handleFacebookConnection = handleFacebookConnection;
    vm.handleInstagramConnection = handleInstagramConnection;
    vm.handleYoutubeConnection = handleYoutubeConnection;
    vm.handelTwitterConnection = handelTwitterConnection;
    vm.checkSocialPrices = checkSocialPrices;
    vm.setSocialIndex = setSocialIndex;

    init();

    function init() {
      vm.analyticsAuthorized = getKey('newProfileAnalyticsAuthorized') || false;
      var selectedAnalytics = getKey('newProfileSelectedAnalytics');
      if (selectedAnalytics) {
        var parsedAnalytics = JSON.parse(selectedAnalytics);
        vm.selectedAnalytics = parsedAnalytics;
        vm.selectedAnalytics.selected = parsedAnalytics.name;
        setWebContent(vm.selectedAnalytics);
        getPricingLabelGA('GA');
      } else {
        vm.selectedAnalytics = vm.initialAnalytics
      }

      $scope.$mdMedia = $mdMedia;
      vm.profile.profileType = getKey('newProfileType') || '';
      vm.profile.name = getKey('newProfileName') || '';
      vm.profile.contentType = getKey('newProfileUrlContentType') || '';
      vm.showTypeError = false;
      vm.showMissingContentTypeError = false;
      vm.profileTypeOld = vm.profile.profileType;

      ProfilesService.getProfileNames(function (response) {
        vm.profileNames = response.data.profile_names;
      });

      ProfilesService.getProfileSocialUrls(function (response) {
        vm.profileSocialUrls = response.data.profile_social_urls;
        if (igAuthCode && igUserId) {
          ProfilesService.verifyInstagramAccount(igAuthCode, igUserId, function (response) {
            var username = response.data.username;
            if (checkExistedSocialAccount('instagram', username)) {
              showUseAnotherAccountModal(vm.profile.instagram_handle, 'instagram')
            } else {
              getInstagramFollowers(username);
            }
          }, function (error) {
            console.log(error);
          });
        }
      });

      // Add one blank item per social handle
      setSocialHandles(SOCIAL.Facebook);
      setSocialHandles(SOCIAL.Twitter);
      setSocialHandles(SOCIAL.Youtube);
      setSocialHandles(SOCIAL.Instagram);

      if (twitterFollowersCount && twitterNickname) {
        loadSocialHandle(vm.profile.twitter_handle, 'twitter', twitterNickname, twitterFollowersCount)
      }
    }

    function getInstagramFollowers(username) {
      ProfilesService.getInstagramData(username, function (response) {
        var followersCount = response.data.qty_followers;
        if (followersCount == null) {
          // followersCount = MIN_VALUES.SOCIAL;
          return $mdDialog.show($mdDialog.alert()
            .title('')
            .textContent('Hey ' + username + ',  seems like Instagram is taking longer than normal. Nothing to worry about. Should only be a moment longer.  Remember, after we get the data, click the orange ? icon to see what our suggested pricing is.')
            .escapeToClose(false)
            .ok('Ok')
          )
          .then(function(result) {
            getInstagramFollowers(username);
          });
        }

        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, followersCount);
      }, function (error) {
        console.log(error);
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, MIN_VALUES.SOCIAL);
      });
    }

    function analyticSelected() {
      vm.showProgressCircular = true;
      var domain = vm.url.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
      if (!vm.selectedAnalytics.websiteUrl.includes(domain)) {
        toastr.error('The selected analytics property does not match the website you are attempting to validate.');
        vm.showProgressCircular = false;
        return false;
      }
      setKey('newProfileSelectedAnalytics', JSON.stringify(vm.selectedAnalytics));
      setKey('newProfileWebContentHref', vm.profile.web_content.href);
      GoogleService.queryProfiles(vm.selectedAnalytics, handleProfiles, function (err) {
        $log.error(err);
      });
    }

    function setWebContent(selectedAnalytics) {
      vm.profile.web_content.ga_account_id = selectedAnalytics.accountId;
      vm.profile.web_content.ga_profile_id = selectedAnalytics.id;
      vm.profile.web_content.website_url = selectedAnalytics.websiteUrl;
      vm.profile.web_content.href = selectedAnalytics.selfLink;
      vm.profile.web_content.muv = vm.web_content.muv;
      lodash.map(vm.profile.web_content.web_content_prices, function (price) {
        price.price = getKey(price.key)
      })
    }

    function showFollowLinkErrorMessage() {
      return 'You MUST select one option.';
    }

    function showHomePageErrorMessage() {
      return 'You MUST select one option.';
    }

    function authorize(event, isYoutube, socialHandle) {
      GoogleService.authorize(event, function (response) {
        if (response.error) {
          vm.hidden = false;
        } else {
          vm.hidden = true;
          if (isYoutube) {
            getYouTubeFollowers(socialHandle);
          } else {
            queryAccounts();
          }
        }
      });
    }

    function queryAccounts() {
      vm.analytics = [];
      vm.showProgressCircular = true;
      GoogleService.queryAccounts(handleAccounts, function (error) {
        toastr.error('No Google Analytics account found');
        vm.showProgressCircular = false;
      });
    }

    function handleAccounts(response) {
      var accounts = response.result.items;
      if (accounts && accounts.length) {
        console.log("Analytics authorized");
        vm.analyticsAuthorized = true;
        setKey('newProfileAnalyticsAuthorized', vm.analyticsAuthorized);
        vm.showProgressCircular = true;
        lodash.map(accounts, function (account) {
          GoogleService.queryProperties(account, handleProperties, function (err) {
            $log.error(err);
            vm.showProgressCircular = false;
          });
        })
      } else {
        $log.log('There are no accounts to show');
      }
    }

    function getAuthURL() {
      ProfilesService.getInstagramAuthUrl('new', null, function (response) {
        if (response.data.auth_url) {
          $window.location.href = response.data.auth_url;
        }
      }, function (error) {
        console.log(error)
      });
    }

    function handleProperties(response) {
      var properties = response.result.items;
      if (properties && properties.length) {
        lodash.map(properties, function (property) {
          vm.analytics.push(property);
          setKey('newProfileGoogleAnalytics', vm.analytics)
        })
      } else {
        $log.log('There are no properties to show');
      }
      vm.showProgressCircular = false;
    }

    function handleProfiles(response) {
      var profiles = response.result.items;
      if (profiles && profiles.length) {
        var firstProfileId = profiles[0].id;
        GoogleService.queryCoreReportingApi(firstProfileId, handleReports, function (err) {
          vm.showProgressCircular = false;
          $log.error(err);
          toastr.error(err.result.error.message);
          disconnectGA(false);
          handleReportsAlt();
        });
      } else {
        $log.log('There are no profiles to show');
      }
    }

    function handleReports(response) {
      var formattedJson = JSON.stringify(response.result, null, 2);
      vm.web_content.muv = parseInt(response.result.totalsForAllResults['ga:users']);

      if (vm.web_content.muv == 0) {
        handleReportsAlt();
      } else {
        setKey('newProfileWebContentMuv', vm.web_content.muv);
        checkGAMinValues();
        getPricingLabelGA('GA');
        setWebContent(vm.selectedAnalytics);

        $scope.followers = vm.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          'Should be placed on front page for best performance.';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'You have ' + vm.web_content.muv + ' Monthly Visitors';

        vm.showProgressCircular = false
      }
    }

    // sometimes there is an error getting api info from google when a property is selected,
    // so we can use this as a backup option (ask user to manually provide monthly visitors)
    function handleReportsAlt() {
      $mdDialog.show({
        controller: 'MonthlyVisitorsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfileV1/partials/monthlyVisitorsDialog.html',
        clickOutsideToClose: false
      }).then(function (response) {
        vm.web_content.muv = parseInt(response);
        vm.showProgressCircular = false
        checkGAMinValues();
      }, function() {
        vm.showProgressCircular = false
        console.log('error');
      });
    }

    // Functions for Gbutton
    // window.authorize = authorize;

    function toggleLock(positions, lock) {
      lodash.map(positions, function (pos) {
        vm.stepsLocker[pos] = lock;
      });
      setKey('newProfileStepsLocker', vm.stepsLocker);
    }

    function previousStepsUnlock(position) {
      if (position == 0) {
        return !vm.stepsLocker[position];
      }
      return lodash.reduce(vm.stepsLocker.slice(0, position), function (carry, n) {
        return carry && !n;
      }, true);
    }

    function setSocialHandles(socialHandle) {
      var savedSocialHandle = getKey(switchSocialKey(socialHandle));
      var field = socialHandle.concat('_handle');

      if (savedSocialHandle) vm.profile[field] = savedSocialHandle;
      loadAdditionalPrices(socialHandle);
    }

    function loadAdditionalPrices(socialHandle) {
      switch (socialHandle) {
        case SOCIAL.Facebook:
          vm.facebookPrice = getKey('newProfileFacebookPrice');
          vm.facebookVideoPrice = getKey('newProfileFacebookVideoPrice');
          break;
        case SOCIAL.Twitter:
          vm.twitterPrice = getKey('newProfileTwitterPrice');
          vm.twitterVideoPrice = getKey('newProfileTwitterVideoPrice');
          break;
        case SOCIAL.Youtube:
          vm.youtubePrice = getKey('newProfileYoutubePrice');
          vm.youtubeVideoPrice = getKey('newProfileYoutubeVideoPrice');
          break;
        case SOCIAL.Instagram:
          vm.instagramPrice = getKey('newProfileInstagramPrice');
          vm.instagramVideoPrice = getKey('newProfileInstagramVideoPrice');
      }
    }

    function showPriceGa(network, socialHandle, display) {
      if (network == 'GA') {
        if (angular.isDefined(vm.web_content.muv)) {
          $scope.followers = 0;
        }
        checkGAMinValues(display);
      } else {
        if (angular.isUndefined(socialHandle.followers)) {
          $scope.followers = 0;
          $scope.network = '';
        }
        checkSocialMinValues(network, socialHandle, display)
      }
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/newProfileV1/partials/rowDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'NewProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function checkAvatar(ev, tabSelection) {
      // if (!vm.profile.image && typeSelected() && contentTypeSelected()) {
      if (!vm.profile.image && typeSelected()) {
        var confirm = $mdDialog.confirm()
          .title('Upload a Photo!')
          .textContent('Profiles with Photos receive far more work than those that don\'t!')
          .targetEvent(ev)
          .ok('Ok Do it Now!')
          .cancel('No Thanks.');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 0;
          setProfileSelectedIndex();
          var photoEl = angular.element(document.querySelector('#new-prof-photo'));
          photoEl.removeClass('atn-flash');
          photoEl.hide();
          photoEl.show();
          photoEl.addClass('atn-flash');
        }, function () {
          // if (!tabSelection && typeSelected() && contentTypeSelected()) {
          if (!tabSelection && typeSelected()) {
            findNextIndex();
          }
        });
      } else if (!tabSelection && typeSelected()) {
        findNextIndex();
      }
    }

    function findNextIndex() {
      var pos = lodash.findIndex(vm.stepsLocker, function (step, index) {
        return !step && index > vm.selectedIndex;
      });
      vm.selectedIndex = Math.max(pos, 0);

      setProfileSelectedIndex();
    }

    function setAsInfluencer() {
      vm.profile.profileType = PROFILE_TYPE.INFLUENCER;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function setAsBlogger() {
      vm.profile.profileType = PROFILE_TYPE.BLOGGER;
      vm.showTypeError = false;
      setNewProfileType();
    }

    function setAsBroker() {
      vm.profile.profileType = PROFILE_TYPE.BROKER;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function setAsContributor() {
      vm.profile.profileType = PROFILE_TYPE.CONTRIBUTOR;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function isInfluencer() {
      return vm.profile.profileType == PROFILE_TYPE.INFLUENCER;
    }

    function isBlogger() {
      return vm.profile.profileType == PROFILE_TYPE.BLOGGER;
    }

    function isBroker() {
      return vm.profile.profileType == PROFILE_TYPE.BROKER;
    }

    function isContributor() {
      return vm.profile.profileType == PROFILE_TYPE.CONTRIBUTOR;
    }

    function influencer() {
      return PROFILE_TYPE.INFLUENCER;
    }

    function blogger() {
      return PROFILE_TYPE.BLOGGER;
    }

    function broker() {
      return PROFILE_TYPE.BROKER;
    }

    function contributor() {
      return PROFILE_TYPE.CONTRIBUTOR;
    }

    function isInvalidProfileName() {
      var invalid = false;
      lodash.map(vm.profileNames, function (name) {
        if (vm.profile.name && (vm.profile.name.toUpperCase() == name.toUpperCase())) {
          invalid = true;
        }
      });
      return invalid;
    }

    function nextDisabled() {
      var lock;
      switch (vm.selectedIndex) {
        case 0:
          lock = !vm.profile.name;
          if (vm.profile.profileType != vm.profileTypeOld) {
            vm.profileTypeOld = vm.profile.profileType;
            toggleLock([1, 2, 3, 4], true);
            var name = vm.profile.name;
            var image = vm.profile.image;
            vm.profile.name = name;
            vm.profile.image = image;
            vm.profile.profileType = vm.profileTypeOld;
          }

          if (isBlogger()) {
            toggleLock([1, 2, 3, 4], false);
          } else if (isInfluencer()) {
            toggleLock([1, 3], false);
            toggleLock([2, 4], true);
          } else if (isContributor() || isBroker()) {
            toggleLock([1, 4], false);
          }
          return lock;
          break;
        case 1:
          lock = !isDomainInfoCompleted();
          return lock;
          break;
        case 2:
          lock = !isAnalyticsCompleted();
          toggleLock([3, 4], false);
          setUrl();
          return lock;
          break;
        case 3:
          return false;
          break;
        case 4:
          if (vm.seoFirstTime || (vm.oldUrl != vm.url.href)) {
            vm.seoFirstTime = false;
          }
      }
      return true;
    }

    /* STEP 2 */
    function setUrl() {
      if (!vm.oldUrl) {
        vm.oldUrl = vm.url.href;
      }
    }

    function lockStepInvalidName(step) {
      if (isInvalidProfileName()) {
        toggleLock([step], true);
      } else {
        toggleLock([step], !vm.profile.name);
      }
    }

    ////////// Checks for each step (start) //////////
    /* STEP 2 */
    function isDomainInfoCompleted() {
      if (vm.isInfluencer()) {
        return vm.url.description && vm.categories.length;
      }
      return vm.url.href && vm.url.description && vm.categories.length;
    }

    function isAudienceInfoCompleted() {
      return vm.profile.audience.audience_gender && vm.profile.audience.estimated_income &&
        vm.profile.audience.ethnicities.length && vm.profile.audience.age_groups.length &&
        vm.profile.pets.length && vm.profile.languages.length
    }

    function isAudienceInfoCompletedPartially() {
      return vm.profile.audience.audience_gender || vm.profile.audience.estimated_income ||
        vm.profile.audience.ethnicities.length || vm.profile.audience.age_groups.length ||
        vm.profile.pets.length || vm.profile.languages.length
    }

    /* STEP 3 */
    function isAnalyticsCompleted() {
      return lodash.findIndex(vm.profile.web_content.web_content_prices, function (content_price) {
        if (bothSetOrEmpty(vm.profile.web_content.href, content_price.price)) {
          return true;
        }
      }) !== -1;
    }

    /* STEP 4 */

    ////////// Checks for each step (end) //////////
    function emptyFields(val1, val2) {
      return !(val1 || val2);
    }

    function bothSetOrEmpty(value1, value2) {
      return (value1 && value2) || emptyFields(value1, value2);
    }

    function getMetaDescription() {
      ProfilesService.getMetaDescription(vm.url.href, function (response) {
        vm.url.description = response.data.description;
      }, function (response) {
        toastr.error(response.data.error);
      });
    }

    /* STEP 3 */
    function checkGAMinValues(display) {
      if (vm.profile.web_content.href) {
        if (vm.web_content.muv < MIN_VALUES.GA) {
          showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of 3000 unique visitors ' +
            'per month to participate in this product. You currently do not meet ' +
            'that criteria. When you do reach that traffic, you can come back to ' +
            'this profile and submit it then.', 'Ok I understand').then(function (result) {
            toggleLock([3, 4], false);
            vm.profile.web_content.href = '';
            vm.profile.web_content.price = '';
          });
        } else {
          $scope.followers = vm.web_content.muv;
          $scope.network = 'GA';
          $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
          // $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          //   'Should be placed on front page for best performance.';
          $scope.content = 'According to Google, your site had ' + vm.web_content.muv + ' visits last month. Below is our suggested payout for a blog post. You can put any price you want. This is only a suggestion based on your traffic.';
          $scope.contentLineTwo = 'Content must be up 6 months or longer.';
          $scope.header = 'You have ' + vm.web_content.muv + ' Monthly Visitors';
          if (display) {
            displayRowGridPrice();
          }
        }
      } else {
        // vm.web_content.muv = '';
        getPricingLabelGA('GA');
      }
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showPriceSEO() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/newProfileV1/partials/gridDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'NewProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    /* STEP 4 */
    function getHandleFromType(type) {
      var handle = {};
      switch (type) {
        case SOCIAL.Facebook:
          handle = vm.profile.facebook_handle;
          break;
        case SOCIAL.Twitter:
          handle = vm.profile.twitter_handle;
          break;
        case SOCIAL.Youtube:
          handle = vm.profile.youtube_handle;
          break;
        case SOCIAL.Instagram:
          handle = vm.profile.instagram_handle;
          break;
      }
      return handle;
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function checkSocialMinValues(type, socialMedia, display) {
      if (!socialMedia.url) {
        socialMedia.followers = '';
        getPricingLabel(socialMedia, type);
      } else {
        var handle = getHandleFromType(type);
        if (socialMedia.followers < MIN_VALUES.SOCIAL) {
          clearSocial(handle, type);
          showAlert('Minimum followers', "We're sorry but we require a minimum of " +
            MIN_VALUES.SOCIAL + " followers for this account to be approved. " +
            "Please come back and connect your account when you have at least that many. " +
            "Thank you!", 'Ok I understand').then(function (result) {
            toggleLock([3, 4], false);
          });
        } else {
          var price = PricingService.getPrice(socialMedia.followers, type);
          var videoPrice = PricingService.getVideoPrice(socialMedia.followers, type);
          if (type === 'facebook') {
            var sharingPrice =  PricingService.getSharingPrice(socialMedia.followers, type);
            setKey(type + 'SharingPrice', sharingPrice);
          }
          setKey('newProfile' + capitalizeFirstLetter(type) + 'Price', price);
          setKey('newProfile' + capitalizeFirstLetter(type) + 'VideoPrice', videoPrice);

          socialMedia.suggested_post_price = price;
          socialMedia.suggested_video_price = videoPrice;
          socialMedia.suggested_sharing_price = sharingPrice;

          switch (type) {
            case 'facebook':
              vm.facebookPrice = price;
              vm.facebookVideoPrice = videoPrice;
              var sharingPrice = PricingService.getSharingPrice(socialMedia.followers, type);
              vm.facebookSharingPrice = sharingPrice;
              setKey('newProfile' + capitalizeFirstLetter(type) + 'SharingPrice', sharingPrice);
              break;
            case 'instagram':
              vm.instagramPrice = price;
              vm.instagramVideoPrice = videoPrice;
              break;
            case 'youtube':
              vm.youtubePrice = price;
              vm.youtubeVideoPrice = videoPrice;
              break;
            case 'twitter':
              vm.twitterPrice = price;
              vm.twitterVideoPrice = videoPrice;
              break;
          }
          $scope.followers = socialMedia.followers;
          $scope.network = type;
          $scope.rowHeader = 'Suggested Pricing for ' + type;
          $scope.content = 'According to ' + capitalizeFirstLetter(type) + ', you have ' + socialMedia.followers + ' followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.';
          $scope.contentLineTwo = 'For your protection, this content will be disclosed per FTC guidelines.';
          $scope.header = 'Followers';
          if (display) {
            displayRowGridPrice();
          }
        }
      }
    }

    function clearSocial(handle, type) {
      lodash.forEach(Object.keys(handle), function (key) {
        if (key !== 'social_prices') delete handle[key];
        lodash.forEach(handle.social_prices, function (item) {
          delete item.price
        });
      });
      clearSocialPrice(type);
    }

    function typeIsFB(type) {
      return lodash.includes([SOCIAL.Facebook, SOCIAL.Twitter, SOCIAL.Pinterest], type);
    }

    function setSocialIndex(value) {
      clearInstagramSubtype();
      vm.selectedSocialIndex = value;
      setKey('newProfileSelectedSocialIndex', value);
    }

    function clearInstagramSubtype() {
      if (vm.selectedSocialIndex === 1 && !vm.profile.instagram_handle.url && vm.profile.instagram_handle.subtype) {
        vm.profile.instagram_handle.subtype = ''
      }
    }

    function setSocialTab(ev, newSocialIndex) {
      var socialHandle;
      var prices;
      switch (vm.selectedSocialIndex) {
        case 0:
          socialHandle = vm.profile.facebook_handle;
          prices = SOCIAL_PRICES.FACEBOOK;
          break;
        case 1:
          socialHandle = vm.profile.instagram_handle;
          prices = SOCIAL_PRICES.INSTAGRAM;
          break;
        case 2:
          socialHandle = vm.profile.youtube_handle;
          prices = SOCIAL_PRICES.YOUTUBE;
          break;
        case 3:
          socialHandle = vm.profile.twitter_handle;
          prices = SOCIAL_PRICES.TWITTER;
      }
      socialHandle.url ? checkSocialPrices(socialHandle, prices, newSocialIndex) : setSocialIndex(newSocialIndex);
    }

    function setSubtype(socialHandle, subtype) {
      socialHandle.subtype = subtype;
      setKey('newProfileInstagramHandle', socialHandle)
    }

    function checkSocialPrices(socialHandle, prices, newSocialIndex) {
      if (lodash.findIndex(socialHandle.social_prices, function (item) {
        if (item.price) return true
      }) < 0 && newSocialIndex > vm.selectedSocialIndex) {
        showConfirmSocialModal(prices.NAME, newSocialIndex, socialHandle)
      } else {
        setSocialIndex(newSocialIndex)
      }
    }

    function showConfirmSocialModal(socialNetwork, newSocialIndex, socialHandle) {
      var confirmText = 'Please give a price for at least one ' + socialNetwork + ' ad. ' +
        'If you do not give at least one price, then your ' + socialNetwork + ' channel will not be listed to marketers.';
      var confirm = $mdDialog.confirm()
        .title('Are you SURE?!?!')
        .textContent(confirmText)
        .cancel('Skip for now.')
        .ok('Give price now');

      $mdDialog.show(confirm).then(function (result) {
        clearInstagramSubtype();
      }, function () {
        setSocialIndex(newSocialIndex)
      });
    }

    function noSocialHandlesSet(ev, tabSelection) {
      if (!socialMediaProduct()) {
        var confirm = $mdDialog.confirm()
          .title('Are you SURE?!?!')
          .textContent('If you do not submit social handles, you will NOT be able to monetize Tweets and Posts!')
          .targetEvent(ev)
          .ok('Ok I\'ll Do it Now!')
          .cancel('No Thanks.');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 3;
          setProfileSelectedIndex();
        }, function () {
          if (!tabSelection) {
            findNextIndex();
          }
        });
      } else {
        findNextIndex();
      }
    }

    function getCurrentStepName() {
      return vm.stepNames[vm.selectedIndex];
    }

    function next(ev) {
      vm.showFormErrors = false;
      if (nextDisabled()) {
        vm.showFormErrors = true;
        switch (vm.selectedIndex) {
          case 0:
            toastr.error('Please complete required fields on this page.');
            break;
          case 1:
            toastr.error('Please provide a description and select at least one category.');
            break;
          default:
            toastr.error('Please complete required fields on this page.');
            break
        }
        return false;
      }
      switch (vm.selectedIndex) {
        case 0:
          if (vm.isInfluencer()) {
            checkAvatar(ev, false);
            return;
          }
          vm.showTypeError = !typeSelected();
          if (vm.form.$error.required || vm.form.$error.url || vm.form.$error.accepted || vm.form.$error.unmatched || vm.showTypeError) {
            vm.showFormErrors = true;
            return;
          }
          ProfilesService.checkUrl(vm.url.href, function (response) {
            var state = response.data.state;
            switch (state) {
              case "suspended":
                vm.state = "suspended";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "paused":
                vm.state = "paused";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "rejected":
                vm.state = "rejected";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "duplicated":
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('unmatched', false);
                break;
              case "valid":
                vm.showFormErrors = false;
                updateDomain();
                checkAvatar(ev, false);
                break;
            }
          }, function (response) {
            toastr.error(response.data.error || 'Error checking domain url.');
          });
          break;
        case 1:
          if (!isBlogger() && !isInfluencer()) {
            findNextIndex();
          } else {
            if (isAudienceInfoCompleted()) {
              findNextIndex();
            } else {
              vm.showFormErrors = true;
              var confirm;
              if (isAudienceInfoCompletedPartially()) {
                confirm = $mdDialog.confirm()
                  .title('IMPORTANT!')
                  .textContent("It’s better to give fuller information about your audience in order to get more offers")
                  .targetEvent(ev)
                  .ok('I understand')
                  .cancel('I want to skip this');
              } else {
                confirm = $mdDialog.confirm()
                  .title('IMPORTANT!')
                  .textContent("It's important to give information about your audience.")
                  .targetEvent(ev)
                  .ok('I understand')
                  .cancel('I want to skip this');
              }
              $mdDialog.show(confirm).then(function (result) {
                goAudienceBlock();
              }, function () {
                findNextIndex();
              });
            }
          }
          break;
        case 2:
          noWebContentSet(ev, false);
          break;
        case 3:
          noSocialHandlesSet(ev, false);
          setPriceLabel();
          break;
      }
    }

    function previous(ev) {
      var pos = lodash.findLastIndex(vm.stepsLocker, function (step, index) {
        return !step && index < vm.selectedIndex;
      });

      if (isInfluencer() && pos === 1 || isBlogger() && pos === 2) {
        switch (vm.selectedSocialIndex) {
          case 0:
            vm.selectedIndex = Math.max(pos, 0);
            setProfileSelectedIndex();
            break;
          case 1:
            setSocialTab(ev, 0);
            break;
          case 2:
            setSocialTab(ev, 1);
            break;
          case 3:
            setSocialTab(ev, 2);
            break;
        }
      } else {
        vm.selectedIndex = Math.max(pos, 0);
        setProfileSelectedIndex();
      }
    }

    $scope.$on('tab-change', function (event, tabEvent) {
      // TODO: Do nothing when tabs are clicked.
      tabEvent.reject();
    });

    function noWebContentSet(ev, tabSelection) {
      if (!vm.profile.web_content.href) {
        var confirm = $mdDialog.confirm()
          .title('Please Select Analytics Account!')
          .textContent('By selecting an Google Analytics account, you are only authorizing Scalefluence to validate your monthly traffic.' +
            ' This is required for our Sponsored Content product.')
          .targetEvent(ev)
          .ok('Ok Got It!')
          .cancel('Move to next step');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 2;
          setProfileSelectedIndex();
        }, function () {
          if (!tabSelection) {
            findNextIndex();
          }
        });
      } else {
        findNextIndex();
      }
    }

    /* STEP 5 */
    function showSEODialog() {
      showAlert('Minimum Values', 'We apologize but we need a minimum MOZ Domain Authority ' +
        'score of 15. And a minimum of of Majestic Trust Flow score of 5 for ' +
        'you to participate in this product. You currently do not meet one, ' +
        'or both, of these criteria. When you do reach these targets, you can ' +
        'come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
        return false;
      });
    }

    function checkSEO(form) {
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      var valid = regex.test(vm.url.href);
      vm.domainUrlValid = valid;

      if (form.domainUrl) {
        form.domainUrl.$setValidity('url', valid);
      } else {
        form.url.$setValidity('url', valid);
      }

      if (valid) {
        if (vm.oldUrl != vm.url.href) {
          vm.oldUrl = vm.url.href;
          vm.seoFirstTime = true;
          vm.disableSEO = false;
          vm.canContinue = false;
        }

        if (vm.seoFirstTime) {
          ProfilesService.getDomainInformation(vm.url.href, function (response) {
            vm.domInfo = response.data;
            if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
            if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
            // console.log('min tf and da', MIN_VALUES.TF, MIN_VALUES.DA);
            // console.log('our vals', vm.domInfo.trust_flow, vm.domInfo.domain_authority);
            if (vm.domInfo.disable_add) {
              vm.canContinue = false;
            } else {
              vm.canContinue = true;
              setPriceLabel();
            }
          }, function (response) {
            return true;
          });
        } else {
          setPriceLabel();
        }
      }
    }

    function lastStep() {
      return vm.selectedIndex == TABS || (isInfluencer() && vm.selectedIndex === 3 && vm.selectedSocialIndex === 3);
    }

    function submit() {
      vm.showFormErrors = true;
      if (cantSubmit()) {
        if (isInfluencer() && !socialMediaProduct()) {
          showAlert('Social Handle Required', 'You need to connect at least one social handle before completing your profile ' +
            'and give a price for at least one ad', 'Got it').then(function (result) {
            return false;
          });
        } else if (isBlogger() && !socialMediaProduct() && !sponsoredBlogProduct()) {
          showAlert('Social Handle, Blog, or Guest Post Required', 'You need to connect at least one social handle, sponsored blog, or provide guest post details ' +
            'and provide pricing for at least one before completing your profile.', 'Got it').then(function (result) {
            return false;
          });
        } else {
          toastr.error('Please complete the required information before submitting.');
        }
        return false
      }
      // Check if there are social handles repeated
      if (
        oneProductIsSet() ||
        EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined ||
        EnvironmentConfig.TEST_DA_SCORE !== undefined ||
        EnvironmentConfig.TEST_TF_SCORE !== undefined
      ) {
        // If there is at least on product set then check if there are categories selected
        vm.noCategories = vm.categories.length === 0;
        if (!vm.noCategories) {
          continueSubmit();
        } else if (isContributor() || isBroker()) {
          $anchorScroll('scrollHere');
        }
      } else {
        showAlert('We are sorry', 'Please accept our sincerest apologies. But your domain ' +
          'and social handles do not meet minimum standards set by our Agency ' +
          'Partners. These are: *Web Traffic = 3000 / month, Social Following ' +
          '= 1000 followers and Domain Strength = DA of 15 and TF of 5.', 'Ok I understand').then(function (result) {
          return false;
        });
      }
    }

    function goAudienceBlock() {
      $anchorScroll('audience-data');
    }

    function continueSubmit() {
      vm.profile.categories_ids = lodash.map(vm.categories, 'id');
      vm.profile.urls = [];
      if (vm.igAuthCode) vm.profile.auth_key = vm.igAuthCode;
      if (!isInfluencer()) {
        vm.profile.urls.push(vm.url);
      } else {
        SocialHandlesService.setDescriptionToSocialHandles(vm.profile, vm.url.description);
      }
      ProfilesService.createProfile(vm.profile, function (response) {
        if (isInfluencer()) {
          showAlert('Take me live', 'Please note that we will need to vet your Social Handles ' +
            'through email to you. If you do not respond via email, then we will ' +
            'not approve your Profile. This means we will not be sending you any work.', 'OK. I understand ' +
            'and will respond via email.').then(function (result) {
            toastr.success('Successfully created the profile!');
            RoutesService.dashboard();
          });
        } else if (isBroker()) {
          showAlert('Submit', 'As a broker, you will be vetted by email. If you do ' +
            'not respond by email, we will not approve of any submissions.', 'OK. I understand ' +
            'and will respond via email.').then(function (result) {
            toastr.success('Successfully created the profile!');
            RoutesService.dashboard();
          });
        } else {
          toastr.success('Successfully created the profile!');
          RoutesService.dashboard();
        }
        vm.copyProfile = {};
        clearNewProfileLocalStorage()
      }, function (response) {
        handleErrors(response.data.errors);
      });
    }

    function handleErrors(errors) {
      lodash.forEach(errors, function (error) {
        toastr.error(error);
      });
    }

    function socialHandlesRepeated() {
      return SocialHandlesService.anyRepeated(vm.profile);
    }

    function oneProductIsSet(checkStep) {
      var webProduct = vm.profile.web_content.href && vm.profile.web_content.price;
      var socialProduct = socialMediaProduct();
      var seoProduct = vm.url.price;
      switch (checkStep) {
        case 3:
          if (!webProduct && !isBroker()) {
            showWarningPopup(checkStep);
          }
          break;
        case 4:
          if (!socialProduct && !isBroker() && !isContributor() && vm.profile.image) {
            showWarningPopup(checkStep);
          }
          break;
        default:
          return webProduct || socialProduct || seoProduct;
      }
    }

    function showWarningPopup(checkStep) {
      var confirm = $mdDialog.confirm()
        .title('Are you SURE?')
        .textContent('Skipping this step means you will earn less money with us!')
        .ok('Wait! Take me back!')
        .cancel('I understand');

      $mdDialog.show(confirm).then(function (result) {
        previous();
      }, function () {
        vm.selectedIndex = checkStep;
        setProfileSelectedIndex();
      });
    }

    function showInfo(step) {
      switch (step) {
        case 3:
          return showAlertHTML('Sponsored Web Content', '<div class="modal-text">' + 'Sponsored Web Content will read more like featured content. ' +
            'You will need to disclose compensation for the content per FTC regulations. ' +
            'Links inside the content will be NO-FOLLOW. You will have editorial control as well.' +
            '<br>' + '<br>' + 'By supplying your Google Analytics username below, our technology can see how ' +
            'many people engaged with each blog post. We will not be retrieving any ' +
            'private data from your Analytics account. Only the number of monthly ' +
            'unique visitors coming to your blog and previous content placements done through Scalefluence.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 31: // Case 3.1
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos & \'story messaging\' ' +
            'points if you accept this assignment. Choose which ones you like and seamlessly include them in a new blog post going over ' +
            'the product or service, you will then submit a draft for review and ' +
            'publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 32: // Case 3.2
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. Many low traffic bloggers ' +
            '(less than 2000 visits per month) will put $0 because products are usually around $50 to $150 retail. ' +
            'Marketers want photos of you reviewing the product / service. You will submit a draft for r' +
            'eview and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 33: // Case 3.3
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'This assignment is an unboxing video of you using the product with video + blog content. ' +
            'Please give an appropriate discount for the free product. We understand video is more impactful, ' +
            'takes longer and is more expensive, but again, please give a discount for free product ' +
            'being shipped to you. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 4:
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Sponsored Social Content is featured content on your social handle. ' +
            'You will need to disclose compensation for the content per FTC regulations ' +
            'by using #Ad or #Sponsored hashtags. Content will also come with a Tiny URL ' +
            'to track clicks and engagement of your Social Post. ' +
            '<br>' + '<br>' + 'By supplying your Social handles below, our technology can see how many ' +
            'people engaged with the social post. We will not be retrieving any private ' +
            'data of your account. Only the number of followers and previous content ' +
            'placements done through Scalefluence.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 411: // Case 4.1.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos / hashtags &' +
            ' \'story messaging\' points if you accept this assignment. ' +
            'Choose which ones you like and seamlessly include them in a new FB post for review and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 412: // Case 4.1.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Many micro-influencers put $0 because the products are usually around $50 to $150 retail.' +
            ' Marketers want photos of you using the product.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 413: // Case 4.1.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Marketers understand videos are more extensive and more impactful, ' +
            'but please still give a discount compensating for the $50 to $150 retail price of most products. ' +
            'Marketers want video of you using the product.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 414: // Case 4.1.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'You will be given an existing influencer story about the brand, ' +
            'or maybe a blog post / press / news story about the brand if you accept this assignment. ' +
            'You will share this and link to it when possible. ' +
            'You will write your own positive thoughts on the subject and submit for review and publication. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 421: // Case 4.2.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / photos / " +
            "hashtags & 'story messaging' points if you accept this assignment. Choose which ones you like and seamlessly " +
            "include them in a new IG post for review and publication." + '</div>', 'Ok').then(function (result) {
            return false;
          });

        case 422: // Case 4.2.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept this assignment." +
            " Please give an appropriate discount for the free product. Many micro-influencers put $0 because the " +
            "products are usually around $50 to $150 retail. " +
            "Marketers want photos of you using the product." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 423: // Case 4.2.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept this assignment. " +
            "This assignment is an unboxing video for an IG story as opposed to a single post. Please give an " +
            "appropriate discount for the free product. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 424: // Case 4.2.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. But a brand may feel that " +
            "they are 'in tune' with your audience that they will want to schedule out 3 posts with you over several months. " +
            "Please a give a 10 to 20% discount for this to entice marketers to work with you 3 times over." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 425: // Case 4.2.5
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post " +
            "but a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
            "posts with you over several months. Please a give a 20 to 30% discount to entice marketers to " +
            "work you with 5 times over." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 431: // Case 4.3.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / photos / " +
            "hashtags & 'story messaging' points if you accept this assignment. Choose which ones you like " +
            "and seamlessly include them in a new video for review and publication. This type of promotion " +
            "is also called a 'pre-roll ad' or 'mid-roll ad' . Such as:  'This video is brought " +
            "to you by our partners.'" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 432: // Case 4.3.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / " +
            "photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones " +
            "you like and seamlessly include them in a new video for review and publication. " +
            "This type of promotion is also called a 'pre-roll ad' or 'mid-roll ad'. " +
            "Such as: 'This video is brought to you by our partners.'" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 433: // Case 4.3.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule " +
            "out 3 videos with you over several months. Please a give a 10 to 20% discount " +
            "for this product to entice marketers to work with you 3 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 434: // Case 4.3.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
            "videos with you over several months. Please a give a 20 to 30% discount for this product " +
            "to entice marketers to work with you 5 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 441: // Case 4.4.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets" +
            " / photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones you " +
            "like and seamlessly include them in a new video for review and publication" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 442: // Case 4.4.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept " +
            "this assignment. Please give an appropriate discount for the free product. " +
            "Many micro-influencers put $0 because the products are usually around $50 to $150 retail. " +
            "Marketers want photos of you using the product. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 443: // Case 4.4.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept " +
            "this assignment. This assignment is a video of you using the product. We know video takes more time and is more expensive, " +
            "but please give an appropriate discount for the free product. products are usually around $50 to $150 retail. " +
            '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 51: // Case 5.1
          return showAlertHTML('Allow Home Page Links?', '<div class="modal-text">' + "Home page links are, on the whole, branded anchor text. " +
            "This means including the brand name in the link. For example: According to Forbes. " +
            " With ' Forbes ' being the anchor text. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 52: // Case 5.2
          return showAlertHTML('Are Links Do-Follow?', '<div class="modal-text">' + 'Do-Follow links are purchased about 5 times more than ' +
            'No-Follow links. You can change this selection at any time after ' +
            'our team approves your site.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 53: // Case 5.3
          return showAlertHTML('I only allow links to blog posts', '<div class="modal-text">' + 'While linking to blog content is the best practice; ' +
            'SEO firms will request links to service pages. ' + "Even if you select 'yes', you will still have the ability  " +
            'to accept (or decline) content that links elsewhere. Upon order, you can determine if the link is ' +
            'appropriate and request changes.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 54: // Case 5.
          return showAlertHTML('Required article length?', '<div class="modal-text">' + 'Please give the amount of words you require per article. Thank you!', 'Ok').then(function (result) {
            return false;
          });
      }

      $mdDialog.show(confirm).then(function (result) {
        return false;
      });
    }

    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Sign in to Submit Price';
    }

    function getPricingLabelGA(network) {
      vm.profile.web_content.suggested_post_price = PricingService.getPrice(vm.web_content.muv, network);
      vm.profile.web_content.suggested_video_price = PricingService.getVideoPrice(vm.web_content.muv, network);
    }

    function socialMediaProduct() {
      return lodash.findIndex(SocialHandlesService.getAllSocialHandle(vm.profile), function (socialHandle) {
        if (socialHandle.url && lodash.findIndex(socialHandle.social_prices, function (item) {
          if (item.price) return true
        }) >= 0) {
          return true;
        }
      }) !== -1;
    }

    function sponsoredBlogProduct() {
      return gaPriceChangeEnabled() && isAnalyticsCompleted()
    }

    function seoProduct() {
      return vm.url.href && vm.url.description && vm.url.price;
    }

    function getDescriptionTitle(tooltip) {
      if (vm.url.description && !tooltip && !isContributor()) {
        return "Description";
      } else if (isContributor()) {
        return 'Description: Describe what you write about. Be specific so that we can ' +
          'pitch you the right topics'
      }
      return "Description: Use \"My Meta Description\" or write your own." +
        "If you write your own, include friendly KWs. IE >> \"Health | Travel | Tech \" etc.";
    }

    function getFinishText() {
      return isInfluencer() && vm.selectedIndex == 3 ? 'Take Me Live!' : 'Finish';
    }

    function getNextSocialButtonText() {
      switch (vm.selectedSocialIndex) {
        case 0:
          return 'Save facebook';
        case 1:
          return 'Save instagram';
        case 2:
          return 'Save youtube'
      }
    }

    function cantSubmit() {
      if (isBroker()) {
        return !seoProduct();
      } else if (isInfluencer()) {
        return !socialMediaProduct();
      } else if (isBlogger()) {
        return !socialMediaProduct() && !sponsoredBlogProduct() && (!vm.url.description || !vm.url.price);
      } else if (isContributor()) {
        return !vm.url.description || !vm.url.price;
      }
    }

    function getTileForInfluencersDescription() {
      return vm.influencer.description ? "Description" : "Description: Tell Us " +
        "About Yourself and Your Audience. What type of content best resonates?";
    }

    function setPriceLabel() {
      if (!vm.url.href) {
        vm.priceLabel = 'Your price per post (USD):';
      } else if (vm.domInfo && vm.domInfo.trust_flow >= MIN_VALUES.TF &&
        vm.domInfo.domain_authority >= MIN_VALUES.DA) {

        // suggested_price is included in the domain_information response that
        // already populated vm.domInfo; avoid the redundant /urls/suggested_price
        // round trip that used to burn extra API credits on cache misses.
        vm.priceLabel = vm.domInfo.suggested_price
          ? 'Suggested price: ' + vm.domInfo.suggested_price
          : 'Your price per post (USD):';

        $rootScope.da = vm.domInfo.domain_authority;
        $rootScope.tf = vm.domInfo.trust_flow;
      } else {
        vm.priceLabel = 'Your price per post (USD):';
      }
    }

    function showWarningPopup() {
      showAlert('Suggested Pricing', 'In order to be able to display the suggested price, you must sign in to the social network', 'Got it!');
    }

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function typeSelected() {
      // will be non-empty string if selected
      return !!vm.profile.profileType;
    }

    function setContentType(type) {
      vm.profile.contentType = type;
      setKey('newProfileUrlContentType', vm.profile.contentType);
    }

    function contentTypeSelected() {
      // will be non-empty if selected
      return !!vm.profile.contentType;
    }

    function getYouTubeFollowers(socialHandle) {
      GoogleService.queryYouTubeStatistics(function (response) {
        if (response.result.items && response.result.items.length) {
          socialHandle.url = 'www.youtube.com/channel/' + response.result.items[0].id;
          socialHandle.followers = response.result.items[0].statistics.subscriberCount;
          setKey('newProfileYotubeHandles', socialHandle);
          if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
          checkSocialMinValues('youtube', socialHandle);
        } else {
          toastr.error('No channel associated to your account.');
        }
      });
    }

    function authenticateTwitter() {
      $window.location.href = EnvironmentConfig.API_END_POINT.replace('/api/v1', '/auth/twitter?action=new');
    }

    function handleFacebookConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        handleFacebookAuthentication(socialHandle, socialNetwork);
      }
    }

    function handleInstagramConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        switch (socialHandle.subtype) {
          case 'simple':
            getAuthURL();
            break;
          case 'verified':
            handleFacebookAuthentication(socialHandle, socialNetwork);
            break;
        }
      }
    }

    function handleYoutubeConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        authorize(ev, true, socialHandle)
      }
    }

    function handelTwitterConnection(ev, socialHandle) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, 'twitter');
      } else {
        authenticateTwitter()
      }
    }

    function handleFacebookAuthentication(socialHandle, socialNetwork) {
      FacebookService.authenticate(socialNetwork, function (userId) {
        switch (socialNetwork) {
          case 'facebook':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var username = account.username || account.id;
                if (checkExistedSocialAccount(socialNetwork, username)) {
                  showUseAnotherAccountModal(socialHandle, socialNetwork)
                } else {
                  FacebookService.revokePermissions();
                  loadSocialHandle(socialHandle, socialNetwork, username, account.fan_count);
                }
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
          case 'instagram':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var fanPageId = account.id;
                FacebookService.checkForInstagramBusinessAccount(fanPageId, function (response) {
                  if (checkExistedSocialAccount(socialNetwork, response.username)) {
                    showUseAnotherAccountModal(socialHandle, socialNetwork)
                  } else {
                    FacebookService.revokePermissions();
                    loadSocialHandle(socialHandle, socialNetwork, response.username, response.followers_count);
                  }
                }, function (error) {
                  toastr.error(error);
                });
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
        }
      }, function (error) {
        toastr.error(error);
      });
    }

    function disconnectSocial(socialHandle, socialNetwork) {
      socialHandle._destroy = 1;
      var profile = vm.profile;
      var updateData = false;
      switch (socialNetwork) {
        case 'facebook':
          updateData = {
            facebook_handle: profile.facebook_handle
          };
          break;
        case 'instagram':
          updateData = {
            instagram_handle: profile.instagram_handle
          };
          break;
        case 'youtube':
          updateData = {
            youtube_handle: profile.youtube_handle
          };
          break;
        case 'twitter':
          updateData = {
            twitter_handle: profile.twitter_handle
          };
          break;
      }

      if (updateData === false) {
        toastr.error('Sorry, no profile found for that handle. Please try again and report this error if it persists.');
        return;
      }

      clearSocial(socialHandle, socialNetwork);

      toastr.success('Disconnected from social network successfuly.');
    }


    function checkExistedSocialAccount(socialNetwork, username) {
      var url = 'https://www.' + socialNetwork + '.com/' + username;
      if (_.includes(vm.profileSocialUrls, url)) {
        return true
      }
    }

    function loadSocialHandle(socialHandle, socialNetwork, username, count) {
      socialHandle.url = 'https://www.' + socialNetwork + '.com/' + username;
      socialHandle.followers = count;
      var key;
      switch (socialNetwork) {
        case 'facebook':
          key = 'newProfileFacebookHandle';
          break;
        case 'instagram':
          key = 'newProfileInstagramHandle';
      }
      setKey(key, socialHandle);
      // if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
      checkSocialMinValues(socialNetwork, socialHandle);
    }

    function showUseAnotherAccountModal(socialHandle, socialNetwork) {
      var confirm = $mdDialog.confirm()
        .title('Account is already linked')
        .htmlContent('<p>You have already connected this handle in another profile.</p>' +
          'Please email ' + '<strong>admin@scalefluence.com</strong>' + ' for help.</p>')
        .ok('Connect other')
        .cancel('Ok got it');
      $mdDialog.show(confirm).then(function () {
        socialHandle.url = null;
        switch (socialNetwork) {
          case 'facebook':
            handleFacebookConnection(socialHandle, socialNetwork, true);
            break;
          case 'instagram':
            handleInstagramConnection(socialHandle, socialNetwork, true)
        }
      }, function () {
        disconnectSocial(socialHandle, socialNetwork)
      });
    }


    function showChooseAccountModal(accounts, successCallback, errorCallback) {
      $mdDialog.show({
        controller: 'SocialHandleController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfileV1/partials/socialHandleDialog.html',
        clickOutsideToClose: false,
        locals: {
          accounts: accounts,
        }
      }).then(function (response) {
          successCallback(response)
        },
        errorCallback);
    }


    function toggleCategories() {
      vm.categoriesOn = !vm.categoriesOn;
    }

    function categoriesActionMsg() {
      return vm.categoriesOn ? 'Hide Categories' : 'Show Categories';
    }

    function toggleElements() {
      vm.elementsOn = !vm.elementsOn;
    }

    function elementsActionMsg() {
      return vm.elementsOn ? 'Hide Properties' : 'Show Properties';
    }

    function setUrlRequiredLength(requiredLength) {
      switch (requiredLength) {
        case '1500-+':
        case '1250-1500':
        case '1000-1250':
          vm.url.required_length = requiredLength;
          break;

        default:
          vm.url.required_length = '750-1000'
      }
      setKey('newProfileUrlRequiredLength', vm.url.required_length);
    }

    function setUrlAllowHomepage(allow) {
      vm.url.allow_home_page = allow ? 'true' : 'false';
      if (allow) {
        vm.url.allow_blog_post = 'false';
        setKey('newProfileUrlAllowBlogPost', vm.url.allow_blog_post);
      }
      setKey('newProfileUrlAllowHomepage', vm.url.allow_home_page);
    }

    function setUrlFollowLink(isDoFollow) {
      vm.url.follow_link = isDoFollow ? 'true' : 'false';
      setKey('newProfileUrlFollowLink', vm.url.follow_link);
    }

    function setUrlAllowBlogPost(allow) {
      vm.url.allow_blog_post = allow ? 'true' : 'false';
      setKey('newProfileUrlAllowBlogPost', vm.url.allow_blog_post);
    }

    function disconnectGA(showMsg) {
      vm.profile.web_content.href = '';
      vm.profile.web_content.muv = '';
      vm.profile.web_content.ga_account_id = '';
      vm.profile.web_content.ga_profile_id = '';
      vm.profile.web_content.website_url = '';
      vm.initialAnalytics.selected = "none";
      vm.selectedAnalytics = vm.initialAnalytics;
      console.log("Analytics de authorized");
      vm.analyticsAuthorized = false;

      lodash.forEach(vm.profile.web_content.web_content_prices, function (key) {
        delete key.price
      });

      lodash.forEach([
        'newProfileGoogleAnalytics',
        'newProfileSelectedAnalytics',
        'newProfileAnalyticsAuthorized',
        'newProfileWebContentMuv',
        'newProfileWebContentHref'
      ], function (key) {
        removeKey(key);
      });

      if (showMsg !== false) toastr.success('Analytics account disconnected.');
    }

    function getPropertyLabelGA() {
      return vm.web_content.muv && vm.analyticsAuthorized && vm.selectedAnalytics ? 'Website (' + vm.web_content.muv + ' visits)' : 'Website';
    }

    function gaPriceChangeEnabled() {
      return vm.profile.web_content.href && vm.web_content.muv >= MIN_VALUES.GA;
    }

    function updateDomain() {
      vm.form.domainUrl.$setValidity('active', true);
      vm.form.domainUrl.$setValidity('unmatched', true);
    }

    function setProfileSelectedIndex() {
      setKey('newProfileSelectedIndex', vm.selectedIndex);
    }

    function setNewProfileType() {
      setKey('newProfileType', vm.profile.profileType);
    }

    function setNewProfileName() {
      setKey('newProfileName', vm.profile.name);
    }

    function setNewProfileUrl() {
      setKey('newProfileUrl', vm.url.href);
    }

    function setNewProfileDescription() {
      setKey('newProfileDescription', vm.url.description);
    }

    function setNewProfileUrlPrice() {
      setKey('newProfileUrlPrice', vm.url.price);
    }

    function setNewProfileAuthorPage() {
      setKey('newProfileUrlAuthorPage', vm.url.author_page);
    }

    function setNewProfileWebContentPrice(value, key) {
      setKey(key, value);
    }

    function setAudienceGenderGroup() {
      setKey('newProfileAudienceGenderGroup', vm.profile.audience.audience_gender);
    }

    function setAudienceEstimatedIncome() {
      setKey('newProfileAudienceEstimatedIncome', vm.profile.audience.estimated_income);
    }

    function setNewProfileSocialPrice(value, socialNetwork) {
      var key = switchSocialKey(socialNetwork);
      var field = socialNetwork.concat('_handle');
      var socialHandle = vm.profile[field];
      setKey(key, socialHandle);
    }

    function clearSocialPrice(socialNetwork) {
      var key = switchSocialKey(socialNetwork);
      removeKey(key);
    }

    function switchSocialKey(socialNetwork) {
      switch (socialNetwork) {
        case 'facebook':
          return 'newProfileFacebookHandle';
        case 'instagram':
          return 'newProfileInstagramHandle';
        case 'youtube':
          return 'newProfileYoutubeHandle';
        case 'twitter':
          return 'newProfileTwitterHandle';
      }
    }

    function clearNewProfileLocalStorage() {
      var keys = StorageService.getAll();
      keys.forEach(function (key){
        if (key.includes('newProfile')) {
          removeKey(key)
      }});
    }

    function getKey(key) {
      return StorageService.get(key)
    }

    function setKey(key, value) {
      StorageService.set(key, value)
    }

    function removeKey(item) {
      StorageService.remove(item)
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.profile.new', [])
    .controller('NewProfileController', NewProfileController);

  /** @ngInject */
  function NewProfileController($scope, $log, $mdDialog, $mdMedia, $rootElement, $rootScope,
                                $anchorScroll, $location, toastr, lodash, EnvironmentConfig, RoutesService,
                                ProfilesService, SocialHandlesService, PricesService, PricingService,
                                GoogleService, FacebookService, PROFILE_TYPE, SOCIAL, MIN_VALUES, SCOPE,
                                StorageService, NEW_PROFILE, $window, SOCIAL_PRICES, WEB_CONTENT_PRICES
  ) {
    var vm = this;
    const TABS = 4;

    var params = $location.search();
    $location.search({});

    var igAuthCode = params.ig_auth_code;
    var igUserId = params.ig_user_id;
    var twitterFollowersCount = params.twitter_followers_count;
    var twitterNickname = params.twitter_nickname;

    // Accessible attributes
    $rootScope.da;
    $rootScope.tf;
    $scope.da;
    $scope.tf;
    $scope.close = function () {
      $mdDialog.cancel();
    };

    vm.domInfo;
    vm.selectedIndex = getKey('newProfileSelectedIndex') || 0;
    vm.selectedSocialIndex = getKey('newProfileSelectedSocialIndex') || 0;
    vm.stepsLocker = getKey('newProfileStepsLocker') || [false, false, false, false, false];
    vm.stepNames = NEW_PROFILE.STEP_NAMES;
    vm.influencer = {
      description: ''
    };
    vm.url = {
      description: getKey('newProfileDescription') || '',
      href: getKey('newProfileUrl') || '',
      price: getKey('newProfileUrlPrice') || '',
      author_page: getKey('newProfileUrlAuthorPage') || '',
      required_length: getKey('newProfileUrlRequiredLength'),
      follow_link: getKey('newProfileUrlFollowLink'),
      allow_blog_post: getKey('newProfileUrlFollowLink'),
      allow_home_page: getKey('newProfileUrlAllowHomepage')
    };
    vm.profile = {
      categories_ids: [],
      urls: [],
      pets: getKey('newProfilePets') || [],
      languages: getKey('newProfileLanguages') || [],
      facebook_handle: {
        name: 'FACEBOOK',
        social_prices: SOCIAL_PRICES.FACEBOOK.FIELDS
      },
      twitter_handle: {
        name: 'TWITTER',
        social_prices: SOCIAL_PRICES.TWITTER.FIELDS
      },
      instagram_handle: {
        name: 'INSTAGRAM',
        social_prices: SOCIAL_PRICES.INSTAGRAM.FIELDS
      },
      youtube_handle: {
        name: 'YOUTUBE',
        social_prices: SOCIAL_PRICES.YOUTUBE.FIELDS
      },
      web_content: {
        web_content_prices: WEB_CONTENT_PRICES.FIELDS,
        href: getKey('newProfileWebContentHref') || ''
      },
      audience: {
        audience_gender: getKey('newProfileAudienceGenderGroup') || '',
        estimated_income: getKey('newProfileAudienceEstimatedIncome') || '',
        ethnicities: getKey('newProfileAudienceEthnicities') || [],
        age_groups: getKey('newProfileAudienceAgeGroups') || []
      }
    };

    vm.web_content = {
      muv: getKey('newProfileWebContentMuv') || ''
    };
    vm.gaValidating = false;
    vm.categories = [];
    vm.seoFirstTime = true;
    vm.disableSEO = false;
    vm.profileNames = [];
    vm.canContinue = false;
    vm.analytics = getKey('newProfileGoogleAnalytics') || [];
    vm.selectedAnalytics = {};
    vm.initialAnalytics = {};
    vm.analyticsAuthorized = false;
    vm.showProgressCircular = false;
    vm.showHomePageError = false;
    vm.showFollowLinkError = false;
    vm.showAllowBlogPostError = false;
    vm.priceLabel = '';
    vm.domainUrlValid = false;
    vm.categoriesOn = true;
    vm.ethnicitiesOn = true;
    vm.petsOn = true;
    vm.languagesOn = true;
    vm.ageGroupOn = true;
    vm.showFormErrors = false;
    vm.form = {};
    vm.state = "";
    vm.ethnicitiesList = NEW_PROFILE.ETNIC_GROUPS;
    vm.audienceGenderList = NEW_PROFILE.GENDER_LIST;
    vm.audienceEstimatedIncomes = NEW_PROFILE.AUDIENCE_ESTIMATED_INCOMES;
    vm.languagesList = NEW_PROFILE.LANGUAGES_LIST;
    vm.ageGroupList = NEW_PROFILE.AGE_GROUPS;
    vm.petsList = NEW_PROFILE.PETS_LIST;

    // Accessible functions
    vm.next = next;
    vm.previous = previous;
    vm.nextDisabled = nextDisabled;
    vm.showDialog = showDialog;
    vm.showPriceSEO = showPriceSEO;
    vm.showPriceGa = showPriceGa;
    vm.lastStep = lastStep;
    vm.submit = submit;
    vm.getCurrentStepName = getCurrentStepName;
    vm.checkAvatar = checkAvatar;
    vm.getMetaDescription = getMetaDescription;
    vm.noSocialHandlesSet = noSocialHandlesSet;
    vm.noWebContentSet = noWebContentSet;
    vm.setSocialHandles = setSocialHandles;
    vm.getDescriptionTitle = getDescriptionTitle;
    vm.getTileForInfluencersDescription = getTileForInfluencersDescription;
    vm.checkGAMinValues = checkGAMinValues;
    vm.checkSocialMinValues = checkSocialMinValues;
    vm.cantSubmit = cantSubmit;
    vm.setAsInfluencer = setAsInfluencer;
    vm.setAsBroker = setAsBroker;
    vm.setAsContributor = setAsContributor;
    vm.setAsBlogger = setAsBlogger;
    vm.isInfluencer = isInfluencer;
    vm.isBroker = isBroker;
    vm.isContributor = isContributor;
    vm.isBlogger = isBlogger;
    vm.influencer = influencer;
    vm.blogger = blogger;
    vm.broker = broker;
    vm.contributor = contributor;
    vm.oneProductIsSet = oneProductIsSet;
    vm.getFinishText = getFinishText;
    vm.getNextSocialButtonText = getNextSocialButtonText;
    vm.showInfo = showInfo;
    vm.isInvalidProfileName = isInvalidProfileName;
    vm.checkSEO = checkSEO;
    vm.setPriceLabel = setPriceLabel;
    vm.getPricingLabel = getPricingLabel;
    vm.getPricingLabelGA = getPricingLabelGA;
    vm.showWarningPopup = showWarningPopup;
    vm.authorize = authorize;
    vm.analyticSelected = analyticSelected;
    vm.showHomePageErrorMessage = showHomePageErrorMessage;
    vm.showFollowLinkErrorMessage = showFollowLinkErrorMessage;
    vm.setContentType = setContentType;
    vm.typeSelected = typeSelected;
    vm.authenticateTwitter = authenticateTwitter;
    vm.handleFacebookAuthentication = handleFacebookAuthentication;
    vm.toggleCategories = toggleCategories;
    vm.toggleElements = toggleElements;
    vm.categoriesActionMsg = categoriesActionMsg;
    vm.ethnicitiesActionMsg = elementsActionMsg;
    vm.setUrlRequiredLength = setUrlRequiredLength;
    vm.setUrlAllowHomepage = setUrlAllowHomepage;
    vm.setUrlFollowLink = setUrlFollowLink;
    vm.setUrlAllowBlogPost = setUrlAllowBlogPost;
    vm.disconnectSocial = disconnectSocial;
    vm.disconnectGA = disconnectGA;
    vm.getPropertyLabelGA = getPropertyLabelGA;
    vm.gaPriceChangeEnabled = gaPriceChangeEnabled;
    vm.updateDomain = updateDomain;
    vm.setNewProfileUrl = setNewProfileUrl;
    vm.setNewProfileName = setNewProfileName;
    vm.setNewProfileDescription = setNewProfileDescription;
    vm.setNewProfileUrlPrice = setNewProfileUrlPrice;
    vm.setNewProfileSocialPrice = setNewProfileSocialPrice;
    vm.setNewProfileAuthorPage = setNewProfileAuthorPage;
    vm.setNewProfileWebContentPrice = setNewProfileWebContentPrice;
    vm.setAudienceGenderGroup = setAudienceGenderGroup;
    vm.setAudienceEstimatedIncome = setAudienceEstimatedIncome;
    vm.getAuthURL = getAuthURL;
    vm.setSocialTab = setSocialTab;
    vm.setSubtype = setSubtype;
    vm.handleFacebookConnection = handleFacebookConnection;
    vm.handleInstagramConnection = handleInstagramConnection;
    vm.handleYoutubeConnection = handleYoutubeConnection;
    vm.handelTwitterConnection = handelTwitterConnection;
    vm.checkSocialPrices = checkSocialPrices;
    vm.setSocialIndex = setSocialIndex;

    init();

    function init() {

      vm.analyticsAuthorized = getKey('newProfileAnalyticsAuthorized') || false;
      var selectedAnalytics = getKey('newProfileSelectedAnalytics');
      if (selectedAnalytics) {
        var parsedAnalytics = JSON.parse(selectedAnalytics);
        vm.selectedAnalytics = parsedAnalytics;
        vm.selectedAnalytics.selected = parsedAnalytics.name;
        setWebContent(vm.selectedAnalytics);
        getPricingLabelGA('GA');
      } else {
        vm.selectedAnalytics = vm.initialAnalytics
      }

      $scope.$mdMedia = $mdMedia;
      vm.profile.profileType = getKey('newProfileType') || '';
      vm.profile.name = getKey('newProfileName') || '';
      vm.profile.contentType = getKey('newProfileUrlContentType') || '';
      vm.showTypeError = false;
      vm.showMissingContentTypeError = false;
      vm.profileTypeOld = vm.profile.profileType;

      ProfilesService.getProfileNames(function (response) {
        vm.profileNames = response.data.profile_names;
      });

      ProfilesService.getProfileSocialUrls(function (response) {
        vm.profileSocialUrls = response.data.profile_social_urls;
        if (igAuthCode && igUserId) {
          ProfilesService.verifyInstagramAccount(igAuthCode, igUserId, function (response) {
            var username = response.data.username;
            if (checkExistedSocialAccount('instagram', username)) {
              showUseAnotherAccountModal(vm.profile.instagram_handle, 'instagram')
            } else {
              getInstagramFollowers(username);
            }
          }, function (error) {
            console.log(error);
          });
        }
      });

      // Add one blank item per social handle
      setSocialHandles(SOCIAL.Facebook);
      setSocialHandles(SOCIAL.Twitter);
      setSocialHandles(SOCIAL.Youtube);
      setSocialHandles(SOCIAL.Instagram);

      if (twitterFollowersCount && twitterNickname) {
        loadSocialHandle(vm.profile.twitter_handle, 'twitter', twitterNickname, twitterFollowersCount)
      }
    }

    function getInstagramFollowers(username) {
      ProfilesService.getInstagramData(username, function (response) {
        var followersCount = response.data.qty_followers;
        if (followersCount == null) {
          // followersCount = MIN_VALUES.SOCIAL;
          return $mdDialog.show($mdDialog.alert()
            .title('')
            .textContent('Hey ' + username + ',  seems like Instagram is taking longer than normal. Nothing to worry about. Should only be a moment longer.  Remember, after we get the data, click the orange ? icon to see what our suggested pricing is.')
            .escapeToClose(false)
            .ok('Ok')
          )
          .then(function(result) {
            getInstagramFollowers(username);
          });
        }

        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, followersCount);
      }, function (error) {
        console.log(error);
        loadSocialHandle(vm.profile.instagram_handle, 'instagram', username, MIN_VALUES.SOCIAL);
      });
    }

    function analyticSelected() {
      vm.showProgressCircular = true;
      var domain = vm.url.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
      if (!vm.selectedAnalytics.websiteUrl.includes(domain)) {
        toastr.error('The selected analytics property does not match the website you are attempting to validate.');
        vm.showProgressCircular = false;
        return false;
      }
      setKey('newProfileSelectedAnalytics', JSON.stringify(vm.selectedAnalytics));
      setKey('newProfileWebContentHref', vm.profile.web_content.href);
      GoogleService.queryProfiles(vm.selectedAnalytics, handleProfiles, function (err) {
        $log.error(err);
      });
    }

    function setWebContent(selectedAnalytics) {
      vm.profile.web_content.ga_account_id = selectedAnalytics.accountId;
      vm.profile.web_content.ga_profile_id = selectedAnalytics.id;
      vm.profile.web_content.website_url = selectedAnalytics.websiteUrl;
      vm.profile.web_content.href = selectedAnalytics.selfLink;
      vm.profile.web_content.muv = vm.web_content.muv;
      lodash.map(vm.profile.web_content.web_content_prices, function (price) {
        price.price = getKey(price.key)
      })
    }

    function showFollowLinkErrorMessage() {
      return 'You MUST select one option.';
    }

    function showHomePageErrorMessage() {
      return 'You MUST select one option.';
    }

    function authorize(event, isYoutube, socialHandle) {
      GoogleService.authorize(event, function (response) {
        if (response.error) {
          vm.hidden = false;
        } else {
          vm.hidden = true;
          if (isYoutube) {
            getYouTubeFollowers(socialHandle);
          } else {
            queryAccounts();
          }
        }
      });
    }

    function queryAccounts() {
      vm.analytics = [];
      vm.showProgressCircular = true;
      GoogleService.queryAccounts(handleAccounts, function (error) {
        toastr.error('No Google Analytics account found');
        vm.showProgressCircular = false;
      });
    }

    function handleAccounts(response) {
      var accounts = response.result.items;
      if (accounts && accounts.length) {
        console.log("Analytics authorized");
        vm.analyticsAuthorized = true;
        setKey('newProfileAnalyticsAuthorized', vm.analyticsAuthorized);
        vm.showProgressCircular = true;
        lodash.map(accounts, function (account) {
          GoogleService.queryProperties(account, handleProperties, function (err) {
            $log.error(err);
            vm.showProgressCircular = false;
          });
        })
      } else {
        $log.log('There are no accounts to show');
      }
    }

    function getAuthURL() {
      ProfilesService.getInstagramAuthUrl('new', null, function (response) {
        if (response.data.auth_url) {
          $window.location.href = response.data.auth_url;
        }
      }, function (error) {
        console.log(error)
      });
    }

    function handleProperties(response) {
      var properties = response.result.items;
      if (properties && properties.length) {
        lodash.map(properties, function (property) {
          vm.analytics.push(property);
          setKey('newProfileGoogleAnalytics', vm.analytics)
        })
      } else {
        $log.log('There are no properties to show');
      }
      vm.showProgressCircular = false;
    }

    function handleProfiles(response) {
      var profiles = response.result.items;
      if (profiles && profiles.length) {
        var firstProfileId = profiles[0].id;
        GoogleService.queryCoreReportingApi(firstProfileId, handleReports, function (err) {
          vm.showProgressCircular = false;
          $log.error(err);
          toastr.error(err.result.error.message);
          disconnectGA(false);
          handleReportsAlt();
        });
      } else {
        $log.log('There are no profiles to show');
      }
    }

    function handleReports(response) {
      var formattedJson = JSON.stringify(response.result, null, 2);
      vm.web_content.muv = parseInt(response.result.totalsForAllResults['ga:users']);

      if (vm.web_content.muv == 0) {
        handleReportsAlt();
      } else {
        setKey('newProfileWebContentMuv', vm.web_content.muv);
        checkGAMinValues();
        getPricingLabelGA('GA');
        setWebContent(vm.selectedAnalytics);

        $scope.followers = vm.web_content.muv;
        $scope.network = 'GA';
        $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
        $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          'Should be placed on front page for best performance.';
        $scope.contentLineTwo = 'Content must be up 6 months or longer.';
        $scope.header = 'You have ' + vm.web_content.muv + ' Monthly Visitors';

        vm.showProgressCircular = false
      }
    }

    // sometimes there is an error getting api info from google when a property is selected,
    // so we can use this as a backup option (ask user to manually provide monthly visitors)
    function handleReportsAlt() {
      $mdDialog.show({
        controller: 'MonthlyVisitorsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfile/partials/monthlyVisitorsDialog.html',
        clickOutsideToClose: false
      }).then(function (response) {
        vm.web_content.muv = parseInt(response);
        vm.showProgressCircular = false
        checkGAMinValues();
      }, function() {
        vm.showProgressCircular = false
        console.log('error');
      });
    }

    // Functions for Gbutton
    // window.authorize = authorize;

    function toggleLock(positions, lock) {
      lodash.map(positions, function (pos) {
        vm.stepsLocker[pos] = lock;
      });
      setKey('newProfileStepsLocker', vm.stepsLocker);
    }

    function previousStepsUnlock(position) {
      if (position == 0) {
        return !vm.stepsLocker[position];
      }
      return lodash.reduce(vm.stepsLocker.slice(0, position), function (carry, n) {
        return carry && !n;
      }, true);
    }

    function setSocialHandles(socialHandle) {
      var savedSocialHandle = getKey(switchSocialKey(socialHandle));
      var field = socialHandle.concat('_handle');

      if (savedSocialHandle) vm.profile[field] = savedSocialHandle;
      loadAdditionalPrices(socialHandle);
    }

    function loadAdditionalPrices(socialHandle) {
      switch (socialHandle) {
        case SOCIAL.Facebook:
          vm.facebookPrice = getKey('newProfileFacebookPrice');
          vm.facebookVideoPrice = getKey('newProfileFacebookVideoPrice');
          break;
        case SOCIAL.Twitter:
          vm.twitterPrice = getKey('newProfileTwitterPrice');
          vm.twitterVideoPrice = getKey('newProfileTwitterVideoPrice');
          break;
        case SOCIAL.Youtube:
          vm.youtubePrice = getKey('newProfileYoutubePrice');
          vm.youtubeVideoPrice = getKey('newProfileYoutubeVideoPrice');
          break;
        case SOCIAL.Instagram:
          vm.instagramPrice = getKey('newProfileInstagramPrice');
          vm.instagramVideoPrice = getKey('newProfileInstagramVideoPrice');
      }
    }

    function showPriceGa(network, socialHandle, display) {
      if (network == 'GA') {
        if (angular.isDefined(vm.web_content.muv)) {
          $scope.followers = 0;
        }
        checkGAMinValues(display);
      } else {
        if (angular.isUndefined(socialHandle.followers)) {
          $scope.followers = 0;
          $scope.network = '';
        }
        checkSocialMinValues(network, socialHandle, display)
      }
    }

    function displayRowGridPrice() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/newProfile/partials/rowDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'NewProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function checkAvatar(ev, tabSelection) {
      // if (!vm.profile.image && typeSelected() && contentTypeSelected()) {
      if (!vm.profile.image && typeSelected()) {
        var confirm = $mdDialog.confirm()
          .title('Upload a Photo!')
          .textContent('Profiles with Photos receive far more work than those that don\'t!')
          .targetEvent(ev)
          .ok('Ok Do it Now!')
          .cancel('No Thanks.');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 0;
          setProfileSelectedIndex();
          var photoEl = angular.element(document.querySelector('#new-prof-photo'));
          photoEl.removeClass('atn-flash');
          photoEl.hide();
          photoEl.show();
          photoEl.addClass('atn-flash');
        }, function () {
          // if (!tabSelection && typeSelected() && contentTypeSelected()) {
          if (!tabSelection && typeSelected()) {
            findNextIndex();
          }
        });
      } else if (!tabSelection && typeSelected()) {
        findNextIndex();
      }
    }

    function findNextIndex() {
      var pos = lodash.findIndex(vm.stepsLocker, function (step, index) {
        return !step && index > vm.selectedIndex;
      });
      vm.selectedIndex = Math.max(pos, 0);

      setProfileSelectedIndex();
    }

    function setAsInfluencer() {
      vm.profile.profileType = PROFILE_TYPE.INFLUENCER;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function setAsBlogger() {
      vm.profile.profileType = PROFILE_TYPE.BLOGGER;
      vm.showTypeError = false;
      setNewProfileType();
    }

    function setAsBroker() {
      vm.profile.profileType = PROFILE_TYPE.BROKER;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function setAsContributor() {
      vm.profile.profileType = PROFILE_TYPE.CONTRIBUTOR;
      vm.showTypeError = false;
      setNewProfileType()
    }

    function isInfluencer() {
      return vm.profile.profileType == PROFILE_TYPE.INFLUENCER;
    }

    function isBlogger() {
      return vm.profile.profileType == PROFILE_TYPE.BLOGGER;
    }

    function isBroker() {
      return vm.profile.profileType == PROFILE_TYPE.BROKER;
    }

    function isContributor() {
      return vm.profile.profileType == PROFILE_TYPE.CONTRIBUTOR;
    }

    function influencer() {
      return PROFILE_TYPE.INFLUENCER;
    }

    function blogger() {
      return PROFILE_TYPE.BLOGGER;
    }

    function broker() {
      return PROFILE_TYPE.BROKER;
    }

    function contributor() {
      return PROFILE_TYPE.CONTRIBUTOR;
    }

    function isInvalidProfileName() {
      var invalid = false;
      lodash.map(vm.profileNames, function (name) {
        if (vm.profile.name && (vm.profile.name.toUpperCase() == name.toUpperCase())) {
          invalid = true;
        }
      });
      return invalid;
    }

    function nextDisabled() {
      var lock;
      switch (vm.selectedIndex) {
        case 0:
          lock = !vm.profile.name;
          if (vm.profile.profileType != vm.profileTypeOld) {
            vm.profileTypeOld = vm.profile.profileType;
            toggleLock([1, 2, 3, 4], true);
            var name = vm.profile.name;
            var image = vm.profile.image;
            vm.profile.name = name;
            vm.profile.image = image;
            vm.profile.profileType = vm.profileTypeOld;
          }

          if (isBlogger()) {
            toggleLock([1, 2, 3, 4], false);
          } else if (isInfluencer()) {
            toggleLock([1, 3], false);
            toggleLock([2, 4], true);
          } else if (isContributor() || isBroker()) {
            toggleLock([1, 4], false);
          }
          return lock;
          break;
        case 1:
          lock = !isDomainInfoCompleted();
          return lock;
          break;
        case 2:
          lock = !isAnalyticsCompleted();
          toggleLock([3, 4], false);
          setUrl();
          return lock;
          break;
        case 3:
          return false;
          break;
        case 4:
          if (vm.seoFirstTime || (vm.oldUrl != vm.url.href)) {
            vm.seoFirstTime = false;
          }
      }
      return true;
    }

    /* STEP 2 */
    function setUrl() {
      if (!vm.oldUrl) {
        vm.oldUrl = vm.url.href;
      }
    }

    function lockStepInvalidName(step) {
      if (isInvalidProfileName()) {
        toggleLock([step], true);
      } else {
        toggleLock([step], !vm.profile.name);
      }
    }

    ////////// Checks for each step (start) //////////
    /* STEP 2 */
    function isDomainInfoCompleted() {
      if (vm.isInfluencer()) {
        return vm.url.description && vm.categories.length;
      }
      return vm.url.href && vm.url.description && vm.categories.length;
    }

    function isAudienceInfoCompleted() {
      return vm.profile.audience.audience_gender && vm.profile.audience.estimated_income &&
        vm.profile.audience.ethnicities.length && vm.profile.audience.age_groups.length &&
        vm.profile.pets.length && vm.profile.languages.length
    }

    function isAudienceInfoCompletedPartially() {
      return vm.profile.audience.audience_gender || vm.profile.audience.estimated_income ||
        vm.profile.audience.ethnicities.length || vm.profile.audience.age_groups.length ||
        vm.profile.pets.length || vm.profile.languages.length
    }

    /* STEP 3 */
    function isAnalyticsCompleted() {
      return lodash.findIndex(vm.profile.web_content.web_content_prices, function (content_price) {
        if (bothSetOrEmpty(vm.profile.web_content.href, content_price.price)) {
          return true;
        }
      }) !== -1;
    }

    /* STEP 4 */

    ////////// Checks for each step (end) //////////
    function emptyFields(val1, val2) {
      return !(val1 || val2);
    }

    function bothSetOrEmpty(value1, value2) {
      return (value1 && value2) || emptyFields(value1, value2);
    }

    function getMetaDescription() {
      ProfilesService.getMetaDescription(vm.url.href, function (response) {
        vm.url.description = response.data.description;
      }, function (response) {
        toastr.error(response.data.error);
      });
    }

    /* STEP 3 */
    function checkGAMinValues(display) {
      if (vm.profile.web_content.href) {
        if (vm.web_content.muv < MIN_VALUES.GA) {
          showAlert('Minimum monthly unique visitors', 'We apologize but we need a minimum of 3000 unique visitors ' +
            'per month to participate in this product. You currently do not meet ' +
            'that criteria. When you do reach that traffic, you can come back to ' +
            'this profile and submit it then.', 'Ok I understand').then(function (result) {
            toggleLock([3, 4], false);
            vm.profile.web_content.href = '';
            vm.profile.web_content.price = '';
          });
        } else {
          $scope.followers = vm.web_content.muv;
          $scope.network = 'GA';
          $scope.rowHeader = 'Suggested Pricing for Sponsored Web Content';
          // $scope.content = 'Content will be disclosed and will have no-follow links. ' +
          //   'Should be placed on front page for best performance.';
          $scope.content = 'According to Google, your site had ' + vm.web_content.muv + ' visits last month. Below is our suggested payout for a blog post. You can put any price you want. This is only a suggestion based on your traffic.';
          $scope.contentLineTwo = 'Content must be up 6 months or longer.';
          $scope.header = 'You have ' + vm.web_content.muv + ' Monthly Visitors';
          if (display) {
            displayRowGridPrice();
          }
        }
      } else {
        // vm.web_content.muv = '';
        getPricingLabelGA('GA');
      }
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showPriceSEO() {
      $mdDialog.show({
        templateUrl: 'app/pages/profiles/newProfile/partials/gridDialog.html',
        parent: $rootElement,
        scope: $scope,
        controller: 'NewProfileController',
        preserveScope: true,
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    /* STEP 4 */
    function getHandleFromType(type) {
      var handle = {};
      switch (type) {
        case SOCIAL.Facebook:
          handle = vm.profile.facebook_handle;
          break;
        case SOCIAL.Twitter:
          handle = vm.profile.twitter_handle;
          break;
        case SOCIAL.Youtube:
          handle = vm.profile.youtube_handle;
          break;
        case SOCIAL.Instagram:
          handle = vm.profile.instagram_handle;
          break;
      }
      return handle;
    }

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function checkSocialMinValues(type, socialMedia, display) {
      if (!socialMedia.url) {
        socialMedia.followers = '';
        getPricingLabel(socialMedia, type);
      } else {
        var handle = getHandleFromType(type);
        if (socialMedia.followers < MIN_VALUES.SOCIAL) {
          clearSocial(handle, type);
          showAlert('Minimum followers', "We're sorry but we require a minimum of " +
            MIN_VALUES.SOCIAL + " followers for this account to be approved. " +
            "Please come back and connect your account when you have at least that many. " +
            "Thank you!", 'Ok I understand').then(function (result) {
            toggleLock([3, 4], false);
          });
        } else {
          var price = PricingService.getPrice(socialMedia.followers, type);
          var videoPrice = PricingService.getVideoPrice(socialMedia.followers, type);
          if (type === 'facebook') {
            var sharingPrice =  PricingService.getSharingPrice(socialMedia.followers, type);
            setKey(type + 'SharingPrice', sharingPrice);
          }
          setKey('newProfile' + capitalizeFirstLetter(type) + 'Price', price);
          setKey('newProfile' + capitalizeFirstLetter(type) + 'VideoPrice', videoPrice);

          socialMedia.suggested_post_price = price;
          socialMedia.suggested_video_price = videoPrice;
          socialMedia.suggested_sharing_price = sharingPrice;

          switch (type) {
            case 'facebook':
              vm.facebookPrice = price;
              vm.facebookVideoPrice = videoPrice;
              var sharingPrice = PricingService.getSharingPrice(socialMedia.followers, type);
              vm.facebookSharingPrice = sharingPrice;
              setKey('newProfile' + capitalizeFirstLetter(type) + 'SharingPrice', sharingPrice);
              break;
            case 'instagram':
              vm.instagramPrice = price;
              vm.instagramVideoPrice = videoPrice;
              break;
            case 'youtube':
              vm.youtubePrice = price;
              vm.youtubeVideoPrice = videoPrice;
              break;
            case 'twitter':
              vm.twitterPrice = price;
              vm.twitterVideoPrice = videoPrice;
              break;
          }
          $scope.followers = socialMedia.followers;
          $scope.network = type;
          $scope.rowHeader = 'Suggested Pricing for ' + type;
          $scope.content = 'According to ' + capitalizeFirstLetter(type) + ', you have ' + socialMedia.followers + ' followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.';
          $scope.contentLineTwo = 'For your protection, this content will be disclosed per FTC guidelines.';
          $scope.header = 'Followers';
          if (display) {
            displayRowGridPrice();
          }
        }
      }
    }

    function clearSocial(handle, type) {
      lodash.forEach(Object.keys(handle), function (key) {
        if (key !== 'social_prices') delete handle[key];
        lodash.forEach(handle.social_prices, function (item) {
          delete item.price
        });
      });
      clearSocialPrice(type);
    }

    function typeIsFB(type) {
      return lodash.includes([SOCIAL.Facebook, SOCIAL.Twitter, SOCIAL.Pinterest], type);
    }

    function setSocialIndex(value) {
      clearInstagramSubtype();
      vm.selectedSocialIndex = value;
      setKey('newProfileSelectedSocialIndex', value);
    }

    function clearInstagramSubtype() {
      if (vm.selectedSocialIndex === 1 && !vm.profile.instagram_handle.url && vm.profile.instagram_handle.subtype) {
        vm.profile.instagram_handle.subtype = ''
      }
    }

    function setSocialTab(ev, newSocialIndex) {
      var socialHandle;
      var prices;
      switch (vm.selectedSocialIndex) {
        case 0:
          socialHandle = vm.profile.facebook_handle;
          prices = SOCIAL_PRICES.FACEBOOK;
          break;
        case 1:
          socialHandle = vm.profile.instagram_handle;
          prices = SOCIAL_PRICES.INSTAGRAM;
          break;
        case 2:
          socialHandle = vm.profile.youtube_handle;
          prices = SOCIAL_PRICES.YOUTUBE;
          break;
        case 3:
          socialHandle = vm.profile.twitter_handle;
          prices = SOCIAL_PRICES.TWITTER;
      }
      socialHandle.url ? checkSocialPrices(socialHandle, prices, newSocialIndex) : setSocialIndex(newSocialIndex);
    }

    function setSubtype(socialHandle, subtype) {
      socialHandle.subtype = subtype;
      setKey('newProfileInstagramHandle', socialHandle)
    }

    function checkSocialPrices(socialHandle, prices, newSocialIndex) {
      if (lodash.findIndex(socialHandle.social_prices, function (item) {
        if (item.price) return true
      }) < 0 && newSocialIndex > vm.selectedSocialIndex) {
        showConfirmSocialModal(prices.NAME, newSocialIndex, socialHandle)
      } else {
        setSocialIndex(newSocialIndex)
      }
    }

    function showConfirmSocialModal(socialNetwork, newSocialIndex, socialHandle) {
      var confirmText = 'Please give a price for at least one ' + socialNetwork + ' ad. ' +
        'If you do not give at least one price, then your ' + socialNetwork + ' channel will not be listed to marketers.';
      var confirm = $mdDialog.confirm()
        .title('Are you SURE?!?!')
        .textContent(confirmText)
        .cancel('Skip for now.')
        .ok('Give price now');

      $mdDialog.show(confirm).then(function (result) {
        clearInstagramSubtype();
      }, function () {
        setSocialIndex(newSocialIndex)
      });
    }

    function noSocialHandlesSet(ev, tabSelection) {
      if (!socialMediaProduct()) {
        var confirm = $mdDialog.confirm()
          .title('Are you SURE?!?!')
          .textContent('If you do not submit social handles, you will NOT be able to monetize Tweets and Posts!')
          .targetEvent(ev)
          .ok('Ok I\'ll Do it Now!')
          .cancel('No Thanks.');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 3;
          setProfileSelectedIndex();
        }, function () {
          if (!tabSelection) {
            findNextIndex();
          }
        });
      } else {
        findNextIndex();
      }
    }

    function getCurrentStepName() {
      return vm.stepNames[vm.selectedIndex];
    }

    function next(ev) {
      vm.showFormErrors = false;
      if (nextDisabled()) {
        vm.showFormErrors = true;
        switch (vm.selectedIndex) {
          case 0:
            toastr.error('Please complete required fields on this page.');
            break;
          case 1:
            toastr.error('Please provide a description and select at least one category.');
            break;
          default:
            toastr.error('Please complete required fields on this page.');
            break
        }
        return false;
      }
      switch (vm.selectedIndex) {
        case 0:
          if (vm.isInfluencer()) {
            checkAvatar(ev, false);
            return;
          }
          vm.showTypeError = !typeSelected();
          if (vm.form.$error.required || vm.form.$error.url || vm.form.$error.accepted || vm.form.$error.unmatched || vm.showTypeError) {
            vm.showFormErrors = true;
            return;
          }
          ProfilesService.checkUrl(vm.url.href, function (response) {
            var state = response.data.state;
            switch (state) {
              case "suspended":
                vm.state = "suspended";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "paused":
                vm.state = "paused";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "rejected":
                vm.state = "rejected";
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('active', false);
                break;
              case "duplicated":
                vm.showFormErrors = true;
                vm.form.domainUrl.$setValidity('unmatched', false);
                break;
              case "valid":
                vm.showFormErrors = false;
                updateDomain();
                checkAvatar(ev, false);
                break;
            }
          }, function (response) {
            toastr.error(response.data.error || 'Error checking domain url.');
          });
          break;
        case 1:
          if (!isBlogger() && !isInfluencer()) {
            findNextIndex();
          } else {
            if (isAudienceInfoCompleted()) {
              findNextIndex();
            } else {
              vm.showFormErrors = true;
              var confirm;
              if (isAudienceInfoCompletedPartially()) {
                confirm = $mdDialog.confirm()
                  .title('IMPORTANT!')
                  .textContent("It’s better to give fuller information about your audience in order to get more offers")
                  .targetEvent(ev)
                  .ok('I understand')
                  .cancel('I want to skip this');
              } else {
                confirm = $mdDialog.confirm()
                  .title('IMPORTANT!')
                  .textContent("It's important to give information about your audience.")
                  .targetEvent(ev)
                  .ok('I understand')
                  .cancel('I want to skip this');
              }
              $mdDialog.show(confirm).then(function (result) {
                goAudienceBlock();
              }, function () {
                findNextIndex();
              });
            }
          }
          break;
        case 2:
          noWebContentSet(ev, false);
          break;
        case 3:
          noSocialHandlesSet(ev, false);
          setPriceLabel();
          break;
      }
    }

    function previous(ev) {
      var pos = lodash.findLastIndex(vm.stepsLocker, function (step, index) {
        return !step && index < vm.selectedIndex;
      });

      if (isInfluencer() && pos === 1 || isBlogger() && pos === 2) {
        switch (vm.selectedSocialIndex) {
          case 0:
            vm.selectedIndex = Math.max(pos, 0);
            setProfileSelectedIndex();
            break;
          case 1:
            setSocialTab(ev, 0);
            break;
          case 2:
            setSocialTab(ev, 1);
            break;
          case 3:
            setSocialTab(ev, 2);
            break;
        }
      } else {
        vm.selectedIndex = Math.max(pos, 0);
        setProfileSelectedIndex();
      }
    }

    $scope.$on('tab-change', function (event, tabEvent) {
      // TODO: Do nothing when tabs are clicked.
      tabEvent.reject();
    });

    function noWebContentSet(ev, tabSelection) {
      if (!vm.profile.web_content.href) {
        var confirm = $mdDialog.confirm()
          .title('Please Select Analytics Account!')
          .textContent('By selecting an Google Analytics account, you are only authorizing Scalefluence to validate your monthly traffic.' +
            ' This is required for our Sponsored Content product.')
          .targetEvent(ev)
          .ok('Ok Got It!')
          .cancel('Move to next step');

        $mdDialog.show(confirm).then(function (result) {
          vm.selectedIndex = 2;
          setProfileSelectedIndex();
        }, function () {
          if (!tabSelection) {
            findNextIndex();
          }
        });
      } else {
        findNextIndex();
      }
    }

    /* STEP 5 */
    function showSEODialog() {
      showAlert('Minimum Values', 'We apologize but we need a minimum MOZ Domain Authority ' +
        'score of 15. And a minimum of of Majestic Trust Flow score of 5 for ' +
        'you to participate in this product. You currently do not meet one, ' +
        'or both, of these criteria. When you do reach these targets, you can ' +
        'come back to this profile and submit it then.', 'Ok I understand').then(function (result) {
        return false;
      });
    }

    function checkSEO(form) {
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      var valid = regex.test(vm.url.href);
      vm.domainUrlValid = valid;

      if (form.domainUrl) {
        form.domainUrl.$setValidity('url', valid);
      } else {
        form.url.$setValidity('url', valid);
      }

      if (valid) {
        if (vm.oldUrl != vm.url.href) {
          vm.oldUrl = vm.url.href;
          vm.seoFirstTime = true;
          vm.disableSEO = false;
          vm.canContinue = false;
        }

        if (vm.seoFirstTime) {
          ProfilesService.getDomainInformation(vm.url.href, function (response) {
            vm.domInfo = response.data;
            if (EnvironmentConfig.TEST_DA_SCORE !== undefined) vm.domInfo.domain_authority = EnvironmentConfig.TEST_DA_SCORE;
            if (EnvironmentConfig.TEST_TF_SCORE !== undefined) vm.domInfo.trust_flow = EnvironmentConfig.TEST_TF_SCORE;
            // console.log('min tf and da', MIN_VALUES.TF, MIN_VALUES.DA);
            // console.log('our vals', vm.domInfo.trust_flow, vm.domInfo.domain_authority);
            if (vm.domInfo.disable_add) {
              vm.canContinue = false;
            } else {
              vm.canContinue = true;
              setPriceLabel();
            }
          }, function (response) {
            return true;
          });
        } else {
          setPriceLabel();
        }
      }
    }

    function lastStep() {
      return vm.selectedIndex == TABS || (isInfluencer() && vm.selectedIndex === 3 && vm.selectedSocialIndex === 3);
    }

    function submit() {
      vm.showFormErrors = true;
      if (cantSubmit()) {
        if (isInfluencer() && !socialMediaProduct()) {
          showAlert('Social Handle Required', 'You need to connect at least one social handle before completing your profile ' +
            'and give a price for at least one ad', 'Got it').then(function (result) {
            return false;
          });
        } else if (isBlogger() && !socialMediaProduct() && !sponsoredBlogProduct()) {
          showAlert('Social Handle, Blog, or Guest Post Required', 'You need to connect at least one social handle, sponsored blog, or provide guest post details ' +
            'and provide pricing for at least one before completing your profile.', 'Got it').then(function (result) {
            return false;
          });
        } else {
          toastr.error('Please complete the required information before submitting.');
        }
        return false
      }
      // Check if there are social handles repeated
      if (
        oneProductIsSet() ||
        EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined ||
        EnvironmentConfig.TEST_DA_SCORE !== undefined ||
        EnvironmentConfig.TEST_TF_SCORE !== undefined
      ) {
        // If there is at least on product set then check if there are categories selected
        vm.noCategories = vm.categories.length === 0;
        if (!vm.noCategories) {
          continueSubmit();
        } else if (isContributor() || isBroker()) {
          $anchorScroll('scrollHere');
        }
      } else {
        showAlert('We are sorry', 'Please accept our sincerest apologies. But your domain ' +
          'and social handles do not meet minimum standards set by our Agency ' +
          'Partners. These are: *Web Traffic = 3000 / month, Social Following ' +
          '= 1000 followers and Domain Strength = DA of 15 and TF of 5.', 'Ok I understand').then(function (result) {
          return false;
        });
      }
    }

    function goAudienceBlock() {
      $anchorScroll('audience-data');
    }

    function continueSubmit() {
      vm.profile.categories_ids = lodash.map(vm.categories, 'id');
      vm.profile.urls = [];
      if (vm.igAuthCode) vm.profile.auth_key = vm.igAuthCode;
      if (!isInfluencer()) {
        vm.profile.urls.push(vm.url);
      } else {
        SocialHandlesService.setDescriptionToSocialHandles(vm.profile, vm.url.description);
      }
      ProfilesService.createProfile(vm.profile, function (response) {
        if (isInfluencer()) {
          showAlert('Take me live', 'Please note that we will need to vet your Social Handles ' +
            'through email to you. If you do not respond via email, then we will ' +
            'not approve your Profile. This means we will not be sending you any work.', 'OK. I understand ' +
            'and will respond via email.').then(function (result) {
            toastr.success('Successfully created the profile!');
            RoutesService.dashboard();
          });
        } else if (isBroker()) {
          showAlert('Submit', 'As a broker, you will be vetted by email. If you do ' +
            'not respond by email, we will not approve of any submissions.', 'OK. I understand ' +
            'and will respond via email.').then(function (result) {
            toastr.success('Successfully created the profile!');
            RoutesService.dashboard();
          });
        } else {
          toastr.success('Successfully created the profile!');
          RoutesService.dashboard();
        }
        vm.copyProfile = {};
        clearNewProfileLocalStorage()
      }, function (response) {
        handleErrors(response.data.errors);
      });
    }

    function handleErrors(errors) {
      lodash.forEach(errors, function (error) {
        toastr.error(error);
      });
    }

    function socialHandlesRepeated() {
      return SocialHandlesService.anyRepeated(vm.profile);
    }

    function oneProductIsSet(checkStep) {
      var webProduct = vm.profile.web_content.href && vm.profile.web_content.price;
      var socialProduct = socialMediaProduct();
      var seoProduct = vm.url.price;
      switch (checkStep) {
        case 3:
          if (!webProduct && !isBroker()) {
            showWarningPopup(checkStep);
          }
          break;
        case 4:
          if (!socialProduct && !isBroker() && !isContributor() && vm.profile.image) {
            showWarningPopup(checkStep);
          }
          break;
        default:
          return webProduct || socialProduct || seoProduct;
      }
    }

    function showWarningPopup(checkStep) {
      var confirm = $mdDialog.confirm()
        .title('Are you SURE?')
        .textContent('Skipping this step means you will earn less money with us!')
        .ok('Wait! Take me back!')
        .cancel('I understand');

      $mdDialog.show(confirm).then(function (result) {
        previous();
      }, function () {
        vm.selectedIndex = checkStep;
        setProfileSelectedIndex();
      });
    }

    function showInfo(step) {
      switch (step) {
        case 3:
          return showAlertHTML('Sponsored Web Content', '<div class="modal-text">' + 'Sponsored Web Content will read more like featured content. ' +
            'You will need to disclose compensation for the content per FTC regulations. ' +
            'Links inside the content will be NO-FOLLOW. You will have editorial control as well.' +
            '<br>' + '<br>' + 'By supplying your Google Analytics username below, our technology can see how ' +
            'many people engaged with each blog post. We will not be retrieving any ' +
            'private data from your Analytics account. Only the number of monthly ' +
            'unique visitors coming to your blog and previous content placements done through Scalefluence.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 31: // Case 3.1
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos & \'story messaging\' ' +
            'points if you accept this assignment. Choose which ones you like and seamlessly include them in a new blog post going over ' +
            'the product or service, you will then submit a draft for review and ' +
            'publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 32: // Case 3.2
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. Many low traffic bloggers ' +
            '(less than 2000 visits per month) will put $0 because products are usually around $50 to $150 retail. ' +
            'Marketers want photos of you reviewing the product / service. You will submit a draft for r' +
            'eview and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 33: // Case 3.3
          return showAlertHTML('Pricing for Sponsored Blog Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'This assignment is an unboxing video of you using the product with video + blog content. ' +
            'Please give an appropriate discount for the free product. We understand video is more impactful, ' +
            'takes longer and is more expensive, but again, please give a discount for free product ' +
            'being shipped to you. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 4:
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Sponsored Social Content is featured content on your social handle. ' +
            'You will need to disclose compensation for the content per FTC regulations ' +
            'by using #Ad or #Sponsored hashtags. Content will also come with a Tiny URL ' +
            'to track clicks and engagement of your Social Post. ' +
            '<br>' + '<br>' + 'By supplying your Social handles below, our technology can see how many ' +
            'people engaged with the social post. We will not be retrieving any private ' +
            'data of your account. Only the number of followers and previous content ' +
            'placements done through Scalefluence.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 411: // Case 4.1.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'You will be given a few branded assets / photos / hashtags &' +
            ' \'story messaging\' points if you accept this assignment. ' +
            'Choose which ones you like and seamlessly include them in a new FB post for review and publication.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 412: // Case 4.1.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Many micro-influencers put $0 because the products are usually around $50 to $150 retail.' +
            ' Marketers want photos of you using the product.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 413: // Case 4.1.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'Product will be shipped to you if you accept this assignment. ' +
            'Please give an appropriate discount for the free product. ' +
            'Marketers understand videos are more extensive and more impactful, ' +
            'but please still give a discount compensating for the $50 to $150 retail price of most products. ' +
            'Marketers want video of you using the product.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 414: // Case 4.1.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + 'You will be given an existing influencer story about the brand, ' +
            'or maybe a blog post / press / news story about the brand if you accept this assignment. ' +
            'You will share this and link to it when possible. ' +
            'You will write your own positive thoughts on the subject and submit for review and publication. ' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 421: // Case 4.2.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / photos / " +
            "hashtags & 'story messaging' points if you accept this assignment. Choose which ones you like and seamlessly " +
            "include them in a new IG post for review and publication." + '</div>', 'Ok').then(function (result) {
            return false;
          });

        case 422: // Case 4.2.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept this assignment." +
            " Please give an appropriate discount for the free product. Many micro-influencers put $0 because the " +
            "products are usually around $50 to $150 retail. " +
            "Marketers want photos of you using the product." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 423: // Case 4.2.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept this assignment. " +
            "This assignment is an unboxing video for an IG story as opposed to a single post. Please give an " +
            "appropriate discount for the free product. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 424: // Case 4.2.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. But a brand may feel that " +
            "they are 'in tune' with your audience that they will want to schedule out 3 posts with you over several months. " +
            "Please a give a 10 to 20% discount for this to entice marketers to work with you 3 times over." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 425: // Case 4.2.5
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post " +
            "but a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
            "posts with you over several months. Please a give a 20 to 30% discount to entice marketers to " +
            "work you with 5 times over." + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 431: // Case 4.3.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / photos / " +
            "hashtags & 'story messaging' points if you accept this assignment. Choose which ones you like " +
            "and seamlessly include them in a new video for review and publication. This type of promotion " +
            "is also called a 'pre-roll ad' or 'mid-roll ad' . Such as:  'This video is brought " +
            "to you by our partners.'" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 432: // Case 4.3.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets / " +
            "photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones " +
            "you like and seamlessly include them in a new video for review and publication. " +
            "This type of promotion is also called a 'pre-roll ad' or 'mid-roll ad'. " +
            "Such as: 'This video is brought to you by our partners.'" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 433: // Case 4.3.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule " +
            "out 3 videos with you over several months. Please a give a 10 to 20% discount " +
            "for this product to entice marketers to work with you 3 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 434: // Case 4.3.4
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "This is the same as a single post. " +
            "But a brand may feel that they are 'in tune' with your audience and will want to schedule out 5 " +
            "videos with you over several months. Please a give a 20 to 30% discount for this product " +
            "to entice marketers to work with you 5 times over. " +
            "This selection is ONLY for pre-roll & midroll ads. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 441: // Case 4.4.1
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "You will be given a few branded assets" +
            " / photos / hashtags & 'story messaging' points if you accept this assignment. Choose which ones you " +
            "like and seamlessly include them in a new video for review and publication" + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 442: // Case 4.4.2
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept " +
            "this assignment. Please give an appropriate discount for the free product. " +
            "Many micro-influencers put $0 because the products are usually around $50 to $150 retail. " +
            "Marketers want photos of you using the product. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 443: // Case 4.4.3
          return showAlertHTML('Sponsored Social Content', '<div class="modal-text">' + "Product will be shipped to you if you accept " +
            "this assignment. This assignment is a video of you using the product. We know video takes more time and is more expensive, " +
            "but please give an appropriate discount for the free product. products are usually around $50 to $150 retail. " +
            '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 51: // Case 5.1
          return showAlertHTML('Allow Home Page Links?', '<div class="modal-text">' + "Home page links are, on the whole, branded anchor text. " +
            "This means including the brand name in the link. For example: According to Forbes. " +
            " With ' Forbes ' being the anchor text. " + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 52: // Case 5.2
          return showAlertHTML('Are Links Do-Follow?', '<div class="modal-text">' + 'Do-Follow links are purchased about 5 times more than ' +
            'No-Follow links. You can change this selection at any time after ' +
            'our team approves your site.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 53: // Case 5.3
          return showAlertHTML('I only allow links to blog posts', '<div class="modal-text">' + 'While linking to blog content is the best practice; ' +
            'SEO firms will request links to service pages. ' + "Even if you select 'yes', you will still have the ability  " +
            'to accept (or decline) content that links elsewhere. Upon order, you can determine if the link is ' +
            'appropriate and request changes.' + '</div>', 'Ok').then(function (result) {
            return false;
          });
        case 54: // Case 5.
          return showAlertHTML('Required article length?', '<div class="modal-text">' + 'Please give the amount of words you require per article. Thank you!', 'Ok').then(function (result) {
            return false;
          });
      }

      $mdDialog.show(confirm).then(function (result) {
        return false;
      });
    }

    function getPricingLabel(socialHandle, network) {
      return socialHandle.followers ? 'Suggested price: ' + PricingService.getPrice(socialHandle.followers, network) : 'Sign in to Submit Price';
    }

    function getPricingLabelGA(network) {
      vm.profile.web_content.suggested_post_price = PricingService.getPrice(vm.web_content.muv, network);
      vm.profile.web_content.suggested_video_price = PricingService.getVideoPrice(vm.web_content.muv, network);
    }

    function socialMediaProduct() {
      return lodash.findIndex(SocialHandlesService.getAllSocialHandle(vm.profile), function (socialHandle) {
        if (socialHandle.url && lodash.findIndex(socialHandle.social_prices, function (item) {
          if (item.price) return true
        }) >= 0) {
          return true;
        }
      }) !== -1;
    }

    function sponsoredBlogProduct() {
      return gaPriceChangeEnabled() && isAnalyticsCompleted()
    }

    function seoProduct() {
      return vm.url.href && vm.url.description && vm.url.price;
    }

    function getDescriptionTitle(tooltip) {
      if (vm.url.description && !tooltip && !isContributor()) {
        return "Description";
      } else if (isContributor()) {
        return 'Description: Describe what you write about. Be specific so that we can ' +
          'pitch you the right topics'
      }
      return "Description: Use \"My Meta Description\" or write your own." +
        "If you write your own, include friendly KWs. IE >> \"Health | Travel | Tech \" etc.";
    }

    function getFinishText() {
      return isInfluencer() && vm.selectedIndex == 3 ? 'Take Me Live!' : 'Finish';
    }

    function getNextSocialButtonText() {
      switch (vm.selectedSocialIndex) {
        case 0:
          return 'Save facebook';
        case 1:
          return 'Save instagram';
        case 2:
          return 'Save youtube'
      }
    }

    function cantSubmit() {
      if (isBroker()) {
        return !seoProduct();
      } else if (isInfluencer()) {
        return !socialMediaProduct();
      } else if (isBlogger()) {
        return !socialMediaProduct() && !sponsoredBlogProduct() && (!vm.url.description || !vm.url.price);
      } else if (isContributor()) {
        return !vm.url.description || !vm.url.price;
      }
    }

    function getTileForInfluencersDescription() {
      return vm.influencer.description ? "Description" : "Description: Tell Us " +
        "About Yourself and Your Audience. What type of content best resonates?";
    }

    function setPriceLabel() {
      if (!vm.url.href) {
        vm.priceLabel = 'Your price per post (USD):';
      } else if (vm.domInfo && vm.domInfo.trust_flow >= MIN_VALUES.TF &&
        vm.domInfo.domain_authority >= MIN_VALUES.DA) {

        // suggested_price is included in the domain_information response that
        // already populated vm.domInfo; avoid the redundant /urls/suggested_price
        // round trip that used to burn extra API credits on cache misses.
        vm.priceLabel = vm.domInfo.suggested_price
          ? 'Suggested price: ' + vm.domInfo.suggested_price
          : 'Your price per post (USD):';

        $rootScope.da = vm.domInfo.domain_authority;
        $rootScope.tf = vm.domInfo.trust_flow;
      } else {
        vm.priceLabel = 'Your price per post (USD):';
      }
    }

    function showWarningPopup() {
      showAlert('Suggested Pricing', 'In order to be able to display the suggested price, you must sign in to the social network', 'Got it!');
    }

    function showAlert(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .textContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
          .title(title)
          .htmlContent(text)
          .escapeToClose(false)
          .ok(confirmText)
      );
    }

    function typeSelected() {
      // will be non-empty string if selected
      return !!vm.profile.profileType;
    }

    function setContentType(type) {
      vm.profile.contentType = type;
      setKey('newProfileUrlContentType', vm.profile.contentType);
    }

    function contentTypeSelected() {
      // will be non-empty if selected
      return !!vm.profile.contentType;
    }

    function getYouTubeFollowers(socialHandle) {
      GoogleService.queryYouTubeStatistics(function (response) {
        if (response.result.items && response.result.items.length) {
          socialHandle.url = 'www.youtube.com/channel/' + response.result.items[0].id;
          socialHandle.followers = response.result.items[0].statistics.subscriberCount;
          setKey('newProfileYotubeHandles', socialHandle);
          if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
          checkSocialMinValues('youtube', socialHandle);
        } else {
          toastr.error('No channel associated to your account.');
        }
      });
    }

    function authenticateTwitter() {
      $window.location.href = EnvironmentConfig.API_END_POINT.replace('/api/v1', '/auth/twitter?action=new');
    }

    function handleFacebookConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        handleFacebookAuthentication(socialHandle, socialNetwork);
      }
    }

    function handleInstagramConnection(socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        switch (socialHandle.subtype) {
          case 'simple':
            getAuthURL();
            break;
          case 'verified':
            handleFacebookAuthentication(socialHandle, socialNetwork);
            break;
        }
      }
    }

    function handleYoutubeConnection(ev, socialHandle, socialNetwork) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, socialNetwork);
      } else {
        authorize(ev, true, socialHandle)
      }
    }

    function handelTwitterConnection(ev, socialHandle) {
      if (socialHandle.url) {
        disconnectSocial(socialHandle, 'twitter');
      } else {
        authenticateTwitter()
      }
    }

    function handleFacebookAuthentication(socialHandle, socialNetwork) {
      FacebookService.authenticate(socialNetwork, function (userId) {
        switch (socialNetwork) {
          case 'facebook':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var username = account.username || account.id;
                if (checkExistedSocialAccount(socialNetwork, username)) {
                  showUseAnotherAccountModal(socialHandle, socialNetwork)
                } else {
                  FacebookService.revokePermissions();
                  loadSocialHandle(socialHandle, socialNetwork, username, account.fan_count);
                }
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
          case 'instagram':
            FacebookService.getUserAccounts(userId, function (response) {
              showChooseAccountModal(response, function (response) {
                var account = JSON.parse(response);
                var fanPageId = account.id;
                FacebookService.checkForInstagramBusinessAccount(fanPageId, function (response) {
                  if (checkExistedSocialAccount(socialNetwork, response.username)) {
                    showUseAnotherAccountModal(socialHandle, socialNetwork)
                  } else {
                    FacebookService.revokePermissions();
                    loadSocialHandle(socialHandle, socialNetwork, response.username, response.followers_count);
                  }
                }, function (error) {
                  toastr.error(error);
                });
              }, function () {
                toastr.error('Error while retrieving account information');
              });
            }, function (error) {
              toastr.error(error);
            });
            break;
        }
      }, function (error) {
        toastr.error(error);
      });
    }

    function disconnectSocial(socialHandle, socialNetwork) {
      socialHandle._destroy = 1;
      var profile = vm.profile;
      var updateData = false;
      switch (socialNetwork) {
        case 'facebook':
          updateData = {
            facebook_handle: profile.facebook_handle
          };
          break;
        case 'instagram':
          updateData = {
            instagram_handle: profile.instagram_handle
          };
          break;
        case 'youtube':
          updateData = {
            youtube_handle: profile.youtube_handle
          };
          break;
        case 'twitter':
          updateData = {
            twitter_handle: profile.twitter_handle
          };
          break;
      }

      if (updateData === false) {
        toastr.error('Sorry, no profile found for that handle. Please try again and report this error if it persists.');
        return;
      }

      clearSocial(socialHandle, socialNetwork);

      toastr.success('Disconnected from social network successfuly.');
    }


    function checkExistedSocialAccount(socialNetwork, username) {
      var url = 'https://www.' + socialNetwork + '.com/' + username;
      if (_.includes(vm.profileSocialUrls, url)) {
        return true
      }
    }

    function loadSocialHandle(socialHandle, socialNetwork, username, count) {
      socialHandle.url = 'https://www.' + socialNetwork + '.com/' + username;
      socialHandle.followers = count;
      var key;
      switch (socialNetwork) {
        case 'facebook':
          key = 'newProfileFacebookHandle';
          break;
        case 'instagram':
          key = 'newProfileInstagramHandle';
      }
      setKey(key, socialHandle);
      // if (EnvironmentConfig.TEST_SOCIAL_FOLLOWERS !== undefined) socialHandle.followers = EnvironmentConfig.TEST_SOCIAL_FOLLOWERS;
      checkSocialMinValues(socialNetwork, socialHandle);
    }

    function showUseAnotherAccountModal(socialHandle, socialNetwork) {
      var confirm = $mdDialog.confirm()
        .title('Account is already linked')
        .htmlContent('<p>You have already connected this handle in another profile.</p>' +
          'Please email ' + '<strong>admin@scalefluence.com</strong>' + ' for help.</p>')
        .ok('Connect other')
        .cancel('Ok got it');
      $mdDialog.show(confirm).then(function () {
        socialHandle.url = null;
        switch (socialNetwork) {
          case 'facebook':
            handleFacebookConnection(socialHandle, socialNetwork, true);
            break;
          case 'instagram':
            handleInstagramConnection(socialHandle, socialNetwork, true)
        }
      }, function () {
        disconnectSocial(socialHandle, socialNetwork)
      });
    }


    function showChooseAccountModal(accounts, successCallback, errorCallback) {
      $mdDialog.show({
        controller: 'SocialHandleController',
        controllerAs: 'ctrl',
        templateUrl: 'app/pages/profiles/newProfile/partials/socialHandleDialog.html',
        clickOutsideToClose: false,
        locals: {
          accounts: accounts,
        }
      }).then(function (response) {
          successCallback(response)
        },
        errorCallback);
    }


    function toggleCategories() {
      vm.categoriesOn = !vm.categoriesOn;
    }

    function categoriesActionMsg() {
      return vm.categoriesOn ? 'Hide Categories' : 'Show Categories';
    }

    function toggleElements() {
      vm.elementsOn = !vm.elementsOn;
    }

    function elementsActionMsg() {
      return vm.elementsOn ? 'Hide Properties' : 'Show Properties';
    }

    function setUrlRequiredLength(requiredLength) {
      switch (requiredLength) {
        case '1500-+':
        case '1250-1500':
        case '1000-1250':
          vm.url.required_length = requiredLength;
          break;

        default:
          vm.url.required_length = '750-1000'
      }
      setKey('newProfileUrlRequiredLength', vm.url.required_length);
    }

    function setUrlAllowHomepage(allow) {
      vm.url.allow_home_page = allow ? 'true' : 'false';
      if (allow) {
        vm.url.allow_blog_post = 'false';
      } else {
        vm.url.allow_blog_post = 'true';
      }
      setKey('newProfileUrlAllowBlogPost', vm.url.allow_blog_post);
      setKey('newProfileUrlAllowHomepage', vm.url.allow_home_page);
    }

    function setUrlFollowLink(isDoFollow) {
      vm.url.follow_link = isDoFollow ? 'true' : 'false';
      setKey('newProfileUrlFollowLink', vm.url.follow_link);
    }

    function setUrlAllowBlogPost(allow) {
      vm.url.allow_blog_post = allow ? 'true' : 'false';
      setKey('newProfileUrlAllowBlogPost', vm.url.allow_blog_post);
    }

    function disconnectGA(showMsg) {
      vm.profile.web_content.href = '';
      vm.profile.web_content.muv = '';
      vm.profile.web_content.ga_account_id = '';
      vm.profile.web_content.ga_profile_id = '';
      vm.profile.web_content.website_url = '';
      vm.initialAnalytics.selected = "none";
      vm.selectedAnalytics = vm.initialAnalytics;
      console.log("Analytics de authorized");
      vm.analyticsAuthorized = false;

      lodash.forEach(vm.profile.web_content.web_content_prices, function (key) {
        delete key.price
      });

      lodash.forEach([
        'newProfileGoogleAnalytics',
        'newProfileSelectedAnalytics',
        'newProfileAnalyticsAuthorized',
        'newProfileWebContentMuv',
        'newProfileWebContentHref'
      ], function (key) {
        removeKey(key);
      });

      if (showMsg !== false) toastr.success('Analytics account disconnected.');
    }

    function getPropertyLabelGA() {
      return vm.web_content.muv && vm.analyticsAuthorized && vm.selectedAnalytics ? 'Website (' + vm.web_content.muv + ' visits)' : 'Website';
    }

    function gaPriceChangeEnabled() {
      return vm.profile.web_content.href && vm.web_content.muv >= MIN_VALUES.GA;
    }

    function updateDomain() {
      vm.form.domainUrl.$setValidity('active', true);
      vm.form.domainUrl.$setValidity('unmatched', true);
    }

    function setProfileSelectedIndex() {
      setKey('newProfileSelectedIndex', vm.selectedIndex);
    }

    function setNewProfileType() {
      setKey('newProfileType', vm.profile.profileType);
    }

    function setNewProfileName() {
      setKey('newProfileName', vm.profile.name);
    }

    function setNewProfileUrl() {
      setKey('newProfileUrl', vm.url.href);
    }

    function setNewProfileDescription() {
      setKey('newProfileDescription', vm.url.description);
    }

    function setNewProfileUrlPrice() {
      setKey('newProfileUrlPrice', vm.url.price);
    }

    function setNewProfileAuthorPage() {
      setKey('newProfileUrlAuthorPage', vm.url.author_page);
    }

    function setNewProfileWebContentPrice(value, key) {
      setKey(key, value);
    }

    function setAudienceGenderGroup() {
      setKey('newProfileAudienceGenderGroup', vm.profile.audience.audience_gender);
    }

    function setAudienceEstimatedIncome() {
      setKey('newProfileAudienceEstimatedIncome', vm.profile.audience.estimated_income);
    }

    function setNewProfileSocialPrice(value, socialNetwork) {
      var key = switchSocialKey(socialNetwork);
      var field = socialNetwork.concat('_handle');
      var socialHandle = vm.profile[field];
      setKey(key, socialHandle);
    }

    function clearSocialPrice(socialNetwork) {
      var key = switchSocialKey(socialNetwork);
      removeKey(key);
    }

    function switchSocialKey(socialNetwork) {
      switch (socialNetwork) {
        case 'facebook':
          return 'newProfileFacebookHandle';
        case 'instagram':
          return 'newProfileInstagramHandle';
        case 'youtube':
          return 'newProfileYoutubeHandle';
        case 'twitter':
          return 'newProfileTwitterHandle';
      }
    }

    function clearNewProfileLocalStorage() {
      var keys = StorageService.getAll();
      keys.forEach(function (key){
        if (key.includes('newProfile')) {
          removeKey(key)
      }});
    }

    function getKey(key) {
      return StorageService.get(key)
    }

    function setKey(key, value) {
      StorageService.set(key, value)
    }

    function removeKey(item) {
      StorageService.remove(item)
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('CreateProfileV1Controller', CreateProfileV1Controller)
    .controller('DialogController', DialogController);
  /* @ngInject */
  function CreateProfileV1Controller($scope, $mdDialog, PROFILE_TYPE, RoutesService, ProfilesService, toastr, lodash) {
    var vm = this;
    vm.showFormErrors = false;
    vm.showRepeatedNameError = false;
    vm.form = {};
    vm.profileNames = [];
    //Accesible variables
    vm.socialHandle = '';
    vm.showBlankProfilePhoto = false;

    //Accesible functions
    vm.setAsInfluencer = setAsInfluencer;
    vm.setAsContributor = setAsContributor;
    vm.setAsBlogger = setAsBlogger;
    vm.setAsBroker = setAsBroker;
    vm.influencer = influencer;
    vm.blogger = blogger;
    vm.broker = broker;
    vm.contributor = contributor;
    vm.saveProfile = saveProfile;
    vm.createProfile = createProfile;
    vm.checkNewProfileName = checkNewProfileName;
    vm.cancel = cancel;

    initialize();

    function initialize() {
      vm.profile = {};
      ProfilesService.getProfileNames(function (response) {
        vm.profileNames = response.data.profile_names;
      });
    }

    function setAsInfluencer() {
      vm.profile.profileType = PROFILE_TYPE.INFLUENCER;
      vm.showTypeError = false;
    }

    function setAsBlogger() {
      vm.profile.profileType = PROFILE_TYPE.BLOGGER;
      vm.showTypeError = false;
    }

    function setAsBroker() {
      vm.profile.profileType = PROFILE_TYPE.BROKER;
      vm.showTypeError = false;
    }

    function setAsContributor() {
      vm.profile.profileType = PROFILE_TYPE.CONTRIBUTOR;
      vm.showTypeError = false;
    }

    function influencer() {
      return PROFILE_TYPE.INFLUENCER;
    }

    function blogger() {
      return PROFILE_TYPE.BLOGGER;
    }

    function broker() {
      return PROFILE_TYPE.BROKER;
    }

    function contributor() {
      return PROFILE_TYPE.CONTRIBUTOR;
    }

    function checkNewProfileName() {
      var res =  lodash.findIndex(vm.profileNames, function (name) {
        return name === vm.profile.name;
      }) ;

      vm.showRepeatedNameError = res !== -1
    }

    function saveProfile(skipPhoto) {
      if (!vm.profile.name || !vm.profile.profileType) {
        vm.showBlankProfileData = true;
        return
      }

      if (!vm.profile.image && !skipPhoto) {
        vm.showBlankProfilePhoto = true;
        $mdDialog.show({
          controller: DialogController,
          controllerAs: 'ctrl',
          templateUrl: 'app/pages/profiles/createProfileV1/imageDialogV1.html',
          clickOutsideToClose: false,
          escapeToClose: true,
          focusOnOpen: true,
          autoWrap: true,
          skipHide: true,
          preserveScope: true
        }).then(function () {
          createProfile()
        })
      } else {
        createProfile()
      }
    }

    function createProfile() {
      ProfilesService.createProfile(vm.profile, function (response) {
        toastr.success('Successfully created the profile!');
        $mdDialog.hide(response.data.id, response.data);
      }, function (response) {
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
  function DialogController($mdDialog) {
    var vm = this;
    vm.cancel = cancel;
    vm.hide = hide;

    function cancel() {
      $mdDialog.cancel();
    }

    function hide() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('CreateProfileController', CreateProfileController)
    .controller('DialogController', DialogController);
  /* @ngInject */
  function CreateProfileController($scope, $mdDialog, PROFILE_TYPE, RoutesService, ProfilesService, toastr, lodash) {
    var vm = this;
    vm.showFormErrors = false;
    vm.showRepeatedNameError = false;
    vm.form = {};
    vm.profileNames = [];
    //Accesible variables
    vm.socialHandle = '';
    vm.showBlankProfilePhoto = false;

    //Accesible functions
    vm.setAsInfluencer = setAsInfluencer;
    vm.setAsContributor = setAsContributor;
    vm.setAsBlogger = setAsBlogger;
    vm.setAsBroker = setAsBroker;
    vm.influencer = influencer;
    vm.blogger = blogger;
    vm.broker = broker;
    vm.contributor = contributor;
    vm.saveProfile = saveProfile;
    vm.createProfile = createProfile;
    vm.checkNewProfileName = checkNewProfileName;
    vm.cancel = cancel;

    initialize();

    function initialize() {
      vm.profile = {};
      ProfilesService.getProfileNames(function (response) {
        vm.profileNames = response.data.profile_names;
      });
    }

    function setAsInfluencer() {
      vm.profile.profileType = PROFILE_TYPE.INFLUENCER;
      vm.showTypeError = false;
    }

    function setAsBlogger() {
      vm.profile.profileType = PROFILE_TYPE.BLOGGER;
      vm.showTypeError = false;
    }

    function setAsBroker() {
      vm.profile.profileType = PROFILE_TYPE.BROKER;
      vm.showTypeError = false;
    }

    function setAsContributor() {
      vm.profile.profileType = PROFILE_TYPE.CONTRIBUTOR;
      vm.showTypeError = false;
    }

    function influencer() {
      return PROFILE_TYPE.INFLUENCER;
    }

    function blogger() {
      return PROFILE_TYPE.BLOGGER;
    }

    function broker() {
      return PROFILE_TYPE.BROKER;
    }

    function contributor() {
      return PROFILE_TYPE.CONTRIBUTOR;
    }

    function checkNewProfileName() {
      var res =  lodash.findIndex(vm.profileNames, function (name) {
        return name === vm.profile.name;
      }) ;

      vm.showRepeatedNameError = res !== -1
    }

    function saveProfile(skipPhoto) {
      vm.profile.profileType = 'blogger';
      if (!vm.profile.name || !vm.profile.profileType) {
        vm.showBlankProfileData = true;
        return
      }

      if (!vm.profile.image && !skipPhoto) {
        vm.showBlankProfilePhoto = true;
        $mdDialog.show({
          controller: DialogController,
          controllerAs: 'ctrl',
          templateUrl: 'app/pages/profiles/createProfile/imageDialog.html',
          clickOutsideToClose: false,
          escapeToClose: true,
          focusOnOpen: true,
          autoWrap: true,
          skipHide: true,
          preserveScope: true
        }).then(function () {
          createProfile()
        })
      } else {
        createProfile()
      }
    }

    function createProfile() {
      ProfilesService.createProfile(vm.profile, function (response) {
        toastr.success('Successfully created the profile!');
        $mdDialog.hide(response.data.id, response.data);
      }, function (response) {
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
  function DialogController($mdDialog) {
    var vm = this;
    vm.cancel = cancel;
    vm.hide = hide;

    function cancel() {
      $mdDialog.cancel();
    }

    function hide() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.allV1', [])
    .controller('AllProfilesV1Controller', AllProfilesV1Controller);

  /** @ngInject */
  function AllProfilesV1Controller($log, $anchorScroll, toastr, ProfilesService) {
    var vm = this;

    // Accessible attributes
    vm.profiles = [];
    vm.perPage = 5;
    vm.total_profiles = 0;
    vm.query = {
      limit: 5,
      page: 1,
      filter: ''
    };

    //Accessible functions
    vm.goTop = goTop;
    vm.paginateProfiles = paginateProfiles;
    vm.searchProfiles = searchProfiles;
    vm.fetchProfiles = fetchProfiles;

    initialize();

    //Functions
    function initialize() {
      fetchProfiles();
    }

    function goTop() {
      $anchorScroll('top');
    }

    function paginateProfiles(newPageNumber, oldPageNumber) {
      vm.query.page = newPageNumber;
      fetchProfiles();
      goTop();
    }

    function fetchProfiles() {
      ProfilesService.indexProfiles(vm.query, function (response) {
        vm.profiles = response.data.profiles;
        vm.total_profiles = response.data.results;
      }, function (response) {
        toastr.error('There was an error retrieving profiles');
        $log.error(response);
      });
    }

    function searchProfiles(event) {
      if (event.keyCode !== 13) return;
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchProfiles();
        goTop();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles.all', [])
    .controller('AllProfilesController', AllProfilesController);

  /** @ngInject */
  function AllProfilesController($log, $anchorScroll, toastr, ProfilesService, $mdDialog, RoutesService, AccountService, EnvironmentConfig) {
    var vm = this;

    // Accessible attributes
    vm.profiles = [];
    vm.perPage = 5;
    vm.total_profiles = 0;
    vm.query = {
      limit: 5,
      page: 1,
      filter: ''
    };

    //Accessible functions
    vm.goTop = goTop;
    vm.paginateProfiles = paginateProfiles;
    vm.searchProfiles = searchProfiles;
    vm.fetchProfiles = fetchProfiles;
    vm.showCreateProfileModal = showCreateProfileModal;

    initialize();

    //Functions
    function initialize() {
      AccountService.getPublisher(function (response) {
        vm.publisher = response.data;
        fetchProfiles();
      });
    }

    function goTop() {
      $anchorScroll('top');
    }

    function paginateProfiles(newPageNumber, oldPageNumber) {
      vm.query.page = newPageNumber;
      fetchProfiles();
      goTop();
    }

    function fetchProfiles() {
      ProfilesService.indexProfiles(vm.query, function (response) {
        vm.profiles = response.data.profiles;
        vm.total_profiles = response.data.results;
      }, function (response) {
        toastr.error('There was an error retrieving profiles');
        $log.error(response);
      });
    }

    function searchProfiles(event) {
      if (event.keyCode !== 13) return;
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchProfiles();
        goTop();
      }
    }

    function showCreateProfileModal() {
      var pDate = Date.parse(vm.publisher.created_at);
      var v2Date = Date.parse(EnvironmentConfig.V2_PROFILE_SWITCH_DATE);
      console.log('pdate, vdate', pDate, v2Date);
      if (pDate < v2Date) {

        $mdDialog.show({
          controller: 'CreateProfileV1Controller',
          controllerAs: 'createProfCtrl',
          templateUrl: 'app/pages/profiles/createProfileV1/createProfileV1Dialog.html',
          clickOutsideToClose: false,
          bindToController: true,
          escapeToClose: true,
          focusOnOpen: true
        }).then(function (id, profile, type) {
          RoutesService.editProfileV2(id, profile, vm.publisher);
        });

      } else {

        $mdDialog.show({
          controller: 'CreateProfileController',
          controllerAs: 'createProfCtrl',
          templateUrl: 'app/pages/profiles/createProfile/createProfileDialog.html',
          clickOutsideToClose: false,
          bindToController: true,
          escapeToClose: true,
          focusOnOpen: true
        }).then(function (id, profile) {
          RoutesService.editProfileV2(id, profile, vm.publisher);
        });

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.landing.signUp', ['betsol.intlTelInput'])
    .config(function (intlTelInputOptions) {
      angular.extend(intlTelInputOptions, {
        nationalMode: false,
        defaultCountry: 'us',
        autoFormat: true,
        separateDialCode: true,
      })
    })
    .controller('SignUpController', SignUpController);

  /* @ngInject */
  function SignUpController($rootScope, $scope, $stateParams, $mdDialog, $mdMedia, $log, toastr, lodash, MIN_PASS_SIZE,
    PasswordMeter, UserService, AuthenticationService, AccountService, RoutesService, $location, GoogleSingleSignOnService) {
    var vm = this;
    vm.user = {};
    vm.password = '';
    vm.passEval;
    vm.passTextStrength = '';
    vm.advertiser = false;
    vm.publisher = false;
    vm.poptin = false;
    vm.poptinName = 'Visitor';
    vm.noTypeSelected = false;
    vm.oldEmail;
    vm.attemptEmail = false;
    vm.accountType = $stateParams.accountType;
    vm.telMask = '999-999-9999';
    vm.ssoEmail = $stateParams.ssoEmail;

    // Accessible Functions
    vm.submit = submit;
    vm.samePassword = samePassword;
    vm.canChangePassword = canChangePassword;
    vm.checkStrength = checkStrength;
    vm.displayCheckboxError = displayCheckboxError;
    vm.toggleOption = toggleOption;
    vm.checkEmail = checkEmail;
    vm.updateAttempt = updateAttempt;
    vm.countryChangeEvent = countryChangeEvent;
    vm.showSsoMsg = showSsoMsg;
    vm.checkConfirmEmail = checkConfirmEmail;

    init();

    function init() {
      vm.user = {
        first_name: '',
        last_name: '',
        email: '',
        confirm_email: '',
        password: '',
        password_confirmation: ''
      };
      vm.oldEmail = vm.user.email;

      // poptin popup on scalefluence blogposts redirects to app signup
      // with first name (text_3) and email (email) as parameters in url
      // we want to auto complete those for the user
      if($location.search().text_3) {
        vm.user.first_name = $location.search().text_3;
        vm.poptinName = vm.user.first_name
        vm.poptin = true;
      }
      if($location.search().email) {
        vm.user.email = $location.search().email;
        vm.poptin = true;
      }

      if($stateParams.accountType === 'influencer') {
        vm.publisher = true;
        $rootScope.title = 'Influencers! Get Paid to Work | Scalefluence.com';
        $rootScope.metaDesc = 'Influencers and Bloggers Can Collaborate with Brands. Register today at Scalefluence.com!';
      }
      else if($stateParams.accountType === 'agency') {
        vm.advertiser = true;
        $rootScope.title = 'Influencer Marketing for Agencies and Brands | Scalefluence.com';
        $rootScope.metaDesc = 'An influencer marketing platform designed to give deep insight through over a dozen different data points. Marketers can collaborate with thousands of influencers with Scalefluence.com';
      }
      else {
        vm.noTypeSelected = true;
        $rootScope.title = 'A next generation marketplace for savvy influencers and brands to collaborate | Scalefluence.com';
        $rootScope.metaDesc = 'A next generation marketplace for savvy influencers and brands to collaborate';
      }

      !vm.noTypeSelected && initGoogleSingleSignOn();


      countryChangeEvent();
    }

    function initGoogleSingleSignOn() {
      GoogleSingleSignOnService.googleInit(function(response) {
        const responsePayload = UserService.decodeJwtResponse(response.credential);
        const userDetails = {
          email: responsePayload.email,
          first_name: responsePayload.given_name,
          last_name: responsePayload.family_name
        };

        googleAuth(userDetails);
      });

      GoogleSingleSignOnService.renderGoogleButton();
    }

    function googleAuth(userDetails) {
      UserService.googleAuth(userDetails, vm.advertiser, vm.publisher);
    }

    function countryChangeEvent() {
      setTimeout(function() {
        $('.country-list.hide').bind('click', function() {
          var placeholder = $('#phone-input').attr('placeholder');
          if (placeholder !== vm.telMask) {
            vm.telMask = placeholder.replace(/[0-8]/g, "9");
          }
        })
      }, 1000);
    }

    function submit(ev) {
      // band-aid to stop signups from repeat offender RANDOM@thepacbook.com
      if (vm.user.email.toLowerCase().includes('@thepacbook.com')) {
        RoutesService.thankYou($stateParams.accountType);
      } else {
        vm.user.password = vm.password;

        UserService.signUp(vm.user, vm.advertiser, vm.publisher, function (response) {
          RoutesService.thankYouWithEmail($stateParams.accountType, vm.user.email);
        }, function () {
          toastr.error('There was an error retrieving your dashboard\'s info.')
        });
      }
    }

    function samePassword() {
      return angular.equals(vm.password, vm.user.password_confirmation);
    }

    function canChangePassword() {
      $scope.signUpForm.confirmPassword.$setValidity('no-match', samePassword());
    }

    function confirmEmail() {
      return angular.equals(vm.user.email, vm.user.confirm_email);
    }

    function checkConfirmEmail() {
      $scope.signUpForm.confirmEmail.$setValidity('no-match', confirmEmail());
    }

    function checkStrength() {
      vm.passEval = vm.password ? (vm.password.length > MIN_PASS_SIZE && PasswordMeter.evaluatePassword(vm.password) || 0) : null;
      if (vm.passEval == 4) return 'Strong';
      return vm.passEval in [0, 1] ? 'Weak' : 'Medium';
    }

    function signIn() {
      vm.credentials = {
        email: vm.user.email,
        password: vm.user.password
      };

      AuthenticationService.login(vm.credentials,
        function () {
          RoutesService.dashboard();
        },
        function (response) {
          var message = response.data.error || response.data.errors[0];
          if (lodash.includes(message, 'authentication')) {
            toastr.error('Incorrect email or password');
          } else if (lodash.includes(message, 'suspended')) {
            toastr.error(message);
          }
        });
    }

    function displayCheckboxError() {
      vm.noTypeSelected = !(vm.advertiser || vm.publisher);
    }

    function toggleOption(opt) {
      switch (opt) {
      case 'adv':
        vm.noTypeSelected = vm.advertiser && !vm.publisher;
        break;
      case 'pub':
        vm.noTypeSelected = vm.publisher && !vm.advertiser;
      }
    }

    function checkEmail() {
      vm.attemptEmail = true;
      if (vm.user.email !== vm.oldEmail) {
        vm.oldEmail = vm.user.email;
        $scope.signUpForm.email.$setValidity('in-use', true);
        UserService.checkDuplicatedEmail(vm.user.email, function (response) {
          var data = response.data;
          $scope.signUpForm.email.$setValidity('in-use', !data.email_exists);
        }, function (err) {
          $log.error('Error checking duplicated email');
        });
      }
    }

    function updateAttempt() {
      vm.attemptEmail = false;
    }

    function showSsoMsg() {
      if (angular.isDefined($stateParams.ssoEmail) && $stateParams.ssoEmail != "false") return true;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.landing.signIn', [])
    .controller('SignInController', SignInController);

  /* @ngInject */
  function SignInController($mdDialog, $state, $log, lodash, toastr, KEY_CODES, TOSTATE, AuthenticationService, RoutesService, StorageService, $location, GoogleSingleSignOnService, UserService) {
    var vm = this;

    // Accessible attributes
    vm.credentials = {};
    vm.source = '';
    vm.sourceAccountType = '';

    // Accessible Functions
    vm.submit = submit;
    vm.submitEnter = submitEnter;
    vm.showAdvConversion = showAdvConversion;
    vm.showPubConversion = showPubConversion;

    init();

    // Functions
    function init() {
      if($location.search().source) {
        vm.source = $location.search().source;
      }

      if($location.search().act_type) {
        vm.sourceAccountType = $location.search().act_type;
      }

      initGoogleSingleSignOn();
    }
    
    function showSsoError() {
      var text = '<div style="text-align: center;">You previously authorized Scalefluence for either Google Analytics or YouTube.<br>';
      text += 'This is causing a conflict for sign in now.<br>';
      text += '<strong>EITHER:<br>';
      text += 'Sign in with email normally (recommended).<br>';
      text += 'OR:<br>';
      text += 'Remove Scalefluence access to your Google Analytics / YouTube here:</strong><br>';
      text += '<a href="https://myaccount.google.com/permissions" target="_blank">https://myaccount.google.com/permissions</a><br>';
      text += 'Then, use Google Sign In for Scalefluence.<br>';
      text += 'Edit your profile and reconnect Google Analytics / YouTube.</div>';
      return $mdDialog.show(
        $mdDialog.alert()
        .title('Google Sign In Issue!')
        .htmlContent(text)
        .escapeToClose(false)
        .ok('Okay')
      );
    }

    function initGoogleSingleSignOn() {
      GoogleSingleSignOnService.googleInit(function(response) {
        const responsePayload = UserService.decodeJwtResponse(response.credential);
        // Payload will not contain meaningful data such as email address if the same
        // google account first authorized analytics and as such has restricted connection
        // permissions.... prob need preliminary do sso when confirming analytics to avoid this
        if (!responsePayload.email) {
          showSsoError();
        } else {
          const userDetails = {
            email: responsePayload.email,
            first_name: responsePayload.given_name,
            last_name: responsePayload.family_name
          };
          checkDuplicatedEmail(userDetails);
        }
      });

      GoogleSingleSignOnService.renderGoogleButton();
    }

    function checkDuplicatedEmail(userDetails) {
      UserService.checkDuplicatedEmail(userDetails.email, function (response) {
        const data = response.data;
        if(data.email_exists) googleAuth(userDetails);
        else RoutesService.signUpWithSsoMsg(userDetails.email);
      }, function (err) {
        $log.error('Error checking duplicated email');
      });
    }

    function googleAuth(userDetails) {
      UserService.googleAuth(userDetails, false, false);
    }

    function showAdvConversion() {
      return vm.source === 'poptin' && vm.sourceAccountType === 'adv'
    }

    function showPubConversion() {
      return vm.source === 'poptin' && vm.sourceAccountType === 'pub'
    }

    function submitEnter(event) {
      if (event.keyCode === KEY_CODES.ENTER) {
        submit();
      }
    }

    function submit() {
      AuthenticationService.login(vm.credentials,
        function () {
          var toState = StorageService.get(TOSTATE);
          if (toState) {
            StorageService.remove(TOSTATE);
            $state.go(toState.name);
          } else {
            RoutesService.dashboard();
          }
        },
        function (response) {
          var message = response.data.error || response.data.errors[0];
          if (lodash.includes(message, 'authentication')) {
            toastr.error('Incorrect email or password');
          } else {
            toastr.error(message);
          }
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.landing.resetPw', [])
    .controller('ResetPwController', ResetPwController);

  /* @ngInject */
  function ResetPwController($scope, $mdDialog, $state, $stateParams, lodash, toastr, KEY_CODES, TOSTATE, AuthenticationService, RoutesService, StorageService, PasswordMeter, MIN_PASS_SIZE) {
    var vm = this;

    // Accessible attributes
    vm.password = '';
    vm.passwordConfirmation = '';
    vm.token = '';
    vm.passEval;
    vm.passTextStrength = '';

    // Accessible Functions
    vm.init = init;
    vm.submit = submit;
    vm.submitEnter = submitEnter;
    vm.samePassword = samePassword;
    vm.canChangePassword = canChangePassword;
    vm.checkStrength = checkStrength;

    init();

    // Functions
    function init() {
      if ($stateParams.token === undefined) RoutesService.signIn();
      vm.token = $stateParams.token;
    }

    function submitEnter(event) {
      if (event.keyCode === KEY_CODES.ENTER) {
        submit();
      }
    }

    function submit() {
      // AuthenticationService.login(vm.credentials,
      //   function () {
      //     var toState = StorageService.get(TOSTATE);
      //     if (toState) {
      //       StorageService.remove(TOSTATE);
      //       $state.go(toState.name);
      //     } else {
      //       RoutesService.dashboard();
      //     }
      //   },
      //   function (response) {
      //     var message = response.data.error || response.data.errors[0];
      //     if (lodash.includes(message, 'authentication')) {
      //       toastr.error('Incorrect email or password');
      //     } else {
      //       toastr.error(message);
      //     }
      //   });
      console.log('in resetPassword')
      var data = {
        user: {
          password: vm.password,
          password_confirmation: vm.passwordConfirmation,
          reset_password_token: vm.token
        }
      }
      AuthenticationService.resetPassword(data,
        function () {
          toastr.success('Thank you! Your password was reset.');
          RoutesService.signIn();
        },
        function (response) {
          toastr.error('Sorry! There was an error updating your password.');
        });
    }

    function samePassword() {
      return angular.equals(vm.password, vm.passwordConfirmation);
    }

    function canChangePassword() {
      $scope.resetPwForm.passwordConfirmation.$setValidity('no-match', samePassword());
    }

    function checkStrength() {
      vm.passEval = vm.password ? (vm.password.length > MIN_PASS_SIZE && PasswordMeter.evaluatePassword(vm.password) || 0) : null;
      if (vm.passEval == 4) return 'Strong';
      return vm.passEval in [0, 1] ? 'Weak' : 'Medium';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.landing.forgotPw', [])
    .controller('ForgotPwController', ForgotPwController);

  /* @ngInject */
  function ForgotPwController($mdDialog, $state, lodash, toastr, KEY_CODES, TOSTATE, AuthenticationService, RoutesService, StorageService) {
    var vm = this;
    // Accessible attributes
    vm.email = '';

    // Accessible Functions
    vm.submit = submit;
    vm.submitEnter = submitEnter;

    // Functions
    function submitEnter(event) {
      if (event.keyCode === KEY_CODES.ENTER) {
        submit();
      }
    }

    function confirmationPopUp() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .textContent('Thank you! Please check your email (INCLUDING SPAM FOLDER) for instructions on how to reset your password.')
        .ok('OK')
      ).then(function () {
        RoutesService.signIn();
      }, function () {
        // Action cancelled
      })
    }

    function submit() {
      AuthenticationService.forgotPassword(vm.email,
        function () {
          confirmationPopUp();
        },
        function (response) {
          var msg = 'No active account was found for this email. If needed, please email admin@scalefluence.com to request a password reset.';
          toastr.error(msg);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.dashboard.pub', [])
    .controller('PubDashboardController', PubDashboardController);

  /* @ngInject */
  function PubDashboardController($log, toastr, AccountService, RoutesService, CounterService, $mdDialog, EnvironmentConfig, $location, ProfilesService, UserTourService, $timeout) {
    var vm = this;

    //Accessible variables
    vm.showModal = false;
    //Accessible functions
    vm.showActiveContent = showActiveContent;
    vm.newOrders = newOrders;
    vm.pricingPausing = pricingPausing;
    vm.resubmittedContent = resubmittedContent;
    vm.showCreateProfileModal = showCreateProfileModal;

    initialize();

    // Functions
    function initialize() {
      AccountService.getPublisher(function (response) {
        vm.publisher = response.data;
        CounterService.getPubCardValues();
        handlePubTour();
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });
    }

    function handlePubTour() {
      if (UserTourService.currentName() == null && vm.publisher.run_pub_tour) {
        AccountService.disableAutoPubTour(function (response) {
          $timeout(function() {
            showDialog('Welcome to Scalefluence!', 'Click TUTORIAL at the top of the page for a quick 2-minute tutorial that will show you the basics of creating a profile, collaborating with brands, and getting paid.', "OK!")
            .then(function () {
              location.reload();
            });
          }, 2000);
        }, function () {
          // toastr.error('There was an error disabling pub tour.')
        });
      }
    }

    function newOrders() {
      RoutesService.pubNewOrders();
    }

    function showActiveContent() {
      RoutesService.pubActiveAds();
    }

    function pricingPausing() {
      RoutesService.pubPricingPausing();
    }

    function resubmittedContent() {
      RoutesService.pubResubmitted();
    }

    function showCreateProfileModal() {
      var pDate = Date.parse(vm.publisher.created_at);
      var v2Date = Date.parse(EnvironmentConfig.V2_PROFILE_SWITCH_DATE);
      // console.log('pdate, vdate', pDate, v2Date);
      if (pDate < v2Date) {

        $mdDialog.show({
          controller: 'CreateProfileV1Controller',
          controllerAs: 'createProfCtrl',
          templateUrl: 'app/pages/profiles/createProfileV1/createProfileV1Dialog.html',
          clickOutsideToClose: false,
          bindToController: true,
          escapeToClose: true,
          focusOnOpen: true
        }).then(function (id, profile, type) {
          RoutesService.editProfileV2(id, profile, vm.publisher);
        });

      } else {
        if (UserTourService.currentName() == 'pub_welcome_phase_3') {
          UserTourService.stopTour();
          $timeout(function() { UserTourService.startPubWelcomeTourPhase4(); }, 300);
        }
        $mdDialog.show({
          controller: 'CreateProfileController',
          controllerAs: 'createProfCtrl',
          templateUrl: 'app/pages/profiles/createProfile/createProfileDialog.html',
          clickOutsideToClose: false,
          bindToController: true,
          escapeToClose: true,
          focusOnOpen: true
        }).then(function (id, profile, type) {
          RoutesService.editProfileV2(id, profile, vm.publisher);
        });

      }
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .textContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.dashboard.adv', [])
    .controller('AdvDashboardController', AdvDashboardController);

  /* @ngInject */
  function AdvDashboardController($state, $log, $rootScope, toastr, lodash, AccountService, CounterService,
    OrdersService, KEY_CODES, CampaignsService, EnvironmentConfig) {
    var vm = this;

    // Accessible attributes
    vm.advertiser = {};
    vm.selectedCategories = [];
    vm.campaigns = [];
    vm.total_campaigns = 0;
    vm.query = {
      limit: 3,
      page: 1,
      filter: ''
    };

    // Accessible functions
    vm.search = search;
    vm.seeReport = seeReport;
    vm.showActiveContent = showActiveContent;
    vm.showAwaitingContent = showAwaitingContent;
    vm.seeCart = seeCart;
    vm.searchEnter = searchEnter;
    vm.getPlaceholder = getPlaceholder;

    initialize();

    // Functions
    function initialize() {
      AccountService.getAdvertiser(function (response) {
        vm.advertiser = response.data;
        CounterService.getAdvCardValues();
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });

      fetchCampaigns();

      OrdersService.indexOrders(function (response) {
        $rootScope.cartItems = response;
      }, function (error) {
        toastr.error('There was an error retrieving orders');
      });
    }

    function fetchCampaigns() {
      CampaignsService.indexCampaigns(vm.query, function (response) {
        vm.campaigns = response.data.campaigns;
        vm.total_campaigns = response.data.results;
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
        } else {
          toastr.error('There was an error retrieving campaigns');
          $log.error(response);
        }
      })
    }

    function search() {
      $rootScope.categories = vm.selectedCategories;
      $state.go('search');
    }

    function seeReport() {
      $state.go('rejected-reports');
    }

    function showActiveContent() {
      $state.go('active-content');
    }

    function showAwaitingContent() {
      $state.go('awaiting-content');
    }

    function seeCart() {
      $state.go('cart');
    }

    function searchEnter(event) {
      if (event.keyCode == KEY_CODES.ENTER) {
        search();
      }
    }

    function getPlaceholder() {
      return (vm.selectedCategories.length > 0) ? ' ' : 'Type & Select or Press Enter';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.cart', [])
    .controller('CartController', CartController);

  /** @ngInject */
  function CartController($scope, $log, $mdDialog, $anchorScroll, $state, lodash, toastr, OrdersService, ArticlesService,
      $rootScope, EnvironmentConfig, RoutesService, AccountService, $timeout, CounterService, PUBLISHER_NOT_ACTIVE_TOOLTIP) {
    var vm = this;

    // Accessible attributes
    vm.articles = [];
    vm.filteredArticles = [];
    vm.selectedArticles = [];
    vm.filteredOrders =[];
    vm.searchCartArticles= {
      order: 'ordered_date',
      limit: 10,
      page: 1,
      filter: ''
    };
    vm.search;
    vm.orders = [];
    vm.selectedOrders = [];
    vm.checkoutClicked = false;
    vm.total_orders = 0;
    vm.grand_total_orders = 0;
    vm.blank_auto_search_available = true;
    vm.total_price_of_results = 0;
    vm.searchResultsMsg = '0 Ad Spots in your Shopping Cart ($0)';

    // Accessible functions
    vm.goTop = goTop;
    vm.toggleAll = toggleAll;
    vm.allSelected = allSelected;
    vm.selectedItems = selectedItems;
    vm.deleteSelected = deleteSelected;
    vm.cannotCheckout = cannotCheckout;
    vm.cannotDeleteOrders = cannotDelete;
    vm.checkout = checkout;
    vm.close = close;
    vm.paginateCart = paginateCart;
    vm.fetchCarts = fetchCarts;
    vm.searchBoxKeyUp = searchBoxKeyUp;
    vm.searchCartArticle = searchCartArticle;

    preInitialize();

    // Functions

    function preInitialize() {
      AccountService.getAdvertiser(function (response) {
        var has_permission = false;
        var adv = response.data;
        // check if teammate
        if (adv.parent_id) {
          for (var i = 0; i < adv.roles.length; i++) {
            if (adv.roles[i].name === 'purchase_content') {
              has_permission = true;
              break;
            }
          }
        } else {
          has_permission = true;
        }
        if (has_permission) {
          initialize();
        } else {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      });
    }

    function initialize() {
      vm.search = false;
      CounterService.getAdvCardValues();
      vm.fetchCarts();
    }

    function fetchCarts() {
      vm.orders = [];
      vm.filteredOrders = [];
      OrdersService.indexOrdersCart(vm.searchCartArticles,
      function (orderList, response) {
        vm.orders = orderList;
        vm.filteredOrders = sortOrdersPublisherNotActiveFirst(vm.orders);
        vm.total_orders = response.data.total_count;
        vm.grand_total_orders = response.data.total_count;
        vm.total_price_of_results  = response.data.total_price;

        if (vm.searchCartArticles.filter == '') {
          vm.searchResultsMsg = vm.grand_total_orders + ' Ad Spots in your Shopping Cart ($' + vm.total_price_of_results + ')';
        } else {
          vm.searchResultsMsg = vm.grand_total_orders + ' Ad Spot campaign search results ($' + vm.total_price_of_results + ')';
        }
      }, function (orderList) {
        toastr.error('There was an error retrieving your orders.');
      })
    }

    // cart search filter code//
    $scope.$watch('crtCtrl.searchCartArticles.filter', function (newValue, oldValue) {
      var bookmark = '';
      if (!oldValue) {
        bookmark = vm.searchCartArticles.page;
      }

      if (newValue !== oldValue) {
        vm.searchCartArticles.page = 1;
      }

      if (!newValue) {
        vm.searchCartArticles.page = bookmark;
      }

      if (newValue == '') {
        vm.searchCartArticles.page = 1;
      }
    });
//
    function delActionsOnSelected() {
      var qtyDelTypes = {};
      qtyDelTypes['return_to_quote'] = 0;
      qtyDelTypes['return_to_content'] = 0;
      qtyDelTypes['removed_permanently'] = 0;
      for (var i = 0; i < vm.selectedOrders.length; i++) {
        var order = vm.selectedOrders[i];
        if (order.created_from === 'quote' && order.done_by === 'agency' && order.quote_known) qtyDelTypes['return_to_quote']++;
        else if (order.created_from === 'article' && order.done_by === 'scalefluence' && order.quote_known) qtyDelTypes['return_to_content']++;
        else qtyDelTypes['removed_permanently']++;
      }
      return qtyDelTypes;
    }

    function deleteSelected(ev) {
      var delActions = delActionsOnSelected();
      var msg = '';
      if (delActions['removed_permanently'] > 0) {
        msg += ' ' + delActions['removed_permanently'] + ' selected ad spot(s) will be removed permanently.';
      }
      if (delActions['return_to_quote'] > 0) {
        msg += ' ' + delActions['return_to_quote'] + ' selected ad spot(s) will be returned to quotes.';
      }
      if (delActions['return_to_content'] > 0) {
        msg += ' ' + delActions['return_to_content'] + ' selected ad spot(s) will be returned to content pipe.';
      }
      // var msg = 'Selected ad spot(s) will be returned to content pipe or quotes.'
      // var qtyNotSafe = qtySelOrdersNotSafeToDelete();
      // if (qtyNotSafe === vm.selectedOrders.length) {
      //   msg = 'Selected ad spot(s) will be removed permanently.';
      // } else if (qtyNotSafe > 0) {
      //   msg = qtyNotSafe + ' selected ad spot(s) will be removed permanently. ';
      //   msg += (vm.selectedOrders.length - qtyNotSafe) + ' selected ad spot(s) will be returned to content pipe or quotes.';
      // }

      var confirm = $mdDialog.confirm()
        .title('Would you like to delete the selected ad spot(s)?')
        .textContent(msg)
        .ariaLabel('Removing ad spots')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        OrdersService.deleteOrders(lodash.map(vm.selectedOrders, 'id'), function () {
          if ($rootScope.counterPendingOrders > 0) $rootScope.counterPendingOrders -= vm.selectedOrders.length;
          $rootScope.counterApprovedArticles += vm.selectedOrders.length;
          toastr.success('Removed orders successfuly.');
          vm.fetchCarts();
          vm.selectedOrders = [];
        }, function (response) {
          if (response.status === 403) {
            toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          } else {
            $log.error('Error deleting orders.');
          }
        })
      });
    }

    function goTop() {
      $anchorScroll('top');
    }

    function readyForCheckout(order) {
      var ad = order.ad;
      if (!ad || !(ad.blog_post_title || ad.link_text || ad.full_pub_url)) {
        return false;
      } else {
        return true;
      }
    }

    function toggleAll() {
      if (allSelected()) vm.selectedOrders = [];
      else {
        deepSelectAll();
        // START enhanced 2-tiered select-all with confirmed deep select all
        // var noneLeftToAddOnThisPage = true;
        // lodash.map(vm.orders, function (order) {
        //   var pos = lodash.indexOf(vm.selectedOrders, order);
        //   if (pos < 0) {
        //     vm.selectedOrders.push(order);
        //     noneLeftToAddOnThisPage = false;
        //   }
        // });
        // if (noneLeftToAddOnThisPage) {
        //   var confirm = $mdDialog.confirm()
        //     .title('Would you like to select all items in your cart?')
        //     .textContent('This might take a few moments if you have more than a few pages of Ad Spots.')
        //     .ariaLabel('Select all items in cart.')
        //     .ok('Yes')
        //     .cancel('No');

        //   $mdDialog.show(confirm).then(function () {
        //     deepSelectAll();
        //   });
        // }
        // END enhanced 2-tiered select-all with confirmed deep select all
      }
    }

    function allSelected() {
      return vm.selectedOrders.length > 0 &&
        vm.selectedOrders.length == vm.total_orders;
    }

    function selectedItems() {
      return (vm.selectedOrders.length > 1) ? vm.selectedOrders.length + ' Items selected' : '1 Item selected';
    }

    function sortOrdersPublisherNotActiveFirst(orders) {
      return lodash.orderBy(orders, [
        function (o) {
          return o.publisher_not_active ? 0 : 1;
        }
      ], ['asc']);
    }

    function deepSelectAll() {
      OrdersService.indexOrdersWithoutLimit(vm.searchCartArticles,
        function (orderList, response) {
          vm.selectedOrders = [];
          orderList.forEach(function (order) {
            if (!order.publisher_not_active) {
              vm.selectedOrders.push(order);
            }
          });
          // noticed strange behavior when selecting all when not
          // on page 1. it's almost like the site would switch to
          // page 1 but the pagination bar at the bottom would not update,
          // so i found we could get around that by forcing a re-load
          // of the current page's data (paginate to the page we're already on).
          paginateCart(vm.searchCartArticles.page);
        }, function () {
          toastr.error('There was an error retrieving your orders.');
        })
    }

    function cannotCheckout() {
      if (vm.selectedOrders.length < 1) {
        return true;
      }
      if (lodash.some(vm.selectedOrders, 'publisher_not_active')) {
        return true;
      }
      var pos = lodash.findIndex(vm.selectedOrders, function (order) {
        return checkBlogContent(order);
      });

      return pos != -1;
    }

    function checkBlogContent(order) {
      if (order.ad) {
        if (order.ad.blog_post_body || order.ad.blog_post_doc) {
          return false;
        }
      }
      return true;
    }

    function cannotDelete() {
      return (vm.selectedOrders.length == 0);
    }

    function allSelectedOrdersReady() {
      for (var i = 0; i < vm.selectedOrders.length; i++) {
        var order = vm.selectedOrders[i];
        if (!readyForCheckout(order)) {
          return false;
        }
      }
      return true;
    }

    function checkout() {
      vm.checkoutClicked = true;
      if (lodash.some(vm.selectedOrders, 'publisher_not_active')) {
        toastr.error(PUBLISHER_NOT_ACTIVE_TOOLTIP);
        return;
      }
      if (allSelectedOrdersReady()) {
        OrdersService.sendToCheckout(lodash.map(vm.selectedOrders, 'id'), function() {
          $state.go('checkout');
        }, function() {
          $log.error('Error sending orders to checkout.');
        });
      } else {
        $mdDialog.show({
          templateUrl: 'app/pages/cart/modals/notCheckoutReady.html',
          controller: CartController,
          controllerAs: 'crtCtrl',
          autoWrap: false,
          clickOutsideToClose: false,
          escapeToClose: true,
          focusOnOpen: true
        }).then(function () {
          vm.selectedOrders = [];
        });
      }

    }

    function close() {
      $mdDialog.hide();
    }

    function paginateCart(newPageNumber, oldPageNumber) {
      vm.searchCartArticles.page = newPageNumber;
      fetchCarts();
      goTop();
    }

    function makeBlankAutoSearchAvailable() {
      vm.blank_auto_search_available = true;
    }

    function searchBoxKeyUp(event) {
      // if search box is now empty then re-query articles if blank auto search is available
      if (vm.searchCartArticles.filter.length == 0 && vm.blank_auto_search_available) {
        searchCartArticle();
        // make blank auto search unavailable for 5 seconds to avoid rapid pointless api requests
        vm.blank_auto_search_available = false;
        $timeout(makeBlankAutoSearchAvailable, 5000);
      } else if (event.keyCode === 13) searchCartArticle(); // if enter key then search without constraint
    }

    function searchCartArticle() {
      if (vm.searchCartArticles.filter.length > 0 && vm.searchCartArticles.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchCarts();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.cart')
    .controller('CheckoutController', CheckoutController);

  /* @ngInject */
  function CheckoutController() {}
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .controller('BlogPostController', BlogPostController);

  /** @ngInject */
  function BlogPostController($log, $mdDialog, $scope, $mdMedia, toastr, lodash, order, CampaignsService, OrdersService) {
    var vm = this;

    // Accessible variables
    vm.blogPost = {};
    vm.infographic = 'no';
    vm.campaigns = [];
    vm.newURL;
    vm.link;
    vm.$mdMedia = $mdMedia;
    vm.order = {};
    vm.initialized = false;
    vm.searchTextCampaign = '';

    // Accessible functions
    vm.save = save;
    vm.closeDialog = closeDialog;
    vm.hasContent = hasContent;
    vm.existingBlogDocFilename = existingBlogDocFilename;
    vm.downloadContent = downloadContent;
    vm.canDownload = canDownload;
    vm.setEmptyDropdownUrl = setEmptyDropdownUrl;
    vm.setEmptyNewUrl = setEmptyNewUrl;
    vm.noUrl = noUrl;
    vm.isValidURL = isValidURL;
    vm.querySearchCampaign = querySearchCampaign;
    vm.checkIfOrdered = checkIfOrdered;

    initialize();

    // Functions
    function initialize() {
      CampaignsService.shallowIndexScopedCampaigns('all', function (response) {
        vm.campaigns = response.data.campaigns;
        vm.order = order;
        if (order.ad) {
          setupForm(order.ad, order.link);
        } else if(order.searched_campaign_id) {
          setupFormFromSearchedCampaign(order);
        } else {
          vm.blogPost = {};
          vm.initialized = true;
        }
      }, function () {
        $log.error('There was an error retrieving campaigns.');
        toastr.error('Error retrieving campaigns.');
      });
    }

    function setupFormFromSearchedCampaign(order) {
      var campaign = lodash.find(vm.campaigns, function (campaign) {
        return campaign.id == order.searched_campaign_id;
      });
      vm.blogPost.campaign = campaign;
      vm.initialized = true;
    }

    function setupForm(ad, url) {
      vm.blogPost = ad;
      var campaign = lodash.find(vm.campaigns, function (campaign) {
        return campaign.id == ad.campaign_id;
      });
      vm.blogPost.campaign = campaign;

      if(url) {
        vm.newURL = url.href;
        var link = lodash.find(campaign.links, function (link) {
          return link.id == ad.link_id;
        });
        vm.blogPost.link = link;
      }

      if (checkBlogPostBody()) {
        vm.infographic = 'yes';
      }
      vm.initialized = true;
    }

    function save() {
      if (isValidURL(vm.newURL)) {
        vm.blogPost.link = vm.newURL;
        vm.blogPost.campaign.url = vm.newURL;
        CampaignsService.updateCampaign(vm.blogPost.campaign.id, vm.blogPost.campaign,
          function (response) {
            var addedLink = response.data.link;
            createBlogPost(addedLink);
          },
          function (response) {
            var message = response.data.errors['links.href'][0];
            $log.error('Error submiting new site.');
            toastr.error('The site ' + message + '. Please retry.');
          });
      }
    }

    function checkBlogPostBody() {
      if (!vm.blogPost.blog_post_body || vm.blogPost.blog_post_body === 'null') {
        vm.blog_post_body = null;
        return false;
      }

      return true;
    }

    function createBlogPost(link) {
      if (angular.isDefined(link)) {
        vm.blogPost.link = link;
      }

      if (!vm.blogPost.blog_post_body || vm.blogPost.blog_post_body === 'null') {
        vm.blogPost.blog_post_body = null;
      }

      vm.blogPost.url = order.url;
      OrdersService.updateOrder(order.id, vm.blogPost, function (response) {
        vm.blogPost = response.data.ad;
        toastr.success('Order successfuly submitted.');
        order.link = link;
        $mdDialog.hide(vm.blogPost);
      }, function () {
        $log.error('There was an error submiting order.');
        toastr.error('Error submiting order.');
      });
    }

    function closeDialog() {
      $mdDialog.cancel();
    }

    function hasContent() {
      if ((vm.blogPost.blog_post_doc && vm.blogPost.blog_post_doc.url) || vm.blogPost.word || vm.blogPost.blog_post_body) {
        return true;
      }
      return false;
    }

    function existingBlogDocFilename() {
      if (vm.blogPost.blog_post_doc && vm.blogPost.blog_post_doc.url) {
        var ary = vm.blogPost.blog_post_doc.url.split('/');
        return ary[ary.length - 1];
      } else {
        return '';
      }
    }

    function downloadContent(blog) {
      return blog.blog_post_doc.url;
    }

    function canDownload(blog) {
      return angular.isDefined(blog.word.url);
    }

    function setEmptyDropdownUrl() {
      if (isValidURL(vm.newURL)) {
        vm.blogPost.link = null;
      }
    }

    function setEmptyNewUrl() {
      if (isValidURL(vm.blogPost.link)) {
        vm.newURL = null;
      }
    }

    function noUrl() {
      return !isValidURL(vm.blogPost.link) && !isValidURL(vm.newURL);
    }

    function isValidURL(url) {
      return angular.isDefined(url) && url != null && url != '';
    }

    function querySearchCampaign(query) {
      var results = query ? vm.campaigns.filter(createFilterForCampaigns(query)) : vm.campaigns;
      return results;
    }

    function createFilterForCampaigns(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(campaign) {
        return (campaign.name.toLowerCase().indexOf(lowercaseQuery) >= 0);
      };
    }

    function checkIfOrdered() {
      if (vm.blogPost.campaign != undefined) {
        OrdersService.orderAlreadyOrderedForCampaign(vm.order.id, vm.order.url.id, vm.blogPost.campaign.id, function (response) {
          vm.order.already_ordered = response.data.already_ordered;
          vm.order.already_ordered_campaign = response.data.campaign_name;
        }, function () {
          $log.error('Error adding finding order cart.');
          toastr.error('Please try again.');
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.teammate', [])
    .controller('TeammateCampaignsController', TeammateCampaignsController);

  /** @ngInject */
  function TeammateCampaignsController($log, $mdDialog, $anchorScroll, lodash, toastr, CampaignsService, EnvironmentConfig, $stateParams, AccountService, RoutesService) {
    var vm = this;

    // Accessible attributes
    vm.perPage = 10;
    vm.campaigns = [];
    vm.total_campaigns = 0;
    vm.query = {
      limit: 10,
      page: 1,
      filter: '',
      teammate_id: 0
    };
    vm.advertiser;
    vm.teammate = {
      id: '',
      first_name: '',
      last_name: '',
      email: ''
    }
    vm.teammates = [];

    // Accessible functions
    vm.deleteCampaign = deleteCampaign;
    vm.goTop = goTop;
    vm.paginateCampaigns = paginateCampaigns;
    vm.searchCampaigns = searchCampaigns;
    vm.fetchCampaigns = fetchCampaigns;

    initialize();

    // Functions
    function initialize() {
      vm.query.teammate_id = $stateParams.teammateId;
      loadTeammate();
    }

    function loadTeammate() {
      AccountService.getAdvTeammate($stateParams.teammateId, function(response) {
        var adv_data = response.data;
        vm.teammate.id = adv_data.id;
        vm.teammate.first_name = adv_data.first_name;
        vm.teammate.last_name = adv_data.last_name;
        vm.teammate.email = adv_data.email;
        loadTeammates();
      }, function(response) {
        toastr.error('There was a problem loading your teammate.');
      });
    }

    function loadTeammates() {
      AccountService.getAdvTeammates(function(response) {
        vm.advertiser = response.data.advertiser;
        vm.teammates = [];
        for (var i = 0; i < response.data.advertisers.length; i++) {
          var t = response.data.advertisers[i];
          for (var j = 0; j < t.roles.length; j++) {
            if (t.roles[j].name === 'manage_campaigns') {
              vm.teammates.push(t);
              break;
            }
          }
        }
        vm.teammates.push({
          id: 0,
          email: vm.advertiser.email
        });
        fetchCampaigns();
      }, function() {
        console.log('failed to load teammates');
      });
    }

    function deleteCampaign(campaignId) {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete this campaign?')
        .textContent('This campaign will be removed permanently.')
        .ariaLabel('Removing campaign')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        CampaignsService.deleteCampaign(campaignId, function () {
          lodash.remove(vm.campaigns, function (campaign) {
            return campaign.id == campaignId;
          });
          toastr.success('Campaign was removed successfuly.');
        }, function () {
          $log.error('Error deleting campaign.');
          toastr.error('There was an error deleting campaign.');
        });
      });
    }

    function goTop() {
      $anchorScroll('top');
    }

    function paginateCampaigns(newPageNumber, oldPageNumber) {
      vm.query.page = newPageNumber;
      fetchCampaigns();
      goTop();
    }

    function fetchCampaigns() {
      CampaignsService.indexCampaigns(vm.query, function (response) {
        if (!response.data.campaigns.length) {
          RoutesService.advTeammates();
        }
        vm.campaigns = response.data.campaigns;
        vm.total_campaigns = response.data.results;
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
        } else {
          toastr.error('There was an error retrieving campaigns');
          $log.error(response);
        }
      })
    }

    function searchCampaigns(event) {
      if (event.keyCode !== 13) return;
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchCampaigns();
        goTop();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.campaign.new', [])
    .controller('NewCampaignController', NewCampaignController);

  /** @ngInject */
  function NewCampaignController($log, $mdDialog, toastr, CampaignsService, RoutesService, AccountService, EnvironmentConfig) {
    var vm = this;

    // Accessible attributes
    vm.campaign = {
      categories: []
    };
    vm.showCategories = false;
    vm.teammates = [];
    vm.manager = {
      id: 0,
      email: 'none'
    };
    vm.searchTextManager = '';
    vm.advertiser;

    // Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.showDialog = showDialog;
    vm.avatarUploaded = avatarUploaded;
    vm.checkURL = checkURL;
    vm.toggleCategories = toggleCategories;
    vm.toggleCategoriesActionMsg = toggleCategoriesActionMsg;
    vm.querySearchManager = querySearchManager;

    initialize();

    // Functions

    function initialize() {
      confirmAuthorized();
      loadTeammates();

      CampaignsService.getCampaignNames(function (response) {
        vm.campaignNames = response.data.campaign_names;
      });
    }

    // make sure vm.campaign is loaded first so existing manager of
    // campaign can be set
    function loadTeammates() {
      AccountService.getAdvTeammates(function(response) {
        vm.advertiser = response.data.advertiser;
        vm.manager = {
          id: 0,
          email: vm.advertiser.email
        };
        vm.teammates = [];
        for (var i = 0; i < response.data.advertisers.length; i++) {
          var t = response.data.advertisers[i];
          for (var j = 0; j < t.roles.length; j++) {
            if (t.roles[j].name === 'manage_campaigns') {
              vm.teammates.push(t);
              break;
            }
          }
        }
        vm.teammates.push({
          id: 0,
          email: vm.advertiser.email
        });
      }, function() {
        console.log('failed to load teammates');
      });
    }

    function confirmAuthorized() {
      AccountService.getAdvertiser(function (response) {
        var has_permission = false;
        var adv = response.data;
        // check if teammate
        if (adv.parent_id) {
          for (var i = 0; i < adv.roles.length; i++) {
            if (adv.roles[i].name === 'manage_all_campaigns' || adv.roles[i].name === 'create_campaigns') {
              has_permission = true;
              break;
            }
          }
        } else {
          has_permission = true;
        }
        if (has_permission) {
          // do nothing
        } else {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      });
    }

    function checkURL(form) {
      var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      var valid = regex.test(vm.campaign.url);
      form.campaignUrl.$setValidity('url', valid);
    }

    function showDialog() {
      $mdDialog.show({
        controller: 'ModalCampaignController',
        controllerAs: 'modCampCtrl',
        templateUrl: 'app/pages/campaigns/modalCampaign/modalCampaign.html',
        clickOutsideToClose: true
      }).then(function (uploadedFile) {
        vm.campaign.csv = uploadedFile;
      });
    }

    function submit() {
      if (vm.campaign.csv) {
        delete vm.campaign.url;
      }
      vm.campaign.manager_id = vm.manager.id;
      CampaignsService.createCampaign(vm.campaign,
        function () {
          vm.campaign = {};
          if(vm.campaignNames.length > 0) {
            toastr.success('Campaign successfully created!');
            RoutesService.dashboard();
          } else {
            showAlertHTML('Submitted For Review',
              '<span style="font-weight: bold; color: red">This is your first campaign submission.<br><br>' +
              'It will be manually reviewed; and if approved, all future campaigns are auto-approved.<br><br>' +
              'We do this to prevent spam.<br><br>' +
              'Please note we do not allow adult, offshore pharmaceuticals, pyramid schemes, gambling, or any businesses that infringe upon the laws of the United States.</span>',
              'Ok I understand').then(function () {
                RoutesService.dashboard();
            });
          }
        },
        function () {
          $log.error('Error submiting new campaign.');
          toastr.error('There was an error while submiting the new campaign. Please retry.');
        });
    }

    function clearCsv() {
      vm.campaign.csv = null;
    }

    function avatarUploaded() {
      return angular.isDefined(vm.campaign.image) && vm.campaign.image != null;
    }

    function toggleCategories() {
      vm.showCategories = !vm.showCategories;
    }

    function toggleCategoriesActionMsg() {
      return vm.showCategories ? 'Hide Categories' : 'Show Categories';
    }

    function querySearchManager(query) {
      var results = query ? vm.teammates.filter(createFilterForManagers(query)) : vm.teammates;
      return results;
    }

    function showAlertHTML(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.site.new', [])
    .controller('NewSitePageController', NewSitePageController);

  /** @ngInject */
  function NewSitePageController($scope, $log, $state, $stateParams, $mdDialog, lodash, toastr, CampaignsService) {
    var vm = this;

    // Accessible attributes
    vm.csv;
    vm.campaigns = [];
    vm.categories = [];
    vm.campaignUrl;
    vm.selectedCampaign;

    // Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.getSelectedCampaign = getSelectedCampaign;
    vm.isSelectedCategoriesEmpty = isSelectedCategoriesEmpty;
    vm.showDialog = showDialog;

    initialize();

    // Functions
    function initialize() {
      CampaignsService.indexCampaigns(function (response) {
        vm.campaigns = response.data.campaigns;
        if (angular.isDefined($stateParams.campaignId) && $stateParams.campaignId != '') {
          vm.selectedCampaign = lodash.find(vm.campaigns, function (cam) {
            return cam.id == $stateParams.campaignId;
          });
        }
      }, function () {
        $log.error('Error retrieving your campaigns.');
        toastr.error('There was an error retrieving your campaigns.');
      });
    }

    function getSelectedCampaign() {
      if (angular.isDefined(vm.selectedCampaign)) {
        vm.categories = vm.selectedCampaign.categories;
        return vm.selectedCampaign.name;
      } else {
        return 'Please select a campaign';
      }
    }

    function submit() {
      vm.selectedCampaign.url = vm.campaignUrl;
      vm.selectedCampaign.categories = vm.categories;
      if (vm.csv) {
        vm.selectedCampaign.csv = vm.csv;
        delete vm.selectedCampaign.url;
      } else if(angular.isDefined(vm.campaignUrl)) {
          clearCsv();
          delete vm.selectedCampaign.csv;
      }
      CampaignsService.updateCampaign(vm.selectedCampaign.id, vm.selectedCampaign,
        function () {
          $state.go('manage-campaign', { campaignId: vm.selectedCampaign.id });
          toastr.success('Site successfuly added.');
        },
        function () {
          $log.error('Error submiting new site.');
          toastr.error('There was a problem while submiting the new site. Please retry.');
        });
    }

    function clearCsv() {
      vm.csv = null;
    }

    function isSelectedCategoriesEmpty() {
      return vm.categories.length == 0;
    }

    function showDialog() {
      $mdDialog.show({
        controller: 'ModalCampaignController',
        controllerAs: 'modCampCtrl',
        templateUrl: 'app/pages/campaigns/modalCampaign/modalCampaign.html',
        clickOutsideToClose: true
      }).then(function (uploadedFile) {
        vm.csv = uploadedFile;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.campaign.new')
    .controller('ModalCampaignController', ModalCampaignController);

  /** @ngInject */
  function ModalCampaignController($state, $log, $mdDialog) {
    var vm = this;

    //Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;

    function submit() {
      $mdDialog.hide(vm.campaign.csv);
    }

    function clearCsv() {
      vm.campaign.csv = null;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns.all', [])
    .controller('AllCampaignsController', AllCampaignsController);

  /** @ngInject */
  function AllCampaignsController($log, $mdDialog, $anchorScroll, lodash, toastr, CampaignsService, EnvironmentConfig) {
    var vm = this;

    // Accessible attributes
    vm.perPage = 10;
    vm.campaigns = [];
    vm.total_campaigns = 0;
    vm.query = {
      limit: 10,
      page: 1,
      filter: ''
    };

    // Accessible functions
    vm.deleteCampaign = deleteCampaign;
    vm.goTop = goTop;
    vm.paginateCampaigns = paginateCampaigns;
    vm.searchCampaigns = searchCampaigns;
    vm.fetchCampaigns = fetchCampaigns;

    initialize();

    // Functions
    function initialize() {
      fetchCampaigns();
    }

    function deleteCampaign(campaignId) {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete this campaign?')
        .textContent('This campaign will be removed permanently.')
        .ariaLabel('Removing campaign')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        CampaignsService.deleteCampaign(campaignId, function () {
          lodash.remove(vm.campaigns, function (campaign) {
            return campaign.id == campaignId;
          });
          toastr.success('Campaign was removed successfuly.');
        }, function () {
          $log.error('Error deleting campaign.');
          toastr.error('There was an error deleting campaign.');
        });
      });
    }

    function goTop() {
      $anchorScroll('top');
    }

    function paginateCampaigns(newPageNumber, oldPageNumber) {
      vm.query.page = newPageNumber;
      fetchCampaigns();
      goTop();
    }

    function fetchCampaigns() {
      CampaignsService.indexCampaigns(vm.query, function (response) {
        vm.campaigns = response.data.campaigns;
        vm.total_campaigns = response.data.results;
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
        } else {
          toastr.error('There was an error retrieving campaigns');
          $log.error(response);
        }
      })
    }

    function searchCampaigns(event) {
      if (event.keyCode !== 13) return;
      if (vm.query.filter.length > 0 && vm.query.filter.length < 3) {
        toastr.error('PLEASE USE 3 OR MORE CHARACTERS TO SEARCH');
      } else {
        fetchCampaigns();
        goTop();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.articles.pipeline', [])
    .controller('ArticlesPipelineController', ArticlesPipelineController);

  /* @ngInject */
  function ArticlesPipelineController() {
    // TODO: Will be implemented soon..
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.advTeammates.edit', [])
    .controller('EditAdvTeammateController', EditAdvTeammateController);

  /* @ngInject */
  function EditAdvTeammateController(SessionService, AccountService, toastr, $stateParams, RoutesService, $mdDialog) {
    var vm = this;

    //attributes
    vm.role = '';
    vm.adv = {
      'id': '',
      'first_name': '',
      'last_name': '',
      'email': '',
      'password': '',
      'password_confirmation': '',
      'manage_campaigns': false,
      'create_quotes': false,
      'purchase_content': false,
      'create_campaigns': false,
      'approve_content': false,
      'edit_billing': false
    }
    vm.teammates = []

    //functions
    vm.toggleAdvValue = toggleAdvValue;
    vm.hasRole = hasRole;
    vm.submitEditTeammate = submitEditTeammate;
    vm.goTeammates = goTeammates;
    vm.helpMsg = helpMsg;
    vm.canChangePassword = canChangePassword;

    initialize();

    function initialize() {
      vm.role = SessionService.currentRole();
      loadTeammate();
    }

    function loadTeammate() {
      AccountService.getAdvTeammate($stateParams.teammateId, function(response) {
        var adv_data = response.data;
        vm.adv.id = adv_data.id;
        vm.adv.first_name = adv_data.first_name;
        vm.adv.last_name = adv_data.last_name;
        vm.adv.email = adv_data.email;
        for (var i = 0; i < adv_data.roles.length; i++) {
          if (adv_data.roles[i].name === 'manage_campaigns') vm.adv.manage_campaigns = true;
          else if (adv_data.roles[i].name === 'create_quotes') vm.adv.create_quotes = true;
          else if (adv_data.roles[i].name === 'purchase_content') vm.adv.purchase_content = true;
          else if (adv_data.roles[i].name === 'create_campaigns') vm.adv.create_campaigns = true;
          else if (adv_data.roles[i].name === 'approve_content') vm.adv.approve_content = true;
          else if (adv_data.roles[i].name === 'edit_billing') vm.adv.edit_billing = true;
        }
      }, function(response) {
        toastr.error('There was a problem loading your teammate.');
      });
    }

    function hasRole(adv, role_name) {
      var has = 'No';
      for (var i = 0; i < adv.roles.length; i++) {
        if (adv.roles[i].name === role_name) {
          has = 'Yes';
          break;
        }
      }
      return has;
    }

    function toggleAdvValue(role_name) {
      vm.adv[role_name] = !vm.adv[role_name];
      submitPermisssionChanges();
    }

    function submitEditTeammate() {
      AccountService.updateAdvTeammate(vm.adv.id, vm.adv, function(response) {
        toastr.success('Teammate updated successfully!');
        RoutesService.advTeammates();
      }, function(response) {
        toastr.error('There was an error creating teammate. Please make sure all fields are filled and try again.');
      })
    }

    function submitPermisssionChanges() {
      AccountService.updateAdvTeammate(vm.adv.id, {
        'manage_campaigns': vm.adv['manage_campaigns'],
        'create_quotes': vm.adv['create_quotes'],
        'purchase_content': vm.adv['purchase_content'],
        'create_campaigns': vm.adv['create_campaigns'],
        'approve_content': vm.adv['approve_content'],
        'edit_billing': vm.adv['edit_billing']
      }, function(response) {
        toastr.success('Teammate updated successfully!');
      }, function(response) {
        toastr.error('There was an error creating teammate. Please make sure all fields are filled and try again.');
      })
    }

    function goTeammates() {
      RoutesService.advTeammates();
    }

    function helpMsg(subject) {
      var title = '';
      var msg = '';
      if (subject === 'manage_campaigns') {
        title = 'Manage All Campaigns';
        msg = 'Member can manage any campaign they are assigned to. Includes: changing categories, viewing &amp; downloading reports, and campaign deletion.';
      } else if (subject === 'create_quotes') {
        title = 'Create Quotes';
        msg = 'Member can request new lists of blogs or influencers (known as a quote) to order from at anytime. Member can do this for any campaign they are assigned to.';
      } else if (subject === 'purchase_content') {
        title = 'Purchase Content';
        msg = 'IMPORTANT!!! Member can purchase approved content for ANY campaign in cart!';
      } else if (subject === 'create_campaigns') {
        title = 'Create Campaigns';
        msg = 'Member can create a brand new campaign &amp; add themselves as the manager of the campaign.';
      } else if (subject === 'approve_content') {
        title = 'Approve Content';
        msg = 'Member can review pre-written content, request edits, download for client approval and move approved content to the cart for purchase.';
      } else if (subject === 'edit_billing') {
        title = 'Edit Billing';
        msg = 'IMPORTANT!!! Member has access to add or remove Credit / Debit cards saved under "My Account"!';
      }
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(msg)
        .escapeToClose(false)
        .ok('Ok')
      );
    }

    function samePassword() {
      return angular.equals(vm.adv.password, vm.adv.password_confirmation);
    }

    function canChangePassword(form) {
      form.confirmPassword.$setValidity("no-match", samePassword());
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.advTeammates.new', [])
    .controller('NewAdvTeammateController', NewAdvTeammateController);

  /* @ngInject */
  function NewAdvTeammateController(SessionService, AccountService, toastr, $mdDialog, CampaignsService, RoutesService) {
    var vm = this;

    //attributes
    vm.role = '';
    vm.adv = {
      'first_name': '',
      'last_name': '',
      'email': '',
      'password': '',
      'password_confirmation': '',
      'manage_campaigns': false,
      'create_quotes': false,
      'purchase_content': false,
      'create_campaigns': false,
      'approve_content': false,
      'edit_billing': false
    }
    vm.teammates = []

    //functions
    vm.toggleAdvValue = toggleAdvValue;
    vm.submitAddTeammate = submitAddTeammate;
    vm.hasRole = hasRole;
    vm.helpMsg = helpMsg;
    vm.destroyTeammate = destroyTeammate;
    vm.canChangePassword = canChangePassword;

    initialize();

    function initialize() {
      vm.role = SessionService.currentRole();
      loadTeammates();
    }

    function loadTeammates() {
      AccountService.getAdvTeammates(function(response) {
        vm.teammates = response.data.advertisers;
      }, function(response) {
        toastr.error('There was a problem loading your teammates.');
      });
    }

    function hasRole(adv, role_name) {
      var has = 'No';
      for (var i = 0; i < adv.roles.length; i++) {
        if (adv.roles[i].name === role_name) {
          has = 'Yes';
          break;
        }
      }
      return has;
    }

    function toggleAdvValue(role_name) {
      vm.adv[role_name] = !vm.adv[role_name];
    }

    function submitAddTeammate() {
      AccountService.createAdvTeammate({advertiser: vm.adv}, function(response) {
        toastr.success('Teammate added successfully!');
        loadTeammates();
      }, function(response) {
        if (response.data.errors && response.data.errors.email) {
          if (response.data.errors.email[0] === 'has already been taken') {
            toastr.error('This email already exists in our system. Please email admin@scalefluence.com for assistance.');
          } else {
            toastr.error('There was an error creating teammate. Email: ' + response.data.errors.email[0]);
          }
        } else {
          toastr.error('There was an error creating teammate. Please make sure all fields are filled and try again.');
        }
      })
    }

    function helpMsg(subject) {
      var title = '';
      var msg = '';
      if (subject === 'manage_campaigns') {
        title = 'Manage All Campaigns';
        msg = 'Member can manage any campaign they are assigned to. Includes: changing categories, viewing &amp; downloading reports, and campaign deletion.';
      } else if (subject === 'create_quotes') {
        title = 'Create Quotes';
        msg = 'Member can request new lists of blogs or influencers (known as a quote) to order from at anytime. Member can do this for any campaign they are assigned to.';
      } else if (subject === 'purchase_content') {
        title = 'Purchase Content';
        msg = 'IMPORTANT!!! Member can purchase approved content for ANY campaign in cart!';
      } else if (subject === 'create_campaigns') {
        title = 'Create Campaigns';
        msg = 'Member can create a brand new campaign &amp; add themselves as the manager of the campaign.';
      } else if (subject === 'approve_content') {
        title = 'Approve Content';
        msg = 'Member can review pre-written content, request edits, download for client approval and move approved content to the cart for purchase.';
      } else if (subject === 'edit_billing') {
        title = 'Edit Billing';
        msg = 'IMPORTANT!!! Member has access to add or remove Credit / Debit cards saved under "My Account"!';
      }
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .htmlContent(msg)
        .escapeToClose(false)
        .ok('Ok')
      );
    }

    function destroyTeammate(adv) {
      CampaignsService.indexCampaigns({
        limit: 10,
        page: 1,
        filter: '',
        teammate_id: adv.id
      }, function (response) {
        if (!response.data.campaigns.length) {
          actuallyDestroyTeammate(adv.id);
        } else {
          reassignManagers(adv, response.data.campaigns.length);
        }
      }, function (response) {
        if (response.status === 403) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
        } else {
          toastr.error('There was an error retrieving campaigns');
          $log.error(response);
        }
      })
    }

    function actuallyDestroyTeammate(adv_id) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Deleting this teammate is permanent and you would have to manually re-add later in order to restore.')
        .ariaLabel('Removing teammate')
        .ok('Yes Delete Teammate ')
        .cancel('No Keep Teammate');

      $mdDialog.show(confirm).then(function () {
        AccountService.destroyAdvTeammate(adv_id, function() {
          toastr.success('Teammate was removed successfully.');
          loadTeammates();
        }, function() {
          toastr.error('There was an error deleting teammate.');
        });
      });
    }

    function reassignManagers(adv, qty_campaigns) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent(adv.first_name + ' is managing ' + qty_campaigns + ' campaign(s). Please reassign to new teammate before deleting.')
        .ariaLabel('Removing manager')
        .ok('Yes, Continue')
        .cancel('No, Keep Teammate');

      $mdDialog.show(confirm).then(function () {
        RoutesService.managerCampaigns(adv.id);
      });
    }

    function samePassword() {
      return angular.equals(vm.adv.password, vm.adv.password_confirmation);
    }

    function canChangePassword(form) {
      form.confirmPassword.$setValidity("no-match", samePassword());
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('subItem', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/sidenav/subItem/subItem.html',
      controller: SubItemController,
      controllerAs: 'vm',
      bindings: {
        text: '@',
        state: '@'
      }
    };

    return component;
  }

  /* @ngInject */
  function SubItemController($mdSidenav) {
    var vm = this;

    // Accessible functions
    vm.closeMenu = closeMenu;

    // Functions
    function closeMenu() {
      $mdSidenav('left').close();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('menuItem', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/sidenav/menuItem/menuItem.html',
      controller: MenuItemController,
      controllerAs: 'vm',
      bindings: {
        text: '@',
        icon: '@?',
        value: '@',
        valueRight: '@?',
        state: '@',
        nested: '=?'
      }
    };

    return component;
  }

  /* @ngInject */
  function MenuItemController($mdSidenav) {
    var vm = this;

    // Accessible functions
    vm.clickMenu = clickMenu;

    // Functions
    function clickMenu() {
      $mdSidenav('left').close();
      if (angular.isDefined(vm.nested)) {
        vm.nested = !vm.nested;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('containerMenuItem', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/sidenav/containerMenuItem/containerMenuItem.html',
      controller: ContainerMenuItemController,
      controllerAs: 'vm',
      transclude: true,
      bindings: {
        showingNested: '=',
        text: '@',
        icon: '@',
        nestedStates: '<'
      }
    };

    return component;
  }

  /* @ngInject */
  function ContainerMenuItemController($state, $mdSidenav, lodash) {
    var vm = this;

    // Accessible functions
    vm.clickMenu = clickMenu;
    vm.isActive = isActive;

    // Functions
    function clickMenu() {
      vm.showingNested = !vm.showingNested;
    }

    function isActive() {
      return angular.isDefined(lodash.find(vm.nestedStates, function (state) {
        return state == $state.current.name;
      }));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('profileMini', profileMini());

  /* @ngInject */
  function profileMini() {
    var component = {
      templateUrl: 'app/components/cards/profileMini/profileMini.html',
      controller: ProfileMiniController,
      controllerAs: 'vm',
      bindings: {
        profile: '=',
        publisher: '='
      }
    };

    return component;
  }

  /* @ngInject */
  function ProfileMiniController($mdMedia, lodash, RoutesService) {
    var vm = this;

    // Accessible functions
    vm.$mdMedia = $mdMedia;
    vm.categoriesNames = categoriesNames;
    vm.hasImage = hasImage;
    vm.getImage = getImage;
    vm.editProfile = editProfile;

    init();

    // Functions
    function init() {
      vm.profileType = [{ name: vm.profile.profile_type }];
    }

    function categoriesNames() {
      return lodash.map(vm.profile.categories, 'name');
    }

    function hasImage() {
      return !!vm.profile.image;
    }

    function getImage() {
      return vm.profile.image || 'assets/images/no-image.png';
    }

    function editProfile() {
        RoutesService.editProfileV2(vm.profile.id, vm.profile, vm.publisher);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('filterBox', filterBox());

  /* @ngInject */
  function filterBox() {
    var component = {
      templateUrl: 'app/components/cards/filterBox/filterBox.html',
      controller: FilterBoxController,
      controllerAs: 'vm',
      bindings: {
        title: '@',
        minText: '@',
        maxText: '@',
        config: '=',
        suffix: '@',
        prefix: '@'
      }
    };

    return component;
  }

  /* @ngInject */
  function FilterBoxController() {}
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('creditCardHolder', creditCardHolder());

  /* @ngInject */
  function creditCardHolder() {
    var component = {
      templateUrl: 'app/components/cards/creditCardHolder/creditCardHolder.html',
      controller: CreditCardHolderController,
      controllerAs: 'vm'
    };

    return component;
  }

  /* @ngInject */
  function CreditCardHolderController($state, $mdDialog, toastr, lodash, CreditCardService, RoutesService, EnvironmentConfig) {
    var vm = this;

    // Accessible attributes
    vm.cards;

    // Accessible functions
    vm.addNewCC = addNewCC;
    vm.editCC = editCC;
    vm.removeCC = removeCC;
    vm.editable = editable;

    // Functions
    vm.$onInit = function () {
      CreditCardService.indexCreditCards(function (response) {
        vm.cards = response.data.credit_cards || [];
      }, function (response) {
        if (response.status === 403) {
          toastr.error("Note: You don't have permissions to access credit billing. Please contact the admin team member / owner of the account if needed.");
        } else {
          toastr.error('Can\'t retrieved credit cards.');
        }
      })
    }

    function addNewCC() {
      RoutesService.creditCards();
    }

    function editCC(id) {
      RoutesService.creditCards(id);
    }

    function removeCC(id) {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete this credit card?')
        .textContent('This credit card will be removed permanently.')
        .ariaLabel('Removing credit card')
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        CreditCardService.deleteCreditCard(id, function() {
          lodash.remove(vm.cards, function(card) {
            return card.id == id;
          });
          toastr.success('Successfully deleted the credit card');
        }, function() {
          toastr.error('There was a problem while deleting the credit card. Please retry');
        });
      });
    }

    function editable(card) {
      return false;
      // return card.processor == 'braintree';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('metric', metric());

  /* @ngInject */
  function metric() {
    var component = {
      templateUrl: 'app/components/cards/metric/metric.html',
      controller: MetricController,
      controllerAs: 'vm',
      bindings: {
        title: '@',
        badge: '@',
        active: '@',
        icon: '@'
      },
      transclude: true
    };

    return component;
  }

  /* @ngInject */
  function MetricController() {
    var vm = this;

    vm.iconCss = iconCss;
    vm.xlinkHref = xlinkHref;

    function iconCss() {
      return 'icon icon--' + vm.icon;
    }

    function xlinkHref() {
      return 'assets/images/icons.svg#' + vm.icon;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('cartItem', {
      templateUrl: 'app/components/cards/cartItem/cartItem.html',
      controller: CartItemController,
      controllerAs: 'vm',
      bindings: {
        order: '=',
        list: '=',
        checkoutClicked: '='
      }
    });

  /** @ngInject */
  function CartItemController($log, $mdDialog, toastr, lodash, OrdersService, ORDER_CREATED_ORIGIN,
      PUBLISHER_NOT_ACTIVE_TOOLTIP) {
    var vm = this;
    vm.publisherNotActiveTooltip = PUBLISHER_NOT_ACTIVE_TOOLTIP;

    // Accessible functions
    vm.toggle = toggle;
    vm.exists = exists;
    vm.blogPostDialog = blogPostDialog;
    vm.getBlogPostStatus = getBlogPostStatus;
    vm.readyForCheckout = readyForCheckout;
    vm.isCreatedFromSearch = isCreatedFromSearch;
    vm.getOrderUrl = getOrderUrl;
    vm.close = close;
    vm.formatByName = formatByName;
    vm.publisherNotActiveStyle = publisherNotActiveStyle;

    // Functions
    function publisherNotActiveStyle() {
      return vm.order.publisher_not_active ? { 'background-color': '#ffcdd2' } : null;
    }

    function toggle() {
      if (vm.order.publisher_not_active) {
        return;
      }
      var pos = selPos();
      (pos < 0) ? vm.list.push(vm.order): vm.list.splice(pos, 1);
      // below code was to validate and dissalow ad spots from being selected to move to cart,
      // but the logic was moved to the cart controller upon checkout button being clicked.
      // if (readyForCheckout()) {
      //   var pos = lodash.indexOf(vm.list, vm.order);
      //   (pos < 0) ? vm.list.push(vm.order): vm.list.splice(pos, 1);
      // } else {
      //   $mdDialog.show({
      //     templateUrl: 'app/components/cards/cartItem/modals/notCheckoutReady.html',
      //     controller: CartItemController,
      //     controllerAs: 'crtItmCtrl',
      //     autoWrap: false,
      //     clickOutsideToClose: false,
      //     escapeToClose: true,
      //     focusOnOpen: true
      //   }).then(function () {
      //     // do nothing
      //   });
      // }
    }

    function close() {
      $mdDialog.hide();
    }

    function exists() {
      return selPos() >= 0;
    }

    function selPos() {
      var pos = -1;
      for (var i = 0; i < vm.list.length; i++) {
        if (vm.order.id == vm.list[i].id) {
          pos = i;
          break;
        }
      }
      return pos;
    }

    function readyForCheckout() {
      // we only check if ready for checkout of checkout was attempted
      // so that we only highligh non-ready orders after attempt made
      if (!vm.checkoutClicked) return true;
      var ad = vm.order.ad;
      if (!ad || !(ad.blog_post_title || ad.link_text || ad.full_pub_url)) {
        return false;
      } else {
        return true;
      }
    }

    function getBlogPostStatus() {
      vm.order.showMessageError = hasToShowErrorMessage();
      var ad = vm.order.ad;
      if (!ad || !(ad.blog_post_title || ad.link_text || ad.full_pub_url)) {
        return 'Create blog post now';
      } else {
        return 'Edit blog post';
      }
    }

    function hasToShowErrorMessage() {
      var order = vm.order;
      return exists(order) && order.ad !== null &&
        order.ad.word === null && order.ad.blog_post_body === null;
    }

    function isOrderSelected(order) {
      return lodash.indexOf(vm.list, order) >= 0;
    }

    function blogPostDialog(ev) {
      if (vm.order.publisher_not_active) {
        return;
      }
      checkIfOrdered();
      $mdDialog.show({
        controller: 'BlogPostController',
        controllerAs: 'blgCtrl',
        templateUrl: 'app/pages/cart/blogPost/blogPost.html',
        hasBackdrop: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          order: vm.order
        }
      }).then(function (blogPost) {
        vm.order.ad = blogPost;
      }, function () {
        $log.log('Dialog was canceled');
      });
    }

    function isCreatedFromSearch() {
      return vm.order.created_from === ORDER_CREATED_ORIGIN.SEARCH;
    }

    function getOrderUrl() {
      return (vm.order.created_from !== ORDER_CREATED_ORIGIN.SEARCH) ? vm.order.url.href : 'Use Quote function to see domains.';
    }

    function checkIfOrdered() {
      OrdersService.orderAlreadyOrderedForCampaign(vm.order.id, vm.order.url.id, vm.order.campaign.id, function (response) {
        vm.order.already_ordered = response.data.already_ordered;
        vm.order.already_ordered_campaign = response.data.campaign_name;
      }, function () {
        $log.error('Error adding finding order cart.');
        toastr.error('Please try again.');
      });
    }

    function formatByName(order) {
      if (order.creator_first_name && order.creator_last_name) {
        return order.creator_first_name.slice(0,1) + '. ' + order.creator_last_name;
      } else {
        return 'SF Admin Team';
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('campaignMiniManagers', campaignMiniManagers());

  /* @ngInject */
  function campaignMiniManagers() {
    var component = {
      templateUrl: 'app/components/cards/campaignMiniManagers/campaignMiniManagers.html',
      controller: campaignMiniManagersController,
      controllerAs: 'vm',
      bindings: {
        campaign: '=',
        teammates: '=',
        manager: '<'
      }
    };

    return component;
  }

  /* @ngInject */
  function campaignMiniManagersController($mdMedia, $mdDialog, $log, lodash, toastr, RoutesService, CampaignsService, CAMPAIGN_STATE, $window, $scope, AccountService, EnvironmentConfig) {
    var vm = this;

    // Accessible variables
    // vm.campaign.products = [{name: "sponsored"},{name: "search"}, {name: "social"}];
    // TODO: make products dynamic
    vm.campaign.products = [{name: "search"}];
    vm.categoriesToDisplay = [];

    // Accessible functions
    vm.$mdMedia = $mdMedia;
    vm.categoriesNames = categoriesNames;
    vm.getProductBadgeClass = getProductBadgeClass;
    vm.hasImage = hasImage;
    vm.getImage = getImage;
    vm.isCampaignRejected = isCampaignRejected;
    vm.editCampaign = editCampaign;
    vm.destroy = destroy;
    vm.setTeammateManageCampaign = setTeammateManageCampaign;

    init();

    // Functions
    function init() {
      vm.categoriesToDisplay = lodash.take(vm.campaign.categories, 2);
    }

    function categoriesNames() {
      return lodash.map(vm.campaign.categories, 'name');
    }

    function getProductBadgeClass(productName) {
      return 'badge badge-' + productName.toLowerCase();
    }

    function hasImage() {
      return !!vm.campaign.image;
    }

    function getImage() {
      return vm.campaign.image || 'assets/images/no_image_found.png';
    }

    function isCampaignRejected() {
      return vm.campaign.state === CAMPAIGN_STATE.REJECTED;
    }

    function editCampaign(id) {
      if (!isCampaignRejected()) {
        RoutesService.editCampaign(id);
      }
    }

    function getAdvertiserData() {
      AccountService.getAdvertiser(function (response) {
        $scope.$parent.advCtrl.advertiser = response.data;
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });
    }

    function destroy() {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Deleting this campaign is permanent and cannot be undone.')
        .ariaLabel('Removing campaign')
        .ok('Yes Delete Campaign ')
        .cancel('No Keep Campaign');

      $mdDialog.show(confirm).then(function () {
        CampaignsService.deleteCampaign(vm.campaign.id, function () {
          if (vm.campaign.campaign_report) $window.open(vm.campaign.campaign_report, '_blank');
          if ($scope.$parent.allCampCtrl) {
            $scope.$parent.allCampCtrl.fetchCampaigns();
          } else if ($scope.$parent.advCtrl) {
            getAdvertiserData();
          }
          toastr.success('Campaign was removed successfully.');
          vm.campaign.destroyed = true;
        }, function (response) {
          if (response.status === 403) {
            toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          } else {
            $log.error('Error deleting campaign.');
            toastr.error('There was an error deleting campaign.');
          }
        });
      });
    }

    function setTeammateManageCampaign() {
      if (vm.manager.id == 0) removeManagersFromCampaign();
      else addManagerToCampaign();
    }

    function addManagerToCampaign() {
      AccountService.setAdvTeammateManageCampaign(vm.manager.id, vm.campaign.id, function(response) {
        toastr.success('Manager successfully set.');
        $window.location.reload();
      }, function() {
        toastr.error('There was a problem setting the manager. Please retry or contact support.');
      });
    }

    function removeManagersFromCampaign() {
      AccountService.removeAdvTeammatesManageCampaign(vm.campaign.id, function(response) {
        toastr.success('Manager successfully set as admin.');
        $window.location.reload();
      }, function() {
        toastr.error('There was a problem removing the teammate manager. Please retry or contact support.');
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('adSpot', adSpot());

  /* @ngInject */
  function adSpot() {
    var component = {
      templateUrl: 'app/components/cards/adSpot/adSpot.html',
      controller: AdSpotController,
      controllerAs: 'vm',
      bindings: {
        url: '=',
        campaignId: "<"
      }
    };

    return component;
  }

  /* @ngInject */
  function AdSpotController($log, $mdDialog, $rootScope, toastr, OrdersService, PROFILE_TYPE, ORDER_CREATED_ORIGIN) {
    var vm = this;

    // Accessible functions
    vm.added = added;
    vm.checkIfOrdered = checkIfOrdered;
    vm.checkIfOrderedForCampaign = checkIfOrderedForCampaign;
    vm.checkIfOrderedEver = checkIfOrderedEver;
    vm.hasImage = hasImage;
    vm.getImage = getImage;

    // Functions
    function added() {
      return OrdersService.isOrdered(vm.url.id);
    }

    function checkIfOrdered() {
      vm.campaignId === '' ? vm.checkIfOrderedEver() : vm.checkIfOrderedForCampaign();
    }

    function checkIfOrderedForCampaign() {
      OrdersService.alreadyOrderedForCampaign(vm.url.id, vm.campaignId, function (response) {
        if (response.data.already_ordered) {
          var confirm = $mdDialog.confirm()
            .title('Warning!')
            .htmlContent('<p>Remember, you have already purchased a link on this domain for the campaign: <b>' +
              response.data.campaign_name + '</b> .</p><br> Please make note of this when viewing items in your cart.')
            .ok('I Understand')
            .cancel('Cancel');

          $mdDialog.show(confirm).then(function (result) {
            addOrderToCart()
          }, function () {});
        } else {
          addOrderToCart();
        }
      }, function () {
        $log.error('Error adding ad spot to your cart.');
        toastr.error('Please try again.');
      });
    }

    function checkIfOrderedEver() {
      OrdersService.alreadyOrdered(vm.url.id, function (response) {
        if (response.data.already_ordered) {
          var confirm = $mdDialog.confirm()
            .title('Warning!')
            .htmlContent('<p>Remember, you have already purchased a link on this domain for the campaign: <b>' +
              response.data.campaign_name + '</b> .</p><br> Please make note of this when viewing items in your cart.')
            .ok('I Understand')
            .cancel('Cancel');

          $mdDialog.show(confirm).then(function (result) {
            addOrderToCart()
          }, function () {});
        } else {
          addOrderToCart();
        }
      }, function () {
        $log.error('Error adding ad spot to your cart.');
        toastr.error('Please try again.');
      });
    }

    function hasImage() {
      return vm.url.image;
    }

    function getImage() {
      return vm.url.image || 'assets/images/avatarSearch.png';
    }

    function addOrderToCart() {
      if (vm.campaignId !== '') {
        OrdersService.createOrderFromCampaign(vm.campaignId, vm.url.id, ORDER_CREATED_ORIGIN.SEARCH, function () {
          $rootScope.isLoading = true;
          toastr.success('This ad spot has been added to your cart.');
        }, function () {
          $log.error('Error adding ad spot to your cart.');
          toastr.error('There was an error adding this ad spot to your cart, please retry.');
        });
      } else {
        OrdersService.createOrder(vm.url.id, ORDER_CREATED_ORIGIN.SEARCH, function () {
          $rootScope.isLoading = true;
          toastr.success('This ad spot has been added to your cart.');
        }, function () {
          $log.error('Error adding ad spot to your cart.');
          toastr.error('There was an error adding this ad spot to your cart, please retry.');
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('campaignMini', campaignMini());

  /* @ngInject */
  function campaignMini() {
    var component = {
      templateUrl: 'app/components/cards/campaignMini/campaignMini.html',
      controller: campaignMiniController,
      controllerAs: 'vm',
      bindings: {
        campaign: '='
      }
    };

    return component;
  }

  /* @ngInject */
  function campaignMiniController($mdMedia, $mdDialog, $log, lodash, toastr, RoutesService, CampaignsService, CAMPAIGN_STATE, $window, $scope, AccountService, EnvironmentConfig) {
    var vm = this;

    // Accessible variables
    // vm.campaign.products = [{name: "sponsored"},{name: "search"}, {name: "social"}];
    // TODO: make products dynamic
    vm.campaign.products = [{name: "search"}];
    vm.categoriesToDisplay = [];

    // Accessible functions
    vm.$mdMedia = $mdMedia;
    vm.categoriesNames = categoriesNames;
    vm.getProductBadgeClass = getProductBadgeClass;
    vm.hasImage = hasImage;
    vm.getImage = getImage;
    vm.isCampaignRejected = isCampaignRejected;
    vm.editCampaign = editCampaign;
    vm.destroy = destroy;

    init();

    // Functions
    function init() {
      vm.categoriesToDisplay = lodash.take(vm.campaign.categories, 2);
    }

    function categoriesNames() {
      return lodash.map(vm.campaign.categories, 'name');
    }

    function getProductBadgeClass(productName) {
      return 'badge badge-' + productName.toLowerCase();
    }

    function hasImage() {
      return !!vm.campaign.image;
    }

    function getImage() {
      return vm.campaign.image || 'assets/images/no_image_found.png';
    }

    function isCampaignRejected() {
      return vm.campaign.state === CAMPAIGN_STATE.REJECTED;
    }

    function editCampaign(id) {
      if (!isCampaignRejected()) {
        RoutesService.editCampaign(id);
      }
    }

    function getAdvertiserData() {
      AccountService.getAdvertiser(function (response) {
        $scope.$parent.advCtrl.advertiser = response.data;
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });
    }

    function destroy() {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Deleting this campaign is permanent and cannot be undone.')
        .ariaLabel('Removing campaign')
        .ok('Yes Delete Campaign ')
        .cancel('No Keep Campaign');

      $mdDialog.show(confirm).then(function () {
        CampaignsService.deleteCampaign(vm.campaign.id, function () {
          if (vm.campaign.campaign_report) $window.open(vm.campaign.campaign_report, '_blank');
          if ($scope.$parent.allCampCtrl) {
            $scope.$parent.allCampCtrl.fetchCampaigns();
          } else if ($scope.$parent.advCtrl) {
            getAdvertiserData();
          }
          toastr.success('Campaign was removed successfully.');
          vm.campaign.destroyed = true;
        }, function (response) {
          if (response.status === 403) {
            toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          } else {
            $log.error('Error deleting campaign.');
            toastr.error('There was an error deleting campaign.');
          }
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('campaignDetails', campaignDetails());

  /* @ngInject */
  function campaignDetails() {
    var component = {
      templateUrl: 'app/components/cards/campaignDetails/campaignDetails.html',
      controller: CampaignDetailsController,
      controllerAs: 'vm',
      bindings: {
        campaign: '=',
        onDelete: '&'
      }
    };

    return component;
  }

  /* @ngInject */
  function CampaignDetailsController($log, lodash, toastr, CampaignsService) {
    var vm = this;

    //Accessible variables
    vm.categoriesNames = categoriesNames;
    vm.selectedCategories = [];
    vm.showCategories = false;

    //Accessible functions
    vm.submitCategories = submitCategories;

    loadCategoriesFromCampaign();

    // Functions
    function categoriesNames() {
      return lodash.map(vm.campaign.categories, 'name');
    }

    function loadCategoriesFromCampaign() {
      vm.selectedCategories = vm.campaign.categories;
    }

    function submitCategories(campaign) {
      campaign.categories = vm.selectedCategories;
      vm.showCategories = false;

      CampaignsService.updateCampaign(campaign.id, campaign,
        function () {
          toastr.success('Campaign categories successfuly updated.');
        },
        function () {
          $log.error('Error updating categories.');
          toastr.error('There was a problem while updating the categories. Please retry.');
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.thankyouPub', [])
    .controller('ThankyouPubController', ThankyouPubController);

  /* @ngInject */
  function ThankyouPubController(UserService, $stateParams, $mdDialog, toastr) {
    var vm = this;
    vm.isEmailSend = false;

    // Accessible attributes
    vm.userEmail = null;

    // Accessible functions
    vm.resendEmail = resendEmail;

    initialize();

    function initialize() {
      vm.userEmail = $stateParams.email;
    }

    function resendEmail() {
      if (vm.userEmail === null) {
        toastr.error('Sorry, your email address is no longer in the session. This can happen if the page is refreshed. Please contact admin if needed.');
        return;
      }
      if(vm.isEmailSend){
        $mdDialog.show(
          $mdDialog.alert()
          .escapeToClose(false)
          .htmlContent('<span class="red-text"> WE RESENT CONFIRMATION TO ' + '<a href="" >' + vm.userEmail.toUpperCase() + '</a>' + '<br>' + 'PLEASE CHECK SPAM EMAIL IS COMING FROM ' +
          '<a href="mailto:admin@scalefluence.com">ADMIN@SCALEFLUENCE.COM</a>' + '<br>' +'IF YOU STILL DID NOT RECEIVE EMAIL, GO TO' + '<a href="https://www.scalefluence.com/CONTACT-US/" target="blank> HTTPS://SCALEFLUENCE.COM/CONTACT-US.</a></span>')
          .ok('Okay')
          .escapeToClose(false)
        );
        return
      }
      else {
      UserService.sendPubSignupConfirmationEmail(vm.userEmail, function() {
        vm.isEmailSend = true;
        $mdDialog.show(
          $mdDialog.alert()
          .textContent('The confirmation email is being sent again.')
          .escapeToClose(false)
          .ok('Okay')
        );
      }, function() {
        toastr.error('Sorry, there was a problem re-sending your confirmation email. Please contact admin if needed.');
      });
    }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.thankyouAdv', [])
    .controller('ThankyouAdvController', ThankyouAdvController);

  /* @ngInject */
  function ThankyouAdvController(UserService, $stateParams, $mdDialog, toastr) {
    var vm = this;

    // Accessible attributes
    vm.userEmail = null;

    // Accessible functions
    vm.resendEmail = resendEmail;

    initialize();

    function initialize() {
      vm.userEmail = $stateParams.email;
    }

    function resendEmail() {
      if (vm.userEmail === null) {
        toastr.error('Sorry, your email address is no longer in the session. This can happen if the page is refreshed. Please contact admin if needed.');
        return;
      }
      UserService.sendAdvSignupConfirmationEmail(vm.userEmail, function() {
        $mdDialog.show(
          $mdDialog.alert()
          .textContent('The confirmation email is being sent again.')
          .escapeToClose(false)
          .ok('Okay')
        );
      }, function() {
        toastr.error('Sorry, there was a problem re-sending your confirmation email. Please contact admin if needed.');
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.search', [])
    .controller('SearchController', SearchController);

  /** @ngInject */
  function SearchController($log, $stateParams, $timeout, $anchorScroll, $mdDialog,
    $rootScope, lodash, toastr, SearchService, CampaignsService,
    RoutesService, AccountService, KEY_CODES, HTTP_STATUS) {
    var vm = this;

    var delay;
    var TIME_DELAY_MS = 800;
    var MAX_VALUE = 100;
    var MAX_PRICE = 1000;
    var PRICE_STEP = 50;
    var max_lrd = '1000000+';
    var price_steps = [];

    for ( var i = 0; i <= MAX_PRICE; i++ ) {
      if (i % PRICE_STEP === 0 ) {
        if (i === MAX_PRICE) i += '+';
        price_steps.push({ value: i });
      }
    }

    // Accessible attributes
    vm.urls = [];
    vm.perPage = 20;
    vm.selectedCategories = [];
    vm.input = '';
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalItems = 0;
    vm.showCategories = true;
    vm.qtyAdvActiveCampaigns = 0;
    vm.searchingCount = 0;
    vm.campaignId = '';

    // Filters' configurations
    vm.domain_authority = {
      min: 0,
      max: MAX_VALUE,
      options: {
        floor: 0,
        ceil: MAX_VALUE,
        step: 5,
        minRange: MAX_VALUE * 0.1,
        maxRange: MAX_VALUE,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onEnd: function () {
          setupTimer();
        }
      }
    }
    vm.trust_flow = {
      min: 0,
      max: MAX_VALUE,
      options: {
        floor: 0,
        ceil: MAX_VALUE,
        step: 5,
        minRange: MAX_VALUE * 0.1,
        maxRange: MAX_VALUE,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onEnd: function () {
          setupTimer();
        }
      }
    }
    vm.ahrefs_dr = {
      min: 0,
      max: MAX_VALUE,
      options: {
        floor: 0,
        ceil: MAX_VALUE,
        step: 5,
        minRange: MAX_VALUE * 0.1,
        maxRange: MAX_VALUE,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onEnd: function () {
          setupTimer();
        }
      }
    }
    vm.ahrefs_lrd = {
      min: 0,
      max: max_lrd,
        options: {
          stepsArray: [{ value: 0 }, { value: 100 }, { value: 1000 }, { value: 10000 }, { value: 50000 }, { value: 500000 }, { value: max_lrd } ],
          minRange: 1,
          noSwitching: true,
          hideLimitLabels: true,
          hidePointerLabels: true,
          onEnd: function () {
            setupTimer();
        }
      }
    }
    vm.citation_flow = {
      min: 0,
      max: MAX_VALUE,
      options: {
        floor: 0,
        ceil: MAX_VALUE,
        step: 5,
        minRange: MAX_VALUE * 0.1,
        maxRange: MAX_VALUE,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onEnd: function () {
          setupTimer();
        }
      }
    }
    vm.price_range = {
      min: 0,
      max: MAX_PRICE + '+',
      options: {
        stepsArray: price_steps,
        minRange: 2,
        noSwitching: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onEnd: function () {
          setupTimer();
        }
      }
    }

    // Sort filter
    vm.sortOptions = [{
        name: 'Domain Authority High to Low',
        value: 'domain_authority desc'
      },
      {
        name: 'Domain Authority Low to High',
        value: 'domain_authority asc'
      },
      {
        name: 'Trust Flow High to Low',
        value: 'trust_flow desc'
      },
      {
        name: 'Trust Flow Low to High',
        value: 'trust_flow asc'
      },
      {
        name: 'Domain Rating High to Low',
        value: 'ahrefs_dr desc'
      },
      {
        name: 'Domain Rating Low to High',
        value: 'ahrefs_dr asc'
      },

      {
        name: 'Linking Root Domain High to Low',
        value: 'ahrefs_lrd desc'
      },
      {
        name: 'Linking Root Domain Low to High',
        value: 'ahrefs_lrd asc'
      },
      {
        name: 'Price High to Low',
        value: 'price desc'
      }, {
        name: 'Price Low to High',
        value: 'price asc'
      }
    ];
    function refreshSlider() {
      $timeout(function () {
        $rootScope.$broadcast('rzSliderForceRender');
      }, 300);
    };

    // Accessible functions
    vm.setupTimer = setupTimer;
    vm.executeQuery = executeQuery;
    vm.searchInput = searchInput;
    vm.queryEnter = queryEnter;
    vm.sortBy = sortBy;
    vm.retrieveUrls = retrieveUrls;
    vm.getPlaceholder = getPlaceholder;
    vm.search = search;
    vm.categoriesChanged = categoriesChanged;

    initialize();

    // Functions
    function initialize() {

      refreshSlider();

      vm.filter = vm.sortOptions[0];
      // Setup params from call if they are defined
      if (angular.isDefined($stateParams.categories) && $stateParams.categories != '') {
        var categoriesNames = $stateParams.categories.split(',');
        vm.selectedCategories = lodash.map(categoriesNames, function (categoryName) {
          return {
            name: categoryName
          }
        });
      } else if (angular.isDefined($rootScope.categories)) {
        vm.selectedCategories = $rootScope.categories;
      }

      // Setup ad spots to search
      setupFilters();
      AccountService.getAdvertiser(function (response) {
        vm.qtyAdvActiveCampaigns = response.data.qty_active_campaigns;
        search();
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your dashboard\'s info.')
      });

      if (angular.isDefined($stateParams.campaignId) && $stateParams.campaignId != '') {
        vm.campaignId = $stateParams.campaignId;
      }
    }

    function isDataSelected() {
      return vm.selectedCategories.length > 0;
    }

    function showWarning() {
      var confirm = $mdDialog.alert()
        .title('Warning!')
        .htmlContent("<p><b> You cannot search until you have one CAMPAIGN approved by admin!</b></p> </br>" +
          "<p> Click 'Create Campaign' to submit your first URL for approval. </p>")
        .ok('I Understand');

      $mdDialog.show(confirm).then(function (result) {
        RoutesService.dashboard();
      });
    }

    function setupTimer() {
      $timeout.cancel(delay);
      delay = $timeout(executeQuery, TIME_DELAY_MS);
    }

    function executeQuery() {
      vm.firstPage = true;
      vm.filters.text = vm.input;
      setupFilters();
      search();
    }

    function queryEnter(event) {
      if (event.keyCode == KEY_CODES.ENTER) {
        vm.filters.text = vm.input;
        setupTimer();
      }
    }

    function searchInput() {
      if (angular.isDefined(vm.input)) {
        vm.filters.text = vm.input;
      }
      setupTimer();
    }

    function setupFilters() {
      vm.filters = {
        domain_authority_start: vm.domain_authority.min,
        domain_authority_end: vm.domain_authority.max,
        trust_flow_start: vm.trust_flow.min,
        trust_flow_end: vm.trust_flow.max,
        ahrefs_dr_start: vm.ahrefs_dr.min,
        ahrefs_dr_end: vm.ahrefs_dr.max,
        ahrefs_lrd_start: vm.ahrefs_lrd.min,
        ahrefs_lrd_end: parseInt(vm.ahrefs_lrd.max),
        citation_flow_start: vm.citation_flow.min,
        citation_flow_end: vm.citation_flow.max,
        price_start: vm.price_range.min,
        price_end: parseInt(vm.price_range.max),
        text: vm.input,
        auto_approved: vm.auto_approved,
        sort_by: vm.filter.value,
        page: vm.currentPage
      };
    }

    function categoriesChanged() {
      //TODO: Trigger when categories are changed to be completed.
    }

    function sortBy() {
      vm.firstPage = true;
      vm.filters.page = 1;
      vm.filters.sort_by = vm.filter.value;
      if (isDataSelected()) {
        search();
      }
    }

    function retrieveUrls(newPage) {
      vm.filters.page = newPage;
      search();
    }

    function search() {
      if (vm.qtyAdvActiveCampaigns > 0) {
        var names = vm.selectedCategories.filter(function (item) {return !item.byKeywords || !item.activeKey});
        var keywords = vm.selectedCategories.filter(function (item) {return item.byKeywords && item.activeKey});
        SearchService.indexUrls(vm.filters, lodash.map(names, 'name'), lodash.map(keywords, 'activeKey'), function (response) {
          var data = response.data;
          vm.urls = data.urls;
          vm.showCategories = false;
          if (vm.firstPage) {
            vm.currentPage = 1;
            vm.firstPage = false;
          }
          vm.totalPages = data.pages;
          vm.totalItems = data.results > 0 ? data.results : 0;
          vm.filters.auto_approved = data.auto_approved
          $anchorScroll('top');
          vm.searchingCount++;
        }, function (response) {
          if (response.status === parseInt(HTTP_STATUS.FORBIDDEN)) {
            showWarning();
          } else {
            $log.error('Error executing query.');
            toastr.error('There was an error executing the query, please retry');
          }
          $anchorScroll('top');
        });
      } else {
        showWarning();
      }
    }

    function getPlaceholder() {
      return (vm.selectedCategories.length > 0) ? ' ' : 'Start typing. Enter button creates string. Categories will also be suggested.';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.payouts', [])
    .controller('PayoutController', PayoutController);

  /* @ngInject */
  function PayoutController($rootScope, toastr, PayoutService, $mdDialog, INIT_DATE, PAGINATION_SIZE, FileSaver, Blob) {
    var vm = this;

    // Accessible attributes
    vm.total_earnings = '0';
    vm.projected_earnings = '0';
    vm.last_month_payouts = '0';
    vm.items = [];
    vm.filtered = [];
    vm.query = {
      filter: '',
      order: '-date_paid',
      limit: 10,
      page: 1
    };
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;

    // Accessible functions
    vm.getPayouts = getPayouts;
    vm.setChangesToDates = setChangesToDates;
    vm.hasItems = hasItems;
    vm.showInfo = showInfo;
    vm.downloadReport = downloadReport;

    initialize();

    function initialize() {
      initDates();
      getPayouts(vm.date_from, vm.date_to);
      angular.element(document).ready(function() {
        jQuery("#from-date").click(function(){
          jQuery("#from-date").blur();
        });
        jQuery("#to-date").click(function(){
          jQuery("#to-date").blur();
        });
      });
    }

    function setChangesToDates() {
      var totalDays = calculateDifference();
      if (totalDays < 0) {
        toastr.error('Please make sure the selected "to date" is not earlier than the selected "from date"');
        return false;
      }
      // don't think the min/max reflecting any change after init
      // no matter, we are using above diff check instead
      vm.maxDateFrom = vm.date_to;
      vm.minDateTo = vm.date_from;
      vm.totalDays = calculateDifference();
      vm.cannotSearch = false;
      getPayouts(vm.date_from, vm.date_to);
    }

    function initDates() {
      vm.myDate = moment().format('MM/DD/YYYY');
      vm.date_to = moment().add(1, 'days').format('MM/DD/YYYY');
      vm.minDateFrom = moment(INIT_DATE).format('MM/DD/YYYY');
      vm.date_from = moment().subtract(6, 'months').format('MM/DD/YYYY');

      vm.maxDateFrom = vm.date_to;
      vm.minDateTo = vm.minDateFrom
      vm.maxDateTo = vm.date_to;
      vm.totalDays = calculateDifference();
    }

    function calculateDifference() {
      var date_from = moment(vm.date_from, 'MM/DD/YYYY');
      var date_to = moment(vm.date_to, 'MM/DD/YYYY');
      return date_to.diff(date_from, 'days');
    }

    function getPayouts(date_from, date_to) {
      var date_from_obj = moment(date_from, 'MM/DD/YYYY').toDate();
      var date_to_obj = moment(date_to, 'MM/DD/YYYY').toDate();

      vm.cannotSearch = true;
      $rootScope.isLoading = true;
      PayoutService.indexPayoutItems(date_from_obj, date_to_obj, function (response) {
        var data = response.data;
        vm.total_earnings = data.total_earnings;
        vm.projected_earnings = data.projected_earnings;
        vm.last_month_payouts = data.last_month_payouts;
        vm.items = data.items;
        vm.filtered = data.items;
        vm.cannotSearch = false;
      });
    }

    function hasItems() {
      return vm.filtered.length > 0;
    }

    function showInfo() {
      return $mdDialog.show(
        $mdDialog.alert()
        .title('Payout History')
        .htmlContent('You may either search by URL, or download after selecting calendar dates.')
        .escapeToClose(false)
        .ok('Ok')
      );
    }

    function downloadReport(date_from, date_to) {
      var date_from_obj = moment(date_from, 'MM/DD/YYYY').toDate();
      var date_to_obj = moment(date_to, 'MM/DD/YYYY').toDate();
      var filename = 'payout_report_' + moment(date_from, 'MM/DD/YYYY').format('MM-DD-YYYY') + '_to_' + moment(date_to, 'MM/DD/YYYY').format('MM-DD-YYYY') + '.csv';

      vm.cannotSearch = true;
      $rootScope.isLoading = true;
      PayoutService.indexPayoutItems(date_from_obj, date_to_obj, function (response) {
        var data = response.data;
        
        if (data.items.length == 0) {
          toastr.error('Sorry, no payouts found for this date range.');
          return false;
        }

        var file_data = 'Date Paid,Live URL,Product,Paid To,Method,Amount';
        for (var i = 0; i < data.items.length; i++) {
          var item = data.items[i];
          file_data += "\r\n" + moment(item.date_paid).format('MM-DD-YYYY') + ',' + item.live_url + ',' + item.product + ',' + item.email + ',' + item.method + ',' + item.amount;
        }

        var blob_data = new Blob([file_data], { type: 'text/plain;charset=utf-8 '});
        FileSaver.saveAs(blob_data, filename);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.faq', [])
    .controller('FaqController', FaqController);

  /* @ngInject */
  function FaqController(SessionService) {
    var vm = this;

    //attributes
    vm.role = '';

    //functions

    initialize();

    function initialize() {
      vm.role = SessionService.currentRole();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.contactUs', [])
    .controller('ContactUsController', ContactUsController);

  /* @ngInject */
  function ContactUsController($rootScope, $scope, $log, lodash, toastr,
    MessagesService, NotificationService, SessionService, PAGINATION_SIZE, MESSAGE_STATE, TYPE_STATE) {
    var vm = this;

    //attributes
    vm.role = '';
    vm.messages = [];
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;
    vm.unreadItems = 0;
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalItems = 0;

    //functions
    vm.hasReply = hasReply;
    vm.getLastDate = getLastDate;
    vm.readReply = readReply;
    vm.retrieveMoreMessages = retrieveMoreMessages;
    vm.createMessage = createMessage;
    vm.isUnread = isUnread;
    vm.decodeMessage = decodeMessage;
    vm.toggleMessage = toggleMessage;

    initialize();

    function initialize() {
      removeNotification();
      getAllMessages(vm.currentPage);
    }

    function hasReply(msg) {
      return msg.state !== MESSAGE_STATE.SENT;
    }

    function isUnread(message) {
      return message.state === MESSAGE_STATE.UNREAD;
    }

    function getLastDate(message) {
      return (isNotNullOrEmpty(message.replied_at)) ? message.replied_at : message.date;
    }

    function readReply(message) {
      if (isUnread(message)) {
        MessagesService.updateState(message, function () {
          lodash.forEach(vm.messages, function (item) {
            if (item.id === message.id) {
              item.state = MESSAGE_STATE.READ;
              vm.unreadItems--;
            }
          });
        }, function (error) {
          $log.error(error);
        });
      }
    }

    function getAllMessages(currentPage) {
      MessagesService.getMessages(currentPage, function (response) {
        var data = response.data;
        vm.totalPages = data.pages;
        vm.totalItems = data.results;
        vm.messages = data.messages;
        vm.unreadItems = data.unread_messages_count;
      }, function (error) {
        toastr.error('There was an error retrieving messages');
        $log.error(response);
      });
    }

    function createMessage(form) {
      var msg = {};
      msg.subject = encodeURIComponent(vm.subject);
      msg.question_message = encodeURIComponent(vm.question_message);
      MessagesService.createMessage(msg, function (response) {
        toastr.success('Message sent to our admins');
        getAllMessages();
        form.$setPristine();
        vm.subject = '';
        vm.question_message = '';
      }, function (error) {
        toastr.error('Cannot sent message. Please, try again');
        $log.error(error);
      });
    }

    function retrieveMoreMessages(page) {
      vm.currentPage = page;
      getAllMessages(vm.currentPage);
    }

    function isNotNullOrEmpty(value) {
      return value !== '' && value !== null;
    }

    function removeNotification() {
      NotificationService.deleteNotification(TYPE_STATE.MESSAGES, SessionService.currentRole());
    }

    function decodeMessage(message) {
      return decodeURIComponent(message);
    }

    function toggleMessage(message) {
      message.active = !message.active;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.creditCards', [])
    .controller('CreditCardController', CreditCardController);

  /* @ngInject */
  function CreditCardController($mdDialog, $log, $mdMedia, $state, $stateParams, $scope, $rootScope, $timeout,
    toastr, lodash, StatesService, CountriesService, StorageService, CreditCardService,
    RoutesService, PaymentsService, ERROR_CODES, EnvironmentConfig, AccountService, UserService) {

    var vm = this;

    //Accesible variables
    vm.ccType = { logo: '', network: '' };
    vm.country = 'US';
    // vm.paymentProcessor = $stateParams.cardId ? 'braintree' : 'cybersource';
    vm.paymentProcessor = 'cybersource'; // Will be set dynamically from API
    vm.stripe = null;
    vm.stripeElements = null;
    vm.stripeCardElement = null;
    vm.perPage = 1;
    vm.filtered = [];
    vm.expDate = {
      month: '',
      year: ''
    };
    vm.zipMask;
    vm.defaultCvvMask;
    vm.id;
    vm.token;
    vm.ccInfo;
    vm.ccNumberMask;
    vm.user;
    vm.midsourceRequestTimeout = null;

    //Accesible functions
    vm.toggleZipMask = toggleZipMask;
    vm.toggleCvvMask = toggleCvvMask;
    vm.toggleCreditCardMask = toggleCreditCardMask;
    vm.submit = submit;
    vm.$mdMedia = $mdMedia;
    vm.checkExpirationDate = checkExpirationDate;
    vm.headerMessage = headerMessage;
    vm.edit = edit;
    vm.showInfo = showInfo;
    vm.usingBraintree = usingBraintree;
    vm.usingCybersource = usingCybersource;
    vm.usingStripe = usingStripe;
    vm.usingMidsource = usingMidsource;
    vm.midsourceSubmit = midsourceSubmit;

    initialize();

    function initialize() {
      getUserInfo();
      confirmAuthorized();
      
      // Fetch current processor (no order IDs; use global/date-based selection)
      PaymentsService.getCurrentProcessor(function (response) {
        vm.paymentProcessor = response.data.processor;
        initializeProcessor();
      }, function () {
        toastr.error('There was an error retrieving payment processor.');
        // Default to midsource on error
        vm.paymentProcessor = 'midsource';
        initializeProcessor();
      });
    }

    function initializeProcessor() {
      if ($stateParams.cardId) {
        vm.id = $stateParams.cardId;
        CreditCardService.getCreditCard(vm.id, function(response) {
          vm.ccInfo = response.data;
          setCCInfo();
        }, function(response) {
          if (response.status === 403) {
            toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
            RoutesService.dashboard();
          } else {
            toastr.error('There was an error retrieving credit card information. Try again');
          }
        })
      } else {
        vm.ccType = null;
      }

      if (vm.usingCybersource()) {
        initializeCybersource();
        vm.months = [
          '01','02','03','04','05','06',
          '07','08','09','10','11','12'
        ];
      } else if (vm.usingStripe()) {
        initializeStripe();
        vm.months = [
          '01','02','03','04','05','06',
          '07','08','09','10','11','12'
        ];
      } else if (vm.usingMidsource()) {
        initializeMidsource();
        vm.months = [
          '01','02','03','04','05','06',
          '07','08','09','10','11','12'
        ];
      } else {
        vm.months = lodash.range(1, 13);
      }

      vm.years = lodash.range(moment().year(), moment().year() + 20);
      vm.states = StatesService.getAllUSStates();
      vm.countries = CountriesService.getAllCountries();

      // Watch on change of credit card type to setup the mask
      $scope.$watch('vm.ccType', function () {
        if (vm.ccType) {
          switch (vm.ccType.digits) {
          case 14:
            vm.ccNumberMask = '9999 999999 9999';
            break;
          case 15:
            vm.ccNumberMask = '9999 999999 99999';
            vm.defaultCvvMask = '9999'
            break;
          case 16:
            vm.ccNumberMask = '9999 9999 9999 9999';
            vm.defaultCvvMask = '999'
            break;
          }
        }
      });
    }

    function initializeMidsource() {
      if (typeof CollectJS === 'undefined') {
        console.error('CollectJS global not available - Collect.js script may not have loaded');
        toastr.error('Payment library not loaded. Please refresh the page.');
        return;
      }

      // Wait for Angular to render the DOM elements before configuring Collect.js
      $scope.$evalAsync(function() {
        var attemptInit = function(attempts) {
          attempts = attempts || 0;
          var ccNumberContainer = document.getElementById('midsource-ccnumber');

          if (ccNumberContainer) {
            try {
              CollectJS.configure({
                paymentSelector: '#midsource-payment-button',
                variant: 'inline',
                styleSniffer: 'true',
                googleFont: 'Montserrat:400',
                customCss: {
                  'font-size': '14px',
                  'font-family': 'helvetica, tahoma, calibri, sans-serif',
                  'color': '#555'
                },
                fields: {
                  ccnumber: {
                    selector: '#midsource-ccnumber',
                    title: 'Card Number',
                    placeholder: '0000 0000 0000 0000'
                  },
                  ccexp: {
                    selector: '#midsource-ccexp',
                    title: 'Card Expiration',
                    placeholder: 'MM / YY'
                  },
                  cvv: {
                    selector: '#midsource-cvv',
                    title: 'CVV Code',
                    placeholder: 'CVV'
                  }
                },
                fieldsAvailableCallback: function() {
                  console.log('MIDsource Collect.js fields loaded');
                },
                validationCallback: function(field, status, message) {
                  var displayError = document.getElementById('midsource-card-errors');
                  if (displayError) {
                    if (status) {
                      displayError.textContent = '';
                    } else {
                      displayError.textContent = message;
                    }
                  }
                },
                timeoutDuration: 10000,
                timeoutCallback: function() {
                  console.error('MIDsource Collect.js timed out');
                  toastr.error('Payment form timed out. Please refresh the page.');
                },
                callback: function(response) {
                  $scope.$apply(function() {
                    if (vm.midsourceRequestTimeout) {
                      $timeout.cancel(vm.midsourceRequestTimeout);
                      vm.midsourceRequestTimeout = null;
                    }
                    if (response.error) {
                      $rootScope.isLoading = false;
                      toastr.error(response.error.message || response.error || 'Invalid card information. Please try again.');
                      return;
                    }
                    if (response.errors && response.errors.length > 0) {
                      $rootScope.isLoading = false;
                      toastr.error(response.errors.map(function(e) { return e.message || e; }).join(' ') || 'Invalid card information. Please try again.');
                      return;
                    }
                    var paymentToken = response.token;
                    if (!paymentToken) {
                      $rootScope.isLoading = false;
                      toastr.error('Failed to tokenize card. Please try again.');
                      return;
                    }
                    var billingInfo = {
                      first_name: vm.firstName,
                      last_name: vm.lastName,
                      address: vm.address,
                      address2: vm.address2,
                      city: vm.city,
                      state: vm.state,
                      zip: vm.zipCode,
                      country: vm.country || 'US'
                    };
                    if (response.card) {
                      billingInfo.masked_number = '****' + response.card.number;
                      billingInfo.card_type = response.card.type;
                      billingInfo.exp_month = response.card.exp ? response.card.exp.substring(0, 2) : '';
                      billingInfo.exp_year = response.card.exp ? ('20' + response.card.exp.substring(2, 4)) : '';
                    }
                    createMidsourceCreditCard(paymentToken, billingInfo);
                  });
                }
              });
            } catch (error) {
              console.error('Error initializing MIDsource Collect.js:', error);
              toastr.error('Unable to initialize payment form. Please refresh the page.');
            }
          } else if (attempts < 10) {
            $timeout(function() {
              attemptInit(attempts + 1);
            }, 50);
          } else {
            console.error('MIDsource card element container not found in DOM after multiple attempts');
            toastr.error('Unable to initialize payment form. Please refresh the page.');
          }
        };

        attemptInit();
      });
    }

    function initializeStripe() {
      var publishableKey = EnvironmentConfig.STRIPE_PUBLISHABLE_KEY;
      
      if (!publishableKey) {
        toastr.error('Stripe publishable key not configured.');
        return;
      }
      
      // Initialize Stripe
      if (typeof Stripe === 'undefined') {
        toastr.error('Stripe.js library not loaded.');
        return;
      }
      
      vm.stripe = Stripe(publishableKey);
      vm.stripeElements = vm.stripe.elements();
      
      // Wait for Angular to render the DOM element before mounting
      // The element is inside an ng-if block, so we need to wait for it to exist
      // Use $evalAsync to wait for the next digest cycle, then check for element
      $scope.$evalAsync(function() {
        // Try to find the element, with a fallback timeout if it's still not there
        var attemptMount = function(attempts) {
          attempts = attempts || 0;
          var cardElementContainer = document.getElementById('stripe-card-element');
          
          if (cardElementContainer) {
            // Element exists, mount Stripe Elements
            try {
              // Create card element
              var cardElement = vm.stripeElements.create('card', {
                style: {
                  base: {
                    fontSize: '14px',
                    fontFamily: 'helvetica, tahoma, calibri, sans-serif',
                    color: '#555'
                  }
                }
              });
              
              // Mount card element
              cardElement.mount('#stripe-card-element');
              
              // Store card element for later use
              vm.stripeCardElement = cardElement;
              
              // Handle validation errors
              cardElement.on('change', function(event) {
                var displayError = document.getElementById('stripe-card-errors');
                if (displayError) {
                  if (event.error) {
                    displayError.textContent = event.error.message;
                  } else {
                    displayError.textContent = '';
                  }
                }
              });
            } catch (error) {
              console.error('Error mounting Stripe card element:', error);
              toastr.error('Unable to initialize payment form. Please refresh the page.');
            }
          } else if (attempts < 10) {
            // Element not found yet, try again after a short delay
            $timeout(function() {
              attemptMount(attempts + 1);
            }, 50);
          } else {
            // Element still not found after multiple attempts
            console.error('Stripe card element container not found in DOM after multiple attempts');
            toastr.error('Unable to initialize payment form. Please refresh the page.');
          }
        };
        
        attemptMount();
      });
    }

    function getUserInfo() {
      UserService.getUser(function (response) {
        vm.user = response.data.user;
        console.log('user', vm.user);
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving your user info.')
      });
    }

    function confirmAuthorized() {
      AccountService.getAdvertiser(function (response) {
        vm.roles = response.data.roles;
        var adv_can_create_quotes = false;
        if (response.data.parent_id == null) {
          adv_can_create_quotes = true;
        } else {
          for (var i = 0; i < vm.roles.length; i++) {
            if (vm.roles[i].name === 'edit_billing') {
              adv_can_create_quotes = true;
              break;
            }
          }
        }
        if (!adv_can_create_quotes) {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      }, function () {
        $log.error('Error retrieving user\'s info');
        toastr.error('There was an error retrieving user info.')
      });
    }

    function initializeCybersource() {
      PaymentsService.getCybersourcePaymentToken(function (response) {
        var token = response.data.cybersource_token;
          console.log(token)
        // the capture context that was requested server-side for this transaction
        var captureContext = token;
        // custom styles that will be applied to each field we create using Microform
        var myStyles = {  
          'input': {    
            'font-size': '14px',    
            'font-family': 'helvetica, tahoma, calibri, sans-serif',    
            'color': '#555'  
          },  
          ':focus': { 'color': 'blue' },  
          ':disabled': { 'cursor': 'not-allowed' },  
          'valid': { 'color': '#3c763d' },  
          'invalid': { 'color': '#a94442' }
        };
        // setup Microform
        var flex = new Flex(captureContext);
               console.log(flex)

        vm.microform = flex.microform({ styles: myStyles });
        var number = vm.microform.createField('number', { placeholder: 'Enter card number' });
        var securityCode = vm.microform.createField('securityCode', { placeholder: '•••' });
        number.load('#number-container');
        securityCode.load('#securityCode-container');
      }, function () {

      });
    }

    function setCCInfo() {
      vm.expDate.month = vm.ccInfo.month;
      vm.expDate.year = vm.ccInfo.year;
      vm.address = vm.ccInfo.street_address;
      vm.address2 = vm.ccInfo.extended_address;
      vm.firstName = vm.ccInfo.cardholder_name.split(/ +/)[0];
      vm.lastName = vm.ccInfo.cardholder_name.split(/ +/)[1];
      vm.city = vm.ccInfo.city;
      vm.state = vm.ccInfo.state;
      vm.zipCode = vm.ccInfo.zip_code;
      vm.country = vm.ccInfo.country_name;
      vm.token = vm.ccInfo.token;
      vm.ccNumber = vm.ccInfo.masked_number;
      vm.ccType.logo = vm.ccInfo.image_url;
      vm.ccType.network = vm.ccInfo.card_type;
    }

    function toggleZipMask() {
      if (!vm.zipMask) {
        vm.zipMask = '99999';
      } else if (!vm.zipCode) {
        vm.zipMask = '';
      }
    }

    function toggleCreditCardMask() {
      if (!vm.ccNumberMask) {
        vm.ccNumberMask = '9999 9999 9999 9999';
      } else if (!vm.ccNumber) {
        vm.ccNumberMask = '';
      }
    }

    function toggleCvvMask() {
      if (!vm.cvvMask || vm.cvvNumber) {
        vm.cvvMask = vm.defaultCvvMask || '999?9';
      } else if (!vm.cvvNumber) {
        vm.cvvMask = '';
      }
    }

    function showInfo() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('CVV number')
        .textContent("The CVV Number (\"Card Verification Value\") on your credit card or debit card is a 3 digit number on VISA®, MasterCard® and Discover® branded credit and debit cards. On your American Express® branded credit or debit card it is a 4 digit numeric code.")
        .ariaLabel('Notes')
        .ok('Got it!')
      );
    }

    function checkExpirationDate() {
      if (vm.expDate.month && vm.expDate.year) {
        var toDay = new Date(moment().year() + '-' + (moment().month() + 1));
        var date = new Date(vm.expDate.year + '-' + vm.expDate.month);
        $scope.paymentForm.expDateMonth.$setValidity('past', date >= toDay);
      }
    }

    function headerMessage() {
      return vm.edit() ? 'Edit Credit Card' : 'Add New Credit Card';
    }

    function submit() {
      if (vm.usingBraintree()) return newPaymentMethodBraintree();
      else if (vm.usingCybersource()) return newPaymentMethodCybersource();
      else if (vm.usingStripe()) return newPaymentMethodStripe();
      else if (vm.usingMidsource()) return newPaymentMethodMidsource();
    }

    // Midsource add-card: button has id="midsource-payment-button" so Collect.js intercepts
    // the click and tokenizes; we set loading + timeout so the UI does not hang if callback never runs
    function midsourceSubmit() {
      $rootScope.isLoading = true;
      vm.midsourceRequestTimeout = $timeout(function() {
        $rootScope.isLoading = false;
        vm.midsourceRequestTimeout = null;
        toastr.error('Payment request timed out. If the form does not respond, try refreshing the page or disabling ad blockers.');
      }, 15000);
    }

    function sendToken(token, cardInfo) {
      $rootScope.isLoading = true;
      if (token == null) {
        toastr.error('There was an error creating a token');
        $log.error('Token is null');
        return;
      }
      var client = new braintree.api.Client({
        clientToken: token
      });

      if (client) {
        client.tokenizeCard(cardInfo, function (err, nonce) {
          if (err) {
            $log.error(err);
            toastr.error(err);
            return;
          }
          (vm.token && vm.id) ? updateCreditCard(vm.id, nonce, vm.token) : createCreditCard(nonce);
        });
      } else {
        $log.error('There was an error contacting the payment gateway.');
        toastr.error('There was an error connecting the payment gateway. Please try againg in a few minutes.');
      }
    }

    function createCreditCard(nonce) {
      CreditCardService.createCreditCard(nonce, function() {
        RoutesService.profile();
        toastr.success('Successfully added new Credit Card');
      }, function(response) {
        displayErrors(response);
      });
    }

    function createCybersourceCreditCard(token, cardBillingInfo) {
      CreditCardService.createCybersourceCreditCard(token, cardBillingInfo, function() {
        RoutesService.profile();
        toastr.success('Successfully added new Credit Card');
      }, function(response) {
        console.log(response);
        toastr.error(response.data.error);
      });
    }

    function updateCreditCard(id, nonce, token) {
      CreditCardService.updateCreditCard(id, nonce, token, function() {
        RoutesService.profile();
        toastr.success('Successfully updated the Credit Card information');
      }, function(response) {
        displayErrors(response);
      });
    }

    function displayErrors(response) {
      if (lodash.includes(ERROR_CODES, response.data.errors[0].code)) {
        showDialogMessage('Your Credit Card number is invalid',
          'This means you have entered an incorrect 16 digit number. ' +
          'Please retype the entire <b>Credit Card number</b>.');
      } else {
        showDialogMessage('Please check some information',
          'Please double check your <b>Billing Zip Code</b>, <b>CVV</b>, ' +
          'and <b>Expiration Date</b>.');
      }
    }

    function showDialogMessage(title, message) {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title(title)
        .htmlContent(message)
        .ok('Got it!')
      );
    }

    function edit() {
      return angular.isDefined(vm.id);
    }

    function showInfo() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('CVV number')
        .textContent('If you have been issued a new CVV number, then you need to enter an entirely new CC record. PCI compliance does not allow us to edit CVV for existing cards.')
        .ariaLabel('Notes')
        .ok('Got it!')
      );
    }

    function newPaymentMethodBraintree(){
      PaymentsService.getPaymentToken(function (response) {
        var creditCard = {
          cardholderName: vm.firstName + ' ' + vm.lastName,
          expirationMonth: vm.expDate.month,
          expirationYear: vm.expDate.year,
          billingAddress: {
            postalCode: vm.zipCode,
            firstName: vm.firstName,
            lastName: vm.lastName,
            streetAddress: vm.address,
            countryName: vm.country,
            locality: vm.city,
            region: vm.state
          }
        }

        if(!vm.edit()) {
          creditCard.number = vm.ccNumber;
          creditCard.cvv = vm.cvvNumber;
        }
        if (angular.isDefined(vm.address2)) {
          creditCard.billingAddress.extendedAddress = vm.address2;
        }
        sendToken(response.data.token, creditCard);
      }, function () {
        $log.error('There was an error getting token.');
      });
    }

    function newPaymentMethodCybersource() {
      var cardBillingInfo = {
        first_name: vm.firstName,
        last_name: vm.lastName,
        address: vm.address,
        address2: vm.address2,
        city: vm.city,
        state: vm.state,
        zip: vm.zipCode,
        country: vm.country,
        exp_month: document.querySelector('#expMonth').value,
        exp_year: document.querySelector('#expYear').value,
        email: vm.user.email
      }
       // Compiling MM & YY into optional paramiters	 
      var options = {    
        expirationMonth: document.querySelector('#expMonth').value,  
        expirationYear: document.querySelector('#expYear').value 
      };              
      vm.microform.createToken(options, function (err, token) {
         if (err) {
          // handle error
          var msg = err.message;
          if (err.details) {
            for (var i = 0; i < err.details.length; i++) {
              if (err.details[i].location && err.details[i].message) {
                msg += ' - ' + err.details[i].location + ': ' + err.details[i].message
              }
            }
          }
          console.error(err);
          toastr.error(msg);
         } else {
           // At this point you may pass the token back to your server as you wish.
           sendTokenCybersource(JSON.stringify(token), cardBillingInfo);
         }
       });
    }

    function sendTokenCybersource(token,cardBillingInfo) {
      $rootScope.isLoading = true;
      if (token == null) {
        toastr.error('There was an error creating a token');
        $log.error('Token is null');
        return;
      } else{
        createCybersourceCreditCard(token, cardBillingInfo)
      }
    }

    function newPaymentMethodStripe() {
      var cardBillingInfo = {
        first_name: vm.firstName,
        last_name: vm.lastName,
        address: vm.address,
        address2: vm.address2,
        city: vm.city,
        state: vm.state,
        zip: vm.zipCode,
        country: vm.country || 'US'
      };
      
      $rootScope.isLoading = true;
      
      // Create PaymentMethod from card element
      vm.stripe.createPaymentMethod({
        type: 'card',
        card: vm.stripeCardElement,
        billing_details: {
          name: vm.firstName + ' ' + vm.lastName,
          address: {
            line1: vm.address,
            line2: vm.address2,
            city: vm.city,
            state: vm.state,
            postal_code: vm.zipCode,
            country: vm.country || 'US'
          }
        }
      }).then(function(result) {
        if (result.error) {
          $rootScope.isLoading = false;
          var displayError = document.getElementById('stripe-card-errors');
          if (displayError) {
            displayError.textContent = result.error.message;
          }
          toastr.error(result.error.message);
        } else {
          // PaymentMethod created successfully, send to backend
          createStripeCreditCard(result.paymentMethod.id, cardBillingInfo);
        }
      });
    }

    function createStripeCreditCard(paymentMethodId, cardBillingInfo) {
      CreditCardService.createStripeCreditCard(paymentMethodId, cardBillingInfo, function() {
        $rootScope.isLoading = false;
        RoutesService.profile();
        toastr.success('Successfully added new Credit Card');
      }, function(response) {
        $rootScope.isLoading = false;
        console.log(response);
        toastr.error(response.data.error || 'There was an error saving your card.');
      });
    }

    function newPaymentMethodMidsource() {
      var cardBillingInfo = {
        first_name: vm.firstName,
        last_name: vm.lastName,
        address: vm.address,
        address2: vm.address2,
        city: vm.city,
        state: vm.state,
        zip: vm.zipCode,
        country: vm.country || 'US'
      };

      $rootScope.isLoading = true;

      if (vm.midsourcePaymentToken) {
        // Token already generated from Collect.js callback
        var billingInfo = angular.copy(cardBillingInfo);
        if (vm.midsourceCardResponse) {
          billingInfo.masked_number = vm.midsourceCardResponse.card ? ('****' + vm.midsourceCardResponse.card.number) : '';
          billingInfo.card_type = vm.midsourceCardResponse.card ? vm.midsourceCardResponse.card.type : '';
          billingInfo.exp_month = vm.midsourceCardResponse.card ? vm.midsourceCardResponse.card.exp.substring(0, 2) : '';
          billingInfo.exp_year = vm.midsourceCardResponse.card ? ('20' + vm.midsourceCardResponse.card.exp.substring(2, 4)) : '';
        }
        createMidsourceCreditCard(vm.midsourcePaymentToken, billingInfo);
      } else {
        // Need to trigger Collect.js to generate a token
        if (typeof CollectJS !== 'undefined' && CollectJS.startPaymentRequest) {
          CollectJS.startPaymentRequest(function(response) {
            if (response.token) {
              var billingInfo = angular.copy(cardBillingInfo);
              billingInfo.masked_number = response.card ? ('****' + response.card.number) : '';
              billingInfo.card_type = response.card ? response.card.type : '';
              billingInfo.exp_month = response.card ? response.card.exp.substring(0, 2) : '';
              billingInfo.exp_year = response.card ? ('20' + response.card.exp.substring(2, 4)) : '';
              createMidsourceCreditCard(response.token, billingInfo);
            } else {
              $rootScope.isLoading = false;
              toastr.error('Failed to tokenize card. Please check your card details and try again.');
            }
          });
        } else {
          $rootScope.isLoading = false;
          toastr.error('Payment form not ready. Please wait a moment and try again.');
        }
      }
    }

    function createMidsourceCreditCard(paymentToken, cardBillingInfo) {
      CreditCardService.createMidsourceCreditCard(paymentToken, cardBillingInfo, function() {
        $rootScope.isLoading = false;
        RoutesService.profile();
        toastr.success('Successfully added new Credit Card');
      }, function(response) {
        $rootScope.isLoading = false;
        console.log(response);
        toastr.error(response.data.error || 'There was an error saving your card.');
      });
    }

    function usingBraintree() {
      return vm.paymentProcessor === 'braintree';
    }

    function usingCybersource() {
      return vm.paymentProcessor === 'cybersource';
    }

    function usingStripe() {
      return vm.paymentProcessor === 'stripe';
    }

    function usingMidsource() {
      return vm.paymentProcessor === 'midsource';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.billing', [])
    .controller('BillingController', BillingController);

  /* @ngInject */
  function BillingController($window, $mdExpansionPanel, $mdExpansionPanelGroup, $scope,
    $rootScope, $anchorScroll, toastr, lodash, PAGINATION_SIZE, OrdersService, InvoiceService, $mdDialog) {
    var vm = this;

    // Accessible variables
    vm.invoices = [];
    vm.total_invoices = 0;
    vm.query = {
      filter: '',
      order: '-url.domain_authority',
      limit: 10,
      page: 1
    };
    vm.perPage = PAGINATION_SIZE.PER_PAGE;
    vm.maxSize = PAGINATION_SIZE.MAX_SIZE;

    // Accessible functions
    vm.goTop = goTop;
    vm.paginateInvoices = paginateInvoices;
    vm.hasLiveLink = hasLiveLink;
    vm.showInfo = showInfo;
    vm.daysFromDate = daysFromDate;
    vm.openPdf = openPdf;
    vm.fetchInvoices = fetchInvoices;

    initialize();

    function initialize() {
      fetchInvoices();
    }

    $scope.collapseOne = function () {
      $mdExpansionPanel('expansionPanelOne').collapse();
    };

    function goTop() {
      $anchorScroll('top');
    }

    function paginateInvoices(newPageNumber, oldPageNumber) {
      vm.query.page = newPageNumber;
      fetchInvoices();
      $anchorScroll('top');
    }

    function fetchInvoices() {
      InvoiceService.indexInvoice(vm.query, function(response) {
        vm.invoices = response.data.invoices;
        vm.total_invoices = response.data.results;
        for (var i = 0; i < vm.invoices.length; i++) {
          vm.invoices[i].pagination = {
            query: {
              filter: '',
              order: '-url.domain_authority',
              limit: 10,
              page: 1
            },
            perPage: PAGINATION_SIZE.PER_PAGE,
            maxSize: PAGINATION_SIZE.MAX_SIZE
          }
        }
      }, function () {
        toastr.error('There was an error retrieving your billing info.');
      });

      // uncomment to expand the first panel on page load
      // $mdExpansionPanel().waitFor('expansionPanelOne').then(function (instance) {
      //   instance.expand();
      // });
    }

    function hasLiveLink(order) {
      if (order.ad.full_pub_url) {
        if (order.ad.full_pub_url.toLowerCase().includes('refunded')) return false
        else if (order.ad.state == 'approved' || order.ad.state == 'paid') return true
        else return false
      } else return false
    }

    function showInfo() {
      $mdDialog.show(
        $mdDialog.alert()
          .title('Billing')
          .htmlContent('Recent purchases are pending for 7 days while we allow bloggers and influencers to accept your orders. ' +
            'So this means the order totals will go up as they are accpeted. Once the 7 days have passed, the order total becomes final.')
          .escapeToClose(false)
          .ok('Ok')
      );
    }

    function openPdf(invoice) {
      // force false so invoice generates every time, but leaving
      // condition in case we want to switch back easily
      if (false && invoice.pdf_url && invoice.pdf_url !== "") {
        $window.open(invoice.pdf_url, '_blank');
      } else {
        InvoiceService.getInvoicePdf(invoice.id, function(response) {
          var url = response.data.url;
          $window.open(url, '_blank');
        }, function () {
          toastr.error('There was an error retrieving invoice pdf. Try again later.');
        })
      }
    }

    function daysFromDate(date) {
      var now = moment();
      var target = moment(date).set({
                    'hour': now.get('hour'),
                    'minute': now.get('minute'),
                    'second': now.get('second') + 1
                   });
      return now.diff(target, 'days');
    }

  }
})();

angular.module('linktub')
  .directive('foundationDatepicker', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        var options = {};
        options.format = 'mm/dd/yyyy';
        options.leftArrow = '<svg class="icon icon--datepicker-prev"><use xlink:href="assets/images/icons.svg#datepicker-prev"></use></svg>';
        options.rightArrow = '<svg class="icon icon--datepicker-next"><use xlink:href="assets/images/icons.svg#datepicker-next"></use></svg>';
        if(typeof(attrs.minDate) !== 'undefined') options.startDate = attrs.minDate;
        if(typeof(attrs.maxDate) !== 'undefined') options.endDate = attrs.maxDate;

        var dp = angular.element(elem).fdatepicker(options)
        .on('changeDate', function(ev){
          ngModel.$setViewValue(moment.utc((new Date(ev.date))).format('MM/DD/YYYY'));
          ngModel.$render();
        }).data('datepicker');
      }
    }
  });

(function () {
  'use strict';

  angular
    .module('linktub')
    .filter('tel', function () {
      return function (tel) {
        if (!tel) {
          return '';
        }
        var value = tel.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
          return tel;
        }
        var city;
        var number;
        switch (value.length) {
          case 1:
          case 2:
          case 3:
            city = value;
            break;

          default:
            city = value.slice(0, 3);
            number = value.slice(3);
        }
        if (number) {
          if (number.length > 3) {
            number = number.slice(0, 3) + '-' + number.slice(3, 7);
          }
          return ("(" + city + ") " + number).trim();
        } else {
          return "(" + city;
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .filter('maskedCardNumber', function () {
      return function (maskedNumber) {
        if (!maskedNumber) return '';
        // Already in "ending in XXXX" format
        if (/^ending in \d{4}$/i.test(maskedNumber.trim())) return maskedNumber;
        // Extract last 4 digits for display (e.g. ****463588*******2957 -> "ending in 2957")
        var digits = maskedNumber.replace(/\D/g, '');
        if (digits.length >= 4) return 'ending in ' + digits.slice(-4);
        return maskedNumber;
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .filter('passwordCount', function (MIN_PASS_SIZE) {
      return function (value, peak) {
        value = angular.isString(value) ? value : '';
        peak = isFinite(peak) ? peak : MIN_PASS_SIZE;

        return value && (value.length > peak ? peak + '+' : value.length);
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .filter('link', function () {
      return function (url) {
        if (!url.toLowerCase().startsWith('http')) {
          return 'http://' + url;
        }
        return url;
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .filter('capitalize', function () {
      return function (token) {
        if (token) {
          return token.charAt(0).toUpperCase() + token.slice(1);
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('topnavext', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/topnavext/topnavext.html',
      controller: TopnavextController,
      controllerAs: 'vm'
    };

    return component;
  }

  /* @ngInject */
  function TopnavextController($scope, $mdDialog, $state, toastr, RoutesService, SessionService, AuthenticationService,
    AccountService) {
    var vm = this;

    // Accessible attributes
    vm.mobileMenuActive = false;
    vm.loginMenuActive = false;

    // Accessible functions
    vm.setMobileMenuInactive = setMobileMenuInactive;
    vm.toggleMobileMenu = toggleMobileMenu;
    vm.setLoginMenuInactive = setLoginMenuInactive;
    vm.toggleLoginMenu = toggleLoginMenu;
    vm.initLoginMenu = initLoginMenu;

    vm.initLoginMenu();

    function setMobileMenuInactive() {
      vm.mobileMenuActive = false;
    }

    function toggleMobileMenu() {
      vm.mobileMenuActive = !vm.mobileMenuActive;
    }

    function setLoginMenuInactive() {
      vm.loginMenuActive = false;
    }

    function toggleLoginMenu() {
      jQuery(".user-menu__dropdown").toggle();
    }

    function initLoginMenu() {
      angular.element(document).ready(function() {
        jQuery(".user-menu__dropdown").mouseleave(function(){
          setTimeout(function() {
            jQuery(".user-menu__dropdown").hide();
          }, 500);
        });
      });

      angular.element(document).mouseup(function (e) {
        var container = jQuery(".user-menu__dropdown");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.hide();
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('topnav', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/topnav/topnav.html',
      controller: TopnavController,
      controllerAs: 'vm',
      transclude: true
    };

    return component;
  }

  /* @ngInject */
  function TopnavController($mdDialog, $state, toastr, RoutesService, SessionService, AuthenticationService,
    AccountService, $rootScope, UserTourService, $timeout) {
    var vm = this;

    // Accessible attributes
    vm.email;
    vm.userMenuActive = false;
    vm.mobileMenuActive = false;
    vm.userMenuInUse = false;
    vm.isTeammate = false;
    vm.publisher;

    // Accessible functions
    vm.openMenu = openMenu;
    vm.changeAccount = changeAccount;
    vm.signOut = signOut;
    vm.goToDashboard = goToDashboard;
    vm.accountMessage = accountMessage;
    vm.isAdvertiser = isAdvertiser;
    vm.isPublisher = isPublisher;
    vm.setMobileMenuInactive = setMobileMenuInactive;
    vm.toggleMobileMenu = toggleMobileMenu;
    vm.setUserMenuInUse = setUserMenuInUse;
    vm.setUserMenuInactive = setUserMenuInactive;
    vm.fadeUserMenu = fadeUserMenu;
    vm.toggleUserMenu = toggleUserMenu;
    vm.newProfile = newProfile;
    vm.startPubTour = startPubTour;

    // var changingUserTourStep = $rootScope.$on('changingUserTourStep', function(event, state) {
    //   if (state.current_name === 'pub_welcome') {
    //     console.log('[topnav] changing to step ' + state.current_step);
    //     if (state.current_step == 1) {
    //       if (!jQuery(".user-menu__dropdown").is(":visible")) {
    //         jQuery(".user-menu__dropdown").toggle();
    //         $timeout(function () { UserTourService.unpause(); }, 500);
    //       }
    //     }
    //   }
    // });

    initialize();

    // Functions
    function initialize() {
      vm.email = SessionService.sessionUser().email;
      if (!vm.email) {
        if (isAdvertiser()) {
          AccountService.getAdvertiser(function (response) {
            vm.email = response.data.email;
            if (response.data.parent_id) vm.isTeammate = true;
          });
        } else {
          AccountService.getPublisher(function (response) {
            vm.email = response.data.email;
            vm.publisher = response.data;
          });
        }
      } else if(SessionService.sessionUser().parent_id) {
        vm.isTeammate = true;
      }

      angular.element(document).mouseup(function (e) {
        var container = jQuery(".user-menu__dropdown");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.hide();
        }
      });
    }

    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function changeAccount(ev) {
      // ie more than 1 roles do exists, so there are no
      // roles for which to create an account for
      if (SessionService.canSwithAccount()) {
        // ie more than 1 of those existing roles are active
        if (SessionService.switchAccountEnabled()) {
          SessionService.switchAccount();
          RoutesService.dashboard();
        } else {
          // even tho there already are multiple roles (ie both pub and adv account)
          // there is only 1 active role (that we are currently logged into), so let's
          // not allow switching.
          toastr.error('Sorry, switching has been disabled on this account.');
        }
      } else { // we currently only have 1 role, so we can create the other role
        var confirm = $mdDialog.confirm()
          .title('Are you sure?')
          .textContent('Remember that when you login your account will default to the original account you signed up with')
          .targetEvent(ev)
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function () {
          if (isAdvertiser()) {
            AccountService.createPublisher(function (response)  {
              SessionService.updateSession(response.data);
              RoutesService.dashboard();
            }, function () {
              toastr.error('There was an error creating the Publisher Account. Try again.');
            });
          } else if (isPublisher()) {
            AccountService.createAdvertiser(function (response)  {
              SessionService.updateSession(response.data);
              RoutesService.dashboard();
            }, function () {
              toastr.error('There was an error creating the Publisher Account. Try again.');
            });
          } else {
            toastr.error('No role is set to the account. Try again');
          }
        }, function () {
          return;
        });
      }
    }

    function accountMessage() {
      var message = '';
      if (SessionService.canSwithAccount()) {
        if (isAdvertiser()) {
          message = 'Switch to Publisher\'s side';
        } else if (isPublisher()) {
          message = 'Switch to Advertiser\'s side';
        }
      } else {
        if (isAdvertiser()) {
          message = 'Create a Publisher Account';
        } else if (isPublisher()) {
          message = 'Create an Advertiser Account';
        }
      }
      return message;
    }

    function signOut() {
      AuthenticationService.logout(RoutesService.signIn);
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function isAdvertiser() {
      return SessionService.isAdvertiser();
    }

    function isPublisher() {
      return SessionService.isPublisher();
    }

    function setMobileMenuInactive() {
      vm.mobileMenuActive = false;
    }

    function toggleMobileMenu() {
      vm.mobileMenuActive = !vm.mobileMenuActive;
    }

    function setUserMenuInUse() {
      vm.userMenuInUse = true;
    }

    function setUserMenuInactive(doFade) {
      jQuery(".user-menu__dropdown").hide();
    }

    function fadeUserMenu() {
      return false;
      vm.userMenuInUse = false;
      // jQuery(document).ready not working when logged in, so using
      // angularjs function. Also, doing the same things with pure angularjs
      // resulted in inconsisted lag times (not always 500), so sticking to jquery
      setTimeout(function() {
        if (!vm.userMenuInUse) jQuery(".user-menu__dropdown").hide();
      }, 500);
    }

    function toggleUserMenu() {
      console.log('toggling menu');
      jQuery(".user-menu__dropdown").toggle();
      if (jQuery(".user-menu__dropdown").is(":visible")) {
        console.log('going to step 1');
        UserTourService.goToStepNumber(2, 500);
      }
    }

    function newProfile() {
      $mdDialog.show({
        controller: 'CreateProfileController',
        controllerAs: 'createProfCtrl',
        templateUrl: 'app/pages/profiles/createProfile/createProfileDialog.html',
        clickOutsideToClose: false,
        bindToController: true,
        escapeToClose: true,
        focusOnOpen: true,
      }).then(function (id, profile, type) {
        RoutesService.editProfileV2(id, profile, vm.publisher);
      });
    }

    function startPubTour() {
      UserTourService.setActive();
      UserTourService.startPubWelcomeTourPhase3();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('sidenav', sidenav());

  /* @ngInject */
  function sidenav() {
    var component = {
      templateUrl: 'app/components/sidenav/sidenav.html',
      controller: SidenavController,
      controllerAs: 'vm'
    };

    return component;
  }

  /* @ngInject */
  function SidenavController($log, $rootScope, toastr, OrdersService, SessionService) {
    var vm = this;

    // Accessible attributes
    vm.cartItems = [];

    //Accessible functions
    vm.notImplemented = notImplemented;
    vm.isAdvertiser = isAdvertiser;
    vm.isPublisher = isPublisher;

    // Functions
    vm.$onInit = function () {
      if(isAdvertiser()) {
        OrdersService.indexOrders(function (response) {
          $rootScope.cartItems = response;
        }, function () {
          $log.error('Error retrieving your orders.');
          toastr.error('There was an error retrieving your orders.')
        });
      }
    }

    function notImplemented() {
      toastr.warning('Not implemented yet!');
    }

    function isAdvertiser() {
      return SessionService.isAdvertiser();
    }

    function isPublisher() {
      return SessionService.isPublisher();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('toolbar', component());

  /* @ngInject */
  function component() {
    var component = {
      templateUrl: 'app/components/toolbar/toolbar.html',
      controller: ToolbarController,
      controllerAs: 'vm',
      transclude: true
    };

    return component;
  }

  /* @ngInject */
  function ToolbarController($mdSidenav, $mdDialog, $state, toastr, RoutesService, SessionService, AuthenticationService,
    AccountService) {
    var vm = this;

    // Accessible attributes
    vm.email;

    // Accessible functions
    vm.toggleMenu = toggleMenu;
    vm.openMenu = openMenu;
    vm.profile = profile;
    vm.changeAccount = changeAccount;
    vm.signOut = signOut;
    vm.goToDashboard = goToDashboard;
    vm.accountMessage = accountMessage;

    initialize();

    // Functions
    function initialize() {
      vm.email = SessionService.sessionUser().email;
      if (!vm.email) {
        if (isAdvertiser()) {
          AccountService.getAdvertiser(function (response) {
            vm.email = response.data.email;
          });
        } else {
          AccountService.getPublisher(function (response) {
            vm.email = response.data.email;
          });
        }
      }
    }

    function toggleMenu() {
      $mdSidenav('left').toggle();
    }

    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function profile() {
      RoutesService.profile();
    }

    function changeAccount(ev) {
      if (SessionService.switchAccount()) {
        RoutesService.dashboard();
      } else {
        var confirm = $mdDialog.confirm()
          .title('Are you sure?')
          .textContent('Remember that when you login your account will default to the original account you signed up with')
          .targetEvent(ev)
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function () {
          if (isAdvertiser()) {
            AccountService.createPublisher(function (response)  {
              SessionService.updateSession(response.data);
              RoutesService.dashboard();
            }, function () {
              toastr.error('There was an error creating the Publisher Account. Try again.');
            });
          } else if (isPublisher()) {
            AccountService.createAdvertiser(function (response)  {
              SessionService.updateSession(response.data);
              RoutesService.dashboard();
            }, function () {
              toastr.error('There was an error creating the Publisher Account. Try again.');
            });
          } else {
            toastr.error('No role is set to the account. Try again');
          }
        }, function () {
          return;
        });
      }
    }

    function accountMessage() {
      var message = '';
      if (SessionService.canSwithAccount()) {
        if (isAdvertiser()) {
          message = 'Switch to Publisher\'s side';
        } else if (isPublisher()) {
          message = 'Switch to Advertiser\'s side';
        }
      } else {
        if (isAdvertiser()) {
          message = 'Create a Publisher Account';
        } else if (isPublisher()) {
          message = 'Create an Advertiser Account';
        }
      }
      return message;
    }

    function signOut() {
      AuthenticationService.logout(RoutesService.signIn);
    }

    function goToDashboard() {
      RoutesService.dashboard();
    }

    function isAdvertiser() {
      return SessionService.isAdvertiser();
    }

    function isPublisher() {
      return SessionService.isPublisher();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('row', row());

  /* @ngInject */
  function row() {
    var component = {
      templateUrl: 'app/components/row/row.html',
      controller: RowController,
      controllerAs: 'vm',
      bindings: {
        followers: '=',
        network: '=',
        header: '='
      }
    };

    return component;
  }

  /* @ngInject */
  function RowController($scope, lodash, PricingService) {
    var vm = this;

    vm.isSelected = isSelected;
    vm.around = around;
    vm.rowPricingIn = PricingService.getPricingIn();
    vm.rowPricingYt = PricingService.getPricingYt();
    vm.rowPricingFbTwPi = PricingService.getFbTwPiPricing();
    vm.rowPricingGA = PricingService.getGaPricing();
    vm.rowVideoPricingGA = PricingService.getGaVideoPricing();
    vm.rowVideoPricingIn = PricingService.getVideoPricingIn();
    vm.rowVideoPricingYt = PricingService.getVideoPricingYt();
    vm.rowVideoPricingFbTw = PricingService.getFbTwVideoPricing();
    vm.rowFbTwSharingPricing = PricingService.getFbTwSharingPricing();

    vm.getHeader = getHeader;

    vm.$onInit = function () {
      $scope.$watch('vm.followers', function () {
        renderRow(vm.network);
      })
    }

    function getHeader() {
      return vm.header;
    }

    function renderRow(network) {
      var pos = getSelected(vm.followers, vm.network);
      vm.min = 0;
      vm.max = 7;

      if (isRowPricingFbTwPi(network)) {
        if (pos > 10) {
          vm.min = 7;
          vm.max = 14;
        } else if (pos > 3) {
          vm.min = pos - 3;
          vm.max = pos + 4;
        }
        vm.showedRows = vm.rowPricingFbTwPi.slice(vm.min, vm.max);
        vm.showedVideoRows = vm.rowVideoPricingFbTw.slice(vm.min, vm.max);
        vm.showedSharingRows = vm.rowFbTwSharingPricing.slice(vm.min, vm.max);
      } else if (isRowPricingYt(network)) {
        if (pos > 11) {
          vm.min = 8;
          vm.max = 15;
        } else if (pos > 3) {
          vm.min = pos - 3;
          vm.max = pos + 4;
        }
        vm.showedRows = vm.rowPricingYt.slice(vm.min, vm.max);
        vm.showedVideoRows = vm.rowVideoPricingYt.slice(vm.min, vm.max);
      } else if (isRowPricingInsta(network)) {
        if (pos > 12) {
          vm.min = 8;
          vm.max = 15;
        } else if (pos > 3) {
          vm.min = pos - 3;
          vm.max = pos + 4;
        }
        vm.showedRows = vm.rowPricingIn.slice(vm.min, vm.max);
        vm.showedVideoRows = vm.rowVideoPricingIn.slice(vm.min, vm.max);
      } else {
        if (pos > 13) {
          vm.min = 9;
          vm.max = 16;
        } else if (pos > 3) {
          vm.min = pos - 3;
          vm.max = pos + 4;
        }
        vm.showedRows = vm.rowPricingGA.slice(vm.min, vm.max);
        vm.showedVideoRows = vm.rowVideoPricingGA.slice(vm.min, vm.max);
      }
      if (vm.min > 0 && vm.min < 7) {
        vm.center = vm.min + 3;
        vm.preCenter = vm.min + 2;
        vm.posCenter = vm.min + 4;
      }
    }

    function isRowPricingFbTwPi(network) {
      return lodash.includes(['facebook', 'twitter', 'pinterest'], network);
    }

    function isRowPricingYt(network) {
      return 'youtube' == network;
    }

    function isRowPricingInsta(network) {
      return 'instagram' == network;
    }

    function between(x, min, max) {
      return x >= min && x < max;
    }

    function getSelected(value, network) {
      var redux = Math.floor(value / 1000);
      vm.center = -1;
      if (isRowPricingFbTwPi(network)) {
        vm.center = lodash.findIndex(vm.rowPricingFbTwPi, function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
        vm.posCenter = vm.center < vm.rowPricingFbTwPi.length - 1 ? vm.center + 1 : -1;
      } else if (isRowPricingYt(network)) {
        vm.center = lodash.findIndex(vm.rowPricingYt, function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
        vm.posCenter = vm.center < vm.rowPricingYt.length - 1 ? vm.center + 1 : -1;
      } else if (isRowPricingInsta(network)) {
        vm.center = lodash.findIndex(vm.rowPricingIn, function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
        vm.posCenter = vm.center < vm.rowPricingIn.length - 1 ? vm.center + 1 : -1;
      } else {
        vm.center = lodash.findIndex(vm.rowPricingGA, function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
        vm.posCenter = vm.center < vm.rowPricingGA.length - 1 ? vm.center + 1 : -1;
      }
      vm.preCenter = vm.center > 0 ? vm.center - 1 : -1;

      return vm.center;
    }

    function around(index) {
      return index == vm.preCenter || index == vm.posCenter;
    }

    function isSelected(index) {
      return index == vm.center;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('remainingTime', remainingTime());

  /* @ngInject */
  function remainingTime() {
    var component = {
      templateUrl: 'app/components/remainingTime/remaining.html',
      controller: RemainingTimeController,
      controllerAs: 'vm',
      bindings: {
        startedAt: '<',
        endingIn: '<?',
        orderExpired: '=?'
      }
    };

    return component;
  }

  /* @ngInject */
  function RemainingTimeController($interval) {
    var vm = this;

    vm.promise;
    vm.time = {};
    vm.finish = false;
    vm.orderExpired = false;

    vm.remainingMinutes = remainingMinutes;
    vm.remainingHours = remainingHours;
    vm.isFinishing = isFinishing;
    vm.endingDate = endingDate;

    vm.$onInit = function () {
      vm.endingIn = vm.endingIn || 120;
      updateClock();
    }

    function updateClock() {
      getTimeRemaining(moment(vm.startedAt).add(vm.endingIn, 'hours'));
      stopClock();
      vm.promise = $interval(function () {
        getTimeRemaining(moment(vm.startedAt).add(vm.endingIn, 'hours'))
      }, 1000);
    }

    function stopClock() {
      if (vm.promise) {
        $interval.cancel(vm.promise);
      }
    }

    function remainingMinutes() {
      return (vm.endingIn * 60) - moment(moment()).diff(moment(vm.startedAt), 'minutes');
    }

    function remainingHours() {
      return vm.endingIn - moment(moment()).diff(moment(vm.startedAt), 'hours');
    }

    function isFinishing() {
      return remainingMinutes() < 60;
    }

    function endingDate() {
      return moment(vm.startedAt).add(vm.endingIn, 'hours').calendar()
    }

    function getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      if (t <= 0) {
        stopClock();
        vm.finish = true;
        vm.orderExpired = true
      } else {
        vm.time.seconds = Math.floor((t / 1000) % 60);
        vm.time.minutes = Math.floor((t / 1000 / 60) % 60);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('payments', payments());

  /* @ngInject */
  function payments() {
    var component = {
      templateUrl: 'app/components/payments/payments.html',
      controller: PaymentsController,
      controllerAs: 'vm'
    };

    return component;
  }

  /* @ngInject */
  function PaymentsController($mdDialog, $log, $mdMedia, $state, $scope, $rootScope, $timeout,
    toastr, lodash, StatesService, CountriesService, PaymentsService,
    CreditCardService, RoutesService, OrdersService,
    ERROR_CODES, CHECKOUT, ORDER_CREATED_ORIGIN, CounterService, AccountService, EnvironmentConfig, PUBLISHER_NOT_ACTIVE_TOOLTIP) {
    var vm = this;

    var TRANSACTION_FAILED_MESSAGE = 'Transaction failed. Please check your card details and try again, or email admin@scalefluence.com for help.';

    vm.orders = [];
    vm.remember = true;
    vm.agreed = true;
    vm.ccType;
    vm.country = 'US';
    vm.perPage = 1;
    vm.filtered = [];
    vm.errorLabel = '';
    vm.expDate = {
      month: '',
      year: ''
    };
    vm.ccNumber = '';
    vm.cvvNumber = '';
    vm.zipMask = '';
    vm.defaultCvvMask;
    vm.query = {
      filter: '',
      order: '-domain_authority',
      limit: 5,
      page: 1
    };
    vm.cards = [];
    vm.microform;
    vm.options = {};
    vm.canEditBilling = false;
    vm.canPurchaseContent = false;
    vm.microform = null;
    vm.paymentProcessor = 'cybersource'; // Will be set dynamically from API
    vm.stripe = null;
    vm.stripeElements = null;
    vm.message = '';
    vm.midsourceRequestTimeout = null;
    vm.midsourceValidationError = '';
    vm.midsourceFieldValid = { ccnumber: null, ccexp: null, cvv: null };
    vm.midsourceFieldErrors = { ccnumber: '', ccexp: '', cvv: '' };
    vm.midsourcePaymentSent = false; // guard: only one auth request per payment attempt

    // Accessible functions
    vm.showNewProcessorMsg = showNewProcessorMsg;
    vm.showInfo = showInfo;
    vm.toggleZipMask = toggleZipMask;
    vm.toggleCvvMask = toggleCvvMask;
    vm.toggleCreditCardMask = toggleCreditCardMask;
    vm.submit = submit;
    vm.getTotalPrice = getTotalPrice;
    vm.$mdMedia = $mdMedia;
    vm.checkExpirationDate = checkExpirationDate;
    vm.openMenu = openMenu;
    vm.orderSendBack = orderSendBack;
    vm.creditCardsDialog = creditCardsDialog;
    vm.closeDialog = closeDialog;
    vm.setSelectedCard = setSelectedCard;
    vm.hasStoredCards = hasStoredCards;
    vm.cantPurchase = cantPurchase;
    vm.createdFromSearch = createdFromSearch;
    vm.createdFromQuote = createdFromQuote;
    vm.storedCcExpired = storedCcExpired;
    vm.deselCard = deselCard;
    vm.usingBraintree = usingBraintree;
    vm.usingCybersource = usingCybersource;
    vm.usingStripe = usingStripe;
    vm.usingMidsource = usingMidsource;
    vm.midsourceCardInvalid = midsourceCardInvalid;

    vm.$onInit = function () {
      preInitialize();
    }

    // Find first card matching current processor
    function firstProcessorCard() {
      for (var i = 0; i < vm.cards.length; i++) {
        if (vm.cards[i].processor == vm.paymentProcessor) return vm.cards[i];
      }
      return false;
    }

    function showNewProcessorMsg() {
      // Show message if user has ANY saved cards from a different processor
      // This tells them their old cards won't work with the new processor
      if (vm.allCards && vm.allCards.length > 0) {
        for (var i = 0; i < vm.allCards.length; i++) {
          if (vm.allCards[i].processor != vm.paymentProcessor) return true;
        }
      }
      return false;
    }

    function preInitialize() {
      AccountService.getAdvertiser(function (response) {
        var adv = response.data;
        // check if teammate
        if (adv.parent_id) {
          for (var i = 0; i < adv.roles.length; i++) {
            if (adv.roles[i].name === 'edit_billing') {
              vm.canEditBilling = true;
            } else if(adv.roles[i].name === 'purchase_content') {
              vm.canPurchaseContent = true;
            }
          }
        } else {
          vm.canEditBilling = true;
          vm.canPurchaseContent = true;
        }
        if (vm.canPurchaseContent) {
          initialize();
        } else {
          toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
          RoutesService.dashboard();
        }
      });
    }

    function initialize() {
      CounterService.getAdvCardValues();
      OrdersService.indexOrdersCheckout(function (orderList, response) {
        vm.orders = orderList;
        initializeStep2();
      }, function() {
        toastr.error('There was an error retrieving checkout items.');
      });
    }

    function initializeStep2() {
      // First, get the current processor (backend uses in_checkout orders to determine processor)
      PaymentsService.getCurrentProcessor(function (response) {
        vm.paymentProcessor = response.data.processor;

        CreditCardService.indexCreditCards(function (response) {
          // Store all cards (unfiltered) for showNewProcessorMsg()
          vm.allCards = response.data.credit_cards || [];
          // Filter cards to only show cards matching current processor
          vm.cards = lodash.filter(vm.allCards, function(card) {
            return card.processor == vm.paymentProcessor;
          });
          // vm.selectedCard = lodash.first(vm.cards);
          vm.selectedCard = firstProcessorCard();
          if (vm.usingCybersource()) {
            vm.months = [
              '01','02','03','04','05','06',
              '07','08','09','10','11','12'
            ];
            if (!vm.selectedCard) initializeCybersource();
          } else if (vm.usingStripe()) {
            vm.months = [
              '01','02','03','04','05','06',
              '07','08','09','10','11','12'
            ];
            if (!vm.selectedCard) initializeStripe();
          } else if (vm.usingMidsource()) {
            vm.months = [
              '01','02','03','04','05','06',
              '07','08','09','10','11','12'
            ];
            if (!vm.selectedCard) initializeMidsource();
          } else {
            vm.months = lodash.range(1, 13);
          }
          
          // Set the total amount
          vm.amount = vm.getTotalPrice();
        }, function () {
          toastr.error('There was an error retrieving credit cards.');
        });
      }, function () {
        toastr.error('There was an error retrieving payment processor.');
        // Default to midsource on error
        vm.paymentProcessor = 'midsource';
        initializeStep2Cards();
      });
    }

    function initializeStep2Cards() {
      CreditCardService.indexCreditCards(function (response) {
        // Store all cards (unfiltered) for showNewProcessorMsg()
        vm.allCards = response.data.credit_cards || [];
        // Filter cards to only show cards matching current processor
        vm.cards = lodash.filter(vm.allCards, function(card) {
          return card.processor == vm.paymentProcessor;
        });
        vm.selectedCard = firstProcessorCard();
        if (vm.usingCybersource()) {
          vm.months = [
            '01','02','03','04','05','06',
            '07','08','09','10','11','12'
          ];
          if (!vm.selectedCard) initializeCybersource();
        } else if (vm.usingStripe()) {
          vm.months = [
            '01','02','03','04','05','06',
            '07','08','09','10','11','12'
          ];
          if (!vm.selectedCard) initializeStripe();
        } else if (vm.usingMidsource()) {
          vm.months = [
            '01','02','03','04','05','06',
            '07','08','09','10','11','12'
          ];
          if (!vm.selectedCard) initializeMidsource();
        } else {
          vm.months = lodash.range(1, 13);
        }
        
        // Set the total amount
        vm.amount = vm.getTotalPrice();
      }, function () {
        toastr.error('There was an error retrieving credit cards.');
      });

      vm.years = lodash.range(moment().year(), moment().year() + 20);
      console.log('years', vm.years);
      vm.states = StatesService.getAllUSStates();
      vm.countries = CountriesService.getAllCountries();

      // Watch on change of credit card type to setup the mask
      $scope.$watch('vm.ccType', function () {
        if (vm.ccType) {
          switch (vm.ccType.digits) {
          case 14:
            vm.ccNumberMask = '9999 999999 9999';
            break;
          case 15:
            vm.ccNumberMask = '9999 999999 99999';
            vm.defaultCvvMask = '9999'
            break;
          case 16:
            vm.ccNumberMask = '9999 9999 9999 9999';
            vm.defaultCvvMask = '999'
            break;
          }
        }
      })
    }

    function initializeCybersource() {
      PaymentsService.getCybersourcePaymentToken(function (response) {
        var token = response.data.cybersource_token;
        
        // the capture context that was requested server-side for this transaction
        var captureContext = token;
        // custom styles that will be applied to each field we create using Microform
        var myStyles = {  
          'input': {    
            'font-size': '14px',    
            'font-family': 'helvetica, tahoma, calibri, sans-serif',    
            'color': '#555'  
          },  
          ':focus': { 'color': 'blue' },  
          ':disabled': { 'cursor': 'not-allowed' },  
          'valid': { 'color': '#3c763d' },  
          'invalid': { 'color': '#a94442' }
        };
        // setup Microform
        var flex = new Flex(captureContext);
        vm.microform = flex.microform({ styles: myStyles });
        var number = vm.microform.createField('number', { placeholder: 'Enter card number' });
        var securityCode = vm.microform.createField('securityCode', { placeholder: '•••' });
        number.load('#number-container');
        securityCode.load('#securityCode-container');
      }, function () {

      });
    }

    function initializeMidsource() {
      if (typeof CollectJS === 'undefined') {
        console.error('CollectJS global not available - Collect.js script may not have loaded');
        toastr.error('Payment library not loaded. Please refresh the page.');
        return;
      }

      // Wait for Angular to render the DOM elements before configuring Collect.js
      $scope.$evalAsync(function() {
        var attemptInit = function(attempts) {
          attempts = attempts || 0;
          var ccNumberContainer = document.getElementById('midsource-ccnumber');

          if (ccNumberContainer) {
            try {
              // Configure Collect.js with inline fields
              CollectJS.configure({
                paymentSelector: '#midsource-payment-button',
                variant: 'inline',
                styleSniffer: 'true',
                googleFont: 'Montserrat:400',
                customCss: {
                  'font-size': '14px',
                  'font-family': 'helvetica, tahoma, calibri, sans-serif',
                  'color': '#555',
                  'height': '40px',
                  'border': '1px solid #d1dce3',
                  'border-radius': '6px',
                  'padding': '0 16px',
                  'box-sizing': 'border-box'
                },
                fields: {
                  ccnumber: {
                    selector: '#midsource-ccnumber',
                    title: 'Card Number',
                    placeholder: '0000 0000 0000 0000'
                  },
                  ccexp: {
                    selector: '#midsource-ccexp',
                    title: 'Card Expiration',
                    placeholder: 'MM / YY'
                  },
                  cvv: {
                    selector: '#midsource-cvv',
                    title: 'CVV Code',
                    placeholder: 'CVV'
                  }
                },
                fieldsAvailableCallback: function() {
                  console.log('MIDsource Collect.js fields loaded');
                },
                validationCallback: function(field, status, message) {
                  console.log('Collect.js validation:', field, status, message);
                  $scope.$apply(function() {
                    if (vm.midsourceFieldValid && field) vm.midsourceFieldValid[field] = status;
                    if (vm.midsourceFieldErrors && field) {
                      vm.midsourceFieldErrors[field] = status ? '' : (message || ('Invalid ' + field));
                    }
                    if (status) {
                      var anyInvalid = vm.midsourceFieldValid && (vm.midsourceFieldValid.ccnumber === false || vm.midsourceFieldValid.ccexp === false || vm.midsourceFieldValid.cvv === false);
                      if (!anyInvalid) vm.midsourceValidationError = '';
                    } else {
                      vm.midsourceValidationError = message || ('Invalid ' + field);
                      if (vm.midsourceRequestTimeout) {
                        $timeout.cancel(vm.midsourceRequestTimeout);
                        vm.midsourceRequestTimeout = null;
                      }
                      $rootScope.isLoading = false;
                    }
                  });
                },
                timeoutDuration: 20000,
                timeoutCallback: function() {
                  console.error('MIDsource Collect.js timed out');
                  $scope.$apply(function() {
                    if (vm.midsourceRequestTimeout) { $timeout.cancel(vm.midsourceRequestTimeout); vm.midsourceRequestTimeout = null; }
                    $rootScope.isLoading = false;
                    toastr.error('Payment request timed out. This may be due to an invalid card, network issue, or a browser extension blocking the payment form. Please check your card details, try disabling ad blockers for this site, and try again.');
                  });
                },
                callback: function(response) {
                  console.log('Collect.js callback received:', response);
                  if (vm.midsourceRequestTimeout) { $timeout.cancel(vm.midsourceRequestTimeout); vm.midsourceRequestTimeout = null; }

                  if (response.error) {
                    $scope.$apply(function() {
                      $rootScope.isLoading = false;
                      toastr.error(TRANSACTION_FAILED_MESSAGE);
                    });
                    return;
                  }

                  if (response.errors && response.errors.length > 0) {
                    $scope.$apply(function() {
                      $rootScope.isLoading = false;
                      toastr.error(TRANSACTION_FAILED_MESSAGE);
                    });
                    return;
                  }

                  var paymentToken = response.token;
                  if (paymentToken) {
                    $scope.$apply(function() {
                      if (vm.midsourcePaymentSent) {
                        console.warn('Collect.js callback: already sent payment for this attempt, ignoring duplicate callback');
                        return;
                      }
                      vm.midsourcePaymentSent = true;
                      var cardBillingInfo = {
                        first_name: vm.firstName,
                        last_name: vm.lastName,
                        address: vm.address,
                        address2: vm.address2,
                        city: vm.city,
                        state: vm.state,
                        zip: vm.zipCode,
                        country: vm.country || 'US'
                      };
                      if (response.card) {
                        cardBillingInfo.masked_number = '****' + response.card.number;
                        cardBillingInfo.card_type = response.card.type;
                        cardBillingInfo.exp_month = response.card.exp ? response.card.exp.substring(0, 2) : '';
                        cardBillingInfo.exp_year = response.card.exp ? ('20' + response.card.exp.substring(2, 4)) : '';
                      }
                      $rootScope.isLoading = true;
                      vm.midsourcePaymentToken = paymentToken;
                      vm.midsourceCardResponse = response;
                      sendTokenMidsource(paymentToken, cardBillingInfo);
                    });
                  } else {
                    $scope.$apply(function() {
                      $rootScope.isLoading = false;
                      toastr.error(TRANSACTION_FAILED_MESSAGE);
                    });
                  }
                }
              });
            } catch (error) {
              console.error('Error initializing MIDsource Collect.js:', error);
              toastr.error('Unable to initialize payment form. Please refresh the page.');
            }
          } else if (attempts < 10) {
            $timeout(function() {
              attemptInit(attempts + 1);
            }, 50);
          } else {
            console.error('MIDsource card element container not found in DOM after multiple attempts');
            toastr.error('Unable to initialize payment form. Please refresh the page.');
          }
        };

        attemptInit();
      });
    }

    function initializeStripe() {
      // Note: We don't actually need a client secret for PaymentMethod creation flow
      // Stripe Elements can be initialized without it when creating PaymentMethods
      var publishableKey = EnvironmentConfig.STRIPE_PUBLISHABLE_KEY;
      
      if (!publishableKey) {
        toastr.error('Stripe publishable key not configured.');
        return;
      }
      
      // Initialize Stripe
      if (typeof Stripe === 'undefined') {
        toastr.error('Stripe.js library not loaded.');
        return;
      }
      
      vm.stripe = Stripe(publishableKey);
      // Initialize Elements without client secret - we'll create PaymentMethod directly
      vm.stripeElements = vm.stripe.elements();
      
      // Wait for Angular to render the DOM element before mounting
      // The element is inside an ng-if block, so we need to wait for it to exist
      // Use $evalAsync to wait for the next digest cycle, then check for element
      $scope.$evalAsync(function() {
        // Try to find the element, with a fallback timeout if it's still not there
        var attemptMount = function(attempts) {
          attempts = attempts || 0;
          var cardElementContainer = document.getElementById('stripe-card-element');
          
          if (cardElementContainer) {
            // Element exists, mount Stripe Elements
            try {
              // Create card element
              var cardElement = vm.stripeElements.create('card', {
                style: {
                  base: {
                    fontSize: '14px',
                    fontFamily: 'helvetica, tahoma, calibri, sans-serif',
                    color: '#555'
                  }
                }
              });
              
              // Mount card element
              cardElement.mount('#stripe-card-element');
              
              // Store card element for later use
              vm.stripeCardElement = cardElement;
              
              // Handle validation errors
              cardElement.on('change', function(event) {
                var displayError = document.getElementById('stripe-card-errors');
                if (displayError) {
                  if (event.error) {
                    displayError.textContent = event.error.message;
                  } else {
                    displayError.textContent = '';
                  }
                }
              });
            } catch (error) {
              console.error('Error mounting Stripe card element:', error);
              toastr.error('Unable to initialize payment form. Please refresh the page.');
            }
          } else if (attempts < 10) {
            // Element not found yet, try again after a short delay
            $timeout(function() {
              attemptMount(attempts + 1);
            }, 50);
          } else {
            // Element still not found after multiple attempts
            console.error('Stripe card element container not found in DOM after multiple attempts');
            toastr.error('Unable to initialize payment form. Please refresh the page.');
          }
        };
        
        attemptMount();
      });
    }

    function createdFromSearch(order) {
      return order && order.created_from === ORDER_CREATED_ORIGIN.SEARCH;
    }

    function createdFromQuote(order) {
      return order && _.includes([ORDER_CREATED_ORIGIN.QUOTE, ORDER_CREATED_ORIGIN.ARTICLE], order.created_from);
    }

    function getTotalPrice() {
      var price = 0;
      lodash.map(vm.orders, function (order) {
        price += order.amount;
      });
      return price;
    }

    function toggleZipMask() {
      if (!vm.zipMask) {
        vm.zipMask = '99999';
      } else if (!vm.zipCode) {
        vm.zipMask = '';
      }
    }

    function toggleCreditCardMask() {
      if (!vm.ccNumberMask) {
        vm.ccNumberMask = '9999 9999 9999 9999';
      } else if (!vm.ccNumber) {
        vm.ccNumberMask = '';
      }
    }

    function toggleCvvMask() {
      if (!vm.cvvMask || vm.cvvNumber) {
        vm.cvvMask = vm.defaultCvvMask || '999?9';
      } else if (!vm.cvvNumber) {
        vm.cvvMask = '';
      }
    }

    function showInfo() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('CVV number')
        .textContent("The CVV Number (\"Card Verification Value\") on your credit card or debit card is a 3 digit number on VISA®, MasterCard® and Discover® branded credit and debit cards. On your American Express® branded credit or debit card it is a 4 digit numeric code.")
        .ariaLabel('Notes')
        .ok('Got it!')
      );
    }

    function submit() {
      if (lodash.some(vm.orders, 'publisher_not_active')) {
        toastr.error(PUBLISHER_NOT_ACTIVE_TOOLTIP);
        return;
      }
      vm.selectedCard ? storedPaymentMethod() : newPaymentMethod();
    }

    function storedPaymentMethod() {
      if (storedCcExpired()) {
        showStoredCcExpiredAlert();
        CreditCardService.deleteCreditCard(vm.selectedCard.id, function() {
          toastr.success('Successfully deleted the credit card');
        }, function() {
          toastr.error('There was a problem deleting the credit card, but you may continue now with a new card. You may try deleting your old card later through "My Accoun Info"');
        });
        vm.selectedCard = null;
      } else {
        if (vm.usingStripe()) {
          // For Stripe, use PaymentMethod ID directly
          var cardBillingInfo = {
            first_name: vm.selectedCard.cardholder_name.split(' ')[0] || '',
            last_name: vm.selectedCard.cardholder_name.split(' ').slice(1).join(' ') || '',
            address: vm.selectedCard.street_address || '',
            address2: vm.selectedCard.extended_address || '',
            city: vm.selectedCard.city || '',
            state: vm.selectedCard.state || '',
            zip: vm.selectedCard.zip_code || '',
            country: vm.selectedCard.country_name || 'US'
          };
          sendTokenStripe(vm.selectedCard.token, cardBillingInfo);
        } else if (vm.usingMidsource()) {
          // For MIDsource, use customer vault ID stored as token
          var cardBillingInfo = {
            first_name: vm.selectedCard.cardholder_name.split(' ')[0] || '',
            last_name: vm.selectedCard.cardholder_name.split(' ').slice(1).join(' ') || '',
            address: vm.selectedCard.street_address || '',
            address2: vm.selectedCard.extended_address || '',
            city: vm.selectedCard.city || '',
            state: vm.selectedCard.state || '',
            zip: vm.selectedCard.zip_code || '',
            country: vm.selectedCard.country_name || 'US'
          };
          sendTokenMidsource(vm.selectedCard.token, cardBillingInfo);
        } else {
          createPayment(lodash.map(vm.orders, 'id'), null, vm.selectedCard.token);
        }
      }
    }

    function newPaymentMethodBraintree() {
      PaymentsService.getPaymentToken(function (response) {
        var creditCard = {
          number: vm.ccNumber,
          cardholderName: vm.firstName + ' ' + vm.lastName,
          expirationMonth: vm.expDate.month,
          expirationYear: vm.expDate.year,
          cvv: vm.cvvNumber,
          billingAddress: {
            postalCode: vm.zipCode,
            firstName: vm.firstName,
            lastName: vm.lastName,
            streetAddress: vm.address,
            countryName: vm.country,
            locality: vm.city,
            region: vm.state
          }
        }
        if (angular.isDefined(vm.address2)) {
          creditCard.billingAddress.extendedAddress = vm.address2;
        }
        sendTokenBraintree(response.data.token, creditCard);
      }, function () {
        $log.error('There was an error getting token.');
      });
    }

    function newPaymentMethodCybersource() {
     var cardBillingInfo = {
        first_name: vm.firstName,
        last_name: vm.lastName,
        address: vm.address,
        address2: vm.address2,
        city: vm.city,
        state: vm.state,
        zip: vm.zipCode,
        country: vm.country,
        exp_month: document.querySelector('#expMonth').value,
        exp_year: document.querySelector('#expYear').value
      }
      // Compiling MM & YY into optional paramiters	 
      var options = {    
        expirationMonth: document.querySelector('#expMonth').value,  
        expirationYear: document.querySelector('#expYear').value 
      };              
      vm.microform.createToken(options, function (err, token) {
        if (err) {
          // handle error
          var msg = err.message;
          if (err.details) {
            for (var i = 0; i < err.details.length; i++) {
              if (err.details[i].location && err.details[i].message) {
                msg += ' - ' + err.details[i].location + ': ' + err.details[i].message
              }
            }
          }
          console.error(err);
          toastr.error(msg);
        } else {
          // At this point you may pass the token back to your server as you wish.     
          console.log(JSON.stringify(token));
          sendTokenCybersource(JSON.stringify(token), cardBillingInfo);
        }
      });
    }

    function newPaymentMethodStripe() {
      var cardBillingInfo = {
        first_name: vm.firstName,
        last_name: vm.lastName,
        address: vm.address,
        address2: vm.address2,
        city: vm.city,
        state: vm.state,
        zip: vm.zipCode,
        country: vm.country || 'US'
      };
      
      $rootScope.isLoading = true;
      
      // Create PaymentMethod from card element
      vm.stripe.createPaymentMethod({
        type: 'card',
        card: vm.stripeCardElement,
        billing_details: {
          name: vm.firstName + ' ' + vm.lastName,
          address: {
            line1: vm.address,
            line2: vm.address2,
            city: vm.city,
            state: vm.state,
            postal_code: vm.zipCode,
            country: vm.country || 'US'
          }
        }
      }).then(function(result) {
        if (result.error) {
          $rootScope.isLoading = false;
          var displayError = document.getElementById('stripe-card-errors');
          displayError.textContent = result.error.message;
          toastr.error(result.error.message);
        } else {
          // PaymentMethod created successfully, send to backend
          sendTokenStripe(result.paymentMethod.id, cardBillingInfo);
        }
      });
    }

    function newPaymentMethodMidsource() {
      // If we already know a required field is invalid (from validationCallback on blur), show that error and do not start loading or timeout.
      var knownInvalid = vm.midsourceFieldValid && (vm.midsourceFieldValid.ccnumber === false || vm.midsourceFieldValid.ccexp === false || vm.midsourceFieldValid.cvv === false);
      if (knownInvalid) {
        toastr.error(vm.midsourceValidationError || 'Please fix the card errors above.');
        return;
      }
      vm.midsourceValidationError = '';
      vm.midsourcePaymentSent = false; // allow one send for this attempt
      // Collect.js intercepts the same button and handles tokenization. We set loading and a safety timeout only for real hangs (e.g. network, ad blocker).
      $rootScope.isLoading = true;
      vm.midsourceRequestTimeout = $timeout(function() {
        vm.midsourceRequestTimeout = null;
        $rootScope.isLoading = false;
        toastr.error('Payment request timed out. If the form does not respond, try refreshing the page or disabling ad blockers for this site, then try again.');
      }, 20000);
    }

    function newPaymentMethod() {
      if (vm.usingBraintree()) return newPaymentMethodBraintree();
      else if (vm.usingCybersource()) return newPaymentMethodCybersource();
      else if (vm.usingStripe()) return newPaymentMethodStripe();
      else if (vm.usingMidsource()) return newPaymentMethodMidsource();
    }

    function sendTokenBraintree(token, cardInfo) {
      $rootScope.isLoading = true;
      if (token == null) {
        toastr.error('There was an error creating a token');
        $log.error('Token is null');
        return;
      }
      var client = new braintree.api.Client({
        clientToken: token
      });

      if (client) {
        client.tokenizeCard(cardInfo, function (err, nonce) {
          if (err) {
            $log.error(err);
            toastr.error(err);
            return;
          }
          createPayment(lodash.map(vm.orders, 'id'), nonce, null);
        });
      } else {
        $log.error('There was an error contacting the payment gateway.');
        toastr.error('There was an error connecting the payment gateway. Please try againg in a few minutes.');
      }
    }

    function sendTokenCybersource(token,cardBillingInfo ) {
      PaymentsService.authCybersourcePayment( token, lodash.map(vm.orders, 'id'), vm.remember, cardBillingInfo, function (response) {
        console.log('response', response);
        if(response.data.message)
          vm.message = response.data.message;
        CounterService.getAdvCardValues();
        showDialogMessage('Thank you for your patronage!',
          'Please allow 5 days for Publishers to accept or decline your order.' +
          'The charge today will be pending during this time. For any publishers ' +
          'that reject your order, we will automatically void that portion of today\'s order.<br><br>' +
           vm.message);
        // MAYBE we want to run: removeFromCheckout(ordersIds, success, fail)...
        // but orders in checkout must be in pending state PLUS have in_checkout flag
        // so just like cart items (pre checkout) even if in_checkout flag remains they should
        // no longer actually be considered in checkout items so no need to removeFromCheckout
        OrdersService.indexOrders(function () {
          RoutesService.dashboard();
        });
      }, function (err) {
        toastr.error(err.data.error);
      })
    }

    function sendTokenMidsource(paymentToken, cardBillingInfo) {
      PaymentsService.authMidsourcePayment(paymentToken, lodash.map(vm.orders, 'id'), vm.remember, cardBillingInfo, function (response) {
        $rootScope.isLoading = false;
        console.log('response', response);
        if(response.data && response.data.message)
          vm.message = response.data.message;
        CounterService.getAdvCardValues();
        showDialogMessage('Thank you for your patronage!',
          'Please allow 5 days for Publishers to accept or decline your order.' +
          'The charge today will be pending during this time. For any publishers ' +
          'that reject your order, we will automatically void that portion of today\'s order.<br><br>' +
           vm.message);
        OrdersService.indexOrders(function () {
          RoutesService.dashboard();
        });
      }, function (err) {
        $rootScope.isLoading = false;
        if ((err.status === -1 || err.status === 0) && (err.message || err.statusText || '').toLowerCase().indexOf('timeout') !== -1) {
          toastr.error('Request timed out. Please check your card and try again.');
        } else {
          toastr.error(TRANSACTION_FAILED_MESSAGE);
        }
      });
    }

    function sendTokenStripe(paymentMethodId, cardBillingInfo) {
      PaymentsService.authStripePayment(paymentMethodId, lodash.map(vm.orders, 'id'), vm.remember, cardBillingInfo, function (response) {
        console.log('response', response);
        if(response.data.message)
          vm.message = response.data.message;
        CounterService.getAdvCardValues();
        showDialogMessage('Thank you for your patronage!',
          'Please allow 5 days for Publishers to accept or decline your order.' +
          'The charge today will be pending during this time. For any publishers ' +
          'that reject your order, we will automatically void that portion of today\'s order.<br><br>' +
           vm.message);
        OrdersService.indexOrders(function () {
          RoutesService.dashboard();
        });
      }, function (err) {
        $rootScope.isLoading = false;
        toastr.error(err.data.error || 'There was an error processing your payment.');
      });
    }

    function createPayment(ordersIds, payment_nonce, token) {
      PaymentsService.payment(payment_nonce, token, ordersIds, lastCCFourDigits(), vm.remember,
        function () {
          CounterService.getAdvCardValues();
          showDialogMessage('Thank you for your patronage!',
            'Please allow 5 days for Publishers to accept or decline your order.' +
            'The charge today will be pending during this time. For any publishers ' +
            'that reject your order, we will automatically void that portion of today\'s order.');
          // MAYBE we want to run: removeFromCheckout(ordersIds, success, fail)...
          // but orders in checkout must be in pending state PLUS have in_checkout flag
          // so just like cart items (pre checkout) even if in_checkout flag remains they should
          // no longer actually be considered in checkout items so no need to removeFromCheckout
          OrdersService.indexOrders(function () {
            RoutesService.dashboard();
          });
        },
        function (response) {
          if (angular.isUndefined(response.data.errors)) {
            vm.errorLabel = "Sorry, there was an error billing your card. Please try updating your card on file or using a new card.";
          } else if(response.data.errors.masked_number) {
            toastr.error('IMPORTANT! You are trying to save a Credit Card that already exists. Please email admin@scalefluence.com immediately to resolve the issue.');
          } else {
            var error = parseInt(response.data.errors[0].code);
            switch (error) {
            case 2000:
              vm.errorLabel = "Your bank is unwilling to accept the transaction. Please contact your bank."
              break;
            case 2001:
              vm.errorLabel = "The account did not have " +
                "sufficient funds to cover the transaction amount."
              break;
            case 2004:
              vm.errorLabel = "The Credit Card was determined to be expired."
              break;
            case 2005:
            case 81717:
            case 81715:
              vm.errorLabel = "The Credit Card Number is invalid. " +
                "Please double check and edit your card number. Thank you."
              break;
            default:
              vm.errorLabel = "We validate billing zip code, CVV, and expiration date. " +
                "If those are wrong, it will decline. If they are correct, " +
                "you need to check with your financial instution. They may likely be blocking this transaction."
            }
          }
        });
    }

    function showDialogMessage(title, message) {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title(title)
        .htmlContent(message)
        .ok('Got it!')
      );
    }

    function cantPurchase() {
      return !vm.agreed || angular.isUndefined(vm.orders) ||
        vm.orders.length === 0 ||
        lodash.some(vm.orders, 'publisher_not_active');
    }

    function checkExpirationDate() {
      if (vm.expDate.month && vm.expDate.year) {
        var toDay = new Date(moment().year() + '-' + (moment().month() + 1));
        var date = new Date(vm.expDate.year + '-' + vm.expDate.month);
        $scope.paymentForm.expDateMonth.$setValidity('past', date >= toDay);
      }
    }

    function lastCCFourDigits() {
      return vm.ccNumber.slice(vm.ccNumber.length - 4);
    }

    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function orderSendBack(order) {
      OrdersService.removeFromCheckout([order.id], function() {
        vm.amount = vm.amount - order.amount
        for (var i = 0; i < vm.orders.length; i++) {
          if (vm.orders[i].id == order.id) {
            vm.orders.splice(i, 1);
          }
        }
        if (vm.orders.length == 0) {
          toastr.info('No more items to checkout.');
          $state.go('cart');
          // trusting that CounterService.getAdvCardValues()
          // will be run upon cart state initialization
        } else {
          CounterService.getAdvCardValues();
        }
      }, function() {
        $log.error('Error sending order back to cart.');
      });
    }

    function creditCardsDialog() {
      $mdDialog.show({
        contentElement: '#myDialog',
        parent: angular.element(document.body),
        clickOutsideToClose: false
      });
    }

    function closeDialog() {
      vm.selectedCardId = null;
      $mdDialog.cancel();
    }

    function hasStoredCards() {
      return vm.cards && vm.cards.length > 0 && firstProcessorCard();
    }

    function setSelectedCard() {
      vm.selectedCard = lodash.find(vm.cards, function (card) {
        return card.id == vm.selectedCardId;
      })
      vm.selectedCardId = null;
      $mdDialog.hide();
    }

    function storedCcExpired() {
      var toDay = new Date(moment().year() + '-' + (moment().month() + 1));
      var date = new Date(vm.selectedCard.year + '-' + vm.selectedCard.month);
      return date < toDay;
    }

    function showStoredCcExpiredAlert() {
      $mdDialog.show(
        $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Expired Credit Card')
        .textContent("CARD ON FILE HAS EXPIRED AND IS BEING REMOVED. PLEASE ADD NEW CARD TO COMPLETE PURCHASE. THANK YOU!")
        .ariaLabel('Notes')
        .ok('Got it!')
        );
      }

    function deselCard() {
      if (vm.canEditBilling) {
        vm.selectedCard = null;
        if (vm.usingCybersource()) {
          initializeCybersource();
        } else if (vm.usingStripe()) {
          initializeStripe();
        } else if (vm.usingMidsource()) {
          initializeMidsource();
        }
      } else {
        toastr.error(EnvironmentConfig.ADV_NOT_AUTHORIZED_MSG);
      }
    }

    function usingBraintree() {
      return vm.paymentProcessor === 'braintree';
    }

    function usingCybersource() {
      return vm.paymentProcessor === 'cybersource';
    }

    function usingStripe() {
      return vm.paymentProcessor === 'stripe';
    }

    function usingMidsource() {
      return vm.paymentProcessor === 'midsource';
    }

    // True when Midsource new-card form has validation errors or required fields not yet valid
    function midsourceCardInvalid() {
      if (!vm.usingMidsource() || vm.selectedCard) return false;
      var v = vm.midsourceFieldValid;
      if (!v) return true;
      return v.ccnumber !== true || v.ccexp !== true || v.cvv !== true;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('newSite', newSite());

  /** @ngInject */
  function newSite() {
    var component = {
      templateUrl: 'app/components/newSite/newSite.html',
      controller: NewSiteController,
      controllerAs: 'vm',
      bindings: {
        campaign: '=',
        showCategories: '=',
        cannotSelectCampaign: '=',
        showComponent: '=',
        onChange: '&?'
      }
    };

    return component;
  }

  /** @ngInject */
  function NewSiteController($scope, $log, $state, $mdDialog, lodash, toastr, CampaignsService) {
    var vm = this;

    // Accessible attributes
    vm.csv;
    vm.campaigns = [];
    vm.categories = [];
    vm.campaignUrl;
    vm.selectedCampaign;

    // Accessible functions
    vm.submit = submit;
    vm.clearCsv = clearCsv;
    vm.getSelectedCampaign = getSelectedCampaign;
    vm.isSelectedCategoriesEmpty = isSelectedCategoriesEmpty;
    vm.showDialog = showDialog;

    initialize();

    // Functions
    function initialize() {
      CampaignsService.indexCampaigns(function (response) {
        vm.campaigns = response.data.campaigns;
        if(angular.isDefined(vm.showCategories)) {
          vm.showCategories = vm.showCategories;
        }
        if (angular.isDefined(vm.campaign.id) && vm.campaign.id != '') {
          vm.selectedCampaign = lodash.find(vm.campaigns, function (cam) {
            return cam.id == vm.campaign.id;
          });
        }
      }, function () {
        $log.error('Error retrieving your campaigns.');
        toastr.error('There was an error retrieving your campaigns.');
      });
    }

    function getSelectedCampaign() {
      if (angular.isDefined(vm.selectedCampaign)) {
        vm.categories = vm.selectedCampaign.categories;
        return vm.selectedCampaign.name;
      } else {
        return 'Please select a campaign';
      }
    }

    function submit() {
      vm.selectedCampaign.url = vm.campaignUrl;
      vm.selectedCampaign.categories = vm.categories;
      vm.showComponent = false;
      if (vm.csv) {
        vm.selectedCampaign.csv = vm.csv;
        delete vm.selectedCampaign.url;
      } else if(angular.isDefined(vm.campaignUrl)) {
          clearCsv();
          delete vm.selectedCampaign.csv;
      }
      CampaignsService.updateCampaign(vm.selectedCampaign.id, vm.selectedCampaign,
        function () {
          vm.onChange();
          $state.go('manage-campaign', { campaignId: vm.selectedCampaign.id });
          toastr.success('Site successfuly added.');
        },
        function () {
          $log.error('Error submiting new site.');
          toastr.error('There was a problem while submiting the new site. Please retry.');
        });
    }

    function clearCsv() {
      vm.csv = null;
    }

    function isSelectedCategoriesEmpty() {
      if(vm.showCategories) {
        return false;
      }
      return vm.categories.length == 0;
    }

    function showDialog() {
      $mdDialog.show({
        controller: 'ModalCampaignController',
        controllerAs: 'modCampCtrl',
        templateUrl: 'app/pages/campaigns/modalCampaign/modalCampaign.html',
        clickOutsideToClose: true
      }).then(function (uploadedFile) {
        vm.csv = uploadedFile;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('imageSelector', imageSelector());

  /* @ngInject */
  function imageSelector() {
    var component = {
      templateUrl: 'app/components/imageSelector/imageSelector.html',
      controller: ImageSelectorController,
      controllerAs: 'vm',
      bindings: {
        image: '=',
        edit: '<',
        showBlankImage: '<',
        ngDisabled: '=ngDisabled'
      }
    };

    return component;
  }

  /* @ngInject */
  function ImageSelectorController($mdDialog, $scope, lodash, Upload) {
    var vm = this;
    vm.croppedDataUrl = '';

    // Accessible functions
    vm.hide = hide;
    vm.select = select;
    vm.cancel = cancel;
    vm.lastImage = lastImage;
    vm.imageChange = imageChange;

    vm.$onInit = function () {
      if (angular.isUndefined(vm.edit)) {
        vm.edit = false;
      }
    }

    // Functions
    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function select() {
      vm.showBlankImage = false;
      vm.result = vm.croppedDataUrl;
      vm.image = Upload.dataUrltoBlob(vm.result, 'profile_avatar' + Math.random() + '.jpeg');
      $mdDialog.hide();
    }

    function lastImage() {
      return lodash.last(vm.images);
    }

    function imageChange(files, file, newFiles, duplicateFiles, invalidFiles, evt) {
      vm.imageTemp = newFiles[0];
      $mdDialog.show({
        contentElement: '#cropper',
        parent: angular.element(document.body),
        targetEvent: evt,
        clickOutsideToClose: true,
        preserveScope: true,
        autoWrap: true,
        skipHide: true
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('grid', grid());

  /* @ngInject */
  function grid() {
    var component = {
      templateUrl: 'app/components/grid/grid.html',
      controller: GridController,
      controllerAs: 'vm',
      bindings: {
        trustFlow: '<',
        domainAuthority: '<'
      }
    };

    return component;
  }

  /* @ngInject */
  function GridController($scope, lodash) {
    var vm = this;

    ////////// Attributes //////////
    vm.rows = 9;
    vm.around = [];
    vm.matrix = [
      ['  ', '10', '20', '30', '40', '50', '60', '70', '80', '90'],
      ['20', '$30', '$50', '$70', '$90', '$110', '$125', '$150', '$175', '$200'],
      ['30', '$50', '$70', '$90', '$110', '$125', '$150', '$175', '$200', '$250'],
      ['40', '$70', '$90', '$110', '$125', '$150', '$175', '$200', '$250', '$300'],
      ['50', '$90', '$110', '$125', '$150', '$175', '$200', '$250', '$300', '$350'],
      ['60', '$110', '$125', '$150', '$175', '$200', '$250', '$300', '$350', '$400'],
      ['70', '$125', '$150', '$175', '$200', '$250', '$300', '$350', '$400', '$450'],
      ['80', '$150', '$175', '$200', '$250', '$300', '$350', '$400', '$450', '$500'],
      ['90', '$175', '$200', '$250', '$300', '$350', '$400', '$450', '$500', '$600']
    ];

    ////////// Accessible functions //////////
    vm.isAround = isAround;
    vm.isTarget = isTarget;

    ////////// Functions //////////
    vm.$onInit = function () {
      vm.trustFlow = Math.floor(vm.trustFlow / 10) * 10;
      vm.domainAuthority = Math.floor(vm.domainAuthority / 10) * 10;

      vm.posX = lodash.findIndex(vm.matrix[0], function (trustFlow) {
        return trustFlow == vm.trustFlow;
      });

      vm.posY = lodash.findIndex(vm.matrix, function (row) {
        return row[0] == vm.domainAuthority;
      });

      vm.posTarget = ((vm.posY - 1) * vm.rows) + vm.posX + vm.posY - 1;
      vm.around = getAround();
    }

    function isAround(pos) {
      return lodash.findIndex(vm.around, function (id) {
        return pos == id;
      }) != -1;
    }

    function isTarget(id) {
      return id == vm.posTarget;
    }

    function getAround() {
      var around = new Array(8);
      around[0] = vm.posTarget - vm.rows - 2;
      around[1] = vm.posTarget - vm.rows - 1;
      around[2] = vm.posTarget - vm.rows;
      around[3] = vm.posTarget - 1;
      around[4] = vm.posTarget + 1;
      around[5] = vm.posTarget + vm.rows;
      around[6] = vm.posTarget + vm.rows + 1;
      around[7] = vm.posTarget + vm.rows + 2;
      return around;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('fileUploadDialog', fileUploadDialog());

  /* @ngInject */
  function fileUploadDialog() {
    var component = {
      templateUrl: 'app/components/fileUploadDialog/fileUploadDialog.html',
      controller: FileUploadDialogController,
      controllerAs: 'vm',
      bindings: {
        title: '@',
        fileExt: '@'
      }
    };

    return component;
  }

  /* @ngInject */
  function FileUploadDialogController($mdDialog) {
    var vm = this;

    vm.submit = submit;
    vm.cancel = cancel;
    vm.getInputLabel = getInputLabel;

    vm.$onInit = function () {
      if (!vm.fileExt) {
        vm.fileExt = '.xlsx';
      }
      if (!vm.fileMax) {
        vm.fileMax = '25MB';
      }
      if (!vm.fileName) {
        vm.fileName = 'upload';
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function submit() {
      $mdDialog.hide(vm.file);
    }

    function getInputLabel() {
      return !vm.file ? 'Select a file to upload' : 'Selected file name';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('chipsInput', chipsInput());

  /* @ngInject */
  function chipsInput() {
    var component = {
      templateUrl: 'app/components/filterComponentInput/chipsInput.html',
      controller: ChipsInputController,
      controllerAs: 'vm',
      bindings: {
        categories: '=ngModel',
        placeholder: '@',
        subtitle: '@',
        search: '&?',
        onChange: '&?',
        hideCategories: '<',
        hideToggle: '<'
      }
    };

    return component;
  }

  /* @ngInject */
  function ChipsInputController($log, $scope, $mdMedia, lodash, toastr, CategoriesService) {
    var vm = this;

    // Accessible attributes
    vm.mCategories = [];

    // Accessible functions
    vm.isSelected = isSelected;
    vm.querySearch = querySearch;
    vm.toggleCategory = toggleCategory;
    vm.$mdMedia = $mdMedia;
    vm.onAdd = onAdd;
    vm.onRemove = onRemove;
    vm.chipName = chipName;
    vm.checkChips = checkChips;
    vm.toggleCatList = toggleCatList;

    // Functions
    vm.$onInit = function () {
      vm.calls = 0;
      vm.hasChanged = false;
      CategoriesService.indexCategories(function (response) {
        vm.mCategories = lodash.orderBy(response.data.categories, function (cat) {
          return cat.name.toLowerCase();
        }, ['asc']);
      }, function () {
        $log.error('Error retrieving the categories.');
        toastr.error('There was an error retrieving the categories.');
      });

      if (angular.isDefined(vm.onChange)) {
        $scope.$watchCollection('vm.categories', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            vm.onChange();
            vm.hasChanged = vm.calls++ > 0 && oldValue.length !== 0;
          }
        });
      }
    }

    function checkChips(criteria) {
      if (criteria !== '' && criteria.length >= 2) {
        var newObject = {
          name: onAdd,
          category: 'user'
        };
        vm.searchText = '';
        onAdd(criteria, false);
      } else {
        vm.searchText = '';
      }
    }

    function isSelected(category) {
      return lodash.findIndex(vm.categories, ['name', category.name]) >= 0;
    }

    function toggleCategory(category) {
      var pos = lodash.findIndex(vm.categories, ['name', category.name]);
      (pos < 0) ? vm.categories.push(category): vm.categories.splice(pos, 1);
    }

    function querySearch(criteria) {
      var res = vm.mCategories.filter(createFilterFor(criteria));
      res.map(function (item) {
        var uppercaseQuery = angular.uppercase(criteria);
        var upperKeyword = item.keyword && angular.uppercase(item.keyword);
        if (upperKeyword && (upperKeyword.indexOf(uppercaseQuery) !== -1)) {
          item.byKeywords = true;
          var keywordArray = item.keyword.split(', ');
          keywordArray = keywordArray.filter(keywordsFilter(criteria));
          keywordArray.forEach(function (keyItem) {
            var currentItem = Object.assign({}, item);
            currentItem.activeKey = keyItem;
            delete currentItem.$$hashKey;
            res.push(currentItem);
          });
          res = res.filter(function (element) {
            return (!element.byKeywords || element.activeKey)
          });
        }
      });
      return res;
    }

    function createFilterFor(query) {
      var uppercaseQuery = angular.uppercase(query);
      return function filterFn(category) {
        var upperKeyword = category.keyword && angular.uppercase(category.keyword);
        var nameResult = category.name && (category.name.indexOf(uppercaseQuery) !== -1);
        var keyResult = upperKeyword && (upperKeyword.indexOf(uppercaseQuery) !== -1);
        return nameResult || keyResult;
      }
    }

    function keywordsFilter(query) {
      var uppercaseQuery = angular.uppercase(query);
      return function filterFunction(keyword) {
        var upperKeyword = keyword && angular.uppercase(keyword);
        return upperKeyword.indexOf(uppercaseQuery) !== -1;
      }
    }

    function onAdd(chip, manuallyAdded) {
      if (manuallyAdded) {
        vm.categories.splice(vm.categories.length - 1, 1);
      }
      if (angular.isDefined(chip.name)) {
        var duplicate = false;
        var pos = lodash.findIndex(vm.categories, ['name', chip.name]);
        if ((pos > 0) && (vm.categories[pos].activeKey === chip.activeKey)) {
          duplicate = true;
        }
        (duplicate) ? vm.categories.splice(pos, 1) : vm.categories.push(chip);
      } else if(!checkIfLabeled(chip)) {
        var newObject = {
          name: chip,
          category: 'user'
        };
        var pos = lodash.findIndex(vm.categories, ['name', chip]);
        if (pos < 0) {
          vm.categories.push(newObject);
        }
      }
    }

    function checkIfLabeled(chip) {
      var pos = lodash.findIndex(vm.mCategories, ['name', angular.uppercase(chip)]);
      if(pos >= 0) { vm.categories.push(vm.mCategories[pos]) };
      return pos >= 0;
    }

    function onRemove(chip) {
      var pos = lodash.findIndex(vm.categories, ['name', chip]);
    }

    function chipName(chip) {
      if (chip.byKeywords && chip.activeKey) {
        return chip.activeKey;
      } else {
        return (angular.isDefined(chip.name)) ? chip.name : chip;
      }
    }

    function toggleCatList() {
      vm.hideCategories = !vm.hideCategories;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('fileChooser', fileChooser());

  /* @ngInject */
  function fileChooser() {
    var component = {
      templateUrl: 'app/components/fileChooser/fileChooser.html',
      controller: FileChooserController,
      controllerAs: 'vm',
      bindings: {
        file: '=',
        fileName: '@',
        fileExt: '@',
        fileMax: '@',
        disable: '=ngDisabled',
        label: '@',
        text: '@',
        smaller: '@',
        smallInput: '@'
      }
    };

    return component;
  }
  /* @ngInject */
  function FileChooserController() {
    var vm = this;

    // Accessible functions
    vm.clearFile = clearFile;

    // Functions
    vm.$onInit = function () {}

    function clearFile() {
      vm.file = null;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('elementsSelector', elementsSelector());

  /* @ngInject */
  function elementsSelector() {
    var component = {
      templateUrl: 'app/components/elementsSelector/elementsSelector.html',
      controller: ElementsSelectorController,
      controllerAs: 'vm',
      bindings: {
        mElements: '<',
        elements: '=ngModel',
        elementsLimit: '@',
        selectorTitle: '@',
        placeholder: '@',
        onChange: '&?',
        hideInput: '@',
        textToShow: '@?',
        hasChanged: '=?',
        hideElements: '<',
        accentButton: '<',
        customButtonText: '@?',
        showOwnHideButton: '<',
        shrinked: '<',
        storageKeyName: '@',
        editProfileMode: '@',
        infoText: '@',
        highlightBlankAudienceFields: '<'
      }
    };

    return component;
  }

  /* @ngInject */
  function ElementsSelectorController($log, $scope, $mdMedia, lodash, toastr, StorageService) {
    var vm = this;
    // Accessible attributes
    if (!vm.editProfileMode) vm.elements = StorageService.get(vm.storageKeyName) || [];
    vm.elementsLimit = parseInt(vm.elementsLimit);

    // Accessible functions
    vm.isSelected = isSelected;
    vm.toggleElement = toggleElement;
    vm.$mdMedia = $mdMedia;
    vm.buttonText = buttonText;
    vm.toggleCatList = toggleCatList;
    vm.toggleBtnText = toggleBtnText;

    // Functions
    vm.$onInit = function () {
      vm.calls = 0;
      vm.hasChanged = false;
      vm.mElements = lodash.orderBy(vm.mElements, function (eth) {
        return eth.toLowerCase();
      }, ['asc']);
      initOnChange();
    };

    function initOnChange() {
      if (angular.isDefined(vm.onChange)) {
        $scope.$watchCollection('vm.elements', function (newValue, oldValue) {
          if (newValue && newValue !== oldValue && oldValue !== undefined) {
            vm.onChange();
            vm.hasChanged = ++vm.calls > 0;
          }
        });
      }
    }

    function isSelected(element) {
      return lodash.findIndex(vm.elements, function(o) { return o === element; }) >= 0;
    }

    function toggleElement(element) {
      var pos = lodash.findIndex(vm.elements, function(o) { return o === element; });
      (pos < 0) ? vm.elements.push(element): vm.elements.splice(pos, 1);
      StorageService.set(vm.storageKeyName, vm.elements);
    }

    function buttonText() {
      return vm.customButtonText ? vm.customButtonText : 'Show Elements';
    }

    function toggleCatList() {
      vm.hideElements = !vm.hideElements;
    }

    function toggleBtnText() {
      return vm.hideElements ? 'Show Elements' : 'Hide Elements';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('faqSite', faqSite());

  /** @ngInject */
  function faqSite() {
    var component = {
      templateUrl: 'app/components/faqSite/faqSite.html',
      controller: FaqSiteController,
      controllerAs: 'vm',
      bindings: {
        role: '@',
      }
    };

    return component;
  }

  /** @ngInject */
  function FaqSiteController(ROLE) {
    var vm = this;

    // Accessible functions
    vm.isPublisher = isPublisher;

    // Functions
    function isPublisher() {
      return ROLE.PUB === vm.role;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('categorySelector', categorySelector());

  /* @ngInject */
  function categorySelector() {
    var component = {
      templateUrl: 'app/components/categorySelector/categorySelector.html',
      controller: CategorySelectorController,
      controllerAs: 'vm',
      bindings: {
        categories: '=ngModel',
        placeholder: '@',
        subtitle: '@',
        search: '&?',
        onChange: '&?',
        hideInput: '@',
        textToShow: '@?',
        hasChanged: '=?',
        hideCategories: '<',
        accentButton: '<',
        customButtonText: '@?',
        showOwnHideButton: '<',
        shrinked: '<',
        editProfileMode: '@',
        editProfileWizardMode: '@',
        highlightBlankAudienceFields: '<',
        forceClearCategories: '@'
      }
    };

    return component;
  }

  /* @ngInject */
  function CategorySelectorController($log, $scope, $mdMedia, lodash, toastr, CategoriesService, StorageService) {
    var vm = this;

    // Accessible attributes
    vm.mCategories = [];

    // Accessible functions
    vm.isSelected = isSelected;
    vm.querySearch = querySearch;
    vm.toggleCategory = toggleCategory;
    vm.$mdMedia = $mdMedia;
    vm.buttonText = buttonText;
    vm.toggleCatList = toggleCatList;
    vm.toggleBtnText = toggleBtnText;

    // Functions
    vm.$onInit = function () {
      if (angular.isDefined(vm.forceClearCategories) && vm.forceClearCategories) vm.categories = [];
      else if (!vm.editProfileMode && !vm.editProfileWizardMode) vm.categories = StorageService.get('newProfileSelectedCategories') || [];
      vm.calls = 0;
      vm.hasChanged = false;
      CategoriesService.indexCategories(function (response) {
        vm.mCategories = lodash.orderBy(response.data.categories, function (cat) {
          return cat.name.toLowerCase();
        }, ['asc']);
        vm.mCategories.forEach(function (item) {
          item.displayName = item.name;
           return item;
        });
        initOnChange();
      }, function () {
        $log.error('Error retrieving the categories.');
        toastr.error('There was an error retrieving the categories.');
      });
    };

    function initOnChange() {
      if (angular.isDefined(vm.onChange)) {
        $scope.$watchCollection('vm.categories', function (newValue, oldValue) {
          if (newValue && newValue !== oldValue) {
            vm.onChange();
            vm.hasChanged = ++vm.calls > 0 && newValue.length !== 0;
          }
        });
      }
    }

    function isSelected(category) {
      return lodash.findIndex(vm.categories, ['name', category.name]) >= 0;
    }

    function toggleCategory(category) {
      var pos = lodash.findIndex(vm.categories, ['name', category.name]);
      (pos < 0) ? vm.categories.push(category): vm.categories.splice(pos, 1);
    }

    function querySearch(criteria) {
      var categoriesList = vm.mCategories.slice();
      var categoriesFiltered = categoriesList.filter(createFilterFor(criteria));
      categoriesFiltered.map(function (item) {
        var uppercaseQuery = angular.uppercase(criteria);
        var upperKeyword = item.keyword && angular.uppercase(item.keyword);
        if (upperKeyword && (upperKeyword.indexOf(uppercaseQuery) !== -1)) {
          item.byKeywords = true;
          var keywordArray = item.keyword.split(', ');
          keywordArray = keywordArray.filter(keywordsFilter(criteria));
          keywordArray.forEach(function (keyItem) {
            var currentItem = Object.assign({}, item);
            currentItem.activeKey = keyItem;
            currentItem.displayName = keyItem;
            delete currentItem.$$hashKey;
            categoriesFiltered.push(currentItem);
          });
          categoriesFiltered = categoriesFiltered.filter(function (element) {
            return (!element.byKeywords || element.activeKey)
          });
        }
      });
      return categoriesFiltered || "";
    }

    function createFilterFor(query) {
      var uppercaseQuery = angular.uppercase(query);
      return function filterFn(category) {
        var upperKeyword = category.keyword && angular.uppercase(category.keyword);
        var nameResult = category.name && (category.name.indexOf(uppercaseQuery) !== -1);
        var keyResult = upperKeyword && (upperKeyword.indexOf(uppercaseQuery) !== -1);
        return nameResult || keyResult;
      }
    }

    function keywordsFilter(query) {
      var uppercaseQuery = angular.uppercase(query);
      return function filterFunction(keyword) {
        var upperKeyword = keyword && angular.uppercase(keyword);
        return upperKeyword.indexOf(uppercaseQuery) !== -1;
      }
    }

    function buttonText() {
      return vm.customButtonText ? vm.customButtonText : 'Show Categories';
    }

    function toggleCatList() {
      vm.hideCategories = !vm.hideCategories;
    }

    function toggleBtnText() {
      return vm.hideCategories ? 'Show Categories' : 'Hide Categories';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .component('daPricingChart', daPricingChart());

  /* @ngInject */
  function daPricingChart() {
    var component = {
      templateUrl: 'app/components/daPricingChart/daPricingChart.html',
      controller: DaPricingChartController,
      controllerAs: 'vm',
      bindings: {
        da: '=',
        header: '='
      }
    };

    return component;
  }

  /* @ngInject */
  function DaPricingChartController($scope) {
    var vm = this;

    vm.isSelected = isSelected;
    vm.around = around;

    vm.$onInit = function () {
      $scope.$watch('vm.da', function () {
        renderRow();
      })
    }

    function renderRow() {
      vm.columns = [
        {
          index: '0-9',
          range: {
            min: 0, max: 9
          },
          value: '$30'
        },
        {
          index: '10-19',
          range: {
            min: 10, max: 19
          },
          value: '$40'
        },
        {
          index: '20-29',
          range: {
            min: 20, max: 29
          },
          value: '$50'
        },
        {
          index: '30-39',
          range: {
            min: 30, max: 39
          },
          value: '$70'
        },
        {
          index: '40-49',
          range: {
            min: 40, max: 49
          },
          value: '$100'
        },
        {
          index: '50-59',
          range: {
            min: 50, max: 59
          },
          value: '$125'
        },
        {
          index: '60-69',
          range: {
            min: 60, max: 69
          },
          value: '$150'
        },
        {
          index: '70-79',
          range: {
            min: 70, max: 79
          },
          value: '$175'
        },
        {
          index: '80-89',
          range: {
            min: 80, max: 89
          },
          value: '$200'
        },
        {
          index: '90-100',
          range: {
            min: 90, max: 100
          },
          value: '$250'
        }
      ];
    }

    function inRange(index) {
      return vm.da >= vm.columns[index].range.min && vm.da <= vm.columns[index].range.max
    }

    function around(index) {
      if (index < (vm.columns.length - 1) && inRange(index+1)) return true
      if (index > 0 && inRange(index-1)) return true;
      return false;
    }

    function isSelected(index) {
      return inRange(index);
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('UserTourService', UserTourService);

  /** @ngInject */
  function UserTourService($timeout, $rootScope, IntroJsService, $mdDialog, RoutesService, $cookies, $q) {
    var vm = this;
    vm.current_step = -1;
    vm.current_options = null;
    vm.current_name = null;
    vm.paused = false;
    vm.introjs_instance = null;

    vm.intro_options = {
      pub_welcome_phase_1: {
        steps:[
          {
              element: "#btn-gear",
              intro: "Clicking the gear icon (<strong><svg class='icon icon--gear'><use xlink:href='assets/images/icons.svg#gear'></use></svg></strong>) here on the top right of your account will drop down to \"My Account\". (click <strong>'Next'</strong>).",
              position: 'left'
          },
          {
              element: "#li-act-info",
              intro: "Then the '<strong>MY ACCOUNT INFO</strong>' link will take you to your account page (click <strong>'Next'</strong>).",
              position: 'left'
          }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        doneLabel: 'Next',
        disableInteraction: true
      },
      pub_welcome_phase_2: {
        steps:[
          {
              element: "#paypalEmail",
              intro: "Please <strong>provide your PayPal email so you can get paid</strong> upon order completion. This is important so be sure to do it soon.",
              position: 'left'
          },
          {
              element: "#pub-shipping-info",
              intro: "Give public mailing address / PO Box if you are open to getting free product shipped. And mobile number for order notifications.",
              position: 'top'
          }
          // {
          //   element: "#btn-save-profile",
          //   intro: "If you made any changes go ahead and '<strong>Save Profile</strong>' now, otherwise click <strong>'Next'</strong>.",
          //   position: 'left'
          // }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        doneLabel: 'Next',
        disableInteraction: true
      },
      pub_welcome_phase_3: {
        steps:[
          {
              element: "#btn-create-profile",
              intro: "Create your first profile by clicking '<strong>Create new profile</strong>'.",
              position: 'left'
          }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        doneLabel: 'Next',
        disableInteraction: true
      },
      pub_welcome_phase_4: {
        steps:[
          {
              element: "#create-profile-card",
              intro: "<strong>CREATING A PROFILE:</strong><br><br>1) Click camera icon to upload a headshot<br>2) Choose the type of profile & name it<br>3) Click Save<br><br>Click <strong>Next</strong> now to start.",
              position: 'left'
          }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        doneLabel: 'Next',
        disableInteraction: false
      },
      pub_welcome_phase_5: {
        steps:[
          {
              element: "#btn-my-audience",
              intro: 'On this page you see "My Audience" and then different channels for blogs and social media. <strong>Fill out "My Audience" first</strong>. The only required part for "My Audience" is categories. Please take your time.',
              position: 'right'
          },
          {
            element: "#profile-sections",
            intro: "Next is connecting each channel on your blog or social media channels. <strong>AFTER CONNECTING a channel, our suggested pricing will appear. Please try to follow that as much as possible.</strong>",
            position: 'right'
          },
          {
            element: "#sponsored-blog-section",
            intro: "Sponsored blog post pricing is based on your traffic. This is a product or service review. You will connect Google Analytics (verifying monthly unique visitors).  This content is written by you or your team. Content will be disclosed as sponsored using whatever disclosure you want. Links will be no-follow.",
            position: 'right'
          },
          {
            element: "#guest-post-section",
            intro: 'Guest post pricing is based less on traffic and more on "authority". Content will be written by our team and will NOT be advertorial nor endorsing any brand, product, or service.  Content will not need to be disclosed as you are not endorsing a product or service with guest posts.',
            position: 'left'
          },
          {
            element: "#facebook-section",
            intro: "And finally, for all Social media channels (Facebook, but also Instagram, Twitter &amp; Youtube), it works the same way as Sponsored Blog Posts. But instead of traffic, is based on followers and engagement. Content will be written by you. Content will be disclosed as sponsored as well. You will need to connect each social media handle separately so we can confirm followers.",
            position: 'right'
          },
          {
            intro: "That's it for now! If you ever want to go through this tutorial again, you may simply click the TUTORIAL link at the top of your account. If you have any questions, you can always email us at admin@scalefluence.com and we'll get back to you as soon as we can!<br><br>Welcome aboard!"
          }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        doneLabel: 'END',
        disableInteraction: true
      },
      pub_welcome_phase_6: {
        steps:[
          {
              element: "#categories-data",
              intro: "This is where you will start because at minimum you must select applicable Categories for your content. Categories can be added by either typing Category names or clicking '<strong>Show Categories</strong>' and selecting them, whatever is easier for you. Once you are done with Categories then fill in as much other audience information as you can so Advertisers can find you. Then after saving Audience information you will be able to add your Blog or Social Media Account to the market place! <strong>Congratulations and welcome!</strong>",
              position: 'bottom'
          }
        ],
        showStepNumbers: false,
        showBullets: false,
        exitOnOverlayClick: false,
        exitOnEsc:false,
        // nextLabel: 'next',
        // prevLabel: '<span style="color:green">Previous</span>',
        disableInteraction: true
      }
    }

    var service = {
      initPubWelcomeTourPhase1: initPubWelcomeTourPhase1,
      startPubWelcomeTourPhase3: startPubWelcomeTourPhase3,
      startPubWelcomeTourPhase4: startPubWelcomeTourPhase4,
      startPubWelcomeTourPhase5: startPubWelcomeTourPhase5,
      startPubWelcomeTourPhase6: startPubWelcomeTourPhase6,
      nextStep: nextStep,
      goToStepNumber: goToStepNumber,
      currentStep: currentStep,
      currentName: currentName,
      pause: pause,
      unpause: unpause,
      stopTour: stopTour,
      isActive: isActive,
      setActive: setActive,
      setInactive: setInactive
    };

    // NOTE: This service emits events on $rootScope
    // that can be listed for as follows:
    // var changedUserTourStep = $rootScope.$on('changedUserTourStep', function(event, state) {
    //   console.log("we are now on step " + state.current_step);
    // });
    // var chaningUserTourStep = $rootScope.$on('changingUserTourStep', function(event, state) {
    //   console.log("we were on step " + state.current_step);
    // });
    return service;

    function initInstance() {
      if (IntroJsService.instances[0]) vm.introjs_instance = IntroJsService.instances[0];
      else vm.introjs_instance = IntroJsService();
    }
    function getInstance() {
      if (!vm.introjs_instance) initInstance();
      return vm.introjs_instance;
    }

    function pause() {
      vm.paused = true;
    }
    function unpause() {
      vm.paused = false;
    }

    function isActive() {
      if ($cookies.get("pub-tour-active")) return true
      else return false;
    }
    function setActive() {
      $cookies.put("pub-tour-active", true);
    }
    function setInactive() {
      $cookies.remove("pub-tour-active");
    }

    // functions for onbeforechange that will
    // pause next step from happening
    function waitForDelay(delay) {
      return new Promise(function (resolve) {
        $timeout(function() {
          // unpause();
          resolve();
        }, delay);
      });
    }
    // function waitWhilePaused() {
    //   return new Promise(async function (resolve) {
    //     var i = 0;
    //     // waits for a max of 10 seconds (50 * 200 ms)
    //     while (vm.paused && i < 50) {
    //       await $timeout(function() {
    //         i++;
    //         console.log('waiting a moment ' + i);
    //       }, 200);
    //     }
    //     console.log('resolving and continuing');
    //     resolve();
    //   });
    // }

    function getState() {
      return {
        current_step: vm.current_step,
        current_name: vm.current_name
      };
    }
    function currentStep() {
      return vm.current_step;
    }
    function currentName() {
      return vm.current_name;
    }

    function initPubWelcomeTourPhase1() {
      if (!isActive()) return;

      startPubWelcomeTourPhase1();
      // showDialog('Welcome to Scalefluence!', 'This quick 2-minute tutorial will show you the basics of creating a profile, collaborating with brands, and getting paid.', "Let's Go!")
      //   .then(function () {
      //     startPubWelcomeTourPhase1();
      //   });
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .textContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    function startPubWelcomeTourPhase1() {
      if (!isActive()) return;
      vm.current_name = 'pub_welcome_phase_1';
      vm.current_options = vm.intro_options.pub_welcome_phase_1;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        // console.log('instance', vm.introjs_instance);
        // this is effing working
        instance.onbeforechange(function() {
          return onBeforeChangeGlobal();
        });
        instance.onexit(function() {
          return onExitGlobal();
        });
        instance.oncomplete(function() {
          return onCompleteGlobal();
        });
      });
    }
    function startPubWelcomeTourPhase2() {
      if (!isActive()) return;
      vm.current_name = 'pub_welcome_phase_2';
      vm.current_options = vm.intro_options.pub_welcome_phase_2;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        instance.oncomplete(function() {
          return onCompleteGlobal();
        });
      });
    }
    function startPubWelcomeTourPhase3() {
      if (!isActive()) return;
      vm.current_name = 'pub_welcome_phase_3';
      vm.current_options = vm.intro_options.pub_welcome_phase_3;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        instance.onexit(function() {
          return onExitGlobal();
        });
        instance.oncomplete(function() {
          return onCompleteGlobal();
        });
      });
    }
    function startPubWelcomeTourPhase4() {
      if (!isActive()) return;
      // console.log('starting phase 4');
      vm.current_name = 'pub_welcome_phase_4';
      vm.current_options = vm.intro_options.pub_welcome_phase_4;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        instance.onexit(function() {
          return onExitGlobal();
        });
      });
    }
    function startPubWelcomeTourPhase5() {
      if (!isActive()) return;
      // return;
      // console.log('starting phase 5');
      vm.current_name = 'pub_welcome_phase_5';
      vm.current_options = vm.intro_options.pub_welcome_phase_5;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started phase 5');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        instance.onexit(function() {
          return onExitGlobal();
        });
        instance.oncomplete(function() {
          return onCompleteGlobal();
        });
      });
    }
    function startPubWelcomeTourPhase6() {
      if (!isActive()) return;
      // console.log('starting phase 6');
      vm.current_name = 'pub_welcome_phase_6';
      vm.current_options = vm.intro_options.pub_welcome_phase_6;
      vm.current_step = 0;
      getInstance().setOptions(vm.current_options)
      .start().then(function (instance) {
        // console.log('started phase 6');
        vm.introjs_instance = instance;
        // console.log('step ' + vm.introjs_instance._currentStep);
        instance.onexit(function() {
          return onExitGlobal();
        });
      });
    }

    function nextStep() {
      getInstance().nextStep();
    }

    function goToStepNumber(step, delay) {
      if (delay > 0) {
        $timeout(function () {
          vm.current_step = step;
          getInstance().goToStepNumber(vm.current_step);
        }, delay);
      } else {
        vm.current_step = step;
        getInstance().goToStepNumber(vm.current_step);
      }
    }

    function stopTour() {
      vm.introjs_instance.exit();
    }

    function onBeforeChangeGlobal() {
      vm.current_step = getInstance()._currentStep;
      $rootScope.$emit("changingUserTourStep", getState());
      // console.log('we rock and roll to step ' + vm.current_step);
      if (vm.current_name == 'pub_welcome_phase_1' && vm.current_step == 1) {
        if (!jQuery(".user-menu__dropdown").is(":visible")) {
          jQuery(".user-menu__dropdown").toggle();
          return waitForDelay(300);
        }
      }
      return;
    }

    function onExitGlobal() {
      // let's deactivate if it's clear that the user exited the tour.
      // this isn't perfect cuz if they exit on the last step then this
      // won't do anything, but we daisy chain these things together and
      // after the last step an 'exit' event takes place but we want the
      // 1st step of the next phase to continue after that.
      var current_step = getInstance()._currentStep + 1;
      var qty_steps = getInstance()._introItems.length;
      if (current_step < qty_steps) {
        setInactive();
      }
    }

    function onCompleteGlobal() {
      // console.log('onCompleteGlobal name ' + vm.current_name);
      if (vm.current_name == 'pub_welcome_phase_1') {
        RoutesService.profile();
        $timeout(function() { startPubWelcomeTourPhase2(); }, 1000);
      } else if (vm.current_name == 'pub_welcome_phase_2') {
        RoutesService.dashboard();
        $timeout(function() { startPubWelcomeTourPhase3(); }, 1000);
      } else if (vm.current_name == 'pub_welcome_phase_3') {
        jQuery('#btn-create-profile').trigger('click');
      } else if (vm.current_name == 'pub_welcome_phase_5') {
        setInactive();
      }
      return;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('UserService', UserService);

  /** @ngInject */
  function UserService($http, EnvironmentConfig, SessionService, StorageService, toastr, TOSTATE, RoutesService) {
    var USER_URL = EnvironmentConfig.API_END_POINT + '/users/me';
    var USERS_URL = EnvironmentConfig.API_END_POINT + '/users';
    var GOOGLE_AUTH_URL = EnvironmentConfig.GOOGLE_AUTH_ENDPOINT;

    var service = {
      getUser: getUser,
      updateUser: update,
      signUp: signUp,
      checkDuplicatedEmail: checkDuplicatedEmail,
      googleAuth: googleAuth,
      decodeJwtResponse: decodeJwtResponse,
      sendPubSignupConfirmationEmail: sendPubSignupConfirmationEmail,
      sendAdvSignupConfirmationEmail: sendAdvSignupConfirmationEmail
    };

    return service;

    // Functions
    function googleAuth(user, advertiser, publisher) {
      $http.post(GOOGLE_AUTH_URL, {
        user: user,
        advertiser: advertiser,
        publisher: publisher
      }).then(function (res) {
        SessionService.createSession(res.data);
        const toState = StorageService.get(TOSTATE);
        if (toState) {
          StorageService.remove(TOSTATE);
          $state.go(toState.name);
        } else {
          RoutesService.dashboard();
        }
      }, function (e) {
        if (e.data.error) toastr.error(e.data.error);
        else toastr.error('There was an error logging in or retrieving your dashboard\'s info.');
      });
    }

    function getUser(successCallback, errorCallback) {
      $http.get(USER_URL).then(successCallback, errorCallback);
    }

    function update(user, successCallback, errorCallback) {
      $http.put(USER_URL, {
        user: user
      }).then(successCallback, errorCallback);
    }

    function signUp(user, advertiser, publisher, successCallback, errorCallback) {
      $http.post(USERS_URL, {
        user: user,
        advertiser: advertiser,
        publisher: publisher
      }).then(successCallback, errorCallback);
    }

    function checkDuplicatedEmail(email, successCallback, errorCallback) {
      $http.get(USERS_URL + '/check_email', {
        params: {
          email: email
        }
      }).then(successCallback, errorCallback);
    }

    function decodeJwtResponse(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }

    function sendPubSignupConfirmationEmail(email, successCallback, errorCallback) {
      $http.post(USERS_URL + '/send_pub_signup_email', {
        email: email
      }).then(successCallback, errorCallback);
    }

    function sendAdvSignupConfirmationEmail(email, successCallback, errorCallback) {
      $http.post(USERS_URL + '/send_adv_signup_email', {
        email: email
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('UrlsService', UrlsService);

  /** @ngInject */
  function UrlsService($http, EnvironmentConfig, Upload, lodash) {
    var URLS = EnvironmentConfig.API_END_POINT + '/publishers/me/urls';

    var service = {
      updateUrl: updateUrl,
      pauseUrl: pauseUrl,
      requestPrice: requestPrice,
      indexOnlyUrls: indexOnlyUrls
    };

    return service;

    // Functions
    function updateUrl(url, successCallback, errorCallback) {
      Upload.upload({
        url: URLS + '/' + url.id,
        method: 'PUT',
        fields: {
          'url[href]': url.href,
          'url[price]': url.price,
          'url[description]': url.description,
          'url[follow_link]': url.follow_link,
          'url[paused]': url.paused
        }
      }).then(successCallback, errorCallback);
    }

    // might be able to get away with only sending url[note], but this was created
    // by duplicating updateUrl and then adding code on the back end that modifies
    // the auto note if url[note] is present, but otherwise functions the same way
    // as updateUrl (above) so leaving it as-is should result in guaranteed proper functionality.
    function pauseUrl(url, note, successCallback, errorCallback) {
      Upload.upload({
        url: URLS + '/' + url.id,
        method: 'PUT',
        fields: {
          'url[href]': url.href,
          'url[price]': url.price,
          'url[description]': url.description,
          'url[follow_link]': url.follow_link,
          'url[paused]': url.paused,
          'url[note]': note
        }
      }).then(successCallback, errorCallback);
    }

    function requestPrice(url, successCallback, errorCallback) {
      Upload.upload({
        url: URLS + '/' + url.id,
        method: 'PUT',
        fields: {
          'url[requested_price]': url.price
        }
      }).then(successCallback, errorCallback);
    }

    function indexOnlyUrls(states, query, successCallback, errorCallback) {
      $http.get(URLS, {
        params: {
          'states[]': states,
          page: query.page,
          limit: query.limit,
          field: query.order,
          order_by: query.orderBy,
          q: query.filter
        }
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('StorageService', StorageService);

  /** @ngInject */
  function StorageService(localStorageService) {
    var service = {
      getAll: getAll,
      set: set,
      get: get,
      remove: remove,
      clear: clear
    };

    return service;

    ////////// Functions //////////

    function getAll() {
      return localStorageService.keys()
    }

    function set(key, value) {
      return localStorageService.set(key, value);
    }

    function get(key) {
      return localStorageService.get(key);
    }

    function remove(key) {
      return localStorageService.remove(key);
    }

    function clear() {
      return localStorageService.clearAll();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('StatesService', StatesService);

  /* @ngInject */
  function StatesService() {
    var service = {
      getAllUSStates: getAllUSStates
    };

    return service;

    function getAllUSStates() {
      return [{
          code: 'AL',
          name: 'Alabama'
        },
        {
          code: 'AK',
          name: 'Alaska'
        },
        {
          code: 'AZ',
          name: 'Arizona'
        },
        {
          code: 'AR',
          name: 'Arkansas'
        },
        {
          code: 'CA',
          name: 'California'
        },
        {
          code: 'CO',
          name: 'Colorado'
        },
        {
          code: 'CT',
          name: 'Connecticut'
        },
        {
          code: 'DE',
          name: 'Delaware'
        },
        {
          code: 'DC',
          name: 'District Of Columbia'
        },
        {
          code: 'FL',
          name: 'Florida'
        },
        {
          code: 'GA',
          name: 'Georgia'
        },
        {
          code: 'HI',
          name: 'Hawaii'
        },
        {
          code: 'ID',
          name: 'Idaho'
        },
        {
          code: 'IL',
          name: 'Illinois'
        },
        {
          code: 'IN',
          name: 'Indiana'
        },
        {
          code: 'IA',
          name: 'Iowa'
        },
        {
          code: 'KS',
          name: 'Kansas'
        },
        {
          code: 'KY',
          name: 'Kentucky'
        },
        {
          code: 'LA',
          name: 'Louisiana'
        },
        {
          code: 'ME',
          name: 'Maine'
        },
        {
          code: 'MD',
          name: 'Maryland'
        },
        {
          code: 'MA',
          name: 'Massachusetts'
        },
        {
          code: 'MI',
          name: 'Michigan'
        },
        {
          code: 'MN',
          name: 'Minnesota'
        },
        {
          code: 'MS',
          name: 'Mississippi'
        },
        {
          code: 'MO',
          name: 'Missouri'
        },
        {
          code: 'MT',
          name: 'Montana'
        },
        {
          code: 'NE',
          name: 'Nebraska'
        },
        {
          code: 'NV',
          name: 'Nevada'
        },
        {
          code: 'NH',
          name: 'New Hampshire'
        },
        {
          code: 'NJ',
          name: 'New Jersey'
        },
        {
          code: 'NM',
          name: 'New Mexico'
        },
        {
          code: 'NY',
          name: 'New York'
        },
        {
          code: 'NC',
          name: 'North Carolina'
        },
        {
          code: 'ND',
          name: 'North Dakota'
        },
        {
          code: 'OH',
          name: 'Ohio'
        },
        {
          code: 'OK',
          name: 'Oklahoma'
        },
        {
          code: 'OR',
          name: 'Oregon'
        },
        {
          code: 'PA',
          name: 'Pennsylvania'
        },
        {
          code: 'RI',
          name: 'Rhode Island'
        },
        {
          code: 'SC',
          name: 'South Carolina'
        },
        {
          code: 'SD',
          name: 'South Dakota'
        },
        {
          code: 'TN',
          name: 'Tennessee'
        },
        {
          code: 'TX',
          name: 'Texas'
        },
        {
          code: 'UT',
          name: 'Utah'
        },
        {
          code: 'VT',
          name: 'Vermont'
        },
        {
          code: 'VA',
          name: 'Virginia'
        },
        {
          code: 'WA',
          name: 'Washington'
        },
        {
          code: 'WV',
          name: 'West Virginia'
        },
        {
          code: 'WI',
          name: 'Wisconsin'
        },
        {
          code: 'WY',
          name: 'Wyoming'
        }
      ]
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('SessionService', SessionService);

  /* @ngInject */
  function SessionService(lodash, StorageService, ROLE, EnvironmentConfig) {

    ////////// Constants //////////
    const INDEX = 'index';
    const TOKEN = 'token';
    const USER = 'user';
    const ROLES = 'roles';
    const ACTIVE_ROLES = 'activeRoles';
    const CURRENT_ROLE = 'currentRole';

    var service = {
      sessionToken: sessionToken,
      sessionUser: sessionUser,
      createSession: createSession,
      isloggedIn: isloggedIn,
      clearSession: clearSession,
      currentRole: currentRole,
      isAdvertiser: isAdvertiser,
      isPublisher: isPublisher,
      switchAccount: switchAccount,
      canSwithAccount: canSwithAccount,
      switchAccountEnabled: switchAccountEnabled,
      setRole: setRole,
      updateSession: updateSession,
      forceSessionFromAdmin: forceSessionFromAdmin
    };

    return service;

    ////////// Functions //////////

    function sessionToken() {
      return StorageService.get(TOKEN);
    }

    function sessionUser() {
      return StorageService.get(USER);
    }

    function createSession(data) {
      StorageService.set(INDEX, 0);
      StorageService.set(TOKEN, data.token);
      StorageService.set(USER, data.user);
      StorageService.set(ROLES, data.user.roles);
      StorageService.set(ACTIVE_ROLES, data.user.active_roles);
      StorageService.set(CURRENT_ROLE, data.user.active_roles[StorageService.get(INDEX)]);
      // uncomment below to send admin an email each time a session is created.
      // we have some odd logout issues and have tried to used this for troubleshooting
      // but we haven't solved the problem yet and we aren't actively working on solving it right now.
      // try {
      //   jQuery.post( EnvironmentConfig.API_END_POINT + '/send_admin_notification', {
      //     subject: 'scalefluence session created',
      //     body: JSON.stringify(data)
      //   });
      // } catch (error) {
      //   console.log('failed to email admin', error);
      // }
    }

    function updateSession(data) {
      var index = StorageService.get(INDEX);
      var total = StorageService.get(ROLES).length;
      var res = (++index % total);
      StorageService.set(INDEX, res);
      StorageService.set(USER, data.user);
      StorageService.set(ROLES, data.user.roles);
      StorageService.set(ACTIVE_ROLES, data.user.active_roles);
      StorageService.set(CURRENT_ROLE, data.user.active_roles[index]);
    }

    function isloggedIn() {
      return StorageService.get(TOKEN) != null;
    }

    function clearSession() {
      return StorageService.clear();
    }

    function currentRole() {
      return StorageService.get(CURRENT_ROLE);
    }

    function isAdvertiser() {
      return StorageService.get(CURRENT_ROLE) == ROLE.ADV;
    }

    function isPublisher() {
      return StorageService.get(CURRENT_ROLE) == ROLE.PUB;
    }

    function switchAccount() {
      if (switchAccountEnabled()) {
        var index = StorageService.get(INDEX);
        var total = StorageService.get(ACTIVE_ROLES).length;
        var res = (++index % total);
        var newRole = StorageService.get(ACTIVE_ROLES)[res];
        StorageService.set(INDEX, res);
        return StorageService.set(CURRENT_ROLE, newRole);
      }
      return false;
    }

    // 'can' is hypothetical now... it only means that more than 1 role
    // 'exists' and doesn't take into consideration if any are terminated (not active).
    // this was allowing users to login to an active advertiser account and use that
    // to then switch over to a terminated publisher account or vise versa.
    // this function is used for conditional display (switch account vs create account),
    // but the new switchAccountEnabled function is now used to know if the other account
    // type is really accessible to login
    function canSwithAccount() {
      var roles = StorageService.get(ROLES);
      return roles && roles.length > 1;
    }

    function switchAccountEnabled() {
      var roles = StorageService.get(ACTIVE_ROLES);
      return roles && roles.length > 1;
    }

    function setRole(role) {
      StorageService.set(role, true);
    }

    function forceSessionFromAdmin(token, role) {
      createSession({
        token: token,
        user: {
          roles: [role],
          active_roles: [role]
        }
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('SelectedOrdersService', SelectedOrdersService);

  /* @ngInject */
  // I don't believe this service is used anymore and instead checkout (selected orders) state
  // handling has been moved to the backend. If we do end up using this in the future then
  // among other things we'll have to note the root counterCheckoutItems in the main nav
  function SelectedOrdersService(lodash, ORDER_ORIGIN) {

    var orderList = [];
    var service = {
      clean: clean,
      getOrders: getOrders,
      setOrdersCart: toggleCart,
      setOrdersContentDone: toggleContentDone
    };

    return service;

    function clean() {
      orderList = [];
    }

    function getOrders() {
      return orderList;
    }

    function toggleCart(selectedOrders) {
      lodash.map(selectedOrders, function(order) {
        var newOrder = {};
        angular.copy(order, newOrder);
        newOrder.origin = ORDER_ORIGIN.CART;
        orderList.push(newOrder);
      });
    }

    function toggleContentDone(selectedOrders) {
      lodash.map(selectedOrders, function(order) {
        var newOrder = {};
        angular.copy(order, newOrder);
        newOrder.origin = ORDER_ORIGIN.CONTENT;
        orderList.push(newOrder);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('SearchService', SearchService);

  /** @ngInject */
  function SearchService($http, EnvironmentConfig) {
    var SEARCH_URL = EnvironmentConfig.API_END_POINT + '/urls';

    var service = {
      indexUrls: indexUrls
    };

    return service;

    // Functions
    function indexUrls(values, categories_names, categories_keywords, successCallback, errorCallback) {
      $http.get(SEARCH_URL, {
        params: {
          domain_authority_min: values.domain_authority_start,
          domain_authority_max: values.domain_authority_end,
          trust_flow_min: values.trust_flow_start,
          trust_flow_max: values.trust_flow_end,
          ahrefs_dr_min: values.ahrefs_dr_start,
          ahrefs_dr_max: values.ahrefs_dr_end,
          ahrefs_lrd_min: values.ahrefs_lrd_start,
          ahrefs_lrd_max: values.ahrefs_lrd_end,
          citation_flow_min: values.citation_flow_start,
          citation_flow_max: values.citation_flow_end,
          shown_price_min: values.price_start,
          shown_price_max: values.price_end,
          'words[]': categories_names && categories_names.concat(values.text) || [],
          'keywords[]': categories_keywords && categories_keywords.concat(values.text) || [],
          auto_approved: values.auto_approved,
          sort_by: values.sort_by,
          page: values.page
        }
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('RoutesService', RoutesService);

  /* @ngInject */
  function RoutesService($state, SessionService, EnvironmentConfig) {
    var service = {
      dashboard: dashboard,
      profile: profile,
      creditCards: creditCards,
      editProfile: editProfile,
      editProfileV2: editProfileV2,
      editProfileSection: editProfileSection,
      pubNewOrders: pubNewOrders,
      pubActiveAds: pubActiveAds,
      pubPricingPausing: pubPricingPausing,
      pubResubmitted: pubResubmitted,
      mainQuotes: mainQuotes,
      signUp: signUp,
      signUpWithSsoMsg: signUpWithSsoMsg,
      signIn: signIn,
      editCampaign: editCampaign,
      allCampaigns: allCampaigns,
      managerCampaigns: managerCampaigns,
      thankYou: thankYou,
      thankYouWithEmail: thankYouWithEmail,
      advTeammates: advTeammates
    };

    return service;

    ////////// Functions //////////

    function dashboard() {
      if (SessionService.isAdvertiser()) {
        $state.go('adv-dash');
      } else if (SessionService.isPublisher()) {
        $state.go('pub-dash');
      }
    }

    function profile() {
      $state.go('show-profile');
    }

    function creditCards(id) {
      id ? $state.go('credit-card', {
        cardId: id
      }) : $state.go('credit-card');
    }

    function editProfile(id, profile) {
      $state.go('edit-profile', {
        profileId: id,
        profile: profile
      });
    }

    function editProfileV2(id, profile, publisher) {
      var pDate = Date.parse(publisher.created_at);
      var v2Date = Date.parse(EnvironmentConfig.V2_PROFILE_SWITCH_DATE);
      if (pDate < v2Date) {
        $state.go('edit-profile-v1', {
          profileId: id,
          profile: profile
        });
      } else {
        $state.go('edit-profile', {
          profileId: id,
          profile: profile
        });
      }
    }

    function editProfileSection(editSection, profileId, profile, forceAdd) {
      $state.go(editSection, {
        profileId: profileId,
        profile: profile,
        forceAdd: forceAdd
      });
    }

    function pubNewOrders() {
      $state.go('new-orders');
    }

    function pubActiveAds() {
      $state.go('active-ads');
    }

    function pubPricingPausing() {
      $state.go('pricing-pausing');
    }

    function pubResubmitted() {
      $state.go('resubmitted');
    }

    function mainQuotes() {
      $state.go('quotes-main');
    }

    function signUp() {
      $state.go('sign-up');
    }

    function signUpWithSsoMsg(email) {
      $state.go('sign-up', {
        ssoEmail: email
      });
    }

    function signIn() {
      $state.go('sign-in');
    }

    function editCampaign(id) {
      $state.go('edit-campaign', {
        campaignId: id
      })
    }

    function allCampaigns() {
      $state.go('all-campaigns');
    }

    function managerCampaigns(manager_id) {
      $state.go('teammate-campaigns', {
        teammateId: manager_id
      })
    }

    function thankYou($accountType) {
      // 'influencer' or 'agency'
      if ($accountType === 'influencer') $state.go('thankyou-pub');
      else $state.go('thankyou-adv');
    }

    function thankYouWithEmail($accountType, $email) {
      // 'influencer' or 'agency'
      if ($accountType === 'influencer') $state.go('thankyou-pub', {email: $email});
      else $state.go('thankyou-adv', {email: $email});
    }

    function advTeammates() {
      $state.go('adv-teammates');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('RejectedReasonsService', RejectedReasonsService);

  /* @ngInject */
  function RejectedReasonsService() {
    var service = {
      getRejectedReasons: getRejectedReasons
    };

    return service;

    function getRejectedReasons() {
      return [{
          title: 'Content Irrelevant',
          selected: false
        },
        {
          title: 'Content to Salesy',
          selected: false
        },
        {
          title: 'Too short',
          selected: false
        },
        {
          title: 'Too long',
          selected: false
        }
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('ProfilesService', ProfilesService);

  /** @ngInject */
  function ProfilesService($http, EnvironmentConfig, Upload, lodash) {
    var PROFILES_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/profiles';
    var VALIDATE_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/validate_url';
    var PUBLISHER_URL = EnvironmentConfig.API_END_POINT +'/publishers/';

    var service = {
      createProfile: createProfile,
      updateProfile: updateProfile,
      indexProfiles: indexProfiles,
      showProfile: showProfile,
      getMetaDescription: getMetaDescription,
      getAnalyticsMUV: getAnalyticsMUV,
      getSocialHandleFollowers: getSocialHandleFollowers,
      updateSpreadsheetProfile: updateSpreadsheetProfile,
      getDomainInformation: getDomainInformation,
      getProfileNames: getProfileNames,
      getProfileSocialUrls: getProfileSocialUrls,
      indexUrls: indexUrls,
      addUrl: addUrl,
      updateUrl: updateUrl,
      getTwitterFollowersCount: getTwitterFollowersCount,
      checkUrl: checkUrl,
      getInstagramAuthUrl: getInstagramAuthUrl,
      verifyInstagramAccount: verifyInstagramAccount,
      getInstagramData: getInstagramData,
      getRedirectUrl: getRedirectUrl,
      getWebProperties:getWebProperties,
      getWebProfiles: getWebProfiles,
      getWebGaData: getWebGaData,
      getWebPropertiesGa4: getWebPropertiesGa4,
      getWebGa4Data:getWebGa4Data
    };

    return service;

    // Functions
    function indexProfiles(query, successCallback, errorCallback) {
      $http.get(PROFILES_URL, {
        params: {
          page: query.page,
          limit: query.limit,
          q: query.filter
        }
      }).then(successCallback, errorCallback);
    }

    function indexUrls(id, successCallback, errorCallback) {
      $http.get(PROFILES_URL + '/' + id).then(successCallback, errorCallback);
    }

    function showProfile(id, successCallback, errorCallback) {
      $http.get(PROFILES_URL + '/' + id).then(successCallback, errorCallback);
    }

    function createProfile(profile, successCallback, errorCallback) {
      Upload.upload({
        url: PROFILES_URL,
        method: 'POST',
        fields: {
          'profile[name]': profile.name,
          'profile[image]': profile.image,
          'profile[profile_type]': profile.profileType,
        }
      }).then(successCallback, errorCallback);
    }

    function updateProfile(id, profile, successCallback, errorCallback) {
      Upload.upload({
        url: PROFILES_URL + '/' + id,
        method: 'PUT',
        fields: {
          'profile[name]': profile.name,
          'profile[image]': profile.image,
          'profile[profile_type]': profile.profile_type,
          'profile[categories_ids]': profile.categories_ids,
          'profile[urls_attributes]': profile.urls,
          'profile[web_content_attributes]': profile.web_content,
          'profile[facebook_handle_attributes]': profile.facebook_handle,
          'profile[twitter_handle_attributes]': profile.twitter_handle,
          'profile[youtube_handle_attributes]': profile.youtube_handle,
          'profile[instagram_handle_attributes]': profile.instagram_handle,
          'profile[audience_gender]': profile.audience_gender,
          'profile[audience_age_groups]': profile.audience_age_groups,
          'profile[audience_ethnicity_groups]': profile.audience_ethnicities,
          'profile[audience_estimated_income]': profile.audience_estimated_income,
          'profile[pets]': profile.pets,
          'profile[languages]': profile.languages,
          'spreadsheet': profile.csv,
          'completed': true
        }
      }).then(successCallback, errorCallback);
    }

    function updateSpreadsheetProfile(id, profileType, spreadsheet, successCallback, errorCallback) {
      Upload.upload({
        url: PROFILES_URL + '/' + id + '/update_spreadsheet',
        method: 'PUT',
        fields: {
          'spreadsheet': spreadsheet,
          'profile_type': profileType
        }
      }).then(successCallback, errorCallback);
    }

    function getMetaDescription(url, successCallback, errorCallback) {
      var META_URL = '/meta_description?url=';
      $http.get(PROFILES_URL + META_URL + url).then(successCallback, errorCallback);
    }

    function getAnalyticsMUV(url, successCallback, errorCallback) {
      var GA_URL = '/ga_muv?url=';
      // THIS DOES NOT WORK! I FOUND OUT THE HARD WAY. IT'S JUST A RANDOM NUMBER GENERATOR!
      $http.get(PROFILES_URL + GA_URL + url).then(successCallback, errorCallback);
    }

    function getSocialHandleFollowers(url, name, successCallback, errorCallback) {
      var URL = '/' + name + '_followers?url=';
      $http.get(PROFILES_URL + URL + url).then(successCallback, errorCallback);
    }

    function getDomainInformation(url, successCallback, errorCallback) {
      var DOMAIN_URL = '/domain_information?url=';
      $http.get(PROFILES_URL + DOMAIN_URL + url).then(successCallback, errorCallback);
    }

    function getProfileNames(successCallback) {
      $http.get(PROFILES_URL + '/names').then(successCallback);
    }

    function getProfileSocialUrls(successCallback) {
      $http.get(PROFILES_URL + '/social_urls').then(successCallback);
    }

    function addUrl(id, url, successCallback, errorCallback) {
      Upload.upload({
        url: PROFILES_URL + '/' + id + '/urls',
        method: 'POST',
        fields: {
          'url[href]': url.href,
          'url[price]': url.price,
          'url[description]': url.description,
          'url[author_page]': url.author_page,
          'url[follow_link]': url.follow_link
        }
      }).then(successCallback, errorCallback);
    }

    function updateUrl(id, url, successCallback, errorCallback) {
      Upload.upload({
        url: PROFILES_URL + '/' + id + '/urls/' + url.id,
        method: 'PUT',
        fields: {
          'url[href]': url.href,
          'url[price]': url.price,
          'url[description]': url.description,
          'url[author_page]': url.author_page,
          'url[follow_link]': url.follow_link,
          'url[pause]': url.pause,
          'url[required_length]': url.required_length,
          'url[allow_home_page]': url.allow_home_page,
          'url[allow_blog_post]': url.allow_blog_post
        }
      }).then(successCallback, errorCallback);
    }

    function getTwitterFollowersCount(handle, successCallback, errorCallback) {
      $http.get(PROFILES_URL + '/twitter_followers', {
        params: {
          'handle': handle
        }
      }).then(successCallback, errorCallback);
    }

    function checkUrl(url, successCallback, errorCallback) {
      Upload.upload({
        url: VALIDATE_URL,
        method: 'POST',
        fields: {
          url_href: url
        }
      }).then(successCallback, errorCallback);
    }

    function getInstagramAuthUrl(state, profile_id, successCallback, errorCallback) {
      $http.get(PROFILES_URL + '/instagram_auth_url', {
        params: {
          'state': state,
          'profile_id': profile_id
        }
      }).then(successCallback, errorCallback);
    }

    function verifyInstagramAccount(authCode, userId, successCallback, errorCallback) {
      $http.post(PROFILES_URL + '/verify_instagram', {
        auth_code: authCode,
        user_id: userId
      }).then(successCallback, errorCallback);
    }

    function getInstagramData(username, successCallback, errorCallback) {
      $http.post(PROFILES_URL + '/grab_ig_details', {
        username: username
      }).then(successCallback, errorCallback);
    }

    function getRedirectUrl(profile_id, profile_version, ga_version, successCallback, errorCallback) {
      $http.get(PROFILES_URL + '/google_authorization_uri', {
        params: {
          'profile_id': profile_id,
          'profile_version': profile_version,
          'ga_version' : ga_version
        }
      }).then(successCallback, errorCallback);
    }

    function getWebProperties(webContentId,profileId, successCallback, errorCallback) {
      $http.get(EnvironmentConfig.API_END_POINT +'/publishers' + '/' + profileId + '/profiles/web_properties', {
        params: {
          'web_content_id': webContentId
        }
      }).then(successCallback, errorCallback);
    }

    function getWebPropertiesGa4(webContentId, profileId, successCallback, errorCallback) {
      $http.get(PUBLISHER_URL + profileId + '/profiles/web_account_summaries', {
        params: {
          'web_content_id': webContentId
        }
      }).then(successCallback, errorCallback);
    }

    function getWebProfiles(selectedAnalyticObj, successCallback, errorCallback) {
      $http.get(PUBLISHER_URL + selectedAnalyticObj.profileId + '/profiles/web_profiles', {
        params: {
          'web_content_id':selectedAnalyticObj.webContentId,
          'web_account_id': selectedAnalyticObj.selectedAnalytic.account_id,
          'web_property_id': selectedAnalyticObj.selectedAnalytic.id
        }
      }).then(successCallback, errorCallback);
    }

    function getWebGaData(selectedProfileObj, successCallback, errorCallback) {
      $http.get(PUBLISHER_URL + selectedProfileObj.profileId + '/profiles/web_ga_data', {
        params: {
          'web_content_id': selectedProfileObj.webContentId,
          'web_profile_id': selectedProfileObj.selectedProfileId,
        }
      }).then(successCallback, errorCallback);
    }

    function getWebGa4Data(selectedProfileObj, successCallback, errorCallback) {
      $http.get(PUBLISHER_URL + selectedProfileObj.profileId + '/profiles/web_ga4_data', {
        params: {
          'web_content_id': selectedProfileObj.webContentId,
          'property_id': selectedProfileObj.selectedProfileId,
        }
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('PricingService', PricingService);

  /* @ngInject */
  function PricingService(lodash) {
    var service = {
      getFbTwPiPricing: getFbTwPiPricing,
      getPricingYt: getPricingYt,
      getVideoPricingYt: getVideoPricingYt,
      getPricingIn: getPricingIn,
      getVideoPricingIn: getVideoPricingIn,
      getGaPricing: getGaPricing,
      getGaVideoPricing: getGaVideoPricing,
      getPrice: getPrice,
      getVideoPrice: getVideoPrice,
      getSharingPrice: getSharingPrice,
      getFbTwVideoPricing: getFbTwVideoPricing,
      getFbTwSharingPricing: getFbTwSharingPricing
    };

    return service;

    function isRowPricingFbTwPi(network) {
      return lodash.includes(['facebook', 'twitter', 'pinterest'], network);
    }

    function isRowPricingYt(network) {
      return 'youtube' == network;
    }

    function isRowPricingIn(network) {
      return 'instagram' == network;
    }

    function between(x, min, max) {
      return x >= min && x < max;
    }

    function getPrice(followers, network) {
      var redux = Math.floor(followers / 1000);
      var element;
      if (isRowPricingFbTwPi(network)) {
        element = lodash.find(getFbTwPiPricing(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else if (isRowPricingYt(network)) {
        element = lodash.find(getPricingYt(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else if (isRowPricingIn(network)) {
        element = lodash.find(getPricingIn(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else {
        element = lodash.find(getGaPricing(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      }

      if (angular.isUndefined(element)) {
        element = { value: 0 }
      }

      return element.value;
    }

    function getVideoPrice(followers, network) {
      var redux = Math.floor(followers / 1000);
      var element;
      if (isRowPricingFbTwPi(network)) {
        element = lodash.find(getFbTwVideoPricing(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else if (isRowPricingYt(network)) {
        element = lodash.find(getVideoPricingYt(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else if (isRowPricingIn(network)) {
        element = lodash.find(getVideoPricingIn(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      } else {
        element = lodash.find(getGaVideoPricing(), function (elem) {
          return between(redux, elem.range.min, elem.range.max);
        });
      }

      if (angular.isUndefined(element)) {
        element = { value: 0 }
      }

      return element.value;
    }


    function getSharingPrice(followers, network) {
      var redux = Math.floor(followers / 1000);
      var element;
      element = lodash.find(getFbTwSharingPricing(), function (elem) {
        return between(redux, elem.range.min, elem.range.max);
      });

      return element.value;
    }


    function getGaPricing() {
      return [
        { range: { min: 3, max: 5 },        index: '500-5K',      value: '$25 - $100' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$100 - $150' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$150 - $200' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$200 - $250' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$250 - $300' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$300 - $500' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$300 - $500' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$300 - $500' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$500 - $600' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$700 - $800' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$800 - $1K' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$1K - $1.5K' },
        { range: { min: 250, max: 350 },    index: '250K-350K',   value: '$1.5K - $2K' },
        { range: { min: 250, max: 500 },    index: '350K-500K',   value: '$2K - $3K' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$3K +' }
        ];

    }

    function getGaVideoPricing() {
      return [
        { range: { min: 3, max: 5 },        index: '500-5K',      value: '$75 - $300' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$300 - $450' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$450 - $600' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$600 - $750' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$750 - $900' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$900 - $1.5K' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$900 - $1.5K' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$900 - $1.5K' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$1.5K - $1.8K' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$2.1K - $2.4K' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$2.4K - $3K' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$3K - $4.5K' },
        { range: { min: 250, max: 350 },    index: '250K-350K',   value: '$4.5K - $6K' },
        { range: { min: 250, max: 500 },    index: '350K-500K',   value: '$6K - $9K' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$9K +' }
        ];
    }

    function getFbTwPiPricing() {
      return [
        { range: { min: 0, max: 1 },        index: '1K or less',  value: '$5' },
        { range: { min: 1, max: 5 },        index: '1K-5K',       value: '$10 - $25' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$25 - $50' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$50 - $75' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$75 - $100' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$100 - $125' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$125 - $150' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$150 - $200' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$200 - $300' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$300 - $400' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$500 - $600' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$600 - $700' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$700 - $800' },
        { range: { min: 250, max: 500 },    index: '250K-500K',   value: '$800 - $1000' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$1000 +' }
        ];
    }

    function getFbTwVideoPricing() {
      return [
        { range: { min: 0, max: 1 },        index: '1K or less',  value: '$15' },
        { range: { min: 1, max: 5 },        index: '1K-5K',       value: '$30 - $75' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$75 - $150' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$150 - $225' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$225 - $300' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$300 - $375' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$375 - $450' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$450 - $600' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$600 - $900' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$900 - $1.2K' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$1.5K - $1.8K' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$1.8K - $2.1K' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$2.1K - $2.4K' },
        { range: { min: 250, max: 500 },    index: '250K-500K',   value: '$2.1K - $3K' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$3 +' }
      ];
    }

    function getFbTwSharingPricing() {
      return [
        { range: { min: 0, max: 1 },        index: '1K or less',  value: '$2.5' },
        { range: { min: 1, max: 5 },        index: '1K-5K',       value: '$5 - $12.5' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$12.5 - $25' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$25 - $37.5' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$37.5 - $50' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$50 - $62.5' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$62.5 - $75' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$75 - $100' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$100 - $150' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$150 - $200' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$250 - $300' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$300 - $350' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$350 - $400' },
        { range: { min: 250, max: 500 },    index: '250K-500K',   value: '$400 - $500' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$500 +' }
      ];
    }

    function getPricingYt() {
      return [
        { range: { min: 0, max: 2 },        index: '2K or less',  value: '$20' },
        { range: { min: 2, max: 5 },        index: '2K-5K',       value: '$20 - $50' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$50 - $75' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$75 - $100' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$100 - $150' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$150 - $200' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$200 - $250' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$250 - $300' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$300 - $350' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$350 - $400' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$400 - $500' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$500 - $600' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$600 - $750' },
        { range: { min: 250, max: 500 },    index: '250K-500K',   value: '$750 - $1K' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$1K +' }
        ];
    }

    function getVideoPricingYt() {
      return [
        { range: { min: 0, max: 2 },        index: '2K or less',  value: '$40' },
        { range: { min: 2, max: 5 },        index: '2K-5K',       value: '$40 - $100' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$100 - $150' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$150 - $200' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$200 - $300' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$300 - $400' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$400 - $500' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$500 - $600' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$600 - $700' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$700 - $800' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$800 - $1K' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$1K - $1.2K' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$1.2K - $1.5K' },
        { range: { min: 250, max: 500 },    index: '250K-500K',   value: '$1.5K - $2K' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$2K +' }
      ];
    }

    function getPricingIn() {
      return [
        { range: { min: 0, max: 1 },        index: 'less than 1K ',  value: '$5 to $15' },
        { range: { min: 1, max: 2 },        index: '1K-2K',       value: '$20 - $50' },
        { range: { min: 2, max: 5 },        index: '2K-5K',       value: '$50 - $75' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$75 - $100' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$100 - $125' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$125 - $150' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$150 - $175' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$175 - $200' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$225 - $250' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$250 - $300' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$300 - $350' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$350 - $400' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$400 - $450' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$450 - $500' },
        { range: { min: 250, max: 350 },    index: '250K-350K',   value: '$500 - $550' },
        { range: { min: 350, max: 500 },    index: '350K-500K',   value: '$550 - $600' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$750' }
        ];
    }

    function getVideoPricingIn() {
      return [
        { range: { min: 0, max: 1 },        index: 'less than 1K ',  value: '$7.5 to $22.5' },
        { range: { min: 1, max: 2 },        index: '1K-2K',       value: '$30 - $75' },
        { range: { min: 2, max: 5 },        index: '2K-5K',       value: '$75 - $112.5' },
        { range: { min: 5, max: 10 },       index: '5K-10K',      value: '$112.5 - $150' },
        { range: { min: 10, max: 15 },      index: '10K-15K',     value: '$150 - $187.5' },
        { range: { min: 15, max: 20 },      index: '15K-20K',     value: '$187.5 - $225' },
        { range: { min: 20, max: 30 },      index: '20K-30K',     value: '$225 - $262.5' },
        { range: { min: 30, max: 40 },      index: '30K-40K',     value: '$262.5 - $300' },
        { range: { min: 40, max: 50 },      index: '40K-50K',     value: '$300 - $375' },
        { range: { min: 50, max: 75 },      index: '50K-75K',     value: '$375 - $450' },
        { range: { min: 75, max: 100 },     index: '75K-100K',    value: '$450 - $525' },
        { range: { min: 100, max: 150 },    index: '100K-150K',   value: '$525 - $600' },
        { range: { min: 150, max: 200 },    index: '150K-200K',   value: '$600 - $675' },
        { range: { min: 200, max: 250 },    index: '200K-250K',   value: '$675 - $750' },
        { range: { min: 250, max: 350 },    index: '250K-350K',   value: '$750 - $825' },
        { range: { min: 350, max: 500 },    index: '350K-500K',   value: '$825 - $900' },
        { range: { min: 500, max: 100000 }, index: '500K +',      value: '$1125' }
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('PayoutService', PayoutService);

  /* @ngInject */
  function PayoutService($timeout, $http, EnvironmentConfig) {
    var PAYOUT_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/payouts';

    var service = {
      indexPayoutItems: indexPayoutItems
    };

    return service;

    function indexPayoutItems(date_from, date_to, successCallback, errorCallback) {
      $http.get(PAYOUT_URL, {
        params: {
          date_from: date_from,
          date_to: date_to
        }
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('PaymentsService', PaymentsService);

  /* @ngInject */
  function PaymentsService($http, EnvironmentConfig) {
    var PAYMENTS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/payments';

    var service = {
      getPaymentToken: getPaymentToken,
      payment: payment,
      getCybersourcePaymentToken: getCybersourcePaymentToken,
      authCybersourcePayment: authCybersourcePayment,
      getStripeClientSecret: getStripeClientSecret,
      authStripePayment: authStripePayment,
      authMidsourcePayment: authMidsourcePayment,
      getCurrentProcessor: getCurrentProcessor
    };

    return service;

    // braintree
    function getPaymentToken(successCallback, errorCallback) {
      $http.get(PAYMENTS_URL + '/token').then(successCallback, errorCallback);
    }

    // braintree
    function payment(paymentNonce, token, ordersIds, lastFour, storePaymentMethod, successCallback, errorCallback) {
      $http.post(PAYMENTS_URL + '/pay', {
        orders_ids: ordersIds,
        payment_nonce: paymentNonce,
        payment_token: token,
        last_four: lastFour,
        store_payment_method: storePaymentMethod
      }).then(successCallback, errorCallback);
    }

    function getCybersourcePaymentToken(successCallback, errorCallback) {
      $http.get(PAYMENTS_URL + '/cybersource_token').then(successCallback, errorCallback);
    }

    function authCybersourcePayment(token, orderIds, storePaymentMethod, cardBillingInfo, successCallback, errorCallback) {
      $http.post(PAYMENTS_URL + '/pay_cybersource', {
        order_ids: orderIds,
        payment_token: token,
        store_payment_method: storePaymentMethod,
        first_name: cardBillingInfo.first_name,
        last_name: cardBillingInfo.last_name,
        address: cardBillingInfo.address,
        address2: cardBillingInfo.address2,
        city: cardBillingInfo.city,
        state: cardBillingInfo.state,
        zip: cardBillingInfo.zip,
        country: cardBillingInfo.country,
        email: cardBillingInfo.email,
        exp_month: cardBillingInfo.exp_month,
        exp_year: cardBillingInfo.exp_year
      }).then(successCallback, errorCallback);
    }

    function getStripeClientSecret(orderIds, successCallback, errorCallback) {
      $http.get(PAYMENTS_URL + '/stripe_client_secret', {
        params: { order_ids: orderIds }
      }).then(successCallback, errorCallback);
    }

    function authStripePayment(paymentMethodId, orderIds, storePaymentMethod, cardBillingInfo, successCallback, errorCallback) {
      $http.post(PAYMENTS_URL + '/pay_stripe', {
        payment_method_id: paymentMethodId,
        order_ids: orderIds,
        store_payment_method: storePaymentMethod,
        first_name: cardBillingInfo.first_name,
        last_name: cardBillingInfo.last_name,
        address: cardBillingInfo.address,
        address2: cardBillingInfo.address2,
        city: cardBillingInfo.city,
        state: cardBillingInfo.state,
        zip: cardBillingInfo.zip,
        country: cardBillingInfo.country || 'US'
      }).then(successCallback, errorCallback);
    }

    function authMidsourcePayment(paymentToken, orderIds, storePaymentMethod, cardBillingInfo, successCallback, errorCallback) {
      $http.post(PAYMENTS_URL + '/pay_midsource', {
        payment_token: paymentToken,
        order_ids: orderIds,
        store_payment_method: storePaymentMethod,
        first_name: cardBillingInfo.first_name,
        last_name: cardBillingInfo.last_name,
        address: cardBillingInfo.address,
        address2: cardBillingInfo.address2,
        city: cardBillingInfo.city,
        state: cardBillingInfo.state,
        zip: cardBillingInfo.zip,
        country: cardBillingInfo.country || 'US',
        masked_number: cardBillingInfo.masked_number,
        card_type: cardBillingInfo.card_type,
        exp_month: cardBillingInfo.exp_month,
        exp_year: cardBillingInfo.exp_year
      }, {
        timeout: 20000
      }).then(successCallback, errorCallback);
    }

    function getCurrentProcessor(successCallback, errorCallback) {
      $http.get(PAYMENTS_URL + '/current_processor').then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('PasswordMeter', PasswordMeter);

  /* @ngInject */
  function PasswordMeter() {

    var service = {
      evaluatePassword: evaluatePassword
    };

    return service;

    function evaluatePassword(password) {
      return zxcvbn(password).score;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('OrdersService', OrdersService);

  /** @ngInject */
  function OrdersService($http, EnvironmentConfig, Upload, lodash) {
    var ADV_ORDERS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/orders';
    var PUB_ORDERS_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/orders';
    var orderList = [];

    var service = {
      indexOrders: indexOrders,
      indexOrdersCart: indexOrdersCart,
      indexOrdersCheckout: indexOrdersCheckout,
      indexOrdersWithoutLimit: indexOrdersWithoutLimit,
      showOrder: showOrder,
      createOrder: createOrder,
      createOrderFromCampaign: createOrderFromCampaign,
      createOrders: createOrders,
      updateOrder: updateOrder,
      deleteOrder: deleteOrder,
      deleteOrders: deleteOrders,
      isOrdered: isOrdered,
      indexCompletedOrders: indexCompletedOrders,
      alreadyOrdered: alreadyOrdered,
      alreadyOrderedForCampaign: alreadyOrderedForCampaign,
      orderAlreadyOrderedForCampaign: orderAlreadyOrderedForCampaign,
      setInCheckout: setInCheckout,
      sendToCheckout: sendToCheckout,
      removeFromCheckout: removeFromCheckout
    };

    return service;

    // Functions
    function indexOrders(successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL).then(function (response) {
        angular.copy(response.data.orders, orderList);
        successCallback(orderList);
      }, errorCallback);
    }

    function indexOrdersWithoutLimit(order, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL,{
        params: {
          page: order.page,
          status: 'active',
          q: order.filter  
        }
      }).then(function (response) {
        angular.copy(response.data.orders, orderList);
        successCallback(orderList);
      }, errorCallback);
    }
    function indexOrdersCart( order, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL,{
        params: {
          page: order.page,
          limit: order.limit,
          status: 'active',
          q: order.filter,
          field: order.order
        }
      }).then(function (response) {
        angular.copy(response.data.orders, orderList);
        successCallback(orderList, response);
      }, errorCallback);
    }
    function indexOrdersCheckout(successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL,{
        params: {
          in_checkout: true
        }
      }).then(function (response) {
        angular.copy(response.data.orders, orderList);
        successCallback(orderList, response);
      }, errorCallback);
    }

    function showOrder(id, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function createOrder(urlId, orderOrigin, successCallback, errorCallback) {
      $http.post(ADV_ORDERS_URL, {
        order: {
          'url_id': urlId,
          'created_from': orderOrigin
        }
      }).then(function (response) {
        orderList.push(response.data);
        successCallback();
      }, errorCallback);
    }

    function createOrderFromCampaign(campaignId, urlId, orderOrigin, successCallback, errorCallback) {
      $http.post(ADV_ORDERS_URL, {
        order: {
          'url_id': urlId,
          'created_from': orderOrigin,
          'searched_campaign_id': campaignId
        }
      }).then(function (response) {
        orderList.push(response.data);
        successCallback();
      }, errorCallback);
    }

    function createOrders(urlIds, contentId, orderOrigin, successCallback, errorCallback) {
      $http.post(ADV_ORDERS_URL + '/bulk_create', {
        orders: {
          url_ids: urlIds,
          content_id: contentId,
          created_from: orderOrigin
        }
      }).then(successCallback, errorCallback);
    }

    function updateOrder(id, blogPost, successCallback, errorCallback) {
      var body = {
        order: {
          ad_attributes: {
            id: blogPost.id,
            link_id: blogPost.link.id,
            url_id: blogPost.url.id,
            url_price: blogPost.url.shown_price,
            campaign_id: blogPost.campaign.id,
            blog_post_title: blogPost.blog_post_title,
            blog_post_body: blogPost.blog_post_body,
            blog_post_image_1: blogPost.image_1,
            blog_post_image_2: blogPost.image_2,
            blog_post_doc: blogPost.word,
            link_text: blogPost.link_text
          }
        }
      };

      if (!blogPost.link_text) {
        delete body.order.ad_attributes.link_text;
      }
      if (!blogPost.blog_post_body) {
        delete body.order.ad_attributes.blog_post_body;
      }

      Upload.upload({
        url: ADV_ORDERS_URL + '/' + id,
        method: 'PUT',
        fields: body
      }).then(function (response) {
        successCallback(response)
      }, errorCallback);
    }

    function deleteOrder(orderId, successCallback, errorCallback) {
      $http.delete(ADV_ORDERS_URL + '/' + orderId).then(
        function () {
          lodash.remove(orderList, function (order) {
            return order.id == orderId
          });
          successCallback();
        }, errorCallback);
    }

    function deleteOrders(ordersIds, successCallback, errorCallback) {
      $http.delete(ADV_ORDERS_URL + '/soft_destroy_list', {
        params: {
          'orders_ids[]': ordersIds
        }
      }).then(
        function () {
          lodash.pullAll(orderList, ordersIds);
          successCallback();
        }, errorCallback);
    }

    function isOrdered(urlId) {
      return lodash.findIndex(orderList, ['url.id', urlId]) >= 0;
    }

    function indexCompletedOrders(query, successCallback, errorCallback) {
      $http.get(PUB_ORDERS_URL,{
        params:{
        page: query.page,
        limit: query.limit,
        field: query.order,
        order_by: query.orderBy,
        q: query.filter

      }
      }).then(successCallback, errorCallback);
    }

    function alreadyOrdered(urlId, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL + '/' + urlId + '/already_ordered').then(successCallback, errorCallback);
    }

    function alreadyOrderedForCampaign(urlId, campaignId, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL + '/' + urlId + '/' + campaignId + '/already_ordered_for_campaign').then(successCallback, errorCallback);
    }

    function orderAlreadyOrderedForCampaign(orderId, urlId, campaignId, successCallback, errorCallback) {
      $http.get(ADV_ORDERS_URL + '/' + orderId + '/' + urlId + '/' + campaignId + '/order_already_ordered_for_campaign').then(successCallback, errorCallback);
    }

    function setInCheckout(orderIds, inCheckout, successCallback, errorCallback) {
      $http.post(ADV_ORDERS_URL + '/set_in_checkout', {
        'order_ids': orderIds,
        'in_checkout': inCheckout
      }).then(
        function () {
          successCallback();
        }, errorCallback);
    }
    function sendToCheckout(orderIds, successCallback, errorCallback) {
      setInCheckout(orderIds, true, successCallback, errorCallback);
    }
    function removeFromCheckout(orderIds, successCallback, errorCallback) {
      setInCheckout(orderIds, false, successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('NotificationService', NotificationService);

  /** @ngInject */
  function NotificationService($http, $state, $rootScope, $timeout, EnvironmentConfig, lodash,
    POLL_TIME, TYPE_STATE, ROLE) {
    var ADV_NOTIFICATION_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/notifications';
    var PUB_NOTIFICATION_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/notifications';

    var service = {
      deleteNotification: deleteNotification
    };

    return service;

    function deleteNotification(type, role) {
      var URL = role === ROLE.ADV ? ADV_NOTIFICATION_URL : PUB_NOTIFICATION_URL;
      $http.delete(URL + '/destroy_type?type=' + type).then(function () {
        switch (type) {
        case TYPE_STATE.ACTIVE_CONTENT:
          $rootScope.badgeActive = 0;
          break;
        case TYPE_STATE.AWAITING_PUBLICATION:
          $rootScope.badgeAwaiting = 0;
          break;
        case TYPE_STATE.APPROVED_URL:
          $rootScope.badgeApproved = 0;
          break;
        case TYPE_STATE.REJECTED_CONTENT:
          $rootScope.badgeReused = 0;
          break;
        case TYPE_STATE.ACTIVE_ADS:
          $rootScope.badgeActiveAds = 0;
          break;
        case TYPE_STATE.NEW_ORDERS:
          $rootScope.badgeNewOrders = 0;
          break;
        case TYPE_STATE.PRICING_AND_PAUSING:
          $rootScope.badgePricingAndPausing = 0;
          break;
        case TYPE_STATE.RESUBMITTED_CONTENT:
          $rootScope.badgeReSubmitted = 0;
          break
        case TYPE_STATE.QUOTES:
          $rootScope.counterQuotes = 0;
          break;
        case TYPE_STATE.ARTICLES:
          $rootScope.counterArticles = 0;
          break;
        case TYPE_STATE.MESSAGES:
          $rootScope.counterMessages = 0;
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('MessagesService', MessagesService);

  /** @ngInject */
  function MessagesService($http, EnvironmentConfig, lodash, SessionService) {
    var ADV_MSG_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/messages';
    var PUB_MSG_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/messages';

    var service = {
      getMessages: getMessages,
      createMessage: createMessage,
      updateState: updateState
    };

    return service;

    // Functions
    function getMessages(currentPage, successCallback, errorCallback) {
      $http.get(getUrl() + '?page=' + currentPage).then(successCallback, errorCallback);
    }

    function createMessage(data, successCallback, errorCallback) {
      $http.post(getUrl(), {
        message: {
          subject: data.subject,
          question_message: data.question_message
        }
      }).then(successCallback, errorCallback);
    }

    function updateState(data, successCallback, errorCallback) {
      $http.put(getUrl() + '/' + data.id + '/read').then(successCallback, errorCallback);
    }

    function getUrl() {
      if (SessionService.isAdvertiser()) {
        return ADV_MSG_URL;
      } else if(SessionService.isPublisher()) {
        return PUB_MSG_URL;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('LinksService', LinksService);

  /** @ngInject */
  function LinksService($http, EnvironmentConfig, Upload, lodash) {
    var LINKS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/links';

    var service = {
      deleteLink: deleteLink,
      getLinks: getLinks,
      getActiveLinks: getActiveLinks
    };

    return service;

    // Functions
    function deleteLink(id, successCallback, errorCallback) {
      $http.delete(LINKS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function getLinks(id, successCallback, errorCallback) {
      $http.get(LINKS_URL + '/' + id + '/orders_built').then(successCallback, errorCallback);
    }

    function getActiveLinks(id, successCallback, errorCallback) {
      $http.get(LINKS_URL + '/' + id + '/active_orders_built').then(successCallback, errorCallback);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('InvoiceService', InvoiceService);

  /* @ngInject */
  function InvoiceService($http, EnvironmentConfig) {
    var INVOICE_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/invoices';

    var service = {
      indexInvoice: indexInvoice,
      getInvoicePdf: getInvoicePdf
    };

    return service;

    function indexInvoice(query, successCallback, errorCallback) {
      $http.get(INVOICE_URL, {
        params: {
          q: query.filter,
          page: query.page,
          limit: query.limit
        }
      }).then(successCallback, errorCallback);
    }

    function getInvoicePdf(id, successCallback, errorCallback) {
      $http.get(INVOICE_URL + '/' + id + '/get_pdf')
        .then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('IntroJsService', IntroJsService);

  /** @ngInject */
  function IntroJsService($window) {
    if(!$window.introJs){
      // If introJs is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window.introJs;
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('GoogleSingleSignOnService', GoogleSingleSignOnService);

  /* @ngInject */
  function GoogleSingleSignOnService(EnvironmentConfig) {
    var service = {
      googleInit: googleInit,
      renderGoogleButton: renderGoogleButton
    };

    return service;

    function googleInit(callback) {
      google.accounts.id.initialize({
        client_id: EnvironmentConfig.CLIENT_ID,
        callback: callback
      });
    }

    function renderGoogleButton() {
      google.accounts.id.renderButton(
        document.getElementById("g_id_onload"),
        {
          theme: "filled_blue",
          size: "large",
          logo_alignment: "left",
          width: 100
        }  // customization attributes
      );
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('GoogleService', GoogleService);

  /* @ngInject */
  function GoogleService(EnvironmentConfig, SCOPE) {
    var service = {
      authorize: authorize,
      queryAccounts: queryAccounts,
      queryProperties: queryProperties,
      queryProfiles: queryProfiles,
      queryCoreReportingApi: queryCoreReportingApi,
      queryYouTubeStatistics: queryYouTubeStatistics
    };

    return service;

    function authorize(event, successCallback) {
      // Handles the authorization flow. `immediate` should be false when invoked from the button click.
      var useImmdiate = !event;
      var client = google.accounts.oauth2.initTokenClient({
          client_id:  EnvironmentConfig.CLIENT_ID,
          scope: SCOPE.ANALYTICS + ' ' + SCOPE.YOUTUBE,
          immediate: useImmdiate,
          callback: successCallback,
          errorCallback: successCallback
      }); 
      client.requestAccessToken();
    }

    function queryAccounts(successCallback, errorCallback) {
      gapi.client.load('analytics', 'v3').then(function () {
        // Get a list of all Google Analytics accounts for this user
        gapi.client.analytics.management.accounts.list().then(successCallback, errorCallback);
      });
    }

    function queryProperties(account, successCallback, errorCallback) {
      gapi.client.analytics.management.webproperties.list({
          accountId: account.id
        })
        .then(successCallback)
        .then(null, errorCallback);
    }

    function queryProfiles(property, successCallback, errorCallback) {
      gapi.client.analytics.management.profiles.list({
          accountId: property.accountId,
          webPropertyId: property.id
        })
        .then(successCallback)
        .then(null, errorCallback);
    }

    function queryCoreReportingApi(profileId, successCallback, errorCallback) {
      console.log('queryCoreReportingApi - profileId:', profileId);
      gapi.client.analytics.data.ga.get({
          'ids': 'ga:' + profileId,
          'start-date': '28daysAgo',
          'end-date': 'today',
          'metrics': 'ga:users'
        })
        .then(successCallback)
        .then(null, errorCallback);
    }

    function queryYouTubeStatistics(successCallback) {
      gapi.client.request({
        'method': 'GET',
        'path': '/youtube/v3/channels',
        'params': {'part': 'statistics', 'mine': 'true'}
      }).then(successCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('FacebookService', FacebookService);

  /* @ngInject */
  function FacebookService($http, EnvironmentConfig, $stateParams) {
    var PROFILES_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/profiles/';

    var FACEBOOK_LOGIN_SCOPES = 'pages_show_list,public_profile';
    var INSTAGRAM_LOGIN_SCOPES = 'instagram_basic,pages_show_list,pages_read_engagement';
    var PAGE_FIELDS = 'fan_count,username,name,instagram_business_account,cover,picture.type(large)';
    var INSTAGRAM_FIELDS = 'followers_count,username';

    var userAccouts = [];
    var instagramBusinessAccountId;

    var service = {
      authenticate: authenticate,
      authenticateAndGetShortToken: authenticateAndGetShortToken,
      getUserAccounts: getUserAccounts,
      getFanPageData: getFanPageData,
      checkForInstagramBusinessAccount: checkForInstagramBusinessAccount,
      getInstagramAccountData: getInstagramAccountData,
      userHasAccounts: userHasAccounts,
      revokePermissions: revokePermissions
    };

    return service;

    // depreciated, authenticateAndGetShortToken preferred
    function authenticate(network, successCallback, errorCallback) {
      instagramBusinessAccountId = null;
      FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          FB.logout(function(response) {
            if (response.status === 'unknown') {
              loginFacebook(network, successCallback, errorCallback)
            }
          });
        } else {
          loginFacebook(network, successCallback, errorCallback)
        }
      });
    }

    // depreciated, preferred loginFacebookAndGetShortToken
    function loginFacebook(network, successCallback, errorCallback) {
      FB.login(function (response) {
        if (response.authResponse) {
          var userId = response.authResponse.userID;
          successCallback(userId);
        } else {
          errorCallback('Facebook login failed');
        }
      }, {
        scope: network === 'facebook' ? FACEBOOK_LOGIN_SCOPES : INSTAGRAM_LOGIN_SCOPES,
        return_scopes: true
      });
    }

    function authenticateAndGetShortToken(network, successCallback, errorCallback) {
      instagramBusinessAccountId = null;
      FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          FB.logout(function(response) {
            if (response.status === 'unknown') {
              loginFacebookAndGetShortToken(network, successCallback, errorCallback)
            }
          });
        } else {
          loginFacebookAndGetShortToken(network, successCallback, errorCallback)
        }
      });
    }

    function loginFacebookAndGetShortToken(network, successCallback, errorCallback) {
      FB.login(function (response) {
        if (response.authResponse) {
          var userId = response.authResponse.userID;
          var accessToken = response.authResponse.accessToken;
          successCallback(userId, accessToken);
        } else {
          errorCallback('Facebook login failed');
        }
      }, {
        scope: network === 'facebook' ? FACEBOOK_LOGIN_SCOPES : INSTAGRAM_LOGIN_SCOPES,
        return_scopes: true
      });
    }

    function revokePermissions() {
      FB.api('/me/permissions', 'delete', function(response) {
        console.log(response);
      });
    }

    function getUserAccounts(userId, successCallback, errorCallback) {
      FB.api('/' + userId + '/accounts', 'GET', {
        fields: PAGE_FIELDS
        }, function (response) {
        if (response.data.length) {
          userAccouts = response.data;
          successCallback(userAccouts);
        } else {
          errorCallback('No pages found for user');
        }
      });
    }

    function getFanPageData(fanPageId, successCallback, errorCallback) {
      if (!userHasAccounts()) {
        errorCallback('No pages found for user');
      }

      FB.api('/' + fanPageId, {
        fields: PAGE_FIELDS
      }, function (response) {
        if (response.instagram_business_account) {
          instagramBusinessAccountId = response.instagram_business_account.id;
        }
        successCallback(response);
      });
    }

    function checkForInstagramBusinessAccount(fanPageId, successCallback, errorCallback) {
      if (!userHasAccounts()) {
        errorCallback('No pages found for user');
      }

      if(!instagramBusinessAccountId) {
        getFanPageData(fanPageId,function (response) {
          if(instagramBusinessAccountId) {
            getInstagramAccountData(successCallback, errorCallback);
          } else {
            errorCallback('No Instagram business account found');
          }
        }, function (error) {
          errorCallback(error);
        });
      } else {
        getInstagramAccountData(successCallback, errorCallback);
      }
    }

    function getInstagramAccountData(successCallback, errorCallback) {
      FB.api('/' + instagramBusinessAccountId, {
        fields: INSTAGRAM_FIELDS
      }, function (response) {
        if (response) {
          successCallback(response);
        } else {
          errorCallback('Error while retrieving Instagram account information');
        }
      });
    }

    function userHasAccounts() {
      return userAccouts.length > 0;
    }

    // depreciated as we now handle this all on the back end when adding / updating fb social handle
    function generateFBLongLivedToken(userId, accessToken) {
      var profileId = $stateParams.profileId;
      var url = PROFILES_URL + profileId + '/generate_long_lived_facebook_token';
      return $http.post(url, {
        access_token: accessToken,
        fb_user_id: userId
      }).then(function (response) {
        if (response) {
          console.log("Successfully generated long lived token", response);
        } else {
          console.log('Error while retrieving Facebook information');
        }
      }); 
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('EthnicitiesService', EthnicitiesService);

  /** @ngInject */
  function EthnicitiesService($http, EnvironmentConfig) {
    var ETHNICITIES_URL = EnvironmentConfig.API_END_POINT + '/ethnicities';

    var service = {
      indexEthnicities: indexEthnicities
    };

    return service;

    // Functions
    function indexEthnicities(successCallback, errorCallback) {
      $http.get(ETHNICITIES_URL).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('CreditCardService', CreditCardService);

  /* @ngInject */
  function CreditCardService($http, EnvironmentConfig) {
    var CREDIT_CARDS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/credit_cards';
    var Cybersource_CREDIT_CARDS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/credit_cards/cybersource_credit_cards';
    var Stripe_CREDIT_CARDS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/credit_cards/stripe_credit_cards';
    var Midsource_CREDIT_CARDS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/credit_cards/midsource_credit_cards';

    var service = {
      indexCreditCards: indexCreditCards,
      createCreditCard: createCreditCard,
      updateCreditCard: updateCreditCard,
      deleteCreditCard: deleteCreditCard,
      getCreditCard: getCreditCard,
      createCybersourceCreditCard: createCybersourceCreditCard,
      createStripeCreditCard: createStripeCreditCard,
      createMidsourceCreditCard: createMidsourceCreditCard
    };

    return service;

    function indexCreditCards(successCallback, errorCallback) {
      $http.get(CREDIT_CARDS_URL).then(successCallback, errorCallback);
    }

    function getCreditCard(cardId, successCallback, errorCallback) {
      $http.get(CREDIT_CARDS_URL + '/' + cardId).then(successCallback, errorCallback);
    }

    function createCreditCard(nonce, successCallback, errorCallback) {
      $http.post(CREDIT_CARDS_URL, {
        credit_card: {
          payment_nonce: nonce,
        }
      }).then(successCallback, errorCallback);
    }

    function createCybersourceCreditCard(token, cardBillingInfo , successCallback, errorCallback) {
      $http.post(Cybersource_CREDIT_CARDS_URL, {
        credit_card: {
          payment_token: token,
          first_name: cardBillingInfo.first_name,
          last_name: cardBillingInfo.last_name,
          address: cardBillingInfo.address,
          address2: cardBillingInfo.address2,
          city: cardBillingInfo.city,
          state: cardBillingInfo.state,
          zip: cardBillingInfo.zip,
          country: cardBillingInfo.country,
          exp_month: cardBillingInfo.exp_month,
          exp_year: cardBillingInfo.exp_year
        }
      }).then(successCallback, errorCallback);
    }

    function createStripeCreditCard(paymentMethodId, cardBillingInfo, successCallback, errorCallback) {
      $http.post(Stripe_CREDIT_CARDS_URL, {
        credit_card: {
          payment_method_id: paymentMethodId,
          first_name: cardBillingInfo.first_name,
          last_name: cardBillingInfo.last_name,
          address: cardBillingInfo.address,
          address2: cardBillingInfo.address2,
          city: cardBillingInfo.city,
          state: cardBillingInfo.state,
          zip: cardBillingInfo.zip,
          country: cardBillingInfo.country || 'US'
        }
      }).then(successCallback, errorCallback);
    }

    function createMidsourceCreditCard(paymentToken, cardBillingInfo, successCallback, errorCallback) {
      $http.post(Midsource_CREDIT_CARDS_URL, {
        credit_card: {
          payment_token: paymentToken,
          first_name: cardBillingInfo.first_name,
          last_name: cardBillingInfo.last_name,
          address: cardBillingInfo.address,
          address2: cardBillingInfo.address2,
          city: cardBillingInfo.city,
          state: cardBillingInfo.state,
          zip: cardBillingInfo.zip,
          country: cardBillingInfo.country || 'US',
          masked_number: cardBillingInfo.masked_number,
          card_type: cardBillingInfo.card_type,
          exp_month: cardBillingInfo.exp_month,
          exp_year: cardBillingInfo.exp_year
        }
      }).then(successCallback, errorCallback);
    }

    function updateCreditCard(id, nonce, token, successCallback, errorCallback) {
      $http.put(CREDIT_CARDS_URL + '/' + id, {
        credit_card: {
          payment_nonce: nonce,
          payment_token: token,
        }
      }).then(successCallback, errorCallback);
    }

    function deleteCreditCard(cardId, successCallback, errorCallback) {
      $http.delete(CREDIT_CARDS_URL + '/' + cardId).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('CountriesService', CountriesService);

  /* @ngInject */
  function CountriesService() {
    var service = {
      getAllCountries: getAllCountries
    };

    return service;

    function getAllCountries() {
      return [{
          code: 'AF',
          name: 'Afghanistan'
        },
        {
          code: 'AL',
          name: 'Albania'
        },
        {
          code: 'DZ',
          name: 'Algeria'
        },
        {
          code: 'AS',
          name: 'American Samoa'
        },
        {
          code: 'AD',
          name: 'Andorre'
        },
        {
          code: 'AO',
          name: 'Angola'
        },
        {
          code: 'AI',
          name: 'Anguilla'
        },
        {
          code: 'AQ',
          name: 'Antarctica'
        },
        {
          code: 'AG',
          name: 'Antigua and Barbuda'
        },
        {
          code: 'AR',
          name: 'Argentina'
        },
        {
          code: 'AM',
          name: 'Armenia'
        },
        {
          code: 'AW',
          name: 'Aruba'
        },
        {
          code: 'AU',
          name: 'Australia'
        },
        {
          code: 'AT',
          name: 'Austria'
        },
        {
          code: 'AZ',
          name: 'Azerbaijan'
        },
        {
          code: 'BS',
          name: 'Bahamas'
        },
        {
          code: 'BH',
          name: 'Bahrain'
        },
        {
          code: 'BD',
          name: 'Bangladesh'
        },
        {
          code: 'BB',
          name: 'Barbade'
        },
        {
          code: 'BY',
          name: 'Belarus'
        },
        {
          code: 'BE',
          name: 'Belgium'
        },
        {
          code: 'BZ',
          name: 'Belize'
        },
        {
          code: 'BJ',
          name: 'Benin'
        },
        {
          code: 'BM',
          name: 'Bermuda'
        },
        {
          code: 'BT',
          name: 'Bhutan'
        },
        {
          code: 'BO',
          name: 'Bolivia'
        },
        {
          code: 'BQ',
          name: 'Bonaire, Sint Eustatius and Saba'
        },
        {
          code: 'BA',
          name: 'Bosnia and Herzegovina'
        },
        {
          code: 'BW',
          name: 'Botswana'
        },
        {
          code: 'BV',
          name: 'Bouvet Island'
        },
        {
          code: 'BR',
          name: 'Brazil'
        },
        {
          code: 'IO',
          name: 'British Indian Ocean Territory'
        },
        {
          code: 'VG',
          name: 'British Virgin Islands'
        },
        {
          code: 'BN',
          name: 'Brunei'
        },
        {
          code: 'BG',
          name: 'Bulgaria'
        },
        {
          code: 'BF',
          name: 'Burkina Faso'
        },
        {
          code: 'BI',
          name: 'Burundi'
        },
        {
          code: 'KH',
          name: 'Cambodia'
        },
        {
          code: 'CM',
          name: 'Cameroon'
        },
        {
          code: 'CA',
          name: 'Canada'
        },
        {
          code: 'CV',
          name: 'Cape Verde'
        },
        {
          code: 'KY',
          name: 'Cayman Islands'
        },
        {
          code: 'CF',
          name: 'Central African Republic'
        },
        {
          code: 'TD',
          name: 'Chad'
        },
        {
          code: 'CL',
          name: 'Chile'
        },
        {
          code: 'CN',
          name: 'China'
        },
        {
          code: 'CX',
          name: 'Christmas Island'
        },
        {
          code: 'CC',
          name: 'Cocos (Keeling) Islands'
        },
        {
          code: 'CO',
          name: 'Colombia'
        },
        {
          code: 'KM',
          name: 'Comoros'
        },
        {
          code: 'CG',
          name: 'Congo'
        },
        {
          code: 'CD',
          name: 'Congo (Dem. Rep.)'
        },
        {
          code: 'CK',
          name: 'Cook Islands'
        },
        {
          code: 'CR',
          name: 'Costa Rica'
        },
        {
          code: 'ME',
          name: 'Crna Gora'
        },
        {
          code: 'HR',
          name: 'Croatia'
        },
        {
          code: 'CU',
          name: 'Cuba'
        },
        {
          code: 'CW',
          name: 'Curaçao'
        },
        {
          code: 'CY',
          name: 'Cyprus'
        },
        {
          code: 'CZ',
          name: 'Czech Republic'
        },
        {
          code: 'CI',
          name: "Côte D'Ivoire"
        },
        {
          code: 'DK',
          name: 'Denmark'
        },
        {
          code: 'DJ',
          name: 'Djibouti'
        },
        {
          code: 'DM',
          name: 'Dominica'
        },
        {
          code: 'DO',
          name: 'Dominican Republic'
        },
        {
          code: 'TL',
          name: 'East Timor'
        },
        {
          code: 'EC',
          name: 'Ecuador'
        },
        {
          code: 'EG',
          name: 'Egypt'
        },
        {
          code: 'SV',
          name: 'El Salvador'
        },
        {
          code: 'GQ',
          name: 'Equatorial Guinea'
        },
        {
          code: 'ER',
          name: 'Eritrea'
        },
        {
          code: 'EE',
          name: 'Estonia'
        },
        {
          code: 'ET',
          name: 'Ethiopia'
        },
        {
          code: 'FK',
          name: 'Falkland Islands'
        },
        {
          code: 'FO',
          name: 'Faroe Islands'
        },
        {
          code: 'FJ',
          name: 'Fiji'
        },
        {
          code: 'FI',
          name: 'Finland'
        },
        {
          code: 'FR',
          name: 'France'
        },
        {
          code: 'GF',
          name: 'French Guiana'
        },
        {
          code: 'PF',
          name: 'French Polynesia'
        },
        {
          code: 'TF',
          name: 'French Southern Territories'
        },
        {
          code: 'GA',
          name: 'Gabon'
        },
        {
          code: 'GM',
          name: 'Gambia'
        },
        {
          code: 'GE',
          name: 'Georgia'
        },
        {
          code: 'DE',
          name: 'Germany'
        },
        {
          code: 'GH',
          name: 'Ghana'
        },
        {
          code: 'GI',
          name: 'Gibraltar'
        },
        {
          code: 'GR',
          name: 'Greece'
        },
        {
          code: 'GL',
          name: 'Greenland'
        },
        {
          code: 'GD',
          name: 'Grenada'
        },
        {
          code: 'GP',
          name: 'Guadeloupe'
        },
        {
          code: 'GU',
          name: 'Guam'
        },
        {
          code: 'GT',
          name: 'Guatemala'
        },
        {
          code: 'GG',
          name: 'Guernsey and Alderney'
        },
        {
          code: 'GN',
          name: 'Guinea'
        },
        {
          code: 'GW',
          name: 'Guinea-Bissau'
        },
        {
          code: 'GY',
          name: 'Guyana'
        },
        {
          code: 'HT',
          name: 'Haiti'
        },
        {
          code: 'HM',
          name: 'Heard and McDonald Islands'
        },
        {
          code: 'HN',
          name: 'Honduras'
        },
        {
          code: 'HK',
          name: 'Hong Kong'
        },
        {
          code: 'HU',
          name: 'Hungary'
        },
        {
          code: 'IS',
          name: 'Iceland'
        },
        {
          code: 'IN',
          name: 'India'
        },
        {
          code: 'ID',
          name: 'Indonesia'
        },
        {
          code: 'IR',
          name: 'Iran'
        },
        {
          code: 'IQ',
          name: 'Iraq'
        },
        {
          code: 'IE',
          name: 'Ireland'
        },
        {
          code: 'IM',
          name: 'Isle of Man'
        },
        {
          code: 'IL',
          name: 'Israel'
        },
        {
          code: 'IT',
          name: 'Italy'
        },
        {
          code: 'JM',
          name: 'Jamaica'
        },
        {
          code: 'JP',
          name: 'Japan'
        },
        {
          code: 'JE',
          name: 'Jersey'
        },
        {
          code: 'JO',
          name: 'Jordan'
        },
        {
          code: 'KZ',
          name: 'Kazakhstan'
        },
        {
          code: 'KE',
          name: 'Kenya'
        },
        {
          code: 'KI',
          name: 'Kiribati'
        },
        {
          code: 'KP',
          name: 'Korea (North)'
        },
        {
          code: 'KR',
          name: 'Korea (South)'
        },
        {
          code: 'KW',
          name: 'Kuwait'
        },
        {
          code: 'KG',
          name: 'Kyrgyzstan'
        },
        {
          code: 'LA',
          name: 'Laos'
        },
        {
          code: 'LV',
          name: 'Latvia'
        },
        {
          code: 'LB',
          name: 'Lebanon'
        },
        {
          code: 'LS',
          name: 'Lesotho'
        },
        {
          code: 'LR',
          name: 'Liberia'
        },
        {
          code: 'LY',
          name: 'Libya'
        },
        {
          code: 'LI',
          name: 'Liechtenstein'
        },
        {
          code: 'LT',
          name: 'Lithuania'
        },
        {
          code: 'LU',
          name: 'Luxembourg'
        },
        {
          code: 'MO',
          name: 'Macao'
        },
        {
          code: 'MK',
          name: 'Macedonia'
        },
        {
          code: 'MG',
          name: 'Madagascar'
        },
        {
          code: 'MW',
          name: 'Malawi'
        },
        {
          code: 'MY',
          name: 'Malaysia'
        },
        {
          code: 'MV',
          name: 'Maldives'
        },
        {
          code: 'ML',
          name: 'Mali'
        },
        {
          code: 'MT',
          name: 'Malta'
        },
        {
          code: 'MH',
          name: 'Marshall Islands'
        },
        {
          code: 'MQ',
          name: 'Martinique'
        },
        {
          code: 'MR',
          name: 'Mauritania'
        },
        {
          code: 'MU',
          name: 'Mauritius'
        },
        {
          code: 'YT',
          name: 'Mayotte'
        },
        {
          code: 'MX',
          name: 'Mexico'
        },
        {
          code: 'FM',
          name: 'Micronesia'
        },
        {
          code: 'MD',
          name: 'Moldova'
        },
        {
          code: 'MC',
          name: 'Monaco'
        },
        {
          code: 'MN',
          name: 'Mongolia'
        },
        {
          code: 'MS',
          name: 'Montserrat'
        },
        {
          code: 'MA',
          name: 'Morocco'
        },
        {
          code: 'MZ',
          name: 'Mozambique'
        },
        {
          code: 'MM',
          name: 'Myanmar'
        },
        {
          code: 'NA',
          name: 'Namibia'
        },
        {
          code: 'NR',
          name: 'Nauru'
        },
        {
          code: 'NP',
          name: 'Nepal'
        },
        {
          code: 'NL',
          name: 'Netherlands'
        },
        {
          code: 'AN',
          name: 'Netherlands Antilles'
        },
        {
          code: 'NC',
          name: 'New Caledonia'
        },
        {
          code: 'NZ',
          name: 'New Zealand'
        },
        {
          code: 'NI',
          name: 'Nicaragua'
        },
        {
          code: 'NE',
          name: 'Niger'
        },
        {
          code: 'NG',
          name: 'Nigeria'
        },
        {
          code: 'NU',
          name: 'Niue'
        },
        {
          code: 'NF',
          name: 'Norfolk Island'
        },
        {
          code: 'MP',
          name: 'Northern Mariana Islands'
        },
        {
          code: 'NO',
          name: 'Norway'
        },
        {
          code: 'OM',
          name: 'Oman'
        },
        {
          code: 'PK',
          name: 'Pakistan'
        },
        {
          code: 'PW',
          name: 'Palau'
        },
        {
          code: 'PS',
          name: 'Palestine'
        },
        {
          code: 'PA',
          name: 'Panama'
        },
        {
          code: 'PG',
          name: 'Papua New Guinea'
        },
        {
          code: 'PY',
          name: 'Paraguay'
        },
        {
          code: 'PE',
          name: 'Peru'
        },
        {
          code: 'PH',
          name: 'Philippines'
        },
        {
          code: 'PN',
          name: 'Pitcairn'
        },
        {
          code: 'PL',
          name: 'Poland'
        },
        {
          code: 'PT',
          name: 'Portugal'
        },
        {
          code: 'PR',
          name: 'Puerto Rico'
        },
        {
          code: 'QA',
          name: 'Qatar'
        },
        {
          code: 'RO',
          name: 'Romania'
        },
        {
          code: 'RU',
          name: 'Russia'
        },
        {
          code: 'RW',
          name: 'Rwanda'
        },
        {
          code: 'RE',
          name: 'Réunion'
        },
        {
          code: 'BL',
          name: 'Saint Barthélemy'
        },
        {
          code: 'SH',
          name: 'Saint Helena'
        },
        {
          code: 'KN',
          name: 'Saint Kitts and Nevis'
        },
        {
          code: 'LC',
          name: 'Saint Lucia'
        },
        {
          code: 'MF',
          name: 'Saint Martin'
        },
        {
          code: 'PM',
          name: 'Saint Pierre and Miquelon'
        },
        {
          code: 'VC',
          name: 'Saint Vincent and the Grenadines'
        },
        {
          code: 'WS',
          name: 'Samoa'
        },
        {
          code: 'SM',
          name: 'San Marino'
        },
        {
          code: 'SA',
          name: 'Saudi Arabia'
        },
        {
          code: 'SN',
          name: 'Senegal'
        },
        {
          code: 'RS',
          name: 'Serbia'
        },
        {
          code: 'SC',
          name: 'Seychelles'
        },
        {
          code: 'SL',
          name: 'Sierra Leone'
        },
        {
          code: 'SG',
          name: 'Singapore'
        },
        {
          code: 'SX',
          name: 'Sint Maarten'
        },
        {
          code: 'SK',
          name: 'Slovakia'
        },
        {
          code: 'SI',
          name: 'Slovenia'
        },
        {
          code: 'SB',
          name: 'Solomon Islands'
        },
        {
          code: 'SO',
          name: 'Somalia'
        },
        {
          code: 'ZA',
          name: 'South Africa'
        },
        {
          code: 'GS',
          name: 'South Georgia and the South Sandwich Islands'
        },
        {
          code: 'SS',
          name: 'South Sudan'
        },
        {
          code: 'ES',
          name: 'Spain'
        },
        {
          code: 'LK',
          name: 'Sri Lanka'
        },
        {
          code: 'SD',
          name: 'Sudan'
        },
        {
          code: 'SR',
          name: 'Suriname'
        },
        {
          code: 'SJ',
          name: 'Svalbard and Jan Mayen'
        },
        {
          code: 'SZ',
          name: 'Swaziland'
        },
        {
          code: 'SE',
          name: 'Sweden'
        },
        {
          code: 'CH',
          name: 'Switzerland'
        },
        {
          code: 'SY',
          name: 'Syria'
        },
        {
          code: 'ST',
          name: 'São Tomé and Príncipe'
        },
        {
          code: 'TW',
          name: 'Taiwan'
        },
        {
          code: 'TJ',
          name: 'Tajikistan'
        },
        {
          code: 'TZ',
          name: 'Tanzania'
        },
        {
          code: 'TH',
          name: 'Thailand'
        },
        {
          code: 'TG',
          name: 'Togo'
        },
        {
          code: 'TK',
          name: 'Tokelau'
        },
        {
          code: 'TO',
          name: 'Tonga'
        },
        {
          code: 'TT',
          name: 'Trinidad and Tobago'
        },
        {
          code: 'TN',
          name: 'Tunisia'
        },
        {
          code: 'TR',
          name: 'Turkey'
        },
        {
          code: 'TM',
          name: 'Turkmenistan'
        },
        {
          code: 'TC',
          name: 'Turks and Caicos Islands'
        },
        {
          code: 'TV',
          name: 'Tuvalu'
        },
        {
          code: 'UG',
          name: 'Uganda'
        },
        {
          code: 'UA',
          name: 'Ukraine'
        },
        {
          code: 'AE',
          name: 'United Arab Emirates'
        },
        {
          code: 'GB',
          name: 'United Kingdom'
        },
        {
          code: 'UM',
          name: 'United States Minor Outlying Islands'
        },
        {
          code: 'US',
          name: 'United States of America'
        },
        {
          code: 'UY',
          name: 'Uruguay'
        },
        {
          code: 'UZ',
          name: 'Uzbekistan'
        },
        {
          code: 'VU',
          name: 'Vanuatu'
        },
        {
          code: 'VA',
          name: 'Vatican City'
        },
        {
          code: 'VE',
          name: 'Venezuela'
        },
        {
          code: 'VN',
          name: 'Vietnam'
        },
        {
          code: 'VI',
          name: 'Virgin Islands of the United States'
        },
        {
          code: 'WF',
          name: 'Wallis and Futuna'
        },
        {
          code: 'EH',
          name: 'Western Sahara'
        },
        {
          code: 'YE',
          name: 'Yemen'
        },
        {
          code: 'ZM',
          name: 'Zambia'
        },
        {
          code: 'ZW',
          name: 'Zimbabwe'
        },
        {
          code: 'AX',
          name: 'Åland Islands'
        }
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('CounterService', CounterService);

  /** @ngInject */
  function CounterService($http, $state, $rootScope, toastr, $timeout, EnvironmentConfig,
    POLL_TIME, ADV_STATES, PUB_STATES, SessionService) {
    var ADV_COUNTER_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/counters';
    var PUB_COUNTER_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/counters';

    var service = {
      poller: poller,
      getAdvCardValues: getAdvCardValues,
      getPubCardValues: getPubCardValues,
    };

    return service;

    //used to poll server to get notifications and counters
    function poller(initialLoading) {

      // Get initial notifications
      if (initialLoading) {
        if (SessionService.isAdvertiser()) {
          getAdvCardValues();
        } else if (SessionService.isPublisher()) {
          getPubCardValues();
        }
        poller(false);
        return;
      }

      if (ADV_STATES.indexOf($state.current.name) !== -1) {
        getAdvCardValues();
      } else if (PUB_STATES.indexOf($state.current.name) !== -1) {
        getPubCardValues();
      }
      $timeout(poller, POLL_TIME);
    }

    function getPubCardValues() {
      //used for badges notification counter
      $rootScope.badgeActiveAds = $rootScope.badgeActiveAds || 0;
      $rootScope.badgeNewOrders = $rootScope.badgeNewOrders || 0;
      $rootScope.badgePricingAndPausing = $rootScope.badgePricingAndPausing || 0;
      $rootScope.badgeReSubmitted = $rootScope.badgeReSubmitted || 0;

      //used for card items counter
      $rootScope.counterActiveAds = $rootScope.counterActiveAds || 0;
      $rootScope.counterNewOrders = $rootScope.counterNewOrders || 0;
      $rootScope.counterPricingAndPausing = $rootScope.counterPricingAndPausing || 0;
      $rootScope.counterReSubmitted = $rootScope.counterReSubmitted || 0;
      //used for contact/help
      $rootScope.counterMessages = $rootScope.counterMessages || 0;


      $http.get(PUB_COUNTER_URL, {
        ignoreLoading: true
      }).then(function (response) {
        var data = response.data;
        $rootScope.counterActiveAds = data.active_ads;
        $rootScope.counterNewOrders = data.new_orders;
        $rootScope.counterPricingAndPausing = data.pricing_and_pausing;
        $rootScope.counterReSubmitted = data.resubmitted_content;

        $rootScope.badgeActiveAds = data.active_ads_badge;
        $rootScope.badgeNewOrders = data.new_orders_badge;
        $rootScope.badgePricingAndPausing = data.pricing_and_pausing_badge;
        $rootScope.badgeReSubmitted = data.resubmitted_content_badge;
        $rootScope.counterMessages = data.new_message;
      });
    }

    function getAdvCardValues() {
      //used for badges notification counter
      $rootScope.badgeActive = $rootScope.badgeActive || 0;
      $rootScope.badgeAwaiting = $rootScope.badgeAwaiting || 0;
      $rootScope.badgeApproved = $rootScope.badgeApproved || 0;
      $rootScope.badgeReused = $rootScope.badgeReused || 0;
      //used for card items counter
      $rootScope.counterActive = $rootScope.counterActive || 0;
      $rootScope.counterAwaiting = $rootScope.counterAwaiting || 0;
      $rootScope.counterApproved = $rootScope.counterApproved || 0;
      $rootScope.counterReused = $rootScope.counterReused || 0;
      $rootScope.pendingOrders = $rootScope.counterPendingOrders || 0;
      // used for quotes & articles
      $rootScope.counterQuotes = $rootScope.counterQuotes || 0;
      $rootScope.counterArticles = $rootScope.counterArticles || 0;
      $rootScope.counterAssignedQuotes = $rootScope.counterAssignedQuotes || 0;
      $rootScope.counterApprovedArticles = $rootScope.counterApprovedArticles || 0;
      //used for contact/help
      $rootScope.counterMessages = $rootScope.counterMessages || 0;
      // used for checkout
      $rootScope.counterCheckoutItems = $rootScope.counterCheckoutItems || 0;


      $http.get(ADV_COUNTER_URL, {
        ignoreLoading: true
      }).then(function (response) {
        var data = response.data;
        $rootScope.badgeActive = data.active_content_badge;
        $rootScope.badgeAwaiting = data.awaiting_pubs_badge;
        $rootScope.badgeApproved = data.urls_approved_badge;
        $rootScope.badgeReused = data.reuse_content_badge;
        $rootScope.counterActive = data.active_content;
        $rootScope.counterAwaiting = data.awaiting_pubs;
        $rootScope.counterApproved = data.urls_approved;
        $rootScope.counterReused = data.reuse_content;
        $rootScope.counterQuotes = data.new_quotes;
        $rootScope.counterArticles = data.new_articles;
        $rootScope.counterAssignedQuotes = data.new_assigned_quotes;
        $rootScope.counterMessages = data.new_message;
        $rootScope.counterPendingOrders = data.pending_orders;
        $rootScope.counterCheckoutItems = data.orders_in_checkout;
        $rootScope.counterApprovedArticles = data.approved_articles;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('ContentService', ContentService);

  /* @ngInject */
  function ContentService($http, lodash, Upload, EnvironmentConfig) {
    var CONTENTS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/contents';

    var service = {
      indexReceivedContents: indexReceivedContents,
      indexPendingContents: indexPendingContents,
      showContent: showContent,
      createContent: createContent,
      downloadReport: downloadReport,
      uploadReport: uploadReport,
      deleteQuote: deleteQuote
    };

    return service;

    // Functions
    function indexReceivedContents(query, successCallback, errorCallback) {
      $http.get(CONTENTS_URL, {
        params: {
          scope: 'received',
          page: query.page,
          limit: query.limit,
          q: query.filter
        }
      }).then(successCallback, errorCallback);
    }

    function indexPendingContents(successCallback, errorCallback) {
      $http.get(CONTENTS_URL, {
        params: {
          scope: 'pending'
        }
      }).then(successCallback, errorCallback);
    }

    function showContent(contentId, successCallback, errorCallback) {
      $http.get(CONTENTS_URL + '/' + contentId).then(successCallback, errorCallback);
    }

    function createContent(content, successCallback, errorCallback) {
      $http.post(CONTENTS_URL, {
        content: {
          'campaign_id': content.campaign.id,
          'trust_flow_min': content.minTF,
          'trust_flow_max': content.maxTF,
          'domain_authority_min': content.minDA,
          'domain_authority_max': content.maxDA,
          'ahrefs_dr_min': content.minDR,
          'ahrefs_dr_max': content.maxDR,
          'category_ids': lodash.map(content.categories, 'id'),
          'agency_content': content.agency_content,
          'include_no_follow': content.include_no_follow
        }
      }).then(successCallback, errorCallback);
    }

    function downloadReport(contentId, successCallback, errorCallback) {
      $http.get(CONTENTS_URL + '/' + contentId + '/report').then(successCallback, errorCallback);
    }

    function uploadReport(contentId, file, successCallback, errorCallback) {
      Upload.upload({
        url: CONTENTS_URL + '/' + contentId + '/upload',
        method: 'POST',
        fields: {
          'spreadsheet': file
        }
      }).then(successCallback, errorCallback);
    }

    function deleteQuote(quoteId, successCallback, errorCallback) {
      $http.delete(CONTENTS_URL + '/' + quoteId).then(successCallback, errorCallback);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('CategoriesService', CategoriesService);

  /** @ngInject */
  function CategoriesService($http, EnvironmentConfig) {
    var CATEGORIES_URL = EnvironmentConfig.API_END_POINT + '/categories';

    var service = {
      indexCategories: indexCategories
    };

    return service;

    // Functions
    function indexCategories(successCallback, errorCallback) {
      $http.get(CATEGORIES_URL).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('CampaignsService', CampaignsService);

  /** @ngInject */
  function CampaignsService($http, EnvironmentConfig, Upload, lodash) {
    var CAMPAIGNS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/campaigns';

    var service = {
      indexCampaigns: indexCampaigns,
      indexScopedCampaigns: indexScopedCampaigns,
      shallowIndexScopedCampaigns: shallowIndexScopedCampaigns,
      showCampaign: showCampaign,
      showCampaignWithActiveAdLinks: showCampaignWithActiveAdLinks,
      getCampaignNames: getCampaignNames,
      createCampaign: createCampaign,
      updateCampaign: updateCampaign,
      deleteCampaign: deleteCampaign,
      updateSpreadsheetCampaign: updateSpreadsheetCampaign,
      updateCampaignCategories: updateCampaignCategories,
      addUrl: addUrl,
      indexLinks: indexLinks,
      updateCampaignHeader: updateCampaignHeader
    };

    return service;

    // Functions
    function indexCampaigns(query, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL, {
        params: {
          page: query.page,
          limit: query.limit,
          q: query.filter,
          teammate_id: query.teammate_id
        }
      }).then(successCallback, errorCallback);
    }

    function indexScopedCampaigns(scope, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL, {
        params: {
          scope: scope
        }
      }).then(successCallback, errorCallback);
    }

    function shallowIndexScopedCampaigns(scope, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL + '/shallow_index', {
        params: {
          scope: scope
        }
      }).then(successCallback, errorCallback);
    }

    function getCampaignNames(successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL + '/names').then(successCallback, errorCallback);
    }

    function showCampaign(id, page, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL + '/' + id + '?page=' + page).then(successCallback, errorCallback);
    }

    function showCampaignWithActiveAdLinks(id, page, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL + '/' + id + '?only_with_active_ad_links=true&page=' + page).then(successCallback, errorCallback);
    }

    function createCampaign(campaign, successCallback, errorCallback) {
      var manager_id = 0;
      if (angular.isDefined(campaign.manager_id)) manager_id = campaign.manager_id;
      Upload.upload({
        url: CAMPAIGNS_URL,
        method: 'POST',
        fields: {
          'campaign[name]': campaign.name,
          'campaign[image]': campaign.image,
          'campaign[links_attributes]': [{
            'href': campaign.url
          }],
          'spreadsheet': campaign.csv,
          'categories_ids': lodash.map(campaign.categories, 'id'),
          'manager_id': manager_id
        }
      }).then(successCallback, errorCallback);
    }

    function updateCampaign(id, campaign, successCallback, errorCallback) {
      Upload.upload({
        url: CAMPAIGNS_URL + '/' + id,
        method: 'PUT',
        fields: {
          'campaign[name]': campaign.name,
          'campaign[image]': campaign.image,
          'campaign[links_attributes]': [{
            id: campaign.url.id,
            href: campaign.url
          }],
          'categories_ids': lodash.map(campaign.categories, 'id')
        }
      }).then(successCallback, errorCallback);
    }

    function updateCampaignCategories(id, campaign, successCallback, errorCallback) {
      Upload.upload({
        url: CAMPAIGNS_URL + '/' + id,
        method: 'PUT',
        fields: {
          'campaign[categories_ids]': campaign.categories_ids,
        }
      }).then(successCallback, errorCallback);
    }

    function deleteCampaign(id, successCallback, errorCallback) {
      $http.delete(CAMPAIGNS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function updateSpreadsheetCampaign(id, spreadsheet, successCallback, errorCallback) {
      Upload.upload({
        url: CAMPAIGNS_URL + '/' + id + '/update_spreadsheet',
        method: 'PUT',
        fields: {
          'spreadsheet': spreadsheet
        }
      }).then(successCallback, errorCallback);
    }

    function addUrl(id, url, successCallback, errorCallback) {
      Upload.upload({
        url: CAMPAIGNS_URL + '/' + id + '/links',
        method: 'POST',
        fields: {
          'link[href]': url.href
        }
      }).then(successCallback, errorCallback);
    }

    function indexLinks(id, successCallback, errorCallback) {
      $http.get(CAMPAIGNS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function updateCampaignHeader(id, campaign, successCallback, errorCallback) {
      Upload.upload({
        url: CAMPAIGNS_URL + '/' + id,
        method: 'PUT',
        fields: {
          'campaign[name]': campaign.name,
          'campaign[image]': campaign.image,
          'categories_ids': lodash.map(campaign.categories, 'id')
        }
      }).then(successCallback, errorCallback);
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('BlogPostsService', BlogPostsService);

  /** @ngInject */
  function BlogPostsService($http, EnvironmentConfig, Upload) {
    var BLOGS_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/ads';
    var PUB_BLOGS_URL = EnvironmentConfig.API_END_POINT + '/publishers/me/ads';

    var service = {
      showBlogPost: showBlogPost,
      indexBlogPosts: indexBlogPosts,
      indexActiveContent: indexActiveContent,
      updateBlogPost: updateBlogPost,
      deleteBlogPost: deleteBlogPost,
      indexPublisherBlogPosts: indexPublisherBlogPosts,
      indexPublisherBlogPostsWithPagination: indexPublisherBlogPostsWithPagination,
      approveAd: approveAd,
      rejectAd: rejectAd,
      updateLiveUrl: updateLiveUrl
    };

    return service;

    // Functions
    function showBlogPost(id, successCallback, errorCallback) {
      $http.get(BLOGS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function indexBlogPosts(params, successCallback, errorCallback) {
      $http.get(BLOGS_URL, {
        params: params
      }).then(successCallback, errorCallback);
    }

    function indexActiveContent(activeContent, successCallback, errorCallback) {
      $http.get(BLOGS_URL, {
        params: {
          date_from: activeContent.date_from_obj,
          date_to: activeContent.date_to_obj,
          page: activeContent.page,
          limit: activeContent.limit,
          status: 'active',
          q: activeContent.filter,
          state: activeContent.state
        }
      }).then(successCallback, errorCallback);
    }

    function updateBlogPost(id, blogPost, successCallback, errorCallback) {
      var body = {
        ad: {
          id: blogPost.id,
          link_id: blogPost.link.id,
          url_id: blogPost.url.id,
          campaign_id: blogPost.campaign.id,
          blog_post_title: blogPost.blog_post_title,
          blog_post_body: blogPost.blog_post_body,
          blog_post_image_1: blogPost.image_1,
          blog_post_image_2: blogPost.image_2,
          blog_post_doc: blogPost.word,
          link_text: blogPost.link_text
        }
      };

      if (!blogPost.link_text) {
        delete body.ad.link_text;
      }
      if (!blogPost.blog_post_body) {
        delete body.ad.blog_post_body;
      }

      Upload.upload({
        url: BLOGS_URL + '/' + id,
        method: 'PUT',
        fields: body
      }).then(successCallback, errorCallback);
    }

    function deleteBlogPost(id, successCallback, errorCallback) {
      $http.delete(BLOGS_URL + '/' + id).then(successCallback, errorCallback);
    }

    function indexPublisherBlogPosts(state, successCallback, errorCallback) {
      $http.get(PUB_BLOGS_URL, {
        params: {
          state: state
        }
      }).then(successCallback, errorCallback);
    }

    function indexPublisherBlogPostsWithPagination(state, queryNotSubmitted, successCallback, errorCallback) {
      $http.get(PUB_BLOGS_URL, {
        params: {
          state: state,
          page: queryNotSubmitted.page,
          limit: queryNotSubmitted.limit,
          field: queryNotSubmitted.order,
          order_by: queryNotSubmitted.orderBy
        }
      }).then(successCallback, errorCallback);
    }

    function updateLiveUrl(id, live_url, note, successCallback, errorCallback) {
      $http.put(PUB_BLOGS_URL + '/' +id, {
        ad: {
          full_pub_url: live_url,
          notes: note
        }
      }).then(successCallback, errorCallback);
    }

    function approveAd(id, successCallback, errorCallback) {
      $http.put(PUB_BLOGS_URL + '/' + id + '/approve').then(successCallback, errorCallback);
    }

    function rejectAd(id, ad, successCallback, errorCallback) {
      $http.put(PUB_BLOGS_URL + '/' + id + '/reject', {
        ad: ad
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('AuthenticationService', AuthenticationService);

  /** @ngInject */
  function AuthenticationService($http, EnvironmentConfig, SessionService) {
    var AUTHENTICATION_URL = EnvironmentConfig.API_END_POINT + '/users';

    var service = {
      login: login,
      logout: logout,
      forgotPassword: forgotPassword,
      resetPassword: resetPassword
    };

    return service;

    ////////// Functions //////////

    function login(credentials, successCallback, errorCallback) {
      $http.post(AUTHENTICATION_URL + '/sign_in', {
        user: credentials
      }).then(function (response) {
        SessionService.createSession(response.data);
        successCallback();
      }, errorCallback);
    }

    function logout(successCallback) {
      $http.delete(AUTHENTICATION_URL + '/sign_out').then(function () {
        SessionService.clearSession();
        successCallback();
      });
    }

    function forgotPassword(email, successCallback, errorCallback) {
      $http.post(AUTHENTICATION_URL + '/password', {
        user: { email: email }
      }).then(function (response) {
        successCallback();
      }, errorCallback);
    }

    function resetPassword(credentials, successCallback, errorCallback) {
      console.log('credentials');
      console.log(credentials);
      $http.put(AUTHENTICATION_URL + '/password', credentials).then(function (response) {
        successCallback();
      }, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('ArticlesService', ArticlesService);

  /** @ngInject */
  function ArticlesService($http, EnvironmentConfig, Upload, lodash) {
    var ARTICLES_URL = EnvironmentConfig.API_END_POINT + '/advertisers/me/articles';

    var service = {
      indexArticles: indexArticles,
      indexArticlesWithoutLimit: indexArticlesWithoutLimit,
      createArticles: createArticles,
      updateArticle: updateArticle,
      createNote: createNote,
      createOrders: createOrders,
      setStarred: setStarred
    };

    return service;

    // Functions
    function indexArticles(params,successCallback, errorCallback) {
      $http.get(ARTICLES_URL, {
        params: params
      }).then(successCallback, errorCallback);
    }

    function indexArticlesWithoutLimit(params, successCallback, errorCallback) {
      $http.get(ARTICLES_URL, {
        params: {
          q: params.q
        }
      }).then(successCallback, errorCallback);
    }

    function createArticles(articles, successCallback, errorCallback) {
      $http.post(ARTICLES_URL + '/bulk_create', {
        articles: sanitizeArticles(articles)
      }).then(successCallback, errorCallback);
    }

    function sanitizeArticles(articles) {
      var santizedArticles = [];
      santizedArticles = lodash.map(articles, function (article) {
        return {
          ad_attributes: {
            campaign_id: article.campaign,
            blog_post_title: article.quote.blog_post_title,
            link_text: article.quote.link_text,
            url_id: article.url_id
          },
          href: article.quote.href,
          notes: article.quote.notes,
          url_id: article.url_id,
          content_id: article.content_id
        }
      });
      return santizedArticles;
    }

    function updateArticle(id, article, successCallback, errorCallback) {
      Upload.upload({
        url: ARTICLES_URL + '/' + id,
        method: 'PUT',
        fields: {
          'article[ad_attributes][id]': article.ad_id,
          'article[ad_attributes][blog_post_title]': article.title,
          'article[ad_attributes][link_text]': article.anchor,
          'article[full_pub_url]': article.destination_url,
          'article[ad_attributes][campaign_id]': article.campaign_id,
          'article[ad_attributes][blog_post_doc]': article.blog_post_doc
        }
      }).then(successCallback, errorCallback);
    }

    function createNote(id, note, addedNote, successCallback, errorCallback) {
      $http.put(ARTICLES_URL + '/' + id, {
        article: {
          notes: note
        },
        rewrite: addedNote
      }).then(successCallback, errorCallback);
    }

    function createOrders(articleIds, ordersOrigin, successCallback, errorCallback) {
      $http.post(ARTICLES_URL + '/create_orders', {
        articles_ids: articleIds,
        created_from: ordersOrigin
      }).then(successCallback, errorCallback);
    }

    function setStarred(id, starred, successCallback, errorCallback) {
      $http.post(ARTICLES_URL + '/set_starred', {
        id: id,
        starred: starred
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('AdBlockerService', AdBlockerService);

  /** @ngInject */
  function AdBlockerService($http) {

    var service = {
      adBlockerEnabled: adBlockerEnabled
    };

    return service;

    // Functions
    function adBlockerEnabled(callback) {
      var testURL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'

      var myInit = {
        method: 'HEAD',
        mode: 'no-cors'
      };

      var myRequest = new Request(testURL, myInit);

      fetch(myRequest).then(function(response) {
        return response;
      }).then(function(response) {
        callback(false)
      }).catch(function(e){
        callback(true)
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('AccountService', AccountService);

  /** @ngInject */
  function AccountService($http, EnvironmentConfig) {
    var ADVERTISER_URL = EnvironmentConfig.API_END_POINT + '/advertisers';
    var PUBLISHER_URL = EnvironmentConfig.API_END_POINT + '/publishers';

    var service = {
      getAdvertiser: getAdvertiser,
      getPublisher: getPublisher,
      createAdvertiser: createAdv,
      createPublisher: createPub,
      createAdvTeammate: createAdvTeammate,
      getAdvTeammates: getAdvTeammates,
      getAdvTeammate: getAdvTeammate,
      getAdvWithTeammates: getAdvWithTeammates,
      updateAdvTeammate: updateAdvTeammate,
      destroyAdvTeammate: destroyAdvTeammate,
      setAdvTeammateManageCampaign: setAdvTeammateManageCampaign,
      setAdvTeammatesManagersOfCampaign: setAdvTeammatesManagersOfCampaign,
      removeAdvTeammatesManageCampaign: removeAdvTeammatesManageCampaign,
      disableAutoPubTour: disableAutoPubTour
    };

    return service;

    // Functions
    function getAdvertiser(successCallback, errorCallback) {
      $http.get(ADVERTISER_URL + '/me').then(successCallback, errorCallback);
    }

    function getPublisher(successCallback, errorCallback) {
      $http.get(PUBLISHER_URL + '/me').then(successCallback, errorCallback);
    }

    function createAdv(successCallback, errorCallback) {
      $http.post(ADVERTISER_URL).then(successCallback, errorCallback);
    }

    function createPub(successCallback, errorCallback) {
      $http.post(PUBLISHER_URL).then(successCallback, errorCallback);
    }

    function createAdvTeammate(advTeammate, successCallback, errorCallback) {
      $http.post(ADVERTISER_URL + '/me/adv_teammates', advTeammate).then(successCallback, errorCallback);
    }

    function getAdvTeammates(successCallback, errorCallback) {
      $http.get(ADVERTISER_URL + '/me/adv_teammates').then(successCallback, errorCallback);
    }

    function getAdvTeammate(advTeammateId, successCallback, errorCallback) {
      $http.get(ADVERTISER_URL + '/me/adv_teammates/' + advTeammateId).then(successCallback, errorCallback);
    }

    function getAdvWithTeammates(successCallback, errorCallback) {
      $http.get(ADVERTISER_URL + '/me/with_teammates').then(successCallback, errorCallback);
    }

    function updateAdvTeammate(id, adv, successCallback, errorCallback) {
      $http.put(ADVERTISER_URL + '/me/adv_teammates/' + id, {
        advertiser: adv
      }).then(successCallback, errorCallback);
    }

    function destroyAdvTeammate(id, successCallback, errorCallback) {
      $http.delete(ADVERTISER_URL + '/me/adv_teammates/' + id).then(successCallback, errorCallback);
    }

    function setAdvTeammateManageCampaign(teammate_id, campaign_id, successCallback, errorCallback) {
      $http.post(ADVERTISER_URL + '/me/adv_teammates/add_manage_campaign', {
        teammate_advertiser_id: teammate_id,
        campaign_id: campaign_id
      }).then(successCallback, errorCallback);
    }

    function setAdvTeammatesManagersOfCampaign(teammate_ids, campaign_id, successCallback, errorCallback) {
      $http.post(ADVERTISER_URL + '/me/adv_teammates/set_manage_campaign', {
        teammate_advertiser_ids: teammate_ids,
        campaign_id: campaign_id
      }).then(successCallback, errorCallback);
    }

    function removeAdvTeammatesManageCampaign(campaign_id, successCallback, errorCallback) {
      $http.post(ADVERTISER_URL + '/me/adv_teammates/remove_managers_from_campaign', {
        campaign_id: campaign_id
      }).then(successCallback, errorCallback);
    }

    function disableAutoPubTour(successCallback, errorCallback) {
      $http.post(PUBLISHER_URL + '/disable_auto_pub_tour').then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('SocialHandlesService', SocialHandlesService);

  /* @ngInject */
  function SocialHandlesService(lodash) {
    var service = {
      anyChange: anyChange,
      anyRepeated: anyRepeated,
      getAllSocialHandle: getAllSocialHandle,
      setDescriptionToSocialHandles: setDescriptionToSocialHandles
    };

    return service;

    function anyChange(profile, profileCopy) {
      return !arraysEqual(getAllSocialHandle(profile).sort(), getAllSocialHandle(profileCopy).sort());
    }

    function anyRepeated(profile) {
      var allSocialHandles = getAllSocialHandle(profile);
      return lodash.uniqWith(allSocialHandles, function (i1, i2) {
        return i1.url && i2.url && i1.url == i2.url
      }).length !== allSocialHandles.length;
    }

    function getAllSocialHandle(profile) {
      return lodash.concat(
        profile.facebook_handle,
        profile.twitter_handle,
        profile.instagram_handle,
        profile.youtube_handle
      )
    }

    function setDescriptionToSocialHandles(profile, description) {
      lodash.each(getAllSocialHandle(profile), function (sh) {
        sh.description = description;
      });
    }

    function arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length != b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (a[i].url !== b[i].url) return false;
      }
      return true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('PricesService', PricesService);

  /* @ngInject */
  function PricesService($http, EnvironmentConfig) {
    var SUGGEST_PRICE_URL = EnvironmentConfig.API_END_POINT + '/urls/suggested_price'
    var service = {
      getPrice: getPrice
    };

    return service;

    function getPrice(href, successCallback, errorCallback) {
      $http.get(SUGGEST_PRICE_URL, {
        params: {
          href: href
        }
      }).then(successCallback, errorCallback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('urlInput', function ($filter, $browser) {
      return {
        require: ['^form', 'ngModel'],
        link: function ($scope, $element, $attrs, ngModelCtrl) {
          var regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}[^'"@^():;*]*$/;

          $element.bind('blur', function () {
            var val = $element.val();
            var valid = regex.test(val);
            ngModelCtrl[0][$element.attr('name')].$setValidity('pattern', val && valid);
          });
        }
      };
    });
  })();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('uniqueOn', uniqueOn);

  /* @ngInject */
  function uniqueOn(lodash) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, el, attr) {
      scope.$watch(attr.ngModel, function (newVal) {
        if (angular.isUndefined(newVal)) {
          return;
        }
        var items = scope.$eval(attr.uniqueOn) || [];
        var form = scope.form || scope.newProfCtrl.form;
        var valid = lodash.findIndex(items, function (item) {
          return item.toUpperCase() == newVal.toUpperCase()
        }) == -1;
        form.name.$setValidity('repeated', valid);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('tabWatcher', function () {
      return {
        require: '^?mdTabs',
        restrict: 'A',
        link: function (scope, el, attrs, controllers) {
          var mdTabsCtrl = controllers;
          var origSelectFn = mdTabsCtrl.select;

          // overwrite original function with our own
          mdTabsCtrl.select = function (index, canSkipClick) {
            // emit an event with accept/reject functions
            scope.$emit('tab-change', {
              index: index,
              accept: function () {
                return origSelectFn(index, canSkipClick);
              },
              reject: function () {}
            });
          };

          scope.$watch(attrs.mdSelected, function () {
            if (scope.$eval(attrs.mdSelected) != 0) {
              scope.$emit('tab-change', {
                index: attrs.mdSelected,
                accept: function () {
                  return origSelectFn(scope.$eval(attrs.mdSelected), false);
                },
                reject: function () {}
              });
            }
          });
        }
      };
    });
})();

angular.module('linktub')
  .directive('searchChip', function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var chipTemplateClass = elem.name;
        var mdChip = elem.parent().parent();
        mdChip.addClass(scope.$chip.category);
      }
    }
  });

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('rowWrapFill', rowWrapFill);

  /* @ngInject */
  function rowWrapFill($compile, $window) {
    var directive = {
      restrict: 'EA',
      scope: {},
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, elm, attrs) {
      if (scope.$parent.$last) {
        var parentWidth = elm[0].parentNode.clientWidth || 1234;
        var childWidth = elm[0].clientWidth || 196;
        var length = scope.$parent.$index + 1;

        if (length > 0) {
          var theStyle = $window.getComputedStyle(elm[0], null);

          //If there is a border - recalculate child width
          if (theStyle.boxSizing == 'border-box') {
            var border = theStyle.borderWidth;
            border = parseInt(border.replace('px', ''));
            childWidth += border * 2;
          }

          var maxColumn = Math.floor(parentWidth / childWidth);

          //Only add elements if there is more than one row.
          if (length > maxColumn) {
            //Calculate numder of elements to add
            var temp = length % maxColumn
            if (temp != 0) {
              var toAdd = Math.abs(maxColumn - temp);

              for (var i = 0; i < toAdd; i++) {
                var blankNode = '<div style="width: ' + childWidth + 'px;box-sizing: border-box;"></div>';

                //var node = $compile(blankNode)(scope)
                elm.parent().append(blankNode)
              }
            }
          }
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('phoneInput', function ($filter, $browser) {
      return {
        require: ['^form', 'ngModel'],
        link: function ($scope, $element, $attrs, ngModelCtrl) {
          var listener = function () {
            var value = $element.val().replace(/[^0-9]/g, '');
            ngModelCtrl[0].phone.$setValidity('pattern', value.length == 0 || value.length == 10);
            $element.val($filter('tel')(value, false));
          };

          // This runs when we update the text field
          ngModelCtrl[1].$parsers.push(function (viewValue) {
            return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
          });

          // This runs when the model gets updated on the scope directly and keeps our view in sync
          ngModelCtrl[1].$render = function () {
            $element.val($filter('tel')(ngModelCtrl[1].$viewValue, false));
          };

          $element.bind('change', listener);
          $element.bind('keydown', function (event) {
            var key = event.keyCode;
            // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
            // This lets us support copy and paste too
            if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
              return;
            }
            $browser.defer(listener); // Have to do this or changes don't get picked up properly
          });

          $element.bind('paste cut', function () {
            $browser.defer(listener);
          });
        }

      };
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('numbersOnly', function () {
      return {
        require: 'ngModel',
        link: function ($scope, $element, $attr, ngModelCtrl) {
          function fromUser(text) {
            if (text) {
              var cleanText = text.replace(/[^0-9]/g, '');

              if (parseInt(cleanText) <= 0) {
                cleanText = '';
              }

              cleanText = cleanText.slice(0, 6);

              if (!angular.equals(text, cleanText)) {
                ngModelCtrl.$setViewValue(cleanText);
                ngModelCtrl.$render();
              }
              return cleanText;
            }
            return '';
          }
          ngModelCtrl.$parsers.push(fromUser);
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('noDoubleQuotes', directive);

    /* @ngInject */
  function directive() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, $element, attrs, ngModel) {
        attrs.ngTrim = 'false';

        ngModel.$parsers.unshift(function (value) {
          var singleQuoteValue = value.replace(/"/g, "'");

          if (singleQuoteValue !== value) {
            ngModel.$setViewValue(singleQuoteValue);
            ngModel.$render();
          }

          return singleQuoteValue;
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('noCharactersAllowed', directive);

  /* @ngInject */
  function directive() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, $element, attrs, ngModel) {
        $element.bind('keydown', function (e) {
          e.preventDefault();
          return false;
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('checkDomain', checkDomain);

  /* @ngInject */
  function checkDomain(lodash) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, el, attr) {
      scope.$watch(attr.ngModel, function (newVal) {
        var domain = attr.domain + '.com';
        var form = scope.$eval(attr.over);
        var valid = (newVal !== '' && newVal.indexOf(domain) != -1) || newVal == '';
        form.url.$setValidity('domain', valid);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('disallowSpaces', directive);

  /* @ngInject */
  function directive() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, $element, attrs, ngModel) {
        attrs.ngTrim = 'false';

        $element.bind('keydown', function (e) {
          if (e.which === 32) {
            e.preventDefault();
            return false;
          }
        });

        ngModel.$parsers.unshift(function (value) {
          var spacelessValue = value.replace(/ /g, '');

          if (spacelessValue !== value) {
            ngModel.$setViewValue(spacelessValue);
            ngModel.$render();
          }

          return spacelessValue;
        });
      }
    }
  }
})();

angular.module('linktub')
  .directive('customChip', function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var chipTemplateClass = elem.name;
        var mdChip = elem.parent().parent();
        mdChip.addClass(scope.$chip.name);
      }
    }
  });

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('ngCreditCardType', ngCreditCardType);

  /* @ngInject */
  function ngCreditCardType($interpolate) {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        scope.vm.ccType =
          (/^5[1-5]/.test(value)) ? {
            network: 'MasterCard',
            digits: 16,
            logo: 'https://assets.braintreegateway.com/payment_method_logo/mastercard.png'
          } :
          (/^4/.test(value)) ? {
            network: 'Visa',
            digits: 16,
            logo: 'https://assets.braintreegateway.com/payment_method_logo/visa.png'
          } :
          (/^3[47]/.test(value)) ? {
            network: 'Amex',
            digits: 15,
            logo: 'https://assets.braintreegateway.com/payment_method_logo/american_express.png'
          } :
          (/^6011|65|64[4-9]|622(1(2[6-9]|[3-9]\d)|[2-8]\d{2}|9([01]\d|2[0-5]))/.test(value)) ? {
            network: 'Discover',
            digits: 16,
            logo: 'https://assets.braintreegateway.com/payment_method_logo/discover.png'
          } :
          (/^2131|1800|35/.test(value)) ? {
            network: 'JCB',
            digits: 16,
            logo: 'https://assets.braintreegateway.com/payment_method_logo/jcb.png'
          } :
          undefined
        ctrl.$setValidity('invalid', !!scope.vm.ccType)
        return value;
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .directive('checkDuplicateOn', checkDuplicateOn);

  /* @ngInject */
  function checkDuplicateOn(lodash) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, el, attr) {
      scope.$watch(attr.ngModel, function (newVal) {
        var items = scope.$eval(attr.checkDuplicateOn) || [];
        var form = scope.$eval(attr.over);
        var position = index(items, newVal, scope.$index);
        var valid = items.length < 2 || position < 0 || position == scope.$index;
        form.url.$setValidity('duplicate', valid);
      });
    }

    function index(items, newVal, pos) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].url && items[i].url === newVal && pos !== i) {
          return i;
        }
      }
      return -1;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .factory('AuthInterceptor', interceptor);

  /** @ngInject */
  function interceptor($q, $rootScope, SessionService, HTTP_STATUS) {
    ////////// Attributes //////////
    var xhrCount = 0;

    var interceptor = {
      request: function (config) {
        incrementCounter(config);
        setupCredentials(config);
        return config;
      },

      requestError: function (config) {
        decrementCounter(config);
        return config;
      },

      response: function (res) {
        decrementCounter(res.config);
        return res;
      },

      responseError: function (res) {
        decrementCounter(res.config);
        clearCredentials(res);
        return $q.reject(res);
      }
    }

    return interceptor;

    ////////// Functions //////////

    function setupCredentials(config) {
      config.headers['Accept'] = 'application/json';
      if (SessionService.isloggedIn()) {
        config.headers['X-User-Token'] = SessionService.sessionToken();
      }
    }

    function incrementCounter(config) {
      if (!config.ignoreLoading) {
        xhrCount++;
        updateStatus();
      }
    }

    function decrementCounter(config) {
      if (!config.ignoreLoading) {
        xhrCount--;
        updateStatus();
      }
    }

    function updateStatus() {
      $rootScope.isLoading = xhrCount > 0;
    }

    function clearCredentials(response) {
      if (response.status == HTTP_STATUS.UNAUTHORIZED) {
        $rootScope.$emit('unauthorized', 'Your account has been disconnected!');
        SessionService.clearSession();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, $log, $mdDialog, lodash, toastr, TOSTATE, CounterService, RoutesService, SessionService, StorageService, AdBlockerService, EnvironmentConfig) {

    const SIGNIN_STATE = 'sign-in';

    var originalUrl = window.location.href;
    var showingDialog = false;

    // Start the poller for notifications
    CounterService.poller(true);

    // listen for the event in the relevant $scope
    $rootScope.$on('unauthorized', function (event) {
      RoutesService.signIn();
    });

    // Redirect to login if route requires auth and you're not logged in
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      var token = getParamByName('token', originalUrl);
      var role = getParamByName('role', originalUrl);

      if (token && role && toState.name == SIGNIN_STATE) {
        originalUrl = '';
        SessionService.clearSession();
        event.preventDefault();
        SessionService.forceSessionFromAdmin(token, role);
        RoutesService.dashboard();
      }

      // Users not logged may not access "authentication required" pages
      if (!SessionService.isloggedIn() && isLoggedInRequired(toState.name)) {
        event.preventDefault();

        if (toState.name != SIGNIN_STATE) {
          StorageService.set(TOSTATE, toState);
        }
        toastr.warning('You must sign in before continuing.');
        return $state.go(SIGNIN_STATE);
      } else if (toState.authentication.required && !toState.authentication.permittedRoles.includes(SessionService.currentRole())) {
        event.preventDefault();
        RoutesService.dashboard();
        toastr.warning('You don\'t have permission to continue.');
      }

      // Users are prevented to go back to landing page once they are signed in
      if (toState.name == SIGNIN_STATE && SessionService.isloggedIn()) {
        event.preventDefault();
        RoutesService.dashboard();
      }

      AdBlockerService.adBlockerEnabled(function (blocked) {
        if (blocked && !showingDialog) {
          showingDialog = true;
          showDialog('Ad Blocker detected', 'WARNING! Our software requires you to disable your ad block on your browser. Please whitelist our entire website. Thank you!', 'OK, I understand')
          .then(function () {
            showingDialog = false;
          });
        }
      });
    });

    // Private functions

    function isLoggedInRequired(name) {
      return !lodash.includes(['landing', 'sign-up', 'sign-in', 'forgot-pw', 'reset-pw', 'thankyou-adv', 'thankyou-pub'], name)
    }

    function getParamByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function removeParamByName(key, url) {
      if (!url) url = window.location.href;
      var rtn = url.split("?")[0],
        param,
        params_arr = [],
        queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    }

    function showDialog(title, text, confirmText) {
      return $mdDialog.show(
        $mdDialog.alert()
        .title(title)
        .textContent(text)
        .escapeToClose(false)
        .ok(confirmText)
      );
    }

    window.fbAsyncInit = function() {
      FB.init({
        appId: EnvironmentConfig.FACEBOOK_APP_ID,
        status: true,
        cookie: true,
        xfbml: true,
        version: 'v6.0'
      });
    };

    (function(d){
      // load the Facebook javascript SDK

      var js,
      id = 'facebook-jssdk',
      ref = d.getElementsByTagName('script')[0];

      if (d.getElementById(id)) {
        return;
      }

      js = d.createElement('script');
      js.id = id;
      js.async = true;
      js.src = "//connect.facebook.net/en_US/all.js";
      js.target = "_top";

      ref.parentNode.insertBefore(js, ref);

    }(document));
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
  }
})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('linktub')
    .constant('LINK_STATE', {
      NEW_LINK: 'new_link',
      APPROVED: 'approved',
      SUSPENDED: 'suspended'
    })
    .constant('ERROR_CODES', ['81717', '81715'])
    .constant('POLL_TIME', 6000)
    .constant('TYPE_STATE', {
      ACTIVE_CONTENT: 'active_content',
      AWAITING_PUBLICATION: 'awaiting_publication',
      APPROVED_URL: 'approved_url',
      REJECTED_CONTENT: 'rejected_content',
      REJECTED_OR_CANCELLED_CONTENT: 'rejected_or_cancelled_content',
      ACTIVE_ADS: 'active_ads',
      NEW_ORDERS: 'new_orders',
      PRICING_AND_PAUSING: 'pricing_and_pausing',
      RESUBMITTED_CONTENT: 'resubmitted_content',
      QUOTES: 'quotes',
      ARTICLES: 'articles',
      MESSAGES: 'messages'
    })
    .constant('KEY_CODES', {
      ENTER: 13
    })
    .constant('PAGINATION_SIZE', {
      MAX_SIZE: 6,
      PER_PAGE: 10
    })
    .constant('MASK', {
      SEVEN: '*******',
      SIX: '******'
    })
    .constant('ORDER_ORIGIN', {
      CART: 'cart',
      CONTENT: 'content_done'
    })
    .constant('ORDER_STATES', {
      CANCELLED: 'cancelled'
    })
    .constant('CHECKOUT', 'checkout')
    .constant('ROLE', {
      ADV: 'advertiser',
      PUB: 'publisher'
    })
    .constant('PROFILE_TYPE', {
      BLOGGER: 'blogger',
      INFLUENCER: 'influencer',
      BROKER: 'broker',
      CONTRIBUTOR: 'contributor'
    })
    .constant('HTTP_STATUS', {
      BAD_REQUEST: '400',
      UNAUTHORIZED: '401',
      FORBIDDEN: '403',
      NOT_FOUND: '404'
    })
    .constant('ERRORS_RESPONSES', {
      ALREADY_TAKEN: 'Validation failed: Href has already been taken',
      INVALID: 'Validation failed: Href is an invalid URL'
    })
    .constant('SESSION', {
      NAME: 'session',
      EXP: 30
    })
    .constant('SOCIAL', {
      Facebook: 'facebook',
      Twitter: 'twitter',
      Youtube: 'youtube',
      Instagram: 'instagram',
      Pinterest: 'pinterest'
    })
    .constant('MIN_VALUES', {
      GA: 500,
      SOCIAL: 50,
      DA: 15,
      TF: 2
    }).constant('PUB_URL_STATE', {
      PENDING: 'pending',
      PAUSED: 'paused',
      ACTIVE: 'active',
      REJECTED: 'rejected',
      RESUBMITTED: 'resubmitted',
      CANCELLED: 'cancelled',
      APPROVE_PUB: 'approved_by_publisher',
      APPROVE: 'approved',
      REJECTED_ADMIN: 'rejected_by_admin',
      UNDER_REVIEW: 'under_review',
      PAID: 'paid'
    }).constant('Assets', 'assets/files/')
    .constant('ARTICLE_STATES', {
      DRAFT: 'draft',
      ASSIGNED: 'assigned',
      COMPLETED: 'completed',
      ADMIN_REJECTED: 'admin_rejected',
      AUTHOR_REJECTED: 'author_rejected',
      AGENCY_REJECTED: 'agency_rejected',
      APPROVED: 'admin_approved',
      CANCELLED: 'cancelled',
    })
    .constant('BLOG_POST_STATES', {
      CANCELLED: 'cancelled',
    })
    .constant('REGEX', {
      URL: '(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})'
    })
    .constant('SCOPE', {
      ANALYTICS: 'https://www.googleapis.com/auth/analytics.readonly',
      YOUTUBE: 'https://www.googleapis.com/auth/youtube.readonly'
    })
    .constant('AUTHOR_QUOTE', {
      SF: 'scalefluence',
      AGENCY: 'agency'
    })
    .constant('INIT_DATE', new Date(2016, 9, 1))
    .constant('ADV_STATES', ['cart', 'adv-dash', 'search', 'new-campaign',
      'all-campaigns', 'quotes-main', 'done-articles', 'faq-adv', 'advertiser'
    ])
    .constant('PUB_STATES', ['pub-dash', 'new-profile', 'all-profiles', 'payouts',
      'faq-pub', 'pub'
    ])
    .constant('MIN_PASS_SIZE', 7)
    .constant('ORDER_CREATED_ORIGIN', {
      QUOTE: 'quote',
      SEARCH: 'search',
      ARTICLE: 'article'
    })
    .constant('MESSAGE_STATE', {
      SENT: 'sent',
      READ: 'read',
      UNREAD: 'unread'
    })
    .constant('CAMPAIGN_STATE', {
      ACTIVE: 'active',
      REJECTED: 'rejected'
    })
    .constant('TOSTATE', 'toState')
    .constant('ARTICLE_REWRITES', [1, 2])
    .constant('WEB_CONTENT_PRICES', {
      NAME: 'Web Content',
      FIELDS: [
        {
          price_type: 'marketer_article',
          description: 'ARTICLE BY BLOGGER | DIGITAL ASSETS & PHOTOS GIVEN BY MARKETER',
          info: 31,
          key: 'newProfileWebContentMarketerArticle'
        },
        {
          price_type: 'influencer_article',
          description: 'ARTICLE & PHOTOS BY BLOGGER | MARKETER SHIPS FREE PRODUCT FOR REVIEW<br>(PLEASE ASSUME $100 VALUE / DISCOUNT FOR PRODUCT SHIPPED)',
          info: 32,
          key: 'newProfileWebContentInfluencerArticle'
        },
        {
          price_type: 'video',
          description: 'Unboxing / Tutorial / Review Video + blog content<br>(PLEASE ASSUME $100 VALUE / DISCOUNT FOR PRODUCT SHIPPED)',
          info: 33,
          key: 'newProfileWebContentVideo'
        }
      ]
    })
    .constant('SOCIAL_PRICES', {
      FACEBOOK: {
        NAME: 'Facebook',
        FIELDS: [
          {
            price_type: 'marketer_post_price',
            description: '1 Post + Photos given by Marketer (1 to 5)',
            note: '(Content Created by You)',
            info: 411
          },
          {
            price_type: 'influencer_post_price',
            description: '1 Post + Photos done by Influencer (1 to 5)',
            note: '(Give Discount for Free Product)',
            info: 412
          },
          {
            price_type: 'unboxing_tutorial_video_price',
            description: 'Unboxing / Tutorial / Review Video',
            note: '(Give Discount for Free Product)',
            info: 413
          },
          {
            price_type: 'sharing_linking_price',
            description: 'Sharing or Linking to Existing Content',
            note: '',
            info: 414
          }
        ]
      },
      INSTAGRAM: {
        NAME: 'Instagram',
        FIELDS:  [
          {
            price_type: 'brand_photo_price',
            description: 'Standard Post (1 to 3) Branded Photos',
            note: '(Content Created by You)',
            info: 421
          },
          {
            price_type: 'photos_product_price',
            description: 'Standard Post (1 to 3) Photos / Product',
            note: '(Give Discount for Free Product)',
            info: 422
          },
          {
            price_type: 'unboxing_review_price',
            description: 'Unboxing | Review for an IG Story',
            note: '(Give Discount for Free Product)',
            info: 423
          },
          {
            price_type: 'brand_three_posts_price',
            description: 'Brand Ambassador - 3 posts over time',
            note: '(Give Discount for Multiple Posts)',
            info: 424
          },
          {
            price_type: 'brand_five_posts_price',
            description: 'Brand Ambassador - 5 posts over time',
            note: '(Give Discount for Multiple Posts)',
            info: 425
          }
        ]
      },
      YOUTUBE: {
        NAME: 'Youtube',
        FIELDS: [
          {
            price_type: 'brand_partnership_price',
            description: "'Brought to you by' Brand partnership",
            note: '(Digital assets delivered by brand)',
            info: 431
          },
          {
            price_type: 'unboxing_review_price',
            description: 'Unboxing | Review | Featured Video',
            note: '(Give Discount for Free Product)',
            info: 432
          },
          {
            price_type: 'brand_three_video_price',
            description: 'Brand Ambassador - 3 videos over time',
            note: '(Give Discount for Multiple Posts)',
            info: 432
          },
          {
            price_type: 'brand_five_video_price',
            description: 'Brand Ambassador - 5 videos over time',
            note: '(Give Discount for Multiple Posts)',
            info: 433
          },
          {
            price_type: 'brand_shorts_price',
            description: 'Youtube short',
            note: '(Give Discount for shorts)',
            info: 435
          },

        ]
      },
      TWITTER: {
        NAME: 'Twitter',
        FIELDS: [
          {
            price_type: 'brand_partnership_price',
            description: 'Brand partnership | Shoutout',
            note: '(Digital assets delivered by brand)',
            info: 441
          },
          {
            price_type: 'sponsored_tweet_vid_price',
            description: 'Sponsored Tweet + Product Video(s)',
            note: '(Give Discount for Free Product)',
            info: 443
          },
          {
            price_type: 'sponsored_tweet_price',
            description: 'Sponsored Tweet + Product Photo(s)',
            note: '(Give Discount for Free Product)',
            info: 442
          }
        ]
      }
    })
    .constant('NEW_PROFILE', {
      STEP_NAMES: ['Create', 'Domain Info', 'Sponsored Blog', 'Sponsored Social', 'SEO'],
      ETNIC_GROUPS: [
        'White / Caucasian', 'Black / African American',
        'African', 'Arab / Middle Eastern',
        'Asian', 'Australian', 'West Europe & UK',
        'East Europe & Russia', 'Spanish / Latino',
        'South America', 'Pacific Islander',
        'Native American'
      ],
      GENDER_LIST: ['Mostly Female', 'Mostly Male', 'Pretty even'],
      AUDIENCE_ESTIMATED_INCOMES: ['Under $25K', '$25K - $50K', '$50K - $75K', '$75K - $100K', 'Over $150K '],
      LANGUAGES_LIST: [
        'Arabic', 'Chinese', 'English', 'French',
        'German', 'Hindi', 'Hebrew', 'Italian', 'Japanese',
        'Korean', 'Portugese', 'Russian', 'Spanish', 'Turkish'
      ],
      AGE_GROUPS: ['17 and under', '18 to 24', '25 to 34', '35 to 44', '45 to 54', '55 to 64', '65 and up'],
      PETS_LIST: ['Dog', 'Cat', 'Bird', 'Fish', 'Rabbit', 'Reptile', 'Equine', 'Exotic']
    })
    .constant('PUBLISHER_NOT_ACTIVE_TOOLTIP',
      'PUBLISHER HAS STOPPED RESPONDING. EMAIL ADMIN@SCALEFLUENCE.COM FOR HELP.')

})();

(function () {
  'use strict';

  angular
    .module('linktub')
    .config(config)

  /** @ngInject */
  function config($logProvider, $provide, toastrConfig, $httpProvider, $mdThemingProvider,
    paginationTemplateProvider, localStorageServiceProvider, EnvironmentConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Setup local-storage for cookies
    localStorageServiceProvider.setPrefix('linktub');
    localStorageServiceProvider.setStorageCookie(45, '/', true);

    // Setup toastr
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 5000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.closeButton = true;
    toastrConfig.progressBar = true;
    toastrConfig.newestOnTop = true;
    // uncomment below to send admin an email each time a user is faced with a toastr error
    // toastrConfig.onShown = function (toast) {
    //   try {
    //     // this is a pretty patch-worky way to do this, but we wanted a quick way
    //     // to notify admin any time a user was faced with an error... because this
    //     // is all in the config setup part of angularjs a lot of angularjs services
    //     // are not available, so we got around this with raw javascript and some jquery
    //     // which should generally always be loaded and available by the time this is
    //     // ever called
    //     if (toast.iconClass == 'toast-error') {
    //       var subject = 'toastr error on ' + window.location.href;
    //       var msg = '';
    //       jQuery("div.toast-error div div").each( function(index) {
    //         msg += ' - ' + jQuery(this).html();
    //       });
    //       jQuery.post( EnvironmentConfig.API_END_POINT + '/send_admin_notification', { subject: subject, body: msg } );
    //     }
    //   } catch (error) {
    //     // do nothing as we want to take great care that this patch-worky code never breaks
    //     // the app
    //   }
    // };

    // Setup interceptor for $http
    $httpProvider.interceptors.push('AuthInterceptor');

    // Setup pagination template
    paginationTemplateProvider.setPath('app/components/paging/paging.html');

    // Setup theme
    $mdThemingProvider.definePalette('neonorange', {
      '50': 'ffede0',
      '100': 'ffd1b3',
      '200': 'ffb380',
      '300': 'ff944d',
      '400': 'ff7d26',
      '500': 'ff6600',
      '600': 'ff5e00',
      '700': 'ff5300',
      '800': 'ff4900',
      '900': 'ff3800',
      'A100': 'ffffff',
      'A200': 'ff6600',
      'A400': 'ffc9bf',
      'A700': 'ffb4a6',
      'contrastDefaultColor': 'dark',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('neonblue', {
      '50': 'e0edf3',
      '100': 'b3d1e1',
      '200': '80b2cd',
      '300': '4d93b8',
      '400': '267ca9',
      '500': '00659a',
      '600': '005d92',
      '700': '005388',
      '800': '00497e',
      '900': '00376c',
      'A100': '9cc6ff',
      'A200': '69a9ff',
      'A400': '368cff',
      'A700': '1c7eff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A400',
        'A700'
      ]
    });

    // // Use that theme for the primary intentions
    $mdThemingProvider.theme('default')
      .primaryPalette('neonblue')
      .accentPalette('neonorange');

    // Setup actions for textAngular
    $provide.decorator('taOptions', ['$delegate', function (taOptions) {
      taOptions.forceTextAngularSanitize = true;
      taOptions.keyMappings = [];
      taOptions.toolbar = [
        ['html', 'h1', 'h2', 'h3', 'p', 'pre', 'quote'],
        ['bold', 'italics', 'underline', 'ul', 'ol', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['insertImage', 'insertLink']
      ];
      taOptions.classes = {
        focussed: '',
        toolbar: 'ta-toolbar',
        toolbarGroup: 'ta-button-group',
        toolbarButton: '',
        toolbarButtonActive: 'md-primary',
        disabled: 'disabled',
        textEditor: 'ta-text-editor',
        htmlEditor: 'md-input'
      };

      return taOptions;
    }]);

    $provide.decorator('taTools', ['$delegate', function (taTools) {
      taTools.h1.display = '<md-button aria-label="Heading 1">H1</md-button>';
      taTools.h2.display = '<md-button aria-label="Heading 2">H2</md-button>';
      taTools.h3.display = '<md-button aria-label="Heading 3">H3</md-button>';
      taTools.p.display = '<md-button aria-label="Paragraph">P</md-button>';
      taTools.pre.display = '<md-button aria-label="Pre">pre</md-button>';
      taTools.quote.display = '<md-button class="md-icon-button" aria-label="Quote"><md-icon md-font-set="material-icons">format_quote</md-icon></md-button>';
      taTools.bold.display = '<md-button class="md-icon-button" aria-label="Bold"><md-icon md-font-set="material-icons">format_bold</md-icon></md-button>';
      taTools.italics.display = '<md-button class="md-icon-button" aria-label="Italic"><md-icon md-font-set="material-icons">format_italic</md-icon></md-button>';
      taTools.underline.display = '<md-button class="md-icon-button" aria-label="Underline"><md-icon md-font-set="material-icons">format_underlined</md-icon></md-button>';
      taTools.ul.display = '<md-button class="md-icon-button" aria-label="Buletted list"><md-icon md-font-set="material-icons">format_list_bulleted</md-icon></md-button>';
      taTools.ol.display = '<md-button class="md-icon-button" aria-label="Numbered list"><md-icon md-font-set="material-icons">format_list_numbered</md-icon></md-button>';
      taTools.justifyLeft.display = '<md-button class="md-icon-button" aria-label="Align left"><md-icon md-font-set="material-icons">format_align_left</md-icon></md-button>';
      taTools.justifyRight.display = '<md-button class="md-icon-button" aria-label="Align right"><md-icon md-font-set="material-icons">format_align_right</md-icon></md-button>';
      taTools.justifyCenter.display = '<md-button class="md-icon-button" aria-label="Align center"><md-icon md-font-set="material-icons">format_align_center</md-icon></md-button>';
      taTools.justifyFull.display = '<md-button class="md-icon-button" aria-label="Justify"><md-icon md-font-set="material-icons">format_align_justify</md-icon></md-button>';
      taTools.clear.display = '<md-button class="md-icon-button" aria-label="Clear formatting"><md-icon md-font-set="material-icons">format_clear</md-icon></md-button>';
      taTools.html.display = '<md-button aria-label="Show HTML">HTML<md-icon md-font-set="material-icons">code</md-icon></md-button>';
      taTools.insertLink.display = '<md-button class="md-icon-button" aria-label="Insert link"><md-icon md-font-set="material-icons">insert_link</md-icon></md-button>';
      taTools.insertImage.display = '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon md-font-set="material-icons">insert_photo</md-icon></md-button>';
      return taTools;
    }]);
  }
})();

angular.module("linktubConfig", [])
.constant("EnvironmentConfig", {"API_END_POINT":"https://backend.scalefluence.com/api/v1","CLIENT_ID":"867264005190-ce4oaq5ijhdcg3h244559cs78cdi7pi7.apps.googleusercontent.com","FACEBOOK_APP_ID":"248815806006158","TEST_GA_VISITORS":4000,"TEST_DA_SCORE":15,"TEST_TF_SCORE":10,"V2_PROFILE_SWITCH_DATE":"2021-10-01","ADV_NOT_AUTHORIZED_MSG":"You don't have permissions to access this area. Please contact the admin team member / owner of the account.","GOOGLE_AUTH_ENDPOINT":"https://backend.scalefluence.com/google_auth_redirect","STRIPE_PUBLISHABLE_KEY":"pk_live_51ShY58DU5KPxkzlkhwfy3cWQ4xY1D14aXokfxFiW4SvpFCur8laIT2jZA5COhrN88gN304vLNoxA3S1Oaould7zw00tPR9BM6M","MIDSOURCE_TOKENIZATION_KEY":"NOT-USED-FROM-CONFIG-PUT-DIRECTLY-IN-INDEX.HTML-PKhsQQ-u7Au3n-Td23e7-Q67F7g"});

(function () {
  'use strict';

  angular
    .module('linktub.pages.user', [
      'linktub.pages.user.profile'
    ])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('show-profile', {
        parent: 'dashboard',
        url: '/user/profile',
        templateUrl: 'app/pages/user/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'profCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser', 'publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.thankyouPub')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('thankyou-pub', {
        url: '/publishers/thankyou',
        templateUrl: 'app/pages/thankyouPub/thankyouPub.html',
        controller: 'ThankyouPubController',
        controllerAs: 'thankyouPubCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        },
        params: { email: null }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.thankyouAdv')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('thankyou-adv', {
        url: '/advertisers/thankyou',
        templateUrl: 'app/pages/thankyouAdv/thankyouAdv.html',
        controller: 'ThankyouAdvController',
        controllerAs: 'thankyouAdvCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        },
        params: { email: null }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.search')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('search', {
        parent: 'dashboard',
        url: '/search/:categories/:campaignId',
        templateUrl: 'app/pages/search/search.html',
        controller: 'SearchController',
        controllerAs: 'srchCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.reports', [
      'linktub.pages.reports.rejected',
      'linktub.pages.reports.activeContent',
      'linktub.pages.reports.awaitingContent',
      'linktub.pages.reports.activeAdsContent',
      'linktub.pages.reports.newOrders',
      'linktub.pages.reports.pricingPausing',
      'linktub.pages.reports.resubmitted'
    ])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('rejected-reports', {
        parent: 'dashboard',
        url: '/reports/rejected',
        templateUrl: 'app/pages/reports/adv/rejected/reportRejected.html',
        controller: 'ReportRejectedController',
        controllerAs: 'repRejCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('active-content', {
        parent: 'dashboard',
        url: '/reports/activeContent',
        templateUrl: 'app/pages/reports/adv/activeContent/reportActiveContent.html',
        controller: 'ReportActiveContentController',
        controllerAs: 'repActCntCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('awaiting-content', {
        parent: 'dashboard',
        url: '/reports/awaitingContent',
        templateUrl: 'app/pages/reports/adv/awaitingContent/reportAwaitingContent.html',
        controller: 'ReportAwaitingContentController',
        controllerAs: 'repAwaitingCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('new-orders',  {
        parent: 'dashboard',
        url: '/reports/newOrders',
        templateUrl: 'app/pages/reports/pub/newOrders/newOrders.html',
        controller: 'NewOrdersController',
        controllerAs: 'newOrdersCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('active-ads',  {
        parent: 'dashboard',
        url: '/reports/activeAds',
        templateUrl: 'app/pages/reports/pub/activeAds/activeAdsContent.html',
        controller: 'ActiveAdsContentController',
        controllerAs: 'actAdsCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('pricing-pausing',  {
        parent: 'dashboard',
        url: '/reports/pricingPausing',
        templateUrl: 'app/pages/reports/pub/pricingAndPausing/pricingPausing.html',
        controller: 'PricingPausingController',
        controllerAs: 'ppCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('resubmitted',  {
        parent: 'dashboard',
        url: '/reports/resubmitted',
        templateUrl: 'app/pages/reports/pub/resubmittedContent/resubmitted.html',
        controller: 'ResubmittedController',
        controllerAs: 'resCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.quotes', [
      'linktub.pages.quotes.pending',
      'linktub.pages.quotes.received',
      'linktub.pages.quotes.newQuote',
      'linktub.pages.quotes.quoteFor',
      'linktub.pages.quotes.main'
    ])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('received-quotes', {
        parent: 'dashboard',
        url: '/quotes/received',
        templateUrl: 'app/pages/quotes/received/quotesReceived.html',
        controller: 'QuotesReceivedController',
        controllerAs: 'qRecCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('pending-quotes', {
        parent: 'dashboard',
        url: '/quotes/pending',
        templateUrl: 'app/pages/quotes/pending/quotesPending.html',
        controller: 'QuotesPendingController',
        controllerAs: 'qPenCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('new-quote', {
        parent: 'dashboard',
        url: '/quote/new',
        templateUrl: 'app/pages/quotes/newQuote/newQuote.html',
        controller: 'NewQuoteController',
        controllerAs: 'nQuoteCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('quotes-for', {
        parent: 'dashboard',
        url: '/quotes/for/:quoteId',
        templateUrl: 'app/pages/quotes/quoteFor/quoteFor.html',
        controller: 'QuoteForController',
        controllerAs: 'quoteForCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('quotes-main', {
        parent: 'dashboard',
        url: '/quotes',
        templateUrl: 'app/pages/quotes/quotesMain/quotesMain.html',
        controller: 'QuotesMainController',
        controllerAs: 'quotesMainCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.profiles', [
      'linktub.pages.profiles.allV1',
      'linktub.pages.profiles.profile.newV1',
      'linktub.pages.profiles.profile.editV1',
      'linktub.pages.profiles.all',
      'linktub.pages.profiles.profile.new',
      'linktub.pages.profiles.profile.edit',
      'linktub.pages.profiles.profile.edit.audience',
      'linktub.pages.profiles.profile.edit.socials',
      'linktub.pages.profiles.profile.edit.web_content',
      'linktub.pages.profiles.profile.edit.guest_post'
    ])
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('all-profiles-v1', {
        parent: 'dashboard',
        url: '/profiles/all-v1',
        templateUrl: 'app/pages/profiles/allProfilesV1/allProfilesV1.html',
        controller: 'AllProfilesV1Controller',
        controllerAs: 'allProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('new-profile-v1', {
        parent: 'dashboard',
        url: '/profiles/new-v1',
        templateUrl: 'app/pages/profiles/newProfileV1/newProfileV1.html',
        controller: 'NewProfileV1Controller',
        controllerAs: 'newProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-v1', {
        parent: 'dashboard',
        url: '/profiles/edit-v1/:profileId',
        templateUrl: 'app/pages/profiles/editProfileV1/editProfileV1.html',
        controller: 'EditProfileV1Controller',
        controllerAs: 'editProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('all-profiles', {
        parent: 'dashboard',
        url: '/profiles/all',
        templateUrl: 'app/pages/profiles/allProfiles/allProfiles.html',
        controller: 'AllProfilesController',
        controllerAs: 'allProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('new-profile', {
        parent: 'dashboard',
        url: '/profiles/new',
        templateUrl: 'app/pages/profiles/newProfile/newProfile.html',
        controller: 'NewProfileController',
        controllerAs: 'newProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId',
        templateUrl: 'app/pages/profiles/editProfile/editProfile.html',
        controller: 'EditProfileController',
        controllerAs: 'editProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        },
        params: {
          profileId: null,
          profile: null
        },
      })
      .state('edit-profile-audience', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/audience',
        templateUrl: 'app/pages/profiles/editProfile/editAudience/audienceData.html',
        controller: 'EditAudienceController',
        controllerAs: 'editAudienceCtrl',
        params: {
          profileId: null,
          profile: null
        },
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-blog', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/sponsored-blog',
        templateUrl: 'app/pages/profiles/editProfile/editWebContent/webContent.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditWebContentController',
        controllerAs: 'editWebCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-guest-post', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/guest-post',
        templateUrl: 'app/pages/profiles/editProfile/editGuestPost/guestPost.html',
        params: {
          profileId: null,
          profile: null,
          forceAdd: false
        },
        controller: 'EditGuestPostController',
        controllerAs: 'editGPCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-facebook', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/facebook',
        params: {
          profileId: null,
          profile: null
        },
        templateUrl: 'app/pages/profiles/editProfile/editSocials/facebook.html',
        controller: 'EditSocialsController',
        controllerAs: 'editSocialsCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-instagram', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/instagram',
        templateUrl: 'app/pages/profiles/editProfile/editSocials/instagram.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditSocialsController',
        controllerAs: 'editSocialsCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-twitter', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/twitter',
        templateUrl: 'app/pages/profiles/editProfile/editSocials/twitter.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditSocialsController',
        controllerAs: 'editSocialsCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-youtube', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/youtube',
        templateUrl: 'app/pages/profiles/editProfile/editSocials/youtube.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditSocialsController',
        controllerAs: 'editSocialsCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-pinterest', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/pinterest',
        templateUrl: 'app/pages/profiles/editProfile/partials/pinterest.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditProfileController',
        controllerAs: 'editProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('edit-profile-twitch', {
        parent: 'dashboard',
        url: '/profiles/edit/:profileId/twitch',
        templateUrl: 'app/pages/profiles/editProfile/partials/twitch.html',
        params: {
          profileId: null,
          profile: null
        },
        controller: 'EditProfileController',
        controllerAs: 'editProfCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.payouts')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('payouts', {
        parent: 'dashboard',
        url: '/publishers/payouts',
        templateUrl: 'app/pages/payouts/payouts.html',
        controller: 'PayoutController',
        controllerAs: 'payCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.landing', [
      'linktub.pages.landing.signUp',
      'linktub.pages.landing.signIn',
      'linktub.pages.landing.forgotPw',
      'linktub.pages.landing.resetPw'])
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('sign-up', {
        url: '/signUp?accountType&ssoEmail',
        templateUrl: 'app/pages/landing/signUp/signUp.html',
        controller: 'SignUpController',
        controllerAs: 'signUpCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        }
      })
      .state('sign-in', {
        url: '/',
        templateUrl: 'app/pages/landing/signIn/signIn.html',
        controller: 'SignInController',
        controllerAs: 'signInCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        }
      })
      .state('forgot-pw', {
        url: '/forgotPassword',
        templateUrl: 'app/pages/landing/forgotPw/forgotPw.html',
        controller: 'ForgotPwController',
        controllerAs: 'forgotPwCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        }
      })
      .state('reset-pw', {
        url: '/resetPassword?token',
        templateUrl: 'app/pages/landing/resetPw/resetPw.html',
        controller: 'ResetPwController',
        controllerAs: 'resetPwCtrl',
        authentication: {
          required: false,
          permittedRoles: ['advertiser', 'publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.faq')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('faq-pub', {
        parent: 'dashboard',
        url: '/publishers/faq',
        templateUrl: 'app/pages/faq/partials/faqPub.html',
        controller: 'FaqController',
        controllerAs: 'faqCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      })
      .state('faq-adv', {
        parent: 'dashboard',
        url: '/advertisers/faq',
        templateUrl: 'app/pages/faq/partials/faqAdv.html',
        controller: 'FaqController',
        controllerAs: 'faqCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.dashboard', [
      'linktub.pages.dashboard.adv',
      'linktub.pages.dashboard.pub'
    ])
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('dashboard', {
        abstract: true,
        templateUrl: 'app/pages/dashboard/dashboard.html'
      })
      .state('adv-dash', {
        parent: 'dashboard',
        url: '/adv/dashboard',
        templateUrl: 'app/pages/dashboard/adv/advDashboard.html',
        controller: 'AdvDashboardController',
        controllerAs: 'advCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('pub-dash', {
        parent: 'dashboard',
        url: '/pub/dashboard',
        templateUrl: 'app/pages/dashboard/pub/pubDashboard.html',
        controller: 'PubDashboardController',
        controllerAs: 'pubCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.contactUs')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('contact-us', {
        parent: 'dashboard',
        url: '/contactUs',
        templateUrl: 'app/pages/contactUs/contactUs.html',
        controller: 'ContactUsController',
        controllerAs: 'contactCtrl',
        authentication: {
          required: true,
          permittedRoles: ['publisher', 'advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.cart')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('cart', {
        parent: 'dashboard',
        url: '/cart',
        templateUrl: 'app/pages/cart/cart.html',
        controller: 'CartController',
        controllerAs: 'crtCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('checkout', {
        parent: 'dashboard',
        url: '/cart/checkout',
        templateUrl: 'app/pages/cart/checkout/checkout.html',
        controller: 'CheckoutController',
        controllerAs: 'chkCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.creditCards')
      .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('credit-card', {
        parent: 'dashboard',
        url: '/user/profile/creditCard/:cardId',
        templateUrl: 'app/pages/creditCards/creditCards.html',
        controller: 'CreditCardController',
        controllerAs: 'vm',
        authentication: {
          required: true,
          permittedRoles: ['advertiser', 'publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.campaigns', [
      'linktub.pages.campaigns.all',
      'linktub.pages.campaigns.teammate',
      'linktub.pages.campaigns.campaign.new',
      'linktub.pages.campaigns.campaign.edit',
      'linktub.pages.campaigns.site.new'
    ])
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('all-campaigns', {
        parent: 'dashboard',
        url: '/campaigns/all',
        templateUrl: 'app/pages/campaigns/allCampaigns/allCampaigns.html',
        controller: 'AllCampaignsController',
        controllerAs: 'allCampCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('teammate-campaigns', {
        parent: 'dashboard',
        url: '/campaigns/teammate/:teammateId',
        templateUrl: 'app/pages/campaigns/teammateCampaigns/teammateCampaigns.html',
        controller: 'TeammateCampaignsController',
        controllerAs: 'allCampCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('new-campaign', {
        parent: 'dashboard',
        url: '/campaigns/new',
        templateUrl: 'app/pages/campaigns/newCampaign/newCampaign.html',
        controller: 'NewCampaignController',
        controllerAs: 'newCampCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('new-site', {
        parent: 'dashboard',
        url: '/site/new/:campaignId',
        templateUrl: 'app/pages/campaigns/newSite/newSite.html',
        controller: 'NewSitePageController',
        controllerAs: 'newSteCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('edit-campaign', {
        parent: 'dashboard',
        url: '/campaigns/edit/:campaignId',
        templateUrl: 'app/pages/campaigns/editCampaign/editCampaign.html',
        controller: 'EditCampaignController',
        controllerAs: 'editCampCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.billing')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('billing', {
        parent: 'dashboard',
        url: '/billing',
        templateUrl: 'app/pages/billing/billing.html',
        controller: 'BillingController',
        controllerAs: 'billCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser', 'publisher']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.articles', [
      'linktub.pages.articles.done',
      'linktub.pages.articles.pipeline'
    ])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('done-articles', {
        parent: 'dashboard',
        url: '/articles/done',
        templateUrl: 'app/pages/articles/done/articlesDone.html',
        controller: 'ArticlesDoneController',
        controllerAs: 'aDoneCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('pipeline-articles', {
        parent: 'dashboard',
        url: '/articles/pipeline',
        templateUrl: 'app/pages/articles/pipeline/articlesPipeline.html',
        controller: 'ArticlesPipelineController',
        controllerAs: 'aPipeCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages.advTeammates', [
      'linktub.pages.advTeammates.new',
      'linktub.pages.advTeammates.edit'
    ])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('adv-teammates', {
        parent: 'dashboard',
        url: '/adv/teammates',
        templateUrl: 'app/pages/advTeammates/newAdvTeammate/newAdvTeammate.html',
        controller: 'NewAdvTeammateController',
        controllerAs: 'aCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      })
      .state('edit-adv-teammate', {
        parent: 'dashboard',
        url: '/adv/teammates/edit/:teammateId',
        templateUrl: 'app/pages/advTeammates/editAdvTeammate/editAdvTeammate.html',
        controller: 'EditAdvTeammateController',
        controllerAs: 'eCtrl',
        authentication: {
          required: true,
          permittedRoles: ['advertiser']
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('linktub.pages', [
      'linktub.pages.articles',
      'linktub.pages.campaigns',
      'linktub.pages.cart',
      'linktub.pages.payouts',
      'linktub.pages.dashboard',
      'linktub.pages.landing',
      'linktub.pages.quotes',
      'linktub.pages.search',
      'linktub.pages.reports',
      'linktub.pages.user',
      'linktub.pages.billing',
      'linktub.pages.profiles',
      'linktub.pages.creditCards',
      'linktub.pages.faq',
      'linktub.pages.contactUs',
      'linktub.pages.thankyouAdv',
      'linktub.pages.thankyouPub',
      'linktub.pages.advTeammates'
    ]);
})();

angular.module("linktub").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/daPricingChart/daPricingChart.html","<div class=da-price-chart-container><h3 class=text-center>Your Domain Authority (DA) is <span class=highlighted>{{ vm.da }}</span></h3><table><tr><th></th><th class=index ng-repeat=\"row in vm.columns\" ng-class=\"{ highlighted: vm.isSelected($index + vm.min) }\">{{ row.index }}</th></tr><tr><td class=row-name>DA</td><td ng-repeat=\"row in vm.columns\" ng-class=\"{ around: vm.around($index + vm.min), select: vm.isSelected($index + vm.min) }\">{{ row.value }}</td></tr></table></div>");
$templateCache.put("app/components/elementsSelector/elementsSelector.html","<div class=elements><div class=elements__header><h6 class=elements__title ng-class=\"{\'blank__audience-data\': vm.highlightBlankAudienceFields && vm.elements.length == 0}\">{{vm.selectorTitle}} <span class=select-info ng-show=\"vm.showInfo && vm.elements.length != vm.elementsLimit\">Select from below</span></h6></div><md-card ng-mouseover=\"vm.showInfo=true\" ng-mouseleave=\"vm.showInfo=false\" class=cat-card ng-class=\"{ \'shrinked\': vm.shrinked && vm.$mdMedia(\'gt-sm\'),\n    \'adjusted\' : vm.showOwnHideButton && vm.$mdMedia(\'gt-sm\'),\n     \'blank__audience-data\': vm.highlightBlankAudienceFields && vm.elements.length == 0}\"><md-chips readonly=true md-removable=true class=md-no-underline ng-model=vm.elements placeholder=\"{{vm.elements.length == vm.elementsLimit ? \'\' : \'Add an item\'}}\" md-max-chips=vm.elementsLimit layout=row></md-chips></md-card><ul ng-hide=vm.hideElements class=elements__list><li ng-repeat=\"element in vm.mElements\"><a ng-click=\"(vm.elements.length < vm.elementsLimit || vm.isSelected(element)) && vm.toggleElement(element)\" ng-class=\"{ \'selected\': vm.isSelected(element), \'disabled-for-select\': vm.elements.length == vm.elementsLimit }\" href=javascript:void(0)>{{ element }}</a></li></ul><div class=\"edit-profile__show-control-btn d-block d-md-none\"><button type=button class=\"btn btn-link\" ng-click=vm.toggleCatList()>{{ vm.toggleBtnText() }}</button></div></div>");
$templateCache.put("app/components/faqSite/faqSite.html","<div class=faq__content ng-if=!vm.isPublisher()><div class=faq__image><img src=assets/images/faq.svg alt></div><div class=faq__list><div class=faq__row ng-init=\"faq1 = false\" ng-class=\"{\'faq__row--active\':faq1}\" ng-click=\"faq1 = !faq1\"><div class=faq__question>I created an account. Now what?</div><div class=faq__answer>Click \"<a href=#/campaigns/new>Create New Campaign</a>\". This takes 2 minutes. Give us the home page URL, select some relevant categories, click submit.</div><div ng-if=faq1 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq1 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq2 = false\" ng-class=\"{\'faq__row--active\':faq2}\" ng-click=\"faq2 = !faq2\"><div class=faq__question>How come the domains are hidden?</div><div class=faq__answer>To avoid spam and users trying to bypass our markups, to be honest. If you want to see domains for a given Campaign, click \"<a href=#/quotes>Quotes</a>\".<br><br>After you get a quote going, our team will send a good sized selection of about 15 to 20 publishers; given the Authority Metrics that you requested in the quote.</div><div ng-if=faq2 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq2 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq3 = false\" ng-class=\"{\'faq__row--active\':faq3}\" ng-click=\"faq3 = !faq3\"><div class=faq__question>What happens after I have my Quote?</div><div class=faq__answer>A <sub>(1)</sub> :<br>Firstly, you can search hidden domains and put them into the cart if you “like what you see” from the metrics &amp; description. Attach your copy and purchase. It’s that easy.<br><br>A <sub>(2)</sub> :<br>Secondly, if you need to see domains, you will see domains in the Quote.<ul><li>If you want us to do the content they will be in: “Content Pipeline”.</li><li>If you want to do the content, the domains will be in: “Cart”</li></ul></div><div ng-if=faq3 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq3 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq4 = false\" ng-class=\"{\'faq__row--active\':faq4}\" ng-click=\"faq4 = !faq4\"><div class=faq__question>I got content from you! Now what?</div><div class=faq__answer>First click “View” to digitally view the content without having to download it.<ul><li>If minor edits are needed, click “Download”, do some minor edits, then click “Upload”.</li><li>If you want a full rewrite from our Author, click “Rewrite”.</li><li>If all done. Click the check box and move item to Checkout</li></ul></div><div ng-if=faq4 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq4 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq5 = false\" ng-class=\"{\'faq__row--active\':faq5}\" ng-click=\"faq5 = !faq5\"><div class=faq__question>What happens after I purchase?</div><div class=faq__answer>Content is sent to bloggers / Influencers. They have 5 days to respond to your order. If a publisher declines the order (or simply does not respond), then you are not charged. The charge will be pending for this 5 day period. If you have multiple under orders in one purchase, then you will only be charged for the order(s) that were accepted by bloggers.<br><br>Bloggers that accept your order, are required to publish in a reasonable time frame and submit the live post back into their account in order to get paid. Our Admin team will review the live post to ensure it matches with your order. Once we approve, it will go live in your Dashboard and you will be notified via email as well.</div><div ng-if=faq5 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq5 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div></div></div><div class=faq__content ng-if=vm.isPublisher()><div class=faq__image><img src=assets/images/faq2.png alt></div><div class=faq__list><div class=faq__row ng-init=\"faq1 = false\" ng-class=\"{\'faq__row--active\':faq1}\" ng-click=\"faq1 = !faq1\"><div class=faq__question>I created an account. Now what?</div><div class=faq__answer>Top right corner, you will see a gear icon. Click that and go to My Account Info. Give us your PayPal information and a secure shipping address (if you plan on accepting product deliveries).</div><div ng-if=faq1 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq1 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq2 = false\" ng-class=\"{\'faq__row--active\':faq2}\" ng-click=\"faq2 = !faq2\"><div class=faq__question>How do I submit my site information?</div><div class=faq__answer>Create a Profile. This is the most important part for you. Please take your time. There are for different types of users that make up Profiles. Choose wisely.<br><br><ul class=highlighted-item><li class=\"highlighted custom-bullet\">Blogger<ul><li class=black-bullet>Someone that owns their own blog and social media handles</li></ul></li><li class=\"highlighted custom-bullet\">Social Influencer<ul><li class=black-bullet>Someone that only uses YouTube (or other networks) to publish content</li></ul></li><li class=\"highlighted custom-bullet\">Contributors<ul><li class=black-bullet>Someone that writes for a publication they do not own. They are called “Contributors”.</li></ul></li><li class=\"highlighted custom-bullet\">Brokers<ul><li class=black-bullet>Someone that reaches out to bloggers and creates working relationships with them.</li></ul></li></ul></div><div ng-if=faq2 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq2 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq3 = false\" ng-class=\"{\'faq__row--active\':faq3}\" ng-click=\"faq3 = !faq3\"><div class=faq__question>How often do I get paid?</div><div class=faq__answer>3 to 7 business days from the day you submit the live blog post back to us.</div><div ng-if=faq3 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq3 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq4 = false\" ng-class=\"{\'faq__row--active\':faq4}\" ng-click=\"faq4 = !faq4\"><div class=faq__question>What kind of sites can I submit?</div><div class=faq__answer>We do not allow gambling, adult, or sites that otherwise are defamatory is some way. Any site that you either own, or have a relationship with (such as a contributor to a publication), as we all as any social media handle that you have created.</div><div ng-if=faq4 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq4 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq5 = false\" ng-class=\"{\'faq__row--active\':faq5}\" ng-click=\"faq5 = !faq5\"><div class=faq__question>Are there any minimum requirements?</div><div class=faq__answer>Here are the minimum requirements for each channel that advertisers are interested in.<br><br><ul class=\"bullet aligned-bullets\"><li>Search: Moz Domain Authority Score of 20 and Majestic Trust Flow Score of 10</li><li>Social: Minimum 1000 followers for each social channel</li><li>Sponsored: 3000 Monthly Unique Visitors (MUV) per month.</li></ul></div><div ng-if=faq5 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq5 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq6 = false\" ng-class=\"{\'faq__row--active\':faq6}\" ng-click=\"faq6 = !faq6\"><div class=faq__question>How do I know if my site is approved?</div><div class=faq__answer>You will receive an email stating if we approve, reject, or if changes need to made before approval.</div><div ng-if=faq6 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq6 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq7 = false\" ng-class=\"{\'faq__row--active\':faq7}\" ng-click=\"faq7 = !faq7\"><div class=faq__question>When will I start getting orders?</div><div class=faq__answer>Depending upon how active and relevant your site is to an advertiser, it may be only days or several months. We cannot control the interest on your site(s) from our marketing partners.</div><div ng-if=faq7 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq7 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq8 = false\" ng-class=\"{\'faq__row--active\':faq8}\" ng-click=\"faq8 = !faq8\"><div class=faq__question>How do I change my prices?</div><div class=faq__answer>From your dashboard &gt; click on “Pricing and Pausing” at top &gt; Find the URL you want to change &gt; Click on the Price link. When finished, click the Submit Icon at the far right.</div><div ng-if=faq8 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq8 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq9 = false\" ng-class=\"{\'faq__row--active\':faq9}\" ng-click=\"faq9 = !faq9\"><div class=faq__question>Where do I opt out?</div><div class=faq__answer>From your dashboard &gt; click on “Pricing and Pausing” at top &gt; Find the URL you want to change &gt; Click on the Pause checkbox.</div><div ng-if=faq9 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq9 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq10 = false\" ng-class=\"{\'faq__row--active\':faq10}\" ng-click=\"faq10 = !faq10\"><div class=faq__question>I want to opt out of certain products? How do I do that?</div><div class=faq__answer>From your dashboard &gt; click on “Pricing and Pausing” in the Top Navigation Items &gt; Find the URL you want to opt out &gt; Click on the Price link.</div><div ng-if=faq10 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq10 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq11 = false\" ng-class=\"{\'faq__row--active\':faq11}\" ng-click=\"faq11 = !faq11\"><div class=faq__question>I got an order! Now what?</div><div class=faq__answer>Simply approve the order if you are fine with the content. Publish in a reasonable time frame. This is usually a couple of days for smaller sites or 3 to 4 weeks for really large sites. You will receive another email prompting you to submit the live blog post back to us in order to receive payment.</div><div ng-if=faq11 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq11 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=faq__row ng-init=\"faq12 = false\" ng-class=\"{\'faq__row--active\':faq12}\" ng-click=\"faq12 = !faq12\"><div class=faq__question>Can I edit content?</div><div class=faq__answer>Yes. But only minor edits please. If you do not like the topic, or the content is too short / too long, you can reject and ask the agency to rewrite the article more to your liking.</div><div ng-if=faq12 class=\"faq__button faq__button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!faq12 class=\"faq__button faq__button--chevron\"><button type=button><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div></div></div>");
$templateCache.put("app/components/categorySelector/categorySelector.html","<div class=categories><div ng-if=!vm.editProfileMode class=categories__header><div class=\"categories__show-control-btn d-none d-md-block\"><button type=button class=\"btn btn-white btn-small toggle-categories\" ng-class=\"{\'categories-shown\': vm.hideCategories}\" ng-click=vm.toggleCatList()>{{ vm.toggleBtnText() }}</button></div></div><md-card flex class=\"cat-card edit-profile__cat-card\" ng-class=\"{\'hidden-border\': vm.editProfileMode, \'shrinked\': vm.shrinked && vm.$mdMedia(\'gt-sm\'),\n    \'adjusted\' : vm.showOwnHideButton && vm.$mdMedia(\'gt-sm\'),\n     \'blank__audience-data\': vm.highlightBlankAudienceFields && vm.categories.length == 0}\"><md-contact-chips class=md-no-underline ng-model=vm.categories md-contacts=vm.querySearch($query) md-contact-name=name md-require-match=true md-highlight-flags=i filter-selected=true placeholder=\"{{ vm.placeholder }}\" layout=row></md-contact-chips></md-card><ul ng-hide=\"vm.hideCategories && !vm.editProfileMode\" class=categories__list ng-class=\"{\n    \'hidden-border elements__list\': vm.editProfileMode}\"><li ng-repeat=\"category in vm.mCategories\"><a ng-click=vm.toggleCategory(category) ng-class=\"{ \'selected\': vm.isSelected(category) }\" href=javascript:void(0)>{{ category.name }}</a><md-tooltip md-direction=top md-delay=300 ng-if=category.keyword>{{ category.keyword }}</md-tooltip></li></ul><div class=\"edit-profile__show-control-btn d-block d-md-none\"><button type=button class=\"btn btn-link\" ng-click=vm.toggleCatList()>{{ vm.toggleBtnText() }}</button></div></div>");
$templateCache.put("app/components/fileUploadDialog/fileUploadDialog.html","<form name=uploadForm><md-toolbar><div class=md-toolbar-tools><h2 class=white>{{ vm.title }}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout-padding><strong>Leave rows blank if you don\'t want to order with those bloggers.</strong><br><br><strong>Email admin@scalefluence.com if you are having issues.</strong></div><div layout=row class=margin-left><md-input-container class=md-block flex><label class=big-size>{{ vm.getInputLabel() }}</label><input ng-model=vm.file.name ng-required=true disabled=disabled></md-input-container><div layout=column layout-align=\"center center\"><md-button class=\"md-raised md-mini\" aria-label=upload type=file ngf-select ng-model=vm.file name=vm.fileName ngf-accept=vm.fileExt ngf-max-size=vm.fileMax>Search</md-button></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ng-click=vm.submit() ng-disabled=uploadForm.$invalid>Submit file</md-button></md-dialog-actions></form>");
$templateCache.put("app/components/fileChooser/fileChooser.html","<div class=file layout=row layout-align=\"start center\"><div layout=row flex layout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-class=\"{ \'word-doc-btn\': vm.smaller }\" ng-disabled=vm.disable aria-label=\"file chooser\" type=file ngf-select ng-model=vm.file name=vm.fileName ngf-accept=vm.fileExt ngf-max-size=vm.fileMax>{{ vm.text }}</md-button><md-input-container class=\"md-block file-name\" ng-class=\"{ \'smaller-input\': vm.smallInput }\" flex><label>{{ vm.label }}</label><input ng-model=vm.file.name disabled=disabled><md-button class=md-icon-button ng-disabled=vm.disable ng-show=vm.file ng-click=vm.clearFile() aria-label=close><md-icon aria-label=delete>close</md-icon></md-button></md-input-container></div></div>");
$templateCache.put("app/components/filterComponentInput/chipsInput.html","<div class=categories><div class=categories__header><h6 class=categories__title>Categories &amp; Strings</h6></div><div style=\"display: flex\"><div class=chips-bg><md-chips ng-model=vm.categories class=\"md-no-underline user-chips\" md-add-on-blur=false md-on-remove=vm.onRemove($chip) md-require-match flex md-on-add=\"vm.onAdd($chip, true)\" class=no-shadows><md-autocomplete flex md-search-text=vm.searchText md-clear-button=true md-highlight-flags=$ md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=item.name md-no-cache=true placeholder=\"{{ vm.placeholder }}\" md-autoselect=false md-autofocus=false><span ng-if=\"!item.byKeywords || !item.activeKey\" md-highlight-text=vm.searchText id=virtualOptionsParent md-highlight-flags=i>{{ item.name }} </span><span ng-if=\"item.byKeywords && item.activeKey\" md-highlight-text=vm.searchText id=virtualOptionsParent md-highlight-flags=i>{{ item.activeKey }}</span></md-autocomplete><md-chip-template search-chip><span><strong>{{ vm.chipName($chip) }}</strong></span></md-chip-template></md-chips></div><button ng-hide=vm.hideInput class=\"btn btn-white btn-search\" ng-if=vm.search ng-click=\"vm.checkChips(vm.searchText); vm.search()\" ng-disabled=\"vm.categories.length === 0\">Search Pubs</button></div><div class=\"categories__show-control-btn d-none d-md-block\" ng-hide=vm.hideToggle><button class=\"btn btn-link\" ng-click=vm.toggleCatList()>Show/Hide Categories</button></div><ul ng-hide=vm.hideCategories class=categories__list><li ng-repeat=\"category in vm.mCategories\"><a ng-click=vm.toggleCategory(category) ng-class=\"{ \'selected\': vm.isSelected(category) }\" href=\"\">{{ category.name }}</a></li></ul></div>");
$templateCache.put("app/components/grid/grid.html","<div class=grid layout-padding layout=column layout-align=\"center center\"><h2 class=title>Majestic Trust Flow</h2><div layout=row layout-align=\"start center\"><h2 class=title>Moz<br>Domain<br>Authority</h2><table><tr><th class=index ng-repeat=\"index in vm.matrix[0]\">{{ index }}</th></tr><tr ng-repeat=\"(key, row) in vm.matrix\" ng-if=\"$index > 0\"><td ng-init=\"id = ((key - 1) * vm.rows) + $index + key - 1\" id=id ng-class=\"{ index: $first, around: vm.isAround(id), select: vm.isTarget(id) }\" ng-repeat=\"value in row\">{{ value }}</td></tr></table></div></div>");
$templateCache.put("app/components/imageSelector/imageSelector.html","<div class=user-photo><div ngf-drop ngf-select ng-model=vm.images ngf-allow-dir=true ngf-change=\"vm.imageChange($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" ngf-multiple=false accept=image/* ngf-pattern=\"\'image/*\'\" ngf-keep=true ng-disabled=vm.ngDisabled flex layout=row layout-align=\"center center\"><div class=user-photo__image ng-class=\"{\'gradient-border\': vm.showBlankImage}\"><img ng-if=vm.result ng-src=\"{{ vm.result }}\" alt> <img ng-if=\"!vm.result && vm.edit && vm.image\" ng-src=\"{{ vm.image }}\" alt> <svg ng-if=\"!vm.result && vm.edit && !vm.image\" class=\"icon icon--camera\"><use xlink:href=assets/images/icons.svg#camera></use></svg> <svg ng-show=\"!vm.result && !vm.edit\" class=\"icon icon--camera\"><use xlink:href=assets/images/icons.svg#camera></use></svg></div></div></div><div hidden><div class=md-dialog-container id=cropper><md-dialog aria-label=cropper><md-toolbar><div class=md-toolbar-tools><h2>Crop your image</h2><span flex></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding layout=column layout-gt-sm=row layout-align=\"center center\"><div class=crop-area><img-crop image=\"vm.imageTemp | ngfDataUrl\" result-image=vm.croppedDataUrl area-type=square result-image-quality=1.0 result-image-format=image/jpeg></img-crop></div><div layout=column class=preview-container><h2>Preview</h2><img class=preview ng-src=\"{{ vm.croppedDataUrl }}\"></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=vm.cancel()>Cancel</md-button><md-button class=md-accent ng-click=vm.select()>Select</md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/components/newSite/newSite.html","<md-card><form name=form ng-submit=\"form.$valid && vm.submit()\"><md-card-content layout=column layout-gt-xs=row flex><md-subheader class=md-no-sticky flex-order-xs=2><h3>Submit a page from your site and start building links to it today!</h3></md-subheader><span flex></span><md-button ng-show=!vm.csv class=\"md-raised full-accent\" flex-order-xs=1 ng-click=vm.showDialog()>Upload Spreadsheet</md-button></md-card-content><md-card-content layout=column><!-- Input for URL --><md-input-container ng-show=!vm.csv class=normal-input flex><label>Add a new url</label><input ng-required=!vm.csv name=url ng-model=vm.campaignUrl placeholder=http://yourawesomesite.com url-input><div ng-messages=form.url.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></md-input-container><!-- CSV file uploaded --><div layout=row ng-show=vm.csv><md-input-container class=normal-input flex><label>Uploaded Spreadsheet</label><input name=csv class=highlighted disabled=disabled ng-model=vm.csv.name></md-input-container><md-button class=\"md-raised full-accent\" ng-if=vm.csv ng-click=vm.clearCsv()>Remove</md-button></div><!-- Select for campaign --><md-input-container class=normal-input flex><label>Add to campaign</label><md-select ng-disabled=vm.cannotSelectCampaign required name=selectedCampaign ng-model=vm.selectedCampaign md-selected-text=vm.getSelectedCampaign()><md-optgroup label=\"your campaigns\"><md-option ng-value=campaign ng-repeat=\"campaign in vm.campaigns\">{{ campaign.name }}</md-option></md-optgroup></md-select><div ng-messages=form.selectedCampaign.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></md-input-container><md-subheader class=md-no-sticky ng-if=vm.showCategories><h3>Select categories for this campaign</h3></md-subheader><category-selector placeholder=\"Select your categories...\" ng-model=vm.categories flex ng-if=vm.showCategories></category-selector><md-button class=\"md-raised full-accent right\" type=submit ng-disabled=\"form.$invalid || vm.isSelectedCategoriesEmpty() || $root.isLoading\">Create</md-button></md-card-content></form></md-card>");
$templateCache.put("app/components/payments/payments.html","<md-subheader class=md-no-sticky><h2>Preview of purchase</h2></md-subheader><div ng-include=\"\'app/components/payments/partials/preview.html\'\"></div><!-- Credit card and owner info --><form name=paymentForm ng-submit=paymentForm.$valid><!-- Error card for showing notification --><md-card ng-if=vm.errorLabel><md-card-content><p class=error>This order has failed to process.</p><p class=error ng-bind-html=vm.errorLabel></p></md-card-content><div class=md-actions layout=row layout-align=\"end center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.errorLabel = \'\'\">OK</md-button></div></md-card><div class=payment layout-gt-sm=row layout=column><div ng-if=\"!vm.selectedCard && vm.usingBraintree()\" ng-include=\"\'app/components/payments/partials/billing.html\'\" flex=50></div><div ng-if=\"!vm.selectedCard && vm.usingCybersource()\" ng-include=\"\'app/components/payments/partials/billingCybersource.html\'\" flex=50></div><div ng-if=\"!vm.selectedCard && vm.usingStripe()\" ng-include=\"\'app/components/payments/partials/billingStripe.html\'\" flex=50></div><div ng-if=\"!vm.selectedCard && vm.usingMidsource()\" ng-include=\"\'app/components/payments/partials/billingMidsource.html\'\" flex=50></div><div ng-if=vm.usingBraintree() ng-include=\"\'app/components/payments/partials/creditCard.html\'\" flex=50 layout=column></div><div ng-if=vm.usingCybersource() ng-include=\"\'app/components/payments/partials/creditCardCybersource.html\'\" flex=50 layout=column></div><div ng-if=vm.usingStripe() ng-include=\"\'app/components/payments/partials/creditCardStripe.html\'\" flex=50 layout=column></div><div ng-if=vm.usingMidsource() ng-include=\"\'app/components/payments/partials/creditCardMidsource.html\'\" flex=50 layout=column></div></div><!-- Terms & conditions acceptance and purchase button --><div class=payment layout=row layout-align=\"end center\"><md-checkbox ng-model=vm.agreed name=string ng-change=expr ng-disabled=$root.isLoading aria-label=string><span>By Clicking Purchase I Agree to the <a href=https://www.scalefluence.com/terms-of-use/ target=_blank>Terms and Conditions of Sale</a></span></md-checkbox><button type=button id=midsource-payment-button class=\"btn btn-orange\" ng-disabled=\"paymentForm.$invalid || $root.isLoading || vm.cantPurchase() || (!vm.selectedCard && paymentForm.$invalid) || (vm.usingMidsource() && !vm.selectedCard && vm.midsourceCardInvalid())\" ng-click=vm.submit()>Purchase</button></div></form><div ng-show=vm.useCardOnFile ng-include=\"\'app/components/payments/partials/cards.html\'\"></div>");
$templateCache.put("app/components/paging/paging.html","<ul ng-if=\"1 < pages.length || !autoHide\" class=\"pagination pagination--shadow\"><li class=page-item ng-if=\"directionLinks && pagination.current > 1\"><a class=page-link href=\"\" ng-click=\"setCurrent(pagination.current - 1)\"><svg class=\"icon icon--prev\"><use xlink:href=assets/images/icons.svg#prev></use></svg></a></li><li class=\"page-item disabled\" ng-if=\"directionLinks && pagination.current == 1\"><a class=page-link href=#><svg class=\"icon icon--prev\"><use xlink:href=assets/images/icons.svg#prev></use></svg></a></li><li class=page-item aria-label=\"Go to page {{ pageNumber + 1 }}\" ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{\'active\': pagination.current == pageNumber}\"><a class=page-link href=\"\" ng-click=setCurrent(pageNumber)>{{ pageNumber }}</a></li><li class=page-item ng-if=\"directionLinks && pagination.current != pagination.last\"><a class=page-link href=\"\" ng-click=\"setCurrent(pagination.current + 1)\"><svg class=\"icon icon--next\"><use xlink:href=assets/images/icons.svg#next></use></svg></a></li><li class=\"page-item disabled\" ng-if=\"directionLinks && pagination.current == pagination.last\"><a class=page-link href=\"\"><svg class=\"icon icon--next\"><use xlink:href=assets/images/icons.svg#next></use></svg></a></li></ul>");
$templateCache.put("app/components/row/row.html","<div class=row-container><h2 class=title>{{ vm.getHeader() }}</h2><table><tr><th></th><th class=index ng-repeat=\"row in vm.showedRows\" ng-class=\"{ highlighted: vm.isSelected($index + vm.min) }\">{{ row.index }}</th></tr><tr><td class=row-name>Post</td><td ng-repeat=\"row in vm.showedRows\" ng-class=\"{ around: vm.around($index + vm.min), select: vm.isSelected($index + vm.min) }\">{{ row.value }}</td></tr><tr ng-if=\"vm.showedVideoRows.length > 0\"><td class=row-name>Video</td><td ng-repeat=\"row in vm.showedVideoRows\" ng-class=\"{ around: vm.around($index + vm.min), select: vm.isSelected($index + vm.min) }\">{{ row.value }}</td></tr><tr ng-if=\"vm.showedSharingRows.length > 0\"><td class=row-name>Sharing post</td><td ng-repeat=\"row in vm.showedSharingRows\" ng-class=\"{ around: vm.around($index + vm.min), select: vm.isSelected($index + vm.min) }\">{{ row.value }}</td></tr></table></div>");
$templateCache.put("app/components/remainingTime/remaining.html","<div ng-if=\"!vm.finish && vm.isFinishing()\" class=finishing><span>{{ vm.time.minutes }}m</span> <span>{{ vm.time.seconds }}s</span> <span>({{ vm.endingDate() }})</span></div><span ng-if=\"!vm.finish && !vm.isFinishing()\">{{ vm.remainingHours() }}h ({{ vm.endingDate() }}) </span><span ng-if=vm.finish style=\"color: #727272\">FINISHED</span>");
$templateCache.put("app/components/sidenav/sidenav.html","<md-sidenav class=md-sidenav-left md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout-fill><md-content class=menu-container><md-toolbar class=mini-toolbar hide-gt-md></md-toolbar><md-content layout=column class=menu-content><div ng-if=vm.isAdvertiser() ng-include src=\"\'app/components/sidenav/partials/partial_adv.html\'\"></div><div ng-if=vm.isPublisher() ng-include src=\"\'app/components/sidenav/partials/partial_pub.html\'\"></div></md-content></md-content></md-sidenav>");
$templateCache.put("app/components/toolbar/toolbar.html","<md-toolbar class=toolbar md-whiteframe=3 layout=row layout-align=\"center center\"><div class=md-toolbar-tools><md-button class=md-icon-button aria-label=Menu ng-click=vm.toggleMenu() hide-gt-md><md-icon>menu</md-icon></md-button><md-button class=md-button aria-label=Logo ng-click=vm.goToDashboard()><b class=title><strong ng-transclude></strong></b></md-button><span flex></span><md-menu><md-button aria-label=\"user profile\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon class=menu-icon>person</md-icon><span hide-xs>{{ vm.email }}</span><md-icon class=menu-icon>arrow_drop_down</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=vm.profile()><md-icon>account_circle</md-icon>My Account Info</md-button></md-menu-item><md-menu-item><md-button ng-click=vm.changeAccount(ev)><md-icon>supervisor_account</md-icon>{{ vm.accountMessage() }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=vm.signOut()><md-icon>exit_to_app</md-icon>Sign out</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-progress-linear class=\"md-accent progress-bar\" md-whiteframe=3 md-mode=indeterminate ng-show=$root.isLoading></md-progress-linear>");
$templateCache.put("app/components/topnavext/topnavext.html","<div class=application__header><div class=\"header header-ext\" ng-class=\"{\'header--menu-shown\': vm.mobileMenuActive}\"><div class=header__content><a class=header__logo href=https://www.scalefluence.com><img src=assets/images/scalefluence-logo-1.png style=\"width: 200px; height: 25px\" alt></a><div style=\"align-items: center; margin-left: 80px; margin-right: 80px\"><ul class=\"header__main-menu header__main-menu_external\"><li><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/influencers/ >Home</a></li><li><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/influencers/ >Influencers</a></li><li><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/agencies/ >Agencies</a></li><li><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/brands/ >Brands</a></li><li><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/blog>Blog</a></li></ul></div><ul class=\"header__main-menu header__main-menu_external\"><li class=desktop-only><a class=header-button ng-click=\"vm.setMobileMenuInactive(); vm.setLoginMenuInactive()\" ui-sref=sign-in>Login</a></li><li class=desktop-only><a class=header-button2 href=javascript:void(0) ng-click=\"vm.setMobileMenuInactive(); vm.toggleLoginMenu()\">Signup</a><div ng-mouseleave=vm.setLoginMenuInactive() class=user-menu><ul style=\"display: none\" class=\"user-menu__dropdown ext-user-menu__dropdown\"><li><a ui-sref=\"sign-up({accountType: \'agency\'})\"><span>Agencies / Brands</span></a></li><li><a ui-sref=\"sign-up({accountType: \'influencer\'})\"><span>Bloggers / Influencers</span></a></li></ul></div></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/influencers/ >Home</a></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/influencers/ >Influencers</a></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/agencies/ >Agencies</a></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/brands/ >Brands</a></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() ui-sref=sign-in>Login</a></li><li class=mobile-only><a ng-click=vm.setMobileMenuInactive() href=https://www.scalefluence.com/blog>Blog</a></li><li class=mobile-only><a ui-sref=\"sign-up({accountType: \'agency\'})\">Signup -> Agencies / Brands</a></li><li class=mobile-only><a ui-sref=\"sign-up({accountType: \'influencer\'})\">Signup -> Bloggers / Influencers</a></li></ul><div class=header__mobile-menu style=\"margin-left: auto\"><button type=button ng-click=vm.toggleMobileMenu()><span></span><span></span><span></span></button></div></div></div></div>");
$templateCache.put("app/components/topnav/topnav.html","<div class=application__header><div class=header ng-class=\"{\'header--menu-shown\': vm.mobileMenuActive}\"><div class=header__content ng-if=vm.isAdvertiser() ng-include src=\"\'app/components/topnav/partials/partial_adv.html\'\"></div><div class=header__content ng-if=vm.isPublisher() ng-include src=\"\'app/components/topnav/partials/partial_pub.html\'\"></div></div><div style=\"width: 100%; height: 5px\"><md-progress-linear class=\"md-accent progress-bar\" md-whiteframe=3 md-mode=indeterminate ng-show=$root.isLoading></md-progress-linear></div></div>");
$templateCache.put("app/pages/billing/billing.html","<div class=billing-container><div layout=row layout-align=\"space-between center\"><md-subheader class=md-no-sticky><h2 class=content-section__title>Billing<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=billCtrl.showInfo()><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h2></md-subheader><form class=\"search-widget active-ads-search-widget\" ng-submit=billCtrl.fetchInvoices()><input ng-model=billCtrl.query.filter class=form-control placeholder=\"Search by URL or Campaign...\" ng-disabled=\"billCtrl.invoices === 0\"> <button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form><md-button class=\"btn btn-white btn-small btn-auto\" ng-click=billCtrl.fetchInvoices() ng-disabled=$root.isLoading aria-label=search>Search</md-button><md-button class=\"btn btn-white btn-small btn-auto\" ui-sref=show-profile ng-disabled=$root.isLoading aria-label=\"back to my account\">Back to my account</md-button></div><div class=billing-content><div dir-paginate=\"invoice in billCtrl.invoices | itemsPerPage: billCtrl.perPage\" current-page=billCtrl.query.page total-items=billCtrl.total_invoices><md-expansion-panel md-component-id=expansionPanelOne ng-if=invoice.refunded_order disabled=disabled><md-expansion-panel-collapsed layout-gt-sm=row layout=column flex><div class=md-title>{{ invoice.created_at | date:\'MM-dd-yyyy\'}}</div><div class=md-summary><p>Refund for: {{ invoice.refunded_order.campaign.name }}</p><p>Purchase Date: {{ invoice.date_purchased | date:\'MM-dd-yyyy\'}}</p><p>Total refunded: {{ invoice.refunded_order.amount | currency }}</p><div><p>Order is Final.</p><button class=link-button ng-click=\"billCtrl.openPdf(invoice); $event.stopPropagation();\">VIEW INVOICE</button></div></div></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header><div class=md-title>{{ invoice.date_purchased | date:\'MM-dd-yyyy\' }}</div><div class=md-summary><p>Total blog posts ordered: {{ invoice.total_orders }}</p><p>Total accepted: {{ invoice.total_accepted }}</p><p>Total charged: {{ invoice.total_charged | currency }}</p><div ng-show=invoice.pending><p>Order pending for 1 week as bloggers as accept orders. Totals subject to change!</p></div><div ng-show=!invoice.pending><p>Order is Final.</p><button class=link-button ng-click=\"billCtrl.openPdf(invoice); $event.stopPropagation();\">VIEW INVOICE</button></div></div><md-expansion-panel-icon ng-click=$panel.collapse()></md-expansion-panel-icon></md-expansion-panel-header><md-expansion-panel-content><md-table-container><table md-table ng-model=invoice.orders md-progress=promise><thead md-head md-order=billCtrl.query.order><tr md-row><th md-column flex=20><span>Publisher</span></th><th md-column md-order-by=url.domain_authority flex=20><span>DA</span></th><th md-column md-order-by=ad.campaign.name flex=5><span>Campaign</span></th><th md-column md-order-by=url.price flex=20><span>Cost</span></th><th md-column flex=20><span>Live Link</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"ad in invoice.orders |\n                      limitTo: invoice.pagination.query.limit : (invoice.pagination.query.page -1) * invoice.pagination.query.limit\"><td md-cell data-ellipsis data-ng-bind=\"ad.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.url.href }}</md-tooltip></td><td md-cell>{{ ad.url.domain_authority }}</td><td md-cell data-ellipsis data-ng-bind=\"ad.campaign.name | limitTo: 20\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.campaign.name }}</md-tooltip></td><td md-cell>{{ ad.amount | currency }}</td><td md-cell><a ng-if=billCtrl.hasLiveLink(ad) ng-href=\"{{ ad.ad.full_pub_url }}\" target=_blank>Click Here</a> <span ng-if=!billCtrl.hasLiveLink(ad)>{{ ad.invoice_state }}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=invoice.pagination.query.limit md-page=invoice.pagination.query.page md-total=\"{{ invoice.orders.length }}\" md-page-select=true></md-table-pagination></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><md-expansion-panel md-component-id=expansionPanelOne ng-if=!invoice.refunded_order><md-expansion-panel-collapsed layout-gt-sm=row layout=column flex><div class=md-title>{{ invoice.date_purchased | date:\'MM-dd-yyyy\'}}</div><div class=md-summary><p>Total blog posts ordered: {{ invoice.total_orders }}</p><p>Total accepted: {{ invoice.total_accepted }}</p><p ng-show=invoice.pending>Max pending: ${{ invoice.total_charged }}</p><p ng-show=!invoice.pending>Total charged: ${{ invoice.total_charged }}</p><p ng-show=invoice.pending>Order pending. Total subject to change.</p><div ng-show=!invoice.pending><p>Order is Final.</p><button class=link-button ng-click=\"billCtrl.openPdf(invoice); $event.stopPropagation();\">VIEW INVOICE</button></div></div><md-expansion-panel-icon></md-expansion-panel-icon></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header><div class=md-title>{{ invoice.date_purchased | date:\'MM-dd-yyyy\' }}</div><div class=md-summary><p>Total blog posts ordered: {{ invoice.total_orders }}</p><p>Total accepted: {{ invoice.total_accepted }}</p><p>Total charged: {{ invoice.total_charged | currency }}</p><div ng-show=invoice.pending><p>Order pending for 1 week as bloggers as accept orders. Totals subject to change!</p></div><div ng-show=!invoice.pending><p>Order is Final.</p><button class=link-button ng-click=\"billCtrl.openPdf(invoice); $event.stopPropagation();\">VIEW INVOICE</button></div></div><md-expansion-panel-icon ng-click=$panel.collapse()></md-expansion-panel-icon></md-expansion-panel-header><md-expansion-panel-content><md-table-container><table md-table ng-model=invoice.orders md-progress=promise><thead md-head md-order=billCtrl.query.order><tr md-row><th md-column flex=20><span>Publisher</span></th><th md-column md-order-by=url.domain_authority flex=20><span>DA</span></th><th md-column md-order-by=ad.campaign.name flex=5><span>Campaign</span></th><th md-column md-order-by=url.price flex=20><span>Cost</span></th><th md-column flex=20><span>Live Link</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"ad in invoice.orders |\n                      limitTo: invoice.pagination.query.limit : (invoice.pagination.query.page -1) * invoice.pagination.query.limit\"><td md-cell data-ellipsis data-ng-bind=\"ad.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.url.href }}</md-tooltip></td><td md-cell>{{ ad.url.domain_authority }}</td><td md-cell data-ellipsis data-ng-bind=\"ad.campaign.name | limitTo: 20\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.campaign.name }}</md-tooltip></td><td md-cell>{{ ad.amount | currency }}</td><td md-cell><a ng-if=billCtrl.hasLiveLink(ad) ng-href=\"{{ ad.ad.full_pub_url }}\" target=_blank>Click Here</a> <span ng-if=!billCtrl.hasLiveLink(ad)>{{ ad.invoice_state }}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=invoice.pagination.query.limit md-page=invoice.pagination.query.page md-total=\"{{ invoice.orders.length }}\" md-page-select=true></md-table-pagination></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel></div></div><div class=campaigns-list__pagination><dir-pagination-controls max-size=billCtrl.maxSize on-page-change=\"billCtrl.paginateInvoices(newPageNumber, oldPageNumber)\"></dir-pagination-controls></div><md-subheader ng-hide=\"billCtrl.invoices.length > 0\" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No results found</h2></md-subheader></div>");
$templateCache.put("app/pages/cart/cart.html","<div layout=column><div layout=row><md-subheader class=md-no-sticky><h3>{{ crtCtrl.searchResultsMsg }}</h3></md-subheader><div class=content-section__right><form class=search-widget><input class=form-control ng-model=crtCtrl.searchCartArticles.filter ng-keyup=crtCtrl.searchBoxKeyUp($event) placeholder=\"Search for campaigns...\"> <button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form></div></div><div layout-padding layout=row layout-align=\"space-between center\"><div layout=row layout-align=\"start center\" class=sel-all><md-checkbox class=check-all aria-label=check ng-checked=crtCtrl.allSelected() ng-click=crtCtrl.toggleAll()></md-checkbox><md-subheader class=md-no-sticky ng-show=crtCtrl.selectedOrders.length><h3>{{ crtCtrl.selectedItems() || \'Select All/None\' }}</h3></md-subheader><md-subheader class=md-no-sticky ng-hide=crtCtrl.selectedOrders.length><h3>Select All/None</h3></md-subheader></div><div layout=row layout-align=\"end center\"><md-button class=\"btn btn-white-red btn-small\" ng-click=crtCtrl.deleteSelected($event) ng-disabled=crtCtrl.cannotDeleteOrders() aria-label=Delete>Remove Selected</md-button><md-button class=\"btn btn-default btn-small btn-auto\" aria-label=checkout ng-disabled=crtCtrl.cannotCheckout() ng-click=crtCtrl.checkout()>Checkout</md-button></div></div><md-divider></md-divider><table class=\"table cart-table\" md-table ng-model=crtCtrl.filteredOrders md-progress=promise><thead md-head md-order=crtCtrl.searchCartArticles.order md-on-reorder=crtCtrl.fetchCarts><tr md-row><th md-column md-order-by=pub_url class=td-blog-url><a class=\"btn btn-link\" href=javascript:void(0)><span>Blog URL</span></a></th><th md-column md-order-by=campaign_name class=td-campaign><a class=\"btn btn-link\" href=javascript:void(0)><span>Campaign</span></a></th><th md-column md-order-by=ordered_date style=\"padding-left: 20px\"><a class=\"btn btn-link\" href=javascript:void(0)><span>Order Date</span></a></th><th></th><th md-column md-order-by=amount class=td-price><a class=\"btn btn-link\" href=javascript:void(0)><span>Price</span></a></th></tr></thead></table><cart-item list=crtCtrl.selectedOrders order=order checkout-clicked=crtCtrl.checkoutClicked checkout=\"crtCtrl.cannotCheckout() && crtCtrl.selectedOrders.length > 0\" template-url=\"\'test\'\" dir-paginate=\"order in crtCtrl.filteredOrders | itemsPerPage: crtCtrl.searchCartArticles.limit\" total-items=crtCtrl.total_orders></cart-item></div><dir-pagination-controls max-size=6 on-page-change=\"crtCtrl.paginateCart(newPageNumber, oldPageNumber)\"></dir-pagination-controls><md-subheader ng-hide=\"crtCtrl.orders.length \" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No orders to show</h2></md-subheader>");
$templateCache.put("app/pages/contactUs/contactUs.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Contact / Help</h2><div class=\"content-section__small-text text-uppercase\">How can we help you?</div></div><div class=content-section__content><div class=help><form class=help__feedback name=contactForm ng-submit=false layout=column flex><div class=form-group><label>Subject</label><input class=form-control type=text ng-model=contactCtrl.subject name=subject md-select-on-focus ng-disabled=$root.isLoading required placeholder=Subject><div ng-messages=contactForm.subject.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div></div></div><div class=form-group><label>Description</label><textarea ng-model=contactCtrl.question_message name=description placeholder=\"Please describe in detail what you need assistance with. We will reply promptly.\" maxlength=500 class=form-control rows=5 md-select-on-focus ng-disabled=$root.isLoading required>\n          </textarea><div ng-messages=contactForm.description.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div><div ng-message=maxlength>Max 500 characters</div></div></div><div class=form-group><button class=\"btn btn-white btn-small\" ng-click=contactCtrl.createMessage(contactForm) ng-disabled=\"contactForm.$invalid || $root.isLoading\">Submit</button></div></form><div ng-if=\"contactCtrl.messages.length === 0\" class=help__messages><h5 class=help__title>No Messages</h5></div><div ng-if=\"contactCtrl.messages.length > 0\" class=help__messages><h5 class=help__title>Messages <span ng-if=\"contactCtrl.unreadItems > 0\">({{ contactCtrl.unreadItems }})</span></h5><div ng-click=contactCtrl.toggleMessage(message) class=\"help__message ng-class:{\'help__message--active\': message.active}\" dir-paginate=\"message in contactCtrl.messages | itemsPerPage: contactCtrl.perPage\" current-page=contactCtrl.currentPage total-items=contactCtrl.totalItems><div class=help__message-title>{{ contactCtrl.decodeMessage(message.subject) }}</div><div class=help__message-date>{{ contactCtrl.getLastDate(message) | date:\'MM-dd-yyyy\' }}</div><div class=help__message-text><p>You said: {{ contactCtrl.decodeMessage(message.question_message) }}</p><p ng-if=contactCtrl.hasReply(message)>Admin Replied: {{ contactCtrl.decodeMessage(message.reply_message) }}</p><p ng-if=!contactCtrl.hasReply(message)>Admin will respond shortly</p></div><div ng-if=message.active class=\"help__message-button help__message-button--close\"><button type=button><svg class=\"icon icon--close-circle\"><use xlink:href=assets/images/icons.svg#close-circle></use></svg></button></div><div ng-if=!message.active class=\"help__message-button help__message-button--chevron\"><button type=button ng-click=contactCtrl.createMessage(contactForm) ng-disabled=\"contactForm.$invalid || $root.isLoading\"><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div></div></div></div></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=application><topnav>SCALEFLUENCE</topnav><content ui-view id=top class=application__content></content><div class=application__footer><div class=footer>&copy;ScaleFluence 2021</div></div></div>");
$templateCache.put("app/pages/creditCards/creditCards.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>{{vm.headerMessage()}}</h2><div class=content-section__right><a class=\"btn btn-white btn-small\" ui-sref=show-profile ng-disabled=$root.isLoading>Back to my account</a></div></div><div class=content-section__content><div class=add-card><form class=add-card__form name=paymentForm ng-submit=paymentForm.$valid><div class=add-card__main-data ng-if=vm.usingBraintree() ng-include=\"\'app/pages/creditCards/partials/billing.html\'\"></div><div class=add-card__main-data ng-if=vm.usingCybersource() ng-include=\"\'app/pages/creditCards/partials/billingCybersource.html\'\"></div><div class=add-card__main-data ng-if=vm.usingStripe() ng-include=\"\'app/pages/creditCards/partials/billingStripe.html\'\"></div><div class=add-card__main-data ng-if=vm.usingMidsource() ng-include=\"\'app/pages/creditCards/partials/billingMidsource.html\'\"></div><div class=add-card__info ng-if=vm.usingBraintree() ng-include=\"\'app/pages/creditCards/partials/creditCardInfo.html\'\"></div><div class=add-card__info ng-if=vm.usingCybersource() ng-include=\"\'app/pages/creditCards/partials/creditCardInfoCybersource.html\'\"></div><div class=add-card__info ng-if=vm.usingStripe() ng-include=\"\'app/pages/creditCards/partials/creditCardInfoStripe.html\'\"></div><div class=add-card__info ng-if=vm.usingMidsource() ng-include=\"\'app/pages/creditCards/partials/creditCardInfoMidsource.html\'\"></div></form></div></div></div>");
$templateCache.put("app/pages/payouts/payouts.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Payout History</h2><md-button ng-click=payCtrl.showInfo() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button><div class=\"content-section__small-text text-uppercase\">{{ payCtrl.filtered.length }} payouts</div><div class=content-section__right><form class=\"search-widget active-ads-search-widget\"><input ng-model=payCtrl.query.filter class=form-control placeholder=\"Search by URL...\" ng-disabled=\"payCtrl.items.length === 0\"> <button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form><div class=or-span>-- OR --</div><div class=datepicker-period><div class=datepickerdiv><div class=datepicker__field><div class=datepicker__input><input foundation-datepicker initial-date=\"{{ payCtrl.date_from }}\" min-date=\"{{ payCtrl.minDateFrom }}\" max-date=\"{{ payCtrl.maxDateFrom }}\" ng-model=payCtrl.date_from ng-change=payCtrl.setChangesToDates() class=form-control name=from-date type=text id=from-date placeholder value=\"Date from\"></div><div class=datepicker__calendar-icon><svg class=\"icon icon--calendar\"><use xlink:href=assets/images/icons.svg#calendar></use></svg></div><div class=datepicker__chevron-icon><svg class=\"icon icon--chevron-down\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=datepickerdiv><div class=datepicker__field><div class=datepicker__input><input foundation-datepicker ng-model=payCtrl.date_to min-date=\"{{ payCtrl.minDateTo }}\" max-date=\"{{ payCtrl.maxDateTo }}\" ng-change=payCtrl.setChangesToDates() class=form-control name=to-date type=text id=to-date placeholder value=\"Date to\"></div><div class=datepicker__calendar-icon><svg class=\"icon icon--calendar\"><use xlink:href=assets/images/icons.svg#calendar></use></svg></div><div class=datepicker__chevron-icon><svg class=\"icon icon--chevron-down\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div></div></div><div style=\"width: 100%\"><div class=content-section__right style=\"float: right\"><md-button class=\"btn btn-white btn-small btn-auto active-ads-dl-report\" ng-disabled=\"payCtrl.cannotSearch || $root.isLoading\" ng-click=\"payCtrl.downloadReport(payCtrl.date_from, payCtrl.date_to)\">Download Report</md-button></div></div></div><div class=content-section__content><div class=payout-history><ul class=payout-history__statistics><li><span>{{ payCtrl.total_earnings | currency }}</span><small>Total Earnings</small></li><li><span>{{ payCtrl.projected_earnings | currency }}</span><small>Projected Earnings</small></li><li><span>{{ payCtrl.last_month_payouts | currency }}</span><small>Last Month\'s payout</small></li></ul><div ng-include src=\"\'app/pages/payouts/partials/details.html\'\" class=payout-history__content></div></div></div></div>");
$templateCache.put("app/pages/thankyouAdv/thankyouAdv.html","<div class=application><topnavext></topnavext><div class=\"content-section thankyou-container\"><div class=content-section__header><h2 class=content-section__title>WELCOME TO SCALEFLUENCE.COM!</h2></div><div class=content-section__content><div class=thankyou-content><!-- //old thank you page content commented// --><!-- <p>(We hope this will be a life changing experience for you)</p> --><p>Please check your email (look in spam as well) and click the confirmation link to login.</p><p class=\"text-danger font-weight-bold\">SAFELIST THIS ADDRESS PLEASE.</p><a href=mailto:admin@scalefluence.com class=font-weight-bold>admin@scalefluence.com</a><p></p><p>1) IMPORTANT NOTIFICATIONS COME FROM THIS ADDRESS</p><p>2) OUR SUPPORT TEAM CAN BE REACHED THERE AS WELL</p><br><div layout=column layout-align=\"center center\" class=actions><button class=\"btn btn-default\" ng-click=thankyouAdvCtrl.resendEmail()>RESEND ACTIVATION EMAIL</button></div></div></div><!-- Event snippet for Sign-up agencis / advertisers conversion page --><script>gtag(\'event\', \'conversion\', {\'send_to\': \'AW-530161570/S-SzCKPkv-UBEKK_5vwB\'});</script></div></div>");
$templateCache.put("app/pages/search/search.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Search Our Inventory</h2><div class=\"content-section__right content-section__right--sidebar\"><md-select aria-label=filterName class=form-control name=selectedFilter ng-model=srchCtrl.filter md-selected-text=srchCtrl.filter.name ng-change=srchCtrl.sortBy()><md-optgroup label=\"Select a criteria\"><md-option ng-repeat=\"option in srchCtrl.sortOptions\" ng-value=option>{{ option.name }}</md-option></md-optgroup></md-select></div></div><div class=content-section__content><div class=search><div class=search__content><div class=search__content-categories><chips-input placeholder=\"{{ srchCtrl.getPlaceholder() }}\" ng-model=srchCtrl.selectedCategories hide-categories=true hide-toggle=false search=srchCtrl.search() on-change=srchCtrl.categoriesChanged() flex></chips-input><div class=manage-campaigns ng-hide=\"srchCtrl.totalItems == 0\"><div class=manage-campaigns__campaigns-list><div class=campaigns-list><div class=campaigns-list__content><div class=campaigns-list__list><ad-spot url=url campaign-id=srchCtrl.campaignId dir-paginate=\"url in srchCtrl.urls | itemsPerPage: srchCtrl.perPage\" current-page=srchCtrl.currentPage total-items=srchCtrl.totalItems></ad-spot><div class=\"profiles-list__pagination margin-top-5\"><dir-pagination-controls on-page-change=srchCtrl.retrieveUrls(srchCtrl.currentPage) max-size=6></dir-pagination-controls></div></div></div></div></div></div></div><div class=search__content-options><filter-box title=\"Domain authority\" min-text=Min max-text=Max config=srchCtrl.domain_authority></filter-box><filter-box title=\"Trust flow\" min-text=Min max-text=Max config=srchCtrl.trust_flow></filter-box><filter-box title=\"Domain rating\" min-text=Min max-text=Max config=srchCtrl.ahrefs_dr></filter-box><filter-box title=\"Linking root domain\" min-text=Min max-text=Max config=srchCtrl.ahrefs_lrd></filter-box><filter-box title=\"Citation flow\" min-text=Min max-text=Max config=srchCtrl.citation_flow></filter-box><filter-box title=\"Ad price\" min-text=Min max-text=Max config=srchCtrl.price_range prefix=$></filter-box></div></div></div></div></div>");
$templateCache.put("app/pages/thankyouPub/thankyouPub.html","<div class=application><topnavext></topnavext><div class=\"content-section thankyou-container\"><div class=content-section__header><h2 class=content-section__title>WELCOME TO SCALEFLUENCE.COM!</h2></div><div class=content-section__content><div class=thankyou-content><!-- //old thank you page content commented// --><!-- <p>(We hope this will be a life changing experience for you)</p> --><p>Please check your email (look in spam as well) and click the confirmation link to login.</p><p class=\"text-danger font-weight-bold\">SAFELIST THIS ADDRESS PLEASE.</p><a href=mailto:admin@scalefluence.com class=font-weight-bold>admin@scalefluence.com</a><p></p><p>1) IMPORTANT NOTIFICATIONS COME FROM THIS ADDRESS</p><p>2) OUR SUPPORT TEAM CAN BE REACHED THERE AS WELL</p><br><div layout=column layout-align=\"center center\" class=actions><button class=\"btn btn-default\" ng-click=thankyouPubCtrl.resendEmail()>RESEND ACTIVATION EMAIL</button></div></div></div><!-- Event snippet for Influencers Sign Up conversion page --><script>gtag(\'event\', \'conversion\', {\'send_to\': \'AW-530161570/8HtpCLCQ6-sBEKK_5vwB\'});</script></div></div>");
$templateCache.put("app/components/cards/adSpot/adSpot.html","<div class=campaign-row><div class=campaign-row__content><div class=\"campaign-row__cell campaign-row__cell--image\"><div ng-if=vm.hasImage() class=campaign-row__image><img ng-src=\"{{ vm.getImage() }}\" alt></div><div ng-if=!vm.hasImage() class=campaign-row__image><div class=image-placeholder><div class=image-placeholder__icon><svg class=\"icon icon--mask\"><use xlink:href=assets/images/icons.svg#mask></use></svg></div><div class=image-placeholder__label>No image</div></div></div></div><div class=\"campaign-row__cell campaign-row__cell--main\"><div class=display-table><div class=display-table-row><div class=\"as-metrics-cell display-table-cell\">{{ vm.url.domain_authority }}</div><div class=\"as-metrics-cell display-table-cell\">{{ vm.url.trust_flow }}</div><div class=display-table-cell>&nbsp;{{ vm.url.citation_flow }}</div><div class=display-table-cell>&nbsp;{{ vm.url.ahrefs_dr }}</div></div><div class=display-table-row><div class=\"as-metrics-cell display-table-cell\"><h6>DA</h6></div><div class=\"as-metrics-cell display-table-cell\"><h6>TF</h6></div><div class=\"as-metrics-cell display-table-cell\"><h6>CF</h6></div><div class=\"as-metrics-cell display-table-cell\"><h6>DR</h6></div></div></div></div><div class=\"campaign-row__cell campaign-row__cell--types\"><div class=campaign-row__label><p data-ng-bind=vm.url.description data-ellipsis class=url-desc></p></div></div><div class=\"campaign-row__cell campaign-row__cell--buttons\">{{ vm.url.shown_price | currency:undefined:0 }}/post<md-button class=\"btn btn-white\" ng-click=vm.checkIfOrdered() ng-disabled=\"vm.added() || $root.isLoading\">Add to cart</md-button></div></div></div>");
$templateCache.put("app/components/cards/campaignDetails/campaignDetails.html","<md-card><div layout=column layout-gt-xs=row layout-align-gt-xs=\"center center\" flex-order=1><md-card-content flex=40 layout=row layout-align=\"center center\" layout-align-gt-xs=\"center center\" class=\"content-title campaign-title\"><h1>{{ vm.campaign.name }}<md-tooltip md-direction=bottom>{{ vm.campaign.name }}</md-tooltip></h1></md-card-content><md-divider class=vertical-divider></md-divider><md-card-content flex=45 layout=row layout-align=\"space-around center\"><div class=values layout=column flex=40 layout-align=\"center center\"><span class=value>{{ vm.campaign.total_urls }}</span> <span>Total Urls</span></div><div class=values layout=column layout-align=\"center center\"><span class=value>{{ vm.campaign.total_links }}</span> <span>Total Links</span></div></md-card-content><div layout=column hide-sm hide-xs layout-align=\"start end\"><md-button class=\"md-icon-button md-accent\" aria-label=description ng-click=vm.onDelete()><md-icon class=menu-icon>delete</md-icon></md-button><span flex></span><div layout=row><md-button class=md-accent ui-sref=\"manage-campaign({ campaignId: vm.campaign.id })\">Edit urls</md-button><md-button class=md-accent aria-label=description ui-sref=\"search({ categories: vm.categoriesNames(), campaignId: vm.campaign.id })\">Search publishers</md-button></div></div></div><md-divider flex-order=2></md-divider><!-- Actions in res < sm --><md-divider hide-gt-sm flex-order=5 ng-if=vm.showCategories></md-divider><div class=md-actions hide-gt-sm layout=row layout-align=\"end center\" flex-order=5><md-button class=md-accent ui-sref=\"manage-campaign({ campaignId: vm.campaign.id })\">Edit urls</md-button><md-button class=md-accent aria-label=description ui-sref=\"search({ categories: vm.categoriesNames() })\">Search publishers</md-button><md-button class=\"md-icon-button md-accent\" aria-label=description ng-click=vm.onDelete()><md-icon class=menu-icon>delete</md-icon></md-button></div><md-divider flex-order=4></md-divider><!-- Categories --><div layout=column layout-align=\"start start\" layout-padding flex-order=3 class=categories-content><div layout=row class=category-container><md-subheader class=md-no-sticky><h4>Categories</h4></md-subheader><md-button class=md-accent ng-click=\"vm.showCategories = ! vm.showCategories\"><span>Edit categories</span></md-button></div><md-chips class=\"rounded small-chips\" ng-model=vm.campaign.categories ng-attr-readonly=true><md-chip-template>{{ $chip.name }}</md-chip-template></md-chips></div><md-divider hide-sm hide-xs flex-order=6 ng-if=vm.showCategories></md-divider><div hide-sm hide-xs class=save-cats-container ng-if=vm.showCategories flex-order=5 layout=row layout-align=\"end center\"><md-button class=md-accent aria-label=description flex=18 ng-click=vm.submitCategories(vm.campaign)>Save Categories</md-button></div><div hide-sm hide-xs ng-if=vm.showCategories layout=column class=\"chip-select-component color-background chips-custom-input\" flex-order=5><div class=\"hidden-card chips-container\"><category-selector placeholder=\"Search for...\" ng-model=vm.selectedCategories hide-input=true></category-selector></div></div><!-- Category selector in res < sm --><div hide-gt-sm class=save-cats-container ng-if=vm.showCategories flex-order=4 layout=row layout-align=\"end center\"><md-button class=md-accent aria-label=description flex=18>Save Categories</md-button></div><div hide-gt-sm ng-if=vm.showCategories layout=column class=\"chip-select-component color-background chips-custom-input\" flex-order=4><div class=\"hidden-card chips-container\"><category-selector placeholder=\"Search for...\" ng-model=vm.selectedCategories hide-input=true></category-selector></div></div></md-card>");
$templateCache.put("app/components/cards/campaignMiniManagers/campaignMiniManagers.html","<div class=campaign-row><div class=campaign-row__content><div class=\"campaign-row__cell campaign-row__cell--image\"><div ng-if=vm.hasImage() class=campaign-row__image><img ng-src=\"{{ vm.getImage() }}\" ng-click=vm.editCampaign(vm.campaign.id) ng-disabled=vm.isCampaignRejected() alt></div><div ng-if=!vm.hasImage() class=campaign-row__image><div class=image-placeholder><div class=image-placeholder__icon><svg class=\"icon icon--mask\"><use xlink:href=assets/images/icons.svg#mask></use></svg></div><div class=image-placeholder__label>No image</div></div></div></div><div class=\"campaign-row__cell campaign-row__cell--main\"><h4 class=campaign-row__name>{{ vm.campaign.name }}</h4></div><div class=\"campaign-row__cell campaign-row__cell--types\"><div class=campaign-row__label>Product Type</div><div class=campaign-row__badges><span ng-repeat=\"product in vm.campaign.products\" ng-class=vm.getProductBadgeClass(product.name)>{{ product.name }}</span></div></div><div class=\"campaign-row__cell campaign-row__cell--buttons\"><select style=\"margin-left: auto; width: 300px\" class=form-control name=manager ng-if=\"vm.teammates.length > 1\" ng-model=vm.manager ng-options=\"adv.email for adv in vm.teammates track by adv.id\" ng-change=vm.setTeammateManageCampaign()></select></div></div></div>");
$templateCache.put("app/components/cards/campaignMini/campaignMini.html","<div class=campaign-row><div class=campaign-row__content><div class=\"campaign-row__cell campaign-row__cell--image\"><div ng-if=vm.hasImage() class=campaign-row__image><img ng-src=\"{{ vm.getImage() }}\" ng-click=vm.editCampaign(vm.campaign.id) ng-disabled=vm.isCampaignRejected() alt></div><div ng-if=!vm.hasImage() class=campaign-row__image><div class=image-placeholder><div class=image-placeholder__icon><svg class=\"icon icon--mask\"><use xlink:href=assets/images/icons.svg#mask></use></svg></div><div class=image-placeholder__label>No image</div></div></div></div><div class=\"campaign-row__cell campaign-row__cell--main\"><h4 class=campaign-row__name>{{ vm.campaign.name }}</h4></div><div class=\"campaign-row__cell campaign-row__cell--types\"><div class=campaign-row__label>Product Type</div><div class=campaign-row__badges><span ng-repeat=\"product in vm.campaign.products\" ng-class=vm.getProductBadgeClass(product.name)>{{ product.name }}</span></div></div><div class=\"campaign-row__cell campaign-row__cell--buttons\"><div ng-if=vm.isCampaignRejected() class=campaign-row__label style=text-align:left>REJECTED</div><a class=\"btn btn-white\" ng-click=vm.destroy() href=javascript:void(0)>Delete</a> <a ng-if=!vm.isCampaignRejected() class=\"btn btn-white\" ng-click=vm.editCampaign(vm.campaign.id) href=javascript:void(0)>Manage</a> <a class=\"btn btn-white\" href=\"/#/quote/new?campaign_id={{ vm.campaign.id }}\">New Quote</a></div></div></div>");
$templateCache.put("app/components/cards/cartItem/cartItem.html","<md-card class=cart-item ng-class=\"{ \'cart-item-not-ready\': !vm.readyForCheckout(), \'cart-item-publisher-not-active\': vm.order.publisher_not_active }\" ng-style=vm.publisherNotActiveStyle()><md-card-content layout-gt-sm=row layout=column layout-padding flex class=card-no-padding ng-style=vm.publisherNotActiveStyle()><md-tooltip ng-if=vm.order.publisher_not_active md-direction=top md-delay=300>{{ vm.publisherNotActiveTooltip }}</md-tooltip><div layout=row layout-align=\"{{!vm.order.has_teammates ? \'start center\' : \'flex-start\'}}\" flex><span class=cart-check-wrapper><md-checkbox ng-checked=vm.exists() ng-click=vm.toggle() ng-disabled=vm.order.publisher_not_active aria-label=check class=cart-check></md-checkbox></span><span class=url flex hide-gt-sm>{{ vm.getOrderUrl() }}</span></div><!-- Card body --><!-- used to use for only admin advs with teammates --><div layout=row layout-align=flex-start flex=95 ng-if=true ng-include src=\"\'app/components/cards/cartItem/partials/cartItemV2.html\'\"></div><!-- used to use for teammates and for advs with no teammates --><div layout=row layout-align=\"start center\" flex=95 ng-if=false ng-include src=\"\'app/components/cards/cartItem/partials/cartItem.html\'\"></div></md-card-content><md-divider style=\"border-top-style: none\"></md-divider><!-- used to use for teammates and for advs with no teammates --><div class=md-actions layout=row layout-align=space-between ng-if=false><div layout=row layout-align=\"start center\" class=blog-titlez><h3 class=bold-title>Blog Title:</h3><span class=title layout=row layout-align=\"center center\">{{ vm.order.ad.blog_post_title }}</span></div><div layout=row layout-align=\"end center\"><p class=error-message ng-show=vm.order.showMessageError>Please upload content for this publisher before checking out</p><md-button class=\"btn btn-white btn-small\" ng-click=vm.blogPostDialog($event) flex-order-xs=2>{{ vm.getBlogPostStatus() }}</md-button></div></div></md-card>");
$templateCache.put("app/components/cards/creditCardHolder/creditCardHolder.html","<div class=account__card><div class=account__card-header ng-repeat=\"card in vm.cards\"><div class=account__card-data><img ng-src=\"{{ card.image_url }}\" alt><span>{{ card.masked_number | maskedCardNumber }}</span></div><div class=account__card-actions><button ng-if=vm.editable(card) class=btn type=button ng-click=vm.editCC(card.id)><svg class=\"icon icon--edit\"><use xlink:href=assets/images/icons.svg#edit></use></svg></button> <button class=btn type=button ng-click=vm.removeCC(card.id)><svg class=\"icon icon--trash\"><use xlink:href=assets/images/icons.svg#trash></use></svg></button></div></div><div class=account__card-new><a class=\"btn btn-white btn-small\" href=javascript:void(0) ng-click=vm.addNewCC()>Add new credit card</a></div></div>");
$templateCache.put("app/components/cards/filterBox/filterBox.html","<div class=search__options-slider><div class=range-slider-simple><h6 class=range-slider-simple__title>{{ vm. title }}</h6><div class=range-slider-simple__scale><rzslider rz-slider-model=vm.config.min rz-slider-high=vm.config.max rz-slider-options=vm.config.options></rzslider><ul class=range-slider-simple__scale__labels><li>{{ vm.minText }} {{ vm.prefix }} {{ vm.config.min }}</li><li>{{ vm.maxText }} {{ vm.prefix }} {{ vm.config.max }} {{ vm.suffix }}</li></ul></div></div></div>");
$templateCache.put("app/components/cards/metric/metric.html","<div class=common-statistic-cell><div class=common-statistic-cell__icon><svg ng-class=vm.iconCss()><use ng-attr-xlink:href=\"{{ vm.xlinkHref() }}\" xlink:href=\"\"></use></svg></div><div class=common-statistic-cell__wrapper><div class=common-statistic-cell__counter><ng-transclude></ng-transclude></div><div class=common-statistic-cell__name>{{ vm.title }}</div></div><div ng-if=\"vm.badge > 0\" class=common-statistic-cell__badge>{{ vm.badge }}</div></div>");
$templateCache.put("app/components/payments/partials/billing.html","<div class=\"add-card__main-data ng-scope payments-billing\"><div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section><div class=add-card__section-title>Address</div><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.name>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div></div>");
$templateCache.put("app/components/payments/partials/billingCybersource.html","<div class=\"add-card__main-data ng-scope payments-billing\"><div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section style=\"margin-top: 20px\"><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.code>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div></div>");
$templateCache.put("app/components/payments/partials/billingMidsource.html","<div class=\"add-card__main-data ng-scope payments-billing\"><div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section style=\"margin-top: 20px\"><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.code>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div></div>");
$templateCache.put("app/components/payments/partials/billingStripe.html","<div class=\"add-card__main-data ng-scope payments-billing\"><div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section style=\"margin-top: 20px\"><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.code>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div></div>");
$templateCache.put("app/components/payments/partials/cards.html","<div class=md-dialog-container id=myDialog><md-dialog class=credit-card-dialog><md-toolbar md-whiteframe=3><div class=md-toolbar-tools><h2>Select a credit card to pay</h2></div></md-toolbar><md-dialog-content><div layout-margin><div ng-repeat=\"card in vm.cards\"><md-radio-group ng-model=vm.selectedCardId><md-radio-button class=selectable-card aria-label=\"use store card\" value=\"{{ card.id }}\" ng-disabled=$root.isLoading><md-card-content layout=row layout-align=\"start center\" flex><img class=card-logo ng-src=\"{{ card.image_url }}\" alt=\"credit card logo\" height=38 width=56> <span>{{ card.masked_number | maskedCardNumber }}</span></md-card-content></md-radio-button></md-radio-group><md-divider ng-if=!$last></md-divider></div></div><md-divider></md-divider></md-dialog-content><div class=md-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" ng-click=vm.closeDialog()>Cancel</md-button><md-button class=\"btn btn-white btn-small\" ng-click=vm.setSelectedCard() ng-disabled=!vm.selectedCardId>Select</md-button></div></md-dialog></div>");
$templateCache.put("app/components/payments/partials/creditCard.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"start start\" flex><div class=\"add-card__section-title add-card__section-title--double-margin\" flex=50>Card Information</div><div ng-if=vm.hasStoredCards() layout=row layout-align=end flex=50><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading tabindex=-1 md-no-ink ng-click=vm.creditCardsDialog()>Use card on file?</md-button></div></div><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><input id=card-number ng-model=vm.ccNumber name=ccNumber class=form-control ng-required=true ng-credit-card-type=vm.ccType ng-focus=vm.toggleCreditCardMask() ng-blur=vm.toggleCreditCardMask() ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" ui-mask=\"{{ vm.ccNumberMask }}\" ui-mask-placeholder-char=\"\" type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.ccNumber.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid credit card.</div><div ng-message=invalid>This credit card number is invalid.</div></div></div><img class=credit-card-logo ng-if=vm.ccType ng-src=\"{{ vm.ccType.logo }}\" alt=\"credit card logo\" height=38 width=56></div><div layout=row layout-align=\"start start\" flex><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Exp Month</label><md-select class=form-control style=\"margin: 0px\" name=expDateMonth ng-model=vm.expDate.month ng-required=true ng-disabled=$root.isLoading ng-change=vm.checkExpirationDate()><md-option id=exp-date-month ng-value=opt ng-repeat=\"opt in vm.months\">{{ opt }}</md-option></md-select><div class=errors ng-messages=paymentForm.expDateMonth.$error><div ng-message=required>This is required.</div><div ng-message=past>The card is expired.</div></div></div></div><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Year</label><md-select class=form-control style=\"margin: 0px\" name=expDateYear ng-model=vm.expDate.year ng-required=true ng-disabled=$root.isLoading ng-change=vm.checkExpirationDate()><md-option id=exp-date-year ng-value=opt ng-repeat=\"opt in vm.years\">{{ opt }}</md-option></md-select><div class=errors ng-messages=paymentForm.expDateYear.$error><div ng-message=required>This is required.</div></div></div></div><div class=\"md-block positioned-top\" flex><div class=form-group style=\"width: 100%\"><label>CVV</label><input class=form-control style=\"margin: 0px\" id=cvv name=cvv class=hosted-field ng-required=true ng-model=vm.cvvNumber ng-focus=vm.toggleCvvMask() ng-blur=vm.toggleCvvMask() ui-mask=\"{{ vm.cvvMask }}\" ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" ui-mask-placeholder-char=\"\" type=text ng-disabled=$root.isLoading><div ng-messages=paymentForm.cvv.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid cvv</div></div></div></div><md-button class=\"md-icon-button information\" ng-click=vm.showInfo() md-no-ink=true ng-disabled=$root.isLoading aria-label=info><md-icon>info</md-icon></md-button></div><div flex></div><div layout=row layout-align=\"start center\"><md-checkbox ng-model=vm.remember name=\"remember card\" aria-label=remember ng-disabled=$root.isLoading><span>Store card for future purchases?</span></md-checkbox></div></md-card-content></md-card><div layout-gt-sm=row layout=column flex><md-card class=checkout-table-container flex ng-if=vm.selectedCard layout=row layout-align=\"space-between start\"><div layout=column><md-card-header class=no-top-bottom-padding><h2>Billing address</h2></md-card-header><md-card-content class=billing-data layout=column><span>{{ vm.selectedCard.cardholder_name }}</span> <span>{{ vm.selectedCard.street_address }} {{ vm.selectedCard.extended_address }}</span> <span>{{ vm.selectedCard.city }}, {{ vm.selectedCard.state | uppercase }} {{ vm.selectedCard.zip_code }}</span> <span>{{ vm.selectedCard.country_name }}</span></md-card-content></div><div layout=column><md-card-header class=no-top-bottom-padding><h2>Selected credit card</h2></md-card-header><md-card-content layout=row layout-align=\"start center\" flex><img class=card-logo ng-src=\"{{ vm.selectedCard.image_url }}\" alt=\"credit card logo\" height=38 width=56><div class=masked-number>{{ vm.selectedCard.masked_number | maskedCardNumber }}<br><span ng-class=\"{ expCard: vm.storedCcExpired() }\">Exp: {{ vm.selectedCard.month }}/{{ vm.selectedCard.year }}</span></div><span flex></span><md-button class=md-icon-button aria-label=Remove ng-click=vm.deselCard()><md-tooltip>Change the credit card</md-tooltip><md-icon>close</md-icon></md-button></md-card-content></div></md-card><md-card class=checkout-table-container flex><md-card-content flex layout=row layout-align=\"space-between center\"><h1 style=\"font-size: 16px\">Total charge today</h1><h1 class=price style=\"font-size: 16px\">{{ vm.amount | currency }}</h1></md-card-content></md-card></div>");
$templateCache.put("app/components/payments/partials/creditCardCybersource.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"start start\" flex><div class=\"add-card__section-title add-card__section-title--double-margin\" flex=50>Card Information</div><div ng-if=vm.hasStoredCards() layout=row layout-align=end flex=50><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading tabindex=-1 md-no-ink ng-click=vm.creditCardsDialog()>Use card on file?</md-button></div></div><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><div id=number-container class=form-control></div></div></div><div layout=row layout-align=\"start start\" flex><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Exp Month</label><select id=expMonth class=form-control style=\"margin: 0px\" ng-disabled=$root.isLoading><option ng-value=opt ng-repeat=\"opt in vm.months\">{{ opt }}</option></select></div></div><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Year</label><select id=expYear class=form-control style=\"margin: 0px\" ng-disabled=$root.isLoading><option ng-value=opt ng-repeat=\"opt in vm.years\">{{ opt }}</option></select></div></div><div class=\"md-block positioned-top\" flex><div class=form-group style=\"width: 100%\"><label>CVV</label><div id=securityCode-container ng-bind=securityCode class=form-control></div></div></div><md-button class=\"md-icon-button information\" ng-click=vm.showInfo() md-no-ink=true ng-disabled=$root.isLoading aria-label=info><md-icon>info</md-icon></md-button></div><div flex></div><div layout=row layout-align=\"start center\"><md-checkbox ng-model=vm.remember name=\"remember card\" aria-label=remember ng-disabled=$root.isLoading><span>Store card for future purchases?</span></md-checkbox></div></md-card-content></md-card><div layout-gt-sm=row layout=column flex><md-card class=checkout-table-container flex ng-if=vm.selectedCard layout=row layout-align=\"space-between start\"><div layout=column><md-card-header class=no-top-bottom-padding><h2>Billing address</h2></md-card-header><md-card-content class=billing-data layout=column><span>{{ vm.selectedCard.cardholder_name }}</span> <span>{{ vm.selectedCard.street_address }} {{ vm.selectedCard.extended_address }}</span> <span>{{ vm.selectedCard.city }}, {{ vm.selectedCard.state | uppercase }} {{ vm.selectedCard.zip_code }}</span> <span>{{ vm.selectedCard.country_name }}</span></md-card-content></div><div layout=column><md-card-header class=no-top-bottom-padding><h2>Selected credit card</h2></md-card-header><md-card-content layout=row layout-align=\"start center\" flex><img class=card-logo ng-src=\"{{ vm.selectedCard.image_url }}\" alt=\"credit card logo\" height=38 width=56><div class=masked-number>{{ vm.selectedCard.masked_number | maskedCardNumber }}<br><span ng-class=\"{ expCard: vm.storedCcExpired() }\">Exp: {{ vm.selectedCard.month }}/{{ vm.selectedCard.year }}</span></div><span flex></span><md-button class=md-icon-button aria-label=Remove ng-click=vm.deselCard()><md-tooltip>Change the credit card</md-tooltip><md-icon>close</md-icon></md-button></md-card-content></div></md-card><md-card class=checkout-table-container flex><md-card-content flex layout=row layout-align=\"space-between center\"><h1 style=\"font-size: 16px\">Total charge today</h1><h1 class=price style=\"font-size: 16px\">{{ vm.amount | currency }}</h1></md-card-content></md-card></div>");
$templateCache.put("app/components/payments/partials/creditCardMidsource.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content class=add-card__info-content><div layout=row layout-align=\"start start\" flex><div class=\"add-card__section-title add-card__section-title--double-margin\" flex=50>Card Information</div><div ng-if=vm.hasStoredCards() layout=row layout-align=end flex=50><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading tabindex=-1 md-no-ink ng-click=vm.creditCardsDialog()>Use card on file?</md-button></div></div><div layout=row layout-align=\"center start\" class=midsource-card-fields><div class=form-group style=\"width: 100%\" ng-class=\"{\'midsource-field-invalid\': vm.midsourceFieldValid.ccnumber === false}\"><label class=md-lbl-mask>Card number</label><div id=midsource-ccnumber class=midsource-field-host><!-- Collect.js mounts the card number field here --></div><div class=errors ng-if=vm.midsourceFieldErrors.ccnumber role=alert><div ng-bind=vm.midsourceFieldErrors.ccnumber></div></div></div></div><div class=\"midsource-card-fields midsource-exp-cvv-row\" role=group aria-label=\"Expiration and CVV\"><div class=midsource-exp-cvv-inner layout=row layout-align=\"start start\"><div class=\"form-group midsource-exp-cvv-field\" ng-class=\"{\'midsource-field-invalid\': vm.midsourceFieldValid.ccexp === false}\" flex><label class=md-lbl-mask>Expiration</label><div id=midsource-ccexp class=midsource-field-host><!-- Collect.js mounts the expiration field here --></div><div class=\"errors midsource-row-error\" ng-if=vm.midsourceFieldErrors.ccexp role=alert><div ng-bind=vm.midsourceFieldErrors.ccexp></div></div></div><div class=midsource-exp-cvv-spacer style=\"width: 10px; min-width: 10px; flex: 0 0 10px\" aria-hidden=true></div><div class=\"form-group midsource-exp-cvv-field\" ng-class=\"{\'midsource-field-invalid\': vm.midsourceFieldValid.cvv === false}\" flex><label class=md-lbl-mask>CVV</label><div id=midsource-cvv class=midsource-field-host><!-- Collect.js mounts the CVV field here --></div><div class=\"errors midsource-row-error\" ng-if=vm.midsourceFieldErrors.cvv role=alert><div ng-bind=vm.midsourceFieldErrors.cvv></div></div></div></div></div><div layout=row layout-align=\"start center\"><md-checkbox ng-model=vm.remember name=\"remember card\" aria-label=remember ng-disabled=$root.isLoading><span>Store card for future purchases?</span></md-checkbox></div></md-card-content></md-card><div layout-gt-sm=row layout=column flex><md-card class=checkout-table-container flex ng-if=vm.selectedCard layout=row layout-align=\"space-between start\"><div layout=column><md-card-header class=no-top-bottom-padding><h2>Billing address</h2></md-card-header><md-card-content class=billing-data layout=column><span>{{ vm.selectedCard.cardholder_name }}</span> <span>{{ vm.selectedCard.street_address }} {{ vm.selectedCard.extended_address }}</span> <span>{{ vm.selectedCard.city }}, {{ vm.selectedCard.state | uppercase }} {{ vm.selectedCard.zip_code }}</span> <span>{{ vm.selectedCard.country_name }}</span></md-card-content></div><div layout=column><md-card-header class=no-top-bottom-padding><h2>Selected credit card</h2></md-card-header><md-card-content layout=row layout-align=\"start center\" flex><img class=card-logo ng-src=\"{{ vm.selectedCard.image_url }}\" alt=\"credit card logo\" height=38 width=56><div class=masked-number>{{ vm.selectedCard.masked_number | maskedCardNumber }}<br><span ng-class=\"{ expCard: vm.storedCcExpired() }\">Exp: {{ vm.selectedCard.month }}/{{ vm.selectedCard.year }}</span></div><span flex></span><md-button class=md-icon-button aria-label=Remove ng-click=vm.deselCard()><md-tooltip>Change the credit card</md-tooltip><md-icon>close</md-icon></md-button></md-card-content></div></md-card><md-card class=checkout-table-container flex><md-card-content flex layout=row layout-align=\"space-between center\"><h1 style=\"font-size: 16px\">Total charge today</h1><h1 class=price style=\"font-size: 16px\">{{ vm.amount | currency }}</h1></md-card-content></md-card></div>");
$templateCache.put("app/components/payments/partials/creditCardStripe.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"start start\" flex><div class=\"add-card__section-title add-card__section-title--double-margin\" flex=50>Card Information</div><div ng-if=vm.hasStoredCards() layout=row layout-align=end flex=50><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading tabindex=-1 md-no-ink ng-click=vm.creditCardsDialog()>Use card on file?</md-button></div></div><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><div id=stripe-card-element class=form-control style=\"padding: 10px\"><!-- Stripe Elements will mount here --></div><div id=stripe-card-errors role=alert style=\"color: #a94442; margin-top: 5px\"></div></div></div><div flex></div><div layout=row layout-align=\"start center\"><md-checkbox ng-model=vm.remember name=\"remember card\" aria-label=remember ng-disabled=$root.isLoading><span>Store card for future purchases?</span></md-checkbox></div></md-card-content></md-card><div layout-gt-sm=row layout=column flex><md-card class=checkout-table-container flex ng-if=vm.selectedCard layout=row layout-align=\"space-between start\"><div layout=column><md-card-header class=no-top-bottom-padding><h2>Billing address</h2></md-card-header><md-card-content class=billing-data layout=column><span>{{ vm.selectedCard.cardholder_name }}</span> <span>{{ vm.selectedCard.street_address }} {{ vm.selectedCard.extended_address }}</span> <span>{{ vm.selectedCard.city }}, {{ vm.selectedCard.state | uppercase }} {{ vm.selectedCard.zip_code }}</span> <span>{{ vm.selectedCard.country_name }}</span></md-card-content></div><div layout=column><md-card-header class=no-top-bottom-padding><h2>Selected credit card</h2></md-card-header><md-card-content layout=row layout-align=\"start center\" flex><img class=card-logo ng-src=\"{{ vm.selectedCard.image_url }}\" alt=\"credit card logo\" height=38 width=56><div class=masked-number>{{ vm.selectedCard.masked_number | maskedCardNumber }}<br><span ng-class=\"{ expCard: vm.storedCcExpired() }\">Exp: {{ vm.selectedCard.month }}/{{ vm.selectedCard.year }}</span></div><span flex></span><md-button class=md-icon-button aria-label=Remove ng-click=vm.deselCard()><md-tooltip>Change the credit card</md-tooltip><md-icon>close</md-icon></md-button></md-card-content></div></md-card><md-card class=checkout-table-container flex><md-card-content flex layout=row layout-align=\"space-between center\"><h1 style=\"font-size: 16px\">Total charge today</h1><h1 class=price style=\"font-size: 16px\">{{ vm.amount | currency }}</h1></md-card-content></md-card></div>");
$templateCache.put("app/components/payments/partials/preview.html","<md-card ng-hide=!vm.orders.length class=\"payment checkout-table-container\"><md-table-container><table class=table md-table ng-model=vm.orders md-progress=promise><thead md-head md-order=vm.query.order><tr md-row><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Publisher</span></a></th><th md-column md-order-by=url.domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th md-column md-order-by=ad.campaign.name><a class=\"btn btn-link\" href=javascript:void(0)><span>Campaign</span></a></th><th md-column md-order-by=ad.blog_post_title><a class=\"btn btn-link\" href=javascript:void(0)><span>Title</span></a></th><th md-column md-order-by=ad.link.href><a class=\"btn btn-link\" href=javascript:void(0)><span>Destination URL</span></a></th><th md-column md-order-by=ad.link_text><a class=\"btn btn-link\" href=javascript:void(0)><span>Anchor Text</span></a></th><th md-column md-numeric md-order-by=url.shown_price><a class=\"btn btn-link\" href=javascript:void(0)><span>Price</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Remove</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"order in vm.filtered = (vm.orders | filter: vm.query.filter) | orderBy: vm.query.order\n        | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell ng-if=vm.createdFromQuote(order)>{{ order.url.href }}</td><td md-cell ng-if=vm.createdFromSearch(order)><md-button class=md-icon-button aria-label=hidden><md-tooltip>Get Quote to See Domains</md-tooltip><md-icon>visibility_off</md-icon></md-button></td><td md-cell>{{ order.url.domain_authority }}</td><td md-cell data-ellipsis data-ng-bind=\"order.campaign.name | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.campaign.name }}</md-tooltip></td><td md-cell md-cell data-ellipsis data-ng-bind=\"order.ad.blog_post_title | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.ad.blog_post_title }}</md-tooltip></td><td md-cell data-ellipsis data-ellipsis-append=... data-ng-bind=\"order.link.href | limitTo: 30\"><md-tooltip md-direction=bottom>{{ order.link.href }}</md-tooltip></td><td md-cell>{{ order.ad.link_text }}</td><td md-cell>{{ order.amount | currency:undefined:0 }}</td><td md-cell><md-menu class=send-back><md-button aria-label=\"Remove order\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" ng-disabled=$root.isLoading><md-icon class=menu-icon>delete</md-icon><md-icon class=menu-icon>arrow_drop_down</md-icon></md-button><md-menu-content width=2><md-menu-item><md-button ng-click=vm.orderSendBack(order)>Send Back to Cart</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination class=arrows-enabled md-limit=vm.query.limit md-page=vm.query.page md-total=\"{{ vm.filtered.length }}\" md-page-select=true></md-table-pagination></md-card>");
$templateCache.put("app/components/sidenav/containerMenuItem/containerMenuItem.html","<md-button class=menu-item aria-label=\"Menu item\" ng-click=vm.clickMenu() ng-class=\"{ selected: vm.isActive() }\"><md-icon class=menu-icon>{{ vm.icon }}</md-icon><strong>{{ vm.value }}</strong> {{ vm.text }}</md-button><ng-transclude></ng-transclude>");
$templateCache.put("app/components/cards/profileMini/profileMini.html","<md-card><div class=profile-row__content><div ng-if=!vm.hasImage() class=\"profile-row__cell profile-row__cell--image\"><div class=profile-row__image><div class=image-placeholder><div class=image-placeholder__icon><svg class=\"icon icon--mask\"><use xlink:href=assets/images/icons.svg#mask></use></svg></div><div class=image-placeholder__label>No image</div></div></div></div><div ng-if=vm.hasImage() class=\"profile-row__cell profile-row__cell--image\"><div class=profile-row__image><img ng-src=\"{{ vm.getImage() }}\" ng-click=vm.editProfile() alt></div></div><div class=\"profile-row__cell profile-row__cell--main\"><h4 class=profile-row__name>{{ vm.profile.name }}</h4><md-chips class=\"chips-container rounded small-chips\" ng-model=vm.profileType ng-attr-readonly=true><md-chip-template>{{ $chip.name }}</md-chip-template></md-chips><!-- <div class=\"profile-row__badges\"><span class=\"badge badge-primary text-uppercase\">*Blogger</span></div> --></div><div class=\"profile-row__cell profile-row__cell--user-statistics\"><div class=profile-row__user-statistics><div class=user-statistics><div class=user-statistics__row><div class=user-statistics__cell>{{ vm.profile.total_sites }}</div><div class=user-statistics__cell>Total Sites</div></div><div class=user-statistics__row><div class=user-statistics__cell>{{ vm.profile.total_orders }}</div><div class=user-statistics__cell>Total Orders</div></div><div class=user-statistics__row><div class=user-statistics__cell>{{ vm.profile.total_earned | currency:undefined:0 }}</div><div class=user-statistics__cell>Total Earned</div></div></div></div></div><div class=\"profile-row__cell profile-row__cell--buttons\"><a class=\"btn btn-white btn-small\" href=\"\" ng-click=vm.editProfile()>EDIT PROFILE</a></div></div></md-card>");
$templateCache.put("app/components/sidenav/menuItem/menuItem.html","<md-button class=menu-item aria-label=\"Menu item\" ng-click=vm.clickMenu() ui-sref=\"{{ vm.state }}\" ui-sref-active=selected><md-icon class=menu-icon>{{ vm.icon }}</md-icon><strong>{{ vm.value }}</strong> {{ vm.text }} <strong class=right-value ng-if=\"vm.valueRight && vm.valueRight > 0\">({{ vm.valueRight }})</strong></md-button>");
$templateCache.put("app/components/sidenav/partials/partial_adv.html","<menu-item value=\"{{ $root.cartItems.length }}\" text=\"Item in Cart\" icon=shopping_cart state=cart></menu-item><menu-item text=Dashboard icon=home state=adv-dash></menu-item><menu-item text=Search icon=search state=search></menu-item><menu-item text=\"Create New Campaign\" icon=add_box state=new-campaign></menu-item><menu-item text=\"Manage Campaigns\" icon=list state=all-campaigns></menu-item><menu-item value-right=\"{{ $root.counterQuotes }}\" text=Quotes icon=format_quote state=quotes-main></menu-item><menu-item value-right=\"{{ $root.counterArticles }}\" text=\"Content Pipe\" icon=subject state=done-articles></menu-item><menu-item text=\"Read our FAQ\" state=faq-adv></menu-item><menu-item value-right=\"{{ $root.counterMessages }}\" text=\"Contact / Help\" state=contact-us></menu-item>");
$templateCache.put("app/components/sidenav/partials/partial_pub.html","<menu-item text=Dashboard icon=home state=pub-dash></menu-item><menu-item text=\"Create New Profile\" icon=add_box state=new-profile></menu-item><menu-item text=\"Manage Profiles\" icon=list state=all-profiles></menu-item><menu-item text=\"Payout History\" icon=history state=payouts></menu-item><menu-item text=\"Read our FAQ\" state=faq-pub></menu-item><menu-item value-right=\"{{ $root.counterMessages }}\" text=\"Contact / Help\" state=contact-us></menu-item>");
$templateCache.put("app/components/topnav/partials/partial_adv.html","<a class=header__logo ui-sref=adv-dash><img src=assets/images/logo.svg alt></a><ul class=header__main-menu><li><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=adv-dash>Dashboard</a></li><li><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=all-campaigns>Manage Campaigns</a></li><li class=main-menu__item><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=quotes-main>Quotes</a><div class=item__badge>{{ $root.counterAssignedQuotes || 0}}</div></li><li class=main-menu__item><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=done-articles>Content Pipe</a><div class=item__badge>{{ $root.counterApprovedArticles || 0}}</div></li><li class=main-menu__item><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=cart>Cart</a><div class=item__badge>{{ $root.counterPendingOrders || 0}}</div></li><li class=main-menu__item ng-hide=\"$root.counterCheckoutItems == 0\"><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=checkout>Checkout</a><div class=item__badge>{{ $root.counterCheckoutItems || 0}}</div></li></ul><ul class=header__service-menu><li><a ng-click=\"vm.setMobileMenuInactive(); vm.setUserMenuInactive()\" ui-sref=search><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></a></li><li><a ng-click=\"vm.setMobileMenuInactive(); vm.setUserMenuInactive()\" ui-sref=new-campaign><svg class=\"icon icon--plus-circle\"><use xlink:href=assets/images/icons.svg#plus-circle></use></svg></a></li></ul><div class=header__user-menu><div class=user-menu><button ng-click=\"vm.setMobileMenuInactive(); vm.toggleUserMenu()\" class=user-menu__button ng-mouseleave=vm.fadeUserMenu() type=button><svg class=\"icon icon--gear\"><use xlink:href=assets/images/icons.svg#gear></use></svg></button><ul style=\"display: none\" ng-mouseleave=vm.fadeUserMenu() ng-mouseenter=vm.setUserMenuInUse() class=user-menu__dropdown><li><a ui-sref=show-profile ng-click=vm.setUserMenuInactive()><span>My Account</span></a></li><li><a ui-sref=adv-teammates ng-if=!vm.isTeammate ng-click=vm.setUserMenuInactive()><span>My Teammates</span></a></li><li><a href=\"\" ng-click=\"vm.setUserMenuInactive(); vm.changeAccount(ev)\" ng-if=!vm.isTeammate><span>{{ vm.accountMessage() }}</span></a></li><li><a ui-sref=contact-us ng-click=vm.setUserMenuInactive()><span>Help</span></a></li><li><a ui-sref=faq-adv ng-click=vm.setUserMenuInactive()><span>FAQ</span></a></li><li><a href=\"\" ng-click=\"vm.setUserMenuInactive(); vm.signOut()\"><span>Sign out</span></a></li></ul></div></div><div class=header__mobile-menu><button type=button ng-click=\"vm.toggleMobileMenu(); vm.setUserMenuInactive();\"><span></span><span></span><span></span></button></div>");
$templateCache.put("app/components/topnav/partials/partial_pub.html","<a class=header__logo ui-sref=pub-dash><img src=assets/images/logo.svg alt></a><ul class=header__main-menu><li><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=pub-dash>Dashboard</a></li><li><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=all-profiles>{{ vm.state }} Profiles</a></li><li><a ui-sref-active=active ng-click=vm.setMobileMenuInactive() ui-sref=payouts>Payouts</a></li><li><a ng-click=vm.startPubTour() ui-sref=pub-dash>Tutorial</a></li></ul><ul class=header__service-menu><li><a ng-click=\"vm.setMobileMenuInactive(); vm.setUserMenuInactive(); vm.newProfile()\" href=javascript:void(0);><svg class=\"icon icon--plus-circle\"><use xlink:href=assets/images/icons.svg#plus-circle></use></svg></a></li></ul><div class=header__user-menu><div class=user-menu><button id=btn-gear ng-click=\"vm.setMobileMenuInactive(); vm.toggleUserMenu()\" ng-mouseleave=vm.fadeUserMenu() class=user-menu__button type=button><svg class=\"icon icon--gear\"><use xlink:href=assets/images/icons.svg#gear></use></svg></button><ul style=\"display: none\" ng-mouseleave=vm.fadeUserMenu() ng-mouseenter=vm.setUserMenuInUse() class=user-menu__dropdown><li id=li-act-info><a href=\"\" id=a-act-info ui-sref=show-profile ng-click=vm.setUserMenuInactive()><svg class=\"icon icon--edit\"><use xlink:href=assets/images/icons.svg#edit></use></svg><span id=span-act-info>My Account Info</span></a></li><li><a href=\"\" ng-click=\"vm.setUserMenuInactive(); vm.changeAccount(ev)\"><svg class=\"icon icon--plus-user\"><use xlink:href=assets/images/icons.svg#plus-user></use></svg><span>{{ vm.accountMessage() }}</span></a></li><li><a ui-sref=contact-us ng-click=vm.setUserMenuInactive()><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg><span>Help</span></a></li><li><a ui-sref=faq-pub ng-click=vm.setUserMenuInactive()><svg class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg><span>FAQ</span></a></li><li><a href=\"\" ng-click=\"vm.setUserMenuInactive(); vm.signOut()\"><svg class=\"icon icon--sign-out\"><use xlink:href=assets/images/icons.svg#sign-out></use></svg><span>Sign out</span></a></li></ul></div></div><div class=header__mobile-menu><button type=button ng-click=\"vm.toggleMobileMenu(); vm.setUserMenuInactive();\"><span></span><span></span><span></span></button></div>");
$templateCache.put("app/components/sidenav/subItem/subItem.html","<md-button class=sub-menu-item aria-label=\"Menu item\" ng-click=vm.closeMenu() ui-sref=\"{{ vm.state }}\" ui-sref-active=selected>{{ vm.text }}</md-button>");
$templateCache.put("app/pages/articles/done/articlesDone.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Content Pipe<span ng-show=aDoneCtrl.loading> (loading...)</span><span ng-show=\"!aDoneCtrl.loading && aDoneCtrl.articles.length === 0\"> (No Articles to Show)</span></h2><div class=content-section__right><input class=form-control ng-model=aDoneCtrl.queryArticles.filter ng-keypress=\"$event.keyCode === 13 && aDoneCtrl.searchQueryArticles()\" placeholder=\"Search for something...\"></div></div><div class=content-section__content><div class=content-pipeline ng-hide=\"aDoneCtrl.articles.length === 0\"><div class=content-pipeline__content><div class=content-pipeline__header><button ng-click=aDoneCtrl.instructions() class=\"btn btn-white btn-small btn-auto\" type=button>Instructions</button> <a ng-if=\"aDoneCtrl.zip && aDoneCtrl.adminApprovedArticlesCount > 0\" ng-href=\"{{ aDoneCtrl.zip }}\" class=\"btn btn-white btn-small\">Download</a></div><div class=content-pipeline__select-all-row style=\"display:flex;justify-content:flex-end;align-items:center;margin:16px 0 0;padding-right:15px\"><div class=content-pipeline__select-all style=display:flex;align-items:center;font-size:13px;font-weight:600;white-space:nowrap><span>CHECK ALL CONTENT TO MOVE TO CART &gt;&gt;</span><md-checkbox aria-label=\"CHECK ALL CONTENT TO MOVE TO CART\" style=margin-bottom:0;margin-left:8px ng-checked=aDoneCtrl.allSelected() ng-click=aDoneCtrl.toggleAll()></md-checkbox></div></div><div class=\"content-pipeline__table d-lg-block\"><md-table-container style=font-size:0><table class=table md-table ng-model=aDoneCtrl.articles md-progress=promise style=font-size:14px><thead md-head md-order=aDoneCtrl.queryArticles.order><tr><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 100px\">ETA</th><!-- <th md-column style=\"font-size: 14px; padding: 10px 15px; width: 120px;\">Campaign</th> --><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 150px\">Publisher</th><th md-column style=\"font-size: 14px; padding-top: 10px; padding-left: 15px; padding-right: 5px; width: 50px\">DA</th><th md-column style=\"font-size: 14px; padding-top: 10px; padding-left: 5px; padding-right: 5px; width: 50px\">TF</th><th md-column style=\"font-size: 14px; padding-top: 10px; padding-left: 5px; padding-right: 15px; width: 50px\">DR</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 80px\">Price</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 200px\">Title</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 200px\">Destination URL</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 150px\">Anchor</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 120px\">Actions</th><th md-column style=\"font-size: 14px; padding: 10px 15px; width: 60px\">Cart</th><th ng-if=aDoneCtrl.starFeatureEnabled() md-column style=\"font-size: 14px; padding: 10px 15px; width: 60px\">Sent</th></tr></thead><tr md-row ng-repeat=\"article in aDoneCtrl.articles\" ng-class=\"{ \'inactive\': aDoneCtrl.isRejected(article) && !article.publisher_not_active,\n                  \'active\': aDoneCtrl.isApproved(article) && !aDoneCtrl.advUploadedDoc(article) && !article.publisher_not_active,\n                  \'rewritten\': aDoneCtrl.isApprovedAfterAgencyRejected(article) && !article.publisher_not_active,\n                  \'adv-uploaded-doc\': aDoneCtrl.isApproved(article) && aDoneCtrl.advUploadedDoc(article) && !article.publisher_not_active,\n                  \'publisher-not-active\': article.publisher_not_active }\"><td md-cell ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip>{{ (article.eta | date:\'MM-dd\') || \'TBD\' }}</td><!-- <td md-cell>{{ article.campaign_name }}</td> --><td md-cell ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><a ng-href=\"{{ article.publisher }}\" target=_blank data-ellipsi data-ng-bind=\"article.publisher | limitTo: 40\" data-ellipsis-append=...></a><md-tooltip ng-if=!article.publisher_not_active md-direction=bottom>{{ article.publisher }}</md-tooltip></td><td md-cell style=\"padding-right: 5px\" ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip>{{ article.da }}</td><td md-cell style=\"padding-left: 5px; padding-right: 5px\" ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip>{{ article.trust_flow }}</td><td md-cell style=\"padding-left: 5px\" ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip>{{ article.dr }}</td><td md-cell ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip>${{ article.price }}</td><td md-cell class=blue-labels ng-style=aDoneCtrl.rowCellStyle(article) ng-class=\"{ \'disabled\': aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isRowLocked(article), \'md-placeholder\': !article.title }\" ng-click=\"editText($event, article, false)\" style=\"max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap\"><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><span>{{ (article.title || \'Not set yet\') | limitTo: 30 }}{{ article.title.length > 30 ? \'...\' : \'\' }}</span><md-tooltip ng-if=!article.publisher_not_active md-direction=bottom>{{ article.title }}</md-tooltip></td><td md-cell class=blue-labels ng-style=aDoneCtrl.rowCellStyle(article) ng-class=\"{ \'disabled\': aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isRowLocked(article), \'md-placeholder\': !article.destination_url }\" ng-click=\"editURL($event, article)\" style=\"max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap\"><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><span>{{ (article.destination_url || \'http://www.destination.com\') | limitTo: 60 }}{{ article.destination_url.length > 60 ? \'...\' : \'\' }}</span><md-tooltip ng-if=!article.publisher_not_active md-direction=bottom>{{ article.destination_url }}</md-tooltip></td><td md-cell class=blue-labels ng-style=aDoneCtrl.rowCellStyle(article) ng-class=\"{ \'disabled\': aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isRowLocked(article), \'md-placeholder\': !article.anchor }\" ng-click=\"editText($event, article, true)\" style=\"max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap\"><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><span>{{ (article.anchor || \'Not set yet\') | limitTo: 30 }}{{ article.anchor.length > 30 ? \'...\' : \'\' }}</span><md-tooltip ng-if=!article.publisher_not_active md-direction=bottom>{{ article.anchor }}</md-tooltip></td><td md-cell style=\"overflow: visible\" ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><ul class=action-buttons><li><a ng-hide=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\" ng-mouseover=\"aDoneCtrl.setArticleHoverView(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticleHoverView(article, false)\" ng-href=\"https://docs.google.com/viewer?url={{ article.blog_post_doc.url }}\" target=_blank ng-disabled=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article)\" ng-class=\"{ \'disabled\': aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) }\"><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg> </a><button type=button ng-mouseover=\"aDoneCtrl.setArticlePendingHoverView(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticlePendingHoverView(article, false)\" ng-show=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\"><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg></button><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.hoverView }\">View Content</div><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.pendingHoverView }\">Article must be completed first.</div></li><li><a ng-hide=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\" ng-mouseover=\"aDoneCtrl.setArticleHoverDownload(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticleHoverDownload(article, false)\" ng-href=\"{{ article.blog_post_doc.url }}\" target=_blank><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg> </a><button type=button ng-mouseover=\"aDoneCtrl.setArticlePendingHoverDownload(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticlePendingHoverDownload(article, false)\" ng-show=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\"><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg></button><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.hoverDownload }\">Download</div><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.pendingHoverDownload }\">Article must be completed first.</div></li><li><div ng-hide=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\" ngf-select ng-model=article.blog_post_doc name=article.blog_post_doc.name ngf-accept=\"\'.docx\'\" ngf-max-size=2MB type=file ng-change=aDoneCtrl.updateWord(article)><a ng-mouseover=\"aDoneCtrl.setArticleHoverUpload(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticleHoverUpload(article, false)\"><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></a></div><button type=button ng-mouseover=\"aDoneCtrl.setArticlePendingHoverUpload(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticlePendingHoverUpload(article, false)\" ng-show=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\"><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></button><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.hoverUpload }\">Upload</div><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.pendingHoverUpload }\">Article must be completed first.</div></li><li><a ng-hide=\"aDoneCtrl.isRowLocked(article) || (!aDoneCtrl.isCompleted(article) && (aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article)))\" ng-mouseover=\"aDoneCtrl.setArticleHoverNotes(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticleHoverNotes(article, false)\" ng-click=\"aDoneCtrl.showNotes(article, false)\"><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg> </a><button type=button ng-mouseover=\"aDoneCtrl.setArticlePendingHoverNotes(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticlePendingHoverNotes(article, false)\" ng-show=\"aDoneCtrl.isRowLocked(article) || (!aDoneCtrl.isCompleted(article) && (aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article)))\"><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg></button><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.hoverNotes }\">Notes</div><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.pendingHoverNotes }\">Article must be completed first.</div></li><li><a ng-hide=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\" ng-click=\"aDoneCtrl.showNotes(article, true)\" ng-mouseover=\"aDoneCtrl.setArticleHoverRewrite(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticleHoverRewrite(article, false)\" href=javascript:void(0)><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg> </a><button type=button ng-mouseover=\"aDoneCtrl.setArticlePendingHoverRewrite(article, true)\" ng-mouseleave=\"aDoneCtrl.setArticlePendingHoverRewrite(article, false)\" ng-show=\"aDoneCtrl.isRejected(article) || aDoneCtrl.isPending(article) || aDoneCtrl.isAssigned(article) || aDoneCtrl.isCompleted(article) || aDoneCtrl.isRowLocked(article)\"><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg></button><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.hoverRewrite }\">Rewrite</div><div class=action-button-hint ng-class=\"{ \'action-button-hint--active\': article.pendingHoverRewrite }\">Article must be completed first.</div></li></ul></td><td md-cell ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><md-checkbox aria-label=check ng-checked=article.checked ng-disabled=!aDoneCtrl.canAddToCart(article) ng-click=aDoneCtrl.toggle(article)></md-checkbox></td><td ng-if=aDoneCtrl.starFeatureEnabled() md-cell ng-class=set-star-icon ng-style=aDoneCtrl.rowCellStyle(article)><md-tooltip ng-if=article.publisher_not_active md-direction=top md-delay=300>{{ aDoneCtrl.publisherNotActiveTooltip }}</md-tooltip><md-icon md-font-set=material-icons ng-click=aDoneCtrl.toggleStarred(article) ng-checked=!article.starred ng-hide=\"article.starred || aDoneCtrl.isRowLocked(article)\">star_border</md-icon><md-icon md-font-set=material-icons ng-if=\"article.starred && !aDoneCtrl.isRowLocked(article)\" ng-click=aDoneCtrl.toggleStarred(article)>star</md-icon></td></tr><tr style=\"height: 30px\">&nbsp;</tr></table></md-table-container><md-table-pagination style=\"border-top: 0px\" class=\"arrows-enabled pagination-blue\" md-limit=aDoneCtrl.queryArticles.limit md-page=aDoneCtrl.queryArticles.page md-total=\"{{ aDoneCtrl.results }}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=aDoneCtrl.getPaginatedArticles md-page-select=true></md-table-pagination></div><div ng-if=false class=\"content-pipeline__table d-block d-lg-none\"><table class=active><tr><th>ETA</th><td>11/22/18</td></tr><tr><th>Campaign</th><td>Adv1 Campaign1</td></tr><tr><th>Publisher</th><td>webtoolsdepot.com</td></tr><tr><th>Price</th><td>$100</td></tr><tr><th>Title</th><td><span class=span-placeholder>Not set yet</span></td></tr><tr><th>Destination URL</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=testinginvoice.com></td></tr><tr><th>Anchor</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=\"testing invoice\"></td></tr><tr><th>Doc Name</th><td>test.docx</td></tr><tr><th>Actions</th><td><ul class=action-buttons><li><button type=button><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg></button></li></ul></td></tr><tr><th>Cart</th><td><div class=\"form-check form-check-checkbox\"><input class=form-check-input id=checkbox5 name=name type=checkbox><label class=form-check-label for=checkbox5></label></div></td></tr></table><table class=inactive><tr><th>ETA</th><td>11/22/18</td></tr><tr><th>Campaign</th><td>Adv1 Campaign1</td></tr><tr><th>Publisher</th><td>webtoolsdepot.com</td></tr><tr><th>Price</th><td>$100</td></tr><tr><th>Title</th><td><span class=span-placeholder>Not set yet</span></td></tr><tr><th>Destination URL</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=testinginvoice.com></td></tr><tr><th>Anchor</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=\"testing invoice\"></td></tr><tr><th>Doc Name</th><td>test.docx</td></tr><tr><th>Actions</th><td><ul class=action-buttons><li><button type=button><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg></button></li></ul></td></tr><tr><th>Cart</th><td><div class=\"form-check form-check-checkbox\"><input class=form-check-input id=checkbox6 name=name type=checkbox><label class=form-check-label for=checkbox6></label></div></td></tr></table><table><tr><th>ETA</th><td>11/22/18</td></tr><tr><th>Campaign</th><td>Adv1 Campaign1</td></tr><tr><th>Publisher</th><td>webtoolsdepot.com</td></tr><tr><th>Price</th><td>$100</td></tr><tr><th>Title</th><td><span class=span-placeholder>Not set yet</span></td></tr><tr><th>Destination URL</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=testinginvoice.com></td></tr><tr><th>Anchor</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=\"testing invoice\"></td></tr><tr><th>Doc Name</th><td>test.docx</td></tr><tr><th>Actions</th><td><ul class=action-buttons><li><button type=button><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg></button></li></ul></td></tr><tr><th>Cart</th><td><div class=\"form-check form-check-checkbox\"><input class=form-check-input id=checkbox7 name=name type=checkbox><label class=form-check-label for=checkbox7></label></div></td></tr></table><table><tr><th>ETA</th><td>11/22/18</td></tr><tr><th>Campaign</th><td>Adv1 Campaign1</td></tr><tr><th>Publisher</th><td>webtoolsdepot.com</td></tr><tr><th>Price</th><td>$100</td></tr><tr><th>Title</th><td><span class=span-placeholder>Not set yet</span></td></tr><tr><th>Destination URL</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=testinginvoice.com></td></tr><tr><th>Anchor</th><td><input class=\"form-control form-control--editable\" name=name type=text placeholder value=\"testing invoice\"></td></tr><tr><th>Doc Name</th><td>test.docx</td></tr><tr><th>Actions</th><td><ul class=action-buttons><li><button type=button><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#action_view></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_upload\"><use xlink:href=assets/images/icons.svg#action_upload></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_download\"><use xlink:href=assets/images/icons.svg#action_download></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_edit\"><use xlink:href=assets/images/icons.svg#action_edit></use></svg></button></li><li><button type=button><svg class=\"icon icon--action_reload\"><use xlink:href=assets/images/icons.svg#action_reload></use></svg></button></li></ul></td></tr><tr><th>Cart</th><td><div class=\"form-check form-check-checkbox\"><input class=form-check-input id=checkbox8 name=name type=checkbox><label class=form-check-label for=checkbox8></label></div></td></tr></table></div><div class=content-pipeline__footer style=\"flex-flow: row-reverse\"><button class=\"btn btn-white\" type=button ng-click=aDoneCtrl.checkout() ng-disabled=\"aDoneCtrl.selectedArticles.length < 1 || $root.isLoading || aDoneCtrl.selectionHasPublisherNotActive()\">Send to cart</button></div></div></div></div></div>");
$templateCache.put("app/pages/articles/pipeline/articlesPipeline.html","<div layout=row><md-subheader class=md-no-sticky><h3>Content pipeline (work in progress...)</h3></md-subheader><span flex></span></div><md-subheader ng-hide=false class=md-no-sticky layout=row layout-align=\"center center\"><h2>No articles to show</h2></md-subheader>");
$templateCache.put("app/pages/advTeammates/editAdvTeammate/editAdvTeammate.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Edit Team Member</h2></div><div class=content-section__content><div class=adv-add-teammate__content><form class=adv-add-teammate__main-data name=tform><div class=adv-add-teammate__submit-btn><button class=\"btn btn-white btn-auto\" ng-click=eCtrl.goTeammates() style=\"margin-right: 15px\">BACK</button> <button class=\"btn btn-default btn-auto\" ng-disabled=\"!tform.$valid || !tform.$dirty || $root.isLoading || eCtrl.adv.password_confirmation != eCtrl.adv.password\" ng-click=eCtrl.submitEditTeammate()>SAVE</button></div><h4 class=adv-add-teammate__main-switchers-title style=margin-bottom:25px>CREDENTIALS</h4><div class=adv-add-teammate__main-data__inputs><div class=form-group><input class=form-control type=text ng-model=eCtrl.adv.first_name placeholder=\"First name\" name=first_name required><div ng-messages=tform.first_name.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input class=form-control type=text ng-model=eCtrl.adv.last_name placeholder=\"Last Name\" name=last_name required><div ng-messages=tform.last_name.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input class=form-control type=text ng-model=eCtrl.adv.email placeholder=Email name=email data-lpignore=true required><div ng-messages=tform.email.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input name=disable-pwd-mgr-1 type=password id=disable-pwd-mgr-1 style=\"display: none\" value=disable-pwd-mgr-1> <input name=disable-pwd-mgr-2 type=password id=disable-pwd-mgr-2 style=\"display: none\" value=disable-pwd-mgr-2> <input name=disable-pwd-mgr-3 type=password id=disable-pwd-mgr-3 style=\"display: none\" value=disable-pwd-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=newPassword ng-model=eCtrl.adv.password maxlength=16 minlength=8 placeholder=\"New password\"><div ng-messages=tform.newPassword.$error class=form-errors><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div class=form-group><input name=disable-pwdc-mgr-1 type=password id=disable-pwdc-mgr-1 style=\"display: none\" value=disable-pwdc-mgr-1> <input name=disable-pwdc-mgr-2 type=password id=disable-pwdc-mgr-2 style=\"display: none\" value=disable-pwdc-mgr-2> <input name=disable-pwdc-mgr-3 type=password id=disable-pwdc-mgr-3 style=\"display: none\" value=disable-pwdc-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=confirmPassword ng-model=eCtrl.adv.password_confirmation maxlength=16 minlength=8 ng-change=eCtrl.canChangePassword(tform) placeholder=\"Confirm new password\"><div ng-messages=tform.confirmPassword.$error class=form-errors><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div></div><div class=adv-add-teammate__main-switchers><h4 class=adv-add-teammate__main-switchers-title>PERMISSIONS</h4><div class=adv-add-teammate__switcher-list><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.create_campaigns ng-model=eCtrl.adv.create_campaigns ng-disabled=false aria-label=\"Create Campaigns\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'create_campaigns\')\"></label></div><span>Create Campaigns</span></div><a ng-click=\"eCtrl.helpMsg(\'create_campaigns\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.manage_campaigns ng-model=eCtrl.adv.manage_campaigns ng-disabled=false aria-label=\"Manage Campaigns\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'manage_campaigns\')\"></label></div><span>Manage Campaigns</span></div><a ng-click=\"eCtrl.helpMsg(\'manage_campaigns\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.create_quotes ng-model=eCtrl.adv.create_quotes ng-disabled=false aria-label=\"Create Quotes\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'create_quotes\')\"></label></div><span>Create Quotes</span></div><a ng-click=\"eCtrl.helpMsg(\'create_quotes\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.approve_content ng-model=eCtrl.adv.approve_content ng-disabled=false aria-label=\"Approve Content\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'approve_content\')\"></label></div><span>Approve Content</span></div><a ng-click=\"eCtrl.helpMsg(\'approve_content\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.purchase_content ng-model=eCtrl.adv.purchase_content ng-disabled=false aria-label=\"Purchase Content\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'purchase_content\')\"></label></div><span>Purchase Content</span></div><a ng-click=\"eCtrl.helpMsg(\'purchase_content\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=eCtrl.adv.edit_billing ng-model=eCtrl.adv.edit_billing ng-disabled=false aria-label=\"Edit Billing\"><label data-on=ON data-off=OFF ng-click=\"eCtrl.toggleAdvValue(\'edit_billing\')\"></label></div><span>Edit Billing</span></div><a ng-click=\"eCtrl.helpMsg(\'edit_billing\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/advTeammates/newAdvTeammate/newAdvTeammate.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Add Team Member</h2></div><div class=content-section__content><div class=adv-add-teammate__content><form class=adv-add-teammate__main-data name=tform><h4 class=adv-add-teammate__main-switchers-title style=margin-bottom:25px>CREDENTIALS</h4><div class=adv-add-teammate__main-data__inputs><div class=form-group><input class=form-control type=text ng-model=aCtrl.adv.first_name placeholder=\"First name\" name=first_name required><div ng-messages=tform.first_name.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input class=form-control type=text ng-model=aCtrl.adv.last_name placeholder=\"Last Name\" name=last_name required><div ng-messages=tform.last_name.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input class=form-control type=text ng-model=aCtrl.adv.email placeholder=Email name=email data-lpignore=true required><div ng-messages=tform.email.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div></div></div><div class=form-group><input name=disable-pwd-mgr-1 type=password id=disable-pwd-mgr-1 style=\"display: none\" value=disable-pwd-mgr-1> <input name=disable-pwd-mgr-2 type=password id=disable-pwd-mgr-2 style=\"display: none\" value=disable-pwd-mgr-2> <input name=disable-pwd-mgr-3 type=password id=disable-pwd-mgr-3 style=\"display: none\" value=disable-pwd-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=newPassword ng-model=aCtrl.adv.password maxlength=16 minlength=8 placeholder=\"New password\" required><div ng-messages=tform.newPassword.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div class=form-group><input name=disable-pwdc-mgr-1 type=password id=disable-pwdc-mgr-1 style=\"display: none\" value=disable-pwdc-mgr-1> <input name=disable-pwdc-mgr-2 type=password id=disable-pwdc-mgr-2 style=\"display: none\" value=disable-pwdc-mgr-2> <input name=disable-pwdc-mgr-3 type=password id=disable-pwdc-mgr-3 style=\"display: none\" value=disable-pwdc-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=confirmPassword ng-model=aCtrl.adv.password_confirmation maxlength=16 minlength=8 ng-change=aCtrl.canChangePassword(tform) placeholder=\"Confirm new password\" required><div ng-messages=tform.confirmPassword.$error ng-if=tform.$dirty class=form-errors><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div></div><div class=adv-add-teammate__main-switchers><h4 class=adv-add-teammate__main-switchers-title>PERMISSIONS</h4><div class=adv-add-teammate__switcher-list><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.create_campaigns ng-model=aCtrl.adv.create_campaigns ng-disabled=false aria-label=\"Create Campaigns\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'create_campaigns\')\"></label></div><span>Create Campaigns</span></div><a ng-click=\"aCtrl.helpMsg(\'create_campaigns\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.manage_campaigns ng-model=aCtrl.adv.manage_campaigns ng-disabled=false aria-label=\"Manage Campaigns\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'manage_campaigns\')\"></label></div><span>Manage Campaigns</span></div><a ng-click=\"aCtrl.helpMsg(\'manage_campaigns\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.create_quotes ng-model=aCtrl.adv.create_quotes ng-disabled=false aria-label=\"Create Quotes\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'create_quotes\')\"></label></div><span>Create Quotes</span></div><a ng-click=\"aCtrl.helpMsg(\'create_quotes\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.approve_content ng-model=aCtrl.adv.approve_content ng-disabled=false aria-label=\"Approve Content\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'approve_content\')\"></label></div><span>Approve Content</span></div><a ng-click=\"aCtrl.helpMsg(\'approve_content\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.purchase_content ng-model=aCtrl.adv.purchase_content ng-disabled=false aria-label=\"Purchase Content\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'purchase_content\')\"></label></div><span>Purchase Content</span></div><a ng-click=\"aCtrl.helpMsg(\'purchase_content\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div><div class=adv-add-teammate__switcher-group><div class=adv-add-teammate__switcher-inner-group><div class=switcher><input type=checkbox ng-checked=aCtrl.adv.edit_billing ng-model=aCtrl.adv.edit_billing ng-disabled=false aria-label=\"Edit Billing\"><label data-on=ON data-off=OFF ng-click=\"aCtrl.toggleAdvValue(\'edit_billing\')\"></label></div><span>Edit Billing</span></div><a ng-click=\"aCtrl.helpMsg(\'edit_billing\')\" href=javascript:void(0);><svg class=\"icon icon--help\"><use xlink:href=assets/images/icons.svg#help></use></svg></a></div></div></div><div class=adv-add-teammate__submit-btn><button class=\"btn btn-default btn-auto\" ng-disabled=\"!tform.$valid || !tform.$dirty || $root.isLoading || aCtrl.adv.password_confirmation != aCtrl.adv.password\" ng-click=aCtrl.submitAddTeammate()>SAVE</button></div></form></div></div><div class=content-section__header style=\"margin-top: 40px\"><h2 class=content-section__title>Existing Team Members</h2></div><div class=content-section__content><div class=adv-add-teammate__content><table class=table><tr><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Permissions</span></th><th><span></span></th><th><span></span></th></tr><tr ng-repeat=\"adv in aCtrl.teammates\"><td>{{ adv.first_name }}</td><td>{{ adv.last_name }}</td><td>{{ adv.email }}</td><td>Create Campaigns: {{ aCtrl.hasRole(adv, \'create_campaigns\') }}<br>Manage Campaigns: {{ aCtrl.hasRole(adv, \'manage_campaigns\') }}<br>Create Quotes: {{ aCtrl.hasRole(adv, \'create_quotes\') }}<br>Approve Content: {{ aCtrl.hasRole(adv, \'approve_content\') }}<br>Purchase Content: {{ aCtrl.hasRole(adv, \'purchase_content\') }}<br>Edit Billing: {{ aCtrl.hasRole(adv, \'edit_billing\') }}</td><td><a class=\"btn btn-white\" href=\"/#/adv/teammates/edit/{{ adv.id }}\">Edit</a></td><td><a class=\"btn btn-white\" ng-click=aCtrl.destroyTeammate(adv) href=javascript:void(0)>Delete</a></td></tr></table></div></div></div>");
$templateCache.put("app/pages/campaigns/allCampaigns/allCampaigns.html","<div class=content-section><div class=content-section__header><h2 class=\"content-section__title with-searching\">Campaigns ({{ allCampCtrl.total_campaigns }} results)</h2><div class=\"campaigns-list__button with-searching\"><a class=\"btn btn-white btn-small\" href=#/campaigns/new>Create New Campaign</a><div><input class=\"small-search no-focus\" ng-model=allCampCtrl.query.filter ng-keypress=allCampCtrl.searchCampaigns($event) placeholder=\"Search for campaigns\"></div></div></div><div class=content-section__content><div class=manage-campaigns><div class=manage-campaigns__campaigns-list><div class=campaigns-list><div class=campaigns-list__content><div class=campaigns-list__list><md-subheader ng-if=\"allCampCtrl.campaigns.length === 0\" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No campaigns to show</h2></md-subheader><campaign-mini dir-paginate=\"campaign in allCampCtrl.campaigns | itemsPerPage: allCampCtrl.perPage\" total-items=allCampCtrl.total_campaigns campaign=campaign></campaign-mini></div><div class=campaigns-list__pagination><dir-pagination-controls max-size=6 on-page-change=\"allCampCtrl.paginateCampaigns(newPageNumber, oldPageNumber)\"></dir-pagination-controls></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/campaigns/editCampaign/editCampaign.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Edit campaign</h2><div class=content-section__right><a class=\"btn btn-white btn-auto\" ui-sref=\"search({ categories: editCampCtrl.categoriesNames(), campaignId: editCampCtrl.campaign.id })\">Search new pubs</a> <a class=\"btn btn-white btn-auto ng-cloak\" ng-show=!editCampCtrl.isReportNull() href=\"{{ editCampCtrl.campaign.campaign_report }}\" target=_blank>Campaign report</a> <button type=button class=\"btn btn-white btn-auto ng-cloak\" ng-show=editCampCtrl.isReportNull() ng-click=editCampCtrl.showNoReportAlert()>Campaign report</button> <a class=\"btn btn-white-red\" ng-click=editCampCtrl.destroy() href=javascript:void(0)>Delete</a></div></div><div class=content-section__content><div class=edit-campaign><div class=edit-campaign__section><div class=edit-campaign__section-content><!-- partial for avatar & name --><div class=edit-campaign__main-data ng-include=\"\'app/pages/campaigns/editCampaign/partials/header.html\'\"></div><!-- partial for categories --><div class=edit-campaign__categories ng-include=\"\'app/pages/campaigns/editCampaign/partials/categories.html\'\"></div></div></div><!-- partial for URLS --><div class=edit-campaign__section ng-include=\"\'app/pages/campaigns/editCampaign/partials/urls.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/campaigns/modalCampaign/modalCampaign.html","<md-dialog><md-dialog-content><div layout-padding><div class=md-dialog-content><h2>Upload Spreadsheet file</h2><p>Download the <a class=md-primary href=assets/files/example_file.csv>example file</a>. Fill up as shown in the file, save your changes and upload with the button below.</p><p>Rememeber to write the urls in <b>column A</b> as shown in the example file.</p></div><md-button class=md-accent type=file ngf-select class=md-accent ng-model=modCampCtrl.campaign.csv name=csv ngf-accept=\"\'.xlsx, .csv\'\">Select file</md-button><md-card-content ng-show=modCampCtrl.campaign.csv flex layout=row layout-align=\"center center\"><md-input-container class=normal-input flex><label>Selected Spreadsheet</label><input name=csv class=highlighted disabled=disabled ng-model=modCampCtrl.campaign.csv.name></md-input-container><md-button class=md-accent ng-if=modCampCtrl.campaign.csv ng-click=modCampCtrl.clearCsv()>Remove</md-button></md-card-content></div><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=modCampCtrl.submit()>Upload</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/campaigns/newCampaign/newCampaign.html","<form class=new-campaign__main-data__form name=form ng-submit=\"form.$valid && newCampCtrl.submit()\"><div class=content-section><div class=content-section__header><h2 class=content-section__title>Create New Campaign</h2><div class=content-section__right><button type=button class=\"btn btn-default btn-small btn-auto\" ng-click=\"form.$valid && newCampCtrl.submit()\" ng-disabled=\"form.$invalid || newCampCtrl.campaign.categories.length == 0 || $root.isLoading\">Save</button></div></div><div class=content-section__content><div class=new-campaign><div class=new-campaign__content><div class=new-campaign__main-data><div class=new-campaign__main-data__photo><image-selector image=newCampCtrl.campaign.image></image-selector></div><div class=new-campaign__main-data__inputs><h6 ng-if=\"newCampCtrl.teammates.length > 1\">Campaign Manager</h6><select style=\"width: 300px; margin-bottom: 15px\" class=form-control name=manager ng-if=\"newCampCtrl.teammates.length > 1\" ng-model=newCampCtrl.manager ng-options=\"adv.email for adv in newCampCtrl.teammates track by adv.id\"></select><div ng-messages=form.manager.$error><div ng-message=md-require-match>Please select an existing teammate.</div></div><div class=form-group><input class=form-control type=text placeholder=\"Write a campaign name\" ng-model=newCampCtrl.campaign.name name=name required unique-on=newCampCtrl.campaignNames></div><div class=\"errors errors-1\" ng-messages=form.name.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div><h6 ng-show=!newCampCtrl.campaign.csv>Submit home page first. Subpages are added during order process</h6><div class=form-group ng-show=!newCampCtrl.campaign.csv><input class=form-control type=text ng-required=!newCampCtrl.campaign.csv name=url ng-model=newCampCtrl.campaign.url placeholder=http://www.awesome.site.com url-input><div class=errors ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div></div></div><!-- CSV file uploaded --><md-card-content ng-show=newCampCtrl.campaign.csv flex layout=row layout-align=\"center center\"><md-input-container class=normal-input flex><label>Uploaded Spreadsheet</label><input name=csv class=highlighted disabled=disabled ng-model=newCampCtrl.campaign.csv.name></md-input-container><md-button class=\"md-raised orange-button\" ng-if=newCampCtrl.campaign.csv ng-click=newCampCtrl.clearCsv()>Remove</md-button></md-card-content><div class=new-campaign__categories><category-selector flex placeholder=\"Select your categories...\" ng-model=newCampCtrl.campaign.categories hide-categories=!newCampCtrl.showCategories force-clear-categories=true></category-selector></div><div class=\"edit-profile__show-control-btn d-block d-md-none\"><a class=\"btn btn-link\" href=javascript:void(0) ng-click=newCampCtrl.toggleCategories()>{{ newCampCtrl.toggleCategoriesActionMsg() }}</a></div></div></div></div></div></form>");
$templateCache.put("app/pages/campaigns/newSite/newSite.html","<md-card><form name=form ng-submit=\"form.$valid && newSteCtrl.submit()\"><md-card-content layout=column layout-gt-xs=row flex><md-subheader class=md-no-sticky flex-order-xs=2><h3>Submit a page from your site and start builing links to it today!</h3></md-subheader><span flex></span><md-button ng-show=!newSteCtrl.csv class=\"md-raised full-accent\" flex-order-xs=1 ng-click=newSteCtrl.showDialog()>Upload Spreadsheet</md-button></md-card-content><md-card-content layout=column><!-- Input for URL --><md-input-container ng-show=!newSteCtrl.csv class=normal-input flex><label>Add a new url</label><input ng-required=!newSteCtrl.csv name=url ng-model=newSteCtrl.campaignUrl placeholder=http://yourawesomesite.com url-input><div ng-messages=form.url.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></md-input-container><!-- CSV file uploaded --><div layout=row ng-show=newSteCtrl.csv><md-input-container class=normal-input flex><label>Uploaded Spreadsheet</label><input name=csv class=highlighted disabled=disabled ng-model=newSteCtrl.csv.name></md-input-container><md-button class=\"md-raised full-accent\" ng-if=newSteCtrl.csv ng-click=newSteCtrl.clearCsv()>Remove</md-button></div><!-- Select for campaign --><md-input-container class=normal-input flex><label>Add to campaign</label><md-select required name=selectedCampaign ng-model=newSteCtrl.selectedCampaign md-selected-text=newSteCtrl.getSelectedCampaign()><md-optgroup label=\"your campaigns\"><md-option ng-value=campaign ng-repeat=\"campaign in newSteCtrl.campaigns\">{{ campaign.name }}</md-option></md-optgroup></md-select><div ng-messages=form.selectedCampaign.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></md-input-container><md-subheader class=md-no-sticky><h3>Select categories for this campaign</h3></md-subheader><category-selector placeholder=\"Select your categories...\" ng-model=newSteCtrl.categories flex></category-selector><md-button class=\"md-raised full-accent right\" type=submit ng-disabled=\"form.$invalid || newSteCtrl.isSelectedCategoriesEmpty() || $root.isLoading\">Create</md-button></md-card-content></form></md-card>");
$templateCache.put("app/pages/campaigns/teammateCampaigns/teammateCampaigns.html","<div class=content-section><div class=content-section__header><h2 class=\"content-section__title with-searching\">{{ allCampCtrl.teammate.first_name }} {{ allCampCtrl.teammate.last_name }}\'s Campaigns ({{ allCampCtrl.total_campaigns }} results)</h2><div class=\"campaigns-list__button with-searching\"><div><div class=campaigns-list__create-button><a class=\"btn btn-white btn-small\" href=#/adv/teammates>Manage Teammates</a></div><input class=\"small-search no-focus\" style=\"visibility: hidden\" ng-model=allCampCtrl.query.filter ng-keypress=allCampCtrl.searchCampaigns($event) placeholder=\"Search for campaigns\"></div></div><div style=\"color:red; font-weight: bold; margin-bottom: 10px\">1) First reassign all campaigns to a different teammate before deleting {{ allCampCtrl.teammate.first_name }}.<br><br>2) You will then automatically be redirected back to delete {{ allCampCtrl.teammate.first_name }} from the system.</div></div><div class=content-section__content><div class=manage-campaigns><div class=manage-campaigns__campaigns-list><div class=campaigns-list><div class=campaigns-list__content><div class=campaigns-list__list><md-subheader ng-if=\"allCampCtrl.campaigns.length === 0\" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No campaigns to show</h2></md-subheader><campaign-mini-managers dir-paginate=\"campaign in allCampCtrl.campaigns | itemsPerPage: allCampCtrl.perPage\" total-items=allCampCtrl.total_campaigns campaign=campaign teammates=allCampCtrl.teammates manager=allCampCtrl.teammate></campaign-mini-managers></div><div class=campaigns-list__pagination><dir-pagination-controls max-size=6 on-page-change=\"allCampCtrl.paginateCampaigns(newPageNumber, oldPageNumber)\"></dir-pagination-controls></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/cart/blogPost/blogPost.html","<md-dialog class=\"blog-post-container ng-cloak ng-hide\" aria-label=\"Create Blog Post\" layout=column layout-align=\"center center\" ng-show=blgCtrl.initialized><md-toolbar><div class=md-toolbar-tools><h2>Create Blog Post</h2><span flex></span><md-button class=md-icon-button ng-click=blgCtrl.closeDialog()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=dialog-content layout-align=\"start center\"><form name=form ng-submit=false layout=column flex><div clas=\"md-block campaign-container\"><div class=form-group><!-- <label>Campaign</label> --><md-autocomplete flex ng-required=true md-input-name=campaign md-selected-item=blgCtrl.blogPost.campaign md-search-text=blgCtrl.searchTextCampaign md-items=\"campaign in blgCtrl.querySearchCampaign(blgCtrl.searchTextCampaign)\" md-item-text=campaign.name md-require-match md-no-cache=true md-min-length=0 md-floating-label=\"Select Campaign\" md-selected-item-change=blgCtrl.checkIfOrdered()><md-item-template><span md-highlight-flags=^i md-highlight-text=blgCtrl.searchTextCampaign>{{ campaign.name }}</span></md-item-template><div ng-messages=form.campaign.$error><div ng-message=md-require-match>Please select an existing campaign.</div><div ng-message=required>You must supply a campaign.</div></div></md-autocomplete><!-- <md-select aria-label=\"campaign\" required class=\"form-control\" name=\"campaign\" ng-model=\"blgCtrl.blogPost.campaign\">\n            <md-optgroup label=\"Your campaigns\">\n              <md-option ng-value=\"campaign\" ng-repeat=\"campaign in blgCtrl.campaigns\">\n                {{ campaign.name }}\n              </md-option>\n            </md-optgroup>\n          </md-select>\n          <div class=\"errors\" ng-messages=\"form.campaign.$error\" md-auto-hide=\"false\">\n            <div ng-message=\"required\">This is required.</div>\n          </div> --></div></div><p class=\"error-message duplicated-order-warning\" ng-if=blgCtrl.order.already_ordered>Warning! You have already purchased a post for <i>{{ blgCtrl.order.already_ordered_campaign }}</i> on this blog.<br>You can either purchase twice or select a new campaign above.</p><div class=\"md-block infographic\" layout=row layout-xs=column><label class=form-label flex=30>Using an infographic?</label><md-radio-group class=options-container ng-model=blgCtrl.infographic layout=row flex=60 layout-align-sm=\"center center\" layout-align=\"start center\"><md-radio-button value=yes>Yes</md-radio-button><md-radio-button value=no>No</md-radio-button></md-radio-group></div><div class=form-group><label>Title</label><input class=form-control ng-required=true ng-model=blgCtrl.blogPost.blog_post_title name=title placeholder=\"Please Copy / Paste blog post title from Word Doc\" type=text><div class=errors ng-messages=form.title.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div><text-angular ng-required=\"blgCtrl.infographic == \'yes\'\" ng-show=\"blgCtrl.infographic == \'yes\'\" ng-model=blgCtrl.blogPost.blog_post_body></text-angular><div layout=row layout-align=\"center center\" flex><div flex=50><div class=\"form-group input-left\"><label>Target URL</label><input class=form-control name=url ng-required=true ng-model=blgCtrl.newURL ng-change=blgCtrl.setEmptyDropdownUrl() placeholder=\"Please Copy / Paste URL from Word Doc\" url-input><div class=errors ng-messages=form.url.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div></div><div flex=50><div class=\"form-group input-right\" ng-hide=\"blgCtrl.infographic == \'yes\'\"><label>Anchor text</label><input class=form-control ng-required=\"blgCtrl.infographic == \'no\'\" name=linkText ng-model=blgCtrl.blogPost.link_text placeholder=\"Please Copy / Paste anchor text from Word Doc\" type=text><div class=errors ng-messages=form.linkText.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><br><br></form><form name=filesWideForm class=form-doc-upload><div><p>Max file size is 25 MBs. If you want images, copy them onto the Word doc.</p></div><div layout=column layout-align=\"center start\" layout-gt-md=row layout-align-gt-md=\"start center\"><file-chooser text=\"Choose file\" file-max=25MB file-ext=\".doc, .docx\" file-name=word file=blgCtrl.blogPost.word label=\"Word document\" smaller=true small-input=true ng-disabled=$root.isLoading ng-show=\"blgCtrl.infographic == \'no\'\"></file-chooser><div layout=row class=download-content ng-if=blgCtrl.blogPost.blog_post_doc.url><a class=\"btn btn-download\" aria-label=download ng-href={{blgCtrl.blogPost.blog_post_doc.url}} target=_blank ng-click=blgCtrl.downloadContent(blgCtrl.blogPost)><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a><p>Download existing content ({{ blgCtrl.existingBlogDocFilename() }})</p></div></div></form></md-content><div class=dialog-actions><md-divider></md-divider><md-card-actions layout=row layout-align=\"end center\" flex><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading ng-click=blgCtrl.closeDialog()>Cancel</md-button><md-button class=\"btn btn-white btn-small\" ng-disabled=\"$root.isLoading || !blgCtrl.hasContent()\n        || blgCtrl.noUrl() || filesForm.$invalid || form.$invalid || imagesForm.$invalid || filesWideForm.$invalid\" ng-click=blgCtrl.save()>Save</md-button></md-card-actions></div></md-dialog>");
$templateCache.put("app/pages/cart/checkout/checkout.html","<payments></payments>");
$templateCache.put("app/pages/cart/modals/notCheckoutReady.html","<md-dialog class=download-content-dialog><md-toolbar class=\"toolbar toolbar-red\"><div class=md-toolbar-tools><h2>1 OR MORE SELECTED AD SPOTS NOT YET FINISHED</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div style=padding:20px>All unfinished ad spots are now highlighted in red. Please finish editing those you wish to check out.<br><br>Reasons that an ad spot is not ready may include:<ul><li>Title still needs to be saved</li><li>Destination URL still needs to be saved</li><li>Anchor of the Link still needs to be saved</li><li>Article for the Order still needs to be uploaded.</li></ul></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"center center\"><button class=\"btn btn-small btn-white text-uppercase\" class=md-accent ng-click=crtCtrl.close()>OK, UNDERSTOOD</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/dashboard/pub/pubDashboard.html","<div class=dashboard><div class=dashboard__statistics><div class=common-statistics><div class=common-statistics__content><div class=common-statistics__cell><metric title=\"Active Ads\" badge=\"{{ $root.badgeActiveAds }}\" icon=active-ads ng-disable=\"$root.badgeActive === 0\" ng-click=pubCtrl.showActiveContent()>{{ $root.counterActiveAds }}</metric></div><div class=common-statistics__cell><metric title=\"New Orders\" badge=\"{{ $root.badgeNewOrders }}\" icon=cart ng-disable=\"$root.badgeAwaiting === 0\" ng-click=pubCtrl.newOrders()>{{ $root.counterNewOrders }}</metric></div><div class=common-statistics__cell><metric title=\"Pricing & Pausing\" badge=\"{{ $root.badgePricingAndPausing }}\" icon=wallet ng-disable=\"$root.badgeApproved === 0\" ng-click=pubCtrl.pricingPausing()>{{ $root.counterPricingAndPausing }}</metric></div><div class=common-statistics__cell><metric title=\"Re-Submitted Content\" badge=\"{{ $root.badgeReSubmitted }}\" icon=resubmit ng-disable=\"$root.badgeReused === 0\" ng-click=pubCtrl.resubmittedContent()>{{ $root.counterReSubmitted }}</metric></div></div></div></div><div class=dashboard__profiles-list><div class=profiles-list><div class=profiles-list__header><div class=profiles-list__title-wrapper><h5 class=profiles-list__title>Profiles</h5></div><div class=profiles-list__create-button><button id=btn-create-profile class=\"btn btn-white btn-small\" ng-click=pubCtrl.showCreateProfileModal()>Create new profile</button></div><div style=\"flex: 10%\"></div></div><div class=profiles-list__content><div class=profiles-list__list ng-repeat=\"profile in pubCtrl.publisher.profiles | limitTo:3\" ng-if=\"pubCtrl.publisher.profiles.length > 0\"><profile-mini profile=profile publisher=pubCtrl.publisher></profile-mini></div></div><div ng-if=\"pubCtrl.publisher.profiles.length > 0\" class=profiles-list__header><div class=profiles-list__button><a class=\"btn btn-white btn-small\" ui-sref=all-profiles>View More Profiles</a></div></div></div></div></div>");
$templateCache.put("app/pages/dashboard/adv/advDashboard.html","<div class=advertiser-dashboard><div class=advertiser-dashboard__statistics><div class=common-statistics><div class=common-statistics__content><div class=common-statistics__cell><metric title=\"Pending & Published Content\" badge=\"{{ $root.badgeActive }}\" icon=active-ads ng-disable=\"$root.badgeActive === 0\" ng-click=advCtrl.showActiveContent() wide-title=true>{{ $root.counterActive || 0 }}</metric></div><div class=common-statistics__cell><metric title=\"Orders Pending Approval\" badge=\"{{ $root.badgeAwaiting }}\" icon=clock ng-disable=\"$root.badgeAwaiting === 0\" ng-click=advCtrl.showAwaitingContent()>{{ $root.counterAwaiting || 0 }}</metric></div><div class=common-statistics__cell><metric title=\"Rejected Content\" badge=\"{{ $root.badgeReused }}\" icon=rejected ng-disable=\"$root.badgeReused === 0\" ng-click=advCtrl.seeReport()>{{ $root.counterReused || 0 }}</metric></div><div class=common-statistics__cell><metric title=\"Items in Cart\" badge=0 icon=plus-cart ng-disable=\"$root.counterPendingOrders === 0\" ng-click=advCtrl.seeCart()>{{ $root.counterPendingOrders || 0 }}</metric></div></div></div></div><div ng-if=false class=advertiser-dashboard__search><div class=search-for-publishers><h5 class=search-for-publishers__title>Search for Publishers</h5><div class=search-for-publishers__wrapper><chips-input placeholder=\"{{ advCtrl.getPlaceholder() }}\" ng-model=advCtrl.selectedCategories hide-categories=!showCategories search=advCtrl.search()></chips-input></div></div></div><div class=advertiser-dashboard__campaigns-list><div class=campaigns-list><div class=campaigns-list__header><div class=profiles-list__title-wrapper><h5 class=profiles-list__title>Campaigns</h5></div><div class=campaigns-list__create-button><a class=\"btn btn-white btn-small\" href=#/campaigns/new>Create Campaign</a></div><div style=\"flex: 10%\"></div></div><div class=campaigns-list__content><div class=campaigns-list__list><campaign-mini ng-repeat=\"campaign in advCtrl.campaigns | limitTo:3\" ng-if=\"advCtrl.campaigns.length > 0\" campaign=campaign></campaign-mini></div></div><div layout=row class=show-more-container ng-if=\"advCtrl.campaigns.length > 0\" layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" aria-label=\"show more\" ui-sref=all-campaigns>Show more campaigns</md-button></div></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/billing.html","<div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section><div class=add-card__section-title>Address</div><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.name>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/billingCybersource.html","<div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section><div class=add-card__section-title>Address</div><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.name>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/billingMidsource.html","<div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section><div class=add-card__section-title>Address</div><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.name>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/billingStripe.html","<div class=\"add-card__section add-card__section--row\"><div class=add-card__section-title>Card Location</div><div class=add-card__section-fields><div class=\"form-group form-group--radios\" ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading><md-radio-group ng-init=\"vm.creditCardOrigin = \'domestic\'\" ng-model=vm.creditCardOrigin layout=row ng-disabled=$root.isLoading ng-click=\"vm.state = \'\'\"><md-radio-button value=domestic>USA</md-radio-button><md-radio-button value=international>International</md-radio-button></md-radio-group></div></div></div><div class=add-card__section><div class=add-card__section-fields><div class=form-group-row><div class=form-group><label class=md-lbl-mask>First name</label><input placeholder=\"First name\" name=firstName ng-required=true ng-model=vm.firstName type=text ng-disabled=$root.isLoading class=form-control><div class=errors ng-messages=paymentForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Last name</label><input class=form-control placeholder=\"Last name\" name=lastName ng-required=true ng-model=vm.lastName type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.lastName.$error><div ng-message=required>This is required.</div></div></div></div></div></div><div class=add-card__section><div class=add-card__section-title>Address</div><div class=add-card__section-fields><div class=form-group><label class=md-lbl-mask>Billing Address 1</label><input class=form-control placeholder=\"Address line 1\" name=address ng-required=true ng-model=vm.address type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.address.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Billing Address 2</label><input class=form-control placeholder=\"Address line 2\" ng-model=vm.address2 type=text ng-disabled=$root.isLoading></div><div class=form-group ng-if=\"vm.creditCardOrigin === \'international\'\"><label>Country</label><md-select class=form-control name=country ng-required=true ng-model=vm.country ng-disabled=$root.isLoading><md-option ng-repeat=\"country in vm.countries\" ng-value=country.name>{{ country.name }}</md-option></md-select><div ng-messages=paymentForm.country.$error><div ng-message=required>This is required.</div></div></div><div class=form-group-row><div class=form-group><label class=md-lbl-mask>City</label><input class=form-control placeholder=City name=city ng-required=true ng-model=vm.city type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.city.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>State</label><input ng-if=\"vm.creditCardOrigin === \'international\'\" class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading> <input ng-if=\"vm.creditCardOrigin !== \'international\'\" maxlength=2 class=form-control placeholder=State name=state ng-required=true ng-model=vm.state type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.state.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label class=md-lbl-mask>Zip code</label><input class=form-control placeholder=\"Zip code\" name=zipCode ng-required=true ng-model=vm.zipCode type=text ng-disabled=$root.isLoading><div class=errors ng-messages=paymentForm.zipCode.$error><div ng-message=required>This is required.</div></div></div></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/creditCardInfo.html","<div class=add-card__section><div class=\"add-card__section-title add-card__section-title--double-margin\">Card Information</div><div class=add-card__section-fields><div class=form-group><input id=card-number ng-model=vm.ccNumber name=ccNumber class=form-control ng-required=!vm.edit() ng-credit-card-type=vm.ccType ng-focus=vm.toggleCreditCardMask() ng-blur=vm.toggleCreditCardMask() ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" ui-mask=\"{{ vm.ccNumberMask }}\" ui-mask-placeholder-char=\"\" type=text ng-disabled=\"$root.isLoading || vm.edit()\"><div class=errors ng-messages=paymentForm.ccNumber.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid credit card.</div><div ng-message=invalid>This credit card number is invalid.</div></div></div><div class=form-group-row><div class=form-group><md-input-container><label class=md-lbl-mask>Month</label><md-select class=form-control name=expDateMonth ng-model=vm.expDate.month ng-required=true ng-disabled=$root.isLoading ng-change=vm.checkExpirationDate()><md-option id=exp-date-month ng-value=opt ng-repeat=\"opt in vm.months\">{{ opt }}</md-option></md-select><div class=errors ng-messages=paymentForm.expDateMonth.$error><div ng-message=required>This is required.</div><div ng-message=past>The card is expired.</div></div></md-input-container></div><div class=form-group><md-input-container><label class=md-lbl-mask>Year</label><md-select class=form-control name=expDateYear ng-model=vm.expDate.year ng-required=true ng-disabled=$root.isLoading ng-change=vm.checkExpirationDate()><md-option id=exp-date-year ng-value=opt ng-repeat=\"opt in vm.years\">{{ opt }}</md-option></md-select><div ng-messages=paymentForm.expDateYear.$error><div ng-message=required>This is required.</div></div></md-input-container></div><div class=\"form-group form-group--cvv\"><label class=md-lbl-mask>CVV</label><input id=cvv name=cvv class=form-control ng-required=!vm.edit() ng-model=vm.cvvNumber ng-focus=vm.toggleCvvMask() ng-blur=vm.toggleCvvMask() ui-mask=\"{{ vm.cvvMask }}\" ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" ui-mask-placeholder-char=\"\" placeholder=CVV type=text ng-disabled=\"$root.isLoading || vm.edit()\"><div class=errors ng-messages=paymentForm.cvv.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid cvv</div></div></div><div class=hint><div class=hint__icon><a href=javascript:void(0) ng-click=vm.showInfo() ng-disabled=$root.isLoading><svg class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg></a></div><div class=hint__text>Lorem ipsum dolor sit amet.</div></div></div><div class=form-group><button class=\"btn btn-white btn-small btn-auto\" type=submit ng-disabled=\"paymentForm.$invalid || $root.isLoading\" ng-click=vm.submit()>Submit</button></div></div></div>");
$templateCache.put("app/pages/creditCards/partials/creditCardInfoCybersource.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><div id=number-container class=form-control></div></div></div><div layout=row layout-align=\"start start\" flex><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Exp Month</label><select id=expMonth class=form-control style=\"margin: 0px\" ng-disabled=$root.isLoading><option ng-value=opt ng-repeat=\"opt in vm.months\">{{ opt }}</option></select></div></div><div flex class=positioned-top flex=25><div class=form-group style=\"width: 100%; padding-right: 10px\"><label>Year</label><select id=expYear class=form-control style=\"margin: 0px\" ng-disabled=$root.isLoading><option ng-value=opt ng-repeat=\"opt in vm.years\">{{ opt }}</option></select></div></div><div class=\"md-block positioned-top\" flex><div class=form-group style=\"width: 100%\"><label>CVV</label><div id=securityCode-container ng-bind=securityCode class=form-control></div></div></div><md-button class=\"md-icon-button information\" ng-click=vm.showInfo() md-no-ink=true ng-disabled=$root.isLoading aria-label=info><md-icon>info</md-icon></md-button></div></md-card-content><div class=form-group><button class=\"btn btn-white btn-small btn-auto\" type=submit ng-disabled=\"paymentForm.$invalid || $root.isLoading\" ng-click=vm.submit()>Submit</button></div></md-card>");
$templateCache.put("app/pages/creditCards/partials/creditCardInfoMidsource.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><div id=midsource-ccnumber class=form-control style=\"padding: 10px; min-height: 40px\"><!-- Collect.js will mount the card number field here --></div></div></div><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 50%; margin-right: 10px\"><label>Expiration</label><div id=midsource-ccexp class=form-control style=\"padding: 10px; min-height: 40px\"><!-- Collect.js will mount the expiration field here --></div></div><div class=form-group style=\"width: 50%\"><label>CVV</label><div id=midsource-cvv class=form-control style=\"padding: 10px; min-height: 40px\"><!-- Collect.js will mount the CVV field here --></div></div></div><div id=midsource-card-errors role=alert style=\"color: #a94442; margin-top: 5px\"></div></md-card-content><div class=form-group><button id=midsource-payment-button class=\"btn btn-white btn-small btn-auto\" type=button ng-disabled=\"paymentForm.$invalid || $root.isLoading\" ng-click=vm.midsourceSubmit()>Submit</button></div></md-card>");
$templateCache.put("app/pages/creditCards/partials/creditCardInfoStripe.html","<md-card ng-if=!vm.selectedCard class=add-card__info><md-card-content><div layout=row layout-align=\"center start\"><div class=form-group style=\"width: 100%\"><label>Card number</label><div id=stripe-card-element class=form-control style=\"padding: 10px\"></div><div id=stripe-card-errors role=alert style=\"color: #a94442; margin-top: 5px\"></div></div></div></md-card-content><div class=form-group><button class=\"btn btn-white btn-small btn-auto\" type=submit ng-disabled=\"paymentForm.$invalid || $root.isLoading\" ng-click=vm.submit()>Submit</button></div></md-card>");
$templateCache.put("app/pages/landing/forgotPw/forgotPw.html","<div class=application><topnavext></topnavext><div class=signin-container layout=column flex layout-fill><div class=signin-form-container layout=column layout-align=\"start center\" flex><md-card layout=column layout-align=\"start center\" flex=90><img class=main-logo ng-src=assets/images/main_logo.svg><md-card-content flex><form name=forgotPwForm ng-submit=forgotPwForm.$valid flex><div class=form-group><label>Email</label><input class=form-control type=email name=email ng-model=forgotPwCtrl.email ng-disabled=$root.isLoading required md-autofocus ng-keydown=forgotPwCtrl.submitEnter($event)><div class=errors ng-messages=forgotPwForm.email.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=email>This email isn\'t valid.</div></div></div></form><div layout=column layout-align=\"center center\" class=actions><button class=\"btn btn-default\" ng-disabled=\"forgotPwForm.$invalid || !forgotPwForm.$dirty || $root.isLoading\" ng-click=forgotPwCtrl.submit()>Submit</button> <span class=\"opt-descriptions new-user-text\">New to Scalefluence? </span><span class=\"opt-descriptions footer\">Create your Scalefluence account <a target=\"\" ui-sref=sign-up class=\"md-accent links\">now!</a></span></div></md-card-content></md-card></div></div><div class=application__footer><div class=footer>&copy;ScaleFluence 2021</div></div></div>");
$templateCache.put("app/pages/landing/resetPw/resetPw.html","<div class=application><topnavext></topnavext><div class=signin-container layout=column flex layout-fill><div class=signin-form-container layout=column layout-align=\"start center\" flex><md-card layout=column layout-align=\"start center\" flex=90><img class=main-logo ng-src=assets/images/main_logo.svg><md-card-content flex><form name=resetPwForm ng-submit=resetPwForm.$valid flex><div class=form-group><label>Enter Password &nbsp;&nbsp;&nbsp;&nbsp;<span><i>(Min. 8 Characters)</i></span></label><input class=form-control type=password class=\"form-control ok-password\" ng-class=\"(resetPwCtrl.password.$dirty && resetPwCtrl.password.$invalid) ? \'error\' : \'\'\" name=password ng-required=true ng-model=resetPwCtrl.password ng-disabled=$root.isLoading ng-change=resetPwCtrl.checkStrength() ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() ng-blur=resetPwCtrl.displayCheckboxError()><div class=\"label password-count\" ng-class=\"{ \'label-success\': resetPwCtrl.password.length > 7, \'label-danger\': resetPwCtrl.password.length <= 7,\n                      \'label-empty\': resetPwCtrl.password.length === 0 }\" ng-cloak>{{ resetPwCtrl.password | passwordCount: 8 }}</div><div class=errors ng-messages=resetPwCtrl.password.$error><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div></div></div><div class=pass-strength layout=row layout-align=\"start center\" ng-show=resetPwCtrl.password flex><div class=strength-meter flex=100><div class=strength-meter-fill ng-model=resetPwCtrl.password password-strength=\"{{ resetPwCtrl.passEval }}\"></div></div></div><div class=form-group><label>Confirm Password</label><input class=form-control type=password name=passwordConfirmation ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() required ng-model=resetPwCtrl.passwordConfirmation maxlength=16 minlength=8 ng-change=resetPwCtrl.canChangePassword() ng-password-strength=resetPwCtrl.passwordConfirmation ng-blur=resetPwCtrl.displayCheckboxError() ng-disabled=$root.isLoading><div class=errors ng-messages=resetPwCtrl.passwordConfirmation.$error><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div layout=row layout-align=\"end center\" class=forgot-password-link><span class=opt-descriptions><a target=_blank class=\"md-accent links\">Forgot your password?</a></span></div></form><div layout=column layout-align=\"center center\" class=actions><button class=\"btn btn-default\" ng-disabled=\"resetPwForm.$invalid || !resetPwForm.$dirty || $root.isLoading\" ng-click=resetPwCtrl.submit()>Sign In</button> <span class=\"opt-descriptions new-user-text\">New to Scalefluence? </span><span class=\"opt-descriptions footer\">Create your Scalefluence account <a target=\"\" ui-sref=sign-up class=\"md-accent links\">now!</a></span></div></md-card-content></md-card></div></div><div class=application__footer><div class=footer>&copy;ScaleFluence 2021</div></div></div>");
$templateCache.put("app/pages/landing/signIn/signIn.html","<div class=application><topnavext></topnavext><div class=signin-container layout=column flex layout-fill><div class=signin-form-container layout=column layout-align=\"start center\" flex><md-card layout=column layout-align=\"start center\" flex=90><img class=main-logo ng-src=assets/images/main_logo.svg><md-card-content flex><!-- Google Sign in Button --><div id=g_id_onload></div><!-- End Google Sign in Button --><p>OR USE EMAIL</p><form name=signInForm ng-submit=signInForm.$valid flex><div class=form-group><label>Email</label><input class=form-control type=email name=email ng-model=signInCtrl.credentials.email ng-disabled=$root.isLoading required md-autofocus ng-keydown=signInCtrl.submitEnter($event)><div class=errors ng-messages=signInForm.email.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=email>This email isn\'t valid.</div></div></div><div class=form-group><label>Password</label><input type=password class=\"form-control ok-password\" ng-class=\"(signInForm.password.$dirty && signInForm.password.$invalid) ? \'error\' : \'\'\" name=password ng-required=true ng-model=signInCtrl.credentials.password ng-disabled=$root.isLoading ng-keydown=signInCtrl.submitEnter($event)><div class=errors ng-messages=signInForm.password.$error><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div></div></div><div layout=row layout-align=\"end center\" class=forgot-password-link><span class=opt-descriptions><a ui-sref=forgot-pw class=\"md-accent links\">Forgot your password?</a></span></div></form><div layout=column layout-align=\"center center\" class=actions><button class=\"btn btn-default\" ng-disabled=\"signInForm.$invalid || !signInForm.$dirty || $root.isLoading\" ng-click=signInCtrl.submit()>Sign In</button> <span class=\"opt-descriptions new-user-text\">New to Scalefluence? </span><span class=\"opt-descriptions footer\">Create your Scalefluence account <a target=\"\" ui-sref=sign-up class=\"md-accent links\">now!</a></span></div></md-card-content></md-card></div></div><div class=\"application__footer signin-footer\"><div class=footer><a href=https://www.scalefluence.com/influencers/ >Influencers</a></div><div class=footer><a href=https://www.scalefluence.com/agencies/ >Agencies</a></div><div class=footer><a href=https://www.scalefluence.com/brands/ >Brands</a></div><div class=footer style=\"font-weight: 700\">&copy;ScaleFluence 2021</div><div class=footer><a href=https://www.scalefluence.com/contact-us/ >Contact</a></div><div class=footer><a href=https://www.scalefluence.com/terms-of-use/ >User Terms</a></div><div class=footer><a href=https://www.scalefluence.com/privacy/ >Privacy</a></div></div><div ng-if=signInCtrl.showAdvConversion()><!-- Event snippet for Sign-up agencis / advertisers conversion page --><script>gtag(\'event\', \'conversion\', {\'send_to\': \'AW-530161570/S-SzCKPkv-UBEKK_5vwB\'});</script></div><div ng-if=signInCtrl.showPubConversion()><!-- Event snippet for Influencers Sign Up conversion page --><script>gtag(\'event\', \'conversion\', {\'send_to\': \'AW-530161570/8HtpCLCQ6-sBEKK_5vwB\'});</script></div></div>");
$templateCache.put("app/pages/landing/signUp/signUp.html","<div class=application><topnavext></topnavext><div class=signup-container layout=column><div class=signup-form-container layout=column layout-align=\"start center\" flex><md-card layout=column layout-align=\"start center\" flex><img class=main-logo ng-src=assets/images/main_logo.svg><div ng-if=signUpCtrl.noTypeSelected style=\"margin-top: 15px; margin-bottom: 15px\"><h3>A next generation marketplace for savvy influencers and brands to collaborate</h3><h4 ng-if=signUpCtrl.showSsoMsg() style=\"color: red; margin-top: 20px; text-align: center\">No account was found with the email {{ signUpCtrl.ssoEmail }}.<br><div style=\"margin: 10px\">EITHER</div><a href=#/ >Click this link to sign in</a> again using a different email.<br><div style=\"margin: 10px\">OR</div>Please select an account type below to sign up for a new account.</h4></div><div ng-if=signUpCtrl.noTypeSelected style=\"margin-left: auto; margin-right: auto; margin-bottom: 20px\" ng-include src=\"\'app/pages/landing/signUp/partials/chooseSignup.html\'\"></div><div ng-show=!signUpCtrl.noTypeSelected class=user-types-container style=\"padding-top: 1rem\" layout=row layout-align=\"space-between center\"><div ng-if=\"signUpCtrl.advertiser && !signUpCtrl.poptin\" layout=column style=\"margin-left: auto; margin-right: auto; margin-bottom: 20px\" ng-include src=\"\'app/pages/landing/signUp/partials/advSignup.html\'\"></div><div ng-if=\"signUpCtrl.advertiser && signUpCtrl.poptin\" layout=column style=\"margin-left: auto; margin-right: auto; margin-bottom: 20px\"><span class=advertiser-opt style=\"font-size: 2em; text-align: center\">Hey {{ signUpCtrl.poptinName }}!</span> <span class=opt-descriptions>Please take just a moment to finish registration!</span></div><div ng-if=\"signUpCtrl.publisher && !signUpCtrl.poptin\" layout=column style=\"margin-left: auto; margin-right: auto; margin-bottom: 20px\" ng-include src=\"\'app/pages/landing/signUp/partials/pubSignup.html\'\"></div><div ng-if=\"signUpCtrl.publisher && signUpCtrl.poptin\" layout=column style=\"margin-left: auto; margin-right: auto; margin-bottom: 20px\"><span class=publisher-opt style=\"font-size: 2em; text-align: center\">Hey {{ signUpCtrl.poptinName }}!</span> <span class=opt-descriptions>Please take just a moment to finish registration!</span></div><div style=\"display: none\" layout=column><md-checkbox ng-model=signUpCtrl.advertiser aria-label=Advertiser ng-click=\"signUpCtrl.toggleOption(\'adv\')\" ng-disabled=$root.isLoading><span class=advertiser-opt>Advertiser</span></md-checkbox><br><span class=opt-descriptions>Influencer Marketing +<br>Big Data at Scale</span></div><div style=\"display: none\" layout=column><md-checkbox ng-model=signUpCtrl.publisher aria-label=Influencer class=pub ng-click=\"signUpCtrl.toggleOption(\'pub\')\" ng-disabled=$root.isLoading><span class=publisher-opt>Influencer</span></md-checkbox><br><span class=opt-descriptions>Artisan Level Content +<br>No Hassle Payments</span></div></div><div style=\"display: none\"><p class=opt-descriptions ng-class=\"{ \'error\': signUpCtrl.noTypeSelected }\"><i>(select one or both)</i></p><br><br></div><md-card-content flex><p ng-show=!signUpCtrl.noTypeSelected>USE GOOGLE</p><!-- Google Sign in Button --><div ng-show=!signUpCtrl.noTypeSelected id=g_id_onload></div><!-- End Google Sign in Button --><p ng-show=!signUpCtrl.noTypeSelected>OR EMAIL</p><form ng-show=!signUpCtrl.noTypeSelected name=signUpForm ng-submit=signUpForm.$valid flex><div class=form-group><label>First name</label><input class=form-control name=firstName ng-required=true ng-model=signUpCtrl.user.first_name type=text ng-disabled=$root.isLoading ng-blur=signUpCtrl.displayCheckboxError()></div><div class=form-group><label>Last name</label><input class=form-control name=lastName ng-required=true ng-model=signUpCtrl.user.last_name type=text ng-disabled=$root.isLoading ng-blur=signUpCtrl.displayCheckboxError()></div><div class=form-group><label>Email</label><input class=form-control type=email name=email ng-model=signUpCtrl.user.email required ng-blur=signUpCtrl.checkEmail() ng-focus=signUpCtrl.updateAttempt() ng-pattern=/^[A-Za-z0-9_]+(\\.[A-Za-z0-9_]+)*@[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*(\\.[A-Za-z]{2,})$/ ng-copy=$event.preventDefault() ng-paste=$event.preventDefault()><div class=errors ng-messages=signUpForm.email.$error role=alert md-auto-hide=false><div ng-message-exp=\"[\'pattern\']\" ng-show=\"signUpForm.email.$error.pattern && signUpCtrl.attemptEmail\">Enter a valid email address</div><div ng-message=in-use>Email address is already in use. Please click Sign In at bottom.</div></div></div><div class=form-group><label>Confirm Email</label><input class=form-control type=email name=confirmEmail ng-model=signUpCtrl.user.confirm_email required ng-change=signUpCtrl.checkConfirmEmail() ng-pattern=/^[A-Za-z0-9_]+(\\.[A-Za-z0-9_]+)*@[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*(\\.[A-Za-z]{2,})$/ ng-copy=$event.preventDefault() ng-paste=$event.preventDefault()><div class=errors ng-messages=signUpForm.confirmEmail.$error role=alert md-auto-hide=false><div ng-message=no-match>Emails don\'t match</div></div><div class=success><div ng-if=\"signUpForm.confirmEmail.$dirty && signUpForm.confirmEmail.$valid\">Emails match</div></div></div><div class=form-group><label>Enter Password &nbsp;&nbsp;&nbsp;&nbsp;<span><i>(Min. 8 Characters)</i></span></label><input class=form-control type=password class=\"form-control ok-password\" ng-class=\"(signUpForm.password.$dirty && signUpForm.password.$invalid) ? \'error\' : \'\'\" name=password ng-required=true ng-model=signUpCtrl.password ng-disabled=$root.isLoading ng-change=signUpCtrl.checkStrength() ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() ng-blur=signUpCtrl.displayCheckboxError()><div class=\"label password-count\" ng-class=\"{ \'label-success\': signUpCtrl.password.length > 7, \'label-danger\': signUpCtrl.password.length <= 7,\n                      \'label-empty\': signUpCtrl.password.length === 0 }\" ng-cloak>{{ signUpCtrl.password | passwordCount: 8 }}</div><div class=errors ng-messages=signUpForm.password.$error><div ng-message=no-match>Passwords don\'t match</div></div></div><div class=pass-strength layout=row layout-align=\"start center\" ng-show=signUpCtrl.password flex><div class=strength-meter ng-show=signUpCtrl.password flex=100><div class=strength-meter-fill ng-model=signUpCtrl.password password-strength=\"{{ signUpCtrl.passEval }}\"></div></div></div><div class=form-group><label>Confirm Password</label><input class=form-control type=password name=confirmPassword ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() required ng-model=signUpCtrl.user.password_confirmation maxlength=16 minlength=8 ng-change=signUpCtrl.canChangePassword() ng-password-strength=signUpCtrl.user.password_confirmation ng-blur=signUpCtrl.displayCheckboxError() ng-disabled=$root.isLoading><div class=errors ng-messages=signUpForm.confirmPassword.$error><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div><div class=success><div ng-if=\"signUpForm.confirmPassword.$dirty && signUpForm.confirmPassword.$valid\">Passwords match</div></div></div></form><span ng-if=!signUpCtrl.noTypeSelected class=opt-descriptions>By clicking \"Get Going Already\" below, I have already read, accepted and agreed to <a href=https://www.scalefluence.com/terms-of-use/ target=_blank class=\"md-accent links\">Scalefluence user agreement</a></span></md-card-content><div ng-show=!signUpCtrl.noTypeSelected layout=row layout-align=\"end center\" class=actions><button class=\"btn btn-default\" ng-disabled=\"signUpForm.$invalid || !signUpForm.$dirty || $root.isLoading\" ng-click=signUpCtrl.submit($event)>Get Going Already!</button></div><span class=\"opt-descriptions footer\">Already have an account? <a target=\"\" ui-sref=sign-in class=\"md-accent links\">Sign In</a></span></md-card></div></div><div class=\"application__footer signin-footer\"><div class=footer><a href=https://www.scalefluence.com/influencers/ >Influencers</a></div><div class=footer><a href=https://www.scalefluence.com/agencies/ >Agencies</a></div><div class=footer><a href=https://www.scalefluence.com/brands/ >Brands</a></div><div class=footer style=\"font-weight: 700\">&copy;ScaleFluence 2021</div><div class=footer><a href=https://www.scalefluence.com/contact-us/ >Contact</a></div><div class=footer><a href=https://www.scalefluence.com/terms-of-use/ >User Terms</a></div><div class=footer><a href=https://www.scalefluence.com/privacy/ >Privacy</a></div></div></div>");
$templateCache.put("app/pages/faq/partials/faqAdv.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Frequently Asked Questions</h2><div class=\"content-section__small-text text-uppercase\">Popular Questions</div></div><div class=content-section__content><div class=faq><faq-site role=\"{{ faqCtrl.role }}\"></faq-site></div></div></div>");
$templateCache.put("app/pages/faq/partials/faqPub.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Frequently Asked Questions</h2><div class=\"content-section__small-text text-uppercase\">Popular Questions</div></div><div class=content-section__content><div class=faq><faq-site role=\"{{ faqCtrl.role }}\"></faq-site></div></div></div>");
$templateCache.put("app/pages/payouts/partials/details.html","<div ng-if=!payCtrl.hasItems()>No Payouts Found</div><md-table-container ng-if=payCtrl.hasItems()><table class=table md-table ng-model=payCtrl.items md-progress=promise><thead md-order=payCtrl.query.order md-head><tr md-row><th md-column md-order-by=date_paid><a class=\"btn btn-link\" href=javascript:void(0)><span>Date Paid</span></a></th><th md-column md-order-by=domain><a class=\"btn btn-link\" href=javascript:void(0)><span>Domain</span></a></th><th md-column md-order-by=live_url><a class=\"btn btn-link\" href=javascript:void(0)><span>Live URL</span></a></th><th md-column md-order-by=product><a class=\"btn btn-link\" href=javascript:void(0)><span>Product</span></a></th><th md-column md-order-by=email><a class=\"btn btn-link\" href=javascript:void(0)><span>Paid To</span></a></th><th md-column md-order-by=method><a class=\"btn btn-link\" href=javascript:void(0)><span>Method</span></a></th><th md-column md-order-by=amount><a class=\"btn btn-link\" href=javascript:void(0)><span>Amount</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in payCtrl.filtered = (payCtrl.items | filter: payCtrl.query.filter) |\n      orderBy: payCtrl.query.order |\n      limitTo: payCtrl.query.limit : (payCtrl.query.page -1) * payCtrl.query.limit\"><td md-cell>{{ item.date_paid | date:\'MM-dd-yyyy\' }}</td><td md-cell>{{ item.domain }}</td><td md-cell><a href={{item.live_url}} target=_blank>{{ item.live_url }}</a><md-tooltip md-delay=200 md-direction=top md-autohide=true>{{ item.live_url }}</md-tooltip></td><td md-cell>{{ item.product }}</td><td md-cell>{{ item.email }}</td><td md-cell>{{ item.method }}</td><td md-cell>{{ item.amount | currency }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=payCtrl.query.limit md-page=payCtrl.query.page md-total=\"{{ payCtrl.filtered.length }}\" md-page-select=true ng-if=payCtrl.hasItems()></md-table-pagination>");
$templateCache.put("app/pages/profiles/allProfiles/allProfiles.html","<div class=content-section><div class=content-section__header><h2 class=\"content-section__title with-searching\">All profiles</h2><div class=\"content-section__small-text with-searching\">{{ allProfCtrl.total_profiles }} profiles</div><div class=content-section__right><div class=\"profiles-list__create-button text-right\"><button class=\"btn btn-white btn-small\" ng-click=allProfCtrl.showCreateProfileModal()>Create new profile</button></div><div class=content-section__item><input class=\"small-search no-focus\" ng-model=allProfCtrl.query.filter ng-keypress=allProfCtrl.searchProfiles($event) placeholder=\"Search for profiles\"></div></div></div><div class=content-section__content><div class=profiles-list><div class=profiles-list__content><md-subheader ng-if=\"allProfCtrl.profiles.length === 0\" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No profiles to show</h2></md-subheader><div class=profiles-list__list dir-paginate=\"profile in allProfCtrl.profiles | itemsPerPage: allProfCtrl.perPage\" total-items=allProfCtrl.total_profiles><profile-mini profile=profile publisher=allProfCtrl.publisher></profile-mini></div><div class=profiles-list__pagination><dir-pagination-controls max-size=6 on-page-change=\"allProfCtrl.paginateProfiles(newPageNumber, oldPageNumber)\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/pages/profiles/createProfile/createProfileDialog.html","<div class=create-profile-card id=create-profile-card><!-- here’s the avatar --><div class=create-profile__photo><h3>HeadShot Photo</h3><image-selector class=create-profile-image show-blank-image=createProfCtrl.showBlankProfilePhoto image=createProfCtrl.profile.image></image-selector></div><form name=createProfCtrlForm><div class=create-profile__main-data__inputs><div class=\"form-group form-group--radios create-profile__types\"><label><span class=\"input-label-1 profile-type__header\">Click Photo Icon to add Head Shot /<br>Logo & Name Profile Below</span> <span class=error-message ng-if=createProfCtrl.showTypeError><br>Need to select one type of User</span></label><!--         <div class=\"profile-types\">\n          <div ng-click=\"createProfCtrl.setAsBlogger()\" class=\"profile-type form-check form-check-radio form-check-inline\">\n            <input tabindex=\"3\" ng-disabled=\"$root.isLoading\"\n                   ng-model=\"createProfCtrl.profile.profileType\"\n                   class=\"form-check-input\" name=\"profileType\"\n                   ng-value=\"createProfCtrl.blogger()\" type=\"radio\"><label\n            class=\"form-check-label\"><span>Bloggers &amp; Influencers</span></label>\n            <md-tooltip md-direction=\"bottom\" md-autohide=\"true\">\n              YOU OWN YOUR OWN BLOG  &amp; SOCIAL MEDIA\n            </md-tooltip>\n          </div>\n          <div ng-if=\"false\" ng-click=\"createProfCtrl.setAsInfluencer()\" class=\"profile-type form-check form-check-radio form-check-inline\">\n            <input tabindex=\"4\" ng-disabled=\"$root.isLoading\" ng-model=\"createProfCtrl.profile.profileType\"\n                   class=\"form-check-input\" name=\"profileType\" ng-value=\"createProfCtrl.influencer()\" type=\"radio\"><label\n            class=\"form-check-label\"><span>Social Influencer</span></label>\n            <md-tooltip md-direction=\"bottom\" md-autohide=\"true\">\n              You are only on social. No blog\n            </md-tooltip>\n          </div>\n          <div ng-click=\"createProfCtrl.setAsContributor()\" class=\"profile-type form-check form-check-radio form-check-inline\">\n            <input tabindex=\"6\" ng-disabled=\"$root.isLoading\" ng-model=\"createProfCtrl.profile.profileType\"\n                   class=\"form-check-input\" name=\"profileType\" ng-value=\"createProfCtrl.contributor()\" type=\"radio\"><label\n            class=\"form-check-label\"><span>Contributors</span></label>\n            <md-tooltip md-direction=\"bottom\" md-autohide=\"true\">\n              YOU CONTRIBUTE CONTENT ON ANOTHER SITE YOU DO NOT OWN\n            </md-tooltip>\n          </div>\n        </div> --><div ng-show=\"createProfCtrl.showBlankProfileData && !createProfCtrl.profile.profileType\" class=errors style=color:red>This is required</div></div><div class=\"form-group create-profile__name\" ng-class=\"{\'blank__user-data\': createProfCtrl.showFormErrors && !createProfCtrl.profile.name}\"><label>Name This Profile</label><input ng-model=createProfCtrl.profile.name ng-change=createProfCtrl.checkNewProfileName() name=name required tabindex=1 class=form-control ng-class=\"{\'blank__user-data\': createProfCtrl.showRepeatedNameError && !createProfCtrl.profile.name}\" type=text placeholder=\"Name your profile\"><div ng-show=createProfCtrl.showRepeatedNameError class=errors style=color:red>This name has already been used.</div><div ng-show=\"createProfCtrl.showBlankProfileData && !createProfCtrl.profile.name\" class=errors style=color:red>This is required</div></div></div></form><div class=\"create-profile-action content-section__right\"><button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=createProfCtrl.saveProfile(false) ng-disabled=$root.isLoading>Save</button> <button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=createProfCtrl.cancel()>Cancel</button></div></div>");
$templateCache.put("app/pages/profiles/createProfile/imageDialog.html","<md-dialog class=upload-photo-dialog><md-toolbar class=upload-photo-dialog-toolbar><h2 class=text-center>Upload a Photo!</h2></md-toolbar><md-dialog-content class=upload-photo-dialog-content layout=column layout-padding><p>Profiles with Photos receive far more work than those that don\'t!</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.cancel() ng-disabled=$root.isLoading>Ok Do it Now!</md-button><md-button class=md-accent ng-click=ctrl.hide() ng-disabled=$root.isLoading>No Thanks.</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/allProfilesV1/allProfilesV1.html","<div class=content-section><div class=content-section__header><h2 class=\"content-section__title with-searching\">All profiles</h2><div class=\"content-section__small-text with-searching\">{{ allProfCtrl.total_profiles }} profiles</div><div class=content-section__right><a class=\"btn btn-white btn-small with-searching\" ui-sref=new-profile>Create new profile</a><div class=content-section__item><input class=\"small-search no-focus\" ng-model=allProfCtrl.query.filter ng-keypress=allProfCtrl.searchProfiles($event) placeholder=\"Search for profiles\"></div></div></div><div class=content-section__content><div class=profiles-list><div class=profiles-list__content><md-subheader ng-if=\"allProfCtrl.profiles.length === 0\" class=md-no-sticky layout=row layout-align=\"center center\"><h2>No profiles to show</h2></md-subheader><div class=profiles-list__list dir-paginate=\"profile in allProfCtrl.profiles | itemsPerPage: allProfCtrl.perPage\" total-items=allProfCtrl.total_profiles><profile-mini profile=profile></profile-mini></div><div class=profiles-list__pagination><dir-pagination-controls max-size=6 on-page-change=\"allProfCtrl.paginateProfiles(newPageNumber, oldPageNumber)\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/pages/profiles/createProfileV1/createProfileV1Dialog.html","<div class=create-profile-card><!-- here’s the avatar --><div class=create-profile__photo><h3>HeadShot Photo</h3><image-selector class=create-profile-image show-blank-image=createProfCtrl.showBlankProfilePhoto image=createProfCtrl.profile.image></image-selector></div><form name=createProfCtrlForm><div class=create-profile__main-data__inputs><div class=\"form-group form-group--radios create-profile__types\"><label><span class=\"input-label-1 profile-type__header\">What Kind of User Are You?</span> <span class=error-message ng-if=createProfCtrl.showTypeError><br>Need to select one type of User</span></label><div class=profile-types><div ng-click=createProfCtrl.setAsBroker() class=\"profile-type form-check form-check-radio form-check-inline\"><input tabindex=2 ng-disabled=$root.isLoading ng-model=createProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=createProfCtrl.broker() type=radio><label class=form-check-label><span>Broker</span></label><md-tooltip md-direction=bottom md-autohide=true>You work with other blog owners</md-tooltip></div><div ng-click=createProfCtrl.setAsBlogger() class=\"profile-type form-check form-check-radio form-check-inline\"><input tabindex=3 ng-disabled=$root.isLoading ng-model=createProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=createProfCtrl.blogger() type=radio><label class=form-check-label><span>Blogger</span></label><md-tooltip md-direction=bottom md-autohide=true>You own a blog and social channels</md-tooltip></div><div ng-click=createProfCtrl.setAsInfluencer() class=\"profile-type form-check form-check-radio form-check-inline\"><input tabindex=4 ng-disabled=$root.isLoading ng-model=createProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=createProfCtrl.influencer() type=radio><label class=form-check-label><span>Social Influencer</span></label><md-tooltip md-direction=bottom md-autohide=true>You are only on social. No blog</md-tooltip></div><div ng-click=createProfCtrl.setAsContributor() class=\"profile-type form-check form-check-radio form-check-inline\"><input tabindex=6 ng-disabled=$root.isLoading ng-model=createProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=createProfCtrl.contributor() type=radio><label class=form-check-label><span>Contributor</span></label><md-tooltip md-direction=bottom md-autohide=true>You contribute content as an author.</md-tooltip></div></div><div ng-show=\"createProfCtrl.showBlankProfileData && !createProfCtrl.profile.profileType\" class=errors style=color:red>This is required</div></div><div class=\"form-group create-profile__name\" ng-class=\"{\'blank__user-data\': createProfCtrl.showFormErrors && !createProfCtrl.profile.name}\"><label>Name This Profile</label><input ng-model=createProfCtrl.profile.name ng-change=createProfCtrl.checkNewProfileName() name=name required tabindex=1 class=form-control ng-class=\"{\'blank__user-data\': createProfCtrl.showRepeatedNameError && !createProfCtrl.profile.name}\" type=text placeholder=\"Name your profile\"><div ng-show=createProfCtrl.showRepeatedNameError class=errors style=color:red>This name has already been used.</div><div ng-show=\"createProfCtrl.showBlankProfileData && !createProfCtrl.profile.name\" class=errors style=color:red>This is required</div></div></div></form><div class=\"create-profile-action content-section__right\"><button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=createProfCtrl.saveProfile(false) ng-disabled=$root.isLoading>Save</button> <button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=createProfCtrl.cancel()>Cancel</button></div></div>");
$templateCache.put("app/pages/profiles/createProfileV1/imageDialogV1.html","<md-dialog class=upload-photo-dialog><md-toolbar class=upload-photo-dialog-toolbar><h2 class=text-center>Upload a Photo!</h2></md-toolbar><md-dialog-content class=upload-photo-dialog-content layout=column layout-padding><p>Profiles with Photos receive far more work than those that don\'t!</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.cancel() ng-disabled=$root.isLoading>Ok Do it Now!</md-button><md-button class=md-accent ng-click=ctrl.hide() ng-disabled=$root.isLoading>No Thanks.</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfile/editProfile.html","<section class=profile-header><p>Profile: <span style=\"margin-left: 10px\"><img class=user-photo__mini-image src=\"{{editProfCtrl.profile.image || \'assets/images/no-image.png\' }}\" alt></span><span style=\"margin-left: 10px\">{{ editProfCtrl.profile.name }}</span> <span><md-icon ng-click=editProfCtrl.editProfileNameAndPhoto() style=\"font-size: 26px\">edit</md-icon></span></p></section><section class=profile-sections id=profile-sections ng-cloak><div class=profile-section id=btn-my-audience ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-audience\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">My Audience</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'audience\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{ \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') }\">{{editProfCtrl.isProfilePartCompleted(\'audience\') ? \'Done\' : \'Connect Now\'}}</p></div></div></div><div class=profile-section id=sponsored-blog-section ng-if=editProfCtrl.isBlogger() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-blog\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">Sponsored Blog Posts</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'blog\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n             \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n             \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'blog\')\n            }\">{{editProfCtrl.isProfilePartCompleted(\'blog\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>{{editProfCtrl.isProfilePartCompleted(\'audience\')}} Please complete audience first.</md-tooltip></div><div class=profile-section id=guest-post-section ng-if=!editProfCtrl.isInfluencer() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-guest-post\', false)\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">Guest Blog Post</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'guest-post\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n            \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n            \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'guest-post\')\n           }\">{{editProfCtrl.isProfilePartCompleted(\'guest-post\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>Please complete audience first.</md-tooltip></div><div class=profile-section id=facebook-section ng-if=!editProfCtrl.isContributor() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-facebook\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">Facebook</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'facebook\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n            \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n            \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'facebook\')\n           }\">{{editProfCtrl.isProfilePartCompleted(\'facebook\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>Please complete audience first.</md-tooltip></div><div class=profile-section ng-if=!editProfCtrl.isContributor() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-instagram\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">Instagram</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'instagram\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n            \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n            \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'instagram\')\n           }\">{{editProfCtrl.isProfilePartCompleted(\'instagram\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>Please complete audience first.</md-tooltip></div><div class=profile-section ng-if=!editProfCtrl.isContributor() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-twitter\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">Twitter</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'twitter\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n            \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n            \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'twitter\')\n           }\">{{editProfCtrl.isProfilePartCompleted(\'twitter\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>Please complete audience first.</md-tooltip></div><div class=profile-section ng-if=!editProfCtrl.isContributor() ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-youtube\')\"><div class=profile-section__content><p class=\"profile-section__title text--medium\">YouTube</p><div class=profile-section__info><p class=text--medium>{{editProfCtrl.isProfilePartCompleted(\'youtube\') ? \'Click to edit\' : \'Click to add\'}}</p><p class=\"profile-section__label text--medium\" ng-class=\"{\n            \'disabled\': !editProfCtrl.isProfilePartCompleted(\'audience\'),\n            \'done\': editProfCtrl.isProfilePartCompleted(\'audience\') && editProfCtrl.isProfilePartCompleted(\'youtube\')\n           }\">{{editProfCtrl.isProfilePartCompleted(\'youtube\') ? \'Done\' : \'Connect Now\'}}</p></div></div><md-tooltip ng-if=\"!editProfCtrl.isProfilePartCompleted(\'audience\')\" md-direction=bottom>Please complete audience first.</md-tooltip></div><!--  <div class=\"profile-section\" ng-if=\"!editProfCtrl.isContributor()\"--><!--       ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-pinterest\')\">--><!--    <div class=\"profile-section__content\">--><!--      <p class=\"profile-section__title text&#45;&#45;medium\">--><!--        Pinterest--><!--      </p>--><!--      <div class=\"profile-section__info\">--><!--        <p class=\"text&#45;&#45;medium\">{{editProfCtrl.isProfilePartCompleted(\'pinterest\') ? \'Click to edit\' : \'Click to--><!--          add\'}}</p>--><!--        <p class=\"profile-section__label text&#45;&#45;medium\"--><!--           ng-class=\"{ \'done\': editProfCtrl.isProfilePartCompleted(\'pinterest\') }\">--><!--          {{editProfCtrl.isProfilePartCompleted(\'pinterest\') ? \'Done\' : \'Connect Now\'}}--><!--        </p>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  <div class=\"profile-section\" ng-if=\"!editProfCtrl.isContributor()\"--><!--       ng-click=\"editProfCtrl.goEditProfileSection(\'edit-profile-twitch\')\">--><!--    <div class=\"profile-section__content\">--><!--      <p class=\"profile-section__title text&#45;&#45;medium\">--><!--        Twitch--><!--      </p>--><!--      <div class=\"profile-section__info\">--><!--        <p class=\"text&#45;&#45;medium\">{{editProfCtrl.isProfilePartCompleted(\'twitch\') ? \'Click to edit\' : \'Click to add\'}}</p>--><!--        <p class=\"profile-section__label text&#45;&#45;medium\"--><!--           ng-class=\"{ \'done\': editProfCtrl.isProfilePartCompleted(\'twitch\') }\">--><!--          {{editProfCtrl.isProfilePartCompleted(\'twitch\') ? \'Done\' : \'Connect Now\'}}--><!--        </p>--><!--      </div>--><!--    </div>--><!--  </div>--></section><div class=edit-content-section><div class=edit-content__btn-container><button class=\"lined thick\" ng-click=editProfCtrl.goToDashboard()>Dashboard</button></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editProfileDialog.html","<div class=create-profile-card><!-- here’s the avatar --><div class=create-profile__photo><h3>New HeadShot Photo</h3><image-selector class=create-profile-image show-blank-image=editProfCtrl.showBlankProfilePhoto image=editProfCtrl.profile.image></image-selector></div><form name=editProfCtrlForm><div class=create-profile__main-data__inputs><div class=\"form-group create-profile__name\" ng-class=\"{\'blank__user-data\': editProfCtrl.showFormErrors && !editProfCtrl.profile.name}\"><label>New Profile Name</label><input ng-model=editProfCtrl.profile.newName ng-change=editProfCtrl.checkNewProfileName() name=name required tabindex=1 class=form-control ng-class=\"{\'blank__user-data\': editProfCtrl.showRepeatedNameError && !editProfCtrl.profile.name}\" type=text placeholder=\"Name your profile\"><div ng-show=editProfCtrl.showRepeatedNameError class=errors style=color:red>This name has already been used.</div><div ng-show=\"editProfCtrl.showBlankProfileData && !editProfCtrl.profile.name\" class=errors style=color:red>This is required</div></div></div></form><div class=\"create-profile-action content-section__right\"><button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=editProfCtrl.saveProfileMainData() ng-disabled=\"$root.isLoading || (editProfCtrlForm.$invalid && !editProfCtrl.profile.image)\">Save</button> <button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editProfCtrl.cancel()>Cancel</button></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/editProfileV1.html","<div class=content-section><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white\" ui-sref=all-profiles><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span>Back</span></a></div><h2 class=content-section__title>Edit Profile</h2><div class=content-section__right></div></div><div class=content-section__content><div class=edit-profile><div class=edit-profile__section><!-- partial for avatar/name --><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/header.html\'\"></div></div><div class=edit-profile__section><h5 class=edit-profile__title>Categories</h5><!-- partial for categories --><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/categories.html\'\"></div></div><div class=edit-profile__section ng-if=editProfCtrl.isBlogger()><h5 class=edit-profile__title>Your profile description</h5><!-- partial for categories --><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/domainInformation.html\'\"></div></div><div class=edit-profile__section ng-if=\"editProfCtrl.isBroker() || editProfCtrl.isContributor()\"><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/broker&ContributorPartial.html\'\"></div></div><div class=edit-profile__section ng-if=\"editProfCtrl.isInfluencer() || editProfCtrl.isBlogger()\"><h5 class=edit-profile__title ng-if=editProfCtrl.isBlogger()>Blog & social media connections</h5><h5 class=edit-profile__title ng-if=editProfCtrl.isInfluencer()>Social media connections</h5><!-- partial for audience age --><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/socialContent.html\'\"></div></div><div class=edit-profile__section ng-if=\"editProfCtrl.isInfluencer() || editProfCtrl.isBlogger()\"><h5 class=edit-profile__title>Audience demographics</h5><!-- partial for categories --><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/audienceDemographics.html\'\"></div></div></div></div></div>");
$templateCache.put("app/pages/profiles/newProfile/newProfile.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Create a profile</h2><div class=\"content-section__small-text text-uppercase\">Step {{ newProfCtrl.selectedIndex + 1 }} : {{ newProfCtrl.getCurrentStepName() }}</div><div class=\"content-section__right d-none d-md-block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid || !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n              newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n              newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n              newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div></div><div class=content-section__content><div class=create-profile><div class=create-profile__content><div ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/navigation.html\'\"></div><div class=\"content-section__right d-flex d-md-none\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid ||\n                  !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div><div class=create-profile__inner><div ng-show=\"newProfCtrl.selectedIndex == 0\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/step1.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 1\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/step2.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 2\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/step3.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 3\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/step4.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 4\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/step5.html\'\"></div></div><div style=\"display: flex\"><div class=\"content-section__right d-flex d-md-block\" style=\"margin-top: 20px\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid ||\n                  !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/profiles/newProfileV1/newProfileV1.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Create a profile</h2><div class=\"content-section__small-text text-uppercase\">Step {{ newProfCtrl.selectedIndex + 1 }} : {{ newProfCtrl.getCurrentStepName() }}</div><div class=\"content-section__right d-none d-md-block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid || !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n              newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n              newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n              newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div></div><div class=content-section__content><div class=create-profile><div class=create-profile__content><div ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/navigation.html\'\"></div><div class=\"content-section__right d-flex d-md-none\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid ||\n                  !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n                  newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div><div class=create-profile__inner><div ng-show=\"newProfCtrl.selectedIndex == 0\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/step1.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 1\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/step2.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 2\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/step3.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 3\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/step4.html\'\"></div><div ng-show=\"newProfCtrl.selectedIndex == 4\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/step5.html\'\"></div></div><div style=\"display: flex\"><div class=\"content-section__right d-flex d-md-block\" style=\"margin-top: 20px\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=newProfCtrl.previous($event) ng-hide=\"newProfCtrl.selectedIndex < 1\">Previous</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.next($event) ng-disabled=socialsForm.$invalid ng-show=\"!newProfCtrl.lastStep() && newProfCtrl.selectedIndex!=3 || newProfCtrl.isBlogger()\n              && newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex == 3\" tabindex=50>Next</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=newProfCtrl.submit() ng-disabled=\"socialsForm.$invalid ||\n                  !newProfCtrl.url.description\" ng-if=newProfCtrl.lastStep()>{{ newProfCtrl.getFinishText() }}</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"newProfCtrl.setSocialIndex(newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">Skip</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"newProfCtrl.selectedSocialIndex == 0 && !newProfCtrl.profile.facebook_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 1 && !newProfCtrl.profile.instagram_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 2 && !newProfCtrl.profile.youtube_handle.url ||\n                    newProfCtrl.selectedSocialIndex == 3 && !newProfCtrl.profile.twitter_handle.url\" ng-click=\"newProfCtrl.setSocialTab($event, newProfCtrl.selectedSocialIndex + 1)\" ng-if=\"newProfCtrl.selectedIndex == 3 && newProfCtrl.selectedSocialIndex!=3\">{{ newProfCtrl.getNextSocialButtonText() }}</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/quotes/newQuote/newQuote.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Create New Quote</h2><div class=content-section__right><button type=button class=\"btn btn-default btn-auto\" ng-click=nQuoteCtrl.submit() ng-disabled=\"nQuoteCtrl.content.categories.length == 0 || nQuoteCtrl.content.campaign == null\">Create Quote Now</button></div></div><div class=content-section__content><div class=create-quote><div class=create-quote__content><div class=create-quote__select-campaign><form class=create-quote__select-campaign__form action=#><div class=form-group><label>Select a campaign</label><md-autocomplete flex style=\"width: 450px\" ng-required=true md-input-name=campaign md-selected-item=nQuoteCtrl.content.campaign md-search-text=nQuoteCtrl.searchTextCampaign md-items=\"campaign in nQuoteCtrl.querySearchCampaign(nQuoteCtrl.searchTextCampaign)\" md-item-text=campaign.name md-require-match md-no-cache=true md-min-length=0 md-floating-label=\"start typing\" md-selected-item-change=nQuoteCtrl.getCampaign()><md-item-template><span md-highlight-flags=^i md-highlight-text=nQuoteCtrl.searchTextCampaign>{{ campaign.name }}</span></md-item-template><div ng-messages=form.campaign.$error><div ng-message=md-require-match>Please select an existing campaign.</div><div ng-message=required>You must supply a campaign.</div></div></md-autocomplete></div><div class=\"form-group d-flex\"><label style=\"width: 180px\">Who is doing the Content?<div class=hint style=\"margin-top: -1px\"><div class=\"hint__icon md-icon-button info-icons\" ng-click=nQuoteCtrl.showAuthorContent()><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></div></div></label><div class=\"form-check form-check-radio form-check-inline\" style=\"width: 120px\" ng-click=nQuoteCtrl.setAuthorScalefluence()><input class=form-check-input type=radio value=scalefluence ng-model=nQuoteCtrl.contentAuthor><label class=form-check-label><span>Scalefluence</span></label></div><div class=\"form-check form-check-radio form-check-inline\" ng-click=nQuoteCtrl.setAuthorAgency()><input class=form-check-input type=radio value=agency ng-model=nQuoteCtrl.contentAuthor><label class=form-check-label><span>Agency</span></label></div><p class=error-message ng-show=nQuoteCtrl.showAuthorError>{{nQuoteCtrl.showAuthorErrorMessage()}}</p></div><div class=\"form-group d-flex\"><label style=\"width: 180px\">Include no-follow blogs?</label><div class=\"form-check form-check-radio form-check-inline\" style=\"width: 120px\" ng-click=nQuoteCtrl.setNoFollow(false)><input class=form-check-input type=radio ng-value=false ng-model=nQuoteCtrl.includeNoFollow><label class=form-check-label><span>No</span></label></div><div class=\"form-check form-check-radio form-check-inline\" ng-click=nQuoteCtrl.setNoFollow(true)><input class=form-check-input type=radio ng-value=true ng-model=nQuoteCtrl.includeNoFollow><label class=form-check-label><span>Yes</span></label></div><p class=error-message ng-show=nQuoteCtrl.showNofollowError>{{nQuoteCtrl.showNofollowErrorMessage()}}</p></div></form></div><div class=create-quote__categories><category-selector placeholder=\"Add additional categories\" ng-model=nQuoteCtrl.content.categories hide-categories=true></category-selector></div><div class=\"create-quote__show-control-btn d-block d-md-none\"><a class=\"btn btn-link\" href=#>Hide Categories</a></div><div class=create-quote__authority-parameters><h6 class=create-quote__authority-parameters__title>Authority Parameters<div class=hint style=\"margin-top: -5px\"><div class=\"hint__icon md-icon-button info-icons\" ng-click=nQuoteCtrl.displayRowGridPrice()><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></div></div></h6><div class=create-quote__authority-parameters__sliders><div class=create-quote__authority-parameters__slider><div class=range-slider><div class=range-slider__title><span>Moz DA&nbsp;</span><b>{{ nQuoteCtrl.content.minDA }}-{{ nQuoteCtrl.content.maxDA }}</b></div><div class=da-range-container><rzslider rz-slider-model=nQuoteCtrl.content.minDA rz-slider-high=nQuoteCtrl.content.maxDA rz-slider-options=nQuoteCtrl.da_range.options></rzslider></div></div></div><div class=create-quote__authority-parameters__slider><div class=range-slider><div class=range-slider__title><span>Ahrefs DR&nbsp;</span><b>{{ nQuoteCtrl.content.minDR }}-{{ nQuoteCtrl.content.maxDR }}</b></div><div class=tf-range-container><rzslider rz-slider-model=nQuoteCtrl.content.minDR rz-slider-high=nQuoteCtrl.content.maxDR rz-slider-options=nQuoteCtrl.dr_range.options></rzslider></div></div></div></div><!--          <div class=\"dr-range-slider create-quote__authority-parameters__slider\">--><!--            <div class=\"range-slider\">--><!--              <div class=\"range-slider__title\"><span>Domain Rating&nbsp;</span><b>{{ nQuoteCtrl.content.minDR }}-{{ nQuoteCtrl.content.maxDR }}</b></div>--><!--              <div class=\"dr-range-container\">--><!--                <rzslider rz-slider-model=\"nQuoteCtrl.content.minDR\"--><!--                          rz-slider-high=\"nQuoteCtrl.content.maxDR\"--><!--                          rz-slider-options=\"nQuoteCtrl.dr_range.options\">--><!--                </rzslider>--><!--              </div>--><!--            </div>--><!--          </div>--></div></div></div></div></div>");
$templateCache.put("app/pages/quotes/pending/quotesPending.html","<div class=view-quotes__tab-content__title>Please allow up to two business days</div><div class=view-quotes__tab-content__table><h2 ng-hide=qPenCtrl.initialized>Loading...</h2><h2 ng-hide=\"!qPenCtrl.initialized || qPenCtrl.contents.length > 0\">No quotes received</h2><div dir-paginate=\"quote in qPenCtrl.contents | itemsPerPage: qPenCtrl.perPage\" pagination-id=qPenCtrl.dirId><md-card class=accordion><div layout=column><md-button class=md-no-style layout=row layout-padding ng-click=qPenCtrl.toggleQuote(quote)><span flex=40>Quote for: {{ quote.campaign.name }}</span><div layout=row layout-align=\"end center\" flex=60><span flex=60>{{ qPenCtrl.getDoingContentText(quote) }}</span> <span flex=20>{{ quote.date | date:\'MM-dd-yyyy\' }}</span> <span flex=10><button class=btn type=button ng-click=\"qPenCtrl.deleteQuote(quote.id); $event.stopPropagation();\"><svg class=\"icon icon--trash\"><use xlink:href=assets/images/icons.svg#trash></use></svg></button></span></div></md-button><md-divider></md-divider><md-content ng-show=quote.show ng-init=qPenCtrl.hideQuote(quote)><div layout=row layout-padding layout-align=start><div layout=column layout-align=\"start start\"><md-subheader class=md-no-sticky><h5>Trust Flow</h5></md-subheader><h2 layout-padding>{{ quote.trust_flow_min }} - {{ quote.trust_flow_max }}</h2></div><div layout=column layout-align=\"start start\"><md-subheader class=md-no-sticky><h5>Domain Authority</h5></md-subheader><h2 layout-padding>{{ quote.domain_authority_min }} - {{ quote.domain_authority_max }}</h2></div><div layout=column layout-align=\"start start\"><md-subheader class=md-no-sticky><h5>Domain Rating</h5></md-subheader><h2 layout-padding>{{ quote.ahrefs_dr_min }} - {{ quote.ahrefs_dr_max }}</h2></div><div flex></div><div layout=column layout-align=\"start start\" flex=40><md-subheader class=md-no-sticky><h5>Categories</h5></md-subheader><md-chips class=rounded ng-model=quote.categories ng-attr-readonly=true><md-chip-template>{{$chip.name}}</md-chip-template></md-chips></div></div><md-divider></md-divider></md-content></div></md-card></div><dir-pagination-controls max-size=6 on-page-change=qPenCtrl.goTop() pagination-id=qPenCtrl.dirId></dir-pagination-controls></div>");
$templateCache.put("app/pages/quotes/quoteFor/quoteFor.html","<div class=quotes-for><div layout=row><md-subheader class=md-no-sticky><h2>Manage quotes</h2></md-subheader><div class=content-section__right><form class=search-widget><input class=form-control name=name type=text placeholder=\"Find specific blog...\" ng-model=quoteForCtrl.searchUrls.filter> <button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form></div></div><md-card><div layout=row layout-align=space-between layout-padding><div layout=row layout-padding layout-align=\"start center\"><div class=content-section__back><a class=\"btn btn-white\" ui-sref=quotes-main><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><!-- <md-button class=\"md-fab md-mini md-primary\" aria-label=\"back\" ui-sref=\"quotes-main\">\n        <md-tooltip md-delay=\"400\" md-direction=\"right\" md-autohide=\"true\">\n          Back to Quote List View\n        </md-tooltip>\n        <md-icon class=\"arrow-back\">arrow_back</md-icon>\n      </md-button> --><md-divider class=quotes-divider></md-divider><h2 class=campaign-name>Campaign: {{ quoteForCtrl.quote.campaign.name }}</h2><span></span> <button class=\"btn btn-white btn-small\" style=\"margin: 6px 8px\" ng-click=quoteForCtrl.downloadReport() aria-label=download>Download</button> <button class=\"btn btn-white btn-small\" style=\"margin: 6px 8px\" ng-click=quoteForCtrl.upload(quoteForCtrl.quote.campaign.name) aria-label=upload>Upload</button></div><div><button ng-class=\"{\'btn-orange\': !$root.isLoading && !quoteForCtrl.cannotSubmit(), \'btn-white\': $root.isLoading || quoteForCtrl.cannotSubmit()}\" class=\"btn btn-small\" ng-click=quoteForCtrl.submit() ng-disabled=\"$root.isLoading || quoteForCtrl.cannotSubmit()\" aria-label=SubmitToAuthors>{{ quoteForCtrl.buttonText }}</button></div></div><div class=accordion><div dir-paginate=\"url in quoteForCtrl.filteredUrls = (quoteForCtrl.shownUrls |\n        filter: quoteForCtrl.searchUrls.filter) | itemsPerPage: quoteForCtrl.perPage\"><md-tooltip ng-show=url.profile_deleted>Blogger no longer in our marketplace</md-tooltip><md-tooltip ng-show=\"url.publisher_not_active && !url.profile_deleted\">{{ quoteForCtrl.publisherNotActiveTooltip }}</md-tooltip><md-expansion-panel md-component-id=expansionPanelOne class=selectable-box ng-disabled=\"quoteForCtrl.quote.agency_content || url.profile_deleted || url.publisher_not_active\" ng-show=\"quoteForCtrl.urlNotPaused(url) || url.profile_deleted || url.publisher_not_active\"><md-expansion-panel-collapsed flex disable=true ng-class=\"{\'green-background\': quoteForCtrl.setGreenBackground(url), \'url-profile-deleted\': url.profile_deleted, \'publisher-not-active-quote\': url.publisher_not_active}\"><div layout=column flex layout-align=\"start strech\"><div layout-gt-md=row layout-align=\"start center\" flex><div layout=row layout-align=\"start center\" flex=45><md-checkbox name=string ng-checked=url.checked ng-disabled=\"url.profile_deleted || url.publisher_not_active\" ng-click=\"url.checked = !url.checked; quoteForCtrl.toggle(url)\" aria-label=string></md-checkbox><div layout=column><span class=title>Publisher</span> <span><a href=\"{{ url.href | link }}\" target=_blank ng-click=preventPanelClick($event)>{{ url.href }}</a></span> <span ng-if=\"false && url.showMessage\" class=error-message>Fill out the order before submitting</span></div></div><div class=warning-box><p ng-if=!url.follow_link class=\"text-danger font-weight-bold\">BLOG IS NO-FOLLOW</p><p ng-if=url.branded_link class=\"text-danger font-weight-bold\">ONLY BRAND ANCHOR ALLOWED</p><p ng-if=url.blog_post_only class=\"text-danger font-weight-bold\">ONLY BLOG POST LINK ALLOWED</p><p ng-if=url.sponsored_tag class=\"text-danger font-weight-bold\">SPONSORED TAG</p></div><div class=headers ng-class=\"{\'centered-headers\': quoteForCtrl.$mdMedia(\'gt-xs\')}\" layout=row layout-align=\"space-between center\" flex><div layout=column><md-tooltip>Domain Authority</md-tooltip><span class=title>DA</span> <span>{{ url.domain_authority }}</span></div><div layout=column><md-tooltip>Page Authority</md-tooltip><span class=title>PA</span> <span>{{ url.page_authority }}</span></div><div layout=column><md-tooltip>Trust Flow</md-tooltip><span class=title>TF</span> <span>{{ url.trust_flow }}</span></div><div layout=column><md-tooltip>Citation Flow</md-tooltip><span class=title>CF</span> <span>{{ url.citation_flow }}</span></div><div layout=column><md-tooltip>Domain Rating</md-tooltip><span class=title>DR</span> <span>{{ url.ahrefs_dr }}</span></div><div layout=column><md-tooltip>Ahrefs Traffic</md-tooltip><span class=title>Ahrefs Traffic</span> <span>{{ url.semrush_traffic ? url.semrush_traffic : \'--\' }}</span></div><div layout=column><span class=price>{{ url.shown_price | currency:\"$\":0 }}</span></div></div></div></div><md-expansion-panel-icon ng-hide=quoteForCtrl.quote.agency_content></md-expansion-panel-icon></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header ng-class=\"{\'green-background\': quoteForCtrl.setGreenBackground(url)}\" md-no-sticky ng-click=$panel.collapse()><div layout-gt-md=row layout-padding layout-align=\"start center\" flex><div layout=row layout-align=\"start center\" flex=45><md-checkbox name=string ng-checked=url.checked ng-disabled=\"url.profile_deleted || url.publisher_not_active\" ng-click=\"url.checked = !url.checked; quoteForCtrl.toggle(url)\" aria-label=string></md-checkbox><div layout=column><span class=title>Publisher</span> <span><a href=\"{{ url.href | link }}\" target=_blank ng-click=preventPanelClick($event)>{{ url.href }}</a></span></div></div><div class=warning-box><p ng-if=!url.follow_link class=\"text-danger font-weight-bold\">BLOG IS NO-FOLLOW</p><p ng-if=url.branded_link class=\"text-danger font-weight-bold\">ONLY BRAND ANCHOR ALLOWED</p><p ng-if=url.blog_post_only class=\"text-danger font-weight-bold\">ONLY BLOG POST LINK ALLOWED</p><p ng-if=url.sponsored_tag class=\"text-danger font-weight-bold\">SPONSORED TAG</p></div><div class=headers ng-class=\"{\'centered-headers\': quoteForCtrl.$mdMedia(\'gt-xs\')}\" layout=row layout-align=\"space-between center\" flex><div layout=column><md-tooltip>Domain Authority</md-tooltip><span class=title>DA</span> <span>{{ url.domain_authority }}</span></div><div layout=column><md-tooltip>Page Authority</md-tooltip><span class=title>PA</span> <span>{{ url.page_authority }}</span></div><div layout=column><md-tooltip>Trust Flow</md-tooltip><span class=title>TF</span> <span>{{ url.trust_flow }}</span></div><div layout=column><md-tooltip>Citation Flow</md-tooltip><span class=title>CF</span> <span>{{ url.citation_flow }}</span></div><div layout=column><md-tooltip>Ahrefs Traffic</md-tooltip><span class=title>Ahrefs Traffic</span> <span>{{ url.semrush_traffic ? url.semrush_traffic : \'--\' }}</span></div><div layout=column><span class=price>$ {{ url.shown_price }}</span></div></div></div><md-expansion-panel-icon ng-click=$panel.collapse() ng-hide=quoteForCtrl.quote.agency_content></md-expansion-panel-icon></md-expansion-panel-header><md-expansion-panel-content><div layout=column flex=95 class=quote-sub-form><span class=text-info>Please fill the information for your article</span><form name=form flex><div layout=column layout-gt-sm=row layout-align-gt-sm=\"center center\"><!-- <md-input-container class=\"md-block\" flex> --><div class=form-group flex><input name=domainUrl class=form-control type=text ng-model=url.quote.blog_post_title placeholder=\"Blog Topic / Title (not required)\" no-double-quotes></div><!-- </md-input-container> --> <span class=input-separation ng-if=\"quoteForCtrl.$mdMedia(\'gt-sm\')\"></span><!-- <md-input-container class=\"md-block\" flex> --><div class=form-group flex><div ng-if=url.blog_post_only style=\"font-weight: bold; color: #dd2c00\">This site only allows links to informative blog content.</div><input class=form-control url-input required name=url ng-model=url.quote.href placeholder=\"Target URL\" no-double-quotes><div class=errors ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><!-- </md-input-container> --></div><div layout=column layout-gt-sm=row layout-align-gt-sm=\"center center\"><!-- <md-input-container class=\"md-block\" flex> --><div class=form-group flex><md-tooltip md-direction=top md-delay=300>You can type out a specific anchor or use words like \"relevant phrase\" or \"natural\"</md-tooltip><input class=form-control name=linkText ng-model=url.quote.link_text placeholder=\"Anchor (specific anchor or use words like \'relevant phrase\' or \'natural\')\" type=text required no-double-quotes><div class=errors ng-messages=form.linkText.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div><!-- </md-input-container> --> <span class=input-separation ng-if=\"quoteForCtrl.$mdMedia(\'gt-sm\')\"></span><!-- <md-input-container class=\"md-block\" flex> --><div class=form-group flex><md-tooltip md-direction=top md-delay=300>Notes <i>(i.e. > get \"Atlanta near the anchor\" or \"leave space for CEO quote\")</i></md-tooltip><input class=form-control name=notes type=text ng-model=url.quote.notes no-double-quotes placeholder=\"Notes (i.e. > get \'Atlanta near the anchor\' or \'leave space for CEO quote\')\"></div></div></form><div layout=row layout-gt-sm=row layout-align-gt-sm=\"end center\"><button ng-disabled=!form.$valid class=\"btn btn-default\" ng-click=\"$panel.collapse(); quoteForCtrl.prepareForSubmit(url)\">DONE</button></div></div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel></div></div></md-card><dir-pagination-controls max-size=6 on-page-change=quoteForCtrl.goTop()></dir-pagination-controls></div>");
$templateCache.put("app/pages/quotes/quotesMain/quotesMain.html","<div class=content-section><div class=content-section__header><h2 class=content-section__title>Manage quotes</h2><div class=content-section__right><a class=\"btn btn-white btn-small btn-auto\" ng-disabled=$root.isLoading aria-label=\"new request\" ui-sref=new-quote>Create New Quote</a></div></div><div class=content-section__content><div class=view-quotes><ul class=view-quotes__tabs><li ng-class=\"{ \'active\': quotesMainCtrl.activeQuotesOn() }\"><a href=javascript:void(0) ng-click=\"quotesMainCtrl.setQuotesTab(\'activeQuotes\')\">READY TO ORDER&nbsp;({{ $root.quotesReady }})</a></li><li ng-class=\"{ \'active\': !quotesMainCtrl.activeQuotesOn() }\"><a href=javascript:void(0) ng-click=\"quotesMainCtrl.setQuotesTab(\'pendingQuotes\')\">PENDING REQUESTS&nbsp;({{ $root.quotesPending }})</a></li></ul><div class=view-quotes__contents><div class=view-quotes__tab-content ng-class=\"{ \'active\': quotesMainCtrl.activeQuotesOn() }\" ng-include src=\"\'app/pages/quotes/received/quotesReceived.html\'\" ng-controller=\"QuotesReceivedController as qRecCtrl\"></div><div class=view-quotes__tab-content ng-class=\"{ \'active\': !quotesMainCtrl.activeQuotesOn() }\" ng-include src=\"\'app/pages/quotes/pending/quotesPending.html\'\" ng-controller=\"QuotesPendingController as qPenCtrl\"></div></div></div></div></div>");
$templateCache.put("app/pages/quotes/received/quotesReceived.html","<div class=box><div class=view-quotes__tab-content__title>These Quotes are valid for 90 days</div><div class=search-box><input class=\"small-search no-focus\" ng-model=qRecCtrl.query.filter ng-keypress=\"$event.keyCode === 13 && qRecCtrl.searchQuotes()\" placeholder=\"Search Quotes\"></div></div><div class=\"view-quotes__tab-content__table quotes-received\"><h2 ng-hide=qRecCtrl.initialized>Loading...</h2><h2 ng-hide=\"!qRecCtrl.initialized || qRecCtrl.contents.length > 0\">No quotes received</h2><div dir-paginate=\"quote in qRecCtrl.contents | itemsPerPage: qRecCtrl.perPage\" pagination-id=qRecCtrl.dirId><md-card class=accordion ng-class=\"{\'new-quote\': quote.is_new}\" layout=row flex><md-button class=md-no-style style=\"width: 100%\" layout=row flex ng-click=qRecCtrl.showQuotesFrom(quote)><div flex=25>Campaign: {{ quote.campaign.name }}</div><div flex=25>{{ qRecCtrl.concatCategories(quote) }}<md-tooltip ng-show=qRecCtrl.showCatPopup(quote) md-direction=left>{{ qRecCtrl.allCategories(quote) }}</md-tooltip></div><div flex=15>DA: {{ quote.domain_authority_min }} - {{ quote.domain_authority_max }}</div><div flex=20>{{ qRecCtrl.getDoingContentText(quote) }}</div><div flex=15>{{ quote.date | date:\'MM-dd-yyyy\' }}</div></md-button></md-card></div><dir-pagination-controls max-size=6 on-page-change=qRecCtrl.goTop() pagination-id=qRecCtrl.dirId></dir-pagination-controls></div>");
$templateCache.put("app/pages/user/profile/profile.html","<div ng-if=profCtrl.isAdvertiser() ng-include=\"\'app/pages/user/profile/partials/advProfile.html\'\" class=content-section></div><div ng-if=!profCtrl.isAdvertiser() ng-include=\"\'app/pages/user/profile/partials/pubProfile.html\'\" class=content-section></div>");
$templateCache.put("app/components/cards/cartItem/partials/cartItem.html","<div flex layout=row layout-align=flex-start show-gt-sm hide-sm hide-xs><span class=url flex>{{ vm.getOrderUrl() }}<md-tooltip md-delay=400 md-direction=bottom md-autohide=true>{{ vm.getOrderUrl() }}</md-tooltip></span></div><div flex=10><span class=title layout=row layout-align=\"center center\">{{ vm.order.campaign.name }}</span></div><div class=card-value layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.domain_authority }}</span><h3>DA</h3></div><div class=card-value layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.trust_flow }}</span><h3>TF</h3></div><div class=card-value layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.citation_flow }}</span><h3>CF</h3></div><div class=\"card-value description-container\" layout=column layout-align=\"center start\" flex><p data-ng-bind=vm.order.url.description data-ellipsis></p></div><div layout=column layout-align=\"end center\" flex=15><span class=url-price>{{ vm.order.amount | currency:undefined:0 }}/post</span></div>");
$templateCache.put("app/components/cards/cartItem/partials/cartItemV2.html","<div flex layout=column layout-align=start show-gt-sm hide-sm hide-xs><div class=\"card-value p-0\" layout=column layout-align=center flex=5><span class=url flex>{{ vm.getOrderUrl() }}<md-tooltip ng-if=!vm.order.publisher_not_active md-delay=400 md-direction=bottom md-autohide=true>{{ vm.getOrderUrl() }}</md-tooltip></span></div><div><div class=\"card-value d-inline-block mt-4\" layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.domain_authority }}</span><h3>DA</h3></div><div class=\"card-value d-inline-block\" layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.trust_flow }}</span><h3>TF</h3></div><div class=\"card-value d-inline-block\" layout=column layout-align=\"center center\" flex=5><span>{{ vm.order.url.ahrefs_dr }}</span><h3>DR</h3></div></div></div><div flex=20><span class=title layout=row layout-align=\"\">{{ vm.order.campaign.name }}</span></div><div class=Order-detaiils><div class=\"card-value d-inline\" layout=column layout-align=\"center center\"><h3 class=d-inline style=\"margin-right: 10px\">Ordered</h3><span>{{ vm.order.ad.created_at | date: \'MMM d\'}}</span></div><div class=\"card-value d-inline\" layout=column layout-align=\"center center\"><h3 class=d-inline style=\"margin-right: 10px\">Moved To Cart</h3><span>{{ vm.order.created_at | date: \'MMM d\' }}</span></div><div class=\"card-value d-inline\" layout=column layout-align=\"center center\"><h3 class=d-inline style=\"margin-right: 10px\">By</h3><span>{{ vm.formatByName(vm.order) }}</span></div><div layout=column layout-align=\"end center\" class=\"d-inline float-right pr-5\"><span class=url-price>{{ vm.order.amount | currency:undefined:0 }}/post</span></div><div class=\"md-actions blog-title-box\" layout=row layout-align=\"\"><div class=blog-titlez><div layout=row><h3 class=bold-title style=\"width: 60px\">URL:</h3><span class=title title={{vm.order.link.href}}>{{ vm.order.link.href | limitTo: 60 }}{{vm.order.link.href.length > 60 ? \'...\' : \'\'}}</span></div><div layout=row><h3 class=bold-title style=\"width: 60px\">Anchor:</h3><span class=title title={{vm.order.ad.link_text}}>{{ vm.order.ad.link_text | limitTo: 60 }}{{vm.order.ad.link_text.length > 60 ? \'...\' : \'\'}}</span></div></div><div layout=row layout-align=\"end center\"><p class=error-message ng-show=vm.order.showMessageError>Please upload content for this publisher before checking out</p><md-button class=\"btn btn-white btn-small\" ng-click=vm.blogPostDialog($event) ng-disabled=vm.order.publisher_not_active flex-order-xs=2>{{ vm.getBlogPostStatus() }}</md-button></div></div></div>");
$templateCache.put("app/components/cards/cartItem/modals/notCheckoutReady.html","<md-dialog class=download-content-dialog><md-toolbar class=\"toolbar toolbar-red\"><div class=md-toolbar-tools><h2>YOU NEED TO FINSIH EDITING THIS AD SPOT BEFORE PURCHASING</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div style=padding:20px>Reasons that this ad spot is not ready may include:<ul><li>Not saving Title</li><li>Not saving Destination URL</li><li>Not saving Anchor of the Link</li><li>Not uploading the Article for the Order</li></ul></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"center center\"><button class=\"btn btn-small btn-white text-uppercase\" class=md-accent ng-click=crtItmCtrl.close()>OK, UNDERSTOOD</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/campaigns/editCampaign/newUrlModal/newUrlModal.html","<md-dialog class=edit-dialog-container><md-toolbar><div class=md-toolbar-tools><h2>{{newUrlCtrl.title}}</h2></div></md-toolbar><md-dialog-content layout=column><form name=form layout-padding><div layout=column><!-- <md-input-container class=\"domain-hint md-block\"> --><form class=form-group><label>URL</label><input class=form-control url-input required name=url ng-model=newUrlCtrl.url.href ng-disabled=$root.isLoading placeholder=http://www.awesome.site.com> <span class=error-message ng-if=newUrlCtrl.showMinValues>Minimum MOZ Domain Authority is 15 and Majestic Trust Flow is 10</span><div class=errors2 ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></form><!-- </md-input-container> --></div></form><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=newUrlCtrl.cancel() ng-disabled=\" $root.isLoading\">Cancel</md-button><md-button class=md-accent ng-click=newUrlCtrl.submit() ng-disabled=\"newUrlCtrl.showMinValues || form.$invalid || $root.isLoading\">Save</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/pages/articles/done/partials/instructions.html","<md-dialog class=instructions-dialog><md-toolbar><div class=md-toolbar-tools><h2>Instructions</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div class=content-instructions><p><b>Actions Links Located on Right Hand Side</b></p><ul><li><p>Approve of content? <span class=\"align-bullets-main first\">=</span> <span class=instructions-main-words>View</span> content then move to checkout & purchase</p></li><li><p>Make minor changes <span class=\"align-bullets-main second\">=</span> <span class=instructions-main-words>Download </span>Word doc, edit locally, save & <span class=instructions-main-words>Upload</span></p></li><li><p>Need major changes	<span class=\"align-bullets-main third\">=</span> <span class=instructions-main-words>Rewrite</span>, then be specific with changes needed</p></li></ul></div><div class=\"content-instructions rows-container\"><p><b>Color Codes for Each Row</b></p><ul><li>White = Content is Being Worked On by Our Team</li><br><li>Light Green = Content is Ready for Review & Checkout</li><br><li>Dark Green = You have uploaded new content for the order</li><br><li>Yellow = Rewrite has been completed and approved by our editors.</li><br><li>Pink <span class=aligned-row-bullets>= Content is Being Rewritten per Your Request</span></li></ul></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=aDoneCtrl.ok()>Got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/articles/done/partials/notes.html","<md-dialog class=admin-notes-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{ noteCtrl.title() }}</h2></div></md-toolbar><md-dialog-content class=full-content layout=column layout-padding ng-if=!noteCtrl.addNotes><div ng-repeat=\"note in noteCtrl.notes\" class=no-spacing><p class=\"notes-content {{ note.creator | lowercase }}\">{{ note.creator | capitalize }}: <span>{{ note.note }} </span>- <span>{{ note.created_at | date: \'medium\' }}</span></p></div></md-dialog-content><md-dialog-content layout=column layout-padding ng-if=noteCtrl.addNotes><form name=form><md-input-container class=\"notes-hint md-block\"><label>Write notes to Author</label><textarea ng-trim=true ng-model=noteCtrl.noteAdv rows=2 md-select-on-focus name=noteAdv>\n        </textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=noteCtrl.ok() ng-disabled=\"form.$invalid || $root.isLoading\" ng-if=noteCtrl.addNotes>Submit</md-button><md-button class=md-accent ng-click=noteCtrl.cancel() ng-disabled=\"form.$invalid || $root.isLoading\">{{ noteCtrl.buttonText() }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/campaigns/editCampaign/partials/categories.html","<category-selector flex placeholder=\"Search Categories\" ng-model=editCampCtrl.categories on-change=editCampCtrl.categoriesChanged() hide-categories=!showCategories has-changed=editCampCtrl.hasChanged></category-selector><div ng-if=editCampCtrl.hasChanged layout=row layout-align=\"end center\" flex><md-button class=\"btn btn-default btn-small\" ng-click=editCampCtrl.saveCategories() ng-disabled=!editCampCtrl.categories.length ng-disabled=$root.isLoading>Save categories</md-button></div>");
$templateCache.put("app/pages/campaigns/editCampaign/partials/header.html","<div class=edit-campaign__main-data__photo><image-selector image=editCampCtrl.campaign.image edit=true ng-disabled=$root.isLoading></image-selector></div><form class=edit-campaign__main-data__form name=form><div class=edit-campaign__main-data__inputs><div class=form-group><div layout=row layout-align=\"end start\" ng-if=\"editCampCtrl.teammates.length >= 1\"><div flex></div><div flex=33 class=manager-select-container><md-input-container class=\"md-block manager-select\"><label>Campaign Managers</label><md-select ng-model=editCampCtrl.managers multiple=multiple placeholder=\"Select Managers\" ng-if=\"editCampCtrl.teammates.length >= 1\"><md-select-header class=manager-select-header><span class=select-header>Select Campaign Managers</span></md-select-header><md-option ng-value=teammate ng-repeat=\"teammate in editCampCtrl.teammates\">{{teammate.email}}</md-option></md-select></md-input-container></div></div><md-input-container class=md-block><label>Campaign name</label><input class=form-control type=text ng-model=editCampCtrl.campaign.name name=name required unique-on=editCampCtrl.campaignNames><div class=errors ng-messages=form.name.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div></md-input-container><div layout=row layout-align=\"end center\" flex ng-if=form.$dirty><md-button class=\"btn btn-default btn-small\" ng-click=editCampCtrl.saveHeaderChanges(form) ng-disabled=$root.isLoading>Save changes</md-button></div></div></div></form>");
$templateCache.put("app/pages/campaigns/editCampaign/partials/urls.html","<div class=edit-campaign__section-header><h5 class=edit-campaign__section-title>URLS &amp; ORDERS</h5><div ng-if=false class=edit-campaign__section-buttons><a class=\"btn btn-white btn-auto btn-small\" ng-click=editCampCtrl.addDomain() href=javascript:void(0)>Add 1 url</a> <a class=\"btn btn-white btn-auto btn-small\" href=javascript:void(0) ng-click=editCampCtrl.showCsvDialog()>Add Bulk URLs</a></div></div><div class=edit-campaign__section-content><div class=\"edit-campaign__table d-none d-md-block\"><table class=table><tr><th><span>Domain URL</span></th><th><span>Links Built to this Page</span></th></tr><tr dir-paginate=\"link in editCampCtrl.links | itemsPerPage: editCampCtrl.perPage\" current-page=editCampCtrl.currentPage total-items=editCampCtrl.totalItems><td colspan=2><div class=campaign-links ng-class=\"{\'campaign-links--active\': link.isOpen}\"><div class=campaign-links__header><div class=campaign-links__header-url>{{ link.href }}</div><div class=campaign-links__header-counter>{{ link.qty_active_ads }}</div><div class=campaign-links__header-button><button class=btn type=button ng-click=editCampCtrl.deleteLink(link) ng-if=\"link.qty_active_ads === 0\"><svg class=\"icon icon--trash\"><use xlink:href=assets/images/icons.svg#trash></use></svg></button> <button class=btn type=button ng-if=\"link.qty_active_ads > 0\" ng-click=editCampCtrl.togglePanel(link)><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=campaign-links__table><table class=table><tr><th><span><b>Pub URL</b></span></th><th><span>Live Blog Post</span></th><th><span>Anchor Text</span></th><th><span>DA</span></th><th><span>TF</span></th><th><span>Price</span></th></tr><tr ng-repeat=\"linkUrl in link.orders_built\"><td>{{ linkUrl.href }}</td><td ng-if=editCampCtrl.showLiveLink(linkUrl) ng-class=\"{ strike: linkUrl.state === \'rejected\' }\"><span class=live-link><a href=\"{{ editCampCtrl.addHttpIfMissing(linkUrl.full_pub_url) }}\" target=_blank>click here</a></span></td><td ng-if=!editCampCtrl.showLiveLink(linkUrl)>not live yet</td><td ng-class=\"{ strike: linkUrl.state === \'rejected\' }\">{{ linkUrl.anchor }}</td><td ng-class=\"{ strike: linkUrl.state === \'rejected\' }\">{{ linkUrl.domain_authority }}</td><td ng-class=\"{ strike: linkUrl.state === \'rejected\' }\">{{ linkUrl.trust_flow }}</td><td ng-class=\"{ strike: linkUrl.state === \'rejected\' }\">{{ linkUrl.shown_price | currency:undefined:0 }}</td></tr></table></div></div></td></tr></table></div><div class=\"edit-campaign__table d-block d-md-none\"><div class=campaign-links ng-class=\"{\'campaign-links--active\': link.isOpen}\" dir-paginate=\"link in editCampCtrl.links | itemsPerPage: editCampCtrl.perPage\" current-page=editCampCtrl.currentPage total-items=editCampCtrl.totalItems><div class=campaign-links__header><div class=campaign-links__header-url>{{ link.href }}</div><div class=campaign-links__header-counter>{{ link.urls.length }}</div><div class=campaign-links__header-button><button class=btn type=button ng-click=editCampCtrl.deleteLink(link) ng-if=\"link.urls.length === 0\"><svg class=\"icon icon--trash\"><use xlink:href=assets/images/icons.svg#trash></use></svg></button> <button class=btn type=button ng-if=\"link.urls.length > 0\" ng-click=editCampCtrl.togglePanel(link)><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg></button></div></div><div class=campaign-links__table ng-if=\"link.urls.length > 0\"><table ng-repeat=\"linkUrl in link.orders_built\"><tr><th>Live Blog Post</th><td><span class=live-link ng-if=editCampCtrl.linkNotRefounded(linkUrl.full_pub_url)><a href=\"{{ linkUrl.full_pub_url }}\" target=_blank>{{ linkUrl.full_pub_url }} </a></span><span ng-if=!editCampCtrl.linkNotRefounded(linkUrl.full_pub_url)>{{ linkUrl.full_pub_url }}</span></td></tr><tr><th>Anchor Text</th><td>{{ linkUrl.anchor }}</td></tr><tr><th>DA</th><td>{{ linkUrl.domain_authority }}</td></tr><tr><th>TF</th><td>{{ linkUrl.trust_flow }}</td></tr><tr><th>Price</th><td>{{ linkUrl.shown_price | currency:undefined:0 }}</td></tr></table></div></div></div><div class=\"profiles-list__pagination margin-top-5\"><dir-pagination-controls max-size=10 on-page-change=editCampCtrl.retrieveMoreLinks(editCampCtrl.currentPage)></dir-pagination-controls></div></div>");
$templateCache.put("app/pages/campaigns/editCampaign/urlsUpload/urlUpload.html","<div class=dialog-container layout-align=\"center center\"><md-dialog><md-dialog-content><md-toolbar><div class=md-toolbar-tools><h2>Upload Spreadsheet file</h2></div></md-toolbar><div layout-padding><div class=md-dialog-content layout-padding><p>Download the <a class=md-primary ng-href=\"{{ urlUploadCtrl.getFileRoute() }}\" ng-click=urlUploadCtrl.download()>example file</a>.</p><p>Download the file first. Copy paste all the URLs into Column A with http(s)://</p><p>Save your changes and upload with the button below.</p></div><md-card-content class=selected-file ng-show=urlUploadCtrl.csv flex layout=row layout-align=\"center center\"><md-input-container class=normal-input flex><label>Selected spreadsheet file</label><input name=csv class=highlighted disabled=disabled ng-model=urlUploadCtrl.csv.name></md-input-container><md-button class=md-accent ng-if=urlUploadCtrl.csv ng-click=urlUploadCtrl.clearCsv()>Remove</md-button></md-card-content></div><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" type=file ngf-select class=md-accent ng-model=urlUploadCtrl.csv name=csv ngf-accept=\"\'.xlsx, .csv\'\" ng-disabled=!$root.sampleSpreadsheet>Select file</md-button><md-button class=\"btn btn-white btn-small\" ng-click=urlUploadCtrl.submit() ng-disabled=!$root.sampleSpreadsheet>Upload</md-button></md-dialog-actions></md-dialog></div>");
$templateCache.put("app/pages/landing/signUp/partials/advSignup.html","<span class=advertiser-opt style=\"font-size: 2em; text-align: center\">Agencies &amp; Brands</span> <span class=opt-descriptions>Data Driven Influencer Marketing Platform</span>");
$templateCache.put("app/pages/landing/signUp/partials/chooseSignup.html","<div class=account-sel-container><a href=\"/#/signUp?accountType=influencer\" class=\"account-sel account-sel-pub\"><span class=publisher-opt style=\"font-size: 2em; text-align: center\">Bloggers<br>&amp; Influencers</span> <span class=opt-descriptions>Artisan Level Content<br>No Hassle Payments</span> </a><a href=\"/#/signUp?accountType=agency\" class=\"account-sel account-sel-adv\"><span class=advertiser-opt style=\"font-size: 2em; text-align: center\">Agencies<br>&amp; Brands</span> <span class=opt-descriptions>Data Driven Influencer Marketing Platform</span></a></div>");
$templateCache.put("app/pages/landing/signUp/partials/pubPoptinHeader.html","<span class=publisher-opt style=\"font-size: 2em; text-align: center\">Influencers</span> <span class=opt-descriptions>Artisan Level Content<br>No Hassle Payments</span>");
$templateCache.put("app/pages/landing/signUp/partials/pubSignup.html","<span class=publisher-opt style=\"font-size: 2em; text-align: center\">Bloggers &amp; Influencers</span> <span class=opt-descriptions>Artisan Level Content<br>No Hassle Payments</span>");
$templateCache.put("app/pages/profiles/editProfile/csvModal/csvModal.html","<div class=dialog-container layout-align=\"center center\"><md-dialog><md-dialog-content><md-toolbar flex><div class=md-toolbar-tools><h2>Upload Spreadsheet</h2></div></md-toolbar><div layout-padding flex><div class=md-dialog-content><p>PLEASE REVIEW THIS EXAMPLE BEFORE UPLOADING</p><p>*Note: Any URLs that already exist within Scalefluence will automatically be ignored.</p></div><div class=upload-modal><table class=csv-modal><tr><th>URL</th><th ng-if=csvModalCtrl.isContributor>Author Page</th><th ng-if=csvModalCtrl.isContributor>Describe what you write about</th><th>Do Follow Links?</th><th>Alow Home or Service Page Links?</th><th>750-1000 words?</th><th>1000-1250 words?</th><th>1250-1500 words?</th><th>1500+ words?</th><th>Best Price</th></tr><tbody><tr><td>https://HealthWebSite.com</td><td ng-if=csvModalCtrl.isContributor>https://HealthWebSite.com<br>/author/Jane-Doe</td><td class=wrap-description ng-if=csvModalCtrl.isContributor>I am one of the most popular authors on this site.</td><td>Yes</td><td>No</td><td>&times</td><td>&nbsp</td><td>&nbsp</td><td>&nbsp</td><td>{{ csvModalCtrl.getPrice() }}</td></tr></tbody></table></div><md-card-content class=selected-file ng-show=csvModalCtrl.csv flex layout=row layout-align=\"center center\"><md-input-container class=normal-input flex><label>Selected csv file</label><input name=csv class=highlighted disabled=disabled ng-model=csvModalCtrl.csv.name></md-input-container><md-button class=md-accent ng-if=csvModalCtrl.csv ng-click=csvModalCtrl.clearCsv()>Remove</md-button></md-card-content></div><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><a class=\"btn btn-white btn-small\" ng-href={{csvModalCtrl.getFileRoute()}} ng-click=csvModalCtrl.download()>Download Sample File</a><md-button class=\"btn btn-white btn-small\" type=file ngf-select class=md-accent ng-model=csvModalCtrl.csv name=csv ngf-accept=\"\'.xlsx, .csv\'\" ng-disabled=!$root.sampleDownloaded>Select file</md-button><md-button class=\"btn btn-white btn-small\" ng-click=csvModalCtrl.submit() ng-disabled=!$root.sampleDownloaded>Upload</md-button></md-dialog-actions></md-dialog></div>");
$templateCache.put("app/pages/profiles/editProfile/editAudience/audienceData.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span><a href=javascript:void(0) ng-click=\"editAudienceCtrl.goEditProfile(\'audience\', true)\">{{ editAudienceCtrl.profile.name }}</a></span></p></section><section><div class=edit-profile__categories id=categories-data><category-selector edit-profile-wizard-mode=true placeholder=Search/Select ng-model=editAudienceCtrl.categories hide-categories=!editAudienceCtrl.categoriesOn text-to-show=\"Select categories for this domain\" highlight-blank-audience-fields=editAudienceCtrl.showFormErrors has-changed=editAudienceCtrl.hasChangedCategories on-change=editAudienceCtrl.categoriesChanged() flex></category-selector></div><div class=\"create-profile__show-control-btn d-block d-md-none\"><a class=\"btn btn-link\" href=javascript:void(0) ng-click=editAudienceCtrl.toggleCategories()>{{ editAudienceCtrl.categoriesActionMsg() }}</a></div><div class=edit-profile__audience-data id=audience-data><div class=audience-data__block><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceIncomeAndGender.html\'\"></div></div><div class=audience-data__block><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceEthnicity.html\'\"></div></div><div class=audience-data__block><div ng-include=\"\'app/pages/profiles/editProfile/partials/language.html\'\"></div></div><div class=audience-data__block><div ng-include=\"\'app/pages/profiles/editProfile/partials/pets.html\'\"></div></div><div class=audience-data__block><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceAge.html\'\"></div></div></div></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=\"editAudienceCtrl.goEditProfile(\'audience\', true)\">Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=editAudienceCtrl.saveAudienceChanges($event) ng-disabled=$root.isLoading>Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editGuestPost/addGuestPost.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span>{{ editGPCtrl.profile.name }}</span></p></section><section><form class=create-profile__seo name=form ng-submit=form.$valid><div class=create-profile__seo__text>This page is all about guest posts. This is NOT advertorial content endorsing a product or service. It does not need to be disclosed.</div><div class=create-profile__seo__input style=\"padding-top: 0\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Domain</span></label><input name=url ng-model=editGPCtrl.url.href ng-class=\"{\'blank__user-data\': editGPCtrl.showFormErrors && !editGPCtrl.url.href}\" ng-blur=editGPCtrl.checkUrlV2(form) ng-disabled=\"editGPCtrl.url.href && editGPCtrl.url.addedFromGoogle\" tabindex=2 class=\"form-control url-input\" type=text required placeholder=https://MyWebsiteURL.com><div ng-show=editGPCtrl.showFormErrors ng-messages=form.url.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div><div ng-message=url>This URL could not be confirmed as a valid URL. Please double check it. Please email admin@scalefluence.com if you would like to discuss.</div><div ng-message=active>Sorry, this URL has already been {{editGPCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=duplicate>This URL has already been submitted before and cannot be accepted. Please email admin@scalefluence.com if you would like to discuss.</div><div ng-message=unmatched>Someone has already submitted this site for significantly less. Please email admin@scalefluence.com if you would like to discuss.</div></div></div><div class=info-icon><md-button ng-if=\"editGPCtrl.url.href && editGPCtrl.url.addedFromGoogle\" ng-click=\"editGPCtrl.showDialog(\'Important!\', \'You must create a new profile to add a different url.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__radios><div class=form-group ng-if=editGPCtrl.isContributor()><div class=\"d-flex align-items-center\"><label>Publication Author Page</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"editGPCtrl.showDialog(\'Publication Author Page\',\n                  \'This is not required, but if you do write for a publication,\n                  please give us your author page on the site.\n                  This will allow us to better understand what your contributor column is all about!\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><input class=form-control url-input name=authorPage ng-model=editGPCtrl.url.author_page placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\"><div class=errors ng-messages=form.authorPage.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div class=create-profile__seo__input><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Please tell us word count for articles.</span></label><div ng-click=\"editGPCtrl.setUrlRequiredLength(\'750-1000\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=750-1000 ng-model=editGPCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"editGPCtrl.setUrlRequiredLength(\'1000-1250\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=1000-1250 ng-model=editGPCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"editGPCtrl.setUrlRequiredLength(\'1250-1500\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=1250-1500 ng-model=editGPCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"editGPCtrl.setUrlRequiredLength(\'1500-+\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=1500-+ ng-model=editGPCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1500 +</span></label></div><div class=errors2 ng-show=editGPCtrl.showFormErrors ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><div class=\"d-flex align-items-center\"><label class=ucase>Are the links Do-Follow?</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"editGPCtrl.showDialog(\'Are the links Do-Follow?\',\n                              \'Do-follow links MUST NOT have either the \\\'rel = nofollow\\\' or \\\'rel = sponsored\\\'\n                              tag on the link.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div ng-click=\"editGPCtrl.setUrlFollowLink(true, form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=true ng-model=editGPCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=\"editGPCtrl.setUrlFollowLink(false, form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=false ng-model=editGPCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=editGPCtrl.showFormErrors ng-messages=form.follow_link.$error><div ng-message=required>This is required.</div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><div class=\"d-flex align-items-center\"><label class=ucase>Will you allow links to client\'s home page or main service pages?</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"editGPCtrl.showDialog(\'Do You Allow Home Page Links?\',\n                              \'Home page links with us are 99% brand name links. Very safe and very natural.\n                               Selecting this option also means you are open to linking to service pages.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div ng-click=\"editGPCtrl.setUrlAllowHomepage(true, form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=true ng-model=editGPCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=\"editGPCtrl.setUrlAllowHomepage(false, form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() value=false ng-model=editGPCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=editGPCtrl.showFormErrors ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div ng-if=false class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Who Will Be Doing the Content?</span> <span class=error-message ng-if=editGPCtrl.showMissingContentTypeError><br>Need to select type of Content</span></label><div ng-click=\"editGPCtrl.setContentType(\'own\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() tabindex=7 ng-disabled=$root.isLoading ng-model=editGPCtrl.profile.contentType value=own class=form-check-input name=contentType type=radio><label class=form-check-label><span>I write my own content. Period.</span></label></div><div ng-click=\"editGPCtrl.setContentType(\'ghosted\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() tabindex=8 ng-disabled=$root.isLoading ng-model=editGPCtrl.profile.contentType value=ghosted class=form-check-input name=contentType type=radio><label class=form-check-label for=radio6><span>I accept ghosted content.</span></label></div><div ng-if=false ng-click=\"editGPCtrl.setContentType(\'collaborate\', form)\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=editGPCtrl.isContributor() tabindex=9 ng-disabled=$root.isLoading ng-model=editGPCtrl.profile.contentType value=collaborate class=form-check-input name=contentType type=radio required><label class=form-check-label for=radio7><span>I can do either. Open to collaboration.</span></label></div><div class=errors2 ng-show=editGPCtrl.showFormErrors ng-messages=form.contentType.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div ng-if=false class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><div class=\"d-flex align-items-center\"><label class=ucase>Do you have a guest post requirements page</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"editGPCtrl.showDialog(\'Do you have a guest post requirements page?\', \'This field is not required.\n                                    But if you have a page on your website that will help our writers make great content\n                                    for you, add it below. Our content team is required to read this before starting on a\n                                    topic.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><input ng-disabled=$root.isLoading class=form-control url-input name=postRequirements ng-model=editGPCtrl.url.post_requirements placeholder=\"For example: http://mysite.com/my-post-requirements\"></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><div class=\"d-flex align-items-center\"><label class=ucase>Please tell us about your site, or click the button below to use your meta description.</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"editGPCtrl.showDialog(\'Website Description\', \'This field is required.\n                                    Provide some details that explain what your website is all about.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><button class=\"btn btn-white btn-small btn-auto no-animate\" style=\"margin-bottom: 15px\" ng-click=editGPCtrl.getMetaDescription()>Use Meta Description</button><textarea ng-disabled=$root.isLoading ng-model=editGPCtrl.url.description name=description style=\"width: 400px\" maxlength=200 class=form-control rows=3 placeholder=\"\" required></textarea><div class=errors2 ng-show=editGPCtrl.showFormErrors ng-messages=form.description.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><input ui-money-mask=0 maxlength=9 name=searchPrice ng-model=editGPCtrl.url.price ng-disabled=\"(!editGPCtrl.url.href || !editGPCtrl.validDomInfo()) && !editGPCtrl.url.addedFromGoogle\" format=currency min=1 ng-required=editGPCtrl.isContributor() class=form-control ng-blur=editGPCtrl.checkUrlV2(form) ng-class=\"{\'blank__audience-data\': editGPCtrl.showFormErrors && !editGPCtrl.url.price && !editGPCtrl.isBlogger()}\" type=text placeholder=\"Your price per post (USD)\"><div class=info-icon ng-if=\"editGPCtrl.validDomInfo() || editGPCtrl.url.addedFromGoogle\"><md-button ng-click=editGPCtrl.showPriceSEO() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=errors ng-messages=\"form.searchPrice.$dirty && form.searchPrice.$error\" multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div><div ng-message=unmatched style=\"max-width: 500px\">{{ editGPCtrl.unmatchedErrorContent() }}</div></div><div class=errors ng-if=editGPCtrl.priceHigherThanSuggested><div>Either change price closer to {{ editGPCtrl.daAvgPrice | currency }} and then save, or if you want to keep your price then ignore this warning and click save.</div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editGPCtrl.goEditProfile(form.$dirty)>Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=editGPCtrl.saveSearchContent(form) ng-disabled=\"$root.isLoading || !(editGPCtrl.url.href && editGPCtrl.url.price) || form.$invalid \">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editGuestPost/editGuestPost.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header style=\"display: flex; justify-content: space-between\"><div style=\"width: 50%\"><p>Profile: <span><a href=javascript:void(0) ng-click=editGPCtrl.goEditProfile(false)>{{ editGPCtrl.profile.name }}</a></span></p></div><div style=\"width: 50%\"><div class=edit-profile__main-data__buttons><button class=\"btn btn-white btn-auto btn-small\" ng-click=editGPCtrl.addUrl($event)>Add New Domain To This Profile</button> <button ng-if=!editGPCtrl.isBlogger() class=\"btn btn-white btn-auto btn-small hide-on-mobile\" ng-click=editGPCtrl.showCsvDialog()>Add Multiple URLs</button></div><div class=selected-spreadsheet layout=row ng-show=editGPCtrl.csv layout-align=\"end center\" flex><md-icon class=md-accent ng-if=editGPCtrl.csv ng-click=editGPCtrl.clearCsv()>delete</md-icon><md-input-container><input name=csv class=highlighted disabled=disabled ng-model=editGPCtrl.csv.name></md-input-container><md-button class=\"btn btn-default btn-auto btn-small\" ng-if=editGPCtrl.csv ng-click=editGPCtrl.sendFileToAdmin()>Submit for approval</md-button><span class=\"error-message errors\" ng-show=editGPCtrl.spreadsheetError flex>Remember to send the file to admin.</span></div></div></section><hr><section class=edit-profile__section><h5 class=edit-profile__title>Categories</h5><!-- partial for categories --><div ng-include=\"\'app/pages/profiles/editProfile/partials/categories.html\'\"></div></section><section><h5 class=edit-profile__title>Domain information - Search Content (SEO)<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=editGPCtrl.showInfo()><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h5><div class=edit-profile__content><md-table-container><table class=table md-table ng-model=editGPCtrl.urls md-progress=promise><thead md-head md-order=editGPCtrl.query.order><tr md-row><th md-column md-order-by=href><a class=\"btn btn-link\" href=javascript:void(0)><span>Domain URL</span></a></th><th md-column md-order-by=description><a class=\"btn btn-link\" href=javascript:void(0)><span>Description</span></a></th><th md-column md-order-by=follow_link><a class=\"btn btn-link\" href=javascript:void(0)><span>DoFollow / NoFollow</span></a></th><th md-column md-order-by=domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th md-column md-order-by=trust_flow><a class=\"btn btn-link\" href=javascript:void(0)><span>TF</span></a></th><th md-column md-order-by=price><a class=\"btn btn-link\" href=javascript:void(0)><span>Payout</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Pause</span></a><div class=\"hint hint--active hint--bottom\"><div ng-mouseover=\"vm.showPauseHint = true\" ng-mouseleave=\"vm.showPauseHint = false\" class=hint__icon><svg class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg></div><div ng-show=vm.showPauseHint class=hint__text>Pausing a URL will deactivate it from getting orders. You can reactivate it anytime.</div></div></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Edit</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"url in editGPCtrl.filtered = (editGPCtrl.urls | filter: editGPCtrl.query.filter) |\n        orderBy: editGPCtrl.query.order |\n        limitTo: editGPCtrl.query.limit : (editGPCtrl.query.page -1) * editGPCtrl.query.limit\"><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.href | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.href }}</md-tooltip></td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.description || \'Will be processed as soon as possible\' | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.description || \'Will be processed as soon as possible\' }}</md-tooltip></td><td md-cell class=follow-cell>{{ editGPCtrl.setFollowValue(url) }}</td><td md-cell>{{ url.domain_authority }}</td><td md-cell>{{ url.trust_flow }}</td><td md-cell>{{ url.price | currency }}</td><td md-cell><div class=switcher><input ng-id=\"{{ url.id }}-pause\" type=checkbox ng-checked=editGPCtrl.getPausedStatus(url) ng-disabled=editGPCtrl.nonPausableUrl(url) aria-label=paused><label ng-if=editGPCtrl.nonPausableUrl(url) ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label><label ng-if=!editGPCtrl.nonPausableUrl(url) ng-click=\"editGPCtrl.pausedStateChanged(url, $index)\" ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label></div></td><td md-cell><md-tooltip class=custom-tooltip md-direction=bottom>{{ editGPCtrl.getPencilTooltip(url.state) }}</md-tooltip><md-icon ng-click=\"editGPCtrl.editDomain($event, url)\" ng-class=url.state>edit</md-icon></td></tr></tbody></table></md-table-container></div></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editGPCtrl.goEditProfile(false)>Back</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editGuestPost/guestPost.html","<div ng-if=\"editGPCtrl.isInitialized() && editGPCtrl.isGuestPostCompleted() && !editGPCtrl.doForceAdd()\" ng-include src=\"\'app/pages/profiles/editProfile/editGuestPost/editGuestPost.html\'\"></div><div ng-if=\"editGPCtrl.isInitialized() && (!editGPCtrl.isGuestPostCompleted() || editGPCtrl.doForceAdd())\" ng-include src=\"\'app/pages/profiles/editProfile/editGuestPost/addGuestPost.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfile/editModalInfo/editInfoDialog.html","<md-dialog class=edit-dialog-container><md-toolbar><div class=md-toolbar-tools><h2>{{editInfoCtrl.title}}</h2></div></md-toolbar><md-dialog-content layout=column><div layout=row class=rejected-reasons flex layout-align=\"start center\" ng-if=editInfoCtrl.showRejectedReasons><span>Changes Needed:</span><div layout-padding class=bold-red>{{ editInfoCtrl.rejectedReasons() }}</div></div><form name=form layout-padding><div layout=column><div class=form-group><label>URL</label><input class=form-control type=text required name=domainUrl ng-model=editInfoCtrl.url.href ng-blur=editInfoCtrl.checkURL(form) placeholder=http://www.awesome.site.com ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"> <span class=error-message ng-if=editInfoCtrl.showMinValues>Minimum MOZ Domain Authority is 15 and Majestic Trust Flow is 10 </span><span class=error-message ng-if=editInfoCtrl.showUrlDisabled>Sorry, this URL is already in Scalefluence and cannot be re-added </span><span class=error-message ng-if=editInfoCtrl.urlStatsRequestFailed>DATA PROVIDERS ARE SLOW RIGHT NOW AND PREVENTING NEW URL SUBMISSIONS. WE HAVE BEEN NOTIFIED AND WILL LET KNOW WHEN IT\'S BACK UP.</span><div class=errors ng-messages=form.domainUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required</div><div ng-message=you-own>You have already submitted this before. If you wish change price, please do so under Pricing and Pausing on your dashboard..</div><div ng-message=url>Check this url, it doesn\'t seem good.</div><div ng-message=duplicate>This URL has already been submitted before and cannot be accepted. Please email admin@scalefluence.com if you would like to discuss.</div><div ng-message=unmatched>This URL has already been submitted before and can only be accepted at a price lower than ${{editInfoCtrl.maxDomPrice}}. Please email admin@scalefluence.com if you would like to discuss.</div></div></div><div class=form-group><label ng-if=editInfoCtrl.isNewDomain()>{{ editInfoCtrl.pricePlaceholder }}</label><label ng-if=!editInfoCtrl.isNewDomain()>{{ editInfoCtrl.pricePlaceholder }} (Current Price: ${{ editInfoCtrl.currentPrice }})</label><input class=form-control type=text ui-money-mask=0 maxlength=9 required name=urlPrice ng-model=editInfoCtrl.url.price format=currency min=1 ng-blur=editInfoCtrl.checkURL(form) ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"><div class=errors ng-messages=form.urlPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div><div ng-message=unmatched>This URL has already been submitted before and can only be accepted at a price lower than ${{editInfoCtrl.maxDomPrice}}. Please email admin@scalefluence.com if you would like to discuss.</div></div></div><label class=suggested-price ng-show=editInfoCtrl.suggestedPrice><i>Suggested price based on DA = {{ editInfoCtrl.domInfo.domain_authority }} and TF = {{ editInfoCtrl.domInfo.trust_flow }}</i></label><div class=\"form-group form-group--radios\"><label>Please tell us word count for articles.</label><div class=errors2 ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'750-1000\')\" class=\"form-check form-check-radio form-check-inline\"><input value=750-1000 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1000-1250\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1000-1250 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1250-1500\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1250-1500 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1500-+\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1500-+ ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1500 +</span></label></div></div><div class=\"form-group form-group--radios\"><label>Will you allow links to client\'s home page or main service pages?</label><div class=errors2 ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div><div ng-click=editInfoCtrl.setUrlAllowHomepage(true) class=\"form-check form-check-radio form-check-inline\"><input value=true ng-model=editInfoCtrl.url.allow_home_page ng-checked=editInfoCtrl.isAllowHomepage() class=form-check-input name=allow_home_page type=radio required><label class=form-check-label><span>Yes</span></label></div><div ng-click=editInfoCtrl.setUrlAllowHomepage(false) class=\"form-check form-check-radio form-check-inline\"><input value=false ng-model=editInfoCtrl.url.allow_home_page ng-checked=editInfoCtrl.isNotAllowHomepage() class=form-check-input name=allow_home_page type=radio required><label class=form-check-label><span>No</span></label></div><p class=error-message ng-show=editInfoCtrl.showHomePageError>{{ editInfoCtrl.showHomePageErrorMessage() }}</p></div><div class=\"form-group form-group--radios\"><label>Are the links Do-Follow?</label><div class=errors2 ng-if=!editInfoCtrl.followLinkOptionIsSet(editInfoCtrl.url)><div>This is required.</div></div><div ng-click=editInfoCtrl.setUrlFollowLink(true) class=\"form-check form-check-radio form-check-inline\"><input value=true ng-model=editInfoCtrl.url.follow_link ng-checked=editInfoCtrl.isDoFollow() class=form-check-input name=follow_link type=radio required><label class=form-check-label><span>Yes</span></label></div><div ng-click=editInfoCtrl.setUrlFollowLink(false) class=\"form-check form-check-radio form-check-inline\"><input value=false ng-model=editInfoCtrl.url.follow_link ng-checked=editInfoCtrl.isNotDoFollow() class=form-check-input name=follow_link type=radio required><label class=form-check-label><span>No</span></label></div><p class=error-message ng-show=editInfoCtrl.showFollowLinkError>{{ editInfoCtrl.showFollowLinkErrorMessage() }}</p></div><div class=\"form-group form-group--radios\" style=\"margin-bottom: 15px\" class=desc-group><label>Please tell us about your site, or click the button below to use your meta description.</label><button class=\"btn btn-white btn-small btn-auto no-animate\" style=\"margin-bottom: 15px\" ng-click=editInfoCtrl.getMetaDescription()>Use Meta Description!</button><textarea class=form-control ng-trim=true maxlength=450 ng-model=editInfoCtrl.url.description rows=2 name=description required ng-disabled=\"$root.isLoading || editInfoCtrl.disable\">\n          </textarea><div class=errors ng-messages=form.description.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div layout=column><div ng-if=editInfoCtrl.isContributor class=form-group><label>Publication Author Page</label><input class=form-control url-input name=url ng-model=editInfoCtrl.profile.author_page placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\" ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"><div class=errors ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div layout=row><div class=pausing-url ng-if=\"editInfoCtrl.showPause && editInfoCtrl.url.id\"><md-checkbox class=pause-url-check ng-model=editInfoCtrl.pausedValue ng-disabled=$root.isLoading><label class=pause-url-lbl>Pause URL <span class=pause-url-note ng-if=\"editInfoCtrl.pausedValue && !editInfoCtrl.disable\">- When paused is selected any changes won\'t have any effect</span></label></md-checkbox></div></div></div></form><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" ng-click=editInfoCtrl.cancel() ng-disabled=\" $root.isLoading\">Cancel</md-button><md-button class=\"btn btn-white btn-small\" ng-mousedown=editInfoCtrl.submit() ng-disabled=\"editInfoCtrl.showUrlDisabled || editInfoCtrl.showMinValues || form.$invalid || $root.isLoading\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfile/editSocials/facebook.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span><a href=javascript:void(0) ng-click=\"editSocialsCtrl.goEditProfile(\'facebook\')\">{{ editSocialsCtrl.profile.name }}</a></span></p></section><section class=edit-profile__block><!-- FACEBOOK SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">Per facebook user terms you must either be a business fan page or content creator.</div><div class=\"social__common-info__item text-uppercase\">Click <a href=https://www.facebook.com/business/news/branded-content-update target=_blank>this link</a> to read fb\'s terms and conditions if unsure.</div><div class=\"social__common-info__item text-uppercase\">Once fb is connected; our suggested pricing will appear to help you with pricing</div><div class=\"social__common-info__item text-uppercase\">Click the orange (?) icons for product descriptions</div></div><ng-form name=fbForm><div class=sponsored-social__row><img src=\"{{ editSocialsCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/facebook.svg\'}}\" alt><div class=sponsored-social__button><button ng-click=\"editSocialsCtrl.handleFacebookConnection(editSocialsCtrl.profile.facebook_handle, \'facebook\')\" class=\"btn btn-white\" type=button>{{editSocialsCtrl.profile.facebook_handle.url ? \'Disconnect Facebook\' : \'Connect Facebook\'}}</button></div></div></ng-form><div ng-if=editSocialsCtrl.profile.facebook_handle.url style=\"text-align: center\"><div style=\"padding: 20px\"><span class=content-format>According to (facebook), you have ({{ editSocialsCtrl.socialCount.facebookFollowersCount }}) followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence. For your protection, this content will be disclosed per FTC guidelines.</span></div><row followers=followers network=network header=header></row></div><form class=connect-social__form name=facebookForm ng-submit=form.$valid><div class=social__promotion-description ng-repeat=\"handle in editSocialsCtrl.profile.facebook_handle.social_prices | orderBy:\'info\'\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"social__item-col center d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"social__item-col right\"><div ng-if=editSocialsCtrl.profile.facebook_handle.url class=info-icon><md-button ng-click=editSocialsCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 ng-disabled=\"!editSocialsCtrl.profile.facebook_handle.url || (editSocialsCtrl.profile.facebook_handle.url && !editSocialsCtrl.canEditSocialPrice(handle) )\" ng-required=editSocialsCtrl.profile.facebook_handle.url ng-model=handle.price ng-change=\"editSocialsCtrl.facebookForm = facebookForm\" ng-keyup=\"editSocialsCtrl.triggerChange(handle, \'facebook\')\" ng-class=editSocialsCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><div class=\"status-container price-status\" ng-class=editSocialsCtrl.getPriceClass(handle) ng-show=\"editSocialsCtrl.profile.facebook_handle.url && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editSocialsCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=\"editSocialsCtrl.goEditProfile(\'facebook\')\">Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"!editSocialsCtrl.profile.facebook_handle.url || !facebookForm.$dirty || $root.isLoading\" ng-click=\"editSocialsCtrl.saveSocialContent(facebookForm, \'facebook\')\">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editSocials/instagram.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span><a href=javascript:void(0) ng-click=\"editSocialsCtrl.goEditProfile(\'instagram\')\">{{ editSocialsCtrl.profile.name }}</a></span></p></section><section class=edit-profile__block><!-- INSTAGRAM SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">First select whether you are a verified user on instagram or not.</div><div class=\"social__common-info__item text-uppercase\">Once ig is connected; our suggested pricing will appear.</div><div class=\"social__common-info__item text-uppercase\">This will aid you in correctly pricing each product.</div><div class=\"social__common-info__item text-uppercase\">Click the orange (?) icons for each product description.</div></div><div class=\"ng-cloak toggle\" ng-class=\"{ \'toggle-disabled\': editSocialsCtrl.profile.instagram_handle.url }\"><input checked=checked type=radio ng-model=editSocialsCtrl.profile.instagram_handle.subtype value=verified name=subtype id=verifiedIgUser><label ng-click=\"editSocialsCtrl.setSubtype(editSocialsCtrl.profile.instagram_handle, \'verified\')\" for=verifiedIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am verified on IG</label><input type=radio ng-model=editSocialsCtrl.profile.instagram_handle.subtype value=simple name=subtype id=simpleIgUser><label ng-click=\"editSocialsCtrl.setSubtype(editSocialsCtrl.profile.instagram_handle, \'simple\')\" for=simpleIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am just a normal user on IG</label></div><ng-form name=inForm><div class=sponsored-social__row><img src=\"{{ editSocialsCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/instagram.svg\'}}\" height=40px alt><div class=sponsored-social__button><button ng-click=\"editSocialsCtrl.handleInstagramConnection(editSocialsCtrl.profile.instagram_handle, \'instagram\')\" class=\"btn btn-white\" type=button>{{editSocialsCtrl.profile.instagram_handle.url ? \'Disconnect Instagram\' : \'Connect Instagram\'}}</button><md-tooltip ng-show=!editSocialsCtrl.profile.instagram_handle.subtype md-direction=bottom>First select the type of IG profile</md-tooltip></div></div></ng-form><div ng-if=editSocialsCtrl.profile.instagram_handle.url style=\"text-align: center\"><div style=\"padding: 20px\"><span class=content-format>According to (Instagram), you have ({{ editSocialsCtrl.socialCount.instagramFollowersCount}}) followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence.For your protection, this content will be disclosed per FTC guidelines.</span></div><row followers=followers network=network header=header></row></div><form class=connect-social__form name=instagramForm ng-submit=form.$valid><div class=social__promotion-description ng-repeat=\"handle in editSocialsCtrl.profile.instagram_handle.social_prices | orderBy:\'info\'\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"social__item-col center d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"social__item-col right\"><div ng-if=editSocialsCtrl.profile.instagram_handle.url class=info-icon><md-button ng-click=editSocialsCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 ng-disabled=\"!editSocialsCtrl.profile.instagram_handle.url || (editSocialsCtrl.profile.instagram_handle.url && !editSocialsCtrl.canEditSocialPrice(handle) )\" ng-required=editSocialsCtrl.profile.instagram_handle.url ng-model=handle.price ng-change=\"editSocialsCtrl.instagramForm = instagramForm\" ng-keyup=\"editSocialsCtrl.triggerChange(handle, \'instagram\')\" ng-class=editSocialsCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><div class=\"status-container price-status\" ng-class=editSocialsCtrl.getPriceClass(handle) ng-show=\"editSocialsCtrl.profile.instagram_handle.url && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editSocialsCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=\"editSocialsCtrl.goEditProfile(\'instagram\')\">Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"!editSocialsCtrl.profile.instagram_handle.url || !instagramForm.$dirty || $root.isLoading\" ng-click=\"editSocialsCtrl.saveSocialContent(instagramForm, \'instagram\')\">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editSocials/twitter.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span><a href=javascript:void(0) ng-click=\"editSocialsCtrl.goEditProfile(\'twitter\')\">{{ editSocialsCtrl.profile.name }}</a></span></p></section><section class=edit-profile__block><!-- TWITTER SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">Once twitter is connected; our suggested pricing will appear.</div><div class=\"social__common-info__item text-uppercase\">This will aid you in correctly pricing each product.</div><div class=\"social__common-info__item text-uppercase\">Click the orange (?) icons for each product description.</div></div><ng-form name=twForm><div class=sponsored-social__row><img src=\"{{ editSocialsCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/twitter.svg\'}}\" height=40px alt><div class=sponsored-social__button><button ng-click=\"editSocialsCtrl.handleTwitterConnection($event, editSocialsCtrl.profile.twitter_handle, \'twitter\')\" class=\"btn btn-white\" type=button>{{editSocialsCtrl.profile.twitter_handle.url ? \'Disconnect Twitter\' : \'Connect Twitter\'}}</button></div></div></ng-form><div ng-if=editSocialsCtrl.profile.twitter_handle.url style=\"text-align: center\"><div style=\"padding: 20px\"><span class=content-format>According to (twitter), you have ({{ editSocialsCtrl.socialCount.twitterFollowersCount }}) followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence. For your protection, this content will be disclosed per FTC guidelines.</span></div><row followers=followers network=network header=header></row></div><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description ng-repeat=\"handle in editSocialsCtrl.profile.twitter_handle.social_prices | orderBy:\'info\'\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"social__item-col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col right\"><div ng-if=editSocialsCtrl.profile.twitter_handle.url class=info-icon><md-button ng-click=editSocialsCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 ng-disabled=\"!editSocialsCtrl.profile.twitter_handle.url || (editSocialsCtrl.profile.twitter_handle.url && !editSocialsCtrl.canEditSocialPrice(handle) )\" ng-required=editSocialsCtrl.profile.twitter_handle.url ng-model=handle.price ng-change=\"editSocialsCtrl.twForm = twForm\" ng-keyup=\"editSocialsCtrl.triggerChange(handle, \'twitter\')\" ng-class=editSocialsCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><div class=\"status-container price-status\" ng-class=editSocialsCtrl.getPriceClass(handle) ng-show=\"editSocialsCtrl.profile.twitter_handle.url && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editSocialsCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=\"editSocialsCtrl.goEditProfile(\'twitter\')\">Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"!editSocialsCtrl.profile.twitter_handle.url || twForm.$dirty || $root.isLoading\" ng-click=\"editSocialsCtrl.saveSocialContent(twForm, \'twitter\')\">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editSocials/youtube.html","<script src=https://apis.google.com/js/client.js></script><div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span><a href=javascript:void(0) ng-click=\"editSocialsCtrl.goEditProfile(\'youtube\')\">{{ editSocialsCtrl.profile.name }}</a></span></p></section><section class=edit-profile__block><!-- YOUTUBE SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">Once youtube is connected, our suggested pricing will appear.</div><div class=\"social__common-info__item text-uppercase\">This will aid you in correctly pricing each product.</div><div class=\"social__common-info__item text-uppercase\">Click the orange (?) icons for each product description.</div></div><div class=sponsored-social__row><img class=\"d-none d-sm-block\" src=\"{{ editSocialsCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/yt_logo_rgb_light.png\'}}\" height=40px alt> <img class=\"d-block d-sm-none\" src=\"{{ editSocialsCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/yt_logo_rgb_light.png\'}}\" height=25px alt><div class=sponsored-social__button><button ng-click=\"editSocialsCtrl.handleYoutubeConnection($event, editSocialsCtrl.profile.youtube_handle, \'youtube\')\" class=\"btn btn-white\" type=button>{{ editSocialsCtrl.profile.youtube_handle.url ? \'Disconnect Youtube\' : \'Connect Youtube\' }}</button></div></div><div ng-if=editSocialsCtrl.profile.youtube_handle.url style=\"text-align: center\"><div style=\"padding: 20px\"><span class=content-format>According to (Youtube), you have ({{ editSocialsCtrl.socialCount.youTubeFollowersCount }}) followers. Below is our suggested payout for ONLY a social media post. You can put any price you want. This only a suggestion based on your influence. For your protection, this content will be disclosed per FTC guidelines.</span></div><row followers=followers network=network header=header></row></div><form class=connect-social__form name=youtubeForm ng-submit=youtubeForm.$valid><div class=social__promotion-description ng-repeat=\"handle in editSocialsCtrl.profile.youtube_handle.social_prices\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"social__item-col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col right\"><div ng-if=editSocialsCtrl.profile.youtube_handle.url class=info-icon><md-button ng-click=editSocialsCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 ng-disabled=\"!editSocialsCtrl.profile.youtube_handle.url || (editSocialsCtrl.profile.youtube_handle.url && !editSocialsCtrl.canEditSocialPrice(handle) )\" ng-required=editSocialsCtrl.profile.youtube_handle.url ng-model=handle.price ng-change=\"editSocialsCtrl.youtubeForm = youtubeForm\" ng-keyup=\"editSocialsCtrl.triggerChange(handle, \'youtube\')\" ng-class=editSocialsCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><div class=\"status-container price-status\" ng-class=editSocialsCtrl.getPriceClass(handle) ng-show=\"editSocialsCtrl.profile.youtube_handle.url && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editSocialsCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=\"editSocialsCtrl.goEditProfile(\'youtube\')\">Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-disabled=\"!editSocialsCtrl.profile.youtube_handle.url || !youtubeForm.$dirty || $root.isLoading\" ng-click=\"editSocialsCtrl.saveSocialContent(youtubeForm, \'youtube\')\">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/editWebContent/webContent.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header style=\"display: flex; justify-content: space-between\"><div style=\"width: 50%\"><p>Profile: <span><a href=javascript:void(0) ng-click=editWebCtrl.goEditProfile(webContentForm.$dirty)>{{ editWebCtrl.profile.name }}</a></span></p></div><div style=\"width: 50%\"><div class=edit-profile__main-data__buttons><button class=\"btn btn-white btn-auto btn-small\" ng-click=editWebCtrl.contributorOnlyPopup()>Add New URL</button></div></div></section><section ng-cloak class=edit-profile__block><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">Sponsored reviews & product giveaways requires google analytics connection. We will verify traffic only.</div><div class=\"social__common-info__item text-uppercase\">Content drafts will be submitted for review. This is not a guest post product. Links are no-follow and content will be disclosed as paid. Use whatever disclosure you feel comfortable with.</div><div class=\"social__common-info__item text-uppercase\">Once ga is connected, put your prices below. Click on orange (?) icons for product description.</div></div><form class=social-handle name=webContentForm ng-submit=webContentForm.$valid><div class=sponsored-social__row><img src=\"{{ editWebCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/google.svg\'}}\" alt><div class=sposored-social__input style=\"padding-bottom: 10px; width: 23%\" ng-show=!editWebCtrl.profile.web_content.href><label>Authorize New Account</label><select class=\"form-control ga4-select\" name=gaUrl ng-change=editWebCtrl.handleWebContentConnection(selectedOption) ng-options=\"editWebCtrl.analyticstAccountTypeDisplay(option) for option in editWebCtrl.dropDownWebContentConnection\" ng-model=editWebCtrl.selectedOption></select></div><div class=sponsored-social__button ng-show=editWebCtrl.profile.web_content.href><button ng-click=editWebCtrl.handleWebContentConnection($event) class=\"btn btn-white ng-cloak\" type=button>Disconnect Account</button></div><div class=sposored-social__input ng-if=editWebCtrl.analytics.length><label>{{ editWebCtrl.getPropertyLabelGA() }}</label><select class=form-control name=gaUrl ng-change=\"( editWebCtrl.connectWithGa4 ? editWebCtrl.analyticSelectedGa4() : editWebCtrl.analyticSelected())\" ng-disabled=!editWebCtrl.analyticsAuthorized ng-options=\"account as (editWebCtrl.connectWithGa4 ? account.displayName : account.name) for account in editWebCtrl.analytics track by (editWebCtrl.connectWithGa4 ? account.account : account.id)\" ng-model=editWebCtrl.selectedAnalytics></select><div class=errors ng-messages=form.gaUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=url>You must add http(s):// in front of the domain.</div></div></div></div><div class=social_input_more_profile ng-if=editWebCtrl.allProfiles.length><h4>You have multiple Analytics Views of your site. PLEASE CHOOSE THE ONE THAT INCLUDES ALL TRAFFIC SOURCES.</h4><select class=form-control name=\"\" ng-change=\"(editWebCtrl.connectWithGa4 ? editWebCtrl.profileSelectedGa4() : editWebCtrl.profileSelected())\" ng-options=\"profiles as (editWebCtrl.connectWithGa4 ? profiles.displayName : profiles.name ) for profiles in editWebCtrl.allProfiles track by (editWebCtrl.connectWithGa4 ? profiles.property : profiles.id)\" ng-model=editWebCtrl.selectedProfile></select></div><div class=\"social__common-info suggested__prices-info\" ng-show=editWebCtrl.profile.web_content.href><div class=\"social__common-info__item text-uppercase\">Suggested Pricing for Sponsored Web Content ({{editWebCtrl.profile.web_content.website_url}}) <span><md-button ng-click=editWebCtrl.showGaDetails() ng-show=editWebCtrl.profile.web_content.href class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div><div><h3 class=text-center>Monthly Visitors</h3><row followers=editWebCtrl.profile.web_content.muv network=GA header=editWebCtrl.profile.web_content.header></row></div></div><div class=social__promotion-description ng-repeat=\"handle in editWebCtrl.profile.web_content.web_content_prices | orderBy:\'info\'\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase ng-bind-html=handle.description></p></div><div class=\"social__item-col right\"><div ng-if=editWebCtrl.profile.web_content.href class=info-icon><md-button ng-click=editWebCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 name=price ng-required=editWebCtrl.gaPriceChangeEnabled() ng-class=\"{\'disabled\': !editWebCtrl.profile.web_content.href || (editWebCtrl.profile.web_content.href && !editWebCtrl.canEditSocialPrice(handle) )}\" ng-disabled=\"!editWebCtrl.profile.web_content.href || (editWebCtrl.profile.web_content.href && !editWebCtrl.canEditSocialPrice(handle) )\" ng-class=editWebCtrl.getPriceClass(handle) ng-model=handle.price ng-keyup=editWebCtrl.triggerChange(handle) ng-change=\"editWebCtrl.webContentForm = webContentForm\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div><div class=\"status-container price-status\" ng-class=editWebCtrl.getPriceClass(handle) ng-show=\"editWebCtrl.profile.web_content.href && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editWebCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editWebCtrl.goEditProfile(webContentForm.$dirty)>Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=editWebCtrl.saveWebContent(webContentForm) ng-disabled=\"!editWebCtrl.profile.web_content.href || !webContentForm.$dirty || $root.isLoading\">Save</button></section></div></div><style>select.ga4-select {\n   font-weight: bold !important;\n }\n select.ga4-select > option {\n   font-weight: bold !important;\n }</style>");
$templateCache.put("app/pages/profiles/editProfile/partials/audienceAge.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editAudienceCtrl.ageGroupList elements-limit=3 ng-model=editAudienceCtrl.profile.audience_age_groups selector-title=\"Select Up to 3 Age Groups\" placeholder=\"Select age groups\" on-change=editAudienceCtrl.audienceAgeChanged() info-text=\"Select Up to 3 Age Groups\" has-changed=editAudienceCtrl.hasChangedAudienceAge highlight-blank-audience-fields=editAudienceCtrl.showFormErrors flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/audienceDemographics.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'audienceDemographics\', editProfCtrl.hasChangedAudienceDemographics)\" class=edit-profile__block-header><div ng-if=editProfCtrl.hideAudienceDemographics class=select-placeholder>Click to edit audience demographics</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit audience demographics</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideAudienceDemographics }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=social-handle ng-hide=editProfCtrl.hideAudienceDemographics><div ng-if=\"editProfCtrl.hasChangedPets || editProfCtrl.hasChangedAudienceAge ||\n       editProfCtrl.hasChangedAudienceEthnicities || editProfCtrl.hasChangedLanguages ||\n        editProfCtrl.hasChangedAudienceIncome || editProfCtrl.hasChangedAudienceGender\" class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editProfCtrl.saveChanges(\'audienceDemographics\')\" ng-disabled=$root.isLoading>Save</button></div><!-- partial for audience income and audience gender --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceIncomeAndGender.html\'\"></div><!-- partial for location/ ethnicity --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceEthnicity.html\'\"></div><!-- partial for languages --><div ng-include=\"\'app/pages/profiles/editProfile/partials/language.html\'\"></div><!-- partial for pets --><div ng-include=\"\'app/pages/profiles/editProfile/partials/pets.html\'\"></div><!-- partial for age --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceAge.html\'\"></div></div><div ng-if=\"editProfCtrl.hasChangedPets || editProfCtrl.hasChangedAudienceAge ||\n       editProfCtrl.hasChangedAudienceEthnicities || editProfCtrl.hasChangedLanguages ||\n        editProfCtrl.hasChangedAudienceIncome || editProfCtrl.hasChangedAudienceGender\" class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editProfCtrl.saveChanges(\'audienceDemographics\')\" ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/audienceEthnicity.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editAudienceCtrl.ethnicitiesList elements-limit=3 ng-model=editAudienceCtrl.profile.audience_ethnicities hide-elements=false placeholder=\"Select ethnicity\" on-change=editAudienceCtrl.ethnicitiesChanged() has-changed=editAudienceCtrl.hasChangedAudienceEthnicities selector-title=\"Select Ethnicity / Geolocation of Your Audience (up to 3)\" highlight-blank-audience-fields=editAudienceCtrl.showFormErrors flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/audienceIncomeAndGender.html","<div class=audience-select><div class=audience-select__block><h6 class=audience__title ng-class=\"{\'blank__audience-data\': editAudienceCtrl.showFormErrors && !editAudienceCtrl.selectedEstimatedIncome()}\">Select Estimated Income of Audience</h6><select ng-change=\"editAudienceCtrl.hasChangedAudienceIncome = true\" class=form-control ng-class=\"{\'blank__audience-data\': editAudienceCtrl.showFormErrors && !editAudienceCtrl.selectedEstimatedIncome()}\" ng-model=editAudienceCtrl.profile.audience_estimated_income><option ng-repeat=\"income in editAudienceCtrl.audienceEstimatedIncomes\">{{income}}</option></select></div><div class=audience-select__block><h6 class=audience__title ng-class=\"{\'blank__audience-data\': editAudienceCtrl.showFormErrors && !editAudienceCtrl.selectedAudienceGender()}\">Select gender of your audience</h6><select ng-change=\"editAudienceCtrl.hasChangedAudienceGender = true\" class=form-control ng-class=\"{\'blank__audience-data\': editAudienceCtrl.showFormErrors && !editAudienceCtrl.selectedAudienceGender()}\" ng-model=editAudienceCtrl.profile.audience_gender><option ng-repeat=\"option in editAudienceCtrl.audienceGenderList\">{{option}}</option></select></div></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/bloggerPartial.html","<h5 class=edit-profile__title>Blog & Social Media Connections<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=editProfCtrl.showInfo(4)><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h5><!-- partial for sponsored web content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/webContent.html\'\"></div><!-- partial for social content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/socialContent.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/broker&ContributorPartial.html","<h5 class=edit-profile__title>Domain information - Search Content (SEO)<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=editProfCtrl.showInfo(2)><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h5><div class=edit-profile__content><md-table-container><table class=table md-table ng-model=editProfCtrl.urls md-progress=promise><thead md-head md-order=editProfCtrl.query.order><tr md-row><th md-column md-order-by=href><a class=\"btn btn-link\" href=javascript:void(0)><span>Domain URL</span></a></th><th md-column md-order-by=description><a class=\"btn btn-link\" href=javascript:void(0)><span>Description</span></a></th><th md-column md-order-by=follow_link><a class=\"btn btn-link\" href=javascript:void(0)><span>DoFollow / NoFollow</span></a></th><th md-column md-order-by=domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th md-column md-order-by=trust_flow><a class=\"btn btn-link\" href=javascript:void(0)><span>TF</span></a></th><th md-column md-order-by=price><a class=\"btn btn-link\" href=javascript:void(0)><span>Payout</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Pause</span></a><div class=\"hint hint--active hint--bottom\"><div ng-mouseover=\"vm.showPauseHint = true\" ng-mouseleave=\"vm.showPauseHint = false\" class=hint__icon><svg class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg></div><div ng-show=vm.showPauseHint class=hint__text>Pausing a URL will deactivate it from getting orders. You can reactivate it anytime.</div></div></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Edit</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"url in editProfCtrl.filtered = (editProfCtrl.urls | filter: editProfCtrl.query.filter) |\n        orderBy: editProfCtrl.query.order |\n        limitTo: editProfCtrl.query.limit : (editProfCtrl.query.page -1) * editProfCtrl.query.limit\"><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.href | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.href }}</md-tooltip></td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.description || \'Will be processed as soon as possible\' | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.description || \'Will be processed as soon as possible\' }}</md-tooltip></td><td md-cell class=follow-cell>{{ editProfCtrl.setFollowValue(url) }}</td><td md-cell>{{ url.domain_authority }}</td><td md-cell>{{ url.trust_flow }}</td><td md-cell>{{ url.price | currency }}</td><td md-cell><div class=switcher><input ng-id=\"{{ url.id }}-pause\" type=checkbox ng-checked=editProfCtrl.getPausedStatus(url) ng-disabled=editProfCtrl.nonPausableUrl(url) aria-label=paused><label ng-if=editProfCtrl.nonPausableUrl(url) ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label><label ng-if=!editProfCtrl.nonPausableUrl(url) ng-click=\"editProfCtrl.pausedStateChanged(url, $index)\" ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label></div></td><td md-cell><md-tooltip class=custom-tooltip md-direction=bottom>{{ editProfCtrl.getPencilTooltip(url.state) }}</md-tooltip><md-icon ng-click=\"editProfCtrl.editDomain($event, url)\" ng-class=url.state>edit</md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=editProfCtrl.query.limit md-page=editProfCtrl.query.page md-total=\"{{ editProfCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/categories.html","<div class=edit-profile__block><div ng-click=\"editGPCtrl.toggleEditProfileBlock(\'categories\', editGPCtrl.hasChangedCategories, editGPCtrl.hideCategories)\" class=edit-profile__block-header><div ng-repeat=\"el in editGPCtrl.categories\"><div class=edit-profile__block-header__element>{{el.name}}</div></div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit categories</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editGPCtrl.hideCategories }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><hr><div class=social-handle ng-hide=editGPCtrl.hideCategories><category-selector flex placeholder=\"Search categories here or click below\" ng-model=editGPCtrl.categories on-change=editGPCtrl.categoriesChanged() hide-categories=!showCategories edit-profile-mode=true hide-title=true has-changed=editGPCtrl.hasChangedCategories></category-selector></div><div ng-if=editGPCtrl.hasChangedCategories class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editGPCtrl.saveChanges(\'categories\')\" ng-disabled=!editGPCtrl.categories.length ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/domainInformation.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'domainInformation\', domainInformationForm.$dirty, editProfCtrl.hideDomainInfo)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.url.description && editProfCtrl.hideAudienceAge\" class=select-placeholder>Click to edit description</div><div ng-if=editProfCtrl.url.description class=social-title>{{editProfCtrl.url.description.substring(0,150); }}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit description</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideDomainInfo }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=social-handle ng-hide=editProfCtrl.hideDomainInfo><form name=domainInformationForm><div layout=column layout-gt-sm=row layout-align-gt-sm=\"start center\"><div class=sposored-blog__input><label>URL</label><input class=\"form-control url-input\" url-input required name=url ng-model=editProfCtrl.url.href ng-disabled=true><div class=errors ng-messages=domainInformationForm.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern ng-show=!domainInformationForm.url.$error.required>This doesn\'t appear to be a valid URL. Please fix to move forward.</div><div ng-message=active>Hello! We\'re sorry but this URL has already been {{editProfCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=unmatched>Hello! This URL has already been submitted before. Please email admin@scalefluence.com to discuss your price.</div></div></div><div class=sposored-blog__input><label>{{ editProfCtrl.pricePlaceholder }}</label><input class=form-control type=text ui-money-mask=0 maxlength=9 name=searchPrice ng-disabled=!editProfCtrl.canEditDomainInfo() ng-model=editProfCtrl.url.price ng-change=\"editProfCtrl.domainInformationChanged = true\" format=currency min=1><md-tooltip ng-show=!editProfCtrl.canEditDomainInfo() md-direction=top>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><div class=errors ng-messages=domainInformationForm.searchPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div></div></div><div class=pending-state-row><md-icon ng-hide=\"$mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showPriceSEO()>info</md-icon><md-tooltip ng-show=!editProfCtrl.canEditDomainInfo() md-direction=top>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><div ng-if=false class=info-block><md-icon ng-show=\"editProfCtrl.url.href && $mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showPriceSEO()>info</md-icon><md-icon ng-if=\"!editProfCtrl.url.href && $mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showWarningPopup()>info</md-icon></div><div layout-align=\"start center\" flex class=domain-info-icon-container><md-icon class=state-icon ng-class=editProfCtrl.url.state flex=5 ng-click=editProfCtrl.showRejectionReasons(editProfCtrl.url)>{{ editProfCtrl.changeIcon(editProfCtrl.url.state) }}<md-tooltip>{{ editProfCtrl.getIconTooltip(editProfCtrl.url.state) }}</md-tooltip></md-icon></div></div></div><div class=desc-block><div class=\"sposored-blog__input md-block\" flex=85><label>Description</label><md-tooltip md-direction=top md-delay=500 ng-show=editProfCtrl.canEditDomainInfo()>\'Use your meta description or write your own. If you write your own, include friendly KWs. IE >> \"Health | Travel | Tech \" etc.\'</md-tooltip><md-tooltip ng-if=!editProfCtrl.canEditDomainInfo()>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><textarea class=form-control ng-trim=true maxlength=450 ng-model=editProfCtrl.url.description ng-change=\"editProfCtrl.domainInformationForm = domainInformationForm\" ng-disabled=!editProfCtrl.canEditDomainInfo() rows=2 md-select-on-focus name=description required>\n          </textarea><div ng-messages=domainInformationForm.description.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></form></div><div ng-if=domainInformationForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=editProfCtrl.saveSearchContent(domainInformationForm) ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/gridDialog.html","<md-dialog class=grid-container style=\"height: auto\"><md-toolbar><div class=md-toolbar-tools><h2>Suggested Pricing for Guest Content (SEO)</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><da-pricing-chart da=da></da-pricing-chart></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfile/partials/guestPost.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span>{{ editProfCtrl.profile.name }}</span></p></section><section><form class=create-profile__seo name=form ng-submit=form.$valid><div class=create-profile__seo__text>This page is all about guest posts. This is NOT advertorial content endorsing a product or service. It does not need to be disclosed.</div><div class=create-profile__seo__input style=\"padding-top: 0\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Domain</span></label><input name=url ng-model=editProfCtrl.url.href ng-class=\"{\'blank__user-data\': editProfCtrl.showFormErrors && !editProfCtrl.url.href}\" ng-blur=editProfCtrl.checkSEO(form) ng-disabled=\"editProfCtrl.url.href && editProfCtrl.url.addedFromGoogle\" tabindex=2 class=\"form-control url-input\" type=text required placeholder=https://MyWebsiteURL.com><div ng-show=editProfCtrl.showFormErrors ng-messages=form.url.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div><div ng-message=url>This url doesn\'t seem good, please check.</div><div ng-message=active>Hello! We\'re sorry but this URL has already been {{editProfCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=unmatched>Hello! This URL has already been submitted before. Please email admin@scalefluence.com to discuss your price.</div></div></div><div class=info-icon><md-button ng-click=\"editProfCtrl.showDialog(\'Do you have a guest post requirements page?\', \'This field is not required.\n                                But if you have a page on your website that will help our writers make great content\n                                for you, add it below. Our content team is required to read this before starting on a\n                                topic.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__radios><div class=form-group ng-if=editProfCtrl.isContributor()><label>Publication Author Page</label><input class=form-control url-input name=authorPage ng-model=editProfCtrl.url.author_page placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\"><div class=errors ng-messages=form.authorPage.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div class=create-profile__seo__input><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Required article length?</span></label><div ng-click=\"editProfCtrl.setUrlRequiredLength(\'750-1000\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=750-1000 ng-model=editProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"editProfCtrl.setUrlRequiredLength(\'1000-1250\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=1000-1250 ng-model=editProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"editProfCtrl.setUrlRequiredLength(\'1250-1500\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=1250-1500 ng-model=editProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"editProfCtrl.setUrlRequiredLength(\'1500-+\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=1500-+ ng-model=editProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1500 +</span></label></div><div class=errors2 ng-show=editProfCtrl.showFormErrors ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Are the links Do-Follow?</span></label><div ng-click=editProfCtrl.setUrlFollowLink(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=true ng-model=editProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=editProfCtrl.setUrlFollowLink(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=false ng-model=editProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=editProfCtrl.showFormErrors ng-messages=form.follow_link.$error><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"editProfCtrl.showDialog(\'Are the links Do-Follow?\',\n                          \'Do-follow links MUST NOT have either the \\\'rel = nofollow\\\' or \\\'rel = sponsored\\\'\n                          tag on the link.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Do You Allow Home Page Links?</span></label><div ng-click=editProfCtrl.setUrlAllowHomepage(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=true ng-model=editProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=editProfCtrl.setUrlAllowHomepage(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=false ng-model=editProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=editProfCtrl.showFormErrors ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"editProfCtrl.showDialog(\'Do You Allow Home Page Links?\',\n                          \'Home page links with us are 99% brand name links. Very safe and very natural.\n                           Selecting this option also means you are open to linking to service pages.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>I only allow links to blog posts</span></label><div ng-click=editProfCtrl.setUrlAllowBlogPost(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=true ng-model=editProfCtrl.url.allow_blog_post ng-disabled=\"editProfCtrl.url.allow_home_page == \'true\';\" class=form-check-input name=allow_blog_post type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=editProfCtrl.setUrlAllowBlogPost(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" value=false ng-model=editProfCtrl.url.allow_blog_post ng-disabled=\"editProfCtrl.url.allow_home_page == \'true\';\" class=form-check-input name=allow_blog_post type=radio><label class=form-check-label for=radio10><span>No</span></label></div><div class=errors2 ng-show=editProfCtrl.showFormErrors ng-messages=form.allow_blog_post.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"editProfCtrl.showDialog(\'I only allow links to blog posts\',\n                                \'Selecting this option means that you will only be linking to non-promotional webpages\n                                located on a clients blog. Selecting this option usually means you will get less orders.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Who Will Be Doing the Content?</span> <span class=error-message ng-if=editProfCtrl.showMissingContentTypeError><br>Need to select type of Content</span></label><div ng-click=\"editProfCtrl.setContentType(\'own\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" tabindex=7 ng-disabled=$root.isLoading ng-model=editProfCtrl.profile.contentType value=own class=form-check-input name=contentType type=radio><label class=form-check-label><span>I write my own content. Period.</span></label></div><div ng-click=\"editProfCtrl.setContentType(\'ghosted\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" tabindex=8 ng-disabled=$root.isLoading ng-model=editProfCtrl.profile.contentType value=ghosted class=form-check-input name=contentType type=radio><label class=form-check-label for=radio6><span>I accept ghosted content.</span></label></div><div ng-if=false ng-click=\"editProfCtrl.setContentType(\'collaborate\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" tabindex=9 ng-disabled=$root.isLoading ng-model=editProfCtrl.profile.contentType value=collaborate class=form-check-input name=contentType type=radio required><label class=form-check-label for=radio7><span>I can do either. Open to collaboration.</span></label></div><div class=errors2 ng-show=editProfCtrl.showFormErrors ng-messages=form.contentType.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Do you have a guest post requirements page?</span></label><textarea ng-disabled=$root.isLoading ng-model=editProfCtrl.url.post_requirements name=description maxlength=100 class=form-control rows=2 placeholder=\"\"></textarea></div><div class=info-icon><md-button ng-click=\"editProfCtrl.showDialog(\'Do you have a guest post requirements page?\', \'This field is not required.\n                                But if you have a page on your website that will help our writers make great content\n                                for you, add it below. Our content team is required to read this before starting on a\n                                topic.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><input ui-money-mask=0 maxlength=9 name=searchPrice ng-model=editProfCtrl.url.price ng-disabled=!editProfCtrl.url.href format=currency min=1 ng-required=\"editProfCtrl.isContributor() || editProfCtrl.isBroker()\" class=form-control ng-class=\"{\'blank__audience-data\': editProfCtrl.showFormErrors && !editProfCtrl.url.price && !editProfCtrl.isBlogger()}\" type=text placeholder=\"Your price per post (USD)\"><div class=info-icon><md-button ng-click=editProfCtrl.showPriceSEO() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=errors ng-messages=form.searchPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editProfCtrl.goEditProfile()>Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=\"editProfCtrl.saveChanges(\'audienceDemographics\')\" ng-disabled=$root.isLoading>Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/header.html","<div class=edit-profile__main-data><div class=edit-profile__main-data__photo><image-selector image=editProfCtrl.profile.image edit=true ng-disabled=$root.isLoading></image-selector></div><form class=edit-profile__main-data__form name=form><div class=edit-profile__main-data__buttons><button ng-if=\"editProfCtrl.isBroker() || editProfCtrl.isContributor()\" class=\"btn btn-white btn-auto btn-small\" ng-click=editProfCtrl.editDomain($event)>Add New URL</button> <button class=\"btn btn-white btn-auto btn-small hide-on-mobile\" ng-click=editProfCtrl.showCsvDialog()>Add Multiple URLs</button> <button ng-if=form.$dirty class=\"btn btn-default btn-auto\" ng-click=editProfCtrl.saveHeaderChanges(form) ng-disabled=$root.isLoading>Save Changes</button></div><div class=edit-profile__main-data__inputs><div class=form-group><label>Name</label><input class=form-control ng-model=editProfCtrl.profile.name name=name required unique-on=editProfCtrl.profileNames ng-disabled=$root.isLoading><div ng-messages=form.name.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div></div><div class=selected-spreadsheet layout=row ng-show=editProfCtrl.csv layout-align=\"end center\" flex><md-icon class=md-accent ng-if=editProfCtrl.csv ng-click=editProfCtrl.clearCsv()>delete</md-icon><md-input-container><input name=csv class=highlighted disabled=disabled ng-model=editProfCtrl.csv.name></md-input-container><md-button class=\"btn btn-default\" ng-if=editProfCtrl.csv ng-click=editProfCtrl.sendFileToAdmin()>Submit for approval</md-button><span class=\"error-message errors\" ng-show=editProfCtrl.spreadsheetError flex>Remember to send the file to admin.</span></div><div ng-if=false class=form-group><label>Description</label><textarea class=form-control rows=3 placeholder=\"Please describe in detail what you need assistance with. We will reply promptly.\">Be colorful. Pitch yourself with easy keywords to be found by our partners. Travel, tech, business, health, entertainment, etc. Words like this are easy to search.</textarea></div></div></form></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/influencerPartial.html","<!-- partial for social content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/socialContent.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/language.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editAudienceCtrl.languagesList elements-limit=2 ng-model=editAudienceCtrl.profile.languages selector-title=\"Select Up to 2 languages (you speak)\" hide-elements=false placeholder=\"Select languages\" has-changed=editAudienceCtrl.hasChangedLanguages on-change=editAudienceCtrl.languagesChanged() info-text=\"Select Up to 2 languages (you speak)\" highlight-blank-audience-fields=editAudienceCtrl.showFormErrors flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/pets.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editAudienceCtrl.petsList elements-limit=2 ng-model=editAudienceCtrl.profile.pets selector-title=\"Select Up to 2 Pets (you own)\" hide-elements=false placeholder=\"Select pets\" has-changed=editAudienceCtrl.hasChangedPets on-change=editAudienceCtrl.petsChanged() highlight-blank-audience-fields=editAudienceCtrl.showFormErrors flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/pinterest.html","pinterest");
$templateCache.put("app/pages/profiles/editProfile/partials/rowDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>{{ rowHeader }}</h2></div></md-toolbar><md-dialog-content layout-padding layout=column layout-align=\"start start\"><div><span class=content-format>{{ content }}</span><br><span class=content-format>{{ contentLineTwo }}</span></div><row followers=followers network=network header=header></row></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfile/partials/socialContent.html","<div ng-if=editProfCtrl.isBlogger() ng-include=\"\'app/pages/profiles/editProfile/partials/webContent.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfile/partials/facebook.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfile/partials/instagram.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfile/partials/youtube.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfile/partials/twitter.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfile/partials/twitch.html","twitch");
$templateCache.put("app/pages/profiles/editProfile/partials/webContent.html","<div class=edit-profile__content><div class=edit-profile__inner><section class=profile-header><p>Profile: <span>{{ editProfCtrl.profile.name }}</span></p></section><section ng-cloak class=edit-profile__block><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">Sponsored reviews & product giveaways requires google analytics connection. We will verify traffic only.</div><div class=\"social__common-info__item text-uppercase\">Content drafts will be submitted for review. This is not a guest post product. Links are no-follow and content will be disclosed as paid. Use whatever disclosure you feel comfortable with.</div><div class=\"social__common-info__item text-uppercase\">Once ga is connected, put your prices below. Click on orange (?) icons for product description.</div></div><form class=social-handle name=webContentForm ng-submit=webContentForm.$valid><div class=sponsored-social__row><img src=\"{{ editProfCtrl.showProgressCircular ? \'assets/images/spinner.gif\' : \'assets/images/google.svg\'}}\" alt><div class=sponsored-social__button><button ng-click=editProfCtrl.handleWebContentConnection($event) class=\"btn btn-white ng-cloak\" type=button>{{editProfCtrl.profile.web_content.href ? \'Disconnect Account\' : \'Authorize New Account\'}}</button></div><div class=sposored-social__input ng-if=editProfCtrl.analytics.length><label>{{ editProfCtrl.getPropertyLabelGA() }}</label><select class=form-control name=gaUrl ng-change=editProfCtrl.analyticSelected() ng-disabled=!editProfCtrl.analyticsAuthorized ng-options=\"account as account.name for account in editProfCtrl.analytics track by account.id\" ng-model=editProfCtrl.selectedAnalytics></select><div class=errors ng-messages=form.gaUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=url>You must add http(s):// in front of the domain.</div></div></div></div><div class=\"social__common-info suggested__prices-info\" ng-show=editProfCtrl.profile.web_content.href><div class=\"social__common-info__item text-uppercase\">Suggested Pricing for Sponsored Web Content ({{editProfCtrl.profile.web_content.website_url}}) <span><md-button ng-click=editProfCtrl.showGaDetails() ng-show=editProfCtrl.profile.web_content.href class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div><div><h3 class=text-center>Monthly Visitors</h3><row followers=editProfCtrl.profile.web_content.muv network=GA header=editProfCtrl.profile.web_content.header></row></div></div><div class=social__promotion-description ng-repeat=\"handle in editProfCtrl.profile.web_content.web_content_prices | orderBy:\'info\'\"><div class=\"social__item-title social__item-col left\"><p class=text-uppercase ng-bind-html=handle.description></p></div><div class=\"social__item-col right\"><div ng-if=editProfCtrl.profile.web_content.href class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div ng-mouseover=\"handle.showStatusMsg=true\" ng-mouseleave=\"handle.showStatusMsg=false\"><input maxlength=9 name=price ng-required=editProfCtrl.gaPriceChangeEnabled() ng-class=\"{\'disabled\': !editProfCtrl.profile.web_content.href || (editProfCtrl.profile.web_content.href && !editProfCtrl.canEditSocialPrice(handle) )}\" ng-disabled=\"!editProfCtrl.profile.web_content.href || (editProfCtrl.profile.web_content.href && !editProfCtrl.canEditSocialPrice(handle) )\" ng-class=editProfCtrl.getPriceClass(handle) ng-model=handle.price ng-keyup=\"handle.changed = true\" ng-change=\"editProfCtrl.webContentForm = webContentForm\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div><div class=\"status-container price-status\" ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.web_content.href && handle.price && handle.state && !handle.changed && handle.showStatusMsg\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</div></div></div></form></section><section class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-small btn-auto no-animate\" ng-click=editProfCtrl.goEditProfile()>Back</button> <button class=\"btn btn-default btn-small btn-auto no-animate\" ng-click=editProfCtrl.saveWebContent(webContentForm) ng-disabled=\"!editProfCtrl.profile.web_content.href || !webContentForm.$dirty || $root.isLoading\">Save</button></section></div></div>");
$templateCache.put("app/pages/profiles/editProfile/notes/notes.html","<md-dialog class=admin-notes-dialog><md-toolbar><div class=md-toolbar-tools><h2>Reason Why We Declined Approval</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><p class=notes-content><span>{{ noteCtrl.note }}</span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=noteCtrl.ok() ng-disabled=$root.isLoading>Ok, Go to Edit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfileV1/csvModal/csvModal.html","<div class=dialog-container layout-align=\"center center\"><md-dialog><md-dialog-content><md-toolbar flex><div class=md-toolbar-tools><h2>Upload Spreadsheet</h2></div></md-toolbar><div layout-padding flex><div class=md-dialog-content><p>PLEASE REVIEW THIS EXAMPLE BEFORE UPLOADING</p><p>*Note: Any URLs that already exist within Scalefluence will automatically be ignored.</p></div><div class=upload-modal><table class=csv-modal><tr><th>URL</th><th ng-if=csvModalCtrl.isContributor>Author Page</th><th ng-if=csvModalCtrl.isContributor>Describe what you write about</th><th>Do Follow Links?</th><th>Alow Home Page Links?</th><th>Only Link to Blog Posts?</th><th>750-1000 words?</th><th>1000-1250 words?</th><th>1250-1500 words?</th><th>1500+ words?</th><th>Best Price</th></tr><tbody><tr><td>https://HealthWebSite.com</td><td ng-if=csvModalCtrl.isContributor>https://HealthWebSite.com<br>/author/Jane-Doe</td><td class=wrap-description ng-if=csvModalCtrl.isContributor>I am one of the most popular authors on this site.</td><td>Yes</td><td>No</td><td>Yes</td><td>&times</td><td>&nbsp</td><td>&nbsp</td><td>&nbsp</td><td>{{ csvModalCtrl.getPrice() }}</td></tr></tbody></table></div><md-card-content class=selected-file ng-show=csvModalCtrl.csv flex layout=row layout-align=\"center center\"><md-input-container class=normal-input flex><label>Selected csv file</label><input name=csv class=highlighted disabled=disabled ng-model=csvModalCtrl.csv.name></md-input-container><md-button class=md-accent ng-if=csvModalCtrl.csv ng-click=csvModalCtrl.clearCsv()>Remove</md-button></md-card-content></div><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><a class=\"btn btn-white btn-small\" ng-href={{csvModalCtrl.getFileRoute()}} ng-click=csvModalCtrl.download()>Download Sample File</a><md-button class=\"btn btn-white btn-small\" type=file ngf-select class=md-accent ng-model=csvModalCtrl.csv name=csv ngf-accept=\"\'.xlsx, .csv\'\" ng-disabled=!$root.sampleDownloaded>Select file</md-button><md-button class=\"btn btn-white btn-small\" ng-click=csvModalCtrl.submit() ng-disabled=!$root.sampleDownloaded>Upload</md-button></md-dialog-actions></md-dialog></div>");
$templateCache.put("app/pages/profiles/editProfileV1/editModalInfo/editInfoDialog.html","<md-dialog class=edit-dialog-container><md-toolbar><div class=md-toolbar-tools><h2>{{editInfoCtrl.title}}</h2></div></md-toolbar><md-dialog-content layout=column><div layout=row class=rejected-reasons flex layout-align=\"start center\" ng-if=editInfoCtrl.showRejectedReasons><span>Changes Needed:</span><div layout-padding class=bold-red>{{ editInfoCtrl.rejectedReasons() }}</div></div><form name=form layout-padding><div layout=column><div class=\"form-group form-group--radios\"><label>Domain</label><input class=form-control type=text required name=domainUrl ng-model=editInfoCtrl.url.href ng-blur=editInfoCtrl.checkURL(form) placeholder=http://www.awesome.site.com ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"> <span class=error-message ng-if=editInfoCtrl.showMinValues>Minimum MOZ Domain Authority is 15 and Majestic Trust Flow is 10 </span><span class=error-message ng-if=editInfoCtrl.showUrlDisabled>{{ editInfoCtrl.getUrlDisabledError() }} </span><span class=error-message ng-if=editInfoCtrl.urlStatsRequestFailed>DATA PROVIDERS ARE SLOW RIGHT NOW AND PREVENTING NEW URL SUBMISSIONS. WE HAVE BEEN NOTIFIED AND WILL LET KNOW WHEN IT\'S BACK UP.</span><div class=error-message ng-messages=form.domainUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=you-own>You have already submitted this before. If you wish change price, please do so under Pricing and Pausing on your dashboard..</div><div ng-message=url>Check this url, it doesn\'t seem good.</div><div ng-message=duplicate>This URL has already been submitted before and cannot be accepted. Please email admin@scalefluence.com if you would like to discuss.</div><div ng-message=unmatched>Someone has already submitted this site for significantly less. Please email admin@scalefluence.com if you would like to discuss.</div></div></div><div ng-if=editInfoCtrl.isNewDomain() layout=row layout-align=\"start center\"><div class=\"form-group form-group--radios\"><label>{{ editInfoCtrl.pricePlaceholder }}</label><input class=form-control type=text ui-money-mask=0 maxlength=9 required name=urlPrice ng-model=editInfoCtrl.url.price format=currency min=1 ng-blur=editInfoCtrl.checkURL(form) ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"><div class=errors ng-messages=form.urlPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div><div ng-message=unmatched>Someone has already submitted this site for significantly less.</div></div><span class=error-message ng-if=editInfoCtrl.showUrlDisabled>{{ editInfoCtrl.getUrlDisabledError() }}</span></div><label class=suggested-price ng-show=editInfoCtrl.suggestedPrice><i>Suggested price based on DA = {{ editInfoCtrl.domInfo.domain_authority }} and TF = {{ editInfoCtrl.domInfo.trust_flow }}</i></label></div><div ng-if=!editInfoCtrl.isNewDomain() layout=row layout-align=\"start center\"><div class=form-group><label>Price: ${{ editInfoCtrl.url.price }}</label><div>(*Use Pricing &amp; Pausing page for price changes)</div></div></div><div class=\"form-group form-group--radios\"><label>Please tell us word count for articles.</label><div class=errors2 ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'750-1000\')\" class=\"form-check form-check-radio form-check-inline\"><input value=750-1000 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1000-1250\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1000-1250 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1250-1500\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1250-1500 ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"editInfoCtrl.setUrlRequiredLength(\'1500-+\')\" class=\"form-check form-check-radio form-check-inline\"><input value=1500-+ ng-model=editInfoCtrl.url.required_length class=form-check-input name=required_length type=radio required><label class=form-check-label><span>1500 +</span></label></div></div><div class=\"form-group form-group--radios\"><label>Will you allow links to client\'s home page or main service pages?</label><div class=errors2 ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div><div ng-click=editInfoCtrl.setUrlAllowHomepage(true) class=\"form-check form-check-radio form-check-inline\"><input value=true ng-model=editInfoCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio required><label class=form-check-label><span>Yes</span></label></div><div ng-click=editInfoCtrl.setUrlAllowHomepage(false) class=\"form-check form-check-radio form-check-inline\"><input value=false ng-model=editInfoCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio required><label class=form-check-label><span>No</span></label></div><p class=error-message ng-show=editInfoCtrl.showHomePageError>{{ editInfoCtrl.showHomePageErrorMessage() }}</p></div><div class=\"form-group form-group--radios\"><label>Are the links Do-Follow?</label><div class=errors2 ng-if=!editInfoCtrl.followLinkOptionIsSet(editInfoCtrl.url)><div>This is required.</div></div><div ng-click=editInfoCtrl.setUrlFollowLink(true) class=\"form-check form-check-radio form-check-inline\"><input value=true ng-model=editInfoCtrl.url.follow_link class=form-check-input name=follow_link type=radio required><label class=form-check-label><span>Yes</span></label></div><div ng-click=editInfoCtrl.setUrlFollowLink(false) class=\"form-check form-check-radio form-check-inline\"><input value=false ng-model=editInfoCtrl.url.follow_link class=form-check-input name=follow_link type=radio required><label class=form-check-label><span>No</span></label></div><p class=error-message ng-show=editInfoCtrl.showFollowLinkError>{{ editInfoCtrl.showFollowLinkErrorMessage() }}</p></div><div class=\"form-group form-group--radios\" style=\"margin-bottom: 15px\" class=desc-group><label>Please tell us about your site, or click the button below to use your meta description.</label><button class=\"btn btn-white btn-small btn-auto no-animate\" style=\"margin-bottom: 15px\" ng-click=editInfoCtrl.getMetaDescription()>Use Meta Description</button><textarea class=form-control ng-trim=true maxlength=450 ng-model=editInfoCtrl.url.description rows=2 name=description required ng-disabled=\"$root.isLoading || editInfoCtrl.disable\">\n          </textarea><div class=errors ng-messages=form.description.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div layout=column><div ng-if=editInfoCtrl.isContributor class=form-group><label>Publication Author Page</label><input class=form-control url-input name=url ng-model=editInfoCtrl.profile.author_page placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\" ng-disabled=\"$root.isLoading || editInfoCtrl.disable\"><div class=errors ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div layout=row><div class=pausing-url ng-if=\"editInfoCtrl.showPause && editInfoCtrl.url.id\"><md-checkbox class=pause-url-check ng-model=editInfoCtrl.pausedValue ng-disabled=$root.isLoading><label class=pause-url-lbl>Pause URL <span class=pause-url-note ng-if=\"editInfoCtrl.pausedValue && !editInfoCtrl.disable\">- When paused is selected any changes won\'t have any effect</span></label></md-checkbox></div></div></div></form><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" ng-click=editInfoCtrl.cancel() ng-disabled=\" $root.isLoading\">Cancel</md-button><md-button class=\"btn btn-white btn-small\" ng-mousedown=editInfoCtrl.submit() ng-disabled=\"editInfoCtrl.showUrlDisabled || editInfoCtrl.urlStatsRequestFailed || editInfoCtrl.showMinValues || form.$invalid || $root.isLoading\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/audienceAge.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editProfCtrl.ageGroupList elements-limit=3 ng-model=editProfCtrl.profile.audience_age_groups selector-title=\"Select Up to 3 Age Groups\" placeholder=\"Select age groups\" on-change=editProfCtrl.audienceAgeChanged() info-text=\"Select Up to 3 Age Groups\" has-changed=editProfCtrl.hasChangedAudienceAge flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/audienceDemographics.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'audienceDemographics\', editProfCtrl.hasChangedAudienceDemographics)\" class=edit-profile__block-header><div ng-if=editProfCtrl.hideAudienceDemographics class=select-placeholder>Click to edit audience demographics</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit audience demographics</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideAudienceDemographics }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=social-handle ng-hide=editProfCtrl.hideAudienceDemographics><div ng-if=\"editProfCtrl.hasChangedPets || editProfCtrl.hasChangedAudienceAge ||\n       editProfCtrl.hasChangedAudienceEthnicities || editProfCtrl.hasChangedLanguages ||\n        editProfCtrl.hasChangedAudienceIncome || editProfCtrl.hasChangedAudienceGender\" class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editProfCtrl.saveChanges(\'audienceDemographics\')\" ng-disabled=$root.isLoading>Save</button></div><!-- partial for audience income and audience gender --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceIncomeAndGender.html\'\"></div><!-- partial for location/ ethnicity --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceEthnicity.html\'\"></div><!-- partial for languages --><div ng-include=\"\'app/pages/profiles/editProfile/partials/language.html\'\"></div><!-- partial for pets --><div ng-include=\"\'app/pages/profiles/editProfile/partials/pets.html\'\"></div><!-- partial for age --><div ng-include=\"\'app/pages/profiles/editProfile/partials/audienceAge.html\'\"></div></div><div ng-if=\"editProfCtrl.hasChangedPets || editProfCtrl.hasChangedAudienceAge ||\n       editProfCtrl.hasChangedAudienceEthnicities || editProfCtrl.hasChangedLanguages ||\n        editProfCtrl.hasChangedAudienceIncome || editProfCtrl.hasChangedAudienceGender\" class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editProfCtrl.saveChanges(\'audienceDemographics\')\" ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/audienceEthnicity.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editProfCtrl.ethnicitiesList elements-limit=3 ng-model=editProfCtrl.profile.audience_ethnicities hide-elements=false placeholder=\"Select ethnicity\" on-change=editProfCtrl.ethnicitiesChanged() has-changed=editProfCtrl.hasChangedAudienceEthnicities selector-title=\"Select Ethnicity / Geolocation of Your Audience (up to 3)\" flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/audienceIncomeAndGender.html","<div class=audience-select><div class=audience-select__block><h6 class=audience__title>Select Estimated Income of Audience</h6><select ng-change=\"editProfCtrl.hasChangedAudienceIncome = true\" class=form-control ng-model=editProfCtrl.profile.audience_estimated_income><option ng-repeat=\"income in editProfCtrl.audienceEstimatedIncomes\">{{income}}</option></select></div><div class=audience-select__block><h6 class=audience__title>Select gender of your audience</h6><select ng-change=\"editProfCtrl.hasChangedAudienceGender = true\" class=form-control ng-model=editProfCtrl.profile.audience_gender><option ng-repeat=\"option in editProfCtrl.audienceGenderList\">{{option}}</option></select></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/bloggerPartial.html","<h5 class=edit-profile__title>Blog & Social Media Connections<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=editProfCtrl.showInfo(4)><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h5><!-- partial for sponsored web content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/webContent.html\'\"></div><!-- partial for social content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/socialContent.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/broker&ContributorPartial.html","<h5 class=edit-profile__title>Domain information - Search Content (SEO)<md-button class=\"md-icon-button info-icons\" aria-label=info ng-click=editProfCtrl.showInfo(2)><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h5><div class=edit-profile__content><md-table-container><table class=table md-table ng-model=editProfCtrl.urls md-progress=promise><thead md-head md-order=editProfCtrl.query.order><tr md-row><th md-column md-order-by=href><a class=\"btn btn-link\" href=javascript:void(0)><span>Domain URL</span></a></th><th md-column md-order-by=description><a class=\"btn btn-link\" href=javascript:void(0)><span>Description</span></a></th><th md-column md-order-by=follow_link><a class=\"btn btn-link\" href=javascript:void(0)><span>DoFollow / NoFollow</span></a></th><th md-column md-order-by=domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th md-column md-order-by=trust_flow><a class=\"btn btn-link\" href=javascript:void(0)><span>TF</span></a></th><th md-column md-order-by=price><a class=\"btn btn-link\" href=javascript:void(0)><span>Payout</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Pause</span></a><div class=\"hint hint--active hint--bottom\"><div ng-mouseover=\"vm.showPauseHint = true\" ng-mouseleave=\"vm.showPauseHint = false\" class=hint__icon><svg class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg></div><div ng-show=vm.showPauseHint class=hint__text>Pausing a URL will deactivate it from getting orders. You can reactivate it anytime.</div></div></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Edit</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"url in editProfCtrl.filtered = (editProfCtrl.urls | filter: editProfCtrl.query.filter) |\n        orderBy: editProfCtrl.query.order |\n        limitTo: editProfCtrl.query.limit : (editProfCtrl.query.page -1) * editProfCtrl.query.limit\"><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.href | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.href }}</md-tooltip></td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"url.description || \'Will be processed as soon as possible\' | limitTo: 80\"><md-tooltip md-direction=bottom>{{ url.description || \'Will be processed as soon as possible\' }}</md-tooltip></td><td md-cell class=follow-cell>{{ editProfCtrl.setFollowValue(url) }}</td><td md-cell>{{ url.domain_authority }}</td><td md-cell>{{ url.trust_flow }}</td><td md-cell>{{ url.price | currency }}</td><td md-cell><div class=switcher><input ng-id=\"{{ url.id }}-pause\" type=checkbox ng-checked=editProfCtrl.getPausedStatus(url) ng-disabled=editProfCtrl.nonPausableUrl(url) aria-label=paused><label ng-if=editProfCtrl.nonPausableUrl(url) ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label><label ng-if=!editProfCtrl.nonPausableUrl(url) ng-click=\"editProfCtrl.pausedStateChanged(url, $index)\" ng-for=\"{{ url.id }}-pause\" data-on=ON data-off=OFF></label></div></td><td md-cell><md-tooltip class=custom-tooltip md-direction=bottom>{{ editProfCtrl.getPencilTooltip(url.state) }}</md-tooltip><md-icon ng-click=\"editProfCtrl.editDomain($event, url)\" ng-class=url.state>edit</md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=editProfCtrl.query.limit md-page=editProfCtrl.query.page md-total=\"{{ editProfCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/categories.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'categories\', editProfCtrl.hasChangedCategories, editProfCtrl.hideCategories)\" class=edit-profile__block-header><div ng-repeat=\"el in editProfCtrl.categories\"><div class=edit-profile__block-header__element>{{el.name}}</div></div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit categories</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideCategories }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=social-handle ng-hide=editProfCtrl.hideCategories><category-selector flex placeholder=\"Search categories here or click below\" ng-model=editProfCtrl.categories on-change=editProfCtrl.categoriesChanged() hide-categories=!showCategories edit-profile-mode=true hide-title=true has-changed=editProfCtrl.hasChangedCategories></category-selector></div><div ng-if=editProfCtrl.hasChangedCategories class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=\"editProfCtrl.saveChanges(\'categories\')\" ng-disabled=!editProfCtrl.categories.length ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/domainInformation.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'domainInformation\', domainInformationForm.$dirty, editProfCtrl.hideDomainInfo)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.url.description && editProfCtrl.hideAudienceAge\" class=select-placeholder>Click to edit description</div><div ng-if=editProfCtrl.url.description class=social-title>{{editProfCtrl.url.description.substring(0,150); }}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit description</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideDomainInfo }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=social-handle ng-hide=editProfCtrl.hideDomainInfo><form name=domainInformationForm><div layout=column layout-gt-sm=row layout-align-gt-sm=\"start center\"><div class=sposored-blog__input><label>URL</label><input class=\"form-control url-input\" url-input required name=url ng-model=editProfCtrl.url.href ng-disabled=true><div class=errors ng-messages=domainInformationForm.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern ng-show=!domainInformationForm.url.$error.required>This doesn\'t appear to be a valid URL. Please fix to move forward.</div><div ng-message=active>Hello! We\'re sorry but this URL has already been {{editProfCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=unmatched>Hello! This URL has already been submitted before. Please email admin@scalefluence.com to discuss your price.</div></div></div><div class=sposored-blog__input><label>{{ editProfCtrl.pricePlaceholder }}</label><input class=form-control type=text ui-money-mask=0 maxlength=9 name=searchPrice ng-disabled=!editProfCtrl.canEditDomainInfo() ng-model=editProfCtrl.url.price ng-change=\"editProfCtrl.domainInformationChanged = true\" format=currency min=1><md-tooltip ng-show=!editProfCtrl.canEditDomainInfo() md-direction=top>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><div class=errors ng-messages=domainInformationForm.searchPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div></div></div><div class=pending-state-row><md-icon ng-hide=\"$mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showPriceSEO()>info</md-icon><md-tooltip ng-show=!editProfCtrl.canEditDomainInfo() md-direction=top>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><div ng-if=false class=info-block><md-icon ng-show=\"editProfCtrl.url.href && $mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showPriceSEO()>info</md-icon><md-icon ng-if=\"!editProfCtrl.url.href && $mdMedia(\'gt-sm\')\" ng-click=editProfCtrl.showWarningPopup()>info</md-icon></div><div layout-align=\"start center\" flex class=domain-info-icon-container><md-icon class=state-icon ng-class=editProfCtrl.url.state flex=5 ng-click=editProfCtrl.showRejectionReasons(editProfCtrl.url)>{{ editProfCtrl.changeIcon(editProfCtrl.url.state) }}<md-tooltip>{{ editProfCtrl.getIconTooltip(editProfCtrl.url.state) }}</md-tooltip></md-icon></div></div></div><div class=desc-block><div class=\"sposored-blog__input md-block\" flex=85><label>Description</label><md-tooltip md-direction=top md-delay=500 ng-show=editProfCtrl.canEditDomainInfo()>\'Use your meta description or write your own. If you write your own, include friendly KWs. IE >> \"Health | Travel | Tech \" etc.\'</md-tooltip><md-tooltip ng-if=!editProfCtrl.canEditDomainInfo()>{{ editProfCtrl.displayPendingStateText() }}</md-tooltip><textarea class=form-control ng-trim=true maxlength=450 ng-model=editProfCtrl.url.description ng-change=\"editProfCtrl.domainInformationForm = domainInformationForm\" ng-disabled=!editProfCtrl.canEditDomainInfo() rows=2 md-select-on-focus name=description required>\n          </textarea><div ng-messages=domainInformationForm.description.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></form></div><div ng-if=domainInformationForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-click=editProfCtrl.saveSearchContent(domainInformationForm) ng-disabled=$root.isLoading>Save</button></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/facebook.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'facebook\', editProfCtrl.facebookForm.$dirty, editProfCtrl.hideFacebook)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.profile.facebook_handle.url && editProfCtrl.hideFacebook\" class=select-placeholder>Click to connect facebook</div><div ng-if=editProfCtrl.profile.facebook_handle.url class=social-title>{{editProfCtrl.profile.facebook_handle.url}}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit facebook</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideFacebook }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div ng-hide=editProfCtrl.hideFacebook><form name=facebookForm class=social-handle ng-init=\"editProfCtrl.facebookForm = facebookForm\"><div class=sponsored-social__row><img src=assets/images/facebook.svg alt><div class=sponsored-social__button><button ng-click=\"editProfCtrl.handleFacebookConnection(editProfCtrl.profile.facebook_handle, \'facebook\')\" class=\"btn btn-white\" type=button>{{editProfCtrl.profile.facebook_handle.url ? \'Disconnect Facebook\' : \'Connect Facebook\'}}</button></div></div><div class=social__promotion-description style=\"display: inline\"><div class=social__form-item ng-repeat=\"handle in editProfCtrl.profile.facebook_handle.social_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=\"!editProfCtrl.profile.facebook_handle.url || (editProfCtrl.profile.facebook_handle.url && !editProfCtrl.canEditSocialPrice(handle) )\" ng-required=editProfCtrl.profile.facebook_handle.url ng-model=handle.price ng-change=\"editProfCtrl.facebookForm = facebookForm\" ng-keyup=\"handle.changed = true\" ng-class=editProfCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><md-tooltip md-direction=top ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.facebook_handle.url && handle.price && handle.state && !handle.changed\" style=\"margin-top: 9px\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</md-tooltip></div></div></div></form><div ng-if=facebookForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-disabled=$root.isLoading ng-click=\"editProfCtrl.saveSocialContent(facebookForm, \'facebook\')\">Save</button></div></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/gridDialog.html","<md-dialog class=grid-container><md-toolbar><div class=md-toolbar-tools><h2>Suggested Pricing for Guest Content (SEO)</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><grid domain-authority=da trust-flow=tf></grid></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/header.html","<div class=edit-profile__main-data><div class=edit-profile__main-data__photo><image-selector image=editProfCtrl.profile.image edit=true ng-disabled=$root.isLoading></image-selector></div><form class=edit-profile__main-data__form name=form><div class=edit-profile__main-data__buttons><button ng-if=\"editProfCtrl.isBroker() || editProfCtrl.isContributor()\" class=\"btn btn-white btn-auto btn-small\" ng-click=editProfCtrl.editDomain($event)>Add New URL</button> <button class=\"btn btn-white btn-auto btn-small hide-on-mobile\" ng-click=editProfCtrl.showCsvDialog()>Add Multiple URLs</button> <button ng-if=form.$dirty class=\"btn btn-default btn-auto\" ng-click=editProfCtrl.saveHeaderChanges(form) ng-disabled=$root.isLoading>Save Changes</button></div><div class=edit-profile__main-data__inputs><div class=form-group><label>Name</label><input class=form-control ng-model=editProfCtrl.profile.name name=name required unique-on=editProfCtrl.profileNames ng-disabled=$root.isLoading><div ng-messages=form.name.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div></div><div class=selected-spreadsheet layout=row ng-show=editProfCtrl.csv layout-align=\"end center\" flex><md-icon class=md-accent ng-if=editProfCtrl.csv ng-click=editProfCtrl.clearCsv()>delete</md-icon><md-input-container><input name=csv class=highlighted disabled=disabled ng-model=editProfCtrl.csv.name></md-input-container><md-button class=\"btn btn-default\" ng-if=editProfCtrl.csv ng-click=editProfCtrl.sendFileToAdmin()>Submit for approval</md-button><span class=\"error-message errors\" ng-show=editProfCtrl.spreadsheetError flex>Remember to send the file to admin.</span></div><div ng-if=false class=form-group><label>Description</label><textarea class=form-control rows=3 placeholder=\"Please describe in detail what you need assistance with. We will reply promptly.\">Be colorful. Pitch yourself with easy keywords to be found by our partners. Travel, tech, business, health, entertainment, etc. Words like this are easy to search.</textarea></div></div></form></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/influencerPartial.html","<!-- partial for social content --><div class=edit-profile__section ng-include=\"\'app/pages/profiles/editProfile/partials/socialContent.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/instagram.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'instagram\', editProfCtrl.instagramForm.$dirty, editProfCtrl.hideInstagram)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.profile.instagram_handle.url && editProfCtrl.hideInstagram\" class=select-placeholder>Click to connect instagram</div><div ng-if=editProfCtrl.profile.instagram_handle.url class=social-title>{{editProfCtrl.profile.instagram_handle.url}}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit instagram</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideInstagram }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div ng-hide=editProfCtrl.hideInstagram><form name=instagramForm class=social-handle><div class=toggle ng-class=\"{ \'toggle-disabled\': editProfCtrl.profile.instagram_handle.url }\"><input type=radio ng-model=editProfCtrl.profile.instagram_handle.subtype value=verified name=igUserType id=verifiedIgUser checked=checked><label for=verifiedIgUser ng-click=\"editProfCtrl.setSubtype(editProfCtrl.profile.instagram_handle, \'verified\')\"><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am verified on IG</label><input type=radio ng-model=editProfCtrl.profile.instagram_handle.subtype value=simple name=igUserType id=simpleIgUser><label for=simpleIgUser ng-click=\"editProfCtrl.setSubtype(editProfCtrl.profile.instagram_handle, \'simple\')\"><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am just a normal user on IG</label></div><div class=sponsored-social__row><img src=assets/images/instagram.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"editProfCtrl.handleInstagramConnection(editProfCtrl.profile.instagram_handle, \'instagram\')\" class=\"btn btn-white\" type=button>{{editProfCtrl.profile.instagram_handle.url ? \'Disconnect Instagram\' : \'Connect Instagram\'}}</button></div></div><div class=social__promotion-description style=\"display: inline\"><div class=social__form-item ng-repeat=\"handle in editProfCtrl.profile.instagram_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=\"!editProfCtrl.profile.instagram_handle.url || (editProfCtrl.profile.instagram_handle.url && !editProfCtrl.canEditSocialPrice(handle) )\" ng-required=editProfCtrl.profile.instagram_handle.url ng-model=handle.price ng-change=\"editProfCtrl.instagramForm = instagramForm\" ng-keyup=\"handle.changed = true\" ng-class=editProfCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><md-tooltip md-direction=top ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.instagram_handle.url && handle.price && handle.state && !handle.changed\" style=\"margin-top: 9px\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</md-tooltip></div></div></div></form><div ng-if=instagramForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-disabled=$root.isLoading ng-click=\"editProfCtrl.saveSocialContent(instagramForm, \'instagram\')\">Save</button></div></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/language.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editProfCtrl.languagesList elements-limit=2 ng-model=editProfCtrl.profile.languages selector-title=\"Select Up to 2 languages (you speak)\" hide-elements=false placeholder=\"Select languages\" has-changed=editProfCtrl.hasChangedLanguages on-change=editProfCtrl.languagesChanged() info-text=\"Select Up to 2 languages (you speak)\" flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/pets.html","<div class=social-handle><elements-selector edit-profile-mode=true m-elements=editProfCtrl.petsList elements-limit=2 ng-model=editProfCtrl.profile.pets selector-title=\"Select Up to 2 Pets (you own)\" hide-elements=false placeholder=\"Select pets\" has-changed=editProfCtrl.hasChangedPets on-change=editProfCtrl.petsChanged() flex></elements-selector></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/rowDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>{{ rowHeader }}</h2></div></md-toolbar><md-dialog-content layout-padding layout=column layout-align=\"start start\"><div><span class=content-format>{{ content }}</span><br><span class=content-format>{{ contentLineTwo }}</span></div><row followers=followers network=network header=header></row></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/socialContent.html","<div ng-if=editProfCtrl.isBlogger() ng-include=\"\'app/pages/profiles/editProfileV1/partials/webContent.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/facebook.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/instagram.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/youtube.html\'\"></div><div ng-include=\"\'app/pages/profiles/editProfileV1/partials/twitter.html\'\"></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/twitter.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'twitter\',editProfCtrl.twitterForm.$dirty, editProfCtrl.hideTwitter)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.profile.twitter_handle.url && editProfCtrl.hideTwitter\" class=select-placeholder>Click to connect twitter</div><div ng-if=editProfCtrl.profile.twitter_handle.url class=social-title>{{editProfCtrl.profile.twitter_handle.url}}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit twitter</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideTwitter }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div ng-hide=editProfCtrl.hideTwitter><form name=twitterForm class=social-handle><div class=sponsored-social__row><img src=assets/images/twitter.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"editProfCtrl.handleTwitterConnection($event, editProfCtrl.profile.twitter_handle, \'twitter\')\" class=\"btn btn-white\" type=button>{{editProfCtrl.profile.twitter_handle.url ? \'Disconnect Twitter\' : \'Connect Twitter\'}}</button></div></div><div class=social__promotion-description style=\"display: inline\"><div class=social__form-item ng-repeat=\"handle in editProfCtrl.profile.twitter_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=\"!editProfCtrl.profile.twitter_handle.url || (editProfCtrl.profile.twitter_handle.url && !editProfCtrl.canEditSocialPrice(handle) )\" ng-required=editProfCtrl.profile.twitter_handle.url ng-model=handle.price ng-change=\"editProfCtrl.twitterForm = twitterForm\" ng-keyup=\"handle.changed = true\" ng-class=editProfCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><md-tooltip md-direction=top ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.twitter_handle.url && handle.price && handle.state && !handle.changed\" style=\"margin-top: 9px\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</md-tooltip></div></div></div></form><div ng-if=twitterForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-disabled=$root.isLoading ng-click=\"editProfCtrl.saveSocialContent(twitterForm, \'twitter\')\">Save</button></div></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/webContent.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'webContent\', editProfCtrl.webContentForm.$dirty, editProfCtrl.hideWebContent)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.profile.web_content.href && editProfCtrl.hideWebContent\" class=select-placeholder>Click to connect website</div><div ng-if=editProfCtrl.profile.web_content.href class=social-title>{{editProfCtrl.profile.web_content.website_url}}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit blog</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideWebContent }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div ng-hide=editProfCtrl.hideWebContent><div class=content-more-padding ng-cloak><form class=social-handle name=webContentForm ng-submit=webContentForm.$valid><div class=sponsored-social__row><img src=assets/images/google.svg alt><div class=sponsored-social__button><button ng-click=editProfCtrl.authorize($event) ng-hide=\"editProfCtrl.profile.web_content.href || editProfCtrl.showProgressCircular\" class=\"btn btn-white ng-cloak\" type=button>Authorize New Account</button> <button ng-click=editProfCtrl.disconnectGA() ng-hide=\"!editProfCtrl.profile.web_content.href || editProfCtrl.showProgressCircular\" class=\"btn btn-white ng-cloak\" type=button>Disconnect Account</button> <img class=ng-cloak ng-show=editProfCtrl.showProgressCircular src=assets/images/spinner.gif alt=loading> <span ng-if=false ng-show=\"editProfCtrl.hidden && !editProfCtrl.gaSaved\" class=set-analytics>Set Analytics Account &amp; Price</span> <span ng-if=false ng-show=\"editProfCtrl.hidden && editProfCtrl.gaSaved\" class=set-analytics>Price Changeable</span></div><div class=sposored-social__input ng-if=editProfCtrl.analytics.length><label>{{ editProfCtrl.getPropertyLabelGA() }}</label><select class=form-control name=gaUrl ng-change=editProfCtrl.analyticSelected() ng-disabled=!editProfCtrl.analyticsAuthorized ng-options=\"account as account.name for account in editProfCtrl.analytics track by account.id\" ng-model=editProfCtrl.selectedAnalytics></select><div class=errors ng-messages=form.gaUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=url>You must add http(s):// in front of the domain.</div></div></div></div><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in editProfCtrl.profile.web_content.web_content_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=editProfCtrl.profile.web_content.href class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-required=editProfCtrl.gaPriceChangeEnabled() ng-disabled=\"!editProfCtrl.profile.web_content.href || (editProfCtrl.profile.web_content.href && !editProfCtrl.canEditSocialPrice(handle) )\" ng-class=editProfCtrl.getPriceClass(handle) ng-model=handle.price ng-keyup=\"handle.changed = true\" name=price ng-change=\"editProfCtrl.webContentForm = webContentForm\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><md-tooltip md-direction=top ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.web_content.href && handle.price && handle.state && !handle.changed\" style=\"margin-top: 9px\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</md-tooltip></div></div></div><!-- actions --></form><div ng-if=editProfCtrl.webContentForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-disabled=\"$root.isLoading || webContentForm.$invalid || !editProfCtrl.profile.web_content.href\" ng-click=editProfCtrl.saveWebContent(webContentForm)>Save</button></div></div></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/partials/youtube.html","<div class=edit-profile__block><div ng-click=\"editProfCtrl.toggleEditProfileBlock(\'youtube\', editProfCtrl.youtubeForm.$dirty, editProfCtrl.hideYoutube)\" class=edit-profile__block-header><div ng-if=\"!editProfCtrl.profile.youtube_handle.url && editProfCtrl.hideYoutube\" class=select-placeholder>Click to connect youtube</div><div ng-if=editProfCtrl.profile.youtube_handle.url class=social-title>{{editProfCtrl.profile.youtube_handle.url}}</div><div class=edit-profile__cat-card__control><div class=edit-profile__info-text>Edit youtube</div><div class=edit-profile__cat-icon ng-class=\"{ \'rotated\': !editProfCtrl.hideYoutube }\"><svg class=\"icon icon--chevron\" style=\"margin-left: auto\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div ng-hide=editProfCtrl.hideYoutube><form class=social-handle name=youtubeForm><div class=sponsored-social__row><img class=\"d-none d-sm-block\" src=assets/images/yt_logo_rgb_light.png height=40px alt> <img class=\"d-block d-sm-none\" src=assets/images/yt_logo_rgb_light.png height=25px alt><div class=sponsored-social__button><button ng-click=\"editProfCtrl.handleYoutubeConnection($event, editProfCtrl.profile.youtube_handle, \'youtube\')\" class=\"btn btn-white\" type=button>{{ editProfCtrl.profile.youtube_handle.url ? \'Disconnect Youtube\' : \'Connect Youtube\' }}</button></div></div><div class=social__promotion-description style=\"display: inline\"><div class=social__form-item ng-repeat=\"handle in editProfCtrl.profile.youtube_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div class=info-icon><md-button ng-click=editProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=\"!editProfCtrl.profile.youtube_handle.url || (editProfCtrl.profile.youtube_handle.url && !editProfCtrl.canEditSocialPrice(handle) )\" ng-required=editProfCtrl.profile.youtube_handle.url ng-model=handle.price ng-change=\"editProfCtrl.youtubeForm = youtubeForm\" ng-keyup=\"handle.changed = true\" ng-class=editProfCtrl.getPriceClass(handle) format=currency name=price min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"><md-tooltip md-direction=top ng-class=editProfCtrl.getPriceClass(handle) ng-show=\"editProfCtrl.profile.youtube_handle.url && handle.price && handle.state && !handle.changed\" style=\"margin-top: 9px\">{{editProfCtrl.getEditSocialPriceInfo(handle.state)}}</md-tooltip></div></div></div></form><div ng-if=youtubeForm.$dirty class=\"edit-profile__main-data__buttons edit-profile__save-button__block\"><button class=\"btn btn-white btn-auto btn-small\" ng-disabled=$root.isLoading ng-click=\"editProfCtrl.saveSocialContent(youtubeForm, \'youtube\')\">Save</button></div></div></div>");
$templateCache.put("app/pages/profiles/editProfileV1/notes/notes.html","<md-dialog class=admin-notes-dialog><md-toolbar><div class=md-toolbar-tools><h2>Reason Why We Declined Approval</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><p class=notes-content><span>{{ noteCtrl.note }}</span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=noteCtrl.ok() ng-disabled=$root.isLoading>Ok, Go to Edit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/navigation.html","<div class=create-profile__pathway><span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 0, \'complete\': newProfCtrl.selectedIndex > 0}\">User & Photo</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 1, \'complete\': newProfCtrl.selectedIndex > 1}\">Categories</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"newProfCtrl.isBlogger() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 2, \'complete\': newProfCtrl.selectedIndex > 2}\">Sponsored Blog</span><svg ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor() && !newProfCtrl.isInfluencer()\" class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 3, \'complete\': newProfCtrl.selectedIndex > 3}\">Sponsored Social</span><svg ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor()\" class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"!newProfCtrl.isInfluencer() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 4, \'complete\': newProfCtrl.selectedIndex > 4}\">Guest post</span><svg ng-if=!newProfCtrl.isInfluencer() class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 5, \'complete\': newProfCtrl.selectedIndex > 5}\">Finish</span></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/social_navigation.html","<div ng-class=\"{\'influencer-profile__pathway\': newProfCtrl.isInfluencer(), \'blogger-profile__pathway\': newProfCtrl.isBlogger()}\" class=\"create-profile__pathway create-profile__social-pathway\"><span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 0, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 0}\">facebook</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 1, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 1}\">instagram</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 2, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 2}\">youtube</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 3, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 3}\">twitter</span></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/step1.html","<div class=create-profile__main-data><form name=newProfCtrl.form ng-submit=newProfCtrl.form.$valid><div class=create-profile__main-data__inputs><div class=\"form-group form-group--radios\"><label><span class=input-label-1>What Kind of User Are You?</span> <span class=error-message ng-if=newProfCtrl.showTypeError><br>Need to select one type of User</span></label><div ng-click=newProfCtrl.setAsBlogger() class=\"form-check form-check-radio form-check-inline\"><input tabindex=3 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.blogger() type=radio><label class=form-check-label><span>Blogger</span></label><md-tooltip md-direction=bottom md-autohide=true>You own a blog and social channels</md-tooltip></div><div ng-click=newProfCtrl.setAsInfluencer() class=\"form-check form-check-radio form-check-inline\"><input tabindex=4 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.influencer() type=radio><label class=form-check-label><span>Social Influencer</span></label><md-tooltip md-direction=bottom md-autohide=true>You are only on social. No blog</md-tooltip></div><div ng-click=newProfCtrl.setAsBroker() class=\"form-check form-check-radio form-check-inline\"><input tabindex=5 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.broker() type=radio><label class=form-check-label><span>Broker</span></label><md-tooltip md-direction=bottom md-autohide=true>You work with other blog owners</md-tooltip></div><div ng-click=newProfCtrl.setAsContributor() class=\"form-check form-check-radio form-check-inline\"><input tabindex=6 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.contributor() type=radio><label class=form-check-label><span>Contributor</span></label><md-tooltip md-direction=bottom md-autohide=true>You contribute content as an author.</md-tooltip></div></div><div class=form-group ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.name}\"><label>Profile Name</label><input ng-model=newProfCtrl.profile.name ng-change=newProfCtrl.setNewProfileName() name=name required unique-on=newProfCtrl.profileNames tabindex=1 class=form-control ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.name}\" type=text placeholder=\"Name your profile\"><div ng-show=newProfCtrl.showFormErrors ng-messages=newProfCtrl.form.name.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div></div><div class=form-group ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.href}\" ng-if=!newProfCtrl.isInfluencer()><label>Domain</label><input name=domainUrl ng-model=newProfCtrl.url.href ng-change=newProfCtrl.setNewProfileUrl() ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.href}\" ng-blur=newProfCtrl.checkSEO(newProfCtrl.form) tabindex=2 class=form-control type=text name=domain required placeholder=https://MyWebsiteURL.com ng-change=newProfCtrl.updateDomain()><div ng-show=newProfCtrl.showFormErrors ng-messages=newProfCtrl.form.domainUrl.$error md-auto-hide=false class=errors><div ng-message=required>Required unless only a Social Influencer.</div><div ng-message=url>This url doesn\'t seem good, please check.</div><div ng-message=active>Hello! We\'re sorry but this URL has already been {{newProfCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=unmatched>Hello! This URL has already been submitted before. Please email admin@scalefluence.com to discuss your price.</div></div></div></div></form><div class=create-profile__main-data__photo id=new-prof-photo style=\"border: 1px solid transparent\"><image-selector image=newProfCtrl.profile.image></image-selector></div></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/step2.html","<div class=create-profile__main-data><div class=create-profile__main-data__domain><div class=domain-info><h2 class=domain-info__name>{{ newProfCtrl.profile.name }}</h2><div class=domain-info__activity>{{ newProfCtrl.profile.profileType }}</div><div class=domain-info__url ng-if=!newProfCtrl.isInfluencer()><a href=#>{{ newProfCtrl.url.href }}</a></div><form class=domain-info__meta action=#><textarea ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.description}\" ng-model=newProfCtrl.url.description ng-change=newProfCtrl.setNewProfileDescription() name=description required class=form-control rows=3 placeholder=\"3 or 4 sentences about you and your audience is fine. Let marketers get to know you as that makes the connection more authentic. Then select your channel categories & answer some questions about your audience below!\"></textarea><button ng-if=!newProfCtrl.isInfluencer() class=\"btn btn-white\" type=button ng-mousedown=newProfCtrl.getMetaDescription() ng-disabled=\"!newProfCtrl.url.href || $root.isLoading\">Use my Meta Description</button></form></div></div></div><div class=create-profile__categories><category-selector placeholder=Search/Select ng-model=newProfCtrl.categories hide-categories=!newProfCtrl.categoriesOn text-to-show=\"Select categories for this domain\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></category-selector></div><div class=\"create-profile__show-control-btn d-block d-md-none\"><a class=\"btn btn-link\" href=javascript:void(0) ng-click=newProfCtrl.toggleCategories()>{{ newProfCtrl.categoriesActionMsg() }}</a></div><div id=audience-data class=create-profile__audience-data ng-if=\"newProfCtrl.isInfluencer() || newProfCtrl.isBlogger()\"><div class=audience-data__block><div class=audience__header ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.audience_gender}\"><h6 class=audience__title>select gender of your audience</h6></div><select class=form-control ng-model=newProfCtrl.profile.audience.audience_gender ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.audience_gender}\" ng-change=newProfCtrl.setAudienceGenderGroup()><option ng-repeat=\"option in newProfCtrl.audienceGenderList\">{{option}}</option></select></div><div class=audience-data__block><div class=audience__header ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.estimated_income}\"><h6 class=audience__title>Select Estimated Income of Audience</h6></div><select class=form-control ng-model=newProfCtrl.profile.audience.estimated_income ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.estimated_income}\" ng-change=newProfCtrl.setAudienceEstimatedIncome()><option ng-repeat=\"income in newProfCtrl.audienceEstimatedIncomes\">{{income}}</option></select></div><div class=audience-data__block><elements-selector storage-key-name=newProfileAudienceEthnicities m-elements=newProfCtrl.ethnicitiesList elements-limit=3 placeholder=Select ng-model=newProfCtrl.profile.audience.ethnicities selector-title=\"Select Ethnicity / Geolocation of Your Audience (up to 3)\" hide-elements=!newProfCtrl.ethnicitiesOn placeholder=\"Select ethnicity\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfilePets m-elements=newProfCtrl.petsList elements-limit=2 ng-model=newProfCtrl.profile.pets selector-title=\"Select Up to 2 Pets (you own)\" hide-elements=!newProfCtrl.petsOn placeholder=\"Select pets\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfileLanguages m-elements=newProfCtrl.languagesList elements-limit=2 ng-model=newProfCtrl.profile.languages selector-title=\"Select Up to 2 languages (you speak)\" hide-elements=!newProfCtrl.languagesOn placeholder=\"Select languages\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfileAudienceAgeGroups m-elements=newProfCtrl.ageGroupList elements-limit=3 ng-model=newProfCtrl.profile.audience.age_groups selector-title=\"Select Up to 3 Age Groups\" hide-elements=!newProfCtrl.ageGroupOn placeholder=\"Select age groups\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/step3.html","<div class=create-profile__sposored-blog><div class=sposored-blog><div class=sposored-blog__note>We need to verify your traffic through Google Analytics. For any blog you submit, please make sure you have GA already installed.<md-button ng-click=newProfCtrl.showInfo(3) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><form name=form ng-submit=form.$valid><div class=\"sposored-blog__form-item connect-block\"><div class=sposored-blog__logo><img src=assets/images/google.svg alt></div><div class=sposored-blog__button><button ng-click=newProfCtrl.authorize($event) ng-hide=\"newProfCtrl.analyticsAuthorized || newProfCtrl.showProgressCircular\" class=\"btn btn-white\" type=button>Connect Analytics</button> <button ng-click=newProfCtrl.disconnectGA() ng-hide=\"!newProfCtrl.analyticsAuthorized || newProfCtrl.showProgressCircular\" class=\"btn btn-white ng-cloak\" type=button>Disconnect Analytics</button> <img class=ng-cloak ng-show=newProfCtrl.showProgressCircular src=assets/images/spinner.gif alt=loading> <span ng-if=false ng-show=newProfCtrl.hidden class=set-analytics>Set Analytics Account &amp; Price</span></div><div class=sposored-blog__input><label>{{ newProfCtrl.getPropertyLabelGA() }}</label><select class=form-control name=gaUrl ng-change=newProfCtrl.analyticSelected() ng-disabled=!newProfCtrl.analyticsAuthorized ng-options=\"account as account.name for account in newProfCtrl.analytics track by account.id\" ng-model=newProfCtrl.selectedAnalytics></select><div class=errors ng-messages=form.gaUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=url>You must add http(s):// in front of the domain.</div></div></div><div ng-show=\"newProfCtrl.analyticsAuthorized && newProfCtrl.selectedAnalytics\" class=sposored-blog__suggested-price__info><div ng-show=newProfCtrl.web_content.muv>Based on our algorithm, your suggested price for a standard post is {{newProfCtrl.profile.web_content.suggested_post_price}} , a video is {{newProfCtrl.profile.web_content.suggested_video_price}}</div></div><md-button ng-click=\"newProfCtrl.showPriceGa(\'GA\', \'\', true)\" ng-show=newProfCtrl.profile.web_content.href class=\"md-icon-button info-icons\" style=\"margin: 11px 6px 0 6px\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button><md-button ng-if=!newProfCtrl.profile.web_content.href ng-click=newProfCtrl.showWarningPopup() class=\"md-icon-button info-icons\" style=\"margin: 11px 6px 0 6px\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div class=sposored-blog__note>Please put your most competitive pricing because there is no \"negotiating\" with our system. Saving you the headache of multiple emails about price. Give your best possible price for each please.</div><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.web_content.web_content_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.web_content.href class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-required=newProfCtrl.gaPriceChangeEnabled() ng-disabled=!newProfCtrl.gaPriceChangeEnabled() ng-model=handle.price name=price ng-change=\"newProfCtrl.setNewProfileWebContentPrice(handle.price, handle.key)\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form></div></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/step4.html","<div class=create-profile__sponsored-social><form name=socialsForm><div class=sponsored-social><div ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/social_navigation.html\'\"></div><div class=edit-profile__inner><div ng-show=\"newProfCtrl.selectedSocialIndex == 0\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/social/facebook.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 1\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/social/instagram.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 2\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/social/youtube.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 3\" ng-include src=\"\'app/pages/profiles/newProfile/tabPartials/social/twitter.html\'\"></div></div></div></form></div>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/step5.html","<form class=create-profile__seo name=form ng-submit=form.$valid><div class=create-profile__seo__text>This page is all about guest posts. This is NOT advertorial content endorsing a product or service. It does not need to be disclosed.</div><div class=create-profile__seo__radios><div class=form-group ng-if=newProfCtrl.isContributor()><div style=\"display: flex; align-items: center\"><label>Publication Author Page</label><div class=info-icon style=\"margin-bottom: .5rem\"><md-button ng-click=\"newProfCtrl.showDialog(\'Publication Author Page\',\n                          \'Do-follow links MUST NOT have either the \\\'rel = nofollow\\\' or \\\'rel = sponsored\\\'\n                          tag on the link.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><input class=form-control url-input name=authorPage ng-model=newProfCtrl.url.author_page ng-change=newProfCtrl.setNewProfileAuthorPage() placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\"><div class=errors ng-messages=form.authorPage.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div class=create-profile__seo__input><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Required article length?</span></label><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'750-1000\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=750-1000 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1000-1250\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1000-1250 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1250-1500\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1250-1500 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1500-+\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1500-+ ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1500 +</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Are the links Do-Follow?</span></label><div ng-click=newProfCtrl.setUrlFollowLink(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=true ng-model=newProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=newProfCtrl.setUrlFollowLink(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=false ng-model=newProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.follow_link.$error><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Are the links Do-Follow?\',\n                          \'This is not required, but if you do write for a publication, please give us your author page on the site. This will allow us to better understand what your contributor column is all about!\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Will You Allow Links to Client\'s Home Page or Main Service Pages?</span></label><div ng-click=newProfCtrl.setUrlAllowHomepage(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=true ng-model=newProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=newProfCtrl.setUrlAllowHomepage(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=false ng-model=newProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Do You Allow Home Page Links?\',\n                          \'Home page links with us are 99% brand name links. Very safe and very natural.\n                           Selecting this option also means you are open to linking to service pages.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Who Will Be Doing the Content?</span> <span class=error-message ng-if=newProfCtrl.showMissingContentTypeError><br>Need to select type of Content</span></label><div ng-click=\"newProfCtrl.setContentType(\'own\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=7 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=own class=form-check-input name=contentType type=radio><label class=form-check-label><span>I write my own content. Period.</span></label></div><div ng-click=\"newProfCtrl.setContentType(\'ghosted\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=8 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=ghosted class=form-check-input name=contentType type=radio><label class=form-check-label for=radio6><span>I accept ghosted content.</span></label></div><div ng-if=false ng-click=\"newProfCtrl.setContentType(\'collaborate\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=9 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=collaborate class=form-check-input name=contentType type=radio required><label class=form-check-label for=radio7><span>I can do either. Open to collaboration.</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.contentType.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Do you have a guest post requirements page?</span></label><textarea ng-disabled=$root.isLoading ng-model=newProfCtrl.url.post_requirements name=description maxlength=100 class=form-control rows=2 placeholder=\"\">\n      </textarea></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Do you have a guest post requirements page?\', \'This field is not required.\n                                But if you have a page on your website that will help our writers make great content\n                                for you, add it below. Our content team is required to read this before starting on a\n                                topic.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><input ui-money-mask=0 maxlength=9 name=searchPrice ng-model=newProfCtrl.url.price ng-change=newProfCtrl.setNewProfileUrlPrice() format=currency min=1 ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" class=form-control ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.price && !newProfCtrl.isBlogger()}\" type=text placeholder=\"Your price per post (USD)\"><div class=info-icon><md-button ng-click=newProfCtrl.showPriceSEO() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=errors ng-messages=form.searchPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div></div></form>");
$templateCache.put("app/pages/profiles/newProfile/partials/gridDialog.html","<md-dialog class=grid-container><md-toolbar><div class=md-toolbar-tools><h2>Suggested Pricing for Guest Content (SEO)</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div class=info-text><span>This content is NOT disclosed. You will NOT be endorsing a product or service.<br>You will be naturally linking to out to another website. Content will NOT be advertorial.</span></div><grid domain-authority=da trust-flow=tf></grid></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfile/partials/monthlyVisitorsDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Visitors Per Month</h2></div></md-toolbar><md-dialog-content style=\"min-width: 500px\"><div style=\"align-items: center; justify-content: space-around; margin: 10px 20px\"><p>How many visitors per month does this site receive?</p><input type=number ng-model=ctrl.visitorsPerMonth></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfile/partials/rowDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>{{ rowHeader }}</h2></div></md-toolbar><md-dialog-content layout-padding layout=column layout-align=\"start start\"><div class=text-center><span class=content-format>{{ content }}</span><br><span class=content-format>{{ contentLineTwo }}</span></div><row followers=followers network=network header=header></row></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfile/partials/socialHandleDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Please Choose Linked Facebook Page:</h2></div></md-toolbar><md-dialog-content style=\"min-width: 500px\"><div ng-repeat=\"account in ctrl.accounts\" style=\"display: flex; align-items: center; justify-content: space-around; margin: 10px 20px\"><div><img style=\"width: 50px; border-radius: 50%\" ng-src={{account.picture.data.url}}></div><div style=\"min-width: 300px\"><label class=form-check-label>{{account.name || account.username}}</label></div><div><input type=radio value={{account.name}} name=radio ng-model=ctrl.socialHandle></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfile/partials/twitterHandleDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Please specify your Twitter handle</h2></div></md-toolbar><md-dialog-content layout=row layout-align=\"center start\"><md-input-container class=\"md-block twitter-handle\"><label class=form-label>Twitter Handle</label><input name=twitterHandle ng-model=ctrl.twitterHandle></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/partials/gridDialog.html","<md-dialog class=grid-container><md-toolbar><div class=md-toolbar-tools><h2>Suggested Pricing for Guest Content (SEO)</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div class=info-text><span>This content is NOT disclosed. You will NOT be endorsing a product or service.<br>You will be naturally linking to out to another website. Content will NOT be advertorial.</span></div><grid domain-authority=da trust-flow=tf></grid></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/partials/monthlyVisitorsDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Visitors Per Month</h2></div></md-toolbar><md-dialog-content style=\"min-width: 500px\"><div style=\"align-items: center; justify-content: space-around; margin: 10px 20px\"><p>How many visitors per month does this site receive?</p><input type=number ng-model=ctrl.visitorsPerMonth></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/partials/rowDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>{{ rowHeader }}</h2></div></md-toolbar><md-dialog-content layout-padding layout=column layout-align=\"start start\"><div class=text-center><span class=content-format>{{ content }}</span><br><span class=content-format>{{ contentLineTwo }}</span></div><row followers=followers network=network header=header></row></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/partials/socialHandleDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Please Choose Linked Facebook Page:</h2></div></md-toolbar><md-dialog-content style=\"min-width: 500px\"><div ng-repeat=\"account in ctrl.accounts\" style=\"display: flex; align-items: center; justify-content: space-around; margin: 10px 20px\"><div><img style=\"width: 50px; border-radius: 50%\" ng-src={{account.picture.data.url}}></div><div style=\"min-width: 300px\"><label class=form-check-label>{{account.name || account.username}}</label></div><div><input type=radio value={{account.name}} name=radio ng-model=ctrl.socialHandle></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/partials/twitterHandleDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Please specify your Twitter handle</h2></div></md-toolbar><md-dialog-content layout=row layout-align=\"center start\"><md-input-container class=\"md-block twitter-handle\"><label class=form-label>Twitter Handle</label><input name=twitterHandle ng-model=ctrl.twitterHandle></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=ctrl.ok()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/navigation.html","<div class=create-profile__pathway><span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 0, \'complete\': newProfCtrl.selectedIndex > 0}\">User & Photo</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 1, \'complete\': newProfCtrl.selectedIndex > 1}\">Categories</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"newProfCtrl.isBlogger() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 2, \'complete\': newProfCtrl.selectedIndex > 2}\">Sponsored Blog</span><svg ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor() && !newProfCtrl.isInfluencer()\" class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 3, \'complete\': newProfCtrl.selectedIndex > 3}\">Sponsored Social</span><svg ng-if=\"!newProfCtrl.isBroker() && !newProfCtrl.isContributor()\" class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-if=\"!newProfCtrl.isInfluencer() || !newProfCtrl.profile.profileType\" ng-class=\"{\'active\': newProfCtrl.selectedIndex == 4, \'complete\': newProfCtrl.selectedIndex > 4}\">Guest post</span><svg ng-if=!newProfCtrl.isInfluencer() class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedIndex == 5, \'complete\': newProfCtrl.selectedIndex > 5}\">Finish</span></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/social_navigation.html","<div ng-class=\"{\'influencer-profile__pathway\': newProfCtrl.isInfluencer(), \'blogger-profile__pathway\': newProfCtrl.isBlogger()}\" class=\"create-profile__pathway create-profile__social-pathway\"><span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 0, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 0}\">facebook</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 1, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 1}\">instagram</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 2, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 2}\">youtube</span><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg> <span ng-class=\"{\'active\': newProfCtrl.selectedSocialIndex == 3, \'complete\': newProfCtrl.newProfileSelectedSocialIndex > 3}\">twitter</span></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/step1.html","<div class=create-profile__main-data><form name=newProfCtrl.form ng-submit=newProfCtrl.form.$valid><div class=create-profile__main-data__inputs><div class=\"form-group form-group--radios\"><label><span class=input-label-1>What Kind of User Are You?</span> <span class=error-message ng-if=newProfCtrl.showTypeError><br>Need to select one type of User</span></label><div ng-click=newProfCtrl.setAsBlogger() class=\"form-check form-check-radio form-check-inline\"><input tabindex=3 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.blogger() type=radio><label class=form-check-label><span>Blogger</span></label><md-tooltip md-direction=bottom md-autohide=true>You own a blog and social channels</md-tooltip></div><div ng-click=newProfCtrl.setAsInfluencer() class=\"form-check form-check-radio form-check-inline\"><input tabindex=4 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.influencer() type=radio><label class=form-check-label><span>Social Influencer</span></label><md-tooltip md-direction=bottom md-autohide=true>You are only on social. No blog</md-tooltip></div><div ng-click=newProfCtrl.setAsBroker() class=\"form-check form-check-radio form-check-inline\"><input tabindex=5 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.broker() type=radio><label class=form-check-label><span>Broker</span></label><md-tooltip md-direction=bottom md-autohide=true>You work with other blog owners</md-tooltip></div><div ng-click=newProfCtrl.setAsContributor() class=\"form-check form-check-radio form-check-inline\"><input tabindex=6 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.profileType class=form-check-input name=profileType ng-value=newProfCtrl.contributor() type=radio><label class=form-check-label><span>Contributor</span></label><md-tooltip md-direction=bottom md-autohide=true>You contribute content as an author.</md-tooltip></div></div><div class=form-group ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.name}\"><label>Profile Name</label><input ng-model=newProfCtrl.profile.name ng-change=newProfCtrl.setNewProfileName() name=name required unique-on=newProfCtrl.profileNames tabindex=1 class=form-control ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.name}\" type=text placeholder=\"Name your profile\"><div ng-show=newProfCtrl.showFormErrors ng-messages=newProfCtrl.form.name.$error md-auto-hide=false class=errors><div ng-message=required>This is required.</div><div ng-message=repeated>This name has already been used.</div></div></div><div class=form-group ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.href}\" ng-if=!newProfCtrl.isInfluencer()><label>Domain</label><input name=domainUrl ng-model=newProfCtrl.url.href ng-change=newProfCtrl.setNewProfileUrl() ng-class=\"{\'blank__user-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.href}\" ng-blur=newProfCtrl.checkSEO(newProfCtrl.form) tabindex=2 class=form-control type=text name=domain required placeholder=https://MyWebsiteURL.com ng-change=newProfCtrl.updateDomain()><div ng-show=newProfCtrl.showFormErrors ng-messages=newProfCtrl.form.domainUrl.$error md-auto-hide=false class=errors><div ng-message=required>Required unless only a Social Influencer.</div><div ng-message=url>This url doesn\'t seem good, please check.</div><div ng-message=active>Hello! We\'re sorry but this URL has already been {{newProfCtrl.state}} by our team before. Email admin@scalefluence.com if you need help.</div><div ng-message=unmatched>Hello! This URL has already been submitted before. Please email admin@scalefluence.com to discuss your price.</div></div></div></div></form><div class=create-profile__main-data__photo id=new-prof-photo style=\"border: 1px solid transparent\"><image-selector image=newProfCtrl.profile.image></image-selector></div></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/step2.html","<div class=create-profile__main-data><div class=create-profile__main-data__domain><div class=domain-info><h2 class=domain-info__name>{{ newProfCtrl.profile.name }}</h2><div class=domain-info__activity>{{ newProfCtrl.profile.profileType }}</div><div class=domain-info__url ng-if=!newProfCtrl.isInfluencer()><a href=#>{{ newProfCtrl.url.href }}</a></div><form class=domain-info__meta action=#><textarea ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.description}\" ng-model=newProfCtrl.url.description ng-change=newProfCtrl.setNewProfileDescription() name=description required class=form-control rows=3 placeholder=\"3 or 4 sentences about you and your audience is fine. Let marketers get to know you as that makes the connection more authentic. Then select your channel categories & answer some questions about your audience below!\"></textarea><button ng-if=!newProfCtrl.isInfluencer() class=\"btn btn-white\" type=button ng-mousedown=newProfCtrl.getMetaDescription() ng-disabled=\"!newProfCtrl.url.href || $root.isLoading\">Use my Meta Description</button></form></div></div></div><div class=create-profile__categories><category-selector placeholder=Search/Select ng-model=newProfCtrl.categories hide-categories=!newProfCtrl.categoriesOn text-to-show=\"Select categories for this domain\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></category-selector></div><div class=\"create-profile__show-control-btn d-block d-md-none\"><a class=\"btn btn-link\" href=javascript:void(0) ng-click=newProfCtrl.toggleCategories()>{{ newProfCtrl.categoriesActionMsg() }}</a></div><div id=audience-data class=create-profile__audience-data ng-if=\"newProfCtrl.isInfluencer() || newProfCtrl.isBlogger()\"><div class=audience-data__block><div class=audience__header ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.audience_gender}\"><h6 class=audience__title>select gender of your audience</h6></div><select class=form-control ng-model=newProfCtrl.profile.audience.audience_gender ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.audience_gender}\" ng-change=newProfCtrl.setAudienceGenderGroup()><option ng-repeat=\"option in newProfCtrl.audienceGenderList\">{{option}}</option></select></div><div class=audience-data__block><div class=audience__header ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.estimated_income}\"><h6 class=audience__title>Select Estimated Income of Audience</h6></div><select class=form-control ng-model=newProfCtrl.profile.audience.estimated_income ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.profile.audience.estimated_income}\" ng-change=newProfCtrl.setAudienceEstimatedIncome()><option ng-repeat=\"income in newProfCtrl.audienceEstimatedIncomes\">{{income}}</option></select></div><div class=audience-data__block><elements-selector storage-key-name=newProfileAudienceEthnicities m-elements=newProfCtrl.ethnicitiesList elements-limit=3 placeholder=Select ng-model=newProfCtrl.profile.audience.ethnicities selector-title=\"Select Ethnicity / Geolocation of Your Audience (up to 3)\" hide-elements=!newProfCtrl.ethnicitiesOn placeholder=\"Select ethnicity\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfilePets m-elements=newProfCtrl.petsList elements-limit=2 ng-model=newProfCtrl.profile.pets selector-title=\"Select Up to 2 Pets (you own)\" hide-elements=!newProfCtrl.petsOn placeholder=\"Select pets\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfileLanguages m-elements=newProfCtrl.languagesList elements-limit=2 ng-model=newProfCtrl.profile.languages selector-title=\"Select Up to 2 languages (you speak)\" hide-elements=!newProfCtrl.languagesOn placeholder=\"Select languages\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div><div class=audience-data__block><elements-selector storage-key-name=newProfileAudienceAgeGroups m-elements=newProfCtrl.ageGroupList elements-limit=3 ng-model=newProfCtrl.profile.audience.age_groups selector-title=\"Select Up to 3 Age Groups\" hide-elements=!newProfCtrl.ageGroupOn placeholder=\"Select age groups\" highlight-blank-audience-fields=newProfCtrl.showFormErrors flex></elements-selector></div></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/step3.html","<div class=create-profile__sposored-blog><div class=sposored-blog><div class=sposored-blog__note>We need to verify your traffic through Google Analytics. For any blog you submit, please make sure you have GA already installed.<md-button ng-click=newProfCtrl.showInfo(3) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><form name=form ng-submit=form.$valid><div class=\"sposored-blog__form-item connect-block\"><div class=sposored-blog__logo><img src=assets/images/google.svg alt></div><div class=sposored-blog__button><button ng-click=newProfCtrl.authorize($event) ng-hide=\"newProfCtrl.analyticsAuthorized || newProfCtrl.showProgressCircular\" class=\"btn btn-white\" type=button>Connect Analytics</button> <button ng-click=newProfCtrl.disconnectGA() ng-hide=\"!newProfCtrl.analyticsAuthorized || newProfCtrl.showProgressCircular\" class=\"btn btn-white ng-cloak\" type=button>Disconnect Analytics</button> <img class=ng-cloak ng-show=newProfCtrl.showProgressCircular src=assets/images/spinner.gif alt=loading> <span ng-if=false ng-show=newProfCtrl.hidden class=set-analytics>Set Analytics Account &amp; Price</span></div><div class=sposored-blog__input><label>{{ newProfCtrl.getPropertyLabelGA() }}</label><select class=form-control name=gaUrl ng-change=newProfCtrl.analyticSelected() ng-disabled=!newProfCtrl.analyticsAuthorized ng-options=\"account as account.name for account in newProfCtrl.analytics track by account.id\" ng-model=newProfCtrl.selectedAnalytics></select><div class=errors ng-messages=form.gaUrl.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=url>You must add http(s):// in front of the domain.</div></div></div><div ng-show=\"newProfCtrl.analyticsAuthorized && newProfCtrl.selectedAnalytics\" class=sposored-blog__suggested-price__info><div ng-show=newProfCtrl.web_content.muv>Based on our algorithm, your suggested price for a standard post is {{newProfCtrl.profile.web_content.suggested_post_price}} , a video is {{newProfCtrl.profile.web_content.suggested_video_price}}</div></div><md-button ng-click=\"newProfCtrl.showPriceGa(\'GA\', \'\', true)\" ng-show=newProfCtrl.profile.web_content.href class=\"md-icon-button info-icons\" style=\"margin: 11px 6px 0 6px\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button><md-button ng-if=!newProfCtrl.profile.web_content.href ng-click=newProfCtrl.showWarningPopup() class=\"md-icon-button info-icons\" style=\"margin: 11px 6px 0 6px\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><div class=sposored-blog__note>Please put your most competitive pricing because there is no \"negotiating\" with our system. Saving you the headache of multiple emails about price. Give your best possible price for each please.</div><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.web_content.web_content_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.web_content.href class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-required=newProfCtrl.gaPriceChangeEnabled() ng-disabled=!newProfCtrl.gaPriceChangeEnabled() ng-model=handle.price name=price ng-change=\"newProfCtrl.setNewProfileWebContentPrice(handle.price, handle.key)\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form></div></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/step4.html","<div class=create-profile__sponsored-social><form name=socialsForm><div class=sponsored-social><div ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/social_navigation.html\'\"></div><div class=create-profile__inner><div ng-show=\"newProfCtrl.selectedSocialIndex == 0\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/social/facebook.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 1\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/social/instagram.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 2\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/social/youtube.html\'\"></div><div ng-show=\"newProfCtrl.selectedSocialIndex == 3\" ng-include src=\"\'app/pages/profiles/newProfileV1/tabPartials/social/twitter.html\'\"></div></div></div></form></div>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/step5.html","<form class=create-profile__seo name=form ng-submit=form.$valid><div class=create-profile__seo__text>This page is all about guest posts. This is NOT advertorial content endorsing a product or service. It does not need to be disclosed.</div><div class=create-profile__seo__radios><div class=form-group ng-if=newProfCtrl.isContributor()><label>Publication Author Page</label><input class=form-control url-input name=authorPage ng-model=newProfCtrl.url.author_page ng-change=newProfCtrl.setNewProfileAuthorPage() placeholder=\"For example: http://HealthPublication.com/Author/Jane-Doe\"><div class=errors ng-messages=form.authorPage.$error multiple=multiple md-auto-hide=false><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div><div class=create-profile__seo__input><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Required article length?</span></label><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'750-1000\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=750-1000 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>750 - 1000</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1000-1250\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1000-1250 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1000 - 1250</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1250-1500\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1250-1500 ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1250 - 1500</span></label></div><div ng-click=\"newProfCtrl.setUrlRequiredLength(\'1500-+\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=1500-+ ng-model=newProfCtrl.url.required_length class=form-check-input name=required_length type=radio><label class=form-check-label><span>1500 +</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.required_length.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Are the links Do-Follow?</span></label><div ng-click=newProfCtrl.setUrlFollowLink(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=true ng-model=newProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=newProfCtrl.setUrlFollowLink(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=false ng-model=newProfCtrl.url.follow_link class=form-check-input name=follow_link type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.follow_link.$error><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Are the links Do-Follow?\',\n                          \'Do-follow links MUST NOT have either the \\\'rel = nofollow\\\' or \\\'rel = sponsored\\\'\n                          tag on the link.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Do You Allow Home Page Links?</span></label><div ng-click=newProfCtrl.setUrlAllowHomepage(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=true ng-model=newProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=newProfCtrl.setUrlAllowHomepage(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=false ng-model=newProfCtrl.url.allow_home_page class=form-check-input name=allow_home_page type=radio><label class=form-check-label><span>No</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.allow_home_page.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Do You Allow Home Page Links?\',\n                          \'Home page links with us are 99% brand name links. Very safe and very natural.\n                           Selecting this option also means you are open to linking to service pages.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>I only allow links to blog posts</span></label><div ng-click=newProfCtrl.setUrlAllowBlogPost(true) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=true ng-model=newProfCtrl.url.allow_blog_post ng-disabled=\"newProfCtrl.url.allow_home_page == \'true\';\" class=form-check-input name=allow_blog_post type=radio><label class=form-check-label><span>Yes</span></label></div><div ng-click=newProfCtrl.setUrlAllowBlogPost(false) class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" value=false ng-model=newProfCtrl.url.allow_blog_post ng-disabled=\"newProfCtrl.url.allow_home_page == \'true\';\" class=form-check-input name=allow_blog_post type=radio><label class=form-check-label for=radio10><span>No</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.allow_blog_post.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'I only allow links to blog posts\',\n                                \'Selecting this option means that you will only be linking to non-promotional webpages\n                                located on a clients blog. Selecting this option usually means you will get less orders.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Who Will Be Doing the Content?</span> <span class=error-message ng-if=newProfCtrl.showMissingContentTypeError><br>Need to select type of Content</span></label><div ng-click=\"newProfCtrl.setContentType(\'own\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=7 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=own class=form-check-input name=contentType type=radio><label class=form-check-label><span>I write my own content. Period.</span></label></div><div ng-click=\"newProfCtrl.setContentType(\'ghosted\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=8 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=ghosted class=form-check-input name=contentType type=radio><label class=form-check-label for=radio6><span>I accept ghosted content.</span></label></div><div ng-if=false ng-click=\"newProfCtrl.setContentType(\'collaborate\')\" class=\"form-check form-check-radio form-check-inline\"><input ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" tabindex=9 ng-disabled=$root.isLoading ng-model=newProfCtrl.profile.contentType value=collaborate class=form-check-input name=contentType type=radio required><label class=form-check-label for=radio7><span>I can do either. Open to collaboration.</span></label></div><div class=errors2 ng-show=newProfCtrl.showFormErrors ng-messages=form.contentType.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><div class=\"form-group form-group--radios\"><label><span class=input-label-1>Do you have a guest post requirements page?</span></label><textarea ng-disabled=$root.isLoading ng-model=newProfCtrl.url.post_requirements name=description maxlength=100 class=form-control rows=2 placeholder=\"\">\n      </textarea></div><div class=info-icon><md-button ng-click=\"newProfCtrl.showDialog(\'Do you have a guest post requirements page?\', \'This field is not required.\n                                But if you have a page on your website that will help our writers make great content\n                                for you, add it below. Our content team is required to read this before starting on a\n                                topic.\', \'OK\')\" class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=create-profile__seo__input style=\"padding-top: 6px\"><input ui-money-mask=0 maxlength=9 name=searchPrice ng-model=newProfCtrl.url.price ng-change=newProfCtrl.setNewProfileUrlPrice() format=currency min=1 ng-required=\"newProfCtrl.isContributor() || newProfCtrl.isBroker()\" class=form-control ng-class=\"{\'blank__audience-data\': newProfCtrl.showFormErrors && !newProfCtrl.url.price && !newProfCtrl.isBlogger()}\" type=text placeholder=\"Your price per post (USD)\"><div class=info-icon><md-button ng-click=newProfCtrl.showPriceSEO() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div></div><div class=errors ng-messages=form.searchPrice.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=min>Must be greater than zero</div></div></form>");
$templateCache.put("app/pages/quotes/newQuote/partials/matrixDialog.html","<md-dialog class=row-container><md-toolbar><div class=md-toolbar-tools layout=column layout-align=\"center start\"><h2>Prices Include Content</h2></div></md-toolbar><md-dialog-content layout-padding layout=column layout-align=\"start start\"><div class=row-container style=\"margin: 0 auto\"><table><tr><td class=row-name>Moz DA 20 to 40</td><td>$125 to $250</td></tr><tr><td class=row-name>Moz DA 40 to 60</td><td>$200 to $350</td></tr><tr><td class=row-name>Moz DA 60 to 90+</td><td>$350 to $950+</td></tr></table></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=close()>Ok, got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/quotes/quoteFor/modals/downloadQuote.html","<md-dialog class=download-content-dialog><md-toolbar class=\"toolbar toolbar-red\"><div class=md-toolbar-tools><h2>Important! Please read carefully!</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><ol><li>Our system is designed to give you the latest data from various sources. Adding or removing columns, or adding formulas in this CSV will result in failure upon upload.</li><li>If you need to massage the data, or check other data sources, please create a copy of this sheet first.</li><li>Just remember to use this clean version of the quote when uploading.</li><li>Any blogs you do not want to use in your current link order, just leave blank (no need to remove them). The system will automatically ignore them and leave them for future orders if you want</li><li>Finally, 2 columns are REQUIRED upon upload. Thease are \"Destination URL\" and \"Anchor text\". You can leave topic and notes blank if you wish.</li></ol></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"center center\"><button class=\"btn btn-small btn-white text-uppercase\" class=md-accent ng-click=quoteForCtrl.close()>I understand</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/reports/adv/activeContent/reportActiveContent.html","<div class=content-section><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white\" ui-sref=adv-dash><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><h2 class=content-section__title>Active Content</h2><md-button ng-click=repActCntCtrl.showInfo() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button><div class=content-section__right><form class=\"search-widget active-ads-search-widget\"><input ng-model=repActCntCtrl.searchReportActiveContents.filter class=form-control placeholder=Search...> <button type=submit ng-click=repActCntCtrl.searchReportActivecontent()><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form><div class=or-span>&nbsp;</div><div class=datepicker-period><div class=datepickerdiv><div class=datepicker__field><div class=datepicker__input><input foundation-datepicker initial-date=\"{{ repActCntCtrl.date_from }}\" min-date=\"{{ repActCntCtrl.minDateFrom }}\" max-date=\"{{ repActCntCtrl.maxDateFrom }}\" ng-model=repActCntCtrl.date_from ng-change=repActCntCtrl.setChangesToDates() class=form-control name=from-date type=text id=from-date placeholder value=\"Date from\"></div><div class=datepicker__calendar-icon><svg class=\"icon icon--calendar\"><use xlink:href=assets/images/icons.svg#calendar></use></svg></div><div class=datepicker__chevron-icon style=display:none><svg class=\"icon icon--chevron-down\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div><div class=datepickerdiv><div class=datepicker__field><div class=datepicker__input><input foundation-datepicker ng-model=repActCntCtrl.date_to min-date=\"{{ repActCntCtrl.minDateTo }}\" max-date=\"{{ repActCntCtrl.maxDateTo }}\" ng-change=repActCntCtrl.setChangesToDates() class=form-control name=to-date type=text id=to-date placeholder value=\"Date to\"></div><div class=datepicker__calendar-icon><svg class=\"icon icon--calendar\"><use xlink:href=assets/images/icons.svg#calendar></use></svg></div><div class=datepicker__chevron-icon style=display:none><svg class=\"icon icon--chevron-down\"><use xlink:href=assets/images/icons.svg#chevron-down></use></svg></div></div></div></div></div><div style=\"width: 100%\"><div class=content-section__right style=\"float: right\"><!-- full report button as apposed to report based on date range --><md-button ng-if=false class=\"btn btn-white btn-small btn-auto active-ads-dl-report\" ng-disabled=\"repActCntCtrl.activeAds.length === 0\" ng-disabled=!repActCntCtrl.active_csv_url href=\"{{ repActCntCtrl.active_csv_url }}\" target=_blank download>Download Full Report</md-button><md-button class=\"btn btn-white btn-small btn-auto active-ads-dl-report\" ng-disabled=\"repActCntCtrl.activeAds.length === 0\" ng-click=\"repActCntCtrl.downloadReport(repActCntCtrl.date_from, repActCntCtrl.date_to)\">Download Report</md-button></div></div></div><div class=content-section__content><div class=active-ads><div class=\"active-ads__section active-ads__section--submit\"><h5 ng-hide=\"repActCntCtrl.activeAds.length > 0\" class=active-ads__section-title>NO ACTIVE CONTENT FOR CURRENT DATE RANGE. DATE RANGE IS ADJUSTABLE USING CALENDAR DROP DOWN FOUND IN UPPPER RIGHT OF THIS PAGE.</h5><div ng-hide=\"repActCntCtrl.activeAds.length === 0\" class=top-desc>*Results below are last 30 days by default. Search URL or Campaign name and/or filter by dates as well*</div><div class=\"active-ads__section-content d-lg-block\" ng-hide=\"repActCntCtrl.activeAds.length === 0\"><md-table-container><table class=table md-table ng-model=repActCntCtrl.activeAds md-progress=promise><thead md-head md-order=repActCntCtrl.query.order><tr md-row><th class=date md-column md-order-by=requested_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Date purchased</span></a></th><th class=campaign md-column md-order-by=campaign.name><a class=\"btn btn-link\" href=javascript:void(0)><span>Campaign</span></a></th><th class=publisher md-column md-order-by=url.href md-desc><a class=\"btn btn-link\" href=javascript:void(0)><span>Publisher</span></a></th><th class=da md-column md-order-by=url.domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th class=cost md-column md-order-by=url.shown_price><a class=\"btn btn-link\" href=javascript:void(0)><span>Cost</span></a></th><th class=url md-column md-order-by=link.href><a class=\"btn btn-link\" href=javascript:void(0)><span>Destination URL</span></a></th><th md-column md-order-by=link_text><a class=\"btn btn-link\" href=javascript:void(0)><span>Anchor Text</span></a></th><th class=action md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Live Link</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"ad in repActCntCtrl.activeAds\"><td md-cell>{{ ad.ordered_date | date:\'MM-dd-yyyy\' }}</td><td md-cell data-ellipsis data-ng-bind=ad.campaign.name data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.campaign.name }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=\"ad.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.url.href }}</md-tooltip></td><td md-cell>{{ ad.url.domain_authority }}</td><td md-cell>{{ ad.url_price | currency:\"$\":0 }}</td><td md-cell class=url data-ellipsis data-ng-bind=\"ad.link.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.link.href }}</md-tooltip></td><td md-cell>{{ ad.link_text }}</td><td md-cell><a ng-if=\"repActCntCtrl.liveLinkStatus(ad) == \'link\'\" ng-href=\"{{ repActCntCtrl.requireHttp(ad.full_pub_url) }}\" target=_blank>Click Here</a> <span ng-if=\"repActCntCtrl.liveLinkStatus(ad) == \'text\'\">{{ repActCntCtrl.liveLinkText(ad) }}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=repActCntCtrl.searchReportActiveContents.limit md-page=repActCntCtrl.searchReportActiveContents.page md-total=\"{{ repActCntCtrl.results }}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=repActCntCtrl.getPaginatedBlogPosts md-page-select></md-table-pagination></div></div></div></div></div>");
$templateCache.put("app/pages/reports/adv/rejected/instructions.html","<md-dialog md-theme=default><div class=md-toolbar-tools><h2 class=sub-title>How to Deal with Rejection</h2><span flex></span><md-button class=md-icon-button ng-click=repRejCtrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div><md-dialog-content class=\"md-dialog-content highlight-words\" role=document><ul><li>Publishers can either fully reject the post, or allow you to make edits</li><br><li>Download the content first, then check the notes.</li><br><li>After that, the Pencil Icon will appear blue or remain greyed out.</li><br><li><a>If the Pencil Icon is blue (publisher is allowing edits):</a><ul><li>Click the Notes Icon to read what needs to be corrected</li><li>Make edits on the Word doc and save it</li><li>Click the Pencil Icon</li><li>Make sure the word matches: Title | Destination URL | Anchor Text</li><li>Upload the edited content</li></ul></li><br><li>If the Pencil Icon is greyed out (publisher rejected content outright):<ul><li>Save content for another publisher</li><li>Delete the item</li></ul></li></ul></md-dialog-content></md-dialog>");
$templateCache.put("app/pages/reports/adv/rejected/reportRejected.html","<div class=\"content-section rejected-wrapper\"><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white\" ui-sref=adv-dash><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><h2 class=content-section__title>Rejected Content</h2><div class=content-section__right><button class=\"btn btn-white btn-small btn-auto\" ng-click=repRejCtrl.showInstructions()>Instructions</button></div></div><div class=content-section__content><div class=active-ads><div class=\"active-ads__section active-ads__section--submit\"><h5 ng-hide=\"repRejCtrl.rejectedAds.length > 0\" class=active-ads__section-title>No Rejected Content</h5><div class=\"active-ads__section-content d-lg-block\" ng-hide=\"repRejCtrl.rejectedAds.length === 0\"><md-table-container><table class=table md-table ng-model=repRejCtrl.rejectedAds md-progress=promise><thead md-head md-order=repRejCtrl.query.order><tr md-row><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Order date</span></a></th><th md-column md-order-by=url.href md-desc><a class=\"btn btn-link\" href=javascript:void(0)><span>Publisher</span></a></th><th class=da md-column md-order-by=url.domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th md-column md-order-by=campaign.name><a class=\"btn btn-link\" href=javascript:void(0)><span>Campaign</span></a></th><th class=action md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Status</span></a></th><th class=action md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Download content</span></a></th><th class=action md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Delete</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"ad in repRejCtrl.filtered = (repRejCtrl.rejectedAds | filter: repRejCtrl.query.filter) | orderBy: repRejCtrl.query.order\n      | limitTo: repRejCtrl.query.limit : (repRejCtrl.query.page -1) * repRejCtrl.query.limit\"><td md-cell><span>{{ ad.requested_date | date:\'MM-dd-yyyy\' }}</span></td><td md-cell data-ellipsis data-ng-bind=ad.url.href data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.url.href }}</md-tooltip></td><td md-cell>{{ ad.url.domain_authority }}</td><td md-cell data-ellipsis data-ng-bind=ad.campaign.name data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.campaign.name }}</md-tooltip></td><td md-cell>{{ ad.rejected_reason === \'Refunded\' ? \'Refunded\' : \'Declined\' }}</td><td md-cell class=action><a class=\"btn btn-download\" aria-label=description ng-href={{ad.word.url}} target=_blank ng-show=ad.word ng-click=\"repRejCtrl.downloadContent($event, ad)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a><a class=\"btn btn-download\" aria-label=description ng-href={{ad.word.url}} target=_blank ng-show=ad.blog_post_body ng-click=\"repRejCtrl.downloadContent($event, ad)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a></td><td md-cell class=action><md-tooltip md-direction=bottom>{{repRejCtrl.getTooltipText(\'delete\', ad)}}</md-tooltip><md-button class=md-icon-button ng-class=\"{\'md-primary\': ad.downloaded}\" aria-label=description ng-click=repRejCtrl.deleteUrl(ad.id) ng-disabled=!repRejCtrl.canDelete(ad)><md-icon class=icon-enabled>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=repRejCtrl.query.limit md-page=repRejCtrl.query.page md-total=\"{{ repRejCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></div></div></div></div></div>");
$templateCache.put("app/pages/reports/adv/awaitingContent/reportAwaitingContent.html","<div class=content-section><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white\" ui-sref=adv-dash><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><h2 class=content-section__title>Pending Approval</h2><div class=content-section__right><form class=search-widget ng-submit=repAwaitingCtrl.search()><input ng-model=repAwaitingCtrl.query.filter ng-change=repAwaitingCtrl.search() class=form-control placeholder=Search... ng-disabled=\"repAwaitingCtrl.awaitingAds.length === 0\"> <button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form></div></div><div class=content-section__content><div class=active-ads><div class=\"active-ads__section active-ads__section--submit\"><h5 ng-hide=\"repAwaitingCtrl.awaitingAds.length > 0\" class=active-ads__section-title>No Pending Content</h5><div class=\"active-ads__section-content d-lg-block\" ng-hide=\"repAwaitingCtrl.awaitingAds.length === 0\"><md-table-container><table class=table md-table ng-model=repAwaitingCtrl.awaitingAds md-progress=promise><thead md-head md-order=repAwaitingCtrl.query.order><tr md-row><th class=date md-column md-order-by=requested_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Date ordered</span></a></th><th class=campaign md-column md-order-by=campaign.name><a class=\"btn btn-link\" href=javascript:void(0)><span>Campaign</span></a></th><th class=publisher md-column md-order-by=url.href md-desc><a class=\"btn btn-link\" href=javascript:void(0)><span>Publisher</span></a></th><th class=da md-column md-order-by=url.domain_authority><a class=\"btn btn-link\" href=javascript:void(0)><span>DA</span></a></th><th class=cost md-column md-order-by=url.shown_price><a class=\"btn btn-link\" href=javascript:void(0)><span>Cost</span></a></th><th class=url md-column md-order-by=link.href><a class=\"btn btn-link\" href=javascript:void(0)><span>Destination URL</span></a></th><th class=action md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Download content</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"ad in repAwaitingCtrl.filtered = (repAwaitingCtrl.awaitingAds | filter: repAwaitingCtrl.query.filter) | orderBy: repAwaitingCtrl.query.order\n                    | limitTo: repAwaitingCtrl.query.limit : (repAwaitingCtrl.query.page -1) * repAwaitingCtrl.query.limit\"><td md-cell>{{ ad.requested_date | date:\'MM-dd-yyyy\' }}</td><td md-cell data-ellipsis data-ng-bind=ad.campaign.name data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.campaign.name }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=ad.url.href data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.url.href }}</md-tooltip></td><td md-cell>{{ ad.url.domain_authority }}</td><td md-cell>{{ ad.url_price | currency:\"$\":0 }}</td><td md-cell class=url data-ellipsis data-ng-bind=\"ad.link.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ad.link.href }}</md-tooltip></td><td md-cell><a class=\"btn btn-download\" aria-label=description ng-href={{ad.word.url}} target=_blank g-show=ad.word ng-click=\"repAwaitingCtrl.downloadContent($event, ad)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a><a class=\"btn btn-download\" aria-label=description ng-href=javascript:void(0) ng-show=ad.blog_post_body ng-click=\"repAwaitingCtrl.downloadContent($event, ad)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=repAwaitingCtrl.query.limit md-page=repAwaitingCtrl.query.page md-total=\"{{ repAwaitingCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></div></div></div></div></div>");
$templateCache.put("app/pages/reports/pub/activeAds/activeAdsContent.html","<div class=content-section><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white btn-small\" ui-sref=pub-dash><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><h2 class=content-section__title></h2></div><div class=content-section__content><div class=active-ads><div ng-if=\"actAdsCtrl.adsNotSubmitted.length > 0\" class=\"active-ads__section active-ads__section--submit\"><div class=\"active-ads__section-content d-none d-lg-block\" ng-hide=\"actAdsCtrl.adsNotSubmitted.length === 0\"><md-table-container><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=actAdsCtrl.search><div class=md-toolbar-tools><h6>Submit Published URL &amp; Get Paid! ({{ actAdsCtrl.notSubmittedTotal }})</h6></div></md-toolbar><table class=table md-table ng-model=actAdsCtrl.adsNotSubmitted md-progress=promise><thead md-head md-order=actAdsCtrl.queryNotSubmitted.order><tr md-row><th md-column md-order-by=requested_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Date</span></a></th><th md-column md-order-by=url_href><a class=\"btn btn-link\" href=javascript:void(0)><span>URL</span></a></th><th md-column md-order-by=blog_post_title><a class=\"btn btn-link\" href=javascript:void(0)><span>Article Title</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Download</span></a></th><th md-column md-order-by=full_pub_url><a class=\"btn btn-link\" href=javascript:void(0)><span>Enter Live Post URL</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Submit for Approval</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"order in actAdsCtrl.adsNotSubmitted\" ng-class=\"{ \'rejected-url\': order.days_after_approved > 15, \' submitted-url\': actAdsCtrl.isSubmitted(order) }\"><td md-cell style=width:10%>{{ order.requested_date | date:\'MM-dd-yyyy\'}}<md-tooltip ng-if=\"order.days_after_approved >= 15\" md-direction=bottom>THIS POST IS {{order.days_after_approved}} DAYS OLD. PLEASE PUBLISH ASAP OR EMAIL ADMIN@SCALEFLUENCE.COM FOR ISSUES.</md-tooltip></td><td style=width:20% md-cell data-ellipsis data-ng-bind=\"order.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.url.href }}</md-tooltip></td><td md-cell style=width:25%>{{ order.blog_post_title }}<md-tooltip ng-if=\"order.days_after_approved >= 15\" md-direction=bottom>THIS POST IS {{order.days_after_approved}} DAYS OLD. PLEASE PUBLISH ASAP OR EMAIL ADMIN@SCALEFLUENCE.COM FOR ISSUES.</md-tooltip></td><td md-cell style=width:15%><md-button class=md-icon-button aria-label=\"download doc\" ng-click=actAdsCtrl.downloadWordDoc(order)><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></md-button></td><td md-cell style=width:30% ng-click=\"editComment($event, order)\" ng-class=\"{\'md-placeholder\': !order.full_pub_url}\" ng-disabled=true>{{ order.full_pub_url || \'http://MySite.com/new-post\' }}<md-tooltip ng-if=\"order.days_after_approved >= 15\" md-direction=bottom>THIS POST IS {{order.days_after_approved}} DAYS OLD. PLEASE PUBLISH ASAP OR EMAIL ADMIN@SCALEFLUENCE.COM FOR ISSUES.</md-tooltip></td><td md-cell style=width:15%><md-button class=md-icon-button aria-label=description ng-class=\"{ \'md-green\': order.full_pub_url && !actAdsCtrl.adRejected(order) }\" ng-if=\"actAdsCtrl.changeIcon(order) !== \'check_circle\'\" ng-click=actAdsCtrl.submitOrNotes(order)><md-icon ng-show=!actAdsCtrl.adRejected(order)>{{ actAdsCtrl.changeIcon(order) }}</md-icon><md-icon ng-show=actAdsCtrl.adRejected(order) class=rejected-warning md-svg-src=assets/images/alert.svg></md-icon><md-tooltip md-direction=bottom>{{ actAdsCtrl.getIconTooltip(order) }}</md-tooltip></md-button><button style=\"width: 100px\" type=button ng-if=\"actAdsCtrl.changeIcon(order) === \'check_circle\'\" ng-disabled=\"!order.full_pub_url || actAdsCtrl.adRejected(order)\" class=\"btn btn-white btn-small\" ng-click=\"order.full_pub_url && !actAdsCtrl.adRejected(order) && actAdsCtrl.submitOrNotes(order)\">Submit</button></td></tr></tbody></table></md-table-container><md-table-pagination class=\"arrows-enabled pagination-blue\" md-limit=actAdsCtrl.queryNotSubmitted.limit md-page=actAdsCtrl.queryNotSubmitted.page md-total=\"{{ actAdsCtrl.notSubmittedTotal }}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=actAdsCtrl.searchUnsubmitted md-page-select></md-table-pagination></div><div class=\"active-ads__section-content d-block d-lg-none\" ng-hide=\"actAdsCtrl.adsNotSubmitted.length === 0\"><table dir-paginate=\"order in actAdsCtrl.filteredNotSubmitted = (actAdsCtrl.adsNotSubmitted |\n          filter: actAdsCtrl.queryNotSubmitted.filterNotSubmitted) | orderBy: actAdsCtrl.queryNotSubmitted.order |\n          limitTo: actAdsCtrl.queryNotSubmitted.limit : (actAdsCtrl.queryNotSubmitted.page -1) * actAdsCtrl.queryNotSubmitted.limit | itemsPerPage: 20\" pagination-id=mobile-pricing><tr><th>Date ordered</th><td>{{ order.requested_date | date:\'MM-dd-yyyy\' }}</td></tr><tr><th>URL</th><td>{{ order.url.href }}</td></tr><tr><th>Product Type</th><td>{{ order.url.product_type | capitalize }}</td></tr><tr><th>Article Title</th><td>{{ order.blog_post_title }}</td></tr><tr><th style=\"padding: 0\">Enter Live Post URL</th><td><input class=form-control ng-disabled=\"actAdsCtrl.isSubmitted(order) || actAdsCtrl.adRejected(order)\" ng-blur=\"editCommentBlur($event, order)\" name=\"{{ order.id }}-mobileLiveUrl\" type=text placeholder=http://MySite.com/new-post ng-value=\"order.full_pub_url || \'\'\"></td></tr><tr><th style=\"padding: 0\">Submit for Approval</th><td><button class=\"btn btn-white\" style=\"padding: 5px\" ng-if=\"actAdsCtrl.changeIcon(order) !== \'check_circle\'\" ng-disabled=actAdsCtrl.isSubmitted(order) ng-click=actAdsCtrl.submitOrNotes(order)><span style=\"font-size: 12px; color: #5c5757\">{{ actAdsCtrl.getIconTooltip(order) }}</span><md-icon ng-if=actAdsCtrl.isSubmitted(order) md-svg-src=assets/images/hourglass_empty.svg></md-icon><md-icon ng-if=actAdsCtrl.adRejected(order) md-svg-src=assets/images/warning.svg></md-icon></button> <button type=button ng-if=\"actAdsCtrl.changeIcon(order) === \'check_circle\'\" class=\"btn btn-white\" ng-click=actAdsCtrl.submitOrNotes(order)>Submit</button></td></tr></table><dir-pagination-controls pagination-id=mobile-pricing></dir-pagination-controls></div></div><div class=\"active-ads__section active-ads__section--approved\"><div class=\"active-ads__section-content d-none d-lg-block\" ng-hide=\"actAdsCtrl.filtered.length === 0 && actAdsCtrl.searchFilter == false\"><md-table-container><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=actAdsCtrl.search><div class=md-toolbar-tools><h6>Active Ads</h6><span flex></span><md-button class=\"md-icon-button table-icons\" ng-click=actAdsCtrl.searchOn()><md-tooltip md-direction=bottom>Search Ads</md-tooltip><md-icon md-svg-src=\"{{ actAdsCtrl.showSearchIcon() }}\"></md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-show=actAdsCtrl.search aria-hidden=false><div class=\"md-toolbar-tools query-container\" flex layout=row layout-align=\"start center\"><md-icon flex=5 class=small-search-icon>search</md-icon><input type=text ng-model=actAdsCtrl.query.filter ng-keyup=actAdsCtrl.searchBoxKeyUp($event) flex=40 placeholder=search aria-invalid=false class=query-no-border> <button class=\"md-icon-button md-button md-ink-ripple\" type=button ng-click=actAdsCtrl.removeFilterAds() aria-label=close flex=5><md-icon class=material-icons>close</md-icon><div class=md-ripple-container></div></button></div></md-toolbar><table class=table md-table ng-model=actAdsCtrl.urls md-progress=promise><thead md-head md-order=actAdsCtrl.query.order md-on-reorder=actAdsCtrl.loadActiveAds><tr md-row><th md-column md-order-by=approved_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Date Approved</span></a></th><th md-column md-order-by=profile_name><a class=\"btn btn-link\" href=javascript:void(0)><span>Profile Name</span></a></th><th md-column md-order-by=created_from><a class=\"btn btn-link\" href=javascript:void(0)><span>Product Type</span></a></th><th md-column md-order-by=blog_post_url><a class=\"btn btn-link\" href=javascript:void(0)><span>Live URL</span></a></th><th md-column md-order-by=payout_created_at><a class=\"btn btn-link\" href=javascript:void(0)><span>Date Paid</span></a></th><th md-column md-order-by=payout_amount flex=10><a class=\"btn btn-link\" href=javascript:void(0)><span>Amount</span></a></th></tr></thead><tbody md-body class=data-table-container><tr md-row ng-repeat=\"order in actAdsCtrl.filtered\"><td md-cell>{{ order.ad.approved_date | date:\'MM-dd-yyyy\' }}</td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"order.profile_name | limitTo: 80\"><md-tooltip md-direction=bottom>{{ order.profile_name }}</md-tooltip></td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"order.created_from | limitTo: 80 | capitalize\"><md-tooltip md-direction=bottom>{{ order.created_from }}</md-tooltip></td><td md-cell class=truncate-text data-ellipsis data-ng-bind=\"order.ad.full_pub_url | limitTo: 80\"><md-tooltip md-direction=bottom>{{ order.ad.full_pub_url }}</md-tooltip></td><td md-cell>{{ actAdsCtrl.orderPayoutDate(order) }}</td><td md-cell>{{ actAdsCtrl.orderPayout(order) | currency:\"$\":0 }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=actAdsCtrl.query.limit md-page=actAdsCtrl.query.page md-total=\"{{ actAdsCtrl.activeAdsResult}}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=actAdsCtrl.loadActiveAds md-page-select=true></md-table-pagination></div><div class=\"active-ads__section-content d-block d-lg-none\"><h5 class=active-ads__section-title>Approved Ads ({{ actAdsCtrl.activeAds.length }})</h5><table ng-repeat=\"order in actAdsCtrl.filtered\"><tr><th>Date Approved</th><td>{{ order.ad.approved_date | date:\'MM-dd-yyyy\' }}</td></tr><tr><th>Profile Name</th><td class=truncate-text data-ellipsis data-ng-bind=\"order.profile_name | limitTo: 80\"></td></tr><tr><th>Product Type</th><td class=truncate-text data-ellipsis data-ng-bind=\"order.url.product_type | limitTo: 80 | capitalize\"></td></tr><tr><th>Live URL</th><td class=truncate-text data-ellipsis data-ng-bind=\"order.ad.full_pub_url | limitTo: 80\"></td></tr><tr><th>Date Paid</th><td>{{ actAdsCtrl.orderPayoutDate(order) }}</td></tr><tr><th>Amount</th><td>{{ order.url.price | currency:\"$\":0 }}</td></tr></table><div class=\"profiles-list__pagination margin-top-5\"><md-table-pagination md-limit=actAdsCtrl.query.limit md-page=actAdsCtrl.query.page md-total=\"{{ actAdsCtrl.activeAdsResult}}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=actAdsCtrl.loadActiveAds md-page-select=true></md-table-pagination></div></div></div></div></div></div>");
$templateCache.put("app/pages/reports/pub/newOrders/newOrders.html","<div layout=row layout-align=\"space-between start\"><div layout=column><md-subheader class=md-no-sticky><h2>New Orders</h2></md-subheader></div></div><div class=edit-profile__content ng-hide=\"newOrdersCtrl.newOrders.length === 0\"><md-table-container><table class=table style=\"margin-bottom: 0\" md-table ng-model=newOrdersCtrl.newOrders md-progress=promise><thead md-head md-order=newOrdersCtrl.query.order><tr md-row><th md-column md-order-by=requested_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Date ordered</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Time Left to Approve</span></a></th><th md-column md-order-by=url.href><a class=\"btn btn-link\" href=javascript:void(0)><span>URL</span></a></th><th md-column md-order-by=url.product_type md-desc><a class=\"btn btn-link\" href=javascript:void(0)><span>Product Type</span></a></th><th md-column md-order-by=url.price><a class=\"btn btn-link\" href=javascript:void(0)><span>Payout</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Get Content</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Approve</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Decline</span></a></th></tr></thead><tbody md-body flex><tr md-row ng-class=\"{ \'submitted-url\': newOrdersCtrl.isRejected(order), \'disabled-order\': order.expired }\" ng-repeat=\"order in newOrdersCtrl.filtered = (newOrdersCtrl.newOrders | filter: newOrdersCtrl.query.filter) | orderBy: newOrdersCtrl.query.order\n        | limitTo: newOrdersCtrl.query.limit : (newOrdersCtrl.query.page -1) * newOrdersCtrl.query.limit\"><td md-cell>{{ order.requested_date | date:\'MM-dd-yyyy\' }}</td><td md-cell><remaining-time order-expired=order.expired started-at=order.requested_date></remaining-time></td><td md-cell data-ellipsis data-ng-bind=\"order.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.url.href }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=\"order.url.product_type | limitTo: 30 | capitalize\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.profile.product_type }}</md-tooltip></td><td md-cell class=price>{{ order.url.price | currency:\"$\":0 }}</td><td md-cell class=action><a href=javascript:void(0) class=\"btn btn-download\" aria-label=description ng-href={{order.word.url}} target=_blank ng-show=order.word ng-click=\"newOrdersCtrl.downloadContent($event, order)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a><a href=javascript:void(0) class=\"btn btn-download\" aria-label=description ng-show=order.blog_post_body ng-click=\"newOrdersCtrl.downloadContent($event, order)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a></td><td md-cell><button class=action-link-button ng-disabled=order.expired ng-click=newOrdersCtrl.approve(order) ng-class=\"{ \'disabled\': newOrdersCtrl.isRejected(order) || order.expired, \'md-primary\': !newOrdersCtrl.isRejected(order) }\">Approve</button></td><td md-cell><button class=action-link-button ng-disabled=order.expired ng-click=newOrdersCtrl.decline(order) ng-class=\"{ \'disabled\': newOrdersCtrl.isRejected(order) || order.expired, \'md-primary\': !newOrdersCtrl.isRejected(order) }\">Decline</button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=newOrdersCtrl.query.limit md-page=newOrdersCtrl.query.page md-total=\"{{ newOrdersCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></div><md-subheader ng-hide=\"newOrdersCtrl.newOrders.length > 0\" class=\"md-no-sticky no-items\" layout=row layout-align=\"center center\"><h2 class=no-items>No content to display</h2></md-subheader>");
$templateCache.put("app/pages/reports/pub/resubmittedContent/resubmitted.html","<div layout=row layout-align=\"space-between start\"><div layout=column><md-subheader class=md-no-sticky><h2>Resubmitted Content</h2></md-subheader></div></div><md-card class=resubmitted-table-container ng-hide=\"resCtrl.resubmitted.length === 0\"><md-table-container><table class=table md-table ng-model=resCtrl.resubmitted md-progress=promise flex><thead md-head md-order=resCtrl.query.order><tr md-row><th md-column md-order-by=url.profile_name><a class=\"btn btn-link\" href=javascript:void(0)><span>Profile Name</span></a></th><th md-column md-order-by=url.href><a class=\"btn btn-link\" href=javascript:void(0)><span>URL</span></a></th><th md-column md-order-by=url.price><a class=\"btn btn-link\" href=javascript:void(0)><span>Payout</span></a></th><th md-column md-order-by=rejected_reason md-desc><a class=\"btn btn-link\" href=javascript:void(0)><span>1st Rejected Reason</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Notes</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Get Content</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Approve</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Reject Again</span></a></th></tr></thead><tbody md-body flex><tr md-row ng-repeat=\"order in resCtrl.filtered = (resCtrl.resubmitted | filter: resCtrl.query.filter) | orderBy: resCtrl.query.order\n        | limitTo: resCtrl.query.limit : (resCtrl.query.page -1) * resCtrl.query.limit\"><td md-cell data-ellipsis data-ng-bind=\"order.url.profile_name | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.url.profile_name }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=\"order.url.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.url.href }}</md-tooltip></td><td md-cell class=price>${{ order.url.price }}</td><td md-cell class=rejected-reason data-ellipsis data-ng-bind=\"order.rejected_reason | limitTo: 30 | capitalize\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ order.rejected_reason }}</md-tooltip></td><td md-cell class=action><md-button class=\"md-icon-button primary-color-svg\" aria-label=description ng-show=order.notes ng-click=\"resCtrl.showNotes($event, order)\"><md-icon md-svg-src=\"{{ resCtrl.showNotesIcon() }}\"></md-icon></md-button></td><td md-cell class=action><a class=\"btn btn-download\" aria-label=description ng-href={{order.word.url}} target=_blank ng-show=order.word ng-click=\"resCtrl.downloadContent($event, order)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg> </a><button class=\"btn btn-download\" aria-label=description ng-show=order.blog_post_body ng-click=\"resCtrl.downloadContent($event, order)\"><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></button></td><td md-cell><a class=\"actions md-primary\" ng-click=resCtrl.approve(order)>Approve</a></td><td md-cell><a class=\"actions md-primary\" ng-click=resCtrl.decline(order)>Reject</a></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=resCtrl.query.limit md-page=resCtrl.query.page md-total=\"{{ resCtrl.filtered.length }}\" md-page-select=true></md-table-pagination></md-card><md-subheader ng-hide=\"resCtrl.resubmitted.length > 0\" class=\"md-no-sticky no-items\" layout=row layout-align=\"center center\"><h2 class=no-items>No content to display</h2></md-subheader>");
$templateCache.put("app/pages/reports/pub/pricingAndPausing/pricingPausing.html","<div class=content-section><div class=content-section__header><div class=content-section__back><a class=\"btn btn-white\" ui-sref=pub-dash><svg class=\"icon icon--chevron\"><use xlink:href=assets/images/icons.svg#chevron></use></svg><span>Back</span></a></div><h2 class=content-section__title>Pricing & Pausing<span ng-hide=\"ppCtrl.pricingPausing.length > 0\"> (0 Items)</span><md-button ng-click=ppCtrl.showInfo() class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></h2><div class=content-section__right><form class=search-widget><input class=form-control name=name type=text ng-keyup=ppCtrl.searchBox($event) ng-model=ppCtrl.query.filter placeholder=\"Search for something...\"><button type=submit><svg class=\"icon icon--search\"><use xlink:href=assets/images/icons.svg#search></use></svg></button></form></div></div><div class=content-section__content><div class=pricing-pausing><div class=\"pricing-pausing__content d-none d-lg-block\"><table class=table md-table ng-model=ppCtrl.pricingPausing><thead md-head md-order=ppCtrl.query.order md-on-reorder=ppCtrl.getActiveURLs><tr md-row><th md-column md-order-by=profile_name><a class=\"btn btn-link\" href=javascript:void(0)><span>Profile Name</span></a></th><th md-column md-order-by=href><a class=\"btn btn-link\" href=javascript:void(0)><span>URL</span></a></th><th md-column md-desc class=product><a class=\"btn btn-link\" href=javascript:void(0)><span>Product Type</span></a></th><th md-column md-order-by=price><a class=\"btn btn-link\" href=javascript:void(0)><span>Change Your Price</span></a></th><th md-column md-order-by=suggested_price class=suggested-cost><a class=\"btn btn-link\" href=javascript:void(0)><span>Our Suggested Price</span></a></th><th md-column md-order-by=approved_date><a class=\"btn btn-link\" href=javascript:void(0)><span>Approved Date</span></a></th><th md-column><a class=\"btn btn-link\" href=javascript:void(0)><span>Pause from Search?</span></a></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"order in ppCtrl.filtered\" ng-class=ppCtrl.getRowClass(order)><td md-cell data-ellipsis data-ng-bind=\"order.profile_name | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : order.profile_name }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=\"order.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : order.href }}</md-tooltip></td><td md-cell data-ellipsis data-ng-bind=\"order.product_type | limitTo: 30 | capitalize\" data-ellipsis-append=...></td><td md-cell ng-click=\"editPrice($event, order)\" ng-disabled=true>{{ ppCtrl.getPriceText(order) }}<md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : ppCtrl.getEditPriceTooltipText(order) }}</md-tooltip></td><td md-cell class=suggested-cost>{{ order.suggested_price | currency:\"$\":0 }}</td><td md-cell>{{ ppCtrl.formatApprovedDate(order) }}</td><td md-cell><div class=switcher><input ng-id=\"{{ order.id }}-pause\" type=checkbox ng-checked=order.paused ng-model=order.paused ng-disabled=order.submitted aria-label=paused><label ng-if=order.submitted ng-for=\"{{ order.id }}-pause\" data-on=ON data-off=OFF></label><label ng-if=!order.submitted ng-click=\"ppCtrl.toggleOrderPaused(order); ppCtrl.submitUrl(order)\" ng-for=\"{{ order.id }}-pause\" data-on=ON data-off=OFF></label></div></td></tr></tbody></table><md-table-pagination style=\"border-top: 0px\" class=\"arrows-enabled pagination-blue\" md-limit=ppCtrl.query.limit md-page=ppCtrl.query.page md-total=\"{{ ppCtrl.totalItemsCount }}\" md-limit-options=\"[10, 15, 20]\" md-on-paginate=ppCtrl.getActiveURLs md-page-select=true></md-table-pagination></div><div class=\"pricing-pausing__content d-block d-lg-none\"><table dir-paginate=\"order in ppCtrl.filtered = (ppCtrl.pricingPausing) |\n        orderBy: ppCtrl.query.order | itemsPerPage: 20\" pagination-id=mobile-pricing ng-class=ppCtrl.getRowClass(order)><tr><th>Profile Name</th><td data-ellipsis data-ng-bind=\"order.profile_name | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : order.profile_name }}</md-tooltip></td></tr><tr><th>URL</th><td data-ellipsis data-ng-bind=\"order.href | limitTo: 30\" data-ellipsis-append=...><md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : order.href }}</md-tooltip></td></tr><tr><th>Product Type</th><td data-ellipsis data-ng-bind=\"order.product_type | limitTo: 30 | capitalize\" data-ellipsis-append=...></td></tr><tr><th>Change Your Price</th><td><span>$</span><input class=\"form-control form-control--editable\" name=name type=number placeholder ng-value=order.price ng-blur=\"editPriceBlur($event, order)\"><md-tooltip md-direction=bottom>{{ ppCtrl.isSubmitted(order) ? \'Submission waiting Admin approval\' : ppCtrl.getEditPriceTooltipText(order) }}</md-tooltip></td></tr><tr><th>Our Suggested Price</th><td class=suggested-cost>{{ order.suggested_price | currency:\"$\":0 }}</td></tr><tr><th>Pause from Search?</th><td><div class=switcher><input ng-id=\"{{ order.id }}-mpause\" type=checkbox ng-checked=order.paused ng-model=order.paused ng-disabled=order.submitted aria-label=paused><label ng-if=order.submitted ng-for=\"{{ order.id }}-mpause\" data-on=ON data-off=OFF></label><label ng-if=!order.submitted ng-click=\"ppCtrl.toggleOrderPaused(order); ppCtrl.submitUrl(order)\" ng-for=\"{{ order.id }}-mpause\" data-on=ON data-off=OFF></label></div></td></tr></table><div class=\"profiles-list__pagination margin-top-5\"><dir-pagination-controls boundary-links=true on-page-change=changeHandler(newPageNumber) pagination-id=mobile-pricing></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/pages/user/profile/confirmation/confirmation.html","<md-dialog class=confirmation-container layout=column layout-align=\"center center\"><md-toolbar><div class=md-toolbar-tools><h2>Changing Your Email?</h2><span flex></span><md-button class=md-icon-button ng-click=confirmCtrl.closeDialog()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=dialog-content layout-align=\"start center\"><form name=form ng-submit=false layout=column flex><p>Changing your email will require re-authorization via the new email address!</p><md-input-container class=md-block><label>Current password</label><input type=password name=currentPassword ng-model=confirmCtrl.current_password ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() required maxlength=16 minlength=8><div ng-messages=form.currentPassword.$error><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div><div ng-message=required>This is required.</div></div></md-input-container></form></md-content><div class=dialog-actions><md-divider></md-divider><md-card-actions layout=row layout-align=\"end center\" flex><md-button class=md-primary ng-disabled=$root.isLoading ng-click=confirmCtrl.closeDialog()>Cancel</md-button><md-button class=md-accent ng-disabled=\"$root.isLoading || form.$invalid\" ng-click=confirmCtrl.save()>Save</md-button></md-card-actions></div></md-dialog>");
$templateCache.put("app/pages/user/profile/partials/advProfile.html","<div class=content-section__header><h2 class=content-section__title>Account information</h2><div ng-if=profCtrl.isAdvertiser() class=\"content-section__right content-section__right--sidebar\"><a class=\"btn btn-white btn-small btn-auto\" href=\"\" ng-click=profCtrl.showOrderHistory()>Show order history</a></div></div><div class=account><div class=account__content><div class=account__content-form><form class=account__form name=profile ng-submit=profile.$valid autocomplete=off><div class=form-group><input class=form-control type=text ng-model=profCtrl.user.first_name ng-disabled=$root.isLoading placeholder=\"First name\"></div><div class=form-group><input class=form-control type=text ng-model=profCtrl.user.last_name ng-disabled=$root.isLoading placeholder=\"Last name\"></div><div class=form-group><input class=form-control type=email name=email ng-model=profCtrl.user.email required ng-blur=profCtrl.checkEmail(profile) ng-disabled=$root.isLoading placeholder=Email><div ng-messages=profile.email.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=email>This email isn\'t valid.</div><div ng-message=in-use>Email address is already in use. Select another one.</div></div></div><div class=form-group><input class=form-control type=text phone-input name=phone ng-model=profCtrl.user.phone ng-disabled=$root.isLoading placeholder=Phone><div ng-messages=profile.phone.$error><div ng-message=pattern>(###) ###-#### - Please enter a valid phone number.</div></div></div><div class=form-group><input class=form-control type=text ng-model=profCtrl.user.state ng-disabled=$root.isLoading placeholder=State></div><div class=form-group><input class=form-control type=text ng-model=profCtrl.user.city ng-disabled=$root.isLoading placeholder=City></div><div class=form-group><input class=form-control name=zipCode ng-required=false ng-model=profCtrl.user.zip_code ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" placeholder=\"Postal Code\" type=text ng-disabled=$root.isLoading><div class=errors ng-messages=profileForm.zipCode.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid postal code.</div></div></div><div class=form-group><input class=form-control type=text ng-model=profCtrl.user.company ng-disabled=$root.isLoading placeholder=Company></div><div class=form-group><input name=disable-pwd-mgr-1 type=password id=disable-pwd-mgr-1 style=\"display: none\" value=disable-pwd-mgr-1> <input name=disable-pwd-mgr-2 type=password id=disable-pwd-mgr-2 style=\"display: none\" value=disable-pwd-mgr-2> <input name=disable-pwd-mgr-3 type=password id=disable-pwd-mgr-3 style=\"display: none\" value=disable-pwd-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=newPassword ng-model=profCtrl.user.password ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() maxlength=16 minlength=8 placeholder=\"New password\"><div ng-messages=profile.newPassword.$error><div ng-message=required>This is required.</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div class=form-group><input name=disable-pwdc-mgr-1 type=password id=disable-pwdc-mgr-1 style=\"display: none\" value=disable-pwdc-mgr-1> <input name=disable-pwdc-mgr-2 type=password id=disable-pwdc-mgr-2 style=\"display: none\" value=disable-pwdc-mgr-2> <input name=disable-pwdc-mgr-3 type=password id=disable-pwdc-mgr-3 style=\"display: none\" value=disable-pwdc-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=confirmPassword ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() ng-model=profCtrl.user.password_confirmation maxlength=16 minlength=8 ng-change=profCtrl.canChangePassword(profile) placeholder=\"Confirm new password\"><div ng-messages=profile.confirmPassword.$error><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div class=form-group><button type=button class=\"btn btn-white btn-small btn-auto\" ng-disabled=\"!profile.$valid || !profile.$dirty || $root.isLoading || profCtrl.user.password_confirmation != profCtrl.user.password\" ng-click=profCtrl.submit(profile)>Save</button></div></form></div><div class=account__content-card><credit-card-holder></credit-card-holder></div></div></div>");
$templateCache.put("app/pages/user/profile/partials/pubProfile.html","<form name=profileForm ng-submit=profileForm.$valid autocomplete=off><div class=content-section__header><h2 class=content-section__title>Account information</h2><div class=content-section__right><button class=\"btn btn-default btn-small btn-auto\" ng-disabled=\"profileForm.$invalid || !profileForm.$dirty || $root.isLoading\" ng-click=profCtrl.submit(profileForm) id=btn-save-profile>Save Profile</button></div></div><div class=account-info><div class=\"account-info__section account-info__section--info\"><div class=account-info__content><div class=account-info__fields><div class=form-group><label>First name</label><input class=form-control name=firstName ng-required=true ng-model=profCtrl.user.first_name type=text ng-disabled=$root.isLoading><div ng-messages=profileForm.firstName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label>Last name</label><input class=form-control name=lastName ng-required=true ng-model=profCtrl.user.last_name type=text ng-disabled=$root.isLoading><div ng-messages=profileForm.lastName.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label>Email</label><div class=\"hint hint--active hint--right\"><div class=hint__icon><svg ng-mouseover=profCtrl.setEmailChangeNotice(true) ng-mouseleave=profCtrl.setEmailChangeNotice(false) class=\"icon icon--info\"><use xlink:href=assets/images/icons.svg#info></use></svg></div><div ng-show=profCtrl.showEmailChangeNotice class=hint__text>Changing your email will require reauthorization via the new email address!</div></div><input class=form-control type=email name=email ng-model=profCtrl.user.email ng-blur=profCtrl.checkEmail(profileForm) ng-disabled=$root.isLoading required><div ng-messages=profileForm.email.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=email>This email isn\'t valid.</div><div ng-message=in-use>Email address is already in use. Select another one.</div></div></div><div class=form-group><label>PayPal Email for Payouts</label><div ng-if=false ng-click=\"profCtrl.setPaymentMethod(\'paypal\', profileForm)\" class=\"form-check form-check-radio form-check-inline\"><input ng-model=profCtrl.user.payment_method value=paypal class=form-check-input id=payment_method_paypal name=payment_method type=radio><label class=form-check-label><span>PayPal</span></label></div><div ng-if=false ng-click=\"profCtrl.setPaymentMethod(\'skrill\', profileForm)\" class=\"form-check form-check-radio form-check-inline\"><input ng-model=profCtrl.user.payment_method value=skrill class=form-check-input id=payment_method_skrill name=payment_method type=radio><label class=form-check-label><span>Skrill</span></label></div><input id=paypalEmail class=form-control style=\"margin-top: 8px\" type=email name=paypalEmail ng-model=profCtrl.user[profCtrl.payment_email] ng-disabled=$root.isLoading md-autofocus><div ng-messages=profileForm.paypalEmail.$error md-auto-hide=false><div ng-message=email>This email isn\'t valid.</div></div></div><div class=form-group><label>Change Password</label><input name=disable-pwd-mgr-1 type=password id=disable-pwd-mgr-1 style=\"display: none\" value=disable-pwd-mgr-1> <input name=disable-pwd-mgr-2 type=password id=disable-pwd-mgr-2 style=\"display: none\" value=disable-pwd-mgr-2> <input name=disable-pwd-mgr-3 type=password id=disable-pwd-mgr-3 style=\"display: none\" value=disable-pwd-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=newPassword ng-model=profCtrl.user.password ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() ng-change=profCtrl.canChangePassword(profileForm) maxlength=16 minlength=8><div ng-messages=profileForm.newPassword.$error><div ng-message=required>This is required.</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div><div class=form-group><label class=\"d-none d-md-block\">Confirm New Password</label><input name=disable-pwdc-mgr-1 type=password id=disable-pwdc-mgr-1 style=\"display: none\" value=disable-pwdc-mgr-1> <input name=disable-pwdc-mgr-2 type=password id=disable-pwdc-mgr-2 style=\"display: none\" value=disable-pwdc-mgr-2> <input name=disable-pwdc-mgr-3 type=password id=disable-pwdc-mgr-3 style=\"display: none\" value=disable-pwdc-mgr-3><!-- browsers ignore autocomplete=\"off\", so instead provide and invalid value --> <input autocomplete=new-password data-lpignore=true class=form-control type=password name=confirmPassword ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() ng-model=profCtrl.user.password_confirmation maxlength=16 minlength=8 ng-change=profCtrl.canChangePassword(profileForm)><div ng-messages=profileForm.confirmPassword.$error><div ng-message=required>This is required.</div><div ng-message=no-match>Passwords don\'t match</div><div ng-message=minlength>Password with at least 8 characters</div><div ng-message=md-maxlength>Password with maximum 16 characters</div></div></div></div></div></div><div class=\"account-info__section account-info__section--address\"><div class=account-info__header><h5 class=account-info__title>Shipping Address for Product Samples & Mobile Number for Order Notifications</h5></div><div class=account-info__content id=pub-shipping-info><div class=account-info__fields><div class=form-groups-row><div class=form-group><label>Address</label><input class=form-control name=addressOne ng-required=false ng-model=profCtrl.user.address_line_1 type=text ng-disabled=$root.isLoading placeholder=\"Address Line 1\"><div ng-messages=profileForm.addressOne.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><label>Mobile number &nbsp;&nbsp;&nbsp;&nbsp;<span><i>(for order notifications)</i></span></label><input id=pub-phone-number type=tel class=\"form-control phoneinput\" name=phone ng-model=profCtrl.user.phone intl-tel-input><div class=errors ng-show=profileForm.phone.$error.phoneNumber><div>Please enter a valid phone number (ex.: {{profCtrl.getPlaceholder()}}) or remove it.</div></div></div></div><div class=form-groups-row><div class=form-group><input class=form-control name=addressTwo ng-required=false ng-model=profCtrl.user.address_line_2 type=text ng-disabled=$root.isLoading placeholder=\"Address Line 2\"><div ng-messages=profileForm.addressTwo.$error><div ng-message=required>This is required.</div></div></div><div class=form-group></div></div><div class=form-groups-row><div class=form-group><md-autocomplete flex md-input-name=country md-selected-item=country md-search-text=profCtrl.searchTextCountry md-items=\"country in profCtrl.querySearchCountries(theCountry, profCtrl.searchTextCountry)\" md-item-text=country.name md-selected-item-change=profCtrl.countrySelected(country) md-select-on-match md-no-cache=true md-floating-label=\"Select Country\" md-menu-class=underline><md-item-template><span md-highlight-flags=^i md-highlight-text=profCtrl.searchTextCountry>{{ country.name }}</span></md-item-template><div ng-messages=pubReassignForm.country.$error><div ng-message=md-require-match>Please select a country.</div><div ng-message=required>You must supply a country.</div></div></md-autocomplete></div><div class=form-group><input class=form-control name=city ng-required=false ng-model=profCtrl.user.city type=text ng-disabled=$root.isLoading placeholder=City><div ng-messages=profileForm.city.$error><div ng-message=required>This is required.</div></div></div></div><div class=form-groups-row><div class=form-group><input class=form-control name=addressOne ng-required=false ng-model=profCtrl.user.state type=text ng-disabled=$root.isLoading placeholder=\"State / Province\"><div ng-messages=profileForm.addressOne.$error><div ng-message=required>This is required.</div></div></div><div class=form-group><input class=form-control name=zipCode ng-required=false ng-model=profCtrl.user.zip_code ui-options=\"{ allowInvalidValue: true, clearOnBlur: false }\" placeholder=\"Postal Code\" type=text ng-disabled=$root.isLoading><div class=errors ng-messages=profileForm.zipCode.$error><div ng-message=required>This is required.</div><div ng-message=mask>Enter a valid postal code.</div></div></div></div></div></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/social/facebook.html","<!-- FACEBOOK SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">All facebook influencers must be verified by fb as a content creator or business page.</div><div class=\"social__common-info__item text-uppercase\">Click \"skip fb\" button in upper right to move to instagram <span style=\"text-transform: none\">(if not verified by FB)</span></div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting FB, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><ng-form name=fbForm><div class=sponsored-social__row><img src=assets/images/facebook.svg alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleFacebookConnection(newProfCtrl.profile.facebook_handle, \'facebook\')\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.facebook_handle.url ? \'Disconnect Facebook\' : \'Connect Facebook\'}}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.facebook_handle.url ng-click=\"newProfCtrl.showPriceGa(\'facebook\', newProfCtrl.profile.facebook_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.facebook_handle.social_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.facebook_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.facebook_handle.url name=price ng-required=newProfCtrl.profile.facebook_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'facebook\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/social/instagram.html","<!-- INSTAGRAM SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase text-bold\">Please choose whether you are verified by instagram below.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting Instagram, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><div class=toggle ng-class=\"{ \'toggle-disabled\': newProfCtrl.profile.instagram_handle.url }\"><input type=radio ng-model=newProfCtrl.profile.instagram_handle.subtype value=verified name=subtype id=verifiedIgUser checked=checked><label ng-click=\"newProfCtrl.setSubtype(newProfCtrl.profile.instagram_handle, \'verified\')\" for=verifiedIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am verified on IG</label><input type=radio ng-model=newProfCtrl.profile.instagram_handle.subtype value=simple checked=checked name=subtype id=simpleIgUser><label ng-click=\"newProfCtrl.setSubtype(newProfCtrl.profile.instagram_handle, \'simple\')\" for=simpleIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am just a normal user on IG</label></div><ng-form name=inForm><div class=sponsored-social__row><img src=assets/images/instagram.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleInstagramConnection(newProfCtrl.profile.instagram_handle, \'instagram\')\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.instagram_handle.url ? \'Disconnect Instagram\' : \'Connect Instagram\'}}</button><md-tooltip ng-show=!newProfCtrl.profile.instagram_handle.subtype md-direction=bottom>First select the type of IG profile</md-tooltip></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.instagram_handle.url ng-click=\"newProfCtrl.showPriceGa(\'instagram\', newProfCtrl.profile.instagram_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.instagram_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.instagram_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.instagram_handle.url name=price ng-required=newProfCtrl.profile.instagram_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'instagram\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/social/twitter.html","<!-- TWITTER SIGN IN --><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting Twitter, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><ng-form name=twForm><div class=sponsored-social__row><img src=assets/images/twitter.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handelTwitterConnection($event, newProfCtrl.profile.twitter_handle)\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.twitter_handle.url ? \'Disconnect Twitter\' : \'Connect Twitter\'}}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.twitter_handle.url ng-click=\"newProfCtrl.showPriceGa(\'twitter\', newProfCtrl.profile.twitter_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.twitter_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.twitter_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.twitter_handle.url name=price ng-required=newProfCtrl.profile.twitter_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'twitter\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfile/tabPartials/social/youtube.html","<!-- YOUTUBE SIGN IN --><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting YouTube, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><div class=sponsored-social__row><img class=\"d-none d-sm-block\" src=assets/images/yt_logo_rgb_light.png height=40px alt> <img class=\"d-block d-sm-none\" src=assets/images/yt_logo_rgb_light.png height=25px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleYoutubeConnection($event, newProfCtrl.profile.youtube_handle, \'youtube\')\" class=\"btn btn-white\" type=button>{{ newProfCtrl.profile.youtube_handle.url ? \'Disconnect Youtube\' : \'Connect Youtube\' }}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.youtube_handle.url ng-click=\"newProfCtrl.showPriceGa(\'youtube\', newProfCtrl.profile.youtube_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.youtube_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.youtube_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.youtube_handle.url name=price ng-required=newProfCtrl.profile.youtube_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'youtube\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/social/facebook.html","<!-- FACEBOOK SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase\">All facebook influencers must be verified by fb as a content creator or business page.</div><div class=\"social__common-info__item text-uppercase\">Click \"skip fb\" button in upper right to move to instagram <span style=\"text-transform: none\">(if not verified by FB)</span></div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting FB, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><ng-form name=fbForm><div class=sponsored-social__row><img src=assets/images/facebook.svg alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleFacebookConnection(newProfCtrl.profile.facebook_handle, \'facebook\')\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.facebook_handle.url ? \'Disconnect Facebook\' : \'Connect Facebook\'}}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.facebook_handle.url ng-click=\"newProfCtrl.showPriceGa(\'facebook\', newProfCtrl.profile.facebook_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.facebook_handle.social_prices | orderBy:\'info\'\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.facebook_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.facebook_handle.url name=price ng-required=newProfCtrl.profile.facebook_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'facebook\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/social/instagram.html","<!-- INSTAGRAM SIGN IN --><div class=\"social__common-info text-bold\"><div class=\"social__common-info__item text-uppercase text-bold\">Please choose whether you are verified by instagram below.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting Instagram, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><div class=toggle ng-class=\"{ \'toggle-disabled\': newProfCtrl.profile.instagram_handle.url }\"><input type=radio ng-model=newProfCtrl.profile.instagram_handle.subtype value=verified name=subtype id=verifiedIgUser checked=checked><label ng-click=\"newProfCtrl.setSubtype(newProfCtrl.profile.instagram_handle, \'verified\')\" for=verifiedIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am verified on IG</label><input type=radio ng-model=newProfCtrl.profile.instagram_handle.subtype value=simple checked=checked name=subtype id=simpleIgUser><label ng-click=\"newProfCtrl.setSubtype(newProfCtrl.profile.instagram_handle, \'simple\')\" for=simpleIgUser><svg class=\"icon icon--action_view\"><use xlink:href=assets/images/icons.svg#check_mark></use></svg> I am just a normal user on IG</label></div><ng-form name=inForm><div class=sponsored-social__row><img src=assets/images/instagram.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleInstagramConnection(newProfCtrl.profile.instagram_handle, \'instagram\')\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.instagram_handle.url ? \'Disconnect Instagram\' : \'Connect Instagram\'}}</button><md-tooltip ng-show=!newProfCtrl.profile.instagram_handle.subtype md-direction=bottom>First select the type of IG profile</md-tooltip></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.instagram_handle.url ng-click=\"newProfCtrl.showPriceGa(\'instagram\', newProfCtrl.profile.instagram_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.instagram_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.instagram_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.instagram_handle.url name=price ng-required=newProfCtrl.profile.instagram_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'instagram\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/social/twitter.html","<!-- TWITTER SIGN IN --><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting Twitter, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><ng-form name=twForm><div class=sponsored-social__row><img src=assets/images/twitter.svg height=40px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handelTwitterConnection($event, newProfCtrl.profile.twitter_handle)\" class=\"btn btn-white\" type=button>{{newProfCtrl.profile.twitter_handle.url ? \'Disconnect Twitter\' : \'Connect Twitter\'}}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.twitter_handle.url ng-click=\"newProfCtrl.showPriceGa(\'twitter\', newProfCtrl.profile.twitter_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div></ng-form><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.twitter_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.twitter_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.twitter_handle.url name=price ng-required=newProfCtrl.profile.twitter_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'twitter\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/profiles/newProfileV1/tabPartials/social/youtube.html","<!-- YOUTUBE SIGN IN --><div class=\"social__common-info text-bold\"><div class=social__common-info__item>After connecting YouTube, orange icons will appear for suggested price & promotion details.</div><div class=social__common-info__item>We do not allow marketers to “haggle” with you over price, saving you time and headache.</div><div class=\"social__common-info__item text-uppercase\">So please put your best possible price.</div></div><div class=\"social__common-info text-bold\"><div class=social__common-info__item>Leave price blank if not willing to do a certain type of promotion.</div></div><div class=sponsored-social__row><img class=\"d-none d-sm-block\" src=assets/images/yt_logo_rgb_light.png height=40px alt> <img class=\"d-block d-sm-none\" src=assets/images/yt_logo_rgb_light.png height=25px alt><div class=sponsored-social__button><button ng-click=\"newProfCtrl.handleYoutubeConnection($event, newProfCtrl.profile.youtube_handle, \'youtube\')\" class=\"btn btn-white\" type=button>{{ newProfCtrl.profile.youtube_handle.url ? \'Disconnect Youtube\' : \'Connect Youtube\' }}</button></div><span class=info-icon><md-button ng-if=newProfCtrl.profile.youtube_handle.url ng-click=\"newProfCtrl.showPriceGa(\'youtube\', newProfCtrl.profile.youtube_handle, true)\" ng-disabled=$root.isLoading class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></span></div><form class=connect-social__form name=form ng-submit=form.$valid><div class=social__promotion-description><div class=social__form-item ng-repeat=\"handle in newProfCtrl.profile.youtube_handle.social_prices\"><div class=\"form-item__col form-item__col social__item-title\"><p class=text-uppercase>{{handle.description}}</p></div><div class=\"form-item__col d-none d-sm-block\"><p>{{handle.note}}</p></div><div class=\"form-item__col form-item__col social__item-input\"><div ng-if=newProfCtrl.profile.youtube_handle.url class=info-icon><md-button ng-click=newProfCtrl.showInfo(handle.info) class=\"md-icon-button info-icons\" aria-label=info><md-icon md-svg-src=assets/images/help-circle.svg></md-icon></md-button></div><input maxlength=9 ng-disabled=!newProfCtrl.profile.youtube_handle.url name=price ng-required=newProfCtrl.profile.youtube_handle.url ng-model=handle.price ng-change=\"newProfCtrl.setNewProfileSocialPrice(handle.price, \'youtube\')\" format=currency min=1 class=form-control ui-money-mask=0 type=text placeholder=\"PRICE IN USD\"></div></div></div></form>");
$templateCache.put("app/pages/reports/adv/rejected/pubNotes/pubNotes.html","<md-dialog><md-toolbar><div class=md-toolbar-tools><h2>Notes</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><h2 class=notes-h2>Here are the publisher notes for the rewrite. Please follow them.</h2><div><label class=reject-content>Reason of rejection: <span class=pub-notes>{{ pubNotesCtrl.rejectedReason }}</span></label></div><div><label class=reject-content>Notes from Publisher:</label><md-input-container class=\"display-notes md-block\"><textarea class=pub-notes ng-disabled=false ng-trim=true ng-model=pubNotesCtrl.note.note ng-readonly=true rows=2 md-select-on-focus name=notes>\n          </textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white btn-small\" ng-click=pubNotesCtrl.ok() ng-disabled=$root.isLoading>I Understand</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/reports/adv/rejected/blogPostsEdit/blogPostsEdit.html","<md-dialog class=blog-post-container aria-label=\"Create Blog Post\" layout=column layout-align=\"center center\"><md-toolbar><div class=md-toolbar-tools><h2>Resubmit Edited Content to Publisher</h2><span flex></span><md-button class=md-icon-button ng-click=blgEditCtrl.closeDialog()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=dialog-content layout-align=\"start center\"><form name=form ng-submit=false layout=column flex><div clas=\"md-block campaign-container\"><label>Campaign</label><md-select required class=form-control name=campaign ng-model=blgEditCtrl.blogPost.campaign><md-optgroup label=\"Your campaigns\"><md-option ng-value=campaign ng-repeat=\"campaign in blgEditCtrl.campaigns\">{{ campaign.name }}</md-option></md-optgroup></md-select><div class=errors ng-messages=form.campaign.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div><br><br><div class=\"md-block infographic\" layout=row layout-xs=column><label class=form-label flex=30>Using an infographic?</label><md-radio-group class=options-container ng-model=blgEditCtrl.infographic layout=row flex=60 layout-align-sm=\"center center\" layout-align=\"start center\"><md-radio-button value=yes>Yes</md-radio-button><md-radio-button value=no>No</md-radio-button></md-radio-group></div><div class=form-group><label>Title</label><input class=form-control ng-required=true ng-model=blgEditCtrl.blogPost.blog_post_title name=title placeholder=\"Please Copy / Paste blog post title from Word Doc\" type=text><div ng-messages=form.title.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div><text-angular ng-required=\"blgEditCtrl.infographic == \'yes\'\" ng-show=\"blgEditCtrl.infographic == \'yes\'\" ng-model=blgEditCtrl.blogPost.blog_post_body></text-angular><div layout=row layout-align=\"center center\" flex><div flex=50><div class=\"form-group input-left\"><label>Target URL</label><input class=form-control name=url ng-required=true ng-model=blgEditCtrl.newURL ng-change=blgEditCtrl.setEmptyDropdownUrl() placeholder=\"Please Copy / Paste URL from Word Doc\" url-input><div class=errors ng-messages=form.url.$error md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></div></div><div flex=50><div class=\"form-group input-right\" ng-hide=\"blgEditCtrl.infographic == \'yes\'\"><label>Anchor text</label><input class=form-control ng-required=\"blgEditCtrl.infographic == \'no\'\" name=linkText ng-model=blgEditCtrl.blogPost.link_text placeholder=\"Please Copy / Paste anchor text from Word Doc\" type=text><div class=errors ng-messages=form.linkText.$error md-auto-hide=false><div ng-message=required>This is required.</div></div></div></div></div><br><br></form><form name=filesWideForm class=form-doc-upload><div><p>Max file size is 25 MBs. If you want images, copy them onto the Word doc.</p></div><div layout=column layout-align=\"center start\" layout-gt-md=row layout-align-gt-md=\"start center\"><file-chooser text=\"Choose file\" file-max=25MB file-ext=\".doc, .docx\" file-name=word file=blgEditCtrl.blogPost.word label=\"Word document\" smaller=true small-input=true ng-disabled=$root.isLoading ng-show=\"blgEditCtrl.infographic == \'no\'\"></file-chooser><div layout=row class=download-content><a class=\"btn btn-download\" aria-label=download ng-href={{blgEditCtrl.blogPost.word.url}} target=_blank ng-click=blgEditCtrl.downloadContent(blgEditCtrl.blogPost)><svg class=\"icon icon--download\"><use xlink:href=assets/images/icons.svg#download></use></svg></a><p>Download content</p></div></div></form></md-content><div class=dialog-actions><md-divider></md-divider><md-card-actions layout=row layout-align=\"end center\" flex><md-button class=\"btn btn-white btn-small\" ng-disabled=$root.isLoading ng-click=blgEditCtrl.closeDialog()>Cancel</md-button><md-button class=\"btn btn-white btn-small\" ng-disabled=\"$root.isLoading || !blgEditCtrl.hasContent()\n        || blgEditCtrl.noUrl() || form.$invalid || filesWideForm.$invalid\" ng-click=blgEditCtrl.save()>Save</md-button></md-card-actions></div></md-dialog>");
$templateCache.put("app/pages/reports/pub/newOrders/partials/rejectOrder.html","<md-dialog class=decline-order-dialog><md-toolbar><div class=md-toolbar-tools><h2>Decline order</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><p class=reject-content>To Improve Your Experience with us, please select the reason below:</p><form><div><md-radio-group ng-model=rejCtrl.selected><md-radio-button ng-repeat=\"r in rejCtrl.rejectedReasons\" ng-value=r.title aria-label=\"{{ r.title }}\">{{ r.title }}</md-radio-button></md-radio-group><md-checkbox class=bigger-checkbox md-no-ink ng-model=rejCtrl.allowAgency aria-label=\"Allow Agency to Rewrite?\">Allow Rewrite?</md-checkbox></div><div><md-input-container class=\"notes-hint md-block\"><label class=change-txt-label>Please tell advertiser what needs to be fixed here.</label><textarea class=change-txt ng-disabled=!rejCtrl.allowAgency ng-trim=true ng-model=rejCtrl.notes rows=2 md-select-on-focus name=notes required>\n            </textarea><div ng-messages=form.notes.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div></div></md-input-container></div></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><button class=\"btn btn-small btn-white\" class=md-accent ng-click=rejCtrl.cancel() ng-disabled=\" $root.isLoading\">Cancel</button> <button class=\"btn btn-small btn-white\" style=\"margin-left: 15px\" ng-click=rejCtrl.submit() ng-disabled=\"form.$invalid || $root.isLoading || rejCtrl.selected.length === 0 || (rejCtrl.allowAgency && !rejCtrl.notes)\">Save</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/reports/pub/activeAds/partials/notes.html","<md-dialog class=admin-notes-dialog><md-toolbar><div class=md-toolbar-tools><h2>Reason Why We Declined Approval</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div ng-repeat=\"note in noteCtrl.notes\"><p class=notes-content>{{ note.creator | capitalize }}: <span>{{ note.note }} </span>- <span>{{ note.created_at | date: \'medium\' }}</span></p></div></md-dialog-content><md-dialog-content layout=column layout-padding><form name=form><md-input-container class=\"notes-hint md-block\"><label>Write notes to Admin</label><textarea ng-trim=true ng-model=noteCtrl.pubNote rows=2 md-select-on-focus name=pubNotes>\n        </textarea></md-input-container><md-input-container class=\"notes-hint md-block\"><label>Enter Live Post URL</label><input url-input required name=url ng-model=noteCtrl.pubUrl><div ng-messages=form.url.$error multiple=multiple md-auto-hide=false><div ng-message=required>This is required.</div><div ng-message=pattern>This doesn\'t appear to be a valid URL. Please fix to move forward.</div></div></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=\"btn btn-white\" ng-click=noteCtrl.cancel()>Cancel</md-button><md-button class=\"btn btn-white\" ng-click=noteCtrl.ok() ng-disabled=\"form.$invalid || $root.isLoading\">Save Changes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/reports/pub/resubmittedContent/partials/notes.html","<md-dialog><md-toolbar><div class=md-toolbar-tools><h2>Notes Between You and Advertiser</h2></div></md-toolbar><md-dialog-content layout=column layout-padding><div ng-repeat=\"note in noteCtrl.notes\"><p class=notes-content>{{ note.creator | capitalize }}: <span>{{ note.note }} </span>- <span>{{ note.created_at | date: \'short\' }}</span></p></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=noteCtrl.ok() ng-disabled=\" $root.isLoading\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/pages/reports/pub/pricingAndPausing/partials/pause.html","<md-dialog-content layout=column layout-padding><h2>Are you sure?</h2><div><p class=notes-content ng-show=pauseCtrl.isPausing()><span>Pausing this URL will remove it from our Advertiser database.</span><br><span>You may \"un-pause\" anytime as well. If a URL is paused, you will not receive any orders for that product type.</span></p><p class=notes-content ng-show=pauseCtrl.isUnpausing()><span>You are activating this URL again. This means you will get orders again.</span></p><p class=notes-content ng-show=\"pauseCtrl.priceChanged() && pauseCtrl.pausedChanged()\"><i>When paused is selected, price won\'t be modified.</i></p><p class=notes-content ng-show=\"pauseCtrl.priceChanged() && !pauseCtrl.pausedChanged()\"><span>Changing the price will require admin approval.</span><br><span>If we do not approve, then you will be required to change price again to fit our model.</span></p></div><form name=form><md-input-container class=\"notes-hint md-block\" ng-if=pauseCtrl.isPausing()><label>Reason for pausing:</label><textarea ng-trim=true ng-model=pauseCtrl.noteReason rows=2 md-select-on-focus name=noteReason required>\n      </textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-accent ng-click=pauseCtrl.cancel() ng-disabled=\" $root.isLoading\">Cancel</md-button><md-button class=md-accent ng-click=pauseCtrl.ok() ng-if=\"!form.$invalid && !$root.isLoading\">I Understand</md-button></md-dialog-actions>");}]);